import React from 'react'

export const logo = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width="82"
    height="57"
    viewBox="0 0 82 57"
  >
    <title>Logo</title>
    <defs>
      <path
        id="a"
        d="M76.546 57H5.454C2.46 57 0 54.603 0 51.658V5.363C0 2.417 2.459 0 5.454 0h71.092C79.54 0 82 2.417 82 5.363v46.295C82 54.603 79.541 57 76.546 57z"
      />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="b" fill="#fff">
        <use xlinkHref="#a" />
      </mask>
      <g fill="#009DE0" mask="url(#b)">
        <path d="M0 0h82v57H0z" />
      </g>
      <g fill="#FEFEFE">
        <path d="M73.751 25.409a2.673 2.673 0 0 0-2.154 3.076c.255 1.446 1.635 2.44 3.082 2.184a2.687 2.687 0 0 0 2.18-3.111c-.25-1.416-1.631-2.41-3.108-2.15zm1.377-8.96a2.686 2.686 0 0 1-2.18 3.112c-1.446.256-2.827-.738-3.082-2.184-.25-1.415.708-2.82 2.155-3.076 1.476-.26 2.858.733 3.107 2.148zm-9.326 16.313c-3.39.566-5.454-1.068-6.095-4.7l-1.432-8.123-2.43.43-.543-3.077 2.43-.429-.629-3.57L61.381 12l.721 4.093 3.753-.662.113 3.152-3.324.586 1.417 8.03c.282 1.6.913 2.124 2.021 1.929.584-.103 1.138-.392 1.743-.911l2.001 2.535c-1.053 1.042-2.577 1.755-4.024 2.01zM53.958 22.096l2.094 11.877-4.369.77-1.964-11.137c-.33-1.878-1.1-2.28-2.207-2.086-1.262.223-2.1 1.227-2.737 2.831l1.985 11.26-4.369.771-2.875-16.307 3.785-.667.701 2c1.036-1.864 2.442-3.062 4.534-3.431 2.862-.504 4.88 1.042 5.422 4.12zm-20.857 5.868c-.434-2.462-1.547-3.915-3.64-3.546-1.722.303-2.593 1.663-2.266 4.777l5.938-1.047-.032-.184zm4.76 2.174l-10.183 1.795c.86 3.085 2.5 3.748 4.593 3.38 1.384-.245 2.477-.882 3.719-2.117l2.25 2.142c-1.372 1.574-3.24 2.855-5.794 3.306-5.231.921-8.577-2.042-9.477-7.15-.868-4.922 1.105-9.203 5.874-10.044 4.615-.814 7.896 1.78 8.813 6.98.098.554.155 1.241.206 1.708zm-27.404.58c.33 1.878 1.573 2.801 3.234 2.508 1.754-.309 2.492-1.518 2.14-3.518-.342-1.938-1.397-2.704-3.212-2.384-1.662.293-2.476 1.61-2.162 3.395zm5.907-5.006c2.156.54 3.389 1.592 3.752 3.653.56 3.169-1.587 5.926-5.741 6.66-.708.123-1.334.17-1.946.12-.326.31-.502.755-.425 1.186.097.554.466 1.028 2.066.746l2.493-.44c3.692-.65 6.408.9 6.886 3.607.58 3.293-1.929 5.797-7.375 6.757-5.969 1.053-7.941-.597-8.516-3.86l3.907-.688c.272 1.539 1.068 2.096 4.175 1.548 3.016-.532 3.67-1.503 3.463-2.672-.195-1.107-1.145-1.638-2.868-1.335l-2.4.423c-3.415.602-5.092-.624-5.395-2.348-.207-1.169.331-2.437 1.37-3.382-2.225-.75-3.341-2.044-3.71-4.136-.635-3.6 1.82-6.412 5.91-7.133 3.77-.57 5.51-1.861 7.284-3.315l1.668 3.163c-1.118.673-2.63 1.099-4.598 1.446z" />
      </g>
    </g>
  </svg>
)

export const footerImage = (
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 2010 895"
    style={{ enableBackground: 'new 0 0 2010 895' }}
    xmlSpace="preserve"
  >
    <title>Footer Image</title>
    <image
      width="2010"
      height="895"
      style={{ overflow: 'visible' }}
      xlinkHref="data:image/png;base64,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"
    />
  </svg>
)

export const homePageIcon = (
  <svg
    width="180px"
    height="180px"
    viewBox="0 0 128 128"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <title>0.hompepage/hompepage_1</title>
    <g
      id="0.hompepage/hompepage_1"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Group" transform="translate(1.600000, 12.800000)">
        <polyline
          id="Fill-427"
          fill="#8A8B8A"
          points="1.17498239 44.3624817 103.090382 103.207861 103.283287 102.874136 1.36788707 44.0285637"
        />
        <polyline
          id="Fill-428"
          fill="#8A8B8A"
          points="26.520728 30.6585334 127.303777 88.8518947 127.496682 88.5181696 26.7136327 30.3248083"
        />
        <polyline
          id="Fill-429"
          fill="#8A8B8A"
          points="16.5668466 94.804933 118.482246 35.959361 118.289341 35.6258288 16.373942 94.4712079"
        />
        <polyline
          id="Fill-430"
          fill="#8A8B8A"
          points="0.193097583 74.1911391 91.6569216 21.3817474 91.4640169 21.0459004 2.41886889e-13 73.8574141"
        />
        <polyline
          id="Fill-431"
          fill="#F8F7F6"
          points="67.9084267 29.9253027 67.9084267 45.5951426 69.526704 44.6923487 69.526704 28.9800698 67.9084267 29.9253027"
        />
        <polyline
          id="Fill-432"
          fill="#F8F7F6"
          points="82.2875414 47.2386904 82.2875414 56.4190241 90.0693161 51.9822165 90.0693161 42.7881866 85.5572757 42.4949715 82.2875414 47.2386904"
        />
        <polyline
          id="Fill-433"
          fill="#E4E4E3"
          points="82.2875414 47.2386904 82.2875414 56.4190241 74.5038376 51.9822165 74.5038376 42.7881866 82.2875414 47.2386904"
        />
        <polyline
          id="Fill-434"
          fill="#9E9F9E"
          points="82.2875414 47.2386904 85.5572757 42.4949715 77.8796695 38.0870996 74.5038376 42.7881866 82.2875414 47.2386904"
        />
        <polyline
          id="Fill-435"
          fill="#B4B5B4"
          points="85.5572757 42.4949715 90.0693161 42.7881866 82.3917099 38.2954367 77.8796695 38.0870996 85.5572757 42.4949715"
        />
        <polyline
          id="Fill-436"
          fill="#9E9F9E"
          points="53.4174273 56.2454099 68.0994023 64.6174729 68.0994023 55.0665694 60.5201775 41.6018228 53.4174273 46.6327769 53.4174273 56.2454099"
        />
        <polyline
          id="Fill-437"
          fill="#F8F7F6"
          points="68.0994023 55.0260594 68.0994023 64.6174729 75.881177 60.1264591 75.881177 50.5759414 68.0994023 55.0260594"
        />
        <polyline
          id="Fill-438"
          fill="#679CC7"
          points="60.5008871 41.5825324 68.618123 37.1341505 75.881177 50.5759414 68.0994023 55.0665694 60.5008871 41.5825324"
        />
        <polyline
          id="Fill-439"
          fill="#F8F7F6"
          points="34.7211059 47.6167836 34.7211059 63.2881667 53.0701989 52.7769837 53.0701989 37.0647048 34.7211059 47.6167836"
        />
        <polyline
          id="Fill-440"
          fill="#E4E4E3"
          points="37.8693102 65.0686769 52.5512853 73.5836823 52.5512853 63.8902222 44.9720605 50.4252828 37.8693102 55.4562368 37.8693102 65.0686769"
        />
        <polyline
          id="Fill-441"
          fill="#F8F7F6"
          points="60.33306 15.4516647 60.33306 69.1912428 68.1167637 64.6174729 68.1167637 10.9571786 60.33306 15.3091081"
        />
        <polyline
          id="Fill-442"
          fill="#E4E4E3"
          points="60.33306 15.4516647 60.33306 69.1912428 52.5512853 64.1600959 52.5512853 10.932101 60.33306 15.4516647"
        />
        <polyline
          id="Fill-443"
          fill="#E4E4E3"
          points="71.3631566 56.6524387 72.6191589 55.88082 72.6191589 62.2061644 71.3631566 62.9199117 71.3631566 56.6524387"
        />
        <polyline
          id="Fill-444"
          fill="#F8F7F6"
          points="62.1540801 79.9088338 62.1540801 89.0891674 69.9377839 84.6523598 69.9377839 75.4587158 65.4257435 75.1653078 62.1540801 79.9088338"
        />
        <polyline
          id="Fill-445"
          fill="#E4E4E3"
          points="62.1540801 79.9088338 62.1540801 89.0891674 54.3723054 84.6523598 54.3723054 75.4587158 62.1540801 79.9088338"
        />
        <polyline
          id="Fill-446"
          fill="#9E9F9E"
          points="62.1540801 79.9088338 65.4257435 75.1653078 57.7481373 70.7576288 54.3723054 75.4587158 62.1540801 79.9088338"
        />
        <polyline
          id="Fill-447"
          fill="#B4B5B4"
          points="65.4257435 75.1653078 69.9377839 75.4587158 62.2601777 70.9659658 57.7481373 70.7576288 65.4257435 75.1653078"
        />
        <polyline
          id="Fill-448"
          fill="#679CC7"
          points="71.1241477 63.2497787 71.1241477 80.9312286 109.139873 59.0288315 112.137418 48.7084312 109.463952 41.3994658 71.1241477 63.2497787"
        />
        <polyline
          id="Fill-449"
          fill="#143A4F"
          points="107.824263 40.45404 109.463952 41.3994658 71.1241477 63.2497787 69.4456841 62.5011157 107.824263 40.45404"
        />
        <polyline
          id="Fill-450"
          fill="#143A4F"
          points="69.4456841 79.9765433 71.1241477 80.9312286 71.1241477 63.2497787 69.4456841 62.5011157 69.4456841 79.9765433"
        />
        <polyline
          id="Fill-451"
          fill="#CBCCCB"
          points="88.167276 94.3573942 91.1069504 96.0549553 91.1069504 69.4188703 88.167276 71.1123805 88.167276 94.3573942"
        />
        <polyline
          id="Fill-452"
          fill="#E4E4E3"
          points="94.0450815 94.3573942 91.1069504 96.0549553 91.1069504 69.4188703 94.0450815 67.6728901 94.0450815 94.3573942"
        />
        <polyline
          id="Fill-453"
          fill="#9E9F9E"
          points="38.1837449 72.7156113 38.1837449 81.8978739 30.4000411 77.4610663 30.4000411 68.2651074 34.9140106 67.9720852 38.1837449 72.7156113"
        />
        <polyline
          id="Fill-454"
          fill="#F8F7F6"
          points="38.1837449 72.7156113 38.1837449 81.8978739 45.9655196 77.4610663 45.9655196 68.2651074 38.1837449 72.7156113"
        />
        <polyline
          id="Fill-455"
          fill="#F8F7F6"
          points="52.5512853 63.8495194 52.5512853 73.5836823 60.33306 69.1717594 60.33306 59.3994013 52.5512853 63.8495194"
        />
        <polyline
          id="Fill-456"
          fill="#B4B5B4"
          points="38.1837449 72.7156113 34.9140106 67.9720852 42.5916168 63.5659495 45.9655196 68.2651074 38.1837449 72.7156113"
        />
        <polyline
          id="Fill-457"
          fill="#9E9F9E"
          points="34.9140106 67.9720852 30.4038992 68.1823513 38.0776473 63.7725504 42.5916168 63.5659495 34.9140106 67.9720852"
        />
        <polyline
          id="Fill-458"
          fill="#E4E4E3"
          points="30.5080677 77.1252193 30.5080677 86.3055529 22.7261001 81.8687453 22.7261001 72.6749084 27.2383334 72.3818862 30.5080677 77.1252193"
        />
        <polyline
          id="Fill-459"
          fill="#F8F7F6"
          points="30.5080677 77.1252193 30.5080677 86.3055529 38.2782682 81.8419316 38.2917715 72.6749084 30.5080677 77.1252193"
        />
        <polyline
          id="Fill-460"
          fill="#B4B5B4"
          points="30.5080677 77.1252193 27.2383334 72.3818862 34.9159396 67.9757504 38.2917715 72.6749084 30.5080677 77.1252193"
        />
        <polyline
          id="Fill-461"
          fill="#9E9F9E"
          points="27.2383334 72.3818862 22.7261001 72.6749084 30.4038992 68.1823513 34.9159396 67.9757504 27.2383334 72.3818862"
        />
        <polyline
          id="Fill-462"
          fill="#E4E4E3"
          points="30.8437219 35.6972036 26.5052957 42.9542775 26.5052957 58.5448336 34.7211059 63.2881667 34.7211059 47.6167836 30.8437219 35.6972036"
        />
        <polyline
          id="Fill-463"
          fill="#679CC7"
          points="44.95277 50.4061853 53.0701989 45.9578034 60.33306 59.3994013 52.5512853 63.8902222 44.95277 50.4061853"
        />
        <polyline
          id="Fill-464"
          fill="#679CC7"
          points="30.8417928 35.6972036 52.5165624 23.216078 52.5512853 37.3637071 34.7288221 47.6628878 30.8417928 35.6972036"
        />
        <polyline
          id="Fill-465"
          fill="#679CC7"
          points="69.526704 29.1461607 68.1167637 29.8037727 68.1167637 14.6260327"
        />
        <polyline
          id="Fill-466"
          fill="#679CC7"
          points="52.5512853 10.932101 60.33306 15.4516647 68.1167637 10.9571786 60.33306 6.33904062 52.5512853 10.932101"
        />
        <polyline
          id="Fill-467"
          fill="#679CC7"
          points="65.3775173 12.5465203 68.1167637 10.9666309 65.3775173 2.94179634 65.3775173 12.5465203"
        />
        <polyline
          id="Fill-468"
          fill="#143A4F"
          points="65.3775173 12.5465203 62.6382709 10.9666309 65.3775173 2.94179634 65.3775173 12.5465203"
        />
        <polyline
          id="Fill-469"
          fill="#679CC7"
          points="60.33306 9.60472392 63.0723064 8.0248346 60.33306 1.87462339e-14 60.33306 9.60472392"
        />
        <polyline
          id="Fill-470"
          fill="#143A4F"
          points="60.33306 9.60472392 57.5957426 8.0248346 60.33306 1.87462339e-14 60.33306 9.60472392"
        />
        <polyline
          id="Fill-471"
          fill="#679CC7"
          points="60.33306 15.4516647 63.0723064 13.8698463 60.33306 5.84694079 60.33306 15.4516647"
        />
        <polyline
          id="Fill-472"
          fill="#143A4F"
          points="60.33306 15.4516647 57.5957426 13.8698463 60.33306 5.84694079 60.33306 15.4516647"
        />
        <polyline
          id="Fill-473"
          fill="#679CC7"
          points="55.2903388 12.5098684 58.0276562 10.92805 55.2903388 2.90514445 55.2903388 12.5098684"
        />
        <polyline
          id="Fill-474"
          fill="#143A4F"
          points="55.2903388 12.5098684 52.5512853 10.92805 55.2903388 2.90514445 55.2903388 12.5098684"
        />
        <path
          d="M61.7875613,58.6218026 L67.2641251,55.4581659 L67.2641251,53.5408863 C67.2641251,53.5408863 66.2743312,51.9878107 64.7853,51.8491122 C64.7853,51.8491122 62.5765414,53.4191634 61.7875613,56.170177 L61.7875613,58.6218026"
          id="Fill-475"
          fill="#E4E4E3"
        />
        <path
          d="M61.7875613,68.3364822 L67.2641251,65.1207612 L67.2641251,60.3077895 C67.2641251,60.3077895 66.2743312,58.7549068 64.7853,58.6179445 C64.7853,58.6179445 62.5765414,60.1883815 61.7875613,62.9372731 L61.7875613,68.3364822"
          id="Fill-476"
          fill="#E4E4E3"
        />
        <polyline
          id="Fill-477"
          fill="#E4E4E3"
          points="62.5861866 43.2764284 63.8419961 42.5048096 63.8419961 48.8318902 62.5861866 49.5437084 62.5861866 43.2764284"
        />
        <polyline
          id="Fill-478"
          fill="#E4E4E3"
          points="56.5403611 65.0609607 57.7963635 64.289342 57.7963635 70.6146864 56.5403611 71.3286266 56.5403611 65.0609607"
        />
        <polyline
          id="Fill-479"
          fill="#E4E4E3"
          points="64.7968742 42.1728207 66.0526837 41.3994658 66.0526837 47.7265464 64.7968742 48.4383646 64.7968742 42.1728207"
        />
        <polyline
          id="Fill-480"
          fill="#E4E4E3"
          points="62.5861866 30.7046376 63.8419961 29.9310898 63.8419961 36.2583633 62.5861866 36.9701815 62.5861866 30.7046376"
        />
        <polyline
          id="Fill-481"
          fill="#E4E4E3"
          points="48.0257415 41.2200645 49.281551 40.4484458 49.281551 46.7737902 48.0257415 47.4854155 48.0257415 41.2200645"
        />
        <polyline
          id="Fill-482"
          fill="#E4E4E3"
          points="44.1522156 43.5250825 45.4080251 42.7515347 45.4080251 49.0788082 44.1522156 49.7908193 44.1522156 43.5250825"
        />
        <polyline
          id="Fill-483"
          fill="#E4E4E3"
          points="39.8118603 46.3397546 41.0676698 45.5662069 41.0676698 51.8934803 39.8118603 52.6052986 39.8118603 46.3397546"
        />
        <polyline
          id="Fill-484"
          fill="#E4E4E3"
          points="63.5970071 17.9401351 64.8526237 17.1667802 64.8526237 23.4938607 63.5970071 24.205679 63.5970071 17.9401351"
        />
        <polyline
          id="Fill-485"
          fill="#E4E4E3"
          points="64.7968742 29.5992938 66.0526837 28.8259389 66.0526837 35.1530195 64.7968742 35.8650306 64.7968742 29.5992938"
        />
        <polyline
          id="Fill-486"
          fill="#F2F1F0"
          points="57.9564744 42.8192443 56.7006649 42.0476256 56.7006649 48.3747061 57.9564744 49.0867173 57.9564744 42.8192443"
        />
        <polyline
          id="Fill-487"
          fill="#F2F1F0"
          points="55.7457867 41.7156366 54.4899773 40.9422818 54.4899773 47.2693623 55.7457867 47.9811805 55.7457867 41.7156366"
        />
        <polyline
          id="Fill-488"
          fill="#F2F1F0"
          points="57.9564744 30.2476464 56.7006649 29.4739057 56.7006649 35.8013721 57.9564744 36.5131903 57.9564744 30.2476464"
        />
        <polyline
          id="Fill-489"
          fill="#F2F1F0"
          points="56.9456538 17.482951 55.6898444 16.7094032 55.6898444 23.0366766 56.9456538 23.7486878 56.9456538 17.482951"
        />
        <polyline
          id="Fill-492"
          fill="#F2F1F0"
          points="55.7457867 29.1423026 54.4899773 28.3685619 54.4899773 34.6960283 55.7457867 35.4078465 55.7457867 29.1423026"
        />
        <path
          d="M75.1828621,67.709542 L75.5570972,67.4877016 C75.6477624,67.4356173 75.7673633,67.3681007 75.8638156,67.3142803 C75.9101127,67.2909388 75.9486937,67.2679832 75.9793655,67.2542869 C76.043217,67.2234222 76.0449531,67.2330674 76.0547912,67.2832226 C76.0547912,67.3142803 76.0547912,67.3430231 76.0490041,67.379675 C76.0393589,67.4491206 76.0219974,67.5264754 75.9988489,67.5687215 C75.8966094,67.6480054 75.7461438,67.7598901 75.58584,67.8717748 L76.2610063,71.1723738 L78.2577627,65.8945018 L78.7959667,65.5781382 L79.5405788,69.2375399 L81.3403794,64.4766525 C81.1860557,64.5497633 81.0431133,64.6114928 80.9449248,64.6500738 C80.9333505,64.6288543 80.9333505,64.5615305 80.9429958,64.4920848 C80.9524481,64.4226392 80.9757896,64.3474063 81.0105124,64.2970582 C81.0161067,64.289342 81.033661,64.2760316 81.0645257,64.2526901 C81.1320424,64.2065859 81.2323528,64.1446635 81.3403794,64.0752178 L81.4927741,63.9866746 L81.8670092,63.7665703 C81.9576744,63.7127499 82.0792043,63.6452333 82.1735347,63.5910271 C82.2200247,63.5680714 82.2584128,63.54473 82.2894704,63.5314195 C82.353129,63.5005548 82.3569871,63.5100071 82.3647033,63.5601623 C82.3647033,63.5910271 82.3647033,63.6201557 82.3587232,63.6568076 C82.3492709,63.7260604 82.3319095,63.8032222 82.3087609,63.8458542 C82.2026633,63.9286103 82.0386943,64.046475 81.8747254,64.1620249 L79.6889225,69.9491653 L79.1528404,70.2655289 L78.4043702,66.6157724 L76.4097358,71.8839992 L75.875197,72.2005558 L75.0516869,68.1879456 C74.8857889,68.2670365 74.7372523,68.3326241 74.6350128,68.3731341 C74.6234385,68.3519145 74.6234385,68.2843979 74.6330838,68.2149522 C74.642729,68.1456994 74.6656847,68.0702737 74.7006004,68.0203114 C74.7063875,68.0124023 74.723749,67.998899 74.7546137,67.9757504 C74.8202013,67.9294533 74.9224408,67.8677238 75.0304674,67.7982781 L75.1828621,67.709542"
          id="Fill-493"
          fill="#FFFFFE"
        />
        <path
          d="M86.5391605,61.0082264 L86.5121538,61.2028672 C86.4947924,61.320539 86.4562115,61.5481666 86.4135795,61.7584326 C86.3906239,61.8647231 86.3692115,61.9631045 86.353972,62.0477897 C86.3385396,62.1307387 86.3269653,62.1810868 86.3211782,62.2001844 C86.2150806,62.3043529 86.0491826,62.4085214 85.9506083,62.4528895 C85.9450141,62.4413152 85.941156,62.4145015 85.9351759,62.3680114 C85.9276527,62.2812043 85.9218655,62.1502221 85.9218655,62.0014925 C85.9199365,61.9322398 85.9218655,61.858936 85.9236017,61.7912264 L83.6783841,63.1164816 L83.4006014,65.1014707 L85.2987834,63.9806945 C85.364371,63.7472799 85.4396038,63.5198453 85.4799209,63.4540648 C85.6207413,63.3616634 85.7424642,63.2920248 85.8348655,63.2787144 C85.8369875,63.4118186 85.8254132,63.6411823 85.7943555,63.8823132 C85.7598256,64.1292311 85.7173866,64.3857944 85.653728,64.5748409 C85.5476304,64.6790095 85.4261005,64.7544352 85.2891382,64.823688 C85.2737058,64.8142357 85.2659896,64.7677456 85.2544153,64.6944418 C85.2447701,64.6230671 85.2370539,64.534331 85.2351249,64.4361425 L83.3388719,65.5547967 L83.0608962,67.5397858 L85.3064996,66.2145307 C85.3431515,66.0582779 85.3933067,65.8808056 85.4338167,65.7266748 C85.4569652,65.6512491 85.4743267,65.5800672 85.4955462,65.5200739 C85.5148366,65.4604663 85.5281471,65.4216925 85.5399143,65.4006659 C85.6421537,65.3252401 85.8059298,65.2366969 85.898524,65.2231936 C85.900646,65.2366969 85.898524,65.2828011 85.8910008,65.3601559 C85.8813555,65.5142867 85.8697813,65.7149076 85.8504908,65.9118633 C85.8408456,66.0121737 85.8292713,66.0930008 85.8215551,66.1529941 L85.7943555,66.3476349 L82.5633951,68.2537261 C82.4628917,68.3135265 82.355058,68.3731341 82.2605347,68.4254112 C82.2123086,68.4483669 82.1698695,68.4755664 82.1390048,68.4888769 C82.0753462,68.5237926 82.0732243,68.5100964 82.06763,68.452225 C82.063772,68.4290764 82.063772,68.4001407 82.0693662,68.3634888 C82.0792043,68.294236 82.0984948,68.2170742 82.1197143,68.1725132 C82.2277409,68.0914932 82.3917099,67.9720852 82.5633951,67.8524843 L83.1845481,63.3923353 C83.0186501,63.4714262 82.8623973,63.5391357 82.7601578,63.5796457 C82.7485836,63.5582333 82.7485836,63.4907167 82.7582288,63.421271 C82.7676811,63.3518253 82.7910226,63.2748563 82.8257454,63.2245082 C82.8315326,63.218914 82.848894,63.2032887 82.8797587,63.1820692 C82.9472754,63.1357721 83.0475858,63.0723064 83.1556124,63.0045969 L83.3080071,62.9158607 L86.5391605,61.0082264"
          id="Fill-494"
          fill="#FFFFFE"
        />
        <path
          d="M89.9632185,63.8881003 L86.8362337,65.732269 C86.7359233,65.7920695 86.6278966,65.8518699 86.5331804,65.9039542 C86.4870762,65.9272956 86.4427081,65.9541094 86.4135795,65.9678056 C86.3479919,66.0023356 86.3462558,65.9888322 86.3423977,65.9309608 C86.3366106,65.9078123 86.3366106,65.8790695 86.3423977,65.8422247 C86.3520429,65.772779 86.3713334,65.6956171 86.3925529,65.6512491 C86.5005795,65.5702291 86.6645485,65.4506282 86.8362337,65.3312202 L87.4593158,60.871264 C87.2914887,60.950355 87.1352359,61.0176787 87.0349255,61.0581887 C87.0214222,61.0369692 87.0233512,60.9677164 87.0328036,60.9001997 C87.0426417,60.8307541 87.0638612,60.7533993 87.1005131,60.703437 C87.1043712,60.6974569 87.1217326,60.6822175 87.1525974,60.6609979 C87.220114,60.6147008 87.3204244,60.5508494 87.4284511,60.4833327 L87.5808457,60.3945966 L87.9550808,60.1729491 C88.0455531,60.1187429 88.167276,60.0514192 88.2617993,59.999142 C88.3080964,59.9759934 88.3486064,59.9528449 88.3775421,59.9395344 C88.4412006,59.9084768 88.4450587,59.9183149 88.4527749,59.9682772 C88.4527749,59.9972129 88.4527749,60.0282706 88.4489168,60.0647296 C88.4390787,60.1324391 88.4199811,60.21153 88.3968325,60.2537762 C88.2905421,60.3347961 88.1306241,60.4563261 87.9589389,60.575927 L87.3377859,65.0165927 L89.4713116,63.7588542 C89.5079635,63.6026014 89.5581187,63.4118186 89.6005577,63.257302 C89.6237063,63.1801401 89.6447329,63.1126235 89.6642163,63.0530159 C89.6852429,62.9970736 89.6968172,62.9582997 89.7085843,62.9411312 C89.8532629,62.8446789 89.9745999,62.7771623 90.0671941,62.7636589 C90.0710522,62.7636589 90.0731742,62.7866146 90.0710522,62.8194084 C90.0693161,62.8907831 90.0615999,63.0086479 90.0500256,63.1456102 C90.0382584,63.2804506 90.024948,63.421271 90.0114447,63.5428009 L89.9900323,63.6934595 L89.9632185,63.8881003"
          id="Fill-495"
          fill="#FFFFFE"
        />
        <path
          d="M94.3035738,61.4017519 C94.0120948,61.4576943 93.6727755,61.40561 93.3330703,61.2937253 C92.993751,61.1797186 92.6600259,61.0061044 92.3880303,60.8170578 C92.1160347,60.6301332 91.9075048,60.4273904 91.8343939,60.2481819 L91.508385,62.5746123 C91.6762121,62.4935924 91.8286068,62.4258828 91.9308462,62.3853729 C91.9424205,62.4067853 91.9404915,62.4760381 91.9308462,62.5437476 C91.92313,62.6130004 91.8999815,62.6884261 91.8652586,62.7405104 C91.8594715,62.7461046 91.8419172,62.7598008 91.8112453,62.7829494 C91.7456577,62.8253884 91.6434183,62.8927122 91.5353916,62.9565636 C91.4773273,62.9932155 91.4312231,63.0221512 91.3829969,63.0491578 L91.0087619,63.2708053 C90.9103805,63.3286767 90.802161,63.3884772 90.7059015,63.4405614 C90.6596044,63.465639 90.6152363,63.4907167 90.5863006,63.5044129 C90.520713,63.5391357 90.518784,63.5254395 90.5149259,63.4694971 C90.5110678,63.4444195 90.5110678,63.4154838 90.5168549,63.3790248 C90.5265002,63.3115082 90.5436687,63.2322244 90.5670102,63.1899783 C90.6729148,63.1068363 90.8370767,62.9893574 91.0106909,62.8676345 L91.631844,58.4096074 C91.465946,58.4888913 91.3096932,58.5542859 91.2074537,58.5969179 C91.1939504,58.5735764 91.1956865,58.5060598 91.2055246,58.436807 C91.2151699,58.3690975 91.2383184,58.2921285 91.2730413,58.2419733 C91.2788284,58.2342571 91.2961898,58.2205609 91.3270546,58.1995342 C91.3926422,58.1513081 91.4929526,58.0895786 91.6029083,58.0220619 L91.755303,57.9312038 L92.127609,57.7114854 C92.2182742,57.6572792 92.3398042,57.5897626 92.4341345,57.5376783 C92.4825536,57.5126007 92.5211345,57.4894521 92.5519993,57.4761417 C92.6156578,57.4450841 92.617394,57.4549222 92.6272321,57.5068135 C92.6272321,57.5359422 92.6272321,57.564685 92.621445,57.6013368 C92.6117997,57.6707825 92.5925093,57.7498734 92.5712898,57.7925054 C92.4632631,57.8735253 92.3031523,57.9948624 92.1312742,58.1146562 L91.8440391,60.1768072 L94.0219329,56.9649443 C93.9524873,56.99388 93.8984739,57.0208867 93.8521768,57.0361261 C93.8386735,57.0131705 93.8404096,56.9456538 93.8502478,56.8762082 C93.859893,56.8086915 93.8830416,56.7315296 93.9177644,56.6811815 C93.9216225,56.6755873 93.940913,56.6601549 93.9717777,56.6387425 C94.0371724,56.5924454 94.1376758,56.5287868 94.2476314,56.4612702 L94.4000261,56.3707979 L94.7723321,56.1506937 C94.8649264,56.0968733 94.9845273,56.0293566 95.0809796,55.9772724 C95.1272767,55.9521947 95.1658577,55.9290462 95.1967224,55.91535 C95.260381,55.8846781 95.2621171,55.8941304 95.2719553,55.9462147 C95.2719553,55.9753433 95.2719553,56.0060152 95.2661681,56.0409309 C95.2565229,56.1101837 95.2372324,56.1894675 95.2160129,56.2317136 C95.0674763,56.3435983 94.8126492,56.5249287 94.5871436,56.6833035 L92.4536179,59.8353659 L92.4594051,59.8469402 C92.4883408,59.9781154 92.617394,60.1168138 92.8008463,60.2499181 C92.9860348,60.3830223 93.2290947,60.5084103 93.489516,60.6069846 C93.7460793,60.7072951 94.0219329,60.7825279 94.2862124,60.8056764 C94.4405361,60.5836432 94.5908088,60.3907385 94.6508022,60.3292019 C94.7568998,60.2848338 94.8591392,60.3041243 94.9131526,60.3347961 C94.8936692,60.3907385 94.8109131,60.5547075 94.6951703,60.7574503 C94.5792346,60.9600002 94.4308909,61.2028672 94.3035738,61.4017519"
          id="Fill-496"
          fill="#FFFFFE"
        />
        <path
          d="M96.29435,57.6729045 C96.2036849,58.3208713 96.3174986,58.7898226 96.6280751,58.9921796 C96.9328645,59.2024457 97.4305586,59.1503614 98.1211573,58.7433325 C98.7808913,58.3536651 99.3364568,57.8079377 99.7531309,57.1906428 C100.169805,56.5714188 100.439872,55.8885362 100.532466,55.2288022 C100.623131,54.5765915 100.515104,54.1022389 100.212244,53.8917799 C99.9074547,53.6873009 99.4136187,53.7432433 98.7307361,54.1464141 C98.0710021,54.5362744 97.5077205,55.0918399 97.0852592,55.7110639 C96.664727,56.3320241 96.3850152,57.0208867 96.29435,57.6729045 Z M95.7831527,58.0143458 C95.8929154,57.2328889 96.2557691,56.3802502 96.788186,55.6124896 C97.322532,54.8429928 98.0189179,54.1601103 98.8136851,53.691159 C99.6084524,53.2224006 100.218031,53.1396445 100.60577,53.3595559 C100.98965,53.5831324 101.149761,54.1157422 101.043663,54.8813809 C100.931779,55.6722901 100.598053,56.5017802 100.077018,57.2620175 C99.5563682,58.0220619 98.8541951,58.7163259 98.0073436,59.2161419 C97.2125763,59.6847074 96.6029975,59.7657273 96.2210463,59.5380998 C95.837166,59.3106652 95.6770551,58.7801773 95.7831527,58.0143458 L95.7831527,58.0143458 Z"
          id="Fill-497"
          fill="#FFFFFE"
        />
        <path
          d="M104.272695,53.1550769 L106.232799,49.3895776 L106.693841,49.1173891 C106.784314,49.0635687 106.906036,48.9960521 107.00056,48.9439678 C107.048786,48.9188902 107.087367,48.8957416 107.116302,48.8820454 C107.181697,48.8513736 107.183819,48.8608259 107.191342,48.9129101 C107.191342,48.9420388 107.191342,48.9707815 107.187677,49.0076263 C107.177839,49.0768791 107.158742,49.1561629 107.135593,49.1984091 C107.023708,49.2910033 106.848165,49.4125333 106.670693,49.5359923 L106.066901,53.9843741 C106.232799,53.9052832 106.389052,53.8339085 106.494957,53.7914694 C106.508653,53.8128819 106.506531,53.8823276 106.497078,53.9498442 C106.487433,54.0192899 106.464285,54.0945227 106.429562,54.1464141 C106.425704,54.1523941 106.406413,54.1678265 106.375356,54.1888531 C106.309768,54.2312921 106.209458,54.2988088 106.101624,54.3624673 C106.043752,54.3991192 105.995526,54.4280549 105.949229,54.4550615 L105.574801,54.6769019 C105.474684,54.7347733 105.366464,54.7947667 105.272134,54.846658 C105.225837,54.8719286 105.181276,54.8968133 105.15234,54.9103166 C105.086945,54.9450394 105.084823,54.931729 105.081158,54.8757866 C105.077107,54.850709 105.075371,54.8215804 105.081158,54.7849285 C105.090803,54.7174119 105.110094,54.6385139 105.131313,54.595882 C105.23934,54.5131258 105.399451,54.397383 105.571136,54.2775892 L106.111269,50.2904424 L104.176435,54.0441746 L104.116635,54.0808265 L102.959207,52.1461855 L102.382422,56.1584098 C102.550249,56.0775828 102.706309,56.0081371 102.808741,55.9674342 C102.820315,55.9888466 102.820315,56.0563633 102.810477,56.125809 C102.801025,56.1950617 102.777876,56.2704875 102.743153,56.3206427 C102.737173,56.328166 102.720005,56.3418622 102.68914,56.3648179 C102.623553,56.4072569 102.523242,56.4728445 102.413286,56.538625 C102.357344,56.5752769 102.309118,56.6020906 102.260892,56.6312192 L101.888586,56.8511305 C101.788275,56.9107381 101.680056,56.9705385 101.585725,57.0226228 C101.537499,57.0477004 101.49506,57.072778 101.464195,57.0864743 C101.400537,57.1211971 101.398608,57.1075009 101.392821,57.0496295 C101.388963,57.0264809 101.388963,56.9977381 101.394557,56.9608933 C101.404202,56.8914476 101.423685,56.8142858 101.444905,56.7720396 C101.551003,56.6888977 101.716901,56.5692968 101.888586,56.4498888 L102.5271,51.9802874 C102.357344,52.0630435 102.191253,52.1423274 102.085348,52.1768573 C102.073774,52.1556378 102.07551,52.0881211 102.083419,52.0186755 C102.094994,51.9494227 102.116213,51.873997 102.150936,51.8238417 C102.156723,51.8163185 102.174085,51.8026222 102.204949,51.7796666 C102.272273,51.7333694 102.370847,51.6716399 102.48061,51.6020014 L102.633198,51.5132652 L103.08826,51.2431987 L104.255526,53.1645292 L104.272695,53.1550769"
          id="Fill-498"
          fill="#FFFFFE"
        />
      </g>
    </g>
  </svg>
)
export const wonningImage = (
  <svg
    width="150px"
    height="150px"
    viewBox="0 0 512 512"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    aria-hidden="true"
  >
    <g
      id="7.category/1_woning"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Group-3" transform="translate(72.000000, 1.000000)">
        <polyline
          id="Fill-125"
          fill="#F8F7F6"
          points="182.173794 510.785801 364.364457 407.925922 366.235955 141.403131 273.268282 105.96358 184.037702 246.29644 182.173794 510.785801"
        />
        <polyline
          id="Fill-126"
          fill="#E4E4E3"
          points="182.20753 510.785801 0.0168679439 408.970891 0.0168679439 134.377632 184.037702 246.29644 182.20753 510.785801"
        />
        <polyline
          id="Fill-127"
          fill="#2A90C3"
          points="92.5375404 8.46041583e-14 -8.46041583e-14 134.96801 184.020834 246.887661 273.268282 105.96358 92.5375404 8.46041583e-14"
        />
        <polyline
          id="Fill-128"
          fill="#1A6C95"
          points="92.5375404 0 180.807491 28.6324914 366.235955 141.403131 273.268282 105.96358 92.5375404 0"
        />
        <polyline
          id="Fill-129"
          fill="#2A90C3"
          points="212.35898 332.163552 258.745826 305.376414 258.745826 467.048066 212.35898 492.855176 212.35898 332.163552"
        />
        <polyline
          id="Fill-130"
          fill="#2A90C3"
          points="289.850315 291.367586 332.112948 266.968105 332.112948 355.652164 289.850315 381.70386 289.850315 291.367586"
        />
        <polyline
          id="Fill-131"
          fill="#1A6C95"
          points="155.868236 330.619292 113.605602 306.21222 113.605602 394.903869 155.868236 420.955565 155.868236 330.619292"
        />
        <polyline
          id="Fill-132"
          fill="#1A6C95"
          points="74.4972744 291.367586 32.2346409 266.968105 32.2346409 355.652164 74.4972744 381.70386 74.4972744 291.367586"
        />
      </g>
    </g>
  </svg>
)

export const verwarmingImage = (
  <svg
    width="150px"
    height="150px"
    viewBox="0 0 512 512"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    aria-hidden="true"
  >
    <g
      id="7.category/2_verwarming"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Group-2" transform="translate(60.000000, 1.000000)">
        <polyline
          id="Fill-117"
          fill="#F8F7F6"
          points="177.242221 510.218812 354.500853 410.143423 356.329895 150.835592 265.871537 116.355415 179.055672 252.889365 177.242221 510.218812"
        />
        <polyline
          id="Fill-118"
          fill="#E4E4E3"
          points="177.275044 510.218812 0.0164113168 411.160104 0.0164113168 144.000278 179.055672 252.889365 177.275044 510.218812"
        />
        <polyline
          id="Fill-119"
          fill="#2A90C3"
          points="90.0324838 13.2603439 -2.0578466e-13 144.574674 179.03926 253.464582 265.871537 116.355415 90.0324838 13.2603439"
        />
        <polyline
          id="Fill-120"
          fill="#1A6C95"
          points="90.0324838 13.2603439 175.912904 41.1177336 356.329895 150.835592 265.871537 116.355415 90.0324838 13.2603439"
        />
        <polyline
          id="Fill-121"
          fill="#2A90C3"
          points="206.618478 336.431994 251.741394 310.370002 251.741394 467.665088 206.618478 492.773582 206.618478 336.431994"
        />
        <polyline
          id="Fill-122"
          fill="#2A90C3"
          points="282.012067 296.740404 323.122416 273.001434 323.122416 359.284752 282.012067 384.63121 282.012067 296.740404"
        />
        <polyline
          id="Fill-123"
          fill="#1A6C95"
          points="151.648773 334.929538 110.530218 311.183183 110.530218 397.473886 151.648773 422.820345 151.648773 334.929538"
        />
        <polyline
          id="Fill-124"
          fill="#1A6C95"
          points="72.4805805 296.740404 31.3620263 273.001434 31.3620263 359.284752 72.4805805 384.63121 72.4805805 296.740404"
        />
        <path
          d="M372.15943,146.32248 L287.96117,194.933621 C282.036684,198.35538 277.228168,194.719453 277.228168,186.810019 L277.228168,70.4127546 C277.228168,62.509885 282.036684,53.3277533 287.96117,49.8986086 L372.15943,1.2874678 C378.083916,-2.13429175 382.892431,1.50081492 382.892431,9.41189016 L382.892431,125.808334 C382.892431,133.710383 378.083916,142.893335 372.15943,146.32248"
          id="Fill-1911"
          fill="#DE482A"
        />
        <polyline
          id="Fill-1912"
          fill="#DE482A"
          points="296.733018 185.553732 296.733018 228.444709 333.157936 164.523451 296.733018 185.553732"
        />
        <polyline
          id="Fill-1913"
          fill="#DE482A"
          points="387.963528 5.86622518 377.821335 3.0867699e-13 281.511522 195.777983 290.989058 201.300391 301.615385 191.396982 296.733018 228.444709 306.670071 234.18867"
        />
        <path
          d="M382.096483,152.059055 L297.906428,200.668555 C291.973737,204.091135 287.165221,200.463414 287.165221,192.55398 L287.165221,76.1567154 C287.165221,68.2546664 291.973737,59.064329 297.906428,55.6425695 L382.096483,7.03142867 C388.029174,3.60966912 392.829484,7.24559635 392.829484,15.1468248 L392.837689,131.54491 C392.837689,139.454344 388.029174,148.637296 382.096483,152.059055"
          id="Fill-1914"
          fill="#E67848"
        />
        <polyline
          id="Fill-1915"
          fill="#E67848"
          points="306.670071 191.289488 306.670071 234.18867 343.094988 170.267411 306.670071 191.289488"
        />
        <path
          d="M343.1114,140.439023 C335.07806,145.494529 328.59559,142.391969 328.554446,133.473239 C328.53815,128.901867 330.269544,123.445104 333.330255,118.472475 C333.945679,117.472205 334.290317,116.371827 334.290317,115.460999 L334.093381,71.8971582 C334.07697,66.5314782 337.917218,59.818429 342.750351,56.7741298 C347.591689,53.7306511 351.46476,55.5843093 351.489377,60.9508099 L351.678107,104.506445 C351.686313,105.426299 352.039156,106.081931 352.65458,106.303484 C355.739908,107.420274 357.51233,110.668894 357.537142,115.239446 C357.577975,124.159817 351.152945,135.384337 343.1114,140.439023 Z M357.471302,99.9367134 L357.290777,57.3074976 C357.249749,48.4626184 350.693428,45.3198512 342.725734,50.332688 C334.749834,55.3463452 328.259158,66.6947708 328.300186,75.5412911 L328.47989,118.177892 C324.952278,124.5701 322.73675,131.330742 322.753071,137.107525 L322.753071,137.116552 C322.810601,149.514481 331.968116,153.905329 343.144222,146.872259 C354.312123,139.849036 363.387581,123.987498 363.338547,111.580543 C363.305525,105.802939 361.040763,101.856017 357.471302,99.9367134 L357.471302,99.9367134 Z"
          id="Fill-1916"
          fill="#F2F1F0"
        />
        <path
          d="M345.901323,113.47605 L345.696182,64.6433562 C345.704388,62.8553432 344.415279,62.19807 342.815996,63.1835695 L342.733939,63.2401886 C341.133836,64.2741015 339.861959,66.5314782 339.894782,68.2956947 L340.107308,117.119362 C336.76022,120.573124 334.331345,125.661452 334.347674,129.820901 C334.372373,135.114371 338.319295,137.000852 343.086783,134.006607 C347.85427,131.002516 351.768369,124.176228 351.743868,118.875373 C351.727341,114.714284 349.265643,112.704718 345.901323,113.47605"
          id="Fill-1917"
          fill="#F2F1F0"
        />
      </g>
    </g>
  </svg>
)

export const isolatieImage = (
  <svg
    width="150px"
    height="150px"
    viewBox="0 0 512 512"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    aria-hidden="true"
  >
    <g
      id="7.category/3_isolatie"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Group-2">
        <g id="Group" transform="translate(161.684211, 0.000000)">
          <polyline
            id="Fill-101"
            fill="#636463"
            points="129.351138 347.003392 179.648584 317.965821 179.648584 74.4990105 106.221438 11.155849 24.7924251 166.540517 24.7775793 395.3939 129.351138 239.039804"
          />
          <polyline
            id="Fill-102"
            fill="#8A8B8A"
            points="179.180943 317.037218 12.9009685 399.542549 185.119248 497.829669 345.46834 407.292038 179.180943 317.037218"
          />
          <polyline
            id="Fill-103"
            fill="#636463"
            points="178.757839 73.4345693 179.180943 317.037218 345.46834 407.292038 346.403623 171.303781 178.757839 73.4345693"
          />
          <polyline
            id="Fill-133"
            fill="#F8F7F6"
            points="185.119248 497.829669 345.46834 407.292038 347.115477 172.72452 265.293794 141.533571 186.752282 265.039189 185.119248 497.829669"
          />
          <polyline
            id="Fill-134"
            fill="#E4E4E3"
            points="160.349092 501.125428 3.63000078e-13 411.508977 3.63000078e-13 169.839246 161.959857 268.339402 160.349092 501.125428"
          />
          <polyline
            id="Fill-135"
            fill="#2A90C3"
            points="98.3531833 5.58461659e-14 16.9093246 118.786892 178.869182 217.286306 257.425539 93.2618287 98.3531833 5.58461659e-14"
          />
          <polyline
            id="Fill-136"
            fill="#1A6C95"
            points="98.3531833 -9.30769432e-15 176.048487 25.1984567 339.247965 124.452778 257.425539 93.2618287 98.3531833 -9.30769432e-15"
          />
          <polyline
            id="Fill-137"
            fill="#2A90C3"
            points="211.685742 340.613033 252.511592 317.037218 252.511592 459.327181 211.685742 482.041199 211.685742 340.613033"
          />
          <polyline
            id="Fill-138"
            fill="#2A90C3"
            points="279.88718 304.708554 317.08324 283.231188 317.08324 361.285016 279.88718 384.21504 279.88718 304.708554"
          />
          <polyline
            id="Fill-139"
            fill="#1A6C95"
            points="137.167432 342.549663 99.9713715 321.076008 99.9713715 399.135033 137.167432 422.063572 137.167432 342.549663"
          />
          <polyline
            id="Fill-140"
            fill="#1A6C95"
            points="65.5514688 308.004313 28.3628312 286.529174 28.3628312 364.588941 65.5514688 387.517481 65.5514688 308.004313"
          />
          <polyline
            id="Fill-2624"
            fill="#E67848"
            points="339.247965 123.954703 339.247965 139.333429 260.951408 111.473869 180.465101 231.192333 16.9093246 133.199159 16.9093246 118.288817 178.884028 216.787489 257.514614 92.3183805 339.247965 123.954703"
          />
          <polyline
            id="Fill-2933"
            fill="#E67848"
            points="-1.11692332e-13 169.603941 11.7652676 166.641469 172.3222 263.98514 170.711435 494.236994 160.349092 501.125428 161.959857 268.692732 -1.11692332e-13 169.603941"
          />
        </g>
        <g
          id="Group-6"
          transform="translate(69.000000, 429.500000) scale(1, -1) translate(-69.000000, -429.500000) translate(0.000000, 347.000000)"
        >
          <path
            d="M36.7655334,41.3490998 L123.305731,91.0516557 C123.305731,91.0516557 135.691339,100.871068 137.547059,115.780456 C139.391115,130.699388 134.35522,135.333387 134.35522,135.333387 C134.35522,135.333387 130.166594,140.074488 124.461579,140.380947 C119.626102,140.656654 114.301775,138.005624 114.301775,138.005624 C114.301775,138.005624 110.920122,136.468028 110.633811,134.082101 C110.633811,134.082101 110.102545,131.686631 111.06858,130.44595 C112.033554,129.193603 113.327257,128.28271 114.163921,128.080171 C115.013311,127.878693 116.307013,127.931713 116.307013,127.931713 C116.307013,127.931713 117.832946,128.537209 119.350395,129.320853 C120.877388,130.116162 123.146669,131.134157 124.9271,130.08541 C126.699048,129.046206 126.985359,128.027151 126.985359,128.027151 C126.985359,128.027151 128.406311,126.425929 128.023502,121.856615 C127.642814,117.275637 126.603611,113.690385 126.603611,113.690385 C126.603611,113.690385 124.9271,107.274894 121.386385,103.617534 C117.855215,99.9474493 116.084327,98.8562856 116.084327,98.8562856 L103.294702,91.0516557 L28.8018416,48.1473991 C28.8018416,48.1473991 27.1041225,47.0329064 26.6799579,45.7498083 C26.2674577,44.4571665 26.2674577,43.3755465 26.2674577,43.3755465 C26.2674577,43.3755465 26.3204783,41.635411 26.9991418,40.818894 C27.6884094,40.0034374 28.9715075,39.2388806 28.9715075,39.2388806 C28.9715075,39.2388806 29.925878,38.7404871 31.0287062,38.6673187 C32.1315343,38.5824858 33.3934242,39.2176723 33.3934242,39.2176723 L36.7655334,41.3490998"
            id="Fill-1780"
            fill="#679CC7"
          />
          <path
            d="M89.3513486,114.612943 C87.7607311,110.987395 84.855203,106.108441 83.6251255,104.083055 C83.2433773,103.469076 82.8086085,102.88479 82.3208191,102.34398 C81.0260565,100.912424 79.584957,98.8456815 77.2944678,96.7662142 C76.6264084,96.16284 75.6720379,95.3452626 74.4737727,94.475725 L2.53544433,52.4940266 C2.53544433,52.4940266 0.838785639,51.3805943 0.425225084,50.0974962 C3.59011066e-13,48.8037939 3.59011066e-13,47.722174 3.59011066e-13,47.722174 C3.59011066e-13,47.722174 0.0540809957,45.9947634 0.732744471,45.177186 C1.42201206,44.360669 2.71571431,43.598233 2.71571431,43.598233 C2.71571431,43.598233 3.65948071,43.0998395 4.76230885,43.0139462 C5.87574112,42.9397173 7.13657061,43.5653602 7.13657061,43.5653602 L10.499136,45.7084522 L78.1109848,84.5301238 C78.7260235,84.9850405 79.6273735,85.6530998 80.6761206,86.5120333 C82.4056521,87.9340453 88.5030192,93.2350433 94.0065558,101.824378 C96.2111517,105.260112 98.7784084,111.028751 99.6373419,113.012782 C99.8483638,113.488906 100.01909,113.967152 100.156944,114.47615 C100.878024,116.967057 103.008391,125.016642 102.680723,131.187177 C102.288371,138.589911 100.750774,142.057457 100.750774,142.057457 C100.750774,142.057457 98.4592245,147.040332 95.1411963,149.681817 C91.8221078,152.321182 88.2580641,153.233136 88.2580641,153.233136 C88.2580641,153.233136 85.2899718,154.049653 80.1469752,153.233136 C74.9933744,152.416619 69.6807119,149.362634 69.6807119,149.362634 C69.6807119,149.362634 67.0827033,147.879118 67.6447215,144.66607 C68.2067397,141.451962 69.9871709,140.986442 69.9871709,140.986442 C69.9871709,140.986442 71.3137459,139.417032 74.1238368,140.403215 C76.9222633,141.398942 80.2519559,143.542034 82.1087368,143.434932 C83.9644572,143.339495 86.8805894,144.157073 89.7320364,140.944025 C92.5962083,137.719313 92.5421273,132.417255 92.5421273,132.417255 C92.5421273,132.417255 92.690585,124.973165 91.567609,121.240516 C90.7288233,118.442089 89.9971393,116.33187 89.6800762,115.450668 C89.5846391,115.153753 89.478598,114.900314 89.3513486,114.612943"
            id="Fill-1781"
            fill="#679CC7"
          />
          <path
            d="M17.8902055,22.3041061 C17.8902055,22.3041061 13.669767,20.1620745 14.9634692,16.4188212 C16.2465673,12.6660243 18.7915554,12.7073803 18.7915554,12.7073803 C18.7915554,12.7073803 20.8169417,12.2726116 22.2591016,13.1007931 C23.700201,13.9162497 70.147293,40.7669338 70.147293,40.7669338 C70.147293,40.7669338 74.7070633,43.4709836 75.8310997,42.1030525 C76.9657401,40.7245173 77.6231954,38.0522799 77.5797185,35.0396503 C77.5489666,32.0185375 77.3474884,30.5435048 76.9339278,28.9327395 C76.5203672,27.3198533 75.5978091,23.1736436 71.0062265,16.5577352 C66.4146439,9.93970586 62.7032031,8.84854224 62.7032031,8.84854224 C62.7032031,8.84854224 61.0277526,7.56544411 60.8262744,5.93241012 C60.6247962,4.36300084 60.9217114,3.50300696 60.9217114,3.50300696 C60.9217114,3.50300696 61.3660239,1.59426594 62.883473,0.83076953 C64.3988013,0.0566690039 65.7147722,0.0036484199 65.7147722,0.0036484199 C65.7147722,0.0036484199 66.9554539,-0.069519986 67.8992203,0.43947762 C68.8313222,0.93787111 72.5003466,2.77238332 76.043182,6.81255182 C79.5743529,10.8633244 81.7375927,14.1718089 82.9040456,16.4718418 C84.0704984,18.7729352 85.5115979,21.7749606 86.1796572,24.4143253 C86.848777,27.0653545 86.9866305,26.9709779 87.4627554,30.0239031 C87.941001,33.0884928 87.6228775,37.6694713 87.6228775,37.6694713 C87.6228775,37.6694713 87.4213993,42.1232004 85.9569708,44.8484584 C84.5052672,47.5747768 83.4766679,48.8568145 82.1935697,49.9607031 C80.9104716,51.0741353 78.0038832,51.9532166 78.0038832,51.9532166 C78.0038832,51.9532166 74.9827703,52.6541487 72.596844,52.21938 C70.2109177,51.7835508 68.2915726,50.9670338 68.2915726,50.9670338 C68.2915726,50.9670338 66.3510192,50.171725 65.4920858,49.7263521 C64.6320919,49.2809792 17.8902055,22.3041061 17.8902055,22.3041061"
            id="Fill-1782"
            fill="#679CC7"
          />
          <path
            d="M44.1555424,123.23409 C44.1555424,123.23409 48.4396055,103.097932 68.7051332,104.105323 C68.7051332,104.105323 67.9511805,125.886179 44.1555424,123.23409"
            id="Fill-1783"
            fill="#408F51"
          />
          <path
            d="M105.289336,50.7337432 C105.289336,50.7337432 116.889179,65.7491726 136.179128,54.5204733 C136.179128,54.5204733 126.295031,36.0788538 105.289336,50.7337432"
            id="Fill-1784"
            fill="#408F51"
          />
          <path
            d="M105.289336,140.403215 C105.289336,140.403215 101.938435,157.677322 124.20708,164.367459 C124.20708,164.367459 130.240823,145.067966 105.289336,140.403215"
            id="Fill-1785"
            fill="#408F51"
          />
        </g>
      </g>
    </g>
  </svg>
)

export const energyImage = (
  <svg
    width="150px"
    height="150px"
    viewBox="0 0 512 512"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    aria-hidden="true"
  >
    <g
      id="7.category/4_greenenergy"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Group-4" transform="translate(73.000000, 1.000000)">
        <path
          d="M131.611659,360.896321 C131.611659,367.308608 135.675847,372.507008 140.679991,372.507008 C145.693086,372.507008 149.757274,367.308608 149.757274,360.896321 C149.757274,354.484035 145.693086,349.286529 140.679991,349.286529 C135.675847,349.286529 131.611659,354.484035 131.611659,360.896321"
          id="Fill-105"
          fill="#E67848"
        />
        <polyline
          id="Fill-141"
          fill="#F8F7F6"
          points="182.082788 510.547963 364.192432 407.735641 366.062495 141.33975 273.142086 105.915964 183.944795 246.180584 182.082788 510.547963"
        />
        <polyline
          id="Fill-142"
          fill="#E4E4E3"
          points="182.118596 510.547963 0.00895195614 408.774068 0.00895195614 134.316045 183.944795 246.180584 182.118596 510.547963"
        />
        <polyline
          id="Fill-143"
          fill="#2A90C3"
          points="92.4916108 2.46950662e-13 -1.79600482e-13 134.905084 183.925996 246.768728 273.142086 105.915964 92.4916108 2.46950662e-13"
        />
        <polyline
          id="Fill-144"
          fill="#1A6C95"
          points="92.4916108 1.79600482e-13 180.722091 28.6194038 366.062495 141.33975 273.142086 105.915964 92.4916108 1.79600482e-13"
        />
        <polyline
          id="Fill-145"
          fill="#2A90C3"
          points="212.258937 332.004778 258.622013 305.236639 258.622013 466.835561 212.258937 492.617194 212.258937 332.004778"
        />
        <polyline
          id="Fill-146"
          fill="#2A90C3"
          points="289.711261 291.228618 331.955542 266.838118 331.955542 355.487549 289.711261 381.523419 289.711261 291.228618"
        />
        <polyline
          id="Fill-147"
          fill="#1A6C95"
          points="155.789998 330.460566 113.546612 306.070066 113.546612 394.719497 155.789998 420.759842 155.789998 330.460566"
        />
        <polyline
          id="Fill-148"
          fill="#1A6C95"
          points="74.4534192 291.228618 32.2180901 266.838118 32.2180901 355.487549 74.4534192 381.523419 74.4534192 291.228618"
        />
        <polyline
          id="Fill-2625"
          fill="#1A6C95"
          points="102.607321 27.4135753 33.8115383 136.629231 86.707752 169.53125 153.463384 59.1258799 102.607321 27.4135753"
        />
        <polyline
          id="Fill-2626"
          fill="#143A4F"
          points="153.463384 59.1258799 155.665565 65.9571176 88.2036238 176.675806 35.1265807 143.431822 33.8115383 136.629231 86.707752 169.53125 153.463384 59.1258799"
        />
        <line
          x1="127.904654"
          y1="43.1842364"
          x2="60.7649831"
          y2="153.280764"
          id="Fill-2627"
          fill="#1A6C95"
        />
        <polyline
          id="Fill-2628"
          fill="#143A4F"
          points="127.520615 42.9505904 60.3809442 153.047118 61.1508124 153.51262 128.280636 43.4169873"
        />
        <line
          x1="69.0732936"
          y1="81.4117747"
          x2="121.692892"
          y2="111.862749"
          id="Fill-2629"
          fill="#1A6C95"
        />
        <polyline
          id="Fill-2630"
          fill="#143A4F"
          points="68.8494947 81.7984992 121.469093 112.251264 121.915795 111.475129 69.2970925 81.0250502"
        />
        <polyline
          id="Fill-2631"
          fill="#1A6C95"
          points="171.840855 70.0374193 103.045967 179.25397 155.943076 212.156885 222.697813 101.751514 171.840855 70.0374193"
        />
        <polyline
          id="Fill-2632"
          fill="#143A4F"
          points="222.697813 101.751514 224.899994 108.580962 157.438053 219.301441 104.361905 186.054771 103.045967 179.25397 155.943076 212.156885 222.697813 101.751514"
        />
        <line
          x1="197.139978"
          y1="85.8089756"
          x2="130.000307"
          y2="195.904608"
          id="Fill-2633"
          fill="#1A6C95"
        />
        <polyline
          id="Fill-2634"
          fill="#143A4F"
          points="196.755044 85.5762247 129.615373 195.672752 130.376289 196.139149 197.51596 86.0417264"
        />
        <line
          x1="138.307722"
          y1="124.037409"
          x2="190.927321"
          y2="154.487488"
          id="Fill-2635"
          fill="#1A6C95"
        />
        <polyline
          id="Fill-2636"
          fill="#143A4F"
          points="138.083923 124.423238 190.702626 154.876003 191.151119 154.100763 138.531521 123.648894"
        />
      </g>
    </g>
  </svg>
)

export const climateImage = (
  <svg
    width="150px"
    height="150px"
    viewBox="0 0 512 512"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    aria-hidden="true"
  >
    <g
      id="7.category/5_climate"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Group" transform="translate(27.000000, 1.000000)">
        <path
          d="M103.28932,144.823115 C99.7261711,144.604166 96.7570006,141.631383 96.7352941,136.224154 C96.7208705,128.589867 102.212644,119.217723 108.853353,115.38143 C115.500567,111.54586 120.790734,114.693513 120.812467,122.326355 C120.826864,127.734306 118.015943,134.043342 113.962148,138.66438 L114.005504,155.278439 C114.019956,158.679725 111.657048,162.828182 108.693658,164.537135 C105.730991,166.24681 103.347128,164.83846 103.339902,161.437173 L103.28932,144.823115 M108.701607,103.998285 C91.4241999,113.973079 77.4563086,138.160727 77.5139379,158.014209 C77.5719249,177.866969 91.6265284,185.877009 108.903936,175.901492 C126.187846,165.920917 140.142008,141.739773 140.084379,121.885568 C140.033618,102.032808 125.98624,94.0191553 108.701607,103.998285"
          id="Fill-111"
          fill="#FFFFFE"
        />
        <path
          d="M70.8011467,249.663231 C70.6421743,249.663231 70.4759759,249.663231 70.3090549,249.663231 C50.0841553,249.471741 34.4759581,237.616737 27.5028515,216.373692 C24.9303894,208.550806 23.5357681,199.451805 23.4991859,189.195919 C23.3478916,135.063656 61.4145504,69.1356424 108.520957,41.9354683 C108.781093,41.7866124 109.034004,41.6406468 109.29414,41.4939587 C122.741759,33.8690653 135.459549,30.2452177 146.753814,30.2336561 C146.767543,30.2336561 146.789944,30.2336561 146.804396,30.2336561 C146.818848,30.2336561 146.840526,30.2336561 146.854978,30.2336561 C174.776309,30.2654505 193.997514,52.3951283 194.105905,90.6988004 C194.105905,90.8043002 194.105905,90.9098001 194.105905,91.0160225 C194.112408,145.087587 156.097054,210.816885 109.076637,237.963586 C108.882257,238.074867 108.693658,238.184702 108.498556,238.294538 C95.0733386,245.944722 82.3700003,249.603977 71.0829614,249.663231 C70.9890232,249.663231 70.8943623,249.663231 70.8011467,249.663231 M134.505715,65.7191814 C126.715345,65.7191814 117.914779,68.2641847 108.614895,73.6360059 C76.7409329,92.0356135 50.9939109,136.64254 51.0954964,173.263996 C51.1680579,199.194559 64.189341,214.169757 83.092602,214.169757 C90.8894746,214.169757 99.6835376,211.624753 108.990648,206.253655 C140.86461,187.848989 166.610909,143.250011 166.510042,106.630001 C166.437485,80.6972699 153.422705,65.7191814 134.505715,65.7191814"
          id="Fill-113"
          fill="#F0A980"
        />
        <path
          d="M60.3378738,279.89472 C24.6847048,279.891106 0.137924313,251.655444 3.12638804e-13,202.767101 C-0.201698496,133.721062 48.3571372,49.6174473 108.448696,14.9260612 C125.993466,4.79663023 142.56995,0 157.267669,0 C192.920838,0 217.466896,28.2428883 217.605499,77.131953 C217.800015,146.180161 169.255631,230.275826 109.156846,264.972271 C91.6120763,275.098811 75.0348702,279.89472 60.3378738,279.89472 M70.8011467,249.663231 L70.8011467,249.663231 C70.8943623,249.663231 70.9890232,249.663231 71.0829614,249.663231 C82.3700003,249.606145 95.0661126,245.946167 108.498556,238.294538 C108.693658,238.184702 108.882257,238.074867 109.076637,237.963586 C156.097054,210.816885 194.112408,145.087587 194.105905,91.0160225 C194.105905,90.9098001 194.105905,90.8043002 194.105905,90.6988004 C193.997514,52.3907927 174.776309,30.2611149 146.854978,30.2336561 C146.840526,30.2336561 146.818848,30.2336561 146.804396,30.2336561 C146.789944,30.2336561 146.767543,30.2336561 146.753814,30.2336561 C135.459549,30.2437725 122.741759,33.8676201 109.29414,41.4939587 C109.034004,41.6406468 108.781093,41.7866124 108.520957,41.9354683 C61.4145504,69.1356424 23.3478916,135.063656 23.4991859,189.195919 C23.5285421,199.451805 24.9303894,208.550806 27.5028515,216.373692 C34.4759581,237.619628 50.0762067,249.473909 70.3090549,249.663231 C70.4759759,249.663231 70.6421743,249.663231 70.8011467,249.663231"
          id="Fill-114"
          fill="#FEEEE0"
        />
        <path
          d="M71.1407917,249.865886 C70.8929176,249.865886 70.6337765,249.865886 70.3735087,249.862506 C70.6337765,249.865886 70.8929176,249.865886 71.1407917,249.865886 M71.0829614,249.663231 C82.3700003,249.603977 95.0733386,245.944722 108.498556,238.294538 C95.0661126,245.946167 82.3700003,249.606145 71.0829614,249.663231 M27.5028515,216.373692 C24.9303894,208.550806 23.5285421,199.451805 23.4991859,189.195919 C23.3478916,135.063656 61.4145504,69.1356424 108.520957,41.9354683 C61.4145504,69.1356424 23.3478916,135.063656 23.4991859,189.195919 C23.5357681,199.451805 24.9303894,208.550806 27.5028515,216.373692 M194.307954,91.3067716 C194.307954,91.1411466 194.307954,90.9766483 194.307954,90.8121501 C194.307954,90.9766483 194.307954,91.1411466 194.307954,91.3067716 M109.29414,41.4939587 C122.741759,33.8676201 135.459549,30.2437725 146.753814,30.2336561 C135.459549,30.2452177 122.741759,33.8690653 109.29414,41.4939587"
          id="Fill-115"
          fill="#EFA47A"
        />
        <path
          d="M108.614895,73.6360059 C76.7409329,92.0348909 50.9939109,136.643263 51.0954964,173.264718 C51.204188,209.884006 77.1159632,224.653262 108.990648,206.253655 C140.86461,187.849711 166.618135,143.250733 166.510086,106.630001 C166.408581,70.0099905 140.488857,55.2306174 108.614895,73.6360059"
          id="Fill-116"
          fill="#E67848"
        />
        <path
          d="M221.254051,58.1188565 C214.656698,61.9269676 208.861432,69.1573204 205.486882,76.9903231 C203.87548,77.4087095 202.177366,78.1139688 200.420721,79.1270564 C190.239985,85.006144 181.95897,99.0383468 181.560816,110.868782 L180.947327,111.222857 C173.020386,115.799816 166.618135,126.892475 166.646942,136.000148 C166.668717,145.10782 173.114325,148.780082 181.041265,144.203845 L257.810472,99.8830682 C265.737413,95.3075541 272.139665,84.2148951 272.11014,75.1086682 C272.089082,66.0862631 265.766317,62.4024395 257.947767,66.7763477 C255.180202,60.2230727 248.286582,58.4237944 240.236799,63.0708461 C240.005566,63.2059726 239.774333,63.3454348 239.543101,63.4899551 C237.287861,55.6042025 229.946227,53.1018328 221.254051,58.1188565"
          id="Fill-392"
          fill="#E4E4E3"
        />
        <polyline
          id="Fill-2851"
          fill="#E4E4E3"
          points="209.909204 510.429237 68.2575887 430.278254 68.2575887 259.854083 211.33273 343.03927 209.909204 510.429237"
        />
        <polyline
          id="Fill-2852"
          fill="#F8F7F6"
          points="351.394621 259.854083 351.249379 430.379418 457.104027 367.195846 457.104027 198.542049 351.394621 259.854083"
        />
        <polyline
          id="Fill-2853"
          fill="#75B86A"
          points="317.013232 115.618443 457.104027 198.542049 210.66071 343.03927 68.2575887 259.854083 317.013232 115.618443"
        />
        <polyline
          id="Fill-2854"
          fill="#F8F7F6"
          points="211.33273 343.03927 209.887526 510.429237 351.538419 430.278254 351.538419 259.854083"
        />
        <polyline
          id="Fill-2855"
          fill="#2A90C3"
          points="381.642007 294.138644 438.15741 261.581101 438.15741 331.397434 381.642007 365.251325 381.642007 294.138644"
        />
        <polyline
          id="Fill-2856"
          fill="#1A6C95"
          points="185.441187 371.602994 152.577984 352.396963 152.577984 422.214018 185.441187 442.721455 185.441187 371.602994"
        />
        <polyline
          id="Fill-2857"
          fill="#1A6C95"
          points="122.170903 340.71177 89.3142028 321.49779 89.3142028 391.315569 122.170903 411.823006 122.170903 340.71177"
        />
        <polyline
          id="Fill-2858"
          fill="#E4E4E3"
          points="229.368869 372.824913 265.426695 351.738672 265.426695 479.003288 229.368869 499.315622 229.368869 372.824913"
        />
        <polyline
          id="Fill-2859"
          fill="#2A90C3"
          points="289.612174 340.71177 322.468152 321.49779 322.468152 391.315569 289.612174 411.823006 289.612174 340.71177"
        />
        <path
          d="M285.067009,219.949125 C286.483309,219.127527 288.795634,219.127527 290.211934,219.949125 C291.634736,220.770001 291.634736,222.102478 290.211934,222.921909 C288.795634,223.742784 286.483309,223.742784 285.067009,222.921909 C283.642761,222.102478 283.642761,220.770001 285.067009,219.949125 Z M198.622165,229.495417 C200.044968,228.673818 202.350068,228.673818 203.774316,229.495417 C205.197118,230.316292 205.197118,231.648047 203.774316,232.468923 C202.350068,233.289798 200.044968,233.289798 198.622165,232.468923 C197.205866,231.648047 197.205866,230.316292 198.622165,229.495417 Z M321.543944,177.694989 C322.960244,176.874114 325.272569,176.874114 326.688869,177.694989 C328.112394,178.515142 328.112394,179.84762 326.688869,180.669218 C325.272569,181.489371 322.960244,181.489371 321.543944,180.669218 C320.120419,179.84762 320.120419,178.515142 321.543944,177.694989 Z M391.701346,197.054212 C393.116922,196.233337 395.42997,196.233337 396.84627,197.054212 C398.269795,197.874365 398.269795,199.206843 396.84627,200.028441 C395.42997,200.848594 393.116922,200.848594 391.701346,200.028441 C390.27782,199.206843 390.27782,197.874365 391.701346,197.054212 Z M385.862724,162.995103 C387.286249,162.172782 389.591348,162.172782 391.014874,162.995103 C392.437677,163.81381 392.437677,165.147011 391.014874,165.967164 C389.591348,166.789484 387.286249,166.789484 385.862724,165.967164 C384.445702,165.147011 384.445702,163.81381 385.862724,162.995103 Z M373.259827,200.203311 C374.684075,199.381712 376.989174,199.381712 378.4127,200.203311 C379.828999,201.024186 379.828999,202.356664 378.4127,203.177539 C376.989174,203.999137 374.684075,203.999137 373.259827,203.177539 C371.837024,202.356664 371.837024,201.024186 373.259827,200.203311 Z M264.118785,169.129269 C265.535085,168.307671 267.84741,168.307671 269.262987,169.129269 C270.687235,169.950144 270.687235,171.281899 269.262987,172.102052 C267.84741,172.92365 265.535085,172.92365 264.118785,172.102052 C262.69526,171.281899 262.69526,169.950144 264.118785,169.129269 Z M301.34,144.207458 C302.762803,143.385137 305.068625,143.385137 306.49215,144.207458 C307.915676,145.026166 307.915676,146.359366 306.49215,147.179519 C305.068625,148.00184 302.762803,148.00184 301.34,147.179519 C299.923701,146.359366 299.923701,145.026166 301.34,144.207458 Z M370.731444,154.237892 C372.147743,153.415572 374.460068,153.415572 375.875645,154.237892 C377.299893,155.057323 377.299893,156.390523 375.875645,157.210676 C374.460068,158.032274 372.147743,158.032274 370.731444,157.210676 C369.307918,156.390523 369.307918,155.057323 370.731444,154.237892 Z M222.293875,245.014734 C223.710897,244.195303 226.023223,244.195303 227.446748,245.014734 C228.862325,245.835609 228.862325,247.168087 227.446748,247.989685 C226.023223,248.809838 223.710897,248.809838 222.293875,247.989685 C220.871072,247.168087 220.871072,245.836332 222.293875,245.014734 Z M396.362127,207.909858 C397.785652,207.088982 400.090752,207.088982 401.514277,207.909858 C402.937802,208.731456 402.937802,210.063211 401.514277,210.884087 C400.090752,211.703517 397.785652,211.703517 396.362127,210.884087 C394.945827,210.063211 394.945827,208.731456 396.362127,207.909858 Z M226.78918,195.943573 C228.211983,195.124143 230.517805,195.124143 231.941331,195.943573 C233.364856,196.763726 233.364856,198.096927 231.941331,198.918525 C230.517805,199.737955 228.211983,199.737955 226.78918,198.918525 C225.372881,198.096927 225.372881,196.763726 226.78918,195.943573 Z M143.862684,247.117505 C145.279706,246.296629 147.592032,246.296629 149.008331,247.117505 C150.431857,247.936935 150.431857,249.269413 149.008331,250.089566 C147.592032,250.911886 145.279706,250.911886 143.862684,250.089566 C142.439881,249.269413 142.439881,247.936935 143.862684,247.117505 Z M342.882373,219.948403 C344.29795,219.127527 346.610275,219.127527 348.026575,219.948403 C349.450823,220.770001 349.450823,222.101756 348.026575,222.922631 C346.610275,223.742784 344.29795,223.742784 342.882373,222.922631 C341.458848,222.101756 341.458848,220.770001 342.882373,219.948403 Z M355.094342,225.292042 C356.510642,224.470444 358.822245,224.470444 360.239267,225.292042 C361.662792,226.111473 361.662792,227.44395 360.239267,228.264103 C358.822245,229.084979 356.510642,229.084979 355.094342,228.264103 C353.670817,227.44395 353.670817,226.111473 355.094342,225.292042 Z M269.538298,260.735657 C270.961824,259.916226 273.266923,259.916226 274.690449,260.735657 C276.113974,261.556532 276.113974,262.88901 274.690449,263.709163 C273.266923,264.530038 270.961824,264.530038 269.538298,263.709163 C268.114773,262.88901 268.114773,261.556532 269.538298,260.735657 Z M160.555507,263.587766 C161.979032,262.765445 164.284132,262.765445 165.707657,263.587766 C167.123234,264.407196 167.123234,265.740396 165.707657,266.560549 C164.284132,267.381425 161.979032,267.381425 160.555507,266.560549 C159.131259,265.740396 159.131259,264.407196 160.555507,263.587766 Z M170.859085,281.675932 C172.276107,280.855057 174.588432,280.855057 176.011957,281.675932 C177.428257,282.496808 177.428257,283.828563 176.011957,284.649438 C174.588432,285.470314 172.276107,285.470314 170.859085,284.649438 C169.436282,283.828563 169.436282,282.496808 170.859085,281.675932 Z M269.538298,284.674729 C270.961824,283.853854 273.266923,283.853854 274.690449,284.674729 C276.113974,285.495605 276.113974,286.828082 274.690449,287.648235 C273.266923,288.469111 270.961824,288.469111 269.538298,287.648235 C268.114773,286.828082 268.114773,285.495605 269.538298,284.674729 L269.538298,284.674729 Z"
          id="Fill-2860"
          fill="#9ECB94"
        />
        <path
          d="M164.197419,214.838163 C165.613719,214.016565 167.926044,214.016565 169.34957,214.838163 C170.765146,215.658316 170.765146,216.990071 169.34957,217.810947 C167.926044,218.6311 165.613719,218.6311 164.197419,217.810947 C162.773894,216.990071 162.773894,215.658316 164.197419,214.838163 Z M231.290989,181.899809 C232.707289,181.079656 235.018891,181.079656 236.435191,181.899809 C237.859439,182.721407 237.859439,184.052439 236.435191,184.874038 C235.018891,185.694913 232.707289,185.694913 231.290989,184.874038 C229.867464,184.052439 229.867464,182.721407 231.290989,181.899809 Z M273.180211,184.001857 C274.603736,183.181704 276.908836,183.181704 278.332361,184.001857 C279.748661,184.823455 279.748661,186.154488 278.332361,186.976086 C276.908836,187.796239 274.603736,187.796239 273.180211,186.976086 C271.756686,186.154488 271.756686,184.823455 273.180211,184.001857 Z M291.151316,161.600481 C292.574841,160.779606 294.879941,160.779606 296.302744,161.600481 C297.726992,162.421357 297.726992,163.753112 296.302744,164.57471 C294.879941,165.39414 292.574841,165.39414 291.151316,164.57471 C289.72779,163.753112 289.72779,162.421357 291.151316,161.600481 Z M184.798794,219.949125 C186.22232,219.126804 188.527419,219.126804 189.950945,219.949125 C191.373747,220.769278 191.373747,222.101756 189.950945,222.921186 C188.527419,223.742784 186.22232,223.742784 184.798794,222.921186 C183.381772,222.101756 183.381772,220.769278 184.798794,219.949125 Z M406.146154,189.281908 C407.569679,188.461033 409.874056,188.461033 411.298304,189.281908 C412.72183,190.101338 412.72183,191.434539 411.298304,192.256137 C409.874056,193.077012 407.569679,193.077012 406.146154,192.256137 C404.722629,191.434539 404.722629,190.101338 406.146154,189.281908 Z M415.915729,195.142931 C417.339255,194.322055 419.644354,194.322055 421.067879,195.142931 C422.483456,195.964529 422.483456,197.296284 421.067879,198.116437 C419.644354,198.93659 417.339255,198.93659 415.915729,198.116437 C414.491481,197.296284 414.491481,195.964529 415.915729,195.142931 Z M205.905991,191.738754 C207.328794,190.919324 209.633893,190.919324 211.058141,191.738754 C212.481666,192.560352 212.481666,193.892107 211.058141,194.71226 C209.633893,195.533858 207.328794,195.533858 205.905991,194.71226 C204.482465,193.892107 204.482465,192.560352 205.905991,191.738754 Z M324.289108,134.236999 C325.713356,133.417569 328.018456,133.417569 329.441981,134.236999 C330.858281,135.057875 330.858281,136.390352 329.441981,137.211228 C328.018456,138.031381 325.713356,138.031381 324.289108,137.211228 C322.866305,136.390352 322.866305,135.057875 324.289108,134.236999 Z M309.144099,195.943573 C310.560398,195.124866 312.872724,195.124866 314.289023,195.943573 C315.712548,196.763726 315.712548,198.096927 314.289023,198.917802 C312.872724,199.738678 310.560398,199.738678 309.144099,198.917802 C307.720573,198.096927 307.720573,196.763726 309.144099,195.943573 Z M244.825319,225.290597 C246.241619,224.470444 248.553222,224.470444 249.970244,225.290597 C251.393769,226.110027 251.393769,227.443228 249.970244,228.262658 C248.553222,229.085701 246.241619,229.085701 244.825319,228.262658 C243.401071,227.443228 243.401071,226.110027 244.825319,225.290597 Z M306.888859,235.750257 C308.305881,234.930104 310.618206,234.930104 312.034506,235.750257 C313.458031,236.57041 313.458031,237.90361 312.034506,238.723041 C310.618206,239.544639 308.305881,239.544639 306.888859,238.723041 C305.466056,237.90361 305.466056,236.57041 306.888859,235.750257 Z M341.812923,243.823163 C343.236448,243.002288 345.541547,243.002288 346.965073,243.823163 C348.381372,244.644762 348.381372,245.975794 346.965073,246.79667 C345.541547,247.617545 343.236448,247.617545 341.812923,246.79667 C340.389397,245.975794 340.389397,244.644762 341.812923,243.823163 Z M109.575955,245.016179 C110.998758,244.193858 113.30458,244.193858 114.728105,245.016179 C116.144405,245.835609 116.144405,247.168809 114.728105,247.989685 C113.30458,248.809115 110.998758,248.809115 109.575955,247.989685 C108.151707,247.168809 108.151707,245.835609 109.575955,245.016179 Z M97.0532673,250.381497 C98.4767927,249.562066 100.781892,249.562066 102.205418,250.381497 C103.628943,251.20165 103.628943,252.535572 102.205418,253.355003 C100.781892,254.176601 98.4767927,254.176601 97.0532673,253.355003 C95.6290193,252.535572 95.6290193,251.20165 97.0532673,250.381497 Z M193.050906,258.504263 C194.473709,257.685555 196.778808,257.685555 198.203056,258.504263 C199.619356,259.326583 199.619356,260.659061 198.203056,261.479937 C196.778808,262.299367 194.473709,262.299367 193.050906,261.479937 C191.627381,260.659061 191.627381,259.326583 193.050906,258.504263 Z M202.264078,301.316247 C203.686881,300.499707 205.99198,300.499707 207.416228,301.316247 C208.839754,302.13929 208.839754,303.468877 207.416228,304.293366 C205.99198,305.109906 203.686881,305.109906 202.264078,304.293366 C200.840553,303.468877 200.840553,302.13929 202.264078,301.316247 Z M181.156159,305.666309 C182.580407,304.841821 184.892733,304.841821 186.309032,305.666309 C187.732557,306.482127 187.732557,307.819662 186.309032,308.63548 C184.892733,309.459968 182.580407,309.459968 181.156159,308.63548 C179.73986,307.819662 179.73986,306.482127 181.156159,305.666309 Z M238.972246,305.745073 C240.387822,304.929256 242.70087,304.929256 244.11717,305.745073 C245.540695,306.568839 245.540695,307.898426 244.11717,308.722915 C242.70087,309.538732 240.387822,309.538732 238.972246,308.722915 C237.54872,307.898426 237.54872,306.568839 238.972246,305.745073 L238.972246,305.745073 Z"
          id="Fill-2861"
          fill="#51A146"
        />
        <path
          d="M302.720169,261.073834 C302.720169,256.105948 306.745061,252.078888 311.715838,252.078888 C311.715838,257.047498 307.691669,261.074557 302.720169,261.074557 L302.720169,261.073834"
          id="Fill-2862"
          fill="#51A146"
        />
        <path
          d="M302.720169,261.073834 C302.720169,256.105948 298.695278,252.078888 293.723778,252.078888 C293.723778,257.047498 297.755896,261.074557 302.720169,261.074557 L302.720169,261.073834"
          id="Fill-2863"
          fill="#51A146"
        />
        <path
          d="M129.245174,271.272635 C129.245174,266.305471 133.270066,262.278411 138.241565,262.278411 C138.241565,267.245576 134.209448,271.272635 129.245174,271.272635 L129.245174,271.27119 L129.245174,271.272635"
          id="Fill-2864"
          fill="#9ECB94"
        />
        <path
          d="M129.245174,271.272635 C129.245174,266.305471 125.220282,262.278411 120.248783,262.278411 C120.248783,267.245576 124.273674,271.272635 129.245174,271.272635 L129.245174,271.27119 L129.245174,271.272635"
          id="Fill-2865"
          fill="#9ECB94"
        />
        <path
          d="M217.474844,220.821305 C217.474844,215.854141 221.506962,211.827082 226.471236,211.827082 C226.471236,216.792801 222.445622,220.821305 217.481348,220.821305 L217.474844,220.821305 L217.474844,220.819138 L217.474844,220.821305"
          id="Fill-2866"
          fill="#9ECB94"
        />
        <path
          d="M217.474844,220.821305 C217.474844,215.854141 213.449953,211.827082 208.485679,211.827082 C208.485679,216.792801 212.509848,220.821305 217.474844,220.821305 L217.474844,220.819138 L217.474844,220.821305"
          id="Fill-2867"
          fill="#9ECB94"
        />
        <path
          d="M229.368869,280.267581 C229.368869,275.300417 233.393038,271.272635 238.357311,271.272635 C238.357311,276.241245 234.333142,280.269027 229.368869,280.269027 L229.368869,280.267581"
          id="Fill-2868"
          fill="#51A146"
        />
        <path
          d="M229.368869,280.267581 C229.368869,275.300417 225.336751,271.272635 220.371755,271.272635 C220.371755,276.241245 224.397369,280.269027 229.361643,280.269027 L229.368869,280.269027 L229.368869,280.267581"
          id="Fill-2869"
          fill="#51A146"
        />
        <path
          d="M291.281384,204.031654 C291.281384,199.062322 295.306276,195.035986 300.277776,195.035986 L300.277776,195.036708 C300.277776,200.003872 296.252884,204.031654 291.281384,204.031654"
          id="Fill-2870"
          fill="#51A146"
        />
        <path
          d="M291.281384,204.031654 C291.281384,199.062322 287.256493,195.035986 282.284993,195.035986 L282.284993,195.036708 C282.284993,200.003872 286.31711,204.031654 291.281384,204.031654"
          id="Fill-2871"
          fill="#51A146"
        />
        <path
          d="M333.112075,158.119709 C333.112075,153.151099 337.137689,149.123317 342.109189,149.123317 L342.109189,149.124763 C342.109189,154.091927 338.076349,158.119709 333.112075,158.119709"
          id="Fill-2872"
          fill="#51A146"
        />
        <path
          d="M333.112075,158.119709 C333.112075,153.151099 329.08068,149.123317 324.116406,149.123317 L324.116406,149.124763 C324.116406,154.091927 328.141298,158.119709 333.112075,158.119709"
          id="Fill-2873"
          fill="#51A146"
        />
        <path
          d="M361.308717,189.987167 C361.308717,185.018558 365.333609,180.990776 370.305109,180.990776 L370.305109,180.992221 C370.305109,185.959385 366.272268,189.987167 361.308717,189.987167"
          id="Fill-2874"
          fill="#51A146"
        />
        <path
          d="M361.308717,189.987167 C361.308717,185.018558 357.276599,180.990776 352.312326,180.990776 L352.312326,180.992221 C352.312326,185.959385 356.337217,189.987167 361.308717,189.987167"
          id="Fill-2875"
          fill="#51A146"
        />
        <polyline
          id="Fill-2876"
          fill="#2A90C3"
          points="140.814028 153.602003 68.0191301 259.773151 212.777933 347.807719 282.985916 236.958447 140.814028 153.602003"
        />
        <polyline
          id="Fill-2877"
          fill="#1A6C95"
          points="140.814028 153.602003 212.792385 177.565644 354.646329 259.310686 282.985916 236.958447 140.814028 153.602003"
        />
        <polyline
          id="Fill-2878"
          fill="#F8F7F6"
          points="210.62458 510.24136 353.944683 430.141682 353.944683 259.119197 282.284993 236.766958 212.091461 347.1581 210.62458 510.24136"
        />
        <polyline
          id="Fill-2879"
          fill="#2A90C3"
          points="242.686418 364.890746 278.75147 343.811732 278.75147 471.076347 242.686418 491.382178 242.686418 364.890746"
        />
        <polyline
          id="Fill-2880"
          fill="#2A90C3"
          points="302.93695 332.778326 335.79365 313.571572 335.79365 383.389351 302.93695 403.896787 302.93695 332.778326"
        />
      </g>
    </g>
  </svg>
)

export const step1Image1 = (
  <svg
    width="70px"
    height="70px"
    viewBox="0 0 128 128"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    aria-hidden="true"
  >
    <g
      id="1.woning/woning_1.1"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Group" transform="translate(19.200000, 0.000000)">
        <polyline
          id="Fill-547"
          fill="#679CC7"
          points="45.4471238 127.433913 90.9063363 101.773435 91.3714328 35.2792603 68.1802294 26.4354269 45.9115841 61.448736 45.4471238 127.433913"
        />
        <polyline
          id="Fill-548"
          fill="#2A90C3"
          points="45.4598487 127.433913 7.65890275e-13 102.034933 7.65890275e-13 33.5232186 45.9115841 61.448736 45.4598487 127.433913"
        />
        <polyline
          id="Fill-549"
          fill="#2A90C3"
          points="23.0830415 -3.19120948e-14 7.65890275e-13 33.6695554 45.9115841 61.5950728 68.1802294 26.4354269 23.0830415 -3.19120948e-14"
        />
        <polyline
          id="Fill-550"
          fill="#1A6C95"
          points="23.0830415 3.19120948e-14 45.1099129 7.13805518 91.3714328 35.2792603 68.1802294 26.4354269 23.0830415 3.19120948e-14"
        />
        <polyline
          id="Fill-551"
          fill="#E4E4E3"
          points="52.9802884 82.8711728 64.5536214 76.1905792 64.5536214 116.521641 52.9802884 122.960461 52.9802884 82.8711728"
        />
        <polyline
          id="Fill-552"
          fill="#E4E4E3"
          points="72.3158349 72.6912207 82.8584479 66.6017006 82.8584479 88.7303715 72.3158349 95.2328159 72.3158349 72.6912207"
        />
        <polyline
          id="Fill-553"
          fill="#FFFFFE"
          points="38.8874171 82.4830621 28.344168 76.393542 28.344168 98.5228492 38.8874171 105.024657 38.8874171 82.4830621"
        />
        <polyline
          id="Fill-554"
          fill="#FFFFFE"
          points="18.5847751 72.6912207 8.04216218 66.6017006 8.04216218 88.7303715 18.5847751 95.2328159 18.5847751 72.6912207"
        />
      </g>
    </g>
  </svg>
)

export const step1Image2 = (
  <svg
    width="70px"
    height="70px"
    viewBox="0 0 128 128"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    aria-hidden="true"
  >
    <g
      id="1.woning/woning_1.2"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Group" transform="translate(6.400000, 0.000000)">
        <polyline
          id="Fill-523"
          fill="#F8F7F6"
          points="76.1433909 106.1997 114.021296 84.8117262 114.408346 29.3993836 95.0818133 22.0295224 76.3390368 48.6617618 76.1433909 106.1997"
        />
        <polyline
          id="Fill-524"
          fill="#E4E4E3"
          points="76.1486929 106.1997 38.2707877 85.0285804 38.2707877 27.9413176 76.5304412 51.20728 76.1486929 106.1997"
        />
        <polyline
          id="Fill-525"
          fill="#B4B5B4"
          points="57.5061254 0 38.5570989 26.89151 76.3390368 48.6617618 95.0818133 22.0295224 57.5061254 0"
        />
        <polyline
          id="Fill-526"
          fill="#9E9F9E"
          points="57.5061254 0 75.8570797 5.95421158 114.408346 29.3993836 95.0818133 22.0295224 57.5061254 0"
        />
        <polyline
          id="Fill-527"
          fill="#E4E4E3"
          points="82.415726 69.0593107 92.0601702 63.4921493 92.0601702 97.1066694 82.415726 102.472883 82.415726 69.0593107"
        />
        <polyline
          id="Fill-528"
          fill="#E4E4E3"
          points="98.5286815 60.575487 107.314192 55.5072494 107.314192 73.9425064 98.5286815 79.3606799 98.5286815 60.575487"
        />
        <polyline
          id="Fill-529"
          fill="#FFFFFE"
          points="70.6711364 68.740657 61.8861559 63.6665871 61.8861559 82.1071462 70.6711364 87.5205478 70.6711364 68.740657"
        />
        <polyline
          id="Fill-530"
          fill="#FFFFFE"
          points="53.7527983 60.575487 44.9672875 55.5072494 44.9672875 73.9425064 53.7527983 79.3606799 53.7527983 60.575487"
        />
        <polyline
          id="Fill-531"
          fill="#679CC7"
          points="38.1700486 127.519276 76.3390368 106.189095 76.3390368 48.6617618 57.2516266 42.7075502 38.5570989 72.107464 38.1700486 127.519276"
        />
        <polyline
          id="Fill-532"
          fill="#2A90C3"
          points="38.1748205 127.519276 0.00583226424 106.189095 0.00583226424 48.6617618 38.5570989 72.107464 38.1748205 127.519276"
        />
        <polyline
          id="Fill-533"
          fill="#2A90C3"
          points="19.3901578 20.5083619 0 48.7837091 38.5570989 72.2299416 57.2516266 42.7075502 19.3901578 20.5083619"
        />
        <polyline
          id="Fill-534"
          fill="#1A6C95"
          points="19.3901578 20.5083619 38.5570989 26.89151 76.3390368 48.6617618 57.2516266 42.7075502 19.3901578 20.5083619"
        />
        <polyline
          id="Fill-535"
          fill="#FFFFFE"
          points="44.4948741 90.0973482 54.2087753 84.4883006 54.2087753 118.35785 44.4948741 123.760117 44.4948741 90.0973482"
        />
        <polyline
          id="Fill-536"
          fill="#FFFFFE"
          points="60.7250051 81.5509603 69.5789124 76.4392457 69.5789124 95.0181886 60.7250051 100.474007 60.7250051 81.5509603"
        />
        <polyline
          id="Fill-537"
          fill="#FFFFFE"
          points="32.6559079 89.7739226 23.8014704 84.6632685 23.8014704 103.241151 32.6559079 108.696969 32.6559079 89.7739226"
        />
        <polyline
          id="Fill-538"
          fill="#FFFFFE"
          points="15.6092599 81.5509603 6.75535261 76.4392457 6.75535261 95.0181886 15.6092599 100.474007 15.6092599 81.5509603"
        />
      </g>
    </g>
  </svg>
)

export const step1Image3 = (
  <svg
    width="70px"
    height="70px"
    viewBox="0 0 128 128"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    aria-hidden="true"
  >
    <g
      id="1.woning/woning_1.3"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Group" transform="translate(0.000000, 1.600000)">
        <polyline
          id="Fill-507"
          fill="#F8F7F6"
          points="94.9825891 88.6902693 126.621312 70.8317713 126.944562 24.554217 110.804164 18.3991681 95.1464285 40.636607 94.9825891 88.6902693"
        />
        <polyline
          id="Fill-508"
          fill="#E4E4E3"
          points="94.9914452 88.6902693 63.3527227 71.0133231 63.3527227 23.3316206 95.3058398 42.7665196 94.9914452 88.6902693"
        />
        <polyline
          id="Fill-509"
          fill="#B4B5B4"
          points="79.4178431 -2.77623535e-15 63.5962678 22.4548582 95.1464285 40.636607 110.804164 18.3991681 79.4178431 -2.77623535e-15"
        />
        <polyline
          id="Fill-510"
          fill="#9E9F9E"
          points="79.4178431 1.38811768e-15 94.7479001 4.96876285 126.944562 24.554217 110.804164 18.3991681 79.4178431 1.38811768e-15"
        />
        <polyline
          id="Fill-511"
          fill="#E4E4E3"
          points="100.225451 57.6759078 108.280152 53.0264104 108.280152 81.0965331 100.225451 85.5777629 100.225451 57.6759078"
        />
        <polyline
          id="Fill-512"
          fill="#E4E4E3"
          points="113.682425 50.5909594 121.019774 46.3537175 121.019774 61.7541812 113.682425 66.2801348 113.682425 50.5909594"
        />
        <polyline
          id="Fill-513"
          fill="#FFFFFE"
          points="90.4172254 57.406237 83.0754477 53.1685522 83.0754477 68.5690159 90.4172254 73.0949695 90.4172254 57.406237"
        />
        <polyline
          id="Fill-514"
          fill="#FFFFFE"
          points="76.2871815 50.5909594 68.9498319 46.3537175 68.9498319 61.7541812 76.2871815 66.2801348 76.2871815 50.5909594"
        />
        <polyline
          id="Fill-515"
          fill="#679CC7"
          points="63.2685889 106.500501 95.1464285 88.6814131 95.1464285 40.636607 79.2097228 35.6638588 63.5962678 60.2180758 63.2685889 106.500501"
        />
        <polyline
          id="Fill-516"
          fill="#E4E4E3"
          points="63.2774451 106.500501 31.3951775 88.6814131 31.3951775 40.636607 63.5962678 60.2180758 63.2774451 106.500501"
        />
        <polyline
          id="Fill-517"
          fill="#2A90C3"
          points="47.5842845 17.1238774 31.3951775 40.7384531 63.5918397 60.3239073 79.2097228 35.6638588 47.5842845 17.1238774"
        />
        <polyline
          id="Fill-518"
          fill="#1A6C95"
          points="47.5842845 17.1238774 63.5962678 22.4548582 95.1464285 40.636607 79.2097228 35.6638588 47.5842845 17.1238774"
        />
        <polyline
          id="Fill-519"
          fill="#FFFFFE"
          points="68.5513035 75.2425945 76.6679975 70.5576724 76.6679975 98.8443287 68.5513035 103.360983 68.5513035 75.2425945"
        />
        <polyline
          id="Fill-520"
          fill="#FFFFFE"
          points="82.1101235 68.104509 89.5050383 63.8358276 89.5050383 79.3558498 82.1101235 83.9123572 82.1101235 68.104509"
        />
        <polyline
          id="Fill-521"
          fill="#FFFFFE"
          points="58.6678006 74.972038 51.2728857 70.7033566 51.2728857 86.2242644 58.6678006 90.7807719 58.6678006 74.972038"
        />
        <polyline
          id="Fill-522"
          fill="#FFFFFE"
          points="44.4270544 68.104509 37.0361248 63.8358276 37.0361248 79.3558498 44.4270544 83.9123572 44.4270544 68.104509"
        />
        <polyline
          id="Fill-539"
          fill="#F8F7F6"
          points="31.6342945 124.358999 63.2685889 106.500501 63.5962678 60.2180758 47.4509989 54.0670122 31.9575452 78.4352493 31.6342945 124.358999"
        />
        <polyline
          id="Fill-540"
          fill="#E4E4E3"
          points="31.6387226 124.358999 0.00398528346 106.677625 0.00398528346 59.0003503 31.9575452 78.4352493 31.6387226 124.358999"
        />
        <polyline
          id="Fill-541"
          fill="#B4B5B4"
          points="16.0695485 35.6638588 -3.55358125e-13 59.1021965 31.9531171 78.5366527 47.4509989 54.0670122 16.0695485 35.6638588"
        />
        <polyline
          id="Fill-542"
          fill="#9E9F9E"
          points="16.0695485 35.6638588 31.3951775 40.636607 63.5962678 60.2180758 47.4509989 54.0670122 16.0695485 35.6638588"
        />
        <polyline
          id="Fill-543"
          fill="#E4E4E3"
          points="36.8771563 93.3446376 44.9318569 88.6902693 44.9318569 116.764377 36.8771563 121.245607 36.8771563 93.3446376"
        />
        <polyline
          id="Fill-544"
          fill="#E4E4E3"
          points="50.329702 86.2596892 57.6714797 82.0215616 57.6714797 97.422911 50.329702 101.943994 50.329702 86.2596892"
        />
        <polyline
          id="Fill-545"
          fill="#FFFFFE"
          points="27.0645028 93.0740811 19.7271531 88.8363963 19.7271531 104.237303 27.0645028 108.762814 27.0645028 93.0740811"
        />
        <polyline
          id="Fill-546"
          fill="#FFFFFE"
          points="12.938887 86.2596892 5.59710921 82.0215616 5.59710921 97.422911 12.938887 101.943994 12.938887 86.2596892"
        />
      </g>
    </g>
  </svg>
)

export const step1Image4 = (
  <svg
    width="70px"
    height="70px"
    viewBox="0 0 128 128"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    aria-hidden="true"
  >
    <g
      id="1.woning/woning_1.4"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Group" transform="translate(27.200000, 0.000000)">
        <polyline
          id="Fill-555"
          fill="#E4E4E3"
          points="0 109.394085 32.7117976 127.601137 32.7117976 98.8713945 0 80.664155 0 109.394085"
        />
        <polyline
          id="Fill-556"
          fill="#2A90C3"
          points="40.4280126 57.3230777 1.45669521e-13 80.664155 32.7117976 98.8713945 72.618538 75.5282561 40.4280126 57.3230777"
        />
        <polyline
          id="Fill-557"
          fill="#F8F7F6"
          points="57.533123 84.3537204 73.1394354 75.7195641 73.1394354 85.6838826 63.322767 91.6891931 63.322767 102.637596 73.1394354 97.0763595 73.1394354 104.258186 32.7117976 127.601137 32.7117976 98.8713945"
        />
        <polyline
          id="Fill-558"
          fill="#E4E4E3"
          points="48.7865429 100.666242 41.0124295 105.155891 41.0124295 122.823121 48.7865429 118.33366 48.7865429 100.666242"
        />
        <polyline
          id="Fill-559"
          fill="#E4E4E3"
          points="59.4630668 95.6090401 51.6870797 100.098502 51.6870797 109.077424 59.4630668 104.587963 59.4630668 95.6090401"
        />
        <polyline
          id="Fill-560"
          fill="#2A90C3"
          points="0 80.8552757 32.7117976 99.0625152 32.7117976 70.3325851 0 52.125533 0 80.8552757"
        />
        <polyline
          id="Fill-561"
          fill="#2A90C3"
          points="40.4280126 28.7825819 -3.00737075e-13 52.125533 32.7117976 70.3325851 73.1394354 47.1824411 40.4280126 28.7825819"
        />
        <polyline
          id="Fill-562"
          fill="#679CC7"
          points="57.533123 55.8128498 73.1394354 47.1824411 73.1394354 75.7195641 32.7117976 99.0625152 32.7117976 70.3325851"
        />
        <polyline
          id="Fill-563"
          fill="#E4E4E3"
          points="0 52.3204011 32.7117976 70.5253921 32.7117976 41.7956494 0 23.590471 0 52.3204011"
        />
        <polyline
          id="Fill-564"
          fill="#F8F7F6"
          points="57.533123 27.2777879 73.1394354 18.1770724 73.1394354 47.1824411 32.7117976 70.5253921 32.7117976 41.7956494"
        />
        <polyline
          id="Fill-565"
          fill="#E4E4E3"
          points="59.4630668 38.5351687 51.6870797 43.0229438 51.6870797 52.0018667 59.4630668 47.5124052 59.4630668 38.5351687"
        />
        <polyline
          id="Fill-566"
          fill="#E4E4E3"
          points="48.7865429 44.688504 41.0124295 49.1760917 41.0124295 58.1550146 48.7865429 53.6655532 48.7865429 44.688504"
        />
        <polyline
          id="Fill-567"
          fill="#F8F7F6"
          points="19.0820849 44.5891962 26.8563856 49.0786577 26.8563856 58.0558942 19.0820849 53.5664328 19.0820849 44.5891962"
        />
        <polyline
          id="Fill-568"
          fill="#F8F7F6"
          points="5.85559932 37.8551914 13.6297127 42.3444655 13.6297127 51.3233884 5.85559932 46.8339269 5.85559932 37.8551914"
        />
        <polyline
          id="Fill-569"
          fill="#F8F7F6"
          points="19.0820849 70.347575 26.8563856 74.8370364 26.8563856 83.8140856 19.0820849 79.3264979 19.0820849 70.347575"
        />
        <polyline
          id="Fill-570"
          fill="#F8F7F6"
          points="5.85559932 63.6150692 13.6297127 68.1026569 13.6297127 77.0817672 5.85559932 72.5923057 5.85559932 63.6150692"
        />
        <polyline
          id="Fill-571"
          fill="#F8F7F6"
          points="19.0820849 99.2478273 26.8563856 103.735415 26.8563856 112.714525 19.0820849 108.224876 19.0820849 99.2478273"
        />
        <polyline
          id="Fill-572"
          fill="#F8F7F6"
          points="5.85559932 92.5136351 13.6297127 97.0030965 13.6297127 105.980333 5.85559932 101.490872 5.85559932 92.5136351"
        />
        <polyline
          id="Fill-573"
          fill="#E4E4E3"
          points="48.7865429 71.3631376 41.0124295 75.8525991 41.0124295 84.8296482 48.7865429 80.3420605 48.7865429 71.3631376"
        />
        <polyline
          id="Fill-574"
          fill="#F8F7F6"
          points="73.1394354 103.07024 60.6433305 106.903895 60.6433305 88.492794 73.1394354 84.6572649 73.1394354 103.07024"
        />
        <polyline
          id="Fill-575"
          fill="#E4E4E3"
          points="70.5087159 32.7567671 62.7344152 37.2462286 62.7344152 46.2232777 70.5087159 41.7355027 70.5087159 32.7567671"
        />
        <polyline
          id="Fill-576"
          fill="#E4E4E3"
          points="70.5087159 59.3335919 62.7344152 63.8230534 62.7344152 72.8019763 70.5087159 68.3125148 70.5087159 59.3335919"
        />
        <polyline
          id="Fill-577"
          fill="#E4E4E3"
          points="70.5087159 89.0472312 62.7344152 93.5350063 62.7344152 102.513929 70.5087159 98.0244678 70.5087159 89.0472312"
        />
        <polyline
          id="Fill-578"
          fill="#B4B5B4"
          points="40.9468489 0 -3.00737075e-13 23.6633592 32.7117976 42.0617194 73.1394354 18.2051784 40.9468489 0"
        />
        <polyline
          id="Fill-579"
          fill="#E4E4E3"
          points="59.8619843 65.0953173 52.087871 69.5847788 52.087871 78.5637017 59.8619843 74.0742402 59.8619843 65.0953173"
        />
      </g>
    </g>
  </svg>
)

export const step3Image1 = (
  <svg
    width="70px"
    height="70px"
    viewBox="0 0 128 128"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    aria-hidden="true"
  >
    <g
      id="1.woning/woning_2.1"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Group" transform="translate(17.600000, 1.600000)">
        <polyline
          id="Fill-499"
          fill="#F8F7F6"
          points="44.856607 125.765583 89.7132141 100.437612 90.1762542 34.8154363 67.2832915 26.092149 45.3131711 60.6423895 44.856607 125.765583"
        />
        <polyline
          id="Fill-500"
          fill="#E4E4E3"
          points="44.8627593 125.765583 0.00647608562 100.693417 0.00647608562 33.0863214 45.3131711 60.6423895 44.8627593 125.765583"
        />
        <polyline
          id="Fill-501"
          fill="#2A90C3"
          points="22.7857834 6.09036631e-14 -5.19711258e-13 33.2323571 45.3096092 60.7877776 67.2832915 26.092149 22.7857834 6.09036631e-14"
        />
        <polyline
          id="Fill-502"
          fill="#1A6C95"
          points="22.7857834 7.9174762e-14 44.5198506 7.04921919 90.1762542 34.8154363 67.2832915 26.092149 22.7857834 7.9174762e-14"
        />
        <polyline
          id="Fill-503"
          fill="#E4E4E3"
          points="52.2879153 81.783571 63.7084923 75.1905921 63.7084923 114.995852 52.2879153 121.349216 52.2879153 81.783571"
        />
        <polyline
          id="Fill-504"
          fill="#E4E4E3"
          points="71.3664635 71.7391622 81.7735331 65.7325928 81.7735331 87.5663917 71.3664635 93.9809545 71.3664635 71.7391622"
        />
        <polyline
          id="Fill-505"
          fill="#FFFFFE"
          points="38.3772834 81.40472 27.9734518 75.3949126 27.9734518 97.2322733 38.3772834 103.646836 38.3772834 81.40472"
        />
        <polyline
          id="Fill-506"
          fill="#FFFFFE"
          points="18.3435125 71.7391622 7.93935716 65.7325928 7.93935716 87.5663917 18.3435125 93.9809545 18.3435125 71.7391622"
        />
      </g>
    </g>
  </svg>
)

export const step3Image2 = (
  <svg
    width="70px"
    height="70px"
    viewBox="0 0 128 128"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    aria-hidden="true"
  >
    <g
      id="1.woning/woning_2.2"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Group" transform="translate(32.000000, 19.200000)">
        <polyline
          id="Fill-499"
          fill="#F8F7F6"
          points="31.3996249 88.0359079 62.7992498 70.3063283 63.1233779 24.3708054 47.0983041 18.2645043 31.7192197 42.4496727 31.3996249 88.0359079"
        />
        <polyline
          id="Fill-500"
          fill="#E4E4E3"
          points="31.4039315 88.0359079 0.00453325993 70.4853921 0.00453325993 23.160425 31.7192197 42.4496727 31.4039315 88.0359079"
        />
        <polyline
          id="Fill-501"
          fill="#2A90C3"
          points="15.9500484 4.26325641e-14 -3.63797881e-13 23.26265 31.7167265 42.5514444 47.0983041 18.2645043 15.9500484 4.26325641e-14"
        />
        <polyline
          id="Fill-502"
          fill="#1A6C95"
          points="15.9500484 5.54223334e-14 31.1638954 4.93445344 63.1233779 24.3708054 47.0983041 18.2645043 15.9500484 5.54223334e-14"
        />
        <polyline
          id="Fill-503"
          fill="#E4E4E3"
          points="36.6015407 57.2484997 44.5959446 52.6334144 44.5959446 80.4970966 36.6015407 84.9444513 36.6015407 57.2484997"
        />
        <polyline
          id="Fill-504"
          fill="#E4E4E3"
          points="49.9565245 50.2174136 57.2414732 46.012815 57.2414732 61.2964742 49.9565245 65.7866681 49.9565245 50.2174136"
        />
        <polyline
          id="Fill-505"
          fill="#FFFFFE"
          points="26.8640984 56.983304 19.5814163 52.7764388 19.5814163 68.0625913 26.8640984 72.5527852 26.8640984 56.983304"
        />
        <polyline
          id="Fill-506"
          fill="#FFFFFE"
          points="12.8404588 50.2174136 5.55755001 46.012815 5.55755001 61.2964742 12.8404588 65.7866681 12.8404588 50.2174136"
        />
      </g>
    </g>
  </svg>
)

export const step3Image3 = (
  <svg
    width="70px"
    height="70px"
    viewBox="0 0 128 128"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    aria-hidden="true"
  >
    <g
      id="1.woning/woning_2.3"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Group" transform="translate(41.600000, 32.000000)">
        <polyline
          id="Fill-499"
          fill="#F8F7F6"
          points="21.9797374 61.6251355 43.9594749 49.2144298 44.1863645 17.0595638 32.9688128 12.785153 22.2034538 29.7147709 21.9797374 61.6251355"
        />
        <polyline
          id="Fill-500"
          fill="#E4E4E3"
          points="21.9827521 61.6251355 0.00317328195 49.3397744 0.00317328195 16.2122975 22.2034538 29.7147709 21.9827521 61.6251355"
        />
        <polyline
          id="Fill-501"
          fill="#2A90C3"
          points="11.1650339 2.98427949e-14 -2.54658516e-13 16.283855 22.2017085 29.786011 32.9688128 12.785153 11.1650339 2.98427949e-14"
        />
        <polyline
          id="Fill-502"
          fill="#1A6C95"
          points="11.1650339 3.87956334e-14 21.8147268 3.45411741 44.1863645 17.0595638 32.9688128 12.785153 11.1650339 3.87956334e-14"
        />
        <polyline
          id="Fill-503"
          fill="#E4E4E3"
          points="25.6210785 40.0739498 31.2171612 36.8433901 31.2171612 56.3479676 25.6210785 59.4611159 25.6210785 40.0739498"
        />
        <polyline
          id="Fill-504"
          fill="#E4E4E3"
          points="34.9695671 35.1521895 40.0690312 32.2089705 40.0690312 42.9075319 34.9695671 46.0506677 34.9695671 35.1521895"
        />
        <polyline
          id="Fill-505"
          fill="#FFFFFE"
          points="18.8048689 39.8883128 13.7069914 36.9435072 13.7069914 47.6438139 18.8048689 50.7869497 18.8048689 39.8883128"
        />
        <polyline
          id="Fill-506"
          fill="#FFFFFE"
          points="8.98832113 35.1521895 3.89028501 32.2089705 3.89028501 42.9075319 8.98832113 46.0506677 8.98832113 35.1521895"
        />
      </g>
    </g>
  </svg>
)

export const step6Image1 = (
  <svg
    width="70px"
    height="70px"
    viewBox="0 0 128 128"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    aria-hidden="true"
  >
    <g
      id="2.verwarming/verwarming_1.1"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="Group"
        transform="translate(64.961803, 64.117557) rotate(36.000000) translate(-64.961803, -64.117557) translate(15.961803, 16.117557)"
      >
        <path
          d="M63.1272312,95.1782856 C63.1272312,95.1782856 7.89807212,86.7171826 16.0985127,48.6651574 L31.3993983,55.2182113 C28.7354281,47.7533601 24.7160131,38.536336 18.5539529,28.7041486 C12.292841,18.7202556 5.63552208,14.9359582 -6.07940365e-13,9.24309034 C-6.07940365e-13,9.24309034 27.2913581,-9.14977318 44.6983963,9.4307673 C62.0996998,28.0154784 49.656196,1.96109795e-14 49.656196,1.96109795e-14 C49.656196,1.96109795e-14 98.9213983,39.0414999 89.6105357,61.369845 C89.6105357,61.369845 84.4129265,84.3034483 63.1272312,95.1782856"
          id="Fill-2517"
          fill="#143A4F"
        />
        <polyline
          id="Fill-2518"
          fill="#143A4F"
          points="57.5542681 1.80847605 49.656196 5.06616971e-14 56.8973987 17.3283181 65.5148992 21.4155052 57.5542681 1.80847605"
        />
        <path
          d="M7.89807212,7.1103502 C5.26538141,6.50613465 2.63269071,9.84730589 0,9.24309034 C4.47818082,14.7743474 9.26915658,17.5634356 13.7838301,25.5600381 C20.8686354,38.1083283 25.0809406,49.8751524 27.666712,59.3476257 C31.5453692,58.5760649 35.4188132,57.804504 39.2974704,57.0329432 L7.89807212,7.1103502"
          id="Fill-2519"
          fill="#143A4F"
        />
        <polyline
          id="Fill-2520"
          fill="#143A4F"
          points="23.9965848 50.479368 16.0985127 48.6651574 63.1272312 95.1782856 74.7058571 95.2038305 23.9965848 50.479368"
        />
        <path
          d="M74.5755258,95.1782856 C74.5755258,95.1782856 20.6757452,89.2711532 23.9965848,50.479368 L39.2974704,57.0329432 C39.2974704,57.0329432 18.7155636,2.60610314 7.89807212,7.1103502 C7.89807212,7.1103502 35.1894302,-7.34025448 52.5912551,11.2449779 C69.9982933,29.8244758 57.5542681,1.80847605 57.5542681,1.80847605 C57.5542681,1.80847605 99.7763711,30.1320574 97.5033946,63.1793637 C97.5033946,63.1793637 95.8664344,84.3034483 74.5755258,95.1782856"
          id="Fill-2521"
          fill="#2A90C3"
        />
        <path
          d="M74.7058571,95.2038305 C74.7058571,95.2038305 53.5765592,84.1308898 55.8495357,78.5422869 L61.55283,80.9873007 C61.55283,80.9873007 53.8789276,60.6973359 49.8490862,62.3765234 C49.8490862,62.3765234 60.0201348,56.9912372 66.5106297,63.919645 C72.9953901,70.8423183 68.3555985,60.400702 68.3555985,60.400702 C68.3555985,60.400702 86.7223958,74.9555717 83.2498507,83.2811302 C83.2498507,83.2811302 82.6404219,91.1531361 74.7058571,95.2038305"
          id="Fill-2522"
          fill="#679CC7"
        />
      </g>
    </g>
  </svg>
)
export const step6Image2 = (
  <svg
    width="70px"
    height="70px"
    viewBox="0 0 128 128"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    aria-hidden="true"
  >
    <g
      id="2.verwarming/verwarming_1.2"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Group" transform="translate(29.001401, 0.000000)">
        <polyline
          id="Fill-2513"
          fill="#DE482A"
          points="42.4426461 3.76260574 35.778754 1.5158245e-13 1.5158245e-13 81.2851283 8.70763679 86.2339371 42.4426461 3.76260574"
        />
        <polyline
          id="Fill-2514"
          fill="#DE482A"
          points="34.8267694 61.4898933 28.1628773 57.7272875 4.26881977 121.94847 12.9802343 126.897656 34.8267694 61.4898933"
        />
        <polyline
          id="Fill-2515"
          fill="#DE482A"
          points="67.4775741 22.2209069 61.1007885 18.3445919 29.9724036 40.470678 31.1434957 55.1244408 67.4775741 22.2209069"
        />
        <polyline
          id="Fill-2516"
          fill="#E67848"
          points="12.7006832 127.467714 67.4775741 22.2209069 32.6016943 50.5160043 42.4426461 3.76260574 8.70763679 86.2339371 34.8267694 61.4898933 12.7006832 127.467714"
        />
      </g>
    </g>
  </svg>
)

export const step6Image3 = (
  <svg
    width="70px"
    height="70px"
    viewBox="0 0 128 128"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    aria-hidden="true"
  >
    <g
      id="2.verwarming/verwarming_1.3"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Group" transform="translate(0.000000, 11.200000)">
        <path
          d="M8.33949506,38.4130078 L96.011303,88.946402 C96.011303,88.946402 104.544238,92.3604615 111.159808,90.5445007 C117.770951,88.7334107 124.594199,80.0942018 125.236715,78.5979493 C125.878788,77.1052392 128.650332,72.1989125 127.371056,65.3756644 C126.091337,58.5471026 122.783552,55.3504624 122.783552,55.3504624 L97.9330953,40.6310394 L97.9330953,35.8575554 C97.9330953,35.8575554 98.2297775,31.0136648 96.3168414,29.6183728 C96.3168414,29.6183728 92.4156917,26.1733166 87.748482,25.3408352 C83.0808294,24.5127819 76.947921,26.8773834 76.947921,26.8773834 L75.4605247,27.7054367 L28.1640662,1.33171643 C28.1640662,1.33171643 25.0688294,-0.505942055 21.420081,0.13613139 C17.7669045,0.783075738 11.058344,2.70929608 8.33949506,5.99051279 C8.33949506,5.99051279 1.54680081,12.0477008 0.391068607,19.3323562 C-0.765106404,26.6161259 1.01055878,31.9874024 1.01055878,31.9874024 C1.01055878,31.9874024 2.96777577,35.1047797 4.16380361,35.8575554 C5.36381674,36.610774 8.33949506,38.4130078 8.33949506,38.4130078"
          id="Fill-1177"
          fill="#E67848"
        />
        <path
          d="M70.2973685,42.8318015 C70.2973685,47.5260226 76.5011264,51.3293114 84.1528707,51.3293114 C91.8046149,51.3293114 98.0083728,47.5260226 98.0083728,42.8318015 C98.0083728,38.1428941 91.8046149,34.3387196 84.1528707,34.3387196 C76.5011264,34.3387196 70.2973685,38.1428941 70.2973685,42.8318015"
          id="Fill-1178"
          fill="#DE482A"
        />
        <polyline
          id="Fill-1179"
          fill="#DE482A"
          points="70.4080709 43.8768314 70.2973685 33.6036562 98.0083728 33.6036562 98.0083728 42.8318015 70.4080709 43.8768314"
        />
        <path
          d="M70.2973685,33.6036562 C70.2973685,38.2930064 76.5011264,42.0967381 84.1528707,42.0967381 C91.8046149,42.0967381 98.0083728,38.2930064 98.0083728,33.6036562 C98.0083728,28.914306 91.8046149,25.1105744 84.1528707,25.1105744 C76.5011264,25.1105744 70.2973685,28.914306 70.2973685,33.6036562"
          id="Fill-1180"
          fill="#EC934D"
        />
        <polyline
          id="Fill-1181"
          fill="#E4E4E3"
          points="15.2694602 59.8622461 22.5758132 63.9453904 22.5758132 46.6182636 15.3181692 42.433716 15.2694602 59.8622461"
        />
        <polyline
          id="Fill-1182"
          fill="#B4B5B4"
          points="22.5758132 46.6182636 37.1265259 55.0046284 22.5758132 63.9453904 22.5758132 46.6182636"
        />
        <polyline
          id="Fill-1183"
          fill="#E4E4E3"
          points="72.8125252 93.0109483 80.1188782 97.0940926 80.1188782 79.7665229 72.8563633 75.5819753 72.8125252 93.0109483"
        />
        <polyline
          id="Fill-1184"
          fill="#B4B5B4"
          points="80.1188782 79.7665229 94.6695909 88.1537734 80.1188782 97.0940926 80.1188782 79.7665229"
        />
        <polyline
          id="Fill-1185"
          fill="#B4B5B4"
          points="79.0339955 101.309637 79.0339955 104.506277 102.246058 90.6463468 98.4866069 89.7695844 79.0339955 101.309637"
        />
        <path
          d="M94.6695909,88.1537734 L80.1188782,97.0940926 L72.8125252,93.0109483 L72.8563633,75.5819753 L37.1265259,55.0046284 L22.5758132,63.9453904 L15.2694602,59.8445338 L15.2694602,55.2791702 L11.1159092,57.515357 L6.47526802,60.0619531 L79.0339955,101.309637 L98.4866069,89.7695844 C98.4866069,89.7695844 95.1566811,88.6895726 94.6695909,88.1537734"
          id="Fill-1186"
          fill="#9E9F9E"
        />
        <polyline
          id="Fill-1187"
          fill="#E4E4E3"
          points="79.0339955 104.506277 6.47526802 62.9796234 6.47526802 60.0619531 79.0339955 101.309637 79.0339955 104.506277"
        />
      </g>
    </g>
  </svg>
)

export const step6Image4 = (
  <svg
    width="70px"
    height="70px"
    viewBox="0 0 128 128"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    aria-hidden="true"
  >
    <g
      id="2.verwarming/verwarming_1.4"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Group" transform="translate(0.201401, 1.600000)">
        <polyline
          id="Fill-2591"
          fill="#D94B2B"
          points="122.92841 86.6083843 106.613207 104.201966 64.8754829 79.7899081 81.2128984 62.4053096 122.92841 86.6083843"
        />
        <path
          d="M126.754481,94.4010582 C126.754481,86.4859863 122.221221,84.7719607 116.509314,87.6601006 C110.670475,90.6067196 106.613207,96.286441 106.613207,104.201966"
          id="Fill-2592"
          fill="#DF6B39"
        />
        <path
          d="M84.7855605,70.1027849 C84.7855605,62.2779249 80.3066997,60.5829391 74.6627911,63.4384395 C68.8919512,66.353779 64.8754829,71.9655014 64.8754829,79.7899081"
          id="Fill-2593"
          fill="#D94B2B"
        />
        <polyline
          id="Fill-2594"
          fill="#D94B2B"
          points="82.0701378 106.337132 65.754482 123.93026 24.0172111 99.5191086 40.3550799 82.1336034 82.0701378 106.337132"
        />
        <path
          d="M85.8962092,114.129352 C85.8962092,106.21428 81.3624959,104.500708 75.6510417,107.388395 C69.812203,110.335467 65.754482,116.015188 65.754482,123.93026"
          id="Fill-2595"
          fill="#DF6B39"
        />
        <path
          d="M43.9272887,89.8315321 C43.9272887,82.0066722 39.4484279,80.3116863 33.804066,83.1671867 C28.0336794,86.0825262 24.0172111,91.6942486 24.0172111,99.5191086"
          id="Fill-2596"
          fill="#D94B2B"
        />
        <polyline
          id="Fill-2597"
          fill="#D94B2B"
          points="34.566107 76.8346759 50.8813095 94.4282577 92.6190337 70.016653 76.2811649 52.6356811 34.566107 76.8346759"
        />
        <path
          d="M30.7400356,84.6268964 C30.7400356,76.7118246 35.2728422,74.9982523 40.985203,77.8859389 C46.8240418,80.8375444 50.8813095,86.5127325 50.8813095,94.4282577"
          id="Fill-2598"
          fill="#DF6B39"
        />
        <path
          d="M72.7089561,60.3331564 C72.7089561,52.5087498 77.1878169,50.8133106 82.8317255,53.6647311 C88.6025654,56.5796172 92.6190337,62.191793 92.6190337,70.016653"
          id="Fill-2599"
          fill="#D94B2B"
        />
        <polyline
          id="Fill-2600"
          fill="#D94B2B"
          points="57.4817359 92.5333551 73.7964851 110.126484 115.534663 85.7148788 99.1967938 68.329827 57.4817359 92.5333551"
        />
        <path
          d="M53.6556646,100.325576 C53.6556646,92.4105037 58.1889245,90.6973848 63.900832,93.5805381 C69.7396708,96.531237 73.7964851,102.211412 73.7964851,110.126484"
          id="Fill-2601"
          fill="#DF6B39"
        />
        <path
          d="M95.624585,76.0273023 C95.624585,68.203349 100.102992,66.5074565 105.747354,69.3638635 C111.518194,72.2782964 115.534663,77.8904722 115.534663,85.7148788"
          id="Fill-2602"
          fill="#D94B2B"
        />
        <path
          d="M75.0662512,81.6716643 C75.0662512,81.6716643 17.108523,66.4213245 19.533817,51.4574868 L34.8698354,54.2363752 C34.8698354,54.2363752 8.934602,8.7043124 1.87583282e-13,15.0821558 C1.87583282e-13,15.0821558 17.6434477,-3.66695396 37.4220607,9.6513104 C57.2006738,22.9700281 39.9742861,-1.36424205e-13 39.9742861,-1.36424205e-13 C39.9742861,-1.36424205e-13 93.1267588,25.3318565 89.3006874,47.6631483 C89.3006874,47.6631483 92.2246401,67.2917104 75.0662512,81.6716643"
          id="Fill-2603"
          fill="#E67848"
        />
      </g>
    </g>
  </svg>
)

export const stepGasImage1 = (
  <svg
    width="70px"
    height="70px"
    viewBox="0 0 128 128"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    aria-hidden="true"
  >
    <g
      id="2.verwarming/verwarming_2.1"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Group" transform="translate(24.000000, 0.000000)">
        <path
          d="M68.7246739,80.7554924 L58.1168457,74.5952455 L57.8448501,62.4909882 L57.8448501,60.2112117 C57.8448501,60.2112117 58.1621783,60.1654258 58.7061694,60.1654258 C60.7461364,60.1654258 65.8687201,60.8635478 68.7246739,67.5365065 L68.7246739,80.7554924"
          id="Fill-596"
          fill="#504E4B"
        />
        <path
          d="M68.3166805,82.0792043 C68.3166805,82.0792043 72.9406056,82.0792043 74.3459162,94.9219297 L78.5165154,92.5238352 C78.5165154,92.5238352 76.3405506,78.3623845 72.3059492,79.6815632 L68.3166805,82.0792043"
          id="Fill-597"
          fill="#E4E4E3"
        />
        <path
          d="M74.3459162,94.9219297 L71.3539647,93.1906778 C71.3539647,93.1906778 72.3512818,84.8762257 67.6366915,83.2809715 C67.6366915,83.2809715 69.9939867,81.2818039 71.4899625,84.6178299 C72.9406056,87.1473889 73.6205946,86.9529121 74.3459162,94.9219297"
          id="Fill-598"
          fill="#C7C5BD"
        />
        <path
          d="M23.2107442,115.181068 C23.2107442,115.181068 18.586819,115.181068 17.1815085,128.023794 L13.0562419,125.625699 C13.0562419,125.625699 15.1868741,111.464249 19.2214754,112.782974 L23.2107442,115.181068"
          id="Fill-599"
          fill="#C7C5BD"
        />
        <path
          d="M17.1815085,128.023794 L20.2183393,126.292542 C20.2183393,126.292542 20.3996697,116.287184 25.0693808,114.69601 C25.0693808,114.69601 21.5783173,114.383668 20.0827948,117.719694 C18.586819,120.249253 17.9521627,120.054323 17.1815085,128.023794"
          id="Fill-600"
          fill="#E4E4E3"
        />
        <path
          d="M10.1998348,107.057467 C10.1998348,107.057467 5.57636304,107.057467 4.17105246,119.904725 L3.62376795e-13,117.507084 C3.62376795e-13,117.507084 2.17641809,103.340647 6.16568683,104.664359 L10.1998348,107.057467"
          id="Fill-601"
          fill="#C7C5BD"
        />
        <path
          d="M4.17105246,119.904725 L7.16300402,118.17302 C7.16300402,118.17302 7.34433442,108.168569 12.0131388,106.576941 C12.0131388,106.576941 8.522982,106.264146 7.02700622,109.601079 C5.53103044,112.126104 4.89637405,111.935708 4.17105246,119.904725"
          id="Fill-602"
          fill="#E4E4E3"
        />
        <path
          d="M23.2107442,65.2109441 C23.2107442,65.2109441 72.7139426,56.6340163 75.161903,35.2284163 L75.161903,85.1985405 C75.161903,85.1985405 66.5033765,104.056448 23.2107442,115.176988 L23.2107442,65.2109441"
          id="Fill-603"
          fill="#E4E4E3"
        />
        <path
          d="M5.93857051,55.2155593 L23.2107442,65.2109441 C23.2107442,65.2109441 73.1672686,56.9064653 75.161903,35.2284163 L57.8448501,25.2371114 L5.93857051,55.2155593"
          id="Fill-604"
          fill="#C7C5BD"
        />
        <path
          d="M32.7759226,44.9699385 C32.7759226,48.007676 36.2665328,50.4737694 40.5277971,50.4737694 C44.8343941,50.4737694 48.3250042,48.007676 48.3250042,44.9699385 C48.3250042,41.9281211 44.8343941,39.462481 40.5277971,39.462481 C36.2665328,39.462481 32.7759226,41.9281211 32.7759226,44.9699385"
          id="Fill-605"
          fill="#777776"
        />
        <polygon
          id="Fill-606"
          fill="#777776"
          points="32.7759226 44.9699385 48.3250042 44.9699385 48.3250042 5.50337756 32.7759226 5.50337756"
        />
        <path
          d="M68.7246739,80.7554924 L35.0425526,102.180132 L35.0425526,80.8778904 C35.0425526,80.8778904 38.2611672,66.7341195 53.4022553,61.4578582 C58.0715131,59.1590421 65.1887311,59.4401042 68.7246739,67.5365065 L68.7246739,80.7554924"
          id="Fill-607"
          fill="#C7C5BD"
        />
        <path
          d="M58.1168457,74.5952455 L35.0425526,88.3623026 L35.0425526,80.8778904 C35.0425526,80.8778904 37.5358456,68.9010177 48.3250042,63.1759637 C55.4422223,59.3766386 57.8448501,60.2152917 57.8448501,60.2152917 L58.1168457,74.5952455"
          id="Fill-608"
          fill="#777776"
        />
        <path
          d="M53.5377998,82.8362587 C53.5377998,82.8362587 44.1992843,80.3751519 44.5623985,77.9539378 L47.0556914,78.4027305 C47.0556914,78.4027305 42.1593174,71.0729025 40.7544601,72.1019525 C40.7544601,72.1019525 44.2904029,69.0465354 47.4636848,71.1993805 C50.6822994,73.3531323 47.8716782,69.6399391 47.8716782,69.6399391 C47.8716782,69.6399391 56.4848721,73.7339261 55.8502157,77.342401 C55.8502157,77.342401 56.3488743,80.515683 53.5377998,82.8362587"
          id="Fill-609"
          fill="#E67848"
        />
        <path
          d="M32.7759226,5.50337756 C32.7759226,8.54519497 36.2665328,11.0072084 40.5277971,11.0072084 C44.8343941,11.0072084 48.3250042,8.54519497 48.3250042,5.50337756 C48.3250042,2.46156014 44.8343941,-1.12265752e-13 40.5277971,-1.12265752e-13 C36.2665328,-1.12265752e-13 32.7759226,2.46156014 32.7759226,5.50337756"
          id="Fill-610"
          fill="#636463"
        />
        <polyline
          id="Fill-611"
          fill="#C7C5BD"
          points="23.2107442 65.2109441 5.93857051 55.2155593 5.93857051 105.185684 23.2107442 115.176988 23.2107442 65.2109441"
        />
      </g>
    </g>
  </svg>
)

export const stepGasImage2 = (
  <svg
    width="70px"
    height="70px"
    viewBox="0 0 128 128"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    aria-hidden="true"
  >
    <g
      id="2.verwarming/verwarming_2.4"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Group" transform="translate(30.400000, 3.200000)">
        <path
          d="M19.1688896,4.46526103 C19.1688896,2.22453541 16.6108358,0.40766959 13.4378777,0.40766959 C10.2642719,0.40766959 7.70654188,2.22453541 7.70654188,4.46526103"
          id="Fill-612"
          fill="#777776"
        />
        <path
          d="M7.70654188,33.5587519 C7.70654188,35.7998013 10.2642719,37.6160195 13.4378777,37.6160195 C16.6108358,37.6160195 19.1688896,35.7998013 19.1688896,33.5587519 C19.1688896,31.315112 16.6108358,29.49857 13.4378777,29.49857 C10.2642719,29.49857 7.70654188,31.315112 7.70654188,33.5587519"
          id="Fill-613"
          fill="#777776"
        />
        <polygon
          id="Fill-614"
          fill="#777776"
          points="7.70654188 33.5590757 19.1688896 33.5590757 19.1688896 4.46526103 7.70654188 4.46526103"
        />
        <path
          d="M7.70654188,4.06050568 C7.70654188,6.30123131 10.2642719,8.11744952 13.4378777,8.11744952 C16.6108358,8.11744952 19.1688896,6.30123131 19.1688896,4.06050568 C19.1688896,1.81621821 16.6108358,-9.79533914e-14 13.4378777,-9.79533914e-14 C10.2642719,-9.79533914e-14 7.70654188,1.81621821 7.70654188,4.06050568"
          id="Fill-615"
          fill="#636463"
        />
        <path
          d="M19.1688896,25.4445404 C19.1688896,23.203491 16.6108358,21.3869489 13.4378777,21.3869489 C10.2642719,21.3869489 7.70654188,23.203491 7.70654188,25.4445404"
          id="Fill-616"
          fill="#777776"
        />
        <path
          d="M7.70654188,54.5380312 C7.70654188,56.7790806 10.2642719,58.5956227 13.4378777,58.5956227 C16.6108358,58.5956227 19.1688896,56.7790806 19.1688896,54.5380312 C19.1688896,52.2973056 16.6108358,50.4807636 13.4378777,50.4807636 C10.2642719,50.4807636 7.70654188,52.2973056 7.70654188,54.5380312"
          id="Fill-617"
          fill="#777776"
        />
        <polygon
          id="Fill-618"
          fill="#777776"
          points="7.70654188 54.538355 19.1688896 54.538355 19.1688896 25.4445404 7.70654188 25.4445404"
        />
        <path
          d="M13.3093102,37.1014945 C13.3093102,37.1014945 13.5378816,37.120599 13.5378816,37.3958326 C13.5378816,37.8750629 13.3093102,37.3958326 13.3093102,37.3958326"
          id="Fill-619"
          fill="#4D4E4C"
        />
        <path
          d="M13.4378777,37.3602141 C10.6531608,37.3602141 8.32144621,36.1556622 7.73892231,34.5398788 L7.57702017,34.5398788 C7.57702017,36.5542653 10.1998348,38.182677 13.4378777,38.182677 C16.6759205,38.182677 19.2987351,36.5542653 19.2987351,34.5398788 L19.136833,34.5398788 C18.5212811,36.1556622 16.2225945,37.3602141 13.4378777,37.3602141"
          id="Fill-620"
          fill="#777776"
        />
        <path
          d="M7.83892624,34.2452169 C7.83892624,34.2452169 7.61035482,34.268207 7.61035482,34.5398788 C7.61035482,35.0255853 7.83892624,34.5398788 7.83892624,34.5398788"
          id="Fill-621"
          fill="#777776"
        />
        <path
          d="M13.4378777,38.6489552 C10.6531608,38.6489552 8.32144621,37.4444032 7.73892231,35.8286199 L7.57702017,35.8286199 C7.57702017,37.8394445 10.1998348,39.471418 13.4378777,39.471418 C16.6759205,39.471418 19.2987351,37.8394445 19.2987351,35.8286199 L19.136833,35.8286199 C18.5212811,37.4444032 16.2225945,38.6489552 13.4378777,38.6489552"
          id="Fill-622"
          fill="#777776"
        />
        <path
          d="M7.83892624,35.533958 C7.83892624,35.533958 7.61035482,35.5533862 7.61035482,35.8286199 C7.61035482,36.3114121 7.83892624,35.8286199 7.83892624,35.8286199"
          id="Fill-623"
          fill="#777776"
        />
        <path
          d="M13.4378777,36.7935566 C10.6531608,36.7935566 8.32144621,35.5890047 7.73892231,33.9732213 L7.57702017,33.9732213 C7.57702017,35.9840459 10.1998348,37.6160195 13.4378777,37.6160195 C16.6759205,37.6160195 19.2987351,35.9840459 19.2987351,33.9732213 L19.136833,33.9732213 C18.5212811,35.5890047 16.2225945,36.7935566 13.4378777,36.7935566"
          id="Fill-624"
          fill="#4D4E4C"
        />
        <path
          d="M7.83892624,33.6785594 C7.83892624,33.6785594 7.61035482,33.6979877 7.61035482,33.9732213 C7.61035482,34.4556897 7.83892624,33.9732213 7.83892624,33.9732213"
          id="Fill-625"
          fill="#4D4E4C"
        />
        <path
          d="M13.4378777,38.1373444 C10.6531608,38.1373444 8.32144621,36.9331163 7.73892231,35.3170091 L7.57702017,35.3170091 C7.57702017,37.3313955 10.1998348,38.9598073 13.4378777,38.9598073 C16.6759205,38.9598073 19.2987351,37.3313955 19.2987351,35.3170091 L19.136833,35.3170091 C18.5212811,36.9331163 16.2225945,38.1373444 13.4378777,38.1373444"
          id="Fill-626"
          fill="#4D4E4C"
        />
        <path
          d="M7.83892624,35.0223472 C7.83892624,35.0223472 7.61035482,35.0420993 7.61035482,35.3170091 C7.61035482,35.8027155 7.83892624,35.3170091 7.83892624,35.3170091"
          id="Fill-627"
          fill="#4D4E4C"
        />
        <path
          d="M13.4378777,39.4778941 C10.6531608,39.4778941 8.32144621,38.2733422 7.73892231,36.6578826 L7.57702017,36.6578826 C7.57702017,38.6683834 10.1998348,40.3006808 13.4378777,40.3006808 C16.6759205,40.3006808 19.2987351,38.6683834 19.2987351,36.6578826 L19.136833,36.6578826 C18.5212811,38.2733422 16.2225945,39.4778941 13.4378777,39.4778941"
          id="Fill-628"
          fill="#4D4E4C"
        />
        <path
          d="M7.83892624,36.3628969 C7.83892624,36.3628969 7.61035482,36.3823252 7.61035482,36.6578826 C7.61035482,37.1400272 7.83892624,36.6578826 7.83892624,36.6578826"
          id="Fill-629"
          fill="#4D4E4C"
        />
        <polyline
          id="Fill-630"
          fill="#C7C5BD"
          points="-5.19711258e-13 52.8963435 32.8985149 72.2698774 32.8985149 124.541279 -5.19711258e-13 105.533967 -5.19711258e-13 52.8963435"
        />
        <polyline
          id="Fill-631"
          fill="#4D4E4C"
          points="-5.19711258e-13 52.8963435 32.8985149 72.2698774 32.8985149 81.0644017 -5.19711258e-13 62.0538524 -5.19711258e-13 52.8963435"
        />
        <polyline
          id="Fill-632"
          fill="#E4E4E3"
          points="65.8294103 53.0776739 32.8985149 72.4541221 32.8985149 124.726171 65.8294103 105.715622 65.8294103 53.0776739"
        />
        <polyline
          id="Fill-633"
          fill="#777776"
          points="65.8294103 53.0776739 63.9513455 49.7683942 32.9956562 67.5747154 32.8985149 72.4541221 65.8294103 53.0776739"
        />
        <polyline
          id="Fill-634"
          fill="#636463"
          points="0 52.8963435 1.8456844 49.5838257 32.9956562 67.5747154 32.8985149 72.4541221 0 52.8963435"
        />
        <polyline
          id="Fill-635"
          fill="#777776"
          points="1.8456844 49.5838257 33.6432648 31.8782076 63.9513455 49.7683942 32.9956562 67.5747154 1.8456844 49.5838257"
        />
        <polyline
          id="Fill-636"
          fill="#4D4E4C"
          points="65.8294103 52.8963435 32.8985149 72.2698774 32.8985149 81.0644017 65.8294103 62.0538524 65.8294103 52.8963435"
        />
      </g>
    </g>
  </svg>
)

export const stepGasImage3 = (
  <svg
    width="70px"
    height="70px"
    viewBox="0 0 128 128"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    aria-hidden="true"
  >
    <g
      id="2.verwarming/verwarming_2.2"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Group" transform="translate(38.400000, 1.600000)">
        <polyline
          id="Fill-650"
          fill="#F8F7F6"
          points="18.6683765 58.9525727 18.6683765 126.296622 51.1022029 107.586622 51.1022029 40.2466938 18.6683765 58.9525727"
        />
        <path
          d="M18.6683765,58.7263218 L18.6683765,126.069547 C24.1911235,124.52865 31.5267623,121.816525 39.1920927,116.859199 C44.0962557,113.694159 48.0525553,110.35191 51.1022029,107.363668 L51.1022029,40.0200308 C48.0525553,42.9872555 44.1786786,46.2965352 39.3569385,49.4286057 C31.6091852,54.4485729 24.2319228,57.1808923 18.6683765,58.7263218"
          id="Fill-651"
          fill="#E4E4E3"
        />
        <polyline
          id="Fill-652"
          fill="#C7C5BD"
          points="18.6683765 58.9525727 18.6683765 126.296622 0 115.346326 0 48.0026894 18.6683765 58.9525727"
        />
        <path
          d="M31.6499845,29.0211059 L51.1022029,40.2466938 C47.4755949,43.654881 42.489009,47.7269848 36.0188107,51.4685727 C29.507401,55.2311784 23.4489052,57.5229474 18.6683765,58.9525727 L3.30725346e-13,48.0026894 L31.6499845,29.0211059"
          id="Fill-653"
          fill="#C7C5BD"
        />
        <path
          d="M18.0502047,42.8553788 C18.0502047,45.6989691 21.3063217,48.0026894 25.3034206,48.0026894 C29.3013437,48.0026894 32.5570486,45.6989691 32.5570486,42.8553788 C32.5570486,40.0159096 29.3013437,37.7084803 25.3034206,37.7084803 C21.3063217,37.7084803 18.0502047,40.0159096 18.0502047,42.8553788"
          id="Fill-654"
          fill="#9E9F9E"
        />
        <path
          d="M32.5982601,5.67852624 C32.5982601,2.82669362 29.3425552,0.515143174 25.3034206,0.515143174 C21.2651102,0.515143174 18.0094054,2.82669362 18.0094054,5.67852624"
          id="Fill-655"
          fill="#777776"
        />
        <path
          d="M18.0094054,42.7074297 C18.0094054,45.5588502 21.2651102,47.875346 25.3034206,47.875346 C29.3425552,47.875346 32.5982601,45.5588502 32.5982601,42.7074297 C32.5982601,39.8555971 29.3425552,37.5432224 25.3034206,37.5432224 C21.2651102,37.5432224 18.0094054,39.8555971 18.0094054,42.7074297"
          id="Fill-656"
          fill="#777776"
        />
        <polygon
          id="Fill-657"
          fill="#777776"
          points="18.0094054 42.7070176 32.5982601 42.7070176 32.5982601 5.67852624 18.0094054 5.67852624"
        />
        <path
          d="M18.0094054,5.16338306 C18.0094054,8.01521567 21.2651102,10.3312994 25.3034206,10.3312994 C29.3425552,10.3312994 32.5982601,8.01521567 32.5982601,5.16338306 C32.5982601,2.31155045 29.3425552,-6.45947942e-16 25.3034206,-6.45947942e-16 C21.2651102,-6.45947942e-16 18.0094054,2.31155045 18.0094054,5.16338306"
          id="Fill-658"
          fill="#636463"
        />
        <path
          d="M30.7849561,113.681796 L30.7849561,121.515681 C32.8455288,120.700106 35.2357931,119.583276 37.7496918,118.045677 C40.139544,116.58267 42.1181059,115.066501 43.7665641,113.681796 L43.7665641,100.073774 L30.7849561,108.196551 L30.7849561,113.681796"
          id="Fill-659"
          fill="#C7C5BD"
        />
        <polyline
          id="Fill-660"
          fill="#E67848"
          points="33.9166145 108.064262 33.9166145 114.736397 41.4175112 110.104641 41.4175112 103.345551 33.9166145 108.064262"
        />
        <path
          d="M34.9061015,114.736397 C35.4830618,114.736397 35.9363878,115.482324 35.9363878,116.405873 C35.9363878,117.328597 35.4830618,118.074525 34.9061015,118.074525 C34.3703526,118.074525 33.9166145,117.328597 33.9166145,116.405873 C33.9166145,115.482324 34.3703526,114.736397 34.9061015,114.736397"
          id="Fill-661"
          fill="#636463"
        />
        <polygon
          id="Fill-662"
          fill="#636463"
          points="34.86489 118.074525 35.4830618 118.074525 35.4830618 114.736397 34.86489 114.736397"
        />
        <path
          d="M35.4830618,114.736397 C36.0600222,114.736397 36.5133482,115.482324 36.5133482,116.405873 C36.5133482,117.328597 36.0600222,118.074525 35.4830618,118.074525 C34.9473129,118.074525 34.4939869,117.328597 34.4939869,116.405873 C34.4939869,115.482324 34.9473129,114.736397 35.4830618,114.736397"
          id="Fill-663"
          fill="#777776"
        />
        <path
          d="M37.9145376,112.865809 C38.491498,112.865809 38.944824,113.611324 38.944824,114.534873 C38.944824,115.457597 38.491498,116.203525 37.9145376,116.203525 C37.3787887,116.203525 36.8842513,115.457597 36.8842513,114.534873 C36.8842513,113.611324 37.3787887,112.865809 37.9145376,112.865809"
          id="Fill-664"
          fill="#636463"
        />
        <polygon
          id="Fill-665"
          fill="#636463"
          points="37.8317026 116.203937 38.491498 116.203937 38.491498 112.865809 37.8317026 112.865809"
        />
        <path
          d="M38.491498,112.865809 C39.0680462,112.865809 39.5213722,113.611324 39.5213722,114.534873 C39.5213722,115.457597 39.0680462,116.203525 38.491498,116.203525 C37.9557491,116.203525 37.5024231,115.457597 37.5024231,114.534873 C37.5024231,113.611324 37.9557491,112.865809 38.491498,112.865809"
          id="Fill-666"
          fill="#777776"
        />
        <path
          d="M40.8817623,111.192624 C41.4587227,111.192624 41.9120486,111.942672 41.9120486,112.865809 C41.9120486,113.784412 41.4587227,114.534873 40.8817623,114.534873 C40.3460134,114.534873 39.8926874,113.784412 39.8926874,112.865809 C39.8926874,111.942672 40.3460134,111.192624 40.8817623,111.192624"
          id="Fill-667"
          fill="#636463"
        />
        <polygon
          id="Fill-668"
          fill="#636463"
          points="40.8405508 114.534873 41.4587227 114.534873 41.4587227 111.192624 40.8405508 111.192624"
        />
        <path
          d="M41.4587227,111.192624 C42.035683,111.192624 42.489009,111.942672 42.489009,112.865809 C42.489009,113.784412 42.035683,114.534873 41.4587227,114.534873 C40.9225616,114.534873 40.4696478,113.784412 40.4696478,112.865809 C40.4696478,111.942672 40.9225616,111.192624 41.4587227,111.192624"
          id="Fill-669"
          fill="#777776"
        />
      </g>
    </g>
  </svg>
)

export const stepGasImage4 = (
  <svg
    width="70px"
    height="70px"
    viewBox="0 0 128 128"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    aria-hidden="true"
  >
    <g
      id="2.verwarming/verwarming_2.3"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Group" transform="translate(40.000000, 0.000000)">
        <polygon
          id="Fill-637"
          fill="#C7C5BD"
          points="22.5575014 126.535615 24.2616445 126.535615 24.2616445 93.9505428 22.5575014 93.9505428"
        />
        <polygon
          id="Fill-638"
          fill="#C7C5BD"
          points="28.1424777 123.243018 29.8466207 123.243018 29.8466207 90.6579454 28.1424777 90.6579454"
        />
        <polygon
          id="Fill-639"
          fill="#C7C5BD"
          points="33.328527 120.120508 35.0330328 120.120508 35.0330328 87.535436 33.328527 87.535436"
        />
        <polyline
          id="Fill-640"
          fill="#F8F7F6"
          points="17.4077181 51.0662665 17.4077181 110.328304 45.9128566 93.8635042 45.9128566 34.605093 17.4077181 51.0662665"
        />
        <path
          d="M17.4077181,50.8664404 L17.4077181,94.0633303 C22.230744,92.7069789 28.6864689,90.3203082 35.4319596,85.9538723 C39.7838892,83.172264 43.2291667,80.2314476 45.9128566,77.6021568 L45.9128566,34.4056296 C43.2291667,37.0164246 39.8201552,39.9285908 35.5770239,42.6848129 C28.7586383,47.102384 22.2673728,49.5064624 17.4077181,50.8664404"
          id="Fill-641"
          fill="#E4E4E3"
        />
        <polyline
          id="Fill-642"
          fill="#C7C5BD"
          points="17.4077181 51.0662665 17.4077181 110.328304 0.942918066 100.69277 0.942918066 41.4300065 17.4077181 51.0662665"
        />
        <path
          d="M28.7952671,24.7258503 L45.9128566,34.605093 C42.7210789,37.6042978 38.333246,41.1870238 32.6394715,44.4803465 C26.909431,47.7910768 21.5783173,49.8074709 17.4077181,51.0662665 L0.942918066,41.4300065 L28.7952671,24.7258503"
          id="Fill-643"
          fill="#C7C5BD"
        />
        <path
          d="M42.8665059,87.6474982 C42.6489094,87.0346014 42.2133538,86.5812754 41.6693626,86.3132691 C40.7993394,85.8922199 39.6384622,85.9248594 38.5145764,86.4761038 L38.5145764,86.4800931 L38.4420442,86.5163592 C38.4054155,86.5341295 38.3691494,86.5489986 38.333246,86.566769 C38.2969799,86.6066617 38.2244477,86.646917 38.1519156,86.6864471 L23.1014926,95.1222998 C21.1793904,95.9672995 19.909715,98.0380926 20.3090045,99.7534782 C20.526601,100.631117 21.1068582,101.244014 21.904712,101.526527 L21.904712,101.530516 L21.904712,101.526527 C22.6662997,101.798522 23.6092177,101.762256 24.5884019,101.349186 C24.6972001,101.30204 24.8056357,101.251267 24.9147966,101.196868 L24.9147966,101.192879 L40.1102839,92.6743394 C40.2553482,92.6126871 40.4004125,92.5474082 40.5451142,92.4712494 C42.431313,91.4376661 43.4830293,89.2794717 42.8665059,87.6474982"
          id="Fill-644"
          fill="#C7C5BD"
        />
        <path
          d="M5.3670171,-3.63797881e-14 C2.42982732,-3.63797881e-14 -2.89901436e-13,4.05781163 -2.89901436e-13,9.06978381 C-2.89901436e-13,14.0781294 2.42982732,18.1399303 5.3670171,18.1399303 C8.34119828,18.1399303 10.7347595,14.0781294 10.7347595,9.06978381 C10.7347595,4.05781163 8.34119828,-3.63797881e-14 5.3670171,-3.63797881e-14"
          id="Fill-645"
          fill="#9E9F9E"
        />
        <path
          d="M16.8274609,36.9007358 C16.8274609,39.4030953 19.6924811,41.4300065 23.2102909,41.4300065 C26.7643666,41.4300065 29.6293869,39.4030953 29.6293869,36.9007358 C29.6293869,34.4016403 26.7643666,32.3707399 23.2102909,32.3707399 C19.6924811,32.3707399 16.8274609,34.4016403 16.8274609,36.9007358"
          id="Fill-646"
          fill="#9E9F9E"
        />
        <path
          d="M17.0450573,37.8940638 L17.0450573,24.2870308 C17.0450573,24.2870308 17.1175895,21.1064956 10.4083648,18.36478 L5.98390311,16.2580834 L5.98390311,1.00058113 L24.0444107,11.5833858 C24.0444107,11.5833858 29.4843226,14.5535777 29.6293869,19.641346 C29.7381852,24.7258503 29.6293869,36.8644698 29.6293869,36.8644698 L17.0450573,37.8940638"
          id="Fill-647"
          fill="#9E9F9E"
        />
        <polyline
          id="Fill-648"
          fill="#E67848"
          points="23.8268142 96.859445 23.8268142 99.8873 27.2358257 97.932921 27.2358257 94.8608214 23.8268142 96.859445"
        />
        <path
          d="M40.1824534,86.8572603 C38.9860354,86.8572603 38.0431174,87.8723479 38.0431174,89.1307808 C38.0431174,90.3859498 38.9860354,91.4010374 40.1824534,91.4010374 C41.3795967,91.4010374 42.3584181,90.3859498 42.3584181,89.1307808 C42.3584181,87.8723479 41.3795967,86.8572603 40.1824534,86.8572603"
          id="Fill-649"
          fill="#9E9F9E"
        />
      </g>
    </g>
  </svg>
)

export const pageElecriciteImage1 = (
  <svg
    width="70px"
    height="70px"
    viewBox="0 0 128 128"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    aria-hidden="true"
  >
    <g
      id="2.verwarming/verwarming_3.1"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Group" transform="translate(12.800000, 0.000000)">
        <path
          d="M5.08205105,107.337462 L27.5622204,121.032707 C27.4502222,114.468013 23.6422839,108.46811 17.9565093,106.142281 C11.3651493,103.449525 5.90390441,106.878803 5.08205105,107.337462"
          id="Fill-670"
          fill="#8A8B8A"
        />
        <polyline
          id="Fill-671"
          fill="#8A8B8A"
          points="2.12326888e-13 109.944886 5.08205105 107.337462 27.5622204 121.032707 23.0662932 123.651331 2.12326888e-13 109.944886"
        />
        <path
          d="M0,109.944886 L23.0662932,123.651331 C22.9489618,117.086104 19.1463567,111.294731 13.4552488,108.969436 C6.86868878,106.275613 0.826119957,109.492094 0,109.944886"
          id="Fill-672"
          fill="#9E9F9E"
        />
        <path
          d="M78.3133986,65.0442802 L100.798368,78.7352585 C100.680503,72.1748314 96.8784314,66.1701286 91.1878568,63.8442996 C84.6012968,61.1510099 79.1400519,64.5856209 78.3133986,65.0442802"
          id="Fill-673"
          fill="#8A8B8A"
        />
        <polyline
          id="Fill-674"
          fill="#8A8B8A"
          points="73.2356142 67.6522379 78.3133986 65.0442802 100.798368 78.7352585 96.2971075 81.359216 73.2356142 67.6522379"
        />
        <path
          d="M73.2356142,67.6522379 L96.2971075,81.359216 C96.1851093,74.793989 92.3771709,68.9962162 86.6913963,66.6714538 C80.1053696,63.9776308 74.0574675,67.194112 73.2356142,67.6522379"
          id="Fill-675"
          fill="#9E9F9E"
        />
        <polyline
          id="Fill-676"
          fill="#E4E4E3"
          points="17.3650522 46.836575 8.63986011 41.8179896 8.63986011 105.572157 22.3036389 114.366148 22.3036389 50.2717193 17.3650522 46.836575"
        />
        <path
          d="M17.3650522,46.836575 C17.3650522,46.836575 22.3036389,51.3325022 22.3036389,61.6843346 L22.3036389,114.366148 L98.4837387,70.3775271 L97.7424174,22.7841644 C97.7157511,21.0556591 97.4912215,19.3388869 97.0490953,17.6695806 C96.0304451,13.8557757 93.7744816,7.3332146 89.7745464,5.02978523 L17.3650522,46.836575"
          id="Fill-677"
          fill="#F8F7F6"
        />
        <polyline
          id="Fill-678"
          fill="#CBCCCB"
          points="8.63986011 41.8179896 17.3650522 46.836575 89.7745464 5.02978523 81.0706873 0 8.63986011 41.8179896"
        />
        <path
          d="M11.3224833,81.4925472 C11.3224833,84.2653023 13.1784533,86.5164658 15.4717495,86.5164658 C17.7650457,86.5164658 19.6258156,84.2653023 19.6258156,81.4925472 C19.6258156,78.7139255 17.7650457,76.4627619 15.4717495,76.4627619 C13.1784533,76.4627619 11.3224833,78.7139255 11.3224833,81.4925472"
          id="Fill-679"
          fill="#DE482A"
        />
        <path
          d="M10.2446341,82.1058706 C10.2446341,84.879159 12.1006041,87.1292559 14.3944336,87.1292559 C16.6877298,87.1292559 18.549033,84.879159 18.549033,82.1058706 C18.549033,79.3267156 16.6877298,77.0760853 14.3944336,77.0760853 C12.1006041,77.0760853 10.2446341,79.3267156 10.2446341,82.1058706"
          id="Fill-680"
          fill="#E67848"
        />
        <path
          d="M26.2982409,60.4048886 C25.444388,60.873681 24.3942717,60.2608909 24.3889384,59.2843734 C24.3836052,58.1169257 24.228941,56.6657492 23.8124144,55.0764416 C23.3756215,53.3916688 22.8316303,52.0690236 22.2983056,51.1298388 C21.9463113,50.5063822 22.1489747,49.7218616 22.7676314,49.364534 L23.0982927,49.1730705 C23.7222826,48.8157429 24.5222696,49.0237396 24.8683973,49.6583959 C25.4342548,50.6765128 26.0155788,52.1431557 26.452905,54.0263252 C26.9755632,56.2502892 27.0875614,58.1595916 26.9648967,59.4022382 C26.9222307,59.8288979 26.6715681,60.1963587 26.2982409,60.4048886"
          id="Fill-681"
          fill="#9E9F9E"
        />
        <path
          d="M31.2634938,57.3430715 C30.404841,57.8129306 29.3595246,57.2049404 29.3541914,56.2289562 C29.3488581,55.0551086 29.1888607,53.6097986 28.7782007,52.0156911 C28.3355412,50.3298517 27.7968833,49.0130731 27.2635586,48.0690883 C26.9110309,47.4504317 27.1142276,46.6611111 27.7328843,46.3037836 L28.0635456,46.1112534 C28.6875355,45.7539258 29.4875225,45.9672557 29.8341836,46.5965789 C30.3995078,47.6205623 30.9754985,49.0872052 31.418158,50.9645081 C31.9354829,53.1943387 32.0528143,55.1036411 31.9242831,56.3457543 C31.8816171,56.7670808 31.6362878,57.1404081 31.2634938,57.3430715"
          id="Fill-682"
          fill="#9E9F9E"
        />
        <path
          d="M35.9034187,54.6129824 C35.0442326,55.0823081 33.9941162,54.4689847 33.988783,53.4930005 C33.9834497,52.3250194 33.8287856,50.8738429 33.412259,49.2845353 C32.9754661,47.5992293 32.4362748,46.276584 31.9034834,45.3384659 C31.5514891,44.714476 31.7488193,43.9299554 32.3728092,43.5731611 L32.6981372,43.3811643 C33.3221271,43.0179701 34.1221142,43.2313 34.4682419,43.8611565 C35.0340994,44.8846066 35.6154233,46.3512495 36.0527496,48.2338857 C36.5754078,50.458383 36.6922059,52.3671521 36.5647413,53.6097986 C36.5220753,54.0364584 36.2714127,54.4049858 35.9034187,54.6129824"
          id="Fill-683"
          fill="#9E9F9E"
        />
        <path
          d="M40.8633384,51.5511653 C40.0100188,52.020491 38.9593692,51.4130342 38.9540359,50.4365167 C38.9487027,49.2632023 38.7940385,47.8178924 38.3780453,46.2237849 C37.940719,44.5384788 37.3967278,43.2206335 36.868203,42.2766488 C36.5108755,41.6585255 36.7140722,40.8692049 37.3327289,40.5113441 L37.6633902,40.3193472 C38.2873801,39.9625529 39.0873671,40.1753495 39.4340282,40.805206 C39.9993523,41.8291894 40.5801429,43.2958323 41.0180025,45.1731352 C41.5406607,47.3965659 41.6526589,49.3112016 41.5299942,50.5538481 C41.4873282,50.9751746 41.2361323,51.3490352 40.8633384,51.5511653"
          id="Fill-684"
          fill="#9E9F9E"
        />
        <path
          d="M45.5512624,48.8312093 C44.6920764,49.3064016 43.6472933,48.6930782 43.64196,47.717094 C43.6360935,46.5432464 43.4766294,45.0979365 43.0659694,43.5038289 C42.6233099,41.8179896 42.0846519,40.5006776 41.5513272,39.5572262 C41.1993329,38.9385695 41.4019963,38.149249 42.0206529,37.7919214 L42.3513143,37.5993912 C42.9699709,37.2420637 43.7752912,37.4553935 44.1219523,38.0847167 C44.6872764,39.1087001 45.2632671,40.575343 45.7059266,42.452646 C46.2232516,44.6824765 46.340583,46.5917789 46.2120517,47.8338922 C46.1699191,48.2552187 45.9240564,48.6290793 45.5512624,48.8312093"
          id="Fill-685"
          fill="#9E9F9E"
        />
        <path
          d="M50.5165154,45.7752588 C49.6578626,46.2445846 48.607213,45.6312612 48.6018797,44.655277 C48.5965465,43.4872959 48.4418823,42.0366527 48.0253557,40.4478784 C47.5885628,38.7625724 47.0499048,37.4399271 46.5165802,36.5007423 C46.1645858,35.8767524 46.361916,35.0932984 46.9859059,34.7301043 L47.3107006,34.5434407 C47.9352238,34.1813132 48.7352109,34.3946431 49.0813386,35.0239662 C49.6471961,36.0479497 50.22852,37.5145926 50.6658463,39.3966954 C51.1885045,41.6206594 51.3058359,43.5299618 51.177838,44.7731417 C51.135172,45.1944682 50.8898427,45.5672622 50.5165154,45.7752588"
          id="Fill-686"
          fill="#9E9F9E"
        />
        <path
          d="M55.151107,43.0398364 C54.2977875,43.5086289 53.2471378,42.9006387 53.2418046,41.9251878 C53.235938,40.7513402 53.0812739,39.3065636 52.6658139,37.7113894 C52.2231544,36.0266167 51.6844965,34.7087713 51.1511718,33.7647866 C50.7991775,33.14613 51.0018409,32.3573427 51.6204975,31.9994819 L51.9511588,31.807485 C52.5751487,31.4506908 53.3751358,31.6634873 53.7217968,32.2933438 C54.287121,33.3173272 54.8679116,34.7839701 55.3057712,36.6612731 C55.8230961,38.8847037 55.9404276,40.7993394 55.8177629,42.0419859 C55.7750969,42.4633124 55.523901,42.8366397 55.151107,43.0398364"
          id="Fill-687"
          fill="#9E9F9E"
        />
        <path
          d="M60.1163599,39.9838859 C59.2577072,40.4526783 58.2118575,39.8398883 58.2070575,38.8633707 C58.2017243,37.695923 58.0417269,36.2447465 57.6310669,34.6554389 C57.1884074,32.9706661 56.6497494,31.6480209 56.1164247,30.7088361 C55.7644304,30.0848462 55.9670938,29.3008589 56.5857504,28.9387314 L56.9164118,28.7515345 C57.5404017,28.3888737 58.3403887,28.6027369 58.6870498,29.2315267 C59.2523739,30.2555101 59.8283646,31.722153 60.2710241,33.6053225 C60.7883491,35.8292865 60.9056805,37.7385889 60.7776826,38.9812355 C60.7350166,39.402562 60.4896872,39.775356 60.1163599,39.9838859"
          id="Fill-688"
          fill="#9E9F9E"
        />
        <path
          d="M64.6336201,37.6100577 C63.7797673,38.0799168 62.729651,37.46606 62.7237844,36.4906092 C62.7189845,35.3220947 62.5643203,33.8719849 62.148327,32.2826773 C61.7056675,30.5968379 61.1670096,29.2741927 60.6336849,28.3360745 C60.2811573,27.7115513 60.484354,26.927564 61.1030106,26.5707698 L61.433672,26.3782396 C62.0576618,26.0161121 62.8576489,26.229442 63.2043099,26.8587651 C63.7696341,27.8827485 64.350958,29.3493914 64.7882843,31.2314943 C65.3056093,33.4554583 65.4229407,35.3647607 65.2997427,36.6074073 C65.25761,37.0292671 65.0069474,37.4025944 64.6336201,37.6100577"
          id="Fill-689"
          fill="#9E9F9E"
        />
        <path
          d="M69.5988731,34.5493073 C68.7402203,35.0180997 67.6949039,34.4101095 67.6895707,33.4341253 C67.6842374,32.2613443 67.5237067,30.8160344 67.11358,29.2208602 C66.6709205,27.5360875 66.1322625,26.2182421 65.5989378,25.2742574 C65.2469435,24.6556008 65.4496069,23.8662802 66.0677303,23.5089527 L66.3989249,23.3174891 C67.0175815,22.9601616 67.8229018,23.1734914 68.1695629,23.8028146 C68.7348871,24.826798 69.3103444,26.2934409 69.7535372,28.1707439 C70.2708622,30.3947079 70.3881936,32.3088102 70.2601957,33.5461235 C70.2175297,33.9733166 69.9722004,34.3461105 69.5988731,34.5493073"
          id="Fill-690"
          fill="#9E9F9E"
        />
        <path
          d="M74.2387979,31.8181515 C73.3796119,32.2874772 72.3294955,31.6741538 72.323629,30.6981696 C72.318829,29.5301885 72.1641649,28.0800787 71.7481716,26.4907711 C71.310312,24.805465 70.7721874,23.4828198 70.2388627,22.543635 C69.8868684,21.9196451 70.0841986,21.1361911 70.7081884,20.7735303 L71.0335165,20.5863333 C71.6575064,20.2242059 72.4574935,20.4370024 72.8041545,21.0663256 C73.3694787,22.0908423 73.9508026,23.5574852 74.3881289,25.4395881 C74.9102537,27.6635521 75.0227853,29.5733878 74.8995872,30.8160344 C74.8574546,31.2368276 74.606792,31.6101548 74.2387979,31.8181515"
          id="Fill-691"
          fill="#9E9F9E"
        />
        <path
          d="M79.1987176,28.757401 C78.3453981,29.2267268 77.2947485,28.6182033 77.2894152,27.6368858 C77.284082,26.4694381 77.1294178,25.0241281 76.7134245,23.4294873 C76.270765,21.7436479 75.7321071,20.4268693 75.1987824,19.4828845 C74.8467881,18.8636946 75.0494515,18.074374 75.6675748,17.7175798 L75.9987694,17.5255829 C76.6227593,17.167722 77.4227464,17.3815852 77.7694074,18.010375 C78.3347316,19.0343585 78.9160555,20.5010014 79.3533818,22.3783043 C79.8707068,24.6028016 79.9880382,26.5174373 79.8653735,27.7542173 C79.8227075,28.1814104 79.5720449,28.5542043 79.1987176,28.757401"
          id="Fill-692"
          fill="#9E9F9E"
        />
        <path
          d="M83.8866417,26.0369118 C83.027989,26.5067708 81.9773393,25.8982473 81.9773393,24.9222631 C81.9666728,23.7489488 81.8114753,22.3041722 81.4013486,20.708998 C80.9586891,19.0242253 80.4200312,17.7069133 79.8867065,16.7629286 C79.5347122,16.1437386 79.7368423,15.3544181 80.3554989,14.9970905 L80.6866935,14.8056269 C81.3053502,14.4482994 82.1101372,14.6616293 82.4573315,15.2909524 C83.0173225,16.3149358 83.5986464,17.7815788 84.0413059,19.6583484 C84.5586309,21.8828457 84.6759623,23.796948 84.5479644,25.0395946 C84.5052984,25.4614544 84.259969,25.8342484 83.8866417,26.0369118"
          id="Fill-693"
          fill="#9E9F9E"
        />
        <path
          d="M88.8518947,22.975628 C87.9932419,23.4508203 86.9425923,22.8369636 86.9367257,21.8615127 C86.9319258,20.6935316 86.7772616,19.2423551 86.3612683,17.6530475 C85.9234088,15.9677415 85.3852841,14.6450962 84.8519594,13.7069781 C84.4994318,13.0829882 84.6972953,12.2984675 85.3212852,11.9363401 L85.6466132,11.7491431 C86.2706031,11.3864823 87.0705902,11.5998122 87.4172512,12.2296686 C87.9825754,13.2531187 88.5638993,14.7197617 89.0012256,16.6029312 C89.5233505,18.8268952 89.6412152,20.7361976 89.5132173,21.9783108 C89.4705513,22.3996373 89.2198887,22.7734979 88.8518947,22.975628"
          id="Fill-694"
          fill="#9E9F9E"
        />
        <path
          d="M93.4864863,20.2450055 C92.6331668,20.7148646 91.5825171,20.1068744 91.5771839,19.125557 C91.5718506,17.9575759 91.4171865,16.5117326 91.0011932,14.9176251 C90.5585337,13.2317858 90.0198758,11.9150071 89.4865511,10.9710224 C89.1345568,10.3464991 89.3366868,9.56304516 89.9553435,9.20571761 L90.2865381,9.01372072 C90.9099947,8.65585985 91.7099817,8.86972305 92.0571761,9.49851287 C92.6225003,10.5224963 93.2038242,11.9891392 93.6411505,13.8664421 C94.1584754,16.0909395 94.2758068,18.0055751 94.1531422,19.2423551 C94.1099429,19.6695482 93.8598136,20.0423421 93.4864863,20.2450055"
          id="Fill-695"
          fill="#9E9F9E"
        />
      </g>
    </g>
  </svg>
)

export const pageElecriciteImage2 = (
  <svg
    width="70px"
    height="70px"
    viewBox="0 0 128 128"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    aria-hidden="true"
  >
    <g
      id="2.verwarming/verwarming_3.2"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Group" transform="translate(14.400000, 1.600000)">
        <polyline
          id="Fill-716"
          fill="#F8F7F6"
          points="17.8043784 28.487761 17.8043784 122.991497 48.6377236 105.186741 48.6377236 10.6837603 17.8043784 28.487761"
        />
        <path
          d="M17.8043784,28.2728089 L17.8043784,122.77579 C23.047849,121.310036 30.0101808,118.726455 37.3347955,114.00771 C42.004431,110.996869 45.7405927,107.816032 48.6377236,104.971411 L48.6377236,10.4684305 C45.7670367,13.290007 42.0762076,16.4406227 37.4711711,19.4253966 C30.1008459,24.2000526 23.0818485,26.8028993 17.8043784,28.2728089"
          id="Fill-717"
          fill="#E4E4E3"
        />
        <polyline
          id="Fill-718"
          fill="#C7C5BD"
          points="17.8043784 28.487761 17.8043784 122.991497 -4.55931589e-13 112.572555 -4.55931589e-13 18.0688185 17.8043784 28.487761"
        />
        <path
          d="M30.1386231,1.13686838e-13 L48.6377236,10.6837603 C45.2003792,13.9250412 40.4555672,17.8043784 34.2975113,21.3633652 C28.1062116,24.9446405 22.3485937,27.124383 17.8043784,28.487761 L3.03164901e-13,18.0688185 L30.1386231,1.13686838e-13"
          id="Fill-719"
          fill="#C7C5BD"
        />
        <path
          d="M21.2608322,40.3312803 C21.2912108,45.9563003 26.8444542,48.8689198 33.659455,46.8323528 C40.474078,44.7961636 45.9748111,38.5821975 45.9409685,32.9571775 C45.9068122,27.3317797 40.3535688,24.4233157 33.5385681,26.4591271 C26.7235673,28.4953164 21.2269896,34.7058825 21.2608322,40.3312803"
          id="Fill-720"
          fill="#9E9F9E"
        />
        <polyline
          id="Fill-721"
          fill="#636463"
          points="29.9081824 35.6276453 29.9081824 41.977987 38.8160382 36.7008946 38.8160382 30.2670655 29.9081824 35.6276453"
        />
        <polyline
          id="Fill-722"
          fill="#C7C5BD"
          points="61.3236737 90.9413497 61.3236737 62.4569887 92.1573967 80.2617449 92.1573967 108.745728 61.3236737 90.9413497"
        />
        <polyline
          id="Fill-723"
          fill="#9E9F9E"
          points="62.3663235 90.1363183 62.3663235 65.0677687 81.4740141 75.7658843 81.4740141 100.83519 62.3663235 90.1363183"
        />
        <polyline
          id="Fill-724"
          fill="#E4E4E3"
          points="98.3226302 76.6993581 92.1573967 80.2617449 92.1573967 108.745728 98.3226302 105.186741 98.3226302 76.6993581"
        />
        <polyline
          id="Fill-725"
          fill="#C7C5BD"
          points="61.3236737 62.4569887 67.4889072 58.8949797 98.3226302 76.6993581 92.1573967 80.2617449 61.3236737 62.4569887"
        />
        <path
          d="M81.2435734,88.0887959 C81.2435734,95.4141662 77.4469682,97.7861945 72.2941628,94.8660195 C66.3253705,91.4811854 62.5967642,86.3434908 62.5967642,79.0188761 C62.5967642,71.6897281 66.7938074,70.1034649 72.0788329,72.7739328 C77.4847454,75.5052219 81.2435734,80.7604035 81.2435734,88.0887959"
          id="Fill-726"
          fill="#8A8B8A"
        />
        <path
          d="M71.5688412,83.9072414 C71.5688412,83.9072414 73.0308175,73.0311953 71.7275053,72.8608203 L71.5688412,83.9072414"
          id="Fill-727"
          fill="#636463"
        />
        <path
          d="M71.8181705,83.7406441 C71.8181705,83.7406441 75.2521149,74.4402836 74.0054684,74.024357 L71.8181705,83.7406441"
          id="Fill-728"
          fill="#636463"
        />
        <path
          d="M71.8181705,83.8199761 C71.8181705,83.8199761 77.3789693,76.7480907 76.3060978,75.9967028 L71.8181705,83.8199761"
          id="Fill-729"
          fill="#636463"
        />
        <path
          d="M71.8899471,83.7784213 C71.8899471,83.7784213 78.9882766,79.0864972 78.1911784,78.0517807 L71.8899471,83.7784213"
          id="Fill-730"
          fill="#636463"
        />
        <path
          d="M72.2714965,83.3972497 C72.2714965,83.3972497 70.8057424,94.2732958 72.1090547,94.4429153 L72.2714965,83.3972497"
          id="Fill-731"
          fill="#636463"
        />
        <path
          d="M72.0221672,83.5630914 C72.0221672,83.5630914 68.5882228,92.860052 69.8310915,93.2797563 L72.0221672,83.5630914"
          id="Fill-732"
          fill="#636463"
        />
        <path
          d="M72.0221672,83.4841371 C72.0221672,83.4841371 66.4613683,90.5556449 67.5342398,91.3074105 L72.0221672,83.4841371"
          id="Fill-733"
          fill="#636463"
        />
        <path
          d="M71.9500128,83.5253142 C71.9500128,83.5253142 64.852061,88.2138383 65.6491593,89.2523326 L71.9500128,83.5253142"
          id="Fill-734"
          fill="#636463"
        />
        <path
          d="M72.8872643,84.4772988 C72.8872643,85.3163297 72.4528269,85.5879475 71.8597254,85.2555085 C71.1755809,84.8667814 70.7449212,84.2774576 70.7449212,83.4350268 C70.7449212,82.595996 71.2288467,82.4112656 71.8332813,82.7172607 C72.4566046,83.0342111 72.8872643,83.634868 72.8872643,84.4772988"
          id="Fill-735"
          fill="#F2F1F0"
        />
      </g>
    </g>
  </svg>
)

export const pageElecriciteImage3 = (
  <svg
    width="70px"
    height="70px"
    viewBox="0 0 128 128"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    aria-hidden="true"
  >
    <g
      id="2.verwarming/verwarming_3.3"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Group" transform="translate(1.600000, 3.200000)">
        <polyline
          id="Fill-187"
          fill="#54A044"
          points="54.4819005 49.5264561 3.65775043e-13 81.1607264 68.6138455 120.777476 124.124599 89.8803534 54.4819005 49.5264561"
        />
        <polyline
          id="Fill-189"
          fill="#9ECB94"
          points="54.4819005 47.839295 3.65775043e-13 79.4735654 68.6138455 119.090315 124.124599 88.1931923 54.4819005 47.839295"
        />
        <polyline
          id="Fill-190"
          fill="#54A044"
          points="0.0315357213 79.4735654 1.49006283 80.3171459 0.0315357213 81.1607264 0.0315357213 79.4735654"
        />
        <polyline
          id="Fill-191"
          fill="#54A044"
          points="124.124599 88.1931923 122.638478 89.021005 124.124599 89.8803534 124.124599 88.1931923"
        />
        <polyline
          id="Fill-2031"
          fill="#F8F7F6"
          points="58.6367317 18.8461412 58.6367317 81.3617667 79.0364014 69.583569 79.0364014 7.06794353 58.6367317 18.8461412"
        />
        <path
          d="M58.6367317,18.7042305 L58.6367317,81.2198559 C62.1056611,80.2501325 66.7098764,78.5432616 71.5584935,75.4212252 C74.6450522,73.4305328 77.1166644,71.3255234 79.0364014,69.445206 L79.0364014,6.92563859 C77.1363742,8.79413007 74.6923558,10.8794296 71.6491587,12.8504122 C66.7729478,16.0118683 62.1253709,17.7305651 58.6367317,18.7042305"
          id="Fill-2032"
          fill="#E4E4E3"
        />
        <polyline
          id="Fill-2033"
          fill="#C7C5BD"
          points="58.6367317 18.8461412 58.6367317 81.3617667 46.8581398 74.4712116 46.8581398 11.9516442 58.6367317 18.8461412"
        />
        <path
          d="M66.7965996,-8.03222223e-14 L79.0364014,7.06794353 C76.7579456,9.21197838 73.6201413,11.7781977 69.5480913,14.1354929 C65.4523895,16.500672 61.6444511,17.9434312 58.6367317,18.8461412 L46.8581398,11.9516442 L66.7965996,-8.03222223e-14"
          id="Fill-2034"
          fill="#C7C5BD"
        />
        <path
          d="M60.9229569,26.682768 C60.9427813,30.4039831 64.6166929,32.3276621 69.126301,30.97951 C73.6359092,29.6352999 77.270401,25.5238302 77.250771,21.8026151 C77.2270394,18.0814 73.5570699,16.157721 69.0474617,17.5058731 C64.5378536,18.8500832 60.8994197,22.9615529 60.9229569,26.682768"
          id="Fill-2035"
          fill="#9E9F9E"
        />
        <polyline
          id="Fill-2036"
          fill="#636463"
          points="66.642863 23.5686155 66.642863 27.7707503 72.5361009 24.2825054 72.5361009 20.025183 66.642863 23.5686155"
        />
        <polyline
          id="Fill-2037"
          fill="#E4E4E3"
          points="50.6227166 76.5368013 50.6227166 59.5548154 32.241333 70.1665856 32.241333 87.1489657 50.6227166 76.5368013"
        />
        <polyline
          id="Fill-2038"
          fill="#9E9F9E"
          points="49.9998861 76.0558816 49.9998861 61.1118917 38.6115487 67.4903855 38.6115487 82.4343754 49.9998861 76.0558816"
        />
        <polyline
          id="Fill-2039"
          fill="#C7C5BD"
          points="28.5674215 68.0458084 32.241333 70.1665856 32.241333 87.1489657 28.5674215 85.0277943 28.5674215 68.0458084"
        />
        <polyline
          id="Fill-2040"
          fill="#C7C5BD"
          points="50.6227166 59.5548154 46.948805 57.4340382 28.5674215 68.0458084 32.241333 70.1665856 50.6227166 59.5548154"
        />
        <path
          d="M38.7495175,74.8338724 C38.7495175,79.2015698 41.0122055,80.6171295 44.0829964,78.8743867 C47.6425909,76.8564947 49.8619173,73.7971355 49.8619173,69.4258904 C49.8619173,65.058193 47.3627114,64.1117271 44.2091393,65.7042811 C40.9885537,67.3323127 38.7495175,70.466175 38.7495175,74.8338724"
          id="Fill-2041"
          fill="#8A8B8A"
        />
        <path
          d="M44.6532635,72.3425504 C44.6532635,72.3425504 43.4933322,65.8580177 44.5226406,65.7559208 L44.6532635,72.3425504"
          id="Fill-2042"
          fill="#636463"
        />
        <path
          d="M44.3668179,72.2443955 C44.3668179,72.2443955 42.3209379,66.7015982 43.0620274,66.4536486 L44.3668179,72.2443955"
          id="Fill-2043"
          fill="#636463"
        />
        <path
          d="M44.3668179,72.2913048 C44.3668179,72.2913048 41.0516252,68.0734021 41.6941655,67.6279601 L44.3668179,72.2913048"
          id="Fill-2044"
          fill="#636463"
        />
        <path
          d="M44.3234562,72.2637111 C44.3234562,72.2637111 40.0937276,69.4688578 40.5667634,68.8499693 L44.3234562,72.2637111"
          id="Fill-2045"
          fill="#636463"
        />
        <path
          d="M44.0987642,72.0390191 C44.0987642,72.0390191 45.2619238,78.520004 44.2250802,78.6221009 L44.0987642,72.0390191"
          id="Fill-2046"
          fill="#636463"
        />
        <path
          d="M44.2446169,72.1379624 C44.2446169,72.1379624 46.2904969,77.6799712 45.5494074,77.9287092 L44.2446169,72.1379624"
          id="Fill-2047"
          fill="#636463"
        />
        <path
          d="M44.2446169,72.0902646 C44.2446169,72.0902646 47.5598096,76.3046196 46.9212113,76.7536094 L44.2446169,72.0902646"
          id="Fill-2048"
          fill="#636463"
        />
        <path
          d="M44.2879786,72.1139164 C44.2879786,72.1139164 48.5216491,74.9087697 48.0446713,75.5276582 L44.2879786,72.1139164"
          id="Fill-2049"
          fill="#636463"
        />
        <path
          d="M43.7282195,72.6815594 C43.7282195,73.182189 43.9883892,73.3438095 44.3431661,73.1471055 C44.7491885,72.9141353 45.0054162,72.5633004 45.0054162,72.0626709 C45.0054162,71.5580993 44.7176528,71.4520605 44.354992,71.6329967 C43.9883892,71.822211 43.7282195,72.1809298 43.7282195,72.6815594"
          id="Fill-2050"
          fill="#F2F1F0"
        />
        <path
          d="M91.4338818,93.3299671 L75.1653916,83.9871155 C75.1653916,83.9871155 72.8356902,82.1422758 72.4848553,79.3399327 C72.1379624,76.5332535 73.084034,75.6616851 73.084034,75.6616851 C73.084034,75.6616851 73.8724271,74.7711951 74.9446416,74.7116714 C75.8552355,74.6604259 76.8564947,75.1614497 76.8564947,75.1614497 C76.8564947,75.1614497 77.495093,75.4488189 77.5463386,75.898203 C77.5463386,75.898203 77.6448877,76.347587 77.4635573,76.5801629 C77.2822269,76.817075 77.0378251,76.9861853 76.8801465,77.025605 C76.7224679,77.0650246 76.478066,77.0531988 76.478066,77.0531988 C76.478066,77.0531988 76.1942445,76.9388818 75.9064811,76.7930291 C75.6187176,76.6432344 75.1929854,76.45402 74.8579184,76.6471763 C74.5267933,76.8442746 74.4716058,77.0334889 74.4716058,77.0334889 C74.4716058,77.0334889 74.2035521,77.3374144 74.2745075,78.1963686 C74.3494049,79.0557171 74.5425611,79.7301873 74.5425611,79.7301873 C74.5425611,79.7301873 74.8579184,80.9360344 75.5241105,81.6262725 C76.1863606,82.3157222 76.5214277,82.5207044 76.5214277,82.5207044 L78.9260264,83.9871155 L92.9318286,92.0563181 C92.9318286,92.0563181 93.2511278,92.2613003 93.3299671,92.5057022 C93.4088064,92.746162 93.4088064,92.9511442 93.4088064,92.9511442 C93.4088064,92.9511442 93.3969805,93.2787215 93.2668956,93.432064 C93.1407528,93.5861948 92.8963509,93.7277114 92.8963509,93.7277114 C92.8963509,93.7277114 92.7189625,93.8223185 92.5100383,93.8380864 C92.3050561,93.8499123 92.0685382,93.7316533 92.0685382,93.7316533 L91.4338818,93.3299671"
          id="Fill-2051"
          fill="#679CC7"
        />
        <path
          d="M81.5474332,79.5602886 C81.8470226,80.2383066 82.3910138,81.1571787 82.6235897,81.5352131 C82.6945451,81.6538663 82.7773264,81.7638471 82.8679916,81.8667324 C83.1123934,82.1343918 83.384389,82.5250406 83.8140632,82.9152951 C83.9402061,83.0292179 84.1175945,83.1790126 84.3462285,83.3449693 L97.867169,91.2363894 C97.867169,91.2363894 98.186074,91.4453135 98.2653075,91.6857734 C98.3441468,91.9301753 98.3441468,92.1312155 98.3441468,92.1312155 C98.3441468,92.1312155 98.3362628,92.4587928 98.206178,92.6121352 C98.0800351,92.7662661 97.8356333,92.9117246 97.8356333,92.9117246 C97.8356333,92.9117246 97.6582448,93.0023898 97.4493207,93.0181576 C97.2403965,93.0343197 97.0034844,92.9160607 97.0034844,92.9160607 L96.3731642,92.5135861 L83.6603266,85.2134608 C83.5420676,85.1302854 83.3765051,85.0005947 83.1794068,84.8389741 C82.8522237,84.5744683 81.7051118,83.5771511 80.672317,81.9613396 C80.2584106,81.3144631 79.7735489,80.2304227 79.6119283,79.8598779 C79.5725087,79.7692127 79.540973,79.6789417 79.5133792,79.5843346 C79.3793524,79.1148465 78.9812139,77.6011319 79.0403434,76.4421942 C79.1152407,75.0506805 79.4030042,74.3967084 79.4030042,74.3967084 C79.4030042,74.3967084 79.8366204,73.4620685 80.4594508,72.9653809 C81.0822813,72.4686933 81.7524154,72.2952468 81.7524154,72.2952468 C81.7524154,72.2952468 82.3082325,72.1415102 83.2779559,72.2952468 C84.2476794,72.4493776 85.2449965,73.0249046 85.2449965,73.0249046 C85.2449965,73.0249046 85.7338002,73.3043899 85.6273672,73.9075106 C85.5248761,74.5145732 85.1858671,74.5977487 85.1858671,74.5977487 C85.1858671,74.5977487 84.9375233,74.8969438 84.4092999,74.7077295 C83.8810766,74.5224571 83.2582461,74.1203767 82.9074112,74.1404807 C82.5605183,74.1562486 82.0125851,74.0064539 81.4764779,74.6095746 C80.9364286,75.212301 80.9482545,76.2100124 80.9482545,76.2100124 C80.9482545,76.2100124 80.9167188,77.60941 81.1295849,78.3106856 C81.2872635,78.838909 81.4252323,79.2334997 81.4843618,79.398668 C81.5040716,79.4538555 81.5237814,79.5051011 81.5474332,79.5602886"
          id="Fill-2052"
          fill="#679CC7"
        />
        <path
          d="M94.9816505,96.9128192 C94.9816505,96.9128192 95.7739855,97.3148997 95.5335256,98.0209056 C95.2891238,98.7261232 94.812146,98.7186335 94.812146,98.7186335 C94.812146,98.7186335 94.4297754,98.7970786 94.1617217,98.6433419 C93.8897261,98.4899995 85.1582733,93.4438899 85.1582733,93.4438899 C85.1582733,93.4438899 84.2989249,92.9314344 84.0860588,93.1916041 C83.8771346,93.4478318 83.7549337,93.9524034 83.7588757,94.5200464 C83.7667596,95.0837474 83.8061793,95.3636269 83.8810766,95.6675524 C83.9599159,95.9706895 84.1333624,96.7472567 84.9966527,97.9933119 C85.8599431,99.2346367 86.5576709,99.443955 86.5576709,99.443955 C86.5576709,99.443955 86.8730282,99.6840207 86.9124478,99.991494 C86.9479255,100.287141 86.892738,100.448762 86.892738,100.448762 C86.892738,100.448762 86.8060148,100.807481 86.5221933,100.949786 C86.2383718,101.095244 85.990028,101.103128 85.990028,101.103128 C85.990028,101.103128 85.757452,101.118896 85.5800636,101.024289 C85.4026752,100.929682 84.7128313,100.582789 84.0505811,99.8259315 C83.384389,99.0651322 82.9783666,98.4423017 82.7576165,98.0090797 C82.5408085,97.5750694 82.2688129,97.0117625 82.14267,96.5150749 C82.0165271,96.0183873 81.9928753,96.037703 81.9022101,95.462176 C81.8115449,94.8866491 81.8706744,94.0233588 81.8706744,94.0233588 C81.8706744,94.0233588 81.910094,93.1841144 82.1860316,92.6752067 C82.4580272,92.1631454 82.6511835,91.9187436 82.8916433,91.7133672 C83.1360452,91.5048372 83.6800364,91.3388805 83.6800364,91.3388805 C83.6800364,91.3388805 84.2476794,91.2091898 84.6970634,91.2880291 C85.1464474,91.3708104 85.5051662,91.5241529 85.5051662,91.5241529 C85.5051662,91.5241529 85.871769,91.6739475 86.0333896,91.757123 C86.1950102,91.8399043 94.9816505,96.9128192 94.9816505,96.9128192"
          id="Fill-2053"
          fill="#679CC7"
        />
        <path
          d="M90.0423681,77.9361989 C90.0423681,77.9361989 89.2382073,81.7244275 85.4263269,81.5352131 C85.4263269,81.5352131 85.5682377,77.4395113 90.0423681,77.9361989"
          id="Fill-2054"
          fill="#408F51"
        />
        <path
          d="M78.5515397,91.5675145 C78.5515397,91.5675145 76.367691,88.7450674 72.7410831,90.8583549 C72.7410831,90.8583549 74.6016906,94.3229481 78.5515397,91.5675145"
          id="Fill-2055"
          fill="#408F51"
        />
        <path
          d="M78.5515397,74.7077295 C78.5515397,74.7077295 79.1783122,71.4634922 74.9919452,70.2024575 C74.9919452,70.2024575 73.8606012,73.8330074 78.5515397,74.7077295"
          id="Fill-2056"
          fill="#408F51"
        />
        <path
          d="M59.4606024,89.9990065 L75.7290927,99.3410698 C75.7290927,99.3410698 78.0587941,101.185909 78.409629,103.989041 C78.7565219,106.79572 77.8104503,107.662558 77.8104503,107.662558 C77.8104503,107.662558 77.0220572,108.557778 75.9498427,108.616514 C75.0392488,108.664212 74.0379896,108.167524 74.0379896,108.167524 C74.0379896,108.167524 73.4033332,107.879366 73.3481457,107.429982 C73.3481457,107.429982 73.2495966,106.980598 73.430927,106.744475 C73.6122574,106.511504 73.8566592,106.338452 74.0143378,106.30258 C74.1720164,106.263161 74.4164183,106.271439 74.4164183,106.271439 C74.4164183,106.271439 74.7002398,106.389303 74.9880032,106.535156 C75.2757667,106.684951 75.7014989,106.874165 76.0365659,106.681009 C76.371633,106.483911 76.4228785,106.290754 76.4228785,106.290754 C76.4228785,106.290754 76.6909322,105.991559 76.6199768,105.131817 C76.5450794,104.26892 76.3519232,103.59445 76.3519232,103.59445 C76.3519232,103.59445 76.0365659,102.392151 75.3703738,101.702701 C74.7081237,101.012463 74.3730566,100.807481 74.3730566,100.807481 L71.9684579,99.3410698 L57.9626557,91.2718671 C57.9626557,91.2718671 57.6472985,91.0629429 57.5645172,90.8224831 C57.4856779,90.5780812 57.4856779,90.377041 57.4856779,90.377041 C57.4856779,90.377041 57.4975038,90.0502521 57.6236467,89.8961212 C57.7537315,89.7427788 57.9981334,89.6004739 57.9981334,89.6004739 C57.9981334,89.6004739 58.1755218,89.5058667 58.384446,89.4900988 C58.5894281,89.4782729 58.829888,89.5969261 58.829888,89.5969261 L59.4606024,89.9990065"
          id="Fill-2927"
          fill="#679CC7"
        />
        <path
          d="M69.3470511,103.767897 C69.0474617,103.089879 68.5034705,102.171795 68.2708946,101.78903 C68.1999392,101.675107 68.1171579,101.564338 68.0264927,101.462241 C67.7820909,101.194188 67.5100953,100.803933 67.0804211,100.413678 C66.9542782,100.298967 66.7768898,100.149173 66.5482558,99.9840043 L53.0273153,92.0917958 C53.0273153,92.0917958 52.7080161,91.8828717 52.6291768,91.638864 C52.5503375,91.39801 52.5503375,91.193422 52.5503375,91.193422 C52.5503375,91.193422 52.5582215,90.8701808 52.6883063,90.71605 C52.8144492,90.5627075 53.058851,90.4168548 53.058851,90.4168548 C53.058851,90.4168548 53.2362395,90.3222477 53.4451636,90.3100276 C53.6540878,90.2946539 53.8906057,90.4125187 53.8906057,90.4125187 L54.5213201,90.8145991 L67.2341577,98.1155128 C67.3524167,98.1978999 67.5179792,98.3240427 67.7150775,98.4856633 C68.0422606,98.753717 69.1893725,99.7510341 70.2221673,101.367634 C70.6360737,102.014116 71.1209354,103.097763 71.282556,103.468307 C71.3219756,103.559367 71.3535113,103.650032 71.3811051,103.744639 C71.5151319,104.213339 71.9132704,105.727053 71.8541409,106.885991 C71.7792436,108.277505 71.4914801,108.932265 71.4914801,108.932265 C71.4914801,108.932265 71.0618059,109.866117 70.4350334,110.362804 C69.812203,110.859492 69.1420689,111.032938 69.1420689,111.032938 C69.1420689,111.032938 68.5862518,111.182733 67.6165284,111.032938 C66.6468049,110.879202 65.6494877,110.304069 65.6494877,110.304069 C65.6494877,110.304069 65.1606841,110.023795 65.2671171,109.420675 C65.3735502,108.814006 65.7086172,108.726889 65.7086172,108.726889 C65.7086172,108.726889 65.956961,108.431241 66.4851844,108.620456 C67.0134077,108.805728 67.6362382,109.207809 67.9870731,109.188493 C68.333966,109.168389 68.8818992,109.32252 69.4180064,108.719399 C69.9580557,108.115884 69.9462298,107.118961 69.9462298,107.118961 C69.9462298,107.118961 69.9777655,105.715227 69.7648994,105.0175 C69.6072208,104.489276 69.469252,104.091138 69.4101225,103.925575 C69.3904127,103.870388 69.3707029,103.823084 69.3470511,103.767897"
          id="Fill-2928"
          fill="#679CC7"
        />
        <path
          d="M55.9128338,86.415366 C55.9128338,86.415366 55.1204988,86.0132856 55.3609587,85.308068 C55.6053605,84.602062 56.0823383,84.6103402 56.0823383,84.6103402 C56.0823383,84.6103402 56.4647089,84.5311067 56.7327626,84.6848433 C57.0047582,84.8389741 65.736211,89.8842953 65.736211,89.8842953 C65.736211,89.8842953 66.5955594,90.3928088 66.8044835,90.1365811 C67.0212916,89.8803534 67.1434925,89.3757818 67.1356086,88.8081389 C67.1277247,88.2404959 67.088305,87.9645583 67.0134077,87.6614212 C66.9345684,87.3574957 66.7611219,86.5809285 65.8978316,85.3356617 C65.0345412,84.0935485 64.3368133,83.8850186 64.3368133,83.8850186 C64.3368133,83.8850186 64.0214561,83.6441645 63.9820365,83.3366912 C63.9465588,83.0410438 64.0017463,82.8794233 64.0017463,82.8794233 C64.0017463,82.8794233 64.0884695,82.5207044 64.372291,82.3791879 C64.6561125,82.232941 64.9044563,82.2211151 64.9044563,82.2211151 C64.9044563,82.2211151 65.1370323,82.2092892 65.3144207,82.3038963 C65.4918091,82.3985035 66.181653,82.7453964 66.8439032,83.5022538 C67.5100953,84.263053 67.9161177,84.8858835 68.1368678,85.3198939 C68.3536758,85.7535101 68.6256714,86.3172111 68.7518143,86.8138987 C68.8779572,87.3105863 68.901609,87.2904823 68.9922742,87.8660092 C69.0829394,88.4415361 69.0238099,89.3048265 69.0238099,89.3048265 C69.0238099,89.3048265 68.9843903,90.1405231 68.7123947,90.6529786 C68.4364571,91.1658282 68.2433008,91.4058939 68.0028409,91.614818 C67.7584391,91.8241364 67.2144479,91.9893047 67.2144479,91.9893047 C67.2144479,91.9893047 66.6468049,92.1197838 66.1974209,92.0366083 C65.7480369,91.957769 65.389318,91.8040324 65.389318,91.8040324 C65.389318,91.8040324 65.0227153,91.6542377 64.8610947,91.5718506 C64.6994741,91.4890694 55.9128338,86.415366 55.9128338,86.415366"
          id="Fill-2929"
          fill="#679CC7"
        />
        <path
          d="M60.8521161,105.391986 C60.8521161,105.391986 61.656277,101.603758 65.4681573,101.792972 C65.4681573,101.792972 65.3262466,105.888674 60.8521161,105.391986"
          id="Fill-2930"
          fill="#408F51"
        />
        <path
          d="M72.3429446,91.7606708 C72.3429446,91.7606708 74.5267933,94.5831178 78.1534012,92.4706187 C78.1534012,92.4706187 76.2927937,89.0056313 72.3429446,91.7606708"
          id="Fill-2931"
          fill="#408F51"
        />
        <path
          d="M72.3429446,108.620456 C72.3429446,108.620456 71.7161721,111.864693 75.9025391,113.126516 C75.9025391,113.126516 77.0338831,109.495966 72.3429446,108.620456"
          id="Fill-2932"
          fill="#408F51"
        />
      </g>
    </g>
  </svg>
)

export const pageElecriciteImage4 = (
  <svg
    width="70px"
    height="70px"
    viewBox="0 0 128 128"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <defs>
      <linearGradient
        x1="49.8009615%"
        y1="13.9522414%"
        x2="49.8009615%"
        y2="99.4443103%"
        id="linearGradient-1"
      >
        <stop stopColor="#479BD2" offset="73.43%" />
        <stop stopColor="#5D9FD3" offset="86.18%" />
        <stop stopColor="#76A5D5" offset="100%" />
      </linearGradient>
    </defs>
    <g
      id="2.verwarming/verwarming_3.4"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="Group-3"
        transform="translate(11.200000, 0.000000)"
        fillRule="nonzero"
      >
        <g id="Group" transform="translate(29.647765, 75.437090)">
          <path
            d="M13.7038557,26.9794659 C13.7038557,26.9794659 26.5841624,25.4970777 29.1536354,31.4266307 C31.7231083,37.3561836 31.5254565,40.2550762 34.6878848,42.066884 C37.8173711,43.8786919 35.2149562,53.1024409 29.1206934,50.7635617 C23.0264306,48.4246825 8.76256159,47.6999593 7.37899923,45.5257899 C5.99543688,43.3516205 0.527071374,36.3349828 4.15068707,33.3702064 C7.77430276,30.4054299 -2.96477648,27.6712471 1.08708471,25.3323679 C5.13894589,22.9934887 13.7038557,26.9794659 13.7038557,26.9794659 Z"
            id="Path"
            fill="#76A5D5"
          />
          <polygon
            id="Path"
            fill="url(#linearGradient-1)"
            points="10.5084855 38.4432683 13.9344494 38.4432683 13.9344494 0.230593726 10.5084855 0.230593726"
          />
        </g>
        <g id="Group" transform="translate(0.000000, 39.530353)">
          <polygon
            id="Path"
            fill="#6DA553"
            points="45.7893256 1.71298196 0.263535687 28.1324346 57.5825476 61.2391052 103.99777 35.4455499"
          />
          <polygon
            id="Path"
            fill="#AECEA0"
            points="45.7893256 0.296477648 0.263535687 26.7488722 57.5825476 59.8555429 103.99777 34.0290456"
          />
          <polygon
            id="Path"
            fill="#6DA553"
            points="0.296477648 26.7488722 1.5153302 27.4406534 0.296477648 28.1324346"
          />
          <polygon
            id="Path"
            fill="#6DA553"
            points="103.99777 34.0290456 102.745976 34.7208267 103.99777 35.4455499"
          />
        </g>
        <g id="Group" transform="translate(39.530353, 0.000000)">
          <g id="Path">
            <polygon
              fill="#F6F6F6"
              points="9.81670434 15.9439091 9.81670434 68.189859 26.8806401 58.3731546 26.8806401 6.12720472"
            />
            <path
              d="M9.81670434,15.8450832 L9.81670434,68.0910331 C12.7155969,67.2674841 16.5698063,65.8509798 20.6216675,63.2485649 C23.1911404,61.6014668 25.266484,59.8226009 26.8806401,58.2413868 L26.8806401,5.99543688 C25.2994259,7.54370904 23.2570244,9.28963296 20.7204934,10.936731 C16.6356902,13.6050298 12.7485389,15.0215342 9.81670434,15.8450832 Z"
              fill="#E6E7E8"
            />
            <polygon
              fill="#CCCAC7"
              points="9.81670434 15.9439091 9.81670434 68.189859 0 62.4579578 0 10.2120079"
            />
            <path
              d="M16.6356902,0.197651765 L26.8476981,6.09426276 C24.9370644,7.87312865 22.3346495,10.0472981 18.9086855,11.9908738 C15.4827216,13.9673914 12.2873514,15.186244 9.78376238,15.9439091 L0,10.2120079 L16.6356902,0.197651765 Z"
              fill="#CCCAC7"
            />
          </g>
          <ellipse
            id="Oval"
            fill="#A7A9AB"
            transform="translate(18.512983, 20.439574) rotate(-34.360683) translate(-18.512983, -20.439574) "
            cx="18.5129834"
            cy="20.4395742"
            rx="7.47781618"
            ry="5.13893975"
          />
          <polygon
            id="Path"
            fill="#6D6E71"
            points="16.5368644 19.8969444 16.5368644 23.4217342 21.4452165 20.4898997 21.4452165 16.9321679"
          />
        </g>
        <g id="Group-2" transform="translate(24.245283, 48.194089)">
          <polygon
            id="Path"
            fill="#E6E7E8"
            points="18.4145561 15.976851 18.4145561 1.77886589 3.06360236 10.6402534 3.06360236 24.8382385"
          />
          <polygon
            id="Path"
            fill="#A7A9AB"
            points="17.8874847 15.5815475 17.8874847 3.09654432 8.36725806 8.40020002 8.36725806 20.9181451"
          />
          <polygon
            id="Path"
            fill="#CCCAC7"
            points="0 8.89432943 3.06360236 10.6402534 3.06360236 24.8382385 0 23.0593726"
          />
          <polygon
            id="Path"
            fill="#CCCAC7"
            points="18.4145561 1.77886589 15.3509538 -2.02109934e-13 1.34739956e-13 8.89432943 3.06360236 10.6402534"
          />
          <path
            d="M8.4990259,14.5603467 C8.4990259,18.2169044 10.3767177,19.4028149 12.9461906,17.9204267 C15.9109671,16.2403867 17.7886589,13.6709138 17.7886589,10.0143561 C17.7886589,6.35779845 15.7133153,5.56719139 13.0779585,6.91781178 C10.3767177,8.30137414 8.4990259,10.903789 8.4990259,14.5603467 Z"
            id="Path"
            fill="#949598"
          />
          <path
            d="M13.4400813,12.4850032 C13.4400813,12.4850032 12.4370816,7.08252159 13.3488996,6.9836957 L13.4400813,12.4850032 Z"
            id="Path"
            fill="#6D6E71"
          />
          <path
            d="M13.1767843,12.3861773 C13.1767843,12.3861773 11.4638024,7.7413608 12.0896996,7.54370904 L13.1767843,12.3861773 Z"
            id="Path"
            fill="#6D6E71"
          />
          <path
            d="M13.1767843,12.4191192 C13.1767843,12.4191192 10.4096596,8.89432943 10.936731,8.53196786 L13.1767843,12.4191192 Z"
            id="Path"
            fill="#6D6E71"
          />
          <path
            d="M13.1438424,12.4191192 C13.1438424,12.4191192 9.61905257,10.08024 10.0143561,9.55316865 L13.1438424,12.4191192 Z"
            id="Path"
            fill="#6D6E71"
          />
          <path
            d="M12.9791326,12.2214675 C12.9791326,12.2214675 13.9821323,17.6239491 13.0703144,17.7227749 L12.9791326,12.2214675 Z"
            id="Path"
            fill="#6D6E71"
          />
          <path
            d="M13.0779585,12.2873514 C13.0779585,12.2873514 14.7909404,16.9321679 14.1650432,17.1298196 L13.0779585,12.2873514 Z"
            id="Path"
            fill="#6D6E71"
          />
          <path
            d="M13.0779585,12.2544094 C13.0779585,12.2544094 15.8450832,15.7791993 15.3180118,16.1415608 L13.0779585,12.2544094 Z"
            id="Path"
            fill="#6D6E71"
          />
          <path
            d="M13.1109004,12.2873514 C13.1109004,12.2873514 16.6356902,14.6262306 16.2403867,15.153302 L13.1109004,12.2873514 Z"
            id="Path"
            fill="#6D6E71"
          />
          <path
            d="M12.649713,12.7485389 C12.649713,13.1767843 12.8803067,13.3085522 13.1767843,13.1438424 C13.506204,12.9461906 13.7367977,12.649713 13.7367977,12.2214675 C13.7367977,11.793222 13.506204,11.7273381 13.2097263,11.8591059 C12.8803067,12.0238157 12.649713,12.3202934 12.649713,12.7485389 Z"
            id="Path"
            fill="#F1F2F2"
          />
        </g>
        <g id="Group" transform="translate(60.613208, 58.636690)">
          <path
            d="M16.1415608,19.5675248 L2.53653099,11.76028 C2.53653099,11.76028 0.592955296,10.2120079 0.296477648,7.87312865 C-1.4974133e-13,5.53424942 0.790607061,4.80952629 0.790607061,4.80952629 C0.790607061,4.80952629 1.44944628,4.05186119 2.33887922,4.01891923 C3.09654432,3.98597726 3.92009334,4.38128079 3.92009334,4.38128079 C3.92009334,4.38128079 4.44716472,4.61187452 4.48010668,5.00717805 C4.48010668,5.00717805 4.57893256,5.36953962 4.41422276,5.56719139 C4.24951295,5.76484315 4.05186119,5.89661099 3.92009334,5.92955296 C3.7883255,5.96249492 3.59067373,5.96249492 3.59067373,5.96249492 C3.59067373,5.96249492 3.36008001,5.86366903 3.09654432,5.73190119 C2.8659506,5.60013335 2.50358903,5.43542354 2.20711138,5.60013335 C1.94357569,5.76484315 1.87769177,5.92955296 1.87769177,5.92955296 C1.87769177,5.92955296 1.64709804,6.19308864 1.71298196,6.88486982 C1.77886589,7.576651 1.94357569,8.16960629 1.94357569,8.16960629 C1.94357569,8.16960629 2.20711138,9.19080708 2.76712471,9.75082042 C3.32713805,10.3108338 3.59067373,10.5084855 3.59067373,10.5084855 L5.60013335,11.7273381 L17.2945295,18.48044 C17.2945295,18.48044 17.5580651,18.6451498 17.6239491,18.8428016 C17.689833,19.0404534 17.689833,19.2051632 17.689833,19.2051632 C17.689833,19.2051632 17.689833,19.4686989 17.5580651,19.6004667 C17.4592393,19.7322346 17.2615875,19.8640024 17.2615875,19.8640024 C17.2615875,19.8640024 17.0968777,19.9298863 16.9321679,19.9628283 C16.7674581,19.9628283 16.5698063,19.8640024 16.5698063,19.8640024 L16.1415608,19.5675248 Z"
            id="Path"
            fill="#76A5D5"
          />
          <path
            d="M7.90607061,8.07078041 C8.16960629,8.63079375 8.59785179,9.42140081 8.79550355,9.71787845 C8.86138747,9.81670434 8.92727139,9.91553022 8.99315532,9.98141414 C9.19080708,10.2120079 9.42140081,10.5414275 9.78376238,10.8708471 C9.88258826,10.969673 10.0472981,11.1014408 10.2120079,11.2332087 L21.5111004,17.8216008 C21.5111004,17.8216008 21.7746361,17.9863106 21.8405201,18.1839624 C21.906404,18.3816142 21.906404,18.546324 21.906404,18.546324 C21.906404,18.546324 21.906404,18.8098597 21.7746361,18.9416275 C21.6758102,19.0733953 21.4781585,19.2051632 21.4781585,19.2051632 C21.4781585,19.2051632 21.3134487,19.2710471 21.1487389,19.3039891 C20.9840291,19.3039891 20.7863773,19.2051632 20.7863773,19.2051632 L20.2593059,18.8757436 L9.65199453,12.7814808 C9.55316865,12.7155969 9.42140081,12.616771 9.256691,12.4850032 C8.99315532,12.2544094 8.03783845,11.4308604 7.14840551,10.08024 C6.78604394,9.55316865 6.39074041,8.63079375 6.25897256,8.3343161 C6.2260306,8.26843218 6.19308864,8.16960629 6.19308864,8.10372237 C6.09426276,7.70841884 5.73190119,6.45662433 5.79778511,5.4683655 C5.86366903,4.31539687 6.09426276,3.75538354 6.09426276,3.75538354 C6.09426276,3.75538354 6.45662433,2.96477648 6.9836957,2.56947295 C7.51076708,2.14122746 8.07078041,2.00945961 8.07078041,2.00945961 C8.07078041,2.00945961 8.53196786,1.87769177 9.35551689,2.00945961 C10.1790659,2.14122746 11.0026149,2.60241491 11.0026149,2.60241491 C11.0026149,2.60241491 11.3979185,2.83300863 11.3320345,3.32713805 C11.2332087,3.82126746 10.969673,3.92009334 10.969673,3.92009334 C10.969673,3.92009334 10.7720212,4.18362903 10.3108338,4.01891923 C9.88258826,3.85420942 9.35551689,3.52478981 9.05903924,3.55773177 C8.76256159,3.59067373 8.30137414,3.45890589 7.87312865,3.9530353 C7.41194119,4.44716472 7.44488315,5.3036557 7.44488315,5.3036557 C7.44488315,5.3036557 7.41194119,6.48956629 7.60959296,7.04957962 C7.7413608,7.47782512 7.87312865,7.80724472 7.90607061,7.97195453 C7.84018669,7.97195453 7.87312865,8.00489649 7.90607061,8.07078041 Z"
            id="Path"
            fill="#76A5D5"
          />
          <path
            d="M19.1063373,22.5652432 C19.1063373,22.5652432 19.7651765,22.8946628 19.5675248,23.4876181 C19.369873,24.0805734 18.9745695,24.0805734 18.9745695,24.0805734 C18.9745695,24.0805734 18.6451498,24.1464573 18.4145561,24.0146895 C18.1839624,23.8829216 10.903789,19.6663506 10.903789,19.6663506 C10.903789,19.6663506 10.1790659,19.2381051 10.0143561,19.4686989 C9.8496463,19.6992926 9.71787845,20.0945961 9.75082042,20.5887255 C9.78376238,21.082855 9.78376238,21.2805067 9.8496463,21.5440424 C9.91553022,21.8075781 10.0472981,22.4334753 10.7720212,23.4876181 C11.4967443,24.5417608 12.0896996,24.7064706 12.0896996,24.7064706 C12.0896996,24.7064706 12.3532353,24.9041224 12.3861773,25.1676581 C12.4191192,25.3982518 12.3861773,25.5629616 12.3861773,25.5629616 C12.3861773,25.5629616 12.3202934,25.8594393 12.0896996,25.9912071 C11.8591059,26.122975 11.6614541,26.122975 11.6614541,26.122975 C11.6614541,26.122975 11.4638024,26.122975 11.3320345,26.057091 C11.2002667,25.9912071 10.6073114,25.6947295 10.0472981,25.0688322 C9.48728473,24.442935 9.15786512,23.9158636 8.96021335,23.553502 C8.76256159,23.1911404 8.56490982,22.729953 8.43314198,22.3017075 C8.3343161,21.873462 8.30137414,21.906404 8.23549022,21.4122746 C8.16960629,20.9181451 8.20254825,20.226364 8.20254825,20.226364 C8.20254825,20.226364 8.23549022,19.5345828 8.46608394,19.1063373 C8.69667767,18.6780918 8.86138747,18.48044 9.05903924,18.3157302 C9.256691,18.1510204 9.71787845,17.9863106 9.71787845,17.9863106 C9.71787845,17.9863106 10.1790659,17.8874847 10.5743694,17.9533687 C10.936731,18.0192526 11.2661506,18.1510204 11.2661506,18.1510204 C11.2661506,18.1510204 11.5626283,18.2827883 11.6943961,18.3486722 C11.76028,18.3157302 19.1063373,22.5652432 19.1063373,22.5652432 Z"
            id="Path"
            fill="#76A5D5"
          />
          <path
            d="M14.9885922,6.68721806 C14.9885922,6.68721806 14.329753,9.8496463 11.1343828,9.68493649 C11.1343828,9.71787845 11.2661506,6.29191452 14.9885922,6.68721806 Z"
            id="Path"
            fill="#58945B"
          />
          <path
            d="M5.40248158,18.0851365 C5.40248158,18.0851365 3.59067373,15.7133153 0.560013335,17.4921812 C0.527071374,17.4921812 2.07534353,20.3910738 5.40248158,18.0851365 Z"
            id="Path"
            fill="#58945B"
          />
          <path
            d="M5.40248158,4.01891923 C5.40248158,4.01891923 5.92955296,1.31767843 2.4377051,0.263535687 C2.40476314,0.230593726 1.48238824,3.26125413 5.40248158,4.01891923 Z"
            id="Path"
            fill="#58945B"
          />
        </g>
      </g>
    </g>
  </svg>
)

export const pageElecriciteImage5 = (
  <svg
    width="70px"
    height="70px"
    viewBox="0 0 128 128"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    aria-hidden="true"
  >
    <defs>
      <linearGradient
        x1="50.000917%"
        y1="55.7404016%"
        x2="50.0195564%"
        y2="94.5043373%"
        id="linearGradient-1"
      >
        <stop stopColor="#E48F3E" offset="78.63%" />
        <stop stopColor="#DD9147" offset="80.91%" />
        <stop stopColor="#CB9664" offset="85.58%" />
        <stop stopColor="#AB9D93" offset="92.22%" />
        <stop stopColor="#76A5D5" offset="100%" />
      </linearGradient>
      <linearGradient
        x1="50%"
        y1="13.9682096%"
        x2="50%"
        y2="99.4788646%"
        id="linearGradient-2"
      >
        <stop stopColor="#479BD2" offset="73.43%" />
        <stop stopColor="#5D9FD3" offset="86.18%" />
        <stop stopColor="#76A5D5" offset="100%" />
      </linearGradient>
    </defs>
    <g
      id="2.verwarming/verwarming_3.5"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="Group-2"
        transform="translate(6.400000, 0.000000)"
        fillRule="nonzero"
      >
        <g id="Group" transform="translate(39.490823, 64.750718)">
          <path
            d="M14.7290095,35.612895 C14.7290095,35.612895 28.4618542,34.0119158 31.2013077,40.3802556 C33.9407611,46.7130182 33.7272972,49.7726675 37.0715651,51.72942 C40.4158329,53.6505951 37.6408022,63.5055122 31.130153,60.9795226 C24.6195039,58.453533 9.4279892,57.7064094 7.93374185,55.3938837 C6.43949451,53.0813581 0.640391719,45.6101213 4.51831935,42.4437401 C8.39624698,39.2773588 -3.05964932,36.3600187 1.24520612,33.8696065 C5.6212162,31.3791942 14.7290095,35.612895 14.7290095,35.612895 Z"
            id="Path"
            fill="#76A5D5"
          />
          <g transform="translate(11.028968, 0.000000)">
            <rect
              id="Rectangle"
              fill="url(#linearGradient-1)"
              x="10.9222365"
              y="0.0355773177"
              width="3.66446373"
              height="44.2937606"
            />
            <polygon
              id="Path"
              fill="url(#linearGradient-2)"
              points="0.284618542 47.815915 3.94908227 47.815915 3.94908227 7.07988623 0.284618542 7.07988623"
            />
          </g>
        </g>
        <g id="Group" transform="translate(0.000000, 28.461854)">
          <polygon
            id="Path"
            fill="#6DA553"
            points="49.488049 1.77886589 0.32019586 30.3118747 62.2247287 66.067079 112.353169 38.1744619"
          />
          <polygon
            id="Path"
            fill="#AECEA0"
            points="49.488049 0.249041224 0.32019586 28.78205 62.2247287 64.5372544 112.353169 36.6446373"
          />
          <polygon
            id="Path"
            fill="#6DA553"
            points="0.355773177 28.78205 1.67213393 29.564751 0.355773177 30.3118747"
          />
          <polygon
            id="Path"
            fill="#6DA553"
            points="112.353169 36.6446373 111.001231 37.3917609 112.353169 38.1744619"
          />
        </g>
        <g id="Group" transform="translate(41.269689, 0.000000)">
          <g id="Path">
            <polygon
              fill="#F6F6F6"
              points="10.9578139 17.0059579 10.9578139 73.4315838 29.3512871 62.7939658 29.3512871 6.36833987"
            />
            <path
              d="M10.9578139,16.8636486 L10.9578139,73.2892745 C14.0886178,72.3998416 18.251164,70.8700169 22.6271741,68.0594088 C25.4022049,66.2805429 27.6435759,64.3593678 29.3868644,62.6516565 L29.3868644,6.26160792 C27.6791532,7.93374185 25.4733595,9.81933969 22.733906,11.5982056 C18.2867413,14.444391 14.0886178,16.009793 10.9578139,16.8636486 Z"
              fill="#E6E7E8"
            />
            <polygon
              fill="#CCCAC7"
              points="10.9578139 17.0059579 10.9578139 73.4315838 0.32019586 67.2055532 0.32019586 10.7799273"
            />
            <path
              d="M18.3223186,0 L29.3512871,6.36833987 C27.2878027,8.28951503 24.4771946,10.637618 20.7771536,12.7366797 C17.0771125,14.8713188 13.6261127,16.1876796 10.9222365,17.0059579 L0.284618542,10.7799273 L18.3223186,0 Z"
              fill="#CCCAC7"
            />
          </g>
          <ellipse
            id="Oval"
            fill="#A7A9AB"
            transform="translate(20.359138, 21.841424) rotate(-34.360683) translate(-20.359138, -21.841424) "
            cx="20.3591379"
            cy="21.8414241"
            rx="8.07604147"
            ry="5.55005493"
          />
          <polygon
            id="Path"
            fill="#6D6E71"
            points="18.1800094 21.275236 18.1800094 25.0464317 23.4810297 21.9156277 23.4810297 18.0732774"
          />
        </g>
      </g>
    </g>
  </svg>
)
export const pageElecriciteImage6 = (
  <svg
    width="70px"
    height="70px"
    viewBox="0 0 128 128"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <defs>
      <linearGradient
        x1="18.5955436%"
        y1="62.5162337%"
        x2="91.2181445%"
        y2="33.0990687%"
        id="linearGradient-1"
      >
        <stop stopColor="#479BD2" offset="5.747209%" />
        <stop stopColor="#5C9AC4" offset="15.83%" />
        <stop stopColor="#8299A6" offset="36.4%" />
        <stop stopColor="#B19578" offset="65.67%" />
        <stop stopColor="#E48F3E" offset="100%" />
      </linearGradient>
    </defs>
    <g
      id="icon/warmtepomp/bodem-water"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="Group-2"
        transform="translate(6.400000, 0.000000)"
        fillRule="nonzero"
      >
        <g id="Group" transform="translate(46.606286, 64.394945)">
          <g transform="translate(12.807834, 0.000000)">
            <polygon
              id="Rectangle"
              fill="#E48F3E"
              points="0.298666667 2.77503078 4.23370081 2.77503078 4.23370081 50.8755644 0.298666667 50.8755644"
            />
            <ellipse
              id="Oval"
              fill="#479BD2"
              cx="2.688"
              cy="2.77503078"
              rx="2.38933333"
              ry="2.56156688"
            />
          </g>
          <rect
            id="Rectangle"
            fill="#479BD2"
            transform="translate(2.243684, 33.814106) rotate(-180.000000) translate(-2.243684, -33.814106) "
            x="0.25135375"
            y="11.7028029"
            width="3.98465959"
            height="44.2226059"
          />
          <path
            d="M0.284618542,55.9275435 L4.26927813,55.9275435 C4.26927813,56.1410074 4.30485545,57.101595 5.08755644,57.8487186 C5.83468011,58.5246877 6.97315428,58.7025743 7.96931917,58.2756464 L7.96931917,58.2756464 L10.8510819,56.8881311 C11.3491644,56.3900486 12.1674427,55.3938837 12.6655251,53.9352137 C13.0924529,52.6544302 13.0924529,51.5515334 13.0568756,50.8755644 C14.3732364,50.8755644 15.7251744,50.8755644 17.0415352,50.8755644 C17.0415352,52.2630797 16.8280713,54.0063683 16.0809476,55.9275435 C15.5472878,57.2794815 14.8357415,59.0227701 13.1280302,59.9477804 C13.0212983,59.9833577 12.9501437,60.018935 12.9145663,60.0545123 L7.93374185,63.043007 L7.93374185,63.043007 L7.93374185,63.043007 L7.93374185,63.043007 L7.93374185,63.043007 C7.54239136,63.0785843 4.76736058,63.3632029 2.52598956,61.2997185 C0.177886589,59.1650794 0.249041224,56.318894 0.284618542,55.9275435 Z"
            id="Path"
            fill="url(#linearGradient-1)"
          />
        </g>
        <g id="Group" transform="translate(0.000000, 33.442679)">
          <polygon
            id="Path"
            fill="#6DA553"
            points="49.2745851 1.74328857 0.106731953 30.2762974 62.0468421 66.0315017 112.139705 38.1388846"
          />
          <polygon
            id="Path"
            fill="#AECEA0"
            points="49.2745851 0.213463906 0.106731953 28.7464727 62.0468421 64.501677 112.139705 36.6446373"
          />
          <polygon
            id="Path"
            fill="#6DA553"
            points="0.142309271 28.7464727 1.45867003 29.5291737 0.142309271 30.2762974"
          />
          <polygon
            id="Path"
            fill="#6DA553"
            points="112.139705 36.6446373 110.787767 37.3917609 112.139705 38.1388846"
          />
        </g>
        <g id="Group" transform="translate(39.490823, 0.000000)">
          <g id="Path">
            <polygon
              fill="#F6F6F6"
              points="10.74435 17.2549991 10.74435 73.680625 29.1378232 63.0785843 29.1378232 6.65295842"
            />
            <path
              d="M10.74435,17.1482671 L10.74435,73.5738931 C13.8751539,72.6844601 18.0377001,71.1546355 22.4137102,68.3440274 C25.188741,66.5651615 27.430112,64.6439863 29.1734005,62.9362751 L29.1734005,6.51064914 C27.4656893,8.18278308 25.2598956,10.0683809 22.5204421,11.8472468 C18.0732774,14.7290095 13.9107312,16.2588342 10.74435,17.1482671 Z"
              fill="#E6E7E8"
            />
            <polygon
              fill="#CCCAC7"
              points="10.74435 17.2549991 10.74435 73.680625 0.106731953 67.4901717 0.106731953 11.0645458"
            />
            <path
              d="M18.1088547,0.249041224 L29.1378232,6.6173811 C27.0743388,8.53855626 24.2637307,10.8866592 20.5636896,12.985721 C16.8636486,15.12036 13.4126488,16.4367208 10.7087726,17.2549991 L0.0711546355,11.0289685 L18.1088547,0.249041224 Z"
              fill="#CCCAC7"
            />
          </g>
          <ellipse
            id="Oval"
            fill="#A7A9AB"
            transform="translate(20.130867, 22.095478) rotate(-34.360683) translate(-20.130867, -22.095478) "
            cx="20.1308667"
            cy="22.0954782"
            rx="8.07604147"
            ry="5.55005493"
          />
          <polygon
            id="Path"
            fill="#6D6E71"
            points="17.9665455 21.5242772 17.9665455 25.3310502 23.3031431 22.1646689 23.3031431 18.3223186"
          />
        </g>
      </g>
    </g>
  </svg>
)
export const pageAndreBronImage1 = (
  <svg
    width="70px"
    height="70px"
    viewBox="0 0 128 128"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    aria-hidden="true"
  >
    <g
      id="2.verwarming/verwarming_4.1"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Group" transform="translate(1.600000, 6.400000)">
        <polygon
          id="Fill-1026"
          fill="#E67848"
          points="36.1783389 64.4688056 40.4659254 64.4688056 40.4659254 44.8032315 36.1783389 44.8032315"
        />
        <path
          d="M36.1783389,44.8032315 C36.1783389,46.3182178 37.1379277,47.5462925 38.3224247,47.5462925 C39.5066291,47.5462925 40.4662179,46.3182178 40.4662179,44.8032315 C40.4662179,43.2879529 39.5066291,42.0598781 38.3224247,42.0598781 C37.1379277,42.0598781 36.1783389,43.2879529 36.1783389,44.8032315"
          id="Fill-1027"
          fill="#E67848"
        />
        <path
          d="M42.8319946,70.9379138 C42.305844,70.394215 41.4284389,69.3410364 40.8932217,67.7619996 C40.428197,66.3871057 40.4164983,65.19091 40.4662179,64.4685131 C39.0360475,64.4685131 37.6088018,64.4685131 36.1783389,64.4685131 C36.1903301,65.9484032 36.4096814,67.8611464 37.2107523,69.9025757 C37.7901322,71.3766163 38.5563994,73.2542634 40.4015824,74.2372496 C40.5010216,74.2928186 40.5861299,74.3337642 40.6446236,74.3600863 C41.3757946,73.2191671 42.1040408,72.0785405 42.8319946,70.9379138"
          id="Fill-1028"
          fill="#E67848"
        />
        <polyline
          id="Fill-1029"
          fill="#E67848"
          points="42.8319946 70.9379138 105.025689 106.645379 105.110212 111.804813 40.6446236 74.3600863"
        />
        <polygon
          id="Fill-1030"
          fill="#E67848"
          points="109.040987 104.133075 113.328574 104.133075 113.328574 84.4675011 109.040987 84.4675011"
        />
        <path
          d="M109.040987,104.133075 L113.328866,104.133075 C113.349339,104.55423 113.442929,107.630997 110.95373,109.915175 C108.517469,112.152851 105.543358,111.854533 105.110212,111.804813 C105.081258,110.084807 105.052011,108.365093 105.025689,106.645379 C106.113671,107.101629 107.336189,106.923224 108.143402,106.186203 C108.994485,105.411454 109.038355,104.34687 109.040987,104.133075"
          id="Fill-1031"
          fill="#E67848"
        />
        <polygon
          id="Fill-1032"
          fill="#E67848"
          points="53.0014128 49.821989 57.4355259 49.821989 57.4355259 29.489587 53.0014128 29.489587"
        />
        <path
          d="M57.4352335,29.489587 C57.4352335,31.0540004 56.440841,32.3236057 55.2183231,32.3236057 C53.9958053,32.3236057 53.0014128,31.0540004 53.0014128,29.489587 C53.0014128,27.921664 53.9958053,26.6523512 55.2183231,26.6523512 C56.440841,26.6523512 57.4352335,27.921664 57.4352335,29.489587"
          id="Fill-1033"
          fill="#E67848"
        />
        <path
          d="M50.5563771,56.5078162 C51.0974436,55.9462769 52.0070203,54.8580021 52.5597855,53.2260285 C53.0423584,51.8046322 53.0540571,50.5674909 53.0014128,49.821989 C54.4780856,49.821989 55.9579757,49.821989 57.4352335,49.821989 C57.4235347,51.3515986 57.1954094,53.3283924 56.3647992,55.4403066 C55.7681637,56.9640669 54.9755744,58.9028398 53.068388,59.9206298 C52.9633919,59.9761988 52.8756514,60.020069 52.8171577,60.0466837 C52.0625893,58.8677436 51.3077284,57.6893885 50.5563771,56.5078162"
          id="Fill-1034"
          fill="#E67848"
        />
        <polyline
          id="Fill-1035"
          fill="#E67848"
          points="50.5563771 56.5078162 27.9836673 68.9345053 27.8959268 74.2694211 52.8171577 60.0466837"
        />
        <polygon
          id="Fill-1036"
          fill="#E67848"
          points="19.3967956 66.3376786 23.8303238 66.3376786 23.8303238 46.0023519 19.3967956 46.0023519"
        />
        <path
          d="M23.8303238,66.3373861 L19.3967956,66.3373861 C19.3763228,66.7734565 19.2798083,69.9555125 21.85353,72.3154398 C24.3713903,74.6291572 27.4484502,74.3220654 27.8959268,74.2694211 C27.9251737,72.4909209 27.9544205,70.7127131 27.9836673,68.9345053 C26.8576641,69.4056719 25.5942006,69.2211244 24.7577411,68.4577819 C23.8803359,67.6593432 23.833541,66.5567374 23.8303238,66.3373861"
          id="Fill-1037"
          fill="#E67848"
        />
        <polygon
          id="Fill-1038"
          fill="#2A90C3"
          points="27.5508141 68.9023338 31.8384006 68.9023338 31.8384006 49.2338351 27.5508141 49.2338351"
        />
        <path
          d="M27.5508141,49.2338351 C27.5508141,50.7491138 28.5101104,51.9771885 29.6946074,51.9771885 C30.8791043,51.9771885 31.8384006,50.7491138 31.8384006,49.2338351 C31.8384006,47.7191413 30.8791043,46.4907741 29.6946074,46.4907741 C28.5101104,46.4907741 27.5508141,47.7191413 27.5508141,49.2338351"
          id="Fill-1039"
          fill="#2A90C3"
        />
        <path
          d="M34.2041774,75.3688098 C33.680659,74.8280357 32.8006216,73.7751495 32.2654044,72.1926031 C31.8003797,70.8209264 31.788681,69.6250232 31.8384006,68.9023338 C30.4082302,68.9023338 28.9809845,68.9023338 27.5508141,68.9023338 C27.5625129,70.3792991 27.7818641,72.2920424 28.5861522,74.3366888 C29.1652396,75.8107295 29.9315068,77.6854518 31.7740576,78.6707778 C31.8764215,78.7237146 31.9612373,78.7643677 32.019731,78.7906898 C32.7479773,77.6503556 33.4762236,76.5094365 34.2041774,75.3688098"
          id="Fill-1040"
          fill="#2A90C3"
        />
        <polyline
          id="Fill-1041"
          fill="#2A90C3"
          points="34.2041774 75.3688098 96.3978714 111.076567 96.4826872 116.235417 32.019731 78.7906898"
        />
        <polygon
          id="Fill-1042"
          fill="#2A90C3"
          points="100.416387 108.564264 104.701049 108.564264 104.701049 88.8986896 100.416387 88.8986896"
        />
        <path
          d="M100.416387,108.564264 L104.701049,108.564264 C104.721522,108.98805 104.815111,112.064818 102.326206,114.348996 C99.8928686,116.583454 96.915248,116.288061 96.4826872,116.235417 C96.4531479,114.515995 96.4271182,112.795989 96.3978714,111.076567 C97.4858538,111.532818 98.7080792,111.35412 99.5185091,110.617392 C100.366667,109.844983 100.410538,108.777473 100.416387,108.564264"
          id="Fill-1043"
          fill="#2A90C3"
        />
        <polygon
          id="Fill-1044"
          fill="#2A90C3"
          points="46.8797571 61.324478 51.398686 61.324478 51.398686 40.6001684 46.8797571 40.6001684"
        />
        <path
          d="M44.3852942,68.141916 C44.9409842,67.568678 45.8651842,66.4602228 46.4296482,64.7960777 C46.9207026,63.3486517 46.9326938,62.088113 46.8797571,61.324478 C48.3862617,61.324478 49.8924739,61.324478 51.398686,61.324478 C51.3866948,62.8833345 51.1559373,64.9016588 50.3104112,67.051009 C49.6994447,68.6072332 48.892232,70.5813948 46.9473173,71.6193651 C46.8417362,71.6781512 46.7513634,71.7188043 46.6899451,71.7480512 C45.9233855,70.5462986 45.1544861,69.3442535 44.3852942,68.141916"
          id="Fill-1045"
          fill="#2A90C3"
        />
        <polyline
          id="Fill-1046"
          fill="#2A90C3"
          points="44.3852942 68.141916 21.9968395 79.8815969 21.9061743 85.3185841 46.6899451 71.7480512"
        />
        <polygon
          id="Fill-1047"
          fill="#2A90C3"
          points="13.2458931 77.234758 17.7616049 77.234758 17.7616049 56.5104484 13.2458931 56.5104484"
        />
        <path
          d="M17.7618974,77.2350505 L13.2458931,77.2350505 C13.2227881,77.6796024 13.1262735,80.9230768 15.7467902,83.3300916 C18.3146626,85.6873868 21.4499237,85.3712284 21.9061743,85.3185841 C21.9351287,83.5082048 21.9675927,81.6951933 21.9968395,79.8815969 C20.8474388,80.3615375 19.5605779,80.1740653 18.7065702,79.3993165 C17.811617,78.5830373 17.7674543,77.4602512 17.7618974,77.2350505"
          id="Fill-1048"
          fill="#2A90C3"
        />
        <polyline
          id="Fill-1049"
          fill="#F8F7F6"
          points="47.999911 44.8234119 63.9865252 35.7952054 64.1529397 12.409141 55.9930719 9.3002021 48.0820946 20.5368374 47.999911 44.8234119"
        />
        <polyline
          id="Fill-1050"
          fill="#E4E4E3"
          points="48.0031281 44.8234119 32.0168063 35.8887952 32.0168063 11.7920327 48.1639857 21.613121 48.0031281 44.8234119"
        />
        <polyline
          id="Fill-1051"
          fill="#B4B5B4"
          points="40.1357286 1.76031233e-13 32.1367184 11.3506979 48.0820946 20.5368374 55.9930719 9.3002021 40.1357286 1.76031233e-13"
        />
        <polyline
          id="Fill-1052"
          fill="#9E9F9E"
          points="40.1357286 5.95939069e-14 47.8802914 2.51201094 64.1529397 12.409141 55.9930719 9.3002021 40.1357286 5.95939069e-14"
        />
        <polyline
          id="Fill-1053"
          fill="#E4E4E3"
          points="50.6496745 29.147399 54.7208344 26.7985854 54.7208344 40.983302 50.6496745 43.2472998 50.6496745 29.147399"
        />
        <polyline
          id="Fill-1054"
          fill="#E4E4E3"
          points="57.4495644 25.567586 61.158356 23.4267175 61.158356 31.2093011 57.4495644 33.4961114 57.4495644 25.567586"
        />
        <polyline
          id="Fill-1055"
          fill="#FFFFFE"
          points="45.6926279 29.0125711 41.9841288 26.8717025 41.9841288 34.6542862 45.6926279 36.9384643 45.6926279 29.0125711"
        />
        <polyline
          id="Fill-1056"
          fill="#FFFFFE"
          points="38.55055 25.567586 34.8420509 23.4267175 34.8420509 31.2093011 38.55055 33.4961114 38.55055 25.567586"
        />
        <polyline
          id="Fill-1057"
          fill="#F8F7F6"
          points="31.9729361 53.8200318 48.0820946 44.8175625 48.0820946 20.5368374 40.0275153 18.024534 32.1367184 30.4342599 31.9729361 53.8200318"
        />
        <polyline
          id="Fill-1058"
          fill="#E4E4E3"
          points="31.9758608 53.8200318 15.8667022 44.8175625 15.8667022 20.5368374 32.1367184 30.4342599 31.9758608 53.8200318"
        />
        <polyline
          id="Fill-1059"
          fill="#B4B5B4"
          points="24.0470429 8.65706413 15.8637775 20.5894817 32.1367184 30.4866117 40.0275153 18.024534 24.0470429 8.65706413"
        />
        <polyline
          id="Fill-1060"
          fill="#9E9F9E"
          points="24.0470429 8.65706413 32.1367184 11.3506979 48.0820946 20.5368374 40.0275153 18.024534 24.0470429 8.65706413"
        />
        <polyline
          id="Fill-1061"
          fill="#E4E4E3"
          points="34.6428799 38.0267391 38.7435791 35.6577452 38.7435791 49.9533073 34.6428799 52.2348532 34.6428799 38.0267391"
        />
        <polyline
          id="Fill-1062"
          fill="#E4E4E3"
          points="41.4957066 34.4173868 45.2305279 32.2618948 45.2305279 40.1032646 41.4957066 42.4079155 41.4957066 34.4173868"
        />
        <polyline
          id="Fill-1063"
          fill="#FFFFFE"
          points="29.6478124 37.8889865 25.9100665 35.7308623 25.9100665 43.5745719 29.6478124 45.876298 29.6478124 37.8889865"
        />
        <polyline
          id="Fill-1064"
          fill="#FFFFFE"
          points="22.4527977 34.4173868 18.7153443 32.2618948 18.7153443 40.1032646 22.4527977 42.4079155 22.4527977 34.4173868"
        />
        <polyline
          id="Fill-1065"
          fill="#F8F7F6"
          points="15.9866143 62.8485308 31.9729361 53.8200318 32.1367184 30.4342599 23.9797752 27.3250285 16.1503966 39.6379474 15.9866143 62.8485308"
        />
        <polyline
          id="Fill-1066"
          fill="#E4E4E3"
          points="15.989539 62.8485308 -2.35625139e-13 53.9133292 -2.35625139e-13 29.8168591 16.1503966 39.6379474 15.989539 62.8485308"
        />
        <polyline
          id="Fill-1067"
          fill="#B4B5B4"
          points="8.11921477 18.024534 4.6941662e-13 29.8695035 16.1474719 39.6876671 23.9797752 27.3250285 8.11921477 18.024534"
        />
        <polyline
          id="Fill-1068"
          fill="#9E9F9E"
          points="8.11921477 18.024534 15.8667022 20.5368374 32.1367184 30.4342599 23.9797752 27.3250285 8.11921477 18.024534"
        />
        <polyline
          id="Fill-1069"
          fill="#E4E4E3"
          points="18.6363778 47.1722254 22.704613 44.8234119 22.704613 59.0081284 18.6363778 61.2721262 18.6363778 47.1722254"
        />
        <polyline
          id="Fill-1070"
          fill="#E4E4E3"
          points="25.4362677 43.59212 29.1447668 41.4515439 29.1447668 49.2338351 25.4362677 51.5212303 25.4362677 43.59212"
        />
        <polyline
          id="Fill-1071"
          fill="#FFFFFE"
          points="13.676114 47.03769 9.97053964 44.896529 9.97053964 52.6794051 13.676114 54.9632907 13.676114 47.03769"
        />
        <polyline
          id="Fill-1072"
          fill="#FFFFFE"
          points="6.53696082 43.59212 2.82846173 41.4515439 2.82846173 49.2338351 6.53696082 51.5212303 6.53696082 43.59212"
        />
        <polyline
          id="Fill-1073"
          fill="#F8F7F6"
          points="108.459268 91.8730931 123.816782 83.201113 123.974423 62.781263 108.538234 60.6722735 108.538234 68.5425977 108.459268 91.8730931"
        />
        <polyline
          id="Fill-1074"
          fill="#B4B5B4"
          points="92.8619287 51.7373644 92.9055065 61.8131927 108.538234 71.3184151 108.538234 60.6722735 92.8619287 51.7373644"
        />
        <polyline
          id="Fill-1075"
          fill="#9E9F9E"
          points="92.8619287 51.7373644 108.34228 53.2760406 123.974423 62.781263 108.538234 60.6722735 92.8619287 51.7373644"
        />
        <polyline
          id="Fill-1076"
          fill="#F8F7F6"
          points="93.0634394 100.409953 108.424171 91.7382651 108.582104 71.3184151 93.1426983 69.2097181 93.1426983 77.0797498 93.0634394 100.409953"
        />
        <polyline
          id="Fill-1077"
          fill="#B4B5B4"
          points="77.4254474 60.2745165 77.5889373 68.5425977 93.1017527 78.0510373 93.1017527 69.2097181 77.4254474 60.2745165"
        />
        <polyline
          id="Fill-1078"
          fill="#9E9F9E"
          points="77.4254474 60.2745165 92.9055065 61.8131927 108.538234 71.3184151 93.1017527 69.2097181 77.4254474 60.2745165"
        />
        <polyline
          id="Fill-1079"
          fill="#E4E4E3"
          points="93.0634394 100.518166 77.5889373 91.8669512 77.5889373 68.5425977 93.2187401 78.0510373 93.0634394 100.518166"
        />
        <polyline
          id="Fill-1080"
          fill="#E4E4E3"
          points="117.654473 67.8786945 121.243061 65.8053861 121.243061 70.4143954 117.654473 72.6254563 117.654473 67.8786945"
        />
        <polyline
          id="Fill-1081"
          fill="#E4E4E3"
          points="112.436838 70.6194157 116.028349 68.5484471 116.028349 73.1580413 112.436838 75.3688098 112.436838 70.6194157"
        />
        <polyline
          id="Fill-1082"
          fill="#E4E4E3"
          points="102.489988 75.7376124 106.0815 73.6666438 106.0815 78.2759455 102.489988 80.4870065 102.489988 75.7376124"
        />
        <polyline
          id="Fill-1083"
          fill="#E4E4E3"
          points="97.2752766 78.4806733 100.863571 76.407365 100.863571 81.0163742 97.2752766 83.2306524 97.2752766 78.4806733"
        />
        <polyline
          id="Fill-1084"
          fill="#F8F7F6"
          points="88.9220871 91.5718506 88.9220871 98.4828785 80.3647547 103.548431 80.3647547 96.5759847 88.9220871 91.5718506"
        />
        <polyline
          id="Fill-1085"
          fill="#E4E4E3"
          points="71.1227538 91.5718506 71.1227538 98.4153183 80.3647547 103.548431 80.3647547 96.5759847 71.1227538 91.5718506"
        />
        <polyline
          id="Fill-1086"
          fill="#B4B5B4"
          points="80.3647547 86.6288425 88.9220871 91.5718506 80.3647547 96.5759847 71.1227538 91.5718506 80.3647547 86.6288425"
        />
        <path
          d="M76.6767284,90.3285675 L76.6767284,71.4936037 C76.6767284,71.4936037 76.7147493,69.1249023 78.5719235,67.9813509 C80.4290977,66.8348748 81.6984105,67.1448913 81.6984105,67.1448913 L86.901423,69.621806 C86.901423,69.621806 87.7700541,70.3295795 87.7495813,70.8504657 C87.7495813,70.8504657 87.7963763,72.0141974 86.845854,72.2689374 C85.8953318,72.5263095 84.6230943,71.5991848 84.6230943,71.5991848 L81.906063,70.0897554 C81.906063,70.0897554 79.9962445,69.4872706 79.5370691,71.3649176 L79.5019729,90.3285675 C79.5019729,90.3285675 79.232902,91.1857924 78.7532539,91.4282487 C78.2765304,91.6712899 77.5333683,91.489667 77.5333683,91.489667 C77.5333683,91.489667 76.9133353,91.258617 76.6767284,90.3285675"
          id="Fill-1087"
          fill="#E67848"
        />
        <path
          d="M80.6776958,92.4609545 L80.6776958,73.6055179 C80.6776958,73.6055179 80.7157167,71.2335993 82.5758156,70.0871232 C84.4356221,68.9403547 85.708152,69.2503712 85.708152,69.2503712 L90.9140892,71.7305031 C90.9140892,71.7305031 91.785645,72.4382766 91.7651722,72.9591628 C91.7651722,72.9591628 91.8119672,74.1231869 90.8582278,74.3802666 C89.907998,74.6376388 88.6328359,73.710514 88.6328359,73.710514 L85.9158046,72.2016696 C85.9158046,72.2016696 84.0030614,71.5959676 83.543886,73.4768318 L83.5058651,92.4609545 C83.5058651,92.4609545 83.2365017,93.3205191 82.757146,93.5632678 C82.2801301,93.8089413 81.5346282,93.6249787 81.5346282,93.6249787 C81.5346282,93.6249787 80.9175199,93.3936362 80.6776958,92.4609545"
          id="Fill-1088"
          fill="#2A90C3"
        />
        <polyline
          id="Fill-1151"
          fill="#777776"
          points="111.629332 55.2823737 115.589647 57.6893885 115.051505 44.7973822 112.167474 44.7973822 111.629332 55.2823737"
        />
        <path
          d="M112.167474,44.7973822 C112.167474,45.358629 112.814122,45.8180968 113.609343,45.8180968 C114.40515,45.8180968 115.051505,45.358629 115.051505,44.7973822 C115.051505,44.2326257 114.40515,43.7737428 113.609343,43.7737428 C112.814122,43.7737428 112.167474,44.2326257 112.167474,44.7973822"
          id="Fill-1152"
          fill="#636463"
        />
        <polyline
          id="Fill-1153"
          fill="#777776"
          points="116.566491 58.2652587 120.526513 60.6722735 119.988371 47.7773425 117.104633 47.7773425 116.566491 58.2652587"
        />
        <path
          d="M117.104633,47.7773425 C117.104633,48.342099 117.750988,48.7983497 118.54621,48.7983497 C119.342016,48.7983497 119.988371,48.342099 119.988371,47.7773425 C119.988371,47.2128786 119.342016,46.7569203 118.54621,46.7569203 C117.750988,46.7569203 117.104633,47.2128786 117.104633,47.7773425"
          id="Fill-1154"
          fill="#636463"
        />
      </g>
    </g>
  </svg>
)

export const pageAndreBronImage2 = (
  <svg
    width="70px"
    height="70px"
    viewBox="0 0 128 128"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    aria-hidden="true"
  >
    <g
      id="2.verwarming/verwarming_4.2"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Group" transform="translate(27.200000, 0.000000)">
        <polyline
          id="Fill-1095"
          fill="#E67848"
          points="10.7480636 117.170552 8.69812804 121.516206 1.7220718 117.452941 3.70925424 113.086369 10.7480636 117.170552"
        />
        <path
          d="M7.99215533,120.135637 C7.99215533,121.474371 8.68766918,121.903707 9.6237367,121.375011 C10.7109347,120.757939 11.3912832,119.821871 11.3912832,118.483661 C11.3912832,117.149634 10.6277868,116.862016 9.66504918,117.348352 C8.67721033,117.845148 7.99215533,118.802656 7.99215533,120.135637"
          id="Fill-1096"
          fill="#DE482A"
        />
        <path
          d="M0.953345964,116.020601 C0.953345964,117.337893 1.63317153,117.767229 2.56400962,117.238534 C3.64074874,116.631921 4.3106384,115.706312 4.3106384,114.38379 C4.3106384,113.065451 3.55237141,112.778356 2.60061562,113.259463 C1.62794211,113.750506 0.953345964,114.697033 0.953345964,116.020601"
          id="Fill-1097"
          fill="#E67848"
        />
        <polyline
          id="Fill-1107"
          fill="#DB4A2C"
          points="5.87946663 105.482781 7.9294022 109.828436 14.9049355 105.76517 12.918276 101.398599 5.87946663 105.482781"
        />
        <path
          d="M8.63537491,108.453096 C8.63537491,109.7866 7.93986105,110.215413 7.0032706,109.687241 C5.91554968,109.070692 5.23624706,108.134101 5.23624706,106.795368 C5.23624706,105.461864 5.99974347,105.174245 6.96143518,105.661105 C7.95031991,106.157378 8.63537491,107.114363 8.63537491,108.453096"
          id="Fill-1108"
          fill="#E2763D"
        />
        <path
          d="M15.6741843,104.332307 C15.6741843,105.650123 14.9891293,106.078936 14.0629977,105.550764 C12.9862586,104.94415 12.3168918,104.019065 12.3168918,102.695497 C12.3168918,101.377681 13.0699294,101.090062 14.0269146,101.57117 C14.9995881,102.063259 15.6741843,103.009785 15.6741843,104.332307"
          id="Fill-1109"
          fill="#DB4A2C"
        />
        <polyline
          id="Fill-1110"
          fill="#E2763D"
          points="16.0768502 111.052122 14.032144 115.403005 7.05608781 111.33974 9.04327025 106.973168 16.0768502 111.052122"
        />
        <path
          d="M13.3261713,114.022436 C13.3261713,115.35594 14.0164558,115.790506 14.9577527,115.257104 C16.0449507,114.639509 16.7247763,113.703964 16.7247763,112.369937 C16.7247763,111.036433 15.9618028,110.743585 14.9943587,111.229922 C14.0107034,111.731947 13.3261713,112.689455 13.3261713,114.022436"
          id="Fill-1111"
          fill="#DB4A2C"
        />
        <path
          d="M6.28683903,109.902171 C6.28683903,111.224693 6.96718755,111.654029 7.89802564,111.125334 C8.97528769,110.514014 9.64465441,109.588405 9.64465441,108.270066 C9.64465441,106.947544 8.88638743,106.664632 7.93463163,107.145739 C6.96143518,107.637305 6.28683903,108.584355 6.28683903,109.902171"
          id="Fill-1112"
          fill="#E2763D"
        />
        <polyline
          id="Fill-1113"
          fill="#E2763D"
          points="25.9709269 108.296213 23.9256979 112.641868 16.9501646 108.578602 18.9321176 104.21203 25.9709269 108.296213"
        />
        <path
          d="M23.2202481,111.261822 C23.2202481,112.600555 23.9105325,113.028845 24.8513065,112.500673 C25.9395504,111.884124 26.619376,110.947533 26.619376,109.6088 C26.619376,108.275296 25.8501272,107.982971 24.8884355,108.474014 C23.9053031,108.970809 23.2202481,109.927795 23.2202481,111.261822"
          id="Fill-1114"
          fill="#DB4A2C"
        />
        <path
          d="M16.1762093,107.145739 C16.1762093,108.464078 16.8612643,108.892891 17.7915795,108.364196 C18.864135,107.757582 19.5387312,106.831974 19.5387312,105.508928 C19.5387312,104.191113 18.7804642,103.903494 17.8287084,104.384602 C16.8560349,104.876691 16.1762093,105.823217 16.1762093,107.145739"
          id="Fill-1115"
          fill="#E2763D"
        />
        <polyline
          id="Fill-1119"
          fill="#DB4A2C"
          points="16.1762093 115.146763 18.2256219 119.492418 25.2022011 115.429152 23.2144957 111.06258 16.1762093 115.146763"
        />
        <path
          d="M18.9321176,118.111849 C18.9321176,119.450582 18.2366037,119.879395 17.3005362,119.345994 C16.2128153,118.734151 15.5329897,117.798083 15.5329897,116.45935 C15.5329897,115.125846 16.2959632,114.832998 17.2581779,115.325087 C18.2470626,115.821359 18.9321176,116.778345 18.9321176,118.111849"
          id="Fill-1120"
          fill="#E2763D"
        />
        <path
          d="M25.9709269,113.996289 C25.9709269,115.314105 25.285349,115.742918 24.3602633,115.215269 C23.2824783,114.608655 22.6136345,113.683047 22.6136345,112.359478 C22.6136345,111.041663 23.3661491,110.754044 24.3179049,111.235152 C25.2963308,111.727241 25.9709269,112.673244 25.9709269,113.996289"
          id="Fill-1121"
          fill="#DB4A2C"
        />
        <polyline
          id="Fill-1122"
          fill="#DB4A2C"
          points="5.44542416 113.567476 9.41403666 116.27632 13.3674838 109.24274 9.44541322 106.482125 5.44542416 113.567476"
        />
        <path
          d="M9.32565933,114.733639 C10.0002555,115.884113 9.6237367,116.605774 8.54124521,116.621462 C7.29141205,116.642903 6.22983827,116.182713 5.55524213,115.026486 C4.88064599,113.876012 5.39260694,113.238022 6.47039194,113.170563 C7.56857171,113.102057 8.64583376,113.583164 9.32565933,114.733639"
          id="Fill-1123"
          fill="#E2763D"
        />
        <path
          d="M13.3104831,107.616388 C13.9793268,108.751174 13.603331,109.467605 12.5365278,109.483293 C11.3023829,109.504211 10.251268,109.044021 9.58713071,107.904006 C8.91776399,106.769743 9.42449551,106.13646 10.4865922,106.07423 C11.5743131,106.001018 12.6411163,106.476373 13.3104831,107.616388"
          id="Fill-1124"
          fill="#DB4A2C"
        />
        <polyline
          id="Fill-1125"
          fill="#F8F7F6"
          points="53.2580795 34.2945853 53.2580795 111.449558 16.1396033 90.0193644 16.1396033 12.8591621 53.2580795 34.2945853"
        />
        <path
          d="M53.2580795,34.0331139 L53.2580795,111.193316 C46.9461605,109.430999 38.5633883,106.31949 29.7465736,100.640332 C24.1249391,97.0163383 19.6276314,93.183168 16.1396033,89.7636453 L16.1396033,12.6029202 C19.5962549,16.002048 24.0412682,19.7933829 29.5792319,23.3865226 C38.4535703,29.1331404 46.9043251,32.2660904 53.2580795,34.0331139"
          id="Fill-1126"
          fill="#E4E4E3"
        />
        <polyline
          id="Fill-1127"
          fill="#C7C5BD"
          points="53.2580795 34.2945853 53.2580795 111.449558 74.6882732 98.909391 74.6882732 21.7497118 53.2580795 34.2945853"
        />
        <path
          d="M38.4117349,0 L16.1396033,12.8591621 C20.2813099,16.7655444 25.9918447,21.4359461 33.4071728,25.7188472 C40.8591069,30.0273725 47.7880983,32.6525451 53.2580795,34.2945853 L74.6882732,21.7497118 L38.4117349,0"
          id="Fill-1128"
          fill="#C7C5BD"
        />
        <path
          d="M43.1182196,2.79774369 L27.6338849,11.7405876 C30.51007,14.4593669 34.4844349,17.701612 39.6406503,20.687615 C44.82249,23.684077 49.6440221,25.5096701 53.4463388,26.6491624 L68.3502071,17.9270003 L43.1182196,2.79774369"
          id="Fill-1129"
          fill="#9E9F9E"
        />
        <path
          d="M39.3948672,97.001173 L39.3948672,105.974348 C37.0468543,105.043509 34.3223226,103.7623 31.4304492,101.999983 C28.6797704,100.326566 26.3945106,98.5851665 24.5485227,97.001173 L24.5485227,19.1820629 L39.3948672,28.4852143 L39.3948672,97.001173"
          id="Fill-1130"
          fill="#C7C5BD"
        />
        <polyline
          id="Fill-1131"
          fill="#E67848"
          points="40.6342416 57.7694852 40.6342416 73.7976804 22.5351931 62.6694587 22.5351931 46.4320864 40.6342416 57.7694852"
        />
        <path
          d="M35.8388566,94.4492124 C35.2003435,94.4492124 34.6779237,95.3068385 34.6779237,96.3626599 C34.6779237,97.4190042 35.2003435,98.2766303 35.8388566,98.2766303 C36.4820761,98.2766303 37.0050189,97.4190042 37.0050189,96.3626599 C37.0050189,95.3068385 36.4820761,94.4492124 35.8388566,94.4492124"
          id="Fill-1132"
          fill="#636463"
        />
        <polygon
          id="Fill-1133"
          fill="#636463"
          points="35.1642604 98.2771533 35.916775 98.2771533 35.916775 94.4492124 35.1642604 94.4492124"
        />
        <path
          d="M35.1642604,94.4492124 C34.5257473,94.4492124 34.0033275,95.3068385 34.0033275,96.3626599 C34.0033275,97.4190042 34.5257473,98.2766303 35.1642604,98.2766303 C35.80748,98.2766303 36.3304228,97.4190042 36.3304228,96.3626599 C36.3304228,95.3068385 35.80748,94.4492124 35.1642604,94.4492124"
          id="Fill-1134"
          fill="#777776"
        />
        <path
          d="M26.9953718,89.8525456 C26.3521522,89.8525456 25.8349618,90.7096488 25.8349618,91.7659931 C25.8349618,92.8223375 26.3521522,93.6804865 26.9953718,93.6804865 C27.6385914,93.6804865 28.1568276,92.8223375 28.1568276,91.7659931 C28.1568276,90.7096488 27.6385914,89.8525456 26.9953718,89.8525456"
          id="Fill-1135"
          fill="#636463"
        />
        <polygon
          id="Fill-1136"
          fill="#636463"
          points="26.3212986 93.6804865 27.0738132 93.6804865 27.0738132 89.8525456 26.3212986 89.8525456"
        />
        <path
          d="M26.3212986,89.8525456 C25.6775561,89.8525456 25.1603657,90.7096488 25.1603657,91.7659931 C25.1603657,92.8223375 25.6775561,93.6804865 26.3212986,93.6804865 C26.9639952,93.6804865 27.4822315,92.8223375 27.4822315,91.7659931 C27.4822315,90.7096488 26.9639952,89.8525456 26.3212986,89.8525456"
          id="Fill-1137"
          fill="#777776"
        />
        <polyline
          id="Fill-2089"
          fill="#DB4A2C"
          points="27.8378326 122.583532 25.7931264 126.929186 18.8170702 122.870628 20.8042526 118.498826 27.8378326 122.583532"
        />
        <path
          d="M25.0871537,125.553324 C25.0871537,126.886828 25.7769152,127.321393 26.7187351,126.787992 C27.806456,126.170396 28.4862816,125.234329 28.4862816,123.895595 C28.4862816,122.562614 27.7227851,122.274996 26.7553411,122.761333 C25.7722087,123.258128 25.0871537,124.214591 25.0871537,125.553324"
          id="Fill-2090"
          fill="#E2763D"
        />
        <path
          d="M18.042592,121.432535 C18.042592,122.750351 18.727647,123.179164 19.659008,122.656221 C20.7305177,122.044378 21.4051138,121.119292 21.4051138,119.795724 C21.4051138,118.477909 20.6468468,118.19029 19.695614,118.671397 C18.7229405,119.162964 18.042592,120.10949 18.042592,121.432535"
          id="Fill-2091"
          fill="#DB4A2C"
        />
      </g>
    </g>
  </svg>
)

export const pageAndreBronImage3 = (
  <svg
    width="70px"
    height="70px"
    viewBox="0 0 128 128"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    aria-hidden="true"
  >
    <g
      id="2.verwarming/verwarming_4.3"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Group" transform="translate(1.600000, 0.000000)">
        <polyline
          id="Fill-1155"
          fill="#C7C5BD"
          points="123.283083 78.4297142 123.283083 81.1194484 43.1264128 126.866517 43.1264128 124.530809 123.283083 78.4297142"
        />
        <polyline
          id="Fill-1156"
          fill="#C7C5BD"
          points="-3.49181002e-13 99.6367359 -3.49181002e-13 102.32647 43.1264128 126.866517 43.1264128 124.530809 -3.49181002e-13 99.6367359"
        />
        <polyline
          id="Fill-1157"
          fill="#9E9F9E"
          points="43.1264128 124.530809 -3.35646854e-13 99.6367359 81.3396354 54.9474278 123.283083 78.4297142"
        />
        <polyline
          id="Fill-1158"
          fill="#E4E4E3"
          points="39.5818353 116.314815 39.5818353 53.0218716 107.360547 14.3294188 107.360547 77.5878231 39.5818353 116.314815"
        />
        <path
          d="M103.643274,79.67744 L44.4902765,113.439433 L44.4902765,79.8937413 C44.4902765,79.8937413 49.4513898,51.6748458 76.1328625,42.4010912 C84.4438391,39.2493962 96.8692887,35.6663939 103.643274,44.2532517 L103.643274,79.67744"
          id="Fill-1159"
          fill="#C7C5BD"
        />
        <path
          d="M83.2043163,66.9065992 L44.4902765,89.1584294 L44.4902765,78.1663534 C45.9543035,71.6298243 44.9828907,58.1638836 65.3652908,47.2538381 C77.0520349,40.9979393 83.8307696,39.9401787 83.8307696,39.9401787 L83.2043163,66.9065992"
          id="Fill-1160"
          fill="#777776"
        />
        <polyline
          id="Fill-1161"
          fill="#C7C5BD"
          points="39.5818353 53.0218716 15.4217185 38.9126398 15.4217185 101.955606 39.5818353 116.314815 39.5818353 53.0218716"
        />
        <polyline
          id="Fill-1162"
          fill="#9E9F9E"
          points="15.4217185 38.9126398 39.5818353 53.0218716 107.360547 14.3294188 82.5441873 3.46474172e-13 15.4217185 38.9126398"
        />
        <polyline
          id="Fill-1163"
          fill="#D94B2B"
          points="87.5696297 80.8301833 82.9366381 85.8297214 71.0815157 78.8959924 75.7222787 73.9568977 87.5696297 80.8301833"
        />
        <path
          d="M88.6576121,83.0450046 C88.6576121,80.7956442 87.3710298,80.307779 85.747691,81.128515 C84.089813,81.965657 82.9366381,83.580361 82.9366381,85.8297214"
          id="Fill-1164"
          fill="#DF6B39"
        />
        <path
          d="M76.7372972,76.1458147 C76.7372972,73.9223586 75.463667,73.4388109 73.8619152,74.2504803 C72.2208751,75.079851 71.0815157,76.6725363 71.0815157,78.8959924"
          id="Fill-1165"
          fill="#D94B2B"
        />
        <polyline
          id="Fill-1166"
          fill="#D94B2B"
          points="75.9640526 86.434156 71.3319244 91.4341259 59.4759386 84.5003969 64.117565 79.5608705 75.9640526 86.434156"
        />
        <path
          d="M77.0520349,88.6494091 C77.0520349,86.4000487 75.7658843,85.9121835 74.1425455,86.732056 C72.4842359,87.5696297 71.3319244,89.1843337 71.3319244,91.4341259"
          id="Fill-1167"
          fill="#DF6B39"
        />
        <path
          d="M65.1321517,81.7459018 C65.1321517,79.5267631 63.8580898,79.0427837 62.2567697,79.8544531 C60.6161614,80.683392 59.4759386,82.2769408 59.4759386,84.5003969"
          id="Fill-1168"
          fill="#D94B2B"
        />
        <polyline
          id="Fill-1169"
          fill="#D94B2B"
          points="62.4726393 78.054533 67.1051992 83.0536393 78.9603215 76.1199103 74.3195585 71.1812475 62.4726393 78.054533"
        />
        <path
          d="M61.3842251,80.2689225 C61.3842251,78.0195621 62.6755566,77.5364461 64.294578,78.3520012 C65.9520242,79.1938923 67.1051992,80.8047107 67.1051992,83.0536393"
          id="Fill-1170"
          fill="#DF6B39"
        />
        <path
          d="M73.3049718,73.3697327 C73.3049718,71.1462766 74.5781702,70.6631606 76.1803538,71.47483 C77.8209622,72.3033372 78.9603215,73.8964543 78.9603215,76.1199103"
          id="Fill-1171"
          fill="#D94B2B"
        />
        <polyline
          id="Fill-1172"
          fill="#D94B2B"
          points="68.9828323 82.5143973 73.6158239 87.5091863 85.4709462 80.5797746 80.8301833 75.6411117 68.9828323 82.5143973"
        />
        <path
          d="M67.8948499,84.7287868 C67.8948499,82.4794264 69.181864,81.9915613 70.8052027,82.8118655 C72.4630807,83.6494392 73.6158239,85.264575 73.6158239,87.5091863"
          id="Fill-1173"
          fill="#DF6B39"
        />
        <path
          d="M79.8151648,77.8252796 C79.8151648,75.6061409 81.0849093,75.1230249 82.6909786,75.9346943 C84.3315869,76.7632015 85.4709462,78.3563186 85.4709462,80.5797746"
          id="Fill-1174"
          fill="#D94B2B"
        />
        <path
          d="M73.9741673,79.4313488 C73.9741673,79.4313488 57.5162751,75.0966888 58.2027401,70.8483767 L62.5589871,71.6384591 C62.5589871,71.6384591 55.193519,58.7035574 52.6548935,60.5168614 C52.6548935,60.5168614 57.6673837,55.1939508 63.2843087,58.975553 C68.9012336,62.7580188 64.0091985,56.2340101 64.0091985,56.2340101 C64.0091985,56.2340101 79.1075445,63.4267825 78.0195621,69.7690291 C78.0195621,69.7690291 78.8485011,75.3432118 73.9741673,79.4313488"
          id="Fill-1175"
          fill="#E67848"
        />
        <path
          d="M83.2043163,66.9065992 L103.643274,79.67744 L103.643274,44.2532517 C103.643274,44.2532517 98.5228492,36.4737459 83.8307696,39.9401787 L83.2043163,66.9065992"
          id="Fill-1176"
          fill="#9E9F9E"
        />
      </g>
    </g>
  </svg>
)
export const step8Image1 = (
  <svg
    width="70px"
    height="70px"
    viewBox="0 0 128 128"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    aria-hidden="true"
  >
    <g
      id="2.verwarming/verwarming_5.1"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Group" transform="translate(11.200000, 1.600000)">
        <path
          d="M100.466107,13.0591937 L87.4329843,20.5844052 C86.1999376,21.2965803 84.6676958,20.3717953 84.7266281,18.9483517 L84.7443078,18.4723594 C84.7669741,17.8603693 85.1028887,17.3027783 85.6287469,16.9899834 L98.6437361,9.30157452 C99.8491299,8.59438597 101.367772,9.45978529 101.367772,10.8560294 L101.367772,11.4956723 C101.367772,12.1389419 101.023698,12.7373322 100.466107,13.0591937"
          id="Fill-1289"
          fill="#777776"
        />
        <path
          d="M95.9101804,9.97249699 C97.4424222,10.8560294 99.9402485,11.4276734 102.456208,9.97249699 C103.866052,9.16104346 103.770853,6.91254654 102.456208,6.19629147 C101.186895,5.50224937 98.7298681,4.56839783 96.3499066,5.94197559 C95.4205883,6.48188684 94.9940086,7.28427385 94.9536625,8.04994146 C94.9037967,8.8477952 95.2709907,9.60484961 95.9101804,9.97249699"
          id="Fill-1290"
          fill="#E15D29"
        />
        <polyline
          id="Fill-1291"
          fill="#E15D29"
          points="94.9491293 2.81447956 103.466671 2.81447956 103.466671 8.27660445 94.9536625 8.27660445 94.9491293 2.81447956"
        />
        <path
          d="M95.9101804,4.74111503 C97.4424222,5.62464739 99.9402485,6.19130488 102.456208,4.74111503 C103.866052,3.92467492 103.770853,1.68116458 102.456208,0.959922921 C101.186895,0.266787478 98.7298681,-0.667517394 96.3499066,0.706060365 C94.4504707,1.80310927 94.6590006,4.01579344 95.9101804,4.74111503"
          id="Fill-1292"
          fill="#E5832D"
        />
        <polyline
          id="Fill-1293"
          fill="#CBCCCB"
          points="5.77083989 47.7889513 18.3506362 55.0553137 18.3506362 113.398369 5.77083989 106.263018 5.77083989 47.7889513"
        />
        <polyline
          id="Fill-1294"
          fill="#F8F7F6"
          points="18.3506362 55.0553137 98.0267594 9.04771197 98.0267594 66.9823206 18.3506362 113.398369 18.3506362 55.0553137"
        />
        <polyline
          id="Fill-1295"
          fill="#B4B5B4"
          points="98.0267594 9.04771197 85.4469631 1.78497623 5.77083989 47.7889513 18.3506362 55.0553137 98.0267594 9.04771197"
        />
        <polyline
          id="Fill-1296"
          fill="#E4E4E3"
          points="25.8255285 52.9201483 27.3400907 51.8820317 27.3985697 104.404381 25.8255285 105.31602 25.8255285 52.9201483"
        />
        <polyline
          id="Fill-1297"
          fill="#E4E4E3"
          points="33.0021323 48.8270679 34.5162411 47.7889513 34.5792534 100.310848 33.0021323 101.222486 33.0021323 48.8270679"
        />
        <polyline
          id="Fill-1298"
          fill="#E4E4E3"
          points="40.182816 44.6927348 41.6923916 43.6546183 41.7558572 96.1765145 40.182816 97.0831665 40.182816 44.6927348"
        />
        <polyline
          id="Fill-1299"
          fill="#E4E4E3"
          points="47.3589665 40.9750083 48.8730753 39.9368918 48.9320077 92.4596947 47.3589665 93.3663467 47.3589665 40.9750083"
        />
        <polyline
          id="Fill-1300"
          fill="#E4E4E3"
          points="54.5396502 36.731877 56.0492258 35.6937605 56.1122381 88.2161101 54.5396502 89.1227621 54.5396502 36.731877"
        />
        <polyline
          id="Fill-1301"
          fill="#E4E4E3"
          points="61.7158007 32.8015407 63.2299095 31.7638775 63.2883886 84.2857737 61.7158007 85.1974123 61.7158007 32.8015407"
        />
        <polyline
          id="Fill-1302"
          fill="#E4E4E3"
          points="68.8919512 28.2007352 70.40606 27.1626187 70.4695256 79.6845149 68.8919512 80.5961535 68.8919512 28.2007352"
        />
        <polyline
          id="Fill-1303"
          fill="#E4E4E3"
          points="76.0726349 24.1928801 77.5867437 23.1547635 77.6456761 75.6775664 76.0726349 76.5837651 76.0726349 24.1928801"
        />
        <polyline
          id="Fill-1304"
          fill="#E4E4E3"
          points="83.2487854 20.3940083 84.7628942 19.3558917 84.8263598 71.8782413 83.2487854 72.7848933 83.2487854 20.3940083"
        />
        <polyline
          id="Fill-1305"
          fill="#E4E4E3"
          points="90.4294691 17.2207263 91.9390447 16.1785298 92.0025103 68.7049593 90.4294691 69.6116113 90.4294691 17.2207263"
        />
        <polygon
          id="Fill-2868"
          fill="#9E9F9E"
          points="-5.45696821e-13 121.594956 5.0681846 121.594956 5.0681846 105.656014 -5.45696821e-13 105.656014"
        />
        <path
          d="M-5.45696821e-13,121.594956 C-5.45696821e-13,119.803865 1.13331498,118.353675 2.5340923,118.353675 C3.93033636,118.353675 5.0681846,119.803865 5.0681846,121.594956 C5.0681846,123.385141 3.93033636,124.835784 2.5340923,124.835784 C1.13331498,124.835784 -5.45696821e-13,123.385141 -5.45696821e-13,121.594956"
          id="Fill-2869"
          fill="#9E9F9E"
        />
        <line
          x1="11.7388284"
          y1="90.2451491"
          x2="11.7388284"
          y2="90.2451491"
          id="Fill-2870"
          fill="#9E9F9E"
        />
        <path
          d="M11.5457597,96.2495 L7.86520598,98.0129381 C7.24414937,98.6516745 6.84068924,98.7019936 5.82070575,100.3929 C4.46072777,102.654543 5.00925222,104.803308 5.0681846,105.656014 C3.37727865,105.656014 1.68591937,105.656014 -1.8189894e-13,105.656014 C0.0131464538,103.906176 -1.8189894e-13,101.222486 0.765667603,98.7790591 C1.53677512,96.3310987 2.81062116,95.2748491 4.99066586,94.109348 C5.10898394,94.0463357 11.5729593,90.6373242 11.6454914,90.6051381"
          id="Fill-2871"
          fill="#9E9F9E"
        />
        <path
          d="M9.46544674,93.4162126 C9.46544674,91.8477046 10.4577773,90.5738586 11.6867441,90.5738586 C12.9107243,90.5738586 13.9080415,91.8477046 13.9080415,93.4162126 C13.9080415,94.9892538 12.9107243,96.2585665 11.6867441,96.2585665 C10.4577773,96.2585665 9.46544674,94.9892538 9.46544674,93.4162126"
          id="Fill-2872"
          fill="#9E9F9E"
        />
      </g>
    </g>
  </svg>
)

export const step8Image2 = (
  <svg
    width="70px"
    height="70px"
    viewBox="0 0 128 128"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    aria-hidden="true"
  >
    <g
      id="2.verwarming/verwarming_5.2"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Group" transform="translate(1.600000, 27.200000)" fill="#E67848">
        <path
          d="M5.71855158,31.4610771 L71.8230251,68.6242649 C71.8230251,68.6242649 73.9751306,70.1226266 72.8919201,71.9316359 C71.9327777,73.5345012 70.2860114,72.7476227 70.2860114,72.7476227 C61.3488087,67.8416811 24.3287766,47.0607403 15.2002226,41.7301038 C11.2109539,39.4014398 7.26463181,37.0680039 3.36602827,34.7255015 C2.83635264,34.2955576 2.30619982,33.861319 1.77222952,33.4275576 C1.35230649,33.0453322 0.712878248,32.3486417 0.325881005,31.303606 C-0.518736898,29.0322042 0.522004146,26.9755357 0.722421953,26.5942647 L4.21541803,28.1684989 C4.21541803,28.1684989 3.6141646,28.5125494 3.64709039,29.4239733 C3.65233943,29.6095983 3.73775559,29.7532311 3.80933337,29.8629837 C4.28699582,30.5544251 5.40360931,31.2659084 5.71855158,31.4610771"
          id="Fill-1188"
        />
        <path
          d="M44.6807277,4.3664983 L4.21541803,28.1684989 L0.393164127,27.3434456 C0.393164127,27.3434456 0.879893088,25.5916985 2.39257035,24.7470806 L42.5238504,1.15981338 L44.6807277,4.3664983"
          id="Fill-1189"
        />
        <path
          d="M50.6646308,8.83295229 L14.1881127,30.2442547 L10.366336,29.4187242 C10.366336,29.4187242 10.8530649,27.6626825 12.3609703,26.8233136 L48.5077535,5.63103923 L50.6646308,8.83295229"
          id="Fill-1190"
        />
        <path
          d="M58.3659237,12.4886685 L20.5733286,34.6104998 L17.066017,33.6752167 C17.066017,33.6752167 17.5479741,31.919175 19.0606513,31.0793289 L56.2095235,9.28150643 L58.3659237,12.4886685"
          id="Fill-1191"
        />
        <path
          d="M44.6807277,4.3664983 C44.6807277,4.3664983 47.7060823,3.23604643 48.4361757,4.70529983 C48.975395,5.79805407 45.6255545,7.48728987 45.6255545,7.48728987 L43.8504254,8.57527226 L43.8504254,12.798839 L52.1248177,7.95493142 C52.1248177,7.95493142 54.7250002,5.82239051 52.6110695,2.67249064 C50.5019107,-0.472160198 45.6207827,-0.658262448 42.5238504,1.15981338 C39.5939329,2.88245215 44.6807277,4.3664983 44.6807277,4.3664983"
          id="Fill-1192"
        />
        <path
          d="M58.3425416,12.4834195 C58.3425416,12.4834195 61.3631243,11.3529676 62.0932177,12.822221 C62.6372089,13.9149753 59.2873684,15.6089829 59.2873684,15.6089829 L57.5074674,16.6969653 L57.4931519,21.0870697 L65.7675442,16.2436393 C65.7675442,16.2436393 68.3825194,13.9393117 66.2733606,10.7941837 C64.1589527,7.64523819 59.2778247,7.46390779 56.1856643,9.28150643 C53.2552696,11.0041452 58.3425416,12.4834195 58.3425416,12.4834195"
          id="Fill-1193"
        />
        <path
          d="M19.1226854,31.0411541 C19.1226854,31.0411541 16.1021028,32.1673113 15.3720093,30.6975807 C14.8280181,29.6095983 18.1778586,27.9155907 18.1778586,27.9155907 L19.9577596,26.8276083 L19.9577596,22.6045188 L11.6785954,27.4479491 C11.6785954,27.4479491 9.08270764,29.5809672 11.1913893,32.7303899 C13.3057972,35.8802898 18.1874023,36.0616202 21.2795628,34.2430672 C24.2090031,32.5204284 19.1226854,31.0411541 19.1226854,31.0411541"
          id="Fill-1194"
        />
        <path
          d="M65.4950714,16.4965475 L29.0147358,37.9126218 L25.1920047,37.0875685 C25.1920047,37.0875685 25.6792108,35.3315267 27.1918881,34.4912035 L63.3338994,13.2946344 L65.4950714,16.4965475"
          id="Fill-1195"
        />
        <path
          d="M73.1925468,20.1522638 L35.3989973,42.274095 L31.8916857,41.3388119 C31.8916857,41.3388119 32.3788918,39.587542 33.8867972,38.7481732 L71.0356694,16.9503507 L73.1925468,20.1522638"
          id="Fill-1196"
        />
        <path
          d="M73.1682103,20.1470147 C73.1682103,20.1470147 76.1892702,19.0208575 76.9193636,20.4910653 C77.4628776,21.5785705 74.1130371,23.2730553 74.1130371,23.2730553 L72.3383852,24.3605605 L72.3383852,28.58365 L80.6127775,23.7402197 C80.6127775,23.7402197 83.2134372,21.6072016 81.0995065,18.4577789 C78.9903476,15.3083562 74.1039706,15.127503 71.0118102,16.9451016 C68.0818927,18.6677404 73.1682103,20.1470147 73.1682103,20.1470147"
          id="Fill-1197"
        />
        <path
          d="M33.9488313,38.7047493 C33.9488313,38.7047493 30.9282487,39.8361556 30.1981552,38.3659478 C29.654164,37.2731936 33.0040045,35.5791859 33.0040045,35.5791859 L34.7834283,34.4912035 L34.7834283,30.273363 L26.5047413,35.1163162 C26.5047413,35.1163162 23.9088535,37.2498115 26.0180124,40.3939851 C28.1319431,43.543885 33.0135482,43.7252154 36.1104805,41.9066624 C39.0356262,40.1840236 33.9488313,38.7047493 33.9488313,38.7047493"
          id="Fill-1198"
        />
        <path
          d="M79.0285225,24.7857326 L42.5524815,46.197035 L38.7302276,45.3710273 C38.7302276,45.3710273 39.2169566,43.6197575 40.724862,42.7751396 L76.8716451,21.5838195 L79.0285225,24.7857326"
          id="Fill-1199"
        />
        <path
          d="M86.7302925,28.4404945 L48.9372202,50.5628029 L45.4251367,49.627997 C45.4251367,49.627997 45.9118657,47.8719553 47.424543,47.031632 L84.5734151,25.2338095 L86.7302925,28.4404945"
          id="Fill-1200"
        />
        <path
          d="M86.705956,28.4357226 C86.705956,28.4357226 89.7270159,27.3047936 90.4571093,28.7750013 C91.0006234,29.8672784 87.6507829,31.561286 87.6507829,31.561286 L85.8708819,32.6492684 L85.8708819,36.8675861 L94.1505232,32.0241557 C94.1505232,32.0241557 96.746411,29.8911376 94.6372522,26.7464868 C92.5233215,23.5970641 87.6417163,23.4157337 84.5495559,25.2338095 C81.6196384,26.9564483 86.705956,28.4357226 86.705956,28.4357226"
          id="Fill-1201"
        />
        <path
          d="M47.486577,46.9939344 C47.486577,46.9939344 44.4659944,48.1196144 43.7359009,46.6498838 C43.1919097,45.5623786 46.5417502,43.8678938 46.5417502,43.8678938 L48.3216512,42.7803886 L48.3216512,38.5568219 L40.042487,43.4050241 C40.042487,43.4050241 37.4465993,45.5332703 39.5557581,48.6831702 C41.6696888,51.8321157 46.5512939,52.0134461 49.6434544,50.1958475 C52.5733719,48.4732087 47.486577,46.9939344 47.486577,46.9939344"
          id="Fill-1202"
        />
        <path
          d="M94.2173292,32.0628077 L57.7365163,53.473633 L53.9142624,52.6481025 C53.9142624,52.6481025 54.4005142,50.8973098 55.9136687,50.0526919 L92.0604518,28.8604175 L94.2173292,32.0628077"
          id="Fill-1203"
        />
        <path
          d="M101.919099,35.7180468 L64.1212551,57.8398781 L60.6134662,56.904595 C60.6134662,56.904595 61.1001952,55.1533251 62.6133497,54.3087072 L99.75745,32.5161337 L101.919099,35.7180468"
          id="Fill-1204"
        />
        <path
          d="M101.890468,35.7127978 C101.890468,35.7127978 104.915823,34.5866406 105.645916,36.0515993 C106.185135,37.1443535 102.840067,38.8383612 102.840067,38.8383612 L101.060166,39.9263436 L101.060166,44.1446612 L109.334558,39.3017081 C109.334558,39.3017081 111.935218,37.1729846 109.821287,34.023562 C107.712128,30.8746165 102.830523,30.6932861 99.7335907,32.5108847 C96.8036733,34.2335235 101.890468,35.7127978 101.890468,35.7127978"
          id="Fill-1205"
        />
        <path
          d="M62.6753837,54.2705324 C62.6753837,54.2705324 59.6500292,55.3966896 58.9199358,53.9317308 C58.3807164,52.8389766 61.7305569,51.1449689 61.7305569,51.1449689 L63.5052089,50.0569866 L63.5052089,45.8391461 L55.2312937,50.6820992 C55.2312937,50.6820992 52.6306341,52.8103455 54.7445648,55.9602454 C56.8537236,59.1091909 61.7353288,59.2909985 64.8322611,57.4729226 C67.7621786,55.7498067 62.6753837,54.2705324 62.6753837,54.2705324"
          id="Fill-1206"
        />
        <path
          d="M107.754598,40.3510385 L71.2742621,61.7623409 L67.4520082,60.9372876 C67.4520082,60.9372876 67.9382599,59.1812458 69.4514144,58.3409226 L105.593426,37.1496026 L107.754598,40.3510385"
          id="Fill-1207"
        />
        <path
          d="M115.452073,44.0019828 L77.6590008,66.128586 L74.1516891,65.1933029 C74.1516891,65.1933029 74.6379409,63.4377383 76.1463235,62.5974151 L113.295196,40.7995926 L115.452073,44.0019828"
          id="Fill-1208"
        />
        <path
          d="M115.428214,44.0019828 C115.428214,44.0019828 118.453568,42.8705766 119.178413,44.3407844 C119.722881,45.4335386 116.373041,47.1270691 116.373041,47.1270691 L114.597911,48.2155287 L114.597911,52.4333691 L122.872304,47.5899388 C122.872304,47.5899388 125.472963,45.4569207 123.359033,42.3122699 C121.249874,39.1628472 116.363497,38.9815168 113.271336,40.7995926 C110.341419,42.5227086 115.428214,44.0019828 115.428214,44.0019828"
          id="Fill-1209"
        />
        <path
          d="M76.2078804,62.5597175 C76.2078804,62.5597175 73.1877749,63.6858747 72.4576815,62.2156669 C71.9184622,61.1281617 75.2635308,59.4336768 75.2635308,59.4336768 L77.0429546,58.3461716 L77.0429546,54.1226049 L68.7642676,58.9665125 C68.7642676,58.9665125 66.1683798,61.0995306 68.2775386,64.2484761 C70.3914693,67.3978988 75.2730745,67.5792292 78.3700068,65.7611533 C81.2951524,64.0385146 76.2078804,62.5597175 76.2078804,62.5597175"
          id="Fill-1210"
        />
        <path
          d="M117.666213,46.516272 L79.5343388,68.0091731 C79.5343388,68.0091731 77.3870052,69.5022857 78.4702157,71.3160669 C79.4288809,72.9141603 81.0708754,72.1272818 81.0708754,72.1272818 C90.0133271,67.2261121 99.0559877,62.115458 108.184542,56.7857759 C112.17381,54.4566346 116.120132,52.1231987 120.018736,49.784991 C120.547934,49.3512296 121.078087,48.9165138 121.612058,48.4870471 C122.032458,48.1010042 122.671886,47.4038365 123.058406,46.359278 C123.903024,44.087399 122.86276,42.0312077 122.662342,41.6489824 L119.169346,43.2236937 C119.169346,43.2236937 119.7706,43.5672671 119.737197,44.4786909 C119.731948,44.6652704 119.646531,44.8131978 119.574476,44.9177014 C119.10254,45.6100972 117.981155,46.320626 117.666213,46.516272"
          id="Fill-1211"
        />
      </g>
    </g>
  </svg>
)

export const step8Image3 = (
  <svg
    width="70px"
    height="70px"
    viewBox="0 0 128 128"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    aria-hidden="true"
  >
    <g
      id="2.verwarming/verwarming_5.3"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Group" transform="translate(1.600000, 8.000000)">
        <polyline
          id="Fill-1212"
          fill="#CBCCCB"
          points="123.002453 61.3380291 106.229391 71.0265122 106.229391 112.551778 123.002453 103.037372 123.002453 61.3380291"
        />
        <polyline
          id="Fill-1213"
          fill="#F8F7F6"
          points="106.229391 71.0265122 -9.62548559e-13 9.68848313 -9.62548559e-13 50.6631086 106.229391 112.551778 106.229391 71.0265122"
        />
        <polyline
          id="Fill-1214"
          fill="#B4B5B4"
          points="-5.00222086e-13 9.68848313 16.7730617 -1.2126596e-13 123.002453 61.3380291 106.229391 71.0265122 -5.00222086e-13 9.68848313"
        />
        <polyline
          id="Fill-1215"
          fill="#E4E4E3"
          points="96.262868 68.1862737 94.2501006 66.8015139 94.1648753 100.565838 96.262868 101.774708 96.262868 68.1862737"
        />
        <polyline
          id="Fill-1216"
          fill="#E4E4E3"
          points="86.6946674 62.7276243 84.6758556 61.3380291 84.5966747 95.1077934 86.6946674 96.3166627 86.6946674 62.7276243"
        />
        <polyline
          id="Fill-1217"
          fill="#E4E4E3"
          points="77.1264667 57.2097403 75.107655 55.8249805 75.0230341 89.5887005 77.1264667 90.8036142 77.1264667 57.2097403"
        />
        <polyline
          id="Fill-1218"
          fill="#E4E4E3"
          points="67.5522218 52.2527717 65.53341 50.8686164 65.4548335 84.6329408 67.5522218 85.8412056 67.5522218 52.2527717"
        />
        <polyline
          id="Fill-1219"
          fill="#E4E4E3"
          points="57.9840211 46.5952633 55.9652094 45.211108 55.8805885 78.9748279 57.9840211 80.190346 57.9840211 46.5952633"
        />
        <polyline
          id="Fill-1220"
          fill="#E4E4E3"
          points="48.4097762 41.3608592 46.3970088 39.9767038 46.3117835 73.7410282 48.4097762 74.9498975 48.4097762 41.3608592"
        />
        <polyline
          id="Fill-1221"
          fill="#E4E4E3"
          points="38.8415755 35.2258474 36.8227638 33.8362521 36.7435828 67.5993677 38.8415755 68.8148858 38.8415755 35.2258474"
        />
        <polyline
          id="Fill-1222"
          fill="#E4E4E3"
          points="29.2673306 29.8766007 27.2545631 28.4924453 27.1699423 62.2567697 29.2673306 63.465639 29.2673306 29.8766007"
        />
        <polyline
          id="Fill-1223"
          fill="#E4E4E3"
          points="19.6991299 24.8114383 17.6797137 23.4272829 17.6017417 57.1916073 19.6991299 58.4004766 19.6991299 24.8114383"
        />
        <polyline
          id="Fill-1224"
          fill="#E4E4E3"
          points="10.1309293 20.5803957 8.11211754 19.1962403 8.02749669 52.9605647 10.1309293 54.169434 10.1309293 20.5803957"
        />
        <polyline
          id="Fill-1225"
          fill="#E5832D"
          points="121.461749 60.9693239 105.619517 70.1984367 27.1578536 25.0653008 43.2841703 15.8301437 121.461749 60.9693239"
        />
        <polyline
          id="Fill-1226"
          fill="#E15D29"
          points="121.461749 60.9693239 105.619517 70.1984367 43.3869242 34.3977719 43.2841703 15.8301437 121.461749 60.9693239"
        />
        <polyline
          id="Fill-1227"
          fill="#B4B5B4"
          points="114.933855 57.2030916 99.0432674 66.4569862 96.5409079 65.0305204 112.594692 55.8431136 114.933855 57.2030916"
        />
        <polyline
          id="Fill-1228"
          fill="#9E9F9E"
          points="114.933855 57.2030916 114.933855 57.953195 99.6839682 66.819647 99.0432674 66.4569862 114.933855 57.2030916"
        />
        <polyline
          id="Fill-1229"
          fill="#B4B5B4"
          points="109.542297 54.1023418 93.6517103 63.3507965 91.1493508 61.9237262 107.203135 52.7369239 109.542297 54.1023418"
        />
        <polyline
          id="Fill-1230"
          fill="#9E9F9E"
          points="109.542297 54.1023418 109.542297 54.8457964 94.2918066 63.7128528 93.6517103 63.3507965 109.542297 54.1023418"
        />
        <polyline
          id="Fill-1231"
          fill="#B4B5B4"
          points="120.101771 60.1345997 104.210579 69.3884943 101.708824 67.9626329 117.762004 58.7746217 120.101771 60.1345997"
        />
        <polyline
          id="Fill-1232"
          fill="#9E9F9E"
          points="120.101771 60.1345997 120.101771 60.8847031 104.851884 69.7517595 104.210579 69.3884943 120.101771 60.1345997"
        />
        <polyline
          id="Fill-1233"
          fill="#B4B5B4"
          points="99.0432674 47.9921118 83.1460315 57.2393576 80.6503208 55.8189362 96.698061 46.6321338 99.0432674 47.9921118"
        />
        <polyline
          id="Fill-1234"
          fill="#9E9F9E"
          points="99.0432674 47.9921118 99.0432674 48.7410064 83.7867322 57.6086672 83.1460315 57.2393576 99.0432674 47.9921118"
        />
        <polyline
          id="Fill-1235"
          fill="#B4B5B4"
          points="93.6517103 44.8847132 77.7550788 54.1386078 75.2587637 52.7127465 91.3058994 43.5247353 93.6517103 44.8847132"
        />
        <polyline
          id="Fill-1236"
          fill="#9E9F9E"
          points="93.6517103 44.8847132 93.6517103 45.6348166 78.3957795 54.5018731 77.7550788 54.1386078 93.6517103 44.8847132"
        />
        <polyline
          id="Fill-1237"
          fill="#B4B5B4"
          points="104.210579 50.9236199 88.3145523 60.1775145 85.8182371 58.7504443 101.865977 49.5636419 104.210579 50.9236199"
        />
        <polyline
          id="Fill-1238"
          fill="#9E9F9E"
          points="104.210579 50.9236199 104.210579 51.6725144 88.955253 60.5395709 88.3145523 60.1775145 104.210579 50.9236199"
        />
        <polyline
          id="Fill-1239"
          fill="#B4B5B4"
          points="82.9532168 38.7376128 66.9840532 48.0338178 64.4756494 46.6019121 80.601966 37.3655461 82.9532168 38.7376128"
        />
        <polyline
          id="Fill-1240"
          fill="#9E9F9E"
          points="82.9532168 38.7376128 82.9532168 39.4877162 67.6307983 48.3964786 66.9840532 48.0338178 82.9532168 38.7376128"
        />
        <polyline
          id="Fill-1241"
          fill="#B4B5B4"
          points="77.5374823 35.6187299 61.5683187 44.9155394 59.1143139 43.4467632 75.1862315 34.2466633 77.5374823 35.6187299"
        />
        <polyline
          id="Fill-1242"
          fill="#9E9F9E"
          points="77.5374823 35.6187299 77.5374823 36.3688333 62.2090194 45.2775958 61.5683187 44.9155394 77.5374823 35.6187299"
        />
        <polyline
          id="Fill-1243"
          fill="#B4B5B4"
          points="88.1447061 41.681814 72.1761469 50.9774146 69.6677431 49.5449044 85.7940597 40.3151872 88.1447061 41.681814"
        />
        <polyline
          id="Fill-1244"
          fill="#9E9F9E"
          points="88.1447061 41.681814 88.1447061 42.4373573 72.822892 51.3461197 72.1761469 50.9774146 88.1447061 41.681814"
        />
        <polyline
          id="Fill-1245"
          fill="#B4B5B4"
          points="67.1472505 29.5743834 51.1659982 38.8711928 48.6696831 37.4507714 64.8020441 28.2144054 67.1472505 29.5743834"
        />
        <polyline
          id="Fill-1246"
          fill="#9E9F9E"
          points="67.1472505 29.5743834 67.1472505 30.317838 51.8060945 39.239898 51.1659982 38.8711928 67.1472505 29.5743834"
        />
        <polyline
          id="Fill-1247"
          fill="#B4B5B4"
          points="61.7556934 26.4681937 45.7804854 35.7643987 43.2841703 34.3379329 59.4098825 25.1082157 61.7556934 26.4681937"
        />
        <polyline
          id="Fill-1248"
          fill="#9E9F9E"
          points="61.7556934 26.4681937 61.7556934 27.2170882 46.4151418 36.1270595 45.7744411 35.7643987 61.7556934 26.4681937"
        />
        <polyline
          id="Fill-1249"
          fill="#B4B5B4"
          points="72.3151669 32.5058915 56.2976484 41.8262739 53.813422 40.3943682 69.9699604 31.1459135 72.3151669 32.5058915"
        />
        <polyline
          id="Fill-1250"
          fill="#9E9F9E"
          points="72.3151669 32.5058915 72.3151669 33.2553904 56.9437891 42.1955834 56.2976484 41.8262739 72.3151669 32.5058915"
        />
        <polyline
          id="Fill-1251"
          fill="#B4B5B4"
          points="51.0572 20.3210932 35.0880363 29.6106494 32.5735881 28.1847881 48.7053447 18.9490265 51.0572 20.3210932"
        />
        <polyline
          id="Fill-1252"
          fill="#9E9F9E"
          points="51.0572 20.3210932 51.0572 21.0699877 35.7347814 29.9793546 35.0880363 29.6106494 51.0572 20.3210932"
        />
        <polyline
          id="Fill-1253"
          fill="#B4B5B4"
          points="45.6414654 17.2022104 29.6723018 26.492371 27.1578536 25.0653008 43.2902146 15.8301437 45.6414654 17.2022104"
        />
        <polyline
          id="Fill-1254"
          fill="#9E9F9E"
          points="45.6414654 17.2022104 45.6414654 17.9511049 30.3130025 26.8610762 29.6723018 26.492371 45.6414654 17.2022104"
        />
        <polyline
          id="Fill-1255"
          fill="#B4B5B4"
          points="56.2492937 23.2640855 40.2378196 32.584468 37.7475488 31.1525623 53.8980429 21.8986676 56.2492937 23.2640855"
        />
        <polyline
          id="Fill-1256"
          fill="#9E9F9E"
          points="56.2492937 23.2640855 56.2492937 24.0141889 40.8785203 32.9537775 40.2378196 32.584468 56.2492937 23.2640855"
        />
        <polyline
          id="Fill-1257"
          fill="#E5832D"
          points="94.8484909 45.8034539 79.0056541 55.0277312 0.544595627 9.89459535 16.6709123 0.664878123 94.8484909 45.8034539"
        />
        <polyline
          id="Fill-1258"
          fill="#E15D29"
          points="94.8484909 45.8034539 79.0056541 55.0277312 16.7730617 19.2325064 16.6709123 0.664878123 94.8484909 45.8034539"
        />
        <polyline
          id="Fill-1259"
          fill="#B4B5B4"
          points="88.3199922 42.037826 72.4300095 51.2856763 69.92765 49.8658593 85.9814345 40.677848 88.3199922 42.037826"
        />
        <polyline
          id="Fill-1260"
          fill="#9E9F9E"
          points="88.3199922 42.037826 88.3199922 42.7812806 73.0707102 51.6483371 72.4300095 51.2856763 88.3199922 42.037826"
        />
        <polyline
          id="Fill-1261"
          fill="#B4B5B4"
          points="82.9290395 38.9310319 67.0378479 48.1849265 64.5360928 46.7584607 80.5898773 37.5710539 82.9290395 38.9310319"
        />
        <polyline
          id="Fill-1262"
          fill="#9E9F9E"
          points="82.9290395 38.9310319 82.9290395 39.6811353 67.679153 48.5475873 67.0378479 48.1849265 82.9290395 38.9310319"
        />
        <polyline
          id="Fill-1263"
          fill="#B4B5B4"
          points="93.4885129 44.9699385 77.5979258 54.2171844 75.0955663 52.7973673 91.1493508 43.6099605 93.4885129 44.9699385"
        />
        <polyline
          id="Fill-1264"
          fill="#9E9F9E"
          points="93.4885129 44.9699385 93.4885129 45.7188331 78.2325822 54.5864939 77.5979258 54.2171844 93.4885129 44.9699385"
        />
        <polyline
          id="Fill-1265"
          fill="#B4B5B4"
          points="72.4300095 32.8268463 56.533378 42.0740921 54.0370628 40.6536706 70.084803 31.4602195 72.4300095 32.8268463"
        />
        <polyline
          id="Fill-1266"
          fill="#9E9F9E"
          points="72.4300095 32.8268463 72.4300095 33.5703009 57.1740787 42.4373573 56.533378 42.0740921 72.4300095 32.8268463"
        />
        <polyline
          id="Fill-1267"
          fill="#B4B5B4"
          points="67.0378479 29.7200521 51.1418208 38.9739467 48.6455057 37.5474809 64.6932458 28.3600741 67.0378479 29.7200521"
        />
        <polyline
          id="Fill-1268"
          fill="#9E9F9E"
          points="67.0378479 29.7200521 67.0378479 30.4689467 51.7825216 39.3366075 51.1418208 38.9739467 67.0378479 29.7200521"
        />
        <polyline
          id="Fill-1269"
          fill="#B4B5B4"
          points="77.5979258 35.7577499 61.7012943 45.0062046 59.2049791 43.5851787 75.2521149 34.3977719 77.5979258 35.7577499"
        />
        <polyline
          id="Fill-1270"
          fill="#9E9F9E"
          points="77.5979258 35.7577499 77.5979258 36.5078533 62.341995 45.3688654 61.7012943 45.0062046 77.5979258 35.7577499"
        />
        <polyline
          id="Fill-1271"
          fill="#B4B5B4"
          points="56.3393544 23.5663029 40.3701908 32.8631123 37.8623914 31.4360421 53.9887081 22.200885 56.3393544 23.5663029"
        />
        <polyline
          id="Fill-1272"
          fill="#9E9F9E"
          points="56.3393544 23.5663029 56.3393544 24.3218462 41.0175403 33.2318175 40.3701908 32.8631123 56.3393544 23.5663029"
        />
        <polyline
          id="Fill-1273"
          fill="#B4B5B4"
          points="50.9236199 20.4480245 34.9550607 29.7442295 32.5004515 28.2814976 48.5729735 19.0813977 50.9236199 20.4480245"
        />
        <polyline
          id="Fill-1274"
          fill="#9E9F9E"
          points="50.9236199 20.4480245 50.9236199 21.2035678 35.595157 30.1123302 34.9550607 29.7442295 50.9236199 20.4480245"
        />
        <polyline
          id="Fill-1275"
          fill="#B4B5B4"
          points="61.5320526 26.5165484 45.5628889 35.8127535 43.0484407 34.3802433 59.1801973 25.1499217 61.5320526 26.5165484"
        />
        <polyline
          id="Fill-1276"
          fill="#9E9F9E"
          points="61.5320526 26.5165484 61.5320526 27.265443 46.209634 36.1754143 45.5628889 35.8127535 61.5320526 26.5165484"
        />
        <polyline
          id="Fill-1277"
          fill="#B4B5B4"
          points="40.5333881 14.4091178 24.5521358 23.7053228 22.0564251 22.278857 38.1887861 13.0436999 40.5333881 14.4091178"
        />
        <polyline
          id="Fill-1278"
          fill="#9E9F9E"
          points="40.5333881 14.4091178 40.5333881 15.1525724 25.193441 24.0746324 24.5521358 23.7053228 40.5333881 14.4091178"
        />
        <polyline
          id="Fill-1279"
          fill="#B4B5B4"
          points="35.141831 11.3023237 19.1672274 20.5991331 16.6709123 19.1720629 32.797229 9.94234568 35.141831 11.3023237"
        />
        <polyline
          id="Fill-1280"
          fill="#9E9F9E"
          points="35.141831 11.3023237 35.141831 12.0518226 19.8018838 20.9611895 19.1611831 20.5991331 35.141831 11.3023237"
        />
        <polyline
          id="Fill-1281"
          fill="#B4B5B4"
          points="45.7019089 17.3412303 29.6843905 26.6610083 27.1995596 25.2284982 43.3567024 15.9812523 45.7019089 17.3412303"
        />
        <polyline
          id="Fill-1282"
          fill="#9E9F9E"
          points="45.7019089 17.3412303 45.7019089 18.084685 30.3311356 27.0297135 29.6843905 26.6610083 45.7019089 17.3412303"
        />
        <polyline
          id="Fill-1283"
          fill="#B4B5B4"
          points="24.443942 5.14917885 8.4741739 14.4459883 5.96577007 13.0128737 22.0926912 3.78315652 24.443942 5.14917885"
        />
        <polyline
          id="Fill-1284"
          fill="#9E9F9E"
          points="24.443942 5.14917885 24.443942 5.9053266 9.12152342 14.814089 8.4741739 14.4459883 24.443942 5.14917885"
        />
        <polyline
          id="Fill-1285"
          fill="#B4B5B4"
          points="19.027603 2.03029601 3.0590438 11.326501 0.544595627 9.89459535 16.6769566 0.664878123 19.027603 2.03029601"
        />
        <polyline
          id="Fill-1286"
          fill="#9E9F9E"
          points="19.027603 2.03029601 19.027603 2.77979499 3.6991401 11.6891618 3.0590438 11.326501 19.027603 2.03029601"
        />
        <polyline
          id="Fill-1287"
          fill="#B4B5B4"
          points="29.6360357 8.09942441 13.6239572 17.4192024 11.1342908 15.9866923 27.2847849 6.73279765 29.6360357 8.09942441"
        />
        <polyline
          id="Fill-1288"
          fill="#9E9F9E"
          points="29.6360357 8.09942441 29.6360357 8.84831895 14.2652624 17.7879075 13.6239572 17.4192024 29.6360357 8.09942441"
        />
      </g>
    </g>
  </svg>
)
export const step8Image4 = (
  <svg
    width="70px"
    height="70px"
    viewBox="0 0 128 128"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    aria-hidden="true"
  >
    <g
      id="2.verwarming/verwarming_5.4"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Group" transform="translate(0.000000, 17.600000)">
        <path
          d="M60.279664,7.83551621 L52.4597906,12.3506431 C51.7199626,12.7779482 50.8006175,12.2230772 50.8359769,11.369011 L50.8465847,11.0834156 C50.8601845,10.7162216 51.0617332,10.381667 51.3772481,10.19399 L59.1862417,5.58094471 C59.909478,5.15663158 60.8206632,5.67587118 60.8206632,6.51361761 L60.8206632,6.8974034 C60.8206632,7.28336515 60.6142186,7.64239934 60.279664,7.83551621"
          id="Fill-1289"
          fill="#777776"
        />
        <path
          d="M57.5461082,5.9834982 C58.4654533,6.51361761 59.9641491,6.85660406 61.4737246,5.9834982 C62.3196309,5.49662608 62.2625119,4.14752792 61.4737246,3.71777488 C60.712137,3.30134962 59.2379208,2.7410387 57.809944,3.56518535 C57.252353,3.88913211 56.9964051,4.37056431 56.9721975,4.82996487 C56.942278,5.30867712 57.1625944,5.76290977 57.5461082,5.9834982"
          id="Fill-1290"
          fill="#E15D29"
        />
        <polyline
          id="Fill-1291"
          fill="#E15D29"
          points="56.9694776 1.68868774 62.0800028 1.68868774 62.0800028 4.96596267 56.9721975 4.96596267 56.9694776 1.68868774"
        />
        <path
          d="M57.5461082,2.84466902 C58.4654533,3.37478843 59.9641491,3.71478293 61.4737246,2.84466902 C62.3196309,2.35480495 62.2625119,1.00869875 61.4737246,0.575953753 C60.712137,0.160072487 59.2379208,-0.400510437 57.809944,0.423636219 C56.6702824,1.08186556 56.7954004,2.40947607 57.5461082,2.84466902"
          id="Fill-1292"
          fill="#E5832D"
        />
        <polyline
          id="Fill-1293"
          fill="#CBCCCB"
          points="3.46250394 28.6733708 11.0103817 33.0331882 11.0103817 68.0390214 3.46250394 63.7578107 3.46250394 28.6733708"
        />
        <polyline
          id="Fill-1294"
          fill="#F8F7F6"
          points="11.0103817 33.0331882 58.8160557 5.42862718 58.8160557 40.1893923 11.0103817 68.0390214 11.0103817 33.0331882"
        />
        <polyline
          id="Fill-1295"
          fill="#B4B5B4"
          points="58.8160557 5.42862718 51.2681779 1.07098574 3.46250394 28.6733708 11.0103817 33.0331882 58.8160557 5.42862718"
        />
        <polyline
          id="Fill-1296"
          fill="#E4E4E3"
          points="15.4953171 31.752089 16.4040544 31.129219 16.4391418 62.6426288 15.4953171 63.1896119 15.4953171 31.752089"
        />
        <polyline
          id="Fill-1297"
          fill="#E4E4E3"
          points="19.8012794 29.2962407 20.7097447 28.6733708 20.7475521 60.1865086 19.8012794 60.7334917 19.8012794 29.2962407"
        />
        <polyline
          id="Fill-1298"
          fill="#E4E4E3"
          points="24.1096896 26.8156409 25.015435 26.192771 25.0535143 57.7059087 24.1096896 58.2498999 24.1096896 26.8156409"
        />
        <polyline
          id="Fill-1299"
          fill="#E4E4E3"
          points="28.4153799 24.585005 29.3238452 23.9621351 29.3592046 55.4758168 28.4153799 56.019808 28.4153799 24.585005"
        />
        <polyline
          id="Fill-1300"
          fill="#E4E4E3"
          points="32.7237901 22.0391262 33.6295355 21.4162563 33.6673429 52.9296661 32.7237901 53.4736572 32.7237901 22.0391262"
        />
        <polyline
          id="Fill-1301"
          fill="#E4E4E3"
          points="37.0294804 19.6809244 37.9379457 19.0583265 37.9730332 50.5714642 37.0294804 51.1184474 37.0294804 19.6809244"
        />
        <polyline
          id="Fill-1302"
          fill="#E4E4E3"
          points="41.3351707 16.9204411 42.243636 16.2975712 42.2817154 47.8107089 41.3351707 48.3576921 41.3351707 16.9204411"
        />
        <polyline
          id="Fill-1303"
          fill="#E4E4E3"
          points="45.643581 14.515728 46.5520462 13.8928581 46.5874057 45.4065399 45.643581 45.9502591 45.643581 14.515728"
        />
        <polyline
          id="Fill-1304"
          fill="#E4E4E3"
          points="49.9492712 12.236405 50.8577365 11.613535 50.8958159 43.1269448 49.9492712 43.670936 49.9492712 12.236405"
        />
        <polyline
          id="Fill-1305"
          fill="#E4E4E3"
          points="54.2576815 10.3324358 55.1634268 9.7071179 55.2015062 41.2229756 54.2576815 41.7669668 54.2576815 10.3324358"
        />
        <polygon
          id="Fill-2868"
          fill="#9E9F9E"
          points="-3.27418093e-13 72.9569738 3.04091076 72.9569738 3.04091076 63.3936086 -3.27418093e-13 63.3936086"
        />
        <path
          d="M-3.27418093e-13,72.9569738 C-3.27418093e-13,71.8823192 0.67998899,71.0122053 1.52045538,71.0122053 C2.35820182,71.0122053 3.04091076,71.8823192 3.04091076,72.9569738 C3.04091076,74.0310844 2.35820182,74.9014703 1.52045538,74.9014703 C0.67998899,74.9014703 -3.27418093e-13,74.0310844 -3.27418093e-13,72.9569738"
          id="Fill-2869"
          fill="#9E9F9E"
        />
        <line
          x1="7.04329707"
          y1="54.1470895"
          x2="7.04329707"
          y2="54.1470895"
          id="Fill-2870"
          fill="#9E9F9E"
        />
        <path
          d="M6.92745583,57.7497 L4.71912359,58.8077629 C4.34648962,59.1910047 4.10441354,59.2211962 3.49242345,60.2357398 C2.67643666,61.5927258 3.00555133,62.8819849 3.04091076,63.3936086 C2.02636719,63.3936086 1.01155162,63.3936086 -1.09139364e-13,63.3936086 C0.00788787228,62.3437056 -1.09139364e-13,60.7334917 0.459400562,59.2674354 C0.92206507,57.7986592 1.68637269,57.1649095 2.99439952,56.4656088 C3.06539037,56.4278014 6.94377557,54.3823945 6.98729486,54.3630828"
          id="Fill-2871"
          fill="#9E9F9E"
        />
        <path
          d="M5.67926804,56.0497275 C5.67926804,55.1086228 6.2746664,54.3443152 7.01204646,54.3443152 C7.74643457,54.3443152 8.34482488,55.1086228 8.34482488,56.0497275 C8.34482488,56.9935523 7.74643457,57.7551399 7.01204646,57.7551399 C6.2746664,57.7551399 5.67926804,56.9935523 5.67926804,56.0497275"
          id="Fill-2872"
          fill="#9E9F9E"
        />
      </g>
      <g id="Group" transform="translate(52.800000, 43.200000)">
        <polyline
          id="Fill-1212"
          fill="#CBCCCB"
          points="73.8014717 36.8028174 63.7376346 42.6159073 63.7376346 67.5310666 73.8014717 61.822423 73.8014717 36.8028174"
        />
        <polyline
          id="Fill-1213"
          fill="#F8F7F6"
          points="63.7376346 42.6159073 -5.77529136e-13 5.81308988 -5.77529136e-13 30.3978651 63.7376346 67.5310666 63.7376346 42.6159073"
        />
        <polyline
          id="Fill-1214"
          fill="#B4B5B4"
          points="-3.00133252e-13 5.81308988 10.063837 -7.27595761e-14 73.8014717 36.8028174 63.7376346 42.6159073 -3.00133252e-13 5.81308988"
        />
        <polyline
          id="Fill-1215"
          fill="#E4E4E3"
          points="57.7577208 40.9117642 56.5500604 40.0809084 56.4989252 60.339503 57.7577208 61.0648246 57.7577208 40.9117642"
        />
        <polyline
          id="Fill-1216"
          fill="#E4E4E3"
          points="52.0168004 37.6365746 50.8055134 36.8028174 50.7580048 57.064676 52.0168004 57.7899976 52.0168004 37.6365746"
        />
        <polyline
          id="Fill-1217"
          fill="#E4E4E3"
          points="46.27588 34.3258442 45.064593 33.4949883 45.0138205 53.7532203 46.27588 54.4821685 46.27588 34.3258442"
        />
        <polyline
          id="Fill-1218"
          fill="#E4E4E3"
          points="40.5313331 31.351663 39.320046 30.5211698 39.2729001 50.7797645 40.5313331 51.5047234 40.5313331 31.351663"
        />
        <polyline
          id="Fill-1219"
          fill="#E4E4E3"
          points="34.7904127 27.957158 33.5791256 27.1266648 33.5283531 47.3848968 34.7904127 48.1142076 34.7904127 27.957158"
        />
        <polyline
          id="Fill-1220"
          fill="#E4E4E3"
          points="29.0458657 24.8165155 27.8382053 23.9860223 27.7870701 44.2446169 29.0458657 44.9699385 29.0458657 24.8165155"
        />
        <polyline
          id="Fill-1221"
          fill="#E4E4E3"
          points="23.3049453 21.1355084 22.0936583 20.3017513 22.0461497 40.5596206 23.3049453 41.2889315 23.3049453 21.1355084"
        />
        <polyline
          id="Fill-1222"
          fill="#E4E4E3"
          points="17.5603983 17.9259604 16.3527379 17.0954672 16.3019654 37.3540618 17.5603983 38.0793834 17.5603983 17.9259604"
        />
        <polyline
          id="Fill-1223"
          fill="#E4E4E3"
          points="11.819478 14.886863 10.6078282 14.0563697 10.561045 34.3149644 11.819478 35.040286 11.819478 14.886863"
        />
        <polyline
          id="Fill-1224"
          fill="#E4E4E3"
          points="6.07855758 12.3482374 4.86727052 11.5177442 4.81649801 31.7763388 6.07855758 32.5016604 6.07855758 12.3482374"
        />
        <polyline
          id="Fill-1225"
          fill="#E5832D"
          points="72.8770493 36.5815943 63.3717099 42.119062 16.2947122 15.0391805 25.9705022 9.49808621 72.8770493 36.5815943"
        />
        <polyline
          id="Fill-1226"
          fill="#E15D29"
          points="72.8770493 36.5815943 63.3717099 42.119062 26.0321545 20.6386632 25.9705022 9.49808621 72.8770493 36.5815943"
        />
        <polyline
          id="Fill-1227"
          fill="#B4B5B4"
          points="68.9603127 34.3218549 59.4259605 39.8741917 57.9245448 39.0183122 67.5568155 33.5058681 68.9603127 34.3218549"
        />
        <polyline
          id="Fill-1228"
          fill="#9E9F9E"
          points="68.9603127 34.3218549 68.9603127 34.771917 59.8103809 40.0917882 59.4259605 39.8741917 68.9603127 34.3218549"
        />
        <polyline
          id="Fill-1229"
          fill="#B4B5B4"
          points="65.7253785 32.4614051 56.1910262 38.0104779 54.6896105 37.1542357 64.3218812 31.6421543 65.7253785 32.4614051"
        />
        <polyline
          id="Fill-1230"
          fill="#9E9F9E"
          points="65.7253785 32.4614051 65.7253785 32.9074778 56.575084 38.2277117 56.1910262 38.0104779 65.7253785 32.4614051"
        />
        <polyline
          id="Fill-1231"
          fill="#B4B5B4"
          points="72.0610625 36.0807598 62.5263476 41.6330966 61.0252946 40.7775797 70.6572026 35.264773 72.0610625 36.0807598"
        />
        <polyline
          id="Fill-1232"
          fill="#9E9F9E"
          points="72.0610625 36.0807598 72.0610625 36.5308218 62.9111307 41.8510557 62.5263476 41.6330966 72.0610625 36.0807598"
        />
        <polyline
          id="Fill-1233"
          fill="#B4B5B4"
          points="59.4259605 28.7952671 49.8876189 34.3436146 48.3901925 33.4913617 58.0188366 27.9792803 59.4259605 28.7952671"
        />
        <polyline
          id="Fill-1234"
          fill="#9E9F9E"
          points="59.4259605 28.7952671 59.4259605 29.2446038 50.2720393 34.5652003 49.8876189 34.3436146 59.4259605 28.7952671"
        />
        <polyline
          id="Fill-1235"
          fill="#B4B5B4"
          points="56.1910262 26.9308279 46.6530473 32.4831647 45.1552582 31.6276479 54.7835396 26.1148412 56.1910262 26.9308279"
        />
        <polyline
          id="Fill-1236"
          fill="#9E9F9E"
          points="56.1910262 26.9308279 56.1910262 27.38089 47.0374677 32.7011238 46.6530473 32.4831647 56.1910262 26.9308279"
        />
        <polyline
          id="Fill-1237"
          fill="#B4B5B4"
          points="62.5263476 30.5541719 52.9887314 36.1065087 51.4909423 35.2502666 61.1195864 29.7381852 62.5263476 30.5541719"
        />
        <polyline
          id="Fill-1238"
          fill="#9E9F9E"
          points="62.5263476 30.5541719 62.5263476 31.0035087 53.3731518 36.3237425 52.9887314 36.1065087 62.5263476 30.5541719"
        />
        <polyline
          id="Fill-1239"
          fill="#B4B5B4"
          points="49.7719301 23.2425677 40.1904319 28.8202907 38.6853896 27.9611473 48.3611796 22.4193277 49.7719301 23.2425677"
        />
        <polyline
          id="Fill-1240"
          fill="#9E9F9E"
          points="49.7719301 23.2425677 49.7719301 23.6926297 40.578479 29.0378872 40.1904319 28.8202907 49.7719301 23.2425677"
        />
        <polyline
          id="Fill-1241"
          fill="#B4B5B4"
          points="46.5224894 21.371238 36.9409912 26.9493236 35.4685884 26.0680579 45.1117389 20.547998 46.5224894 21.371238"
        />
        <polyline
          id="Fill-1242"
          fill="#9E9F9E"
          points="46.5224894 21.371238 46.5224894 21.8213 37.3254116 27.1665575 36.9409912 26.9493236 46.5224894 21.371238"
        />
        <polyline
          id="Fill-1243"
          fill="#B4B5B4"
          points="52.8868237 25.0090884 43.3056881 30.5864488 41.8006458 29.7269427 51.4764358 24.1891123 52.8868237 25.0090884"
        />
        <polyline
          id="Fill-1244"
          fill="#9E9F9E"
          points="52.8868237 25.0090884 52.8868237 25.4624144 43.6937352 30.8076718 43.3056881 30.5864488 52.8868237 25.0090884"
        />
        <polyline
          id="Fill-1245"
          fill="#B4B5B4"
          points="40.2883503 17.74463 30.6995989 23.3227157 29.2018098 22.4704628 38.8812264 16.9286432 40.2883503 17.74463"
        />
        <polyline
          id="Fill-1246"
          fill="#9E9F9E"
          points="40.2883503 17.74463 40.2883503 18.1907028 31.0836567 23.5439388 30.6995989 23.3227157 40.2883503 17.74463"
        />
        <polyline
          id="Fill-1247"
          fill="#B4B5B4"
          points="37.053416 15.8809162 27.4682912 21.4586392 25.9705022 20.6027597 35.6459295 15.0649294 37.053416 15.8809162"
        />
        <polyline
          id="Fill-1248"
          fill="#9E9F9E"
          points="37.053416 15.8809162 37.053416 16.3302529 27.8490851 21.6762357 27.4646646 21.4586392 37.053416 15.8809162"
        />
        <polyline
          id="Fill-1249"
          fill="#B4B5B4"
          points="43.3891001 19.5035349 33.7785891 25.0957643 32.2880532 24.2366209 41.9819762 18.6875481 43.3891001 19.5035349"
        />
        <polyline
          id="Fill-1250"
          fill="#9E9F9E"
          points="43.3891001 19.5035349 43.3891001 19.9532343 34.1662735 25.3173501 33.7785891 25.0957643 43.3891001 19.5035349"
        />
        <polyline
          id="Fill-1251"
          fill="#B4B5B4"
          points="30.63432 12.1926559 21.0528218 17.7663897 19.5441529 16.9108729 29.2232068 11.3694159 30.63432 12.1926559"
        />
        <polyline
          id="Fill-1252"
          fill="#9E9F9E"
          points="30.63432 12.1926559 30.63432 12.6419926 21.4408688 17.9876127 21.0528218 17.7663897 30.63432 12.1926559"
        />
        <polyline
          id="Fill-1253"
          fill="#B4B5B4"
          points="27.3848793 10.3213262 17.8033811 15.8954226 16.2947122 15.0391805 25.9741288 9.49808621 27.3848793 10.3213262"
        />
        <polyline
          id="Fill-1254"
          fill="#9E9F9E"
          points="27.3848793 10.3213262 27.3848793 10.7706629 18.1878015 16.1166457 17.8033811 15.8954226 27.3848793 10.3213262"
        />
        <polyline
          id="Fill-1255"
          fill="#B4B5B4"
          points="33.7495762 13.9584513 24.1426918 19.5506808 22.6485293 18.6915374 32.3388257 13.1392006 33.7495762 13.9584513"
        />
        <polyline
          id="Fill-1256"
          fill="#9E9F9E"
          points="33.7495762 13.9584513 33.7495762 14.4085134 24.5271122 19.7722665 24.1426918 19.5506808 33.7495762 13.9584513"
        />
        <polyline
          id="Fill-1257"
          fill="#E5832D"
          points="56.9090945 27.4820724 47.4033925 33.0166387 0.326757376 5.93675721 10.0025474 0.398926874 56.9090945 27.4820724"
        />
        <polyline
          id="Fill-1258"
          fill="#E15D29"
          points="56.9090945 27.4820724 47.4033925 33.0166387 10.063837 11.5395038 10.0025474 0.398926874 56.9090945 27.4820724"
        />
        <polyline
          id="Fill-1259"
          fill="#B4B5B4"
          points="52.9919953 25.2226956 43.4580057 30.7714058 41.95659 29.9195156 51.5888607 24.4067088 52.9919953 25.2226956"
        />
        <polyline
          id="Fill-1260"
          fill="#9E9F9E"
          points="52.9919953 25.2226956 52.9919953 25.6687684 43.8424261 30.9890022 43.4580057 30.7714058 52.9919953 25.2226956"
        />
        <polyline
          id="Fill-1261"
          fill="#B4B5B4"
          points="49.7574237 23.3586191 40.2227087 28.9109559 38.7216557 28.0550764 48.3539264 22.5426323 49.7574237 23.3586191"
        />
        <polyline
          id="Fill-1262"
          fill="#9E9F9E"
          points="49.7574237 23.3586191 49.7574237 23.8086812 40.6074918 29.1285524 40.2227087 28.9109559 49.7574237 23.3586191"
        />
        <polyline
          id="Fill-1263"
          fill="#B4B5B4"
          points="56.0931078 26.9819631 46.5587555 32.5303106 45.0573398 31.6784204 54.6896105 26.1659763 56.0931078 26.9819631"
        />
        <polyline
          id="Fill-1264"
          fill="#9E9F9E"
          points="56.0931078 26.9819631 56.0931078 27.4312998 46.9395493 32.7518964 46.5587555 32.5303106 56.0931078 26.9819631"
        />
        <polyline
          id="Fill-1265"
          fill="#B4B5B4"
          points="43.4580057 19.6961078 33.9200268 25.2444552 32.4222377 24.3922024 42.0508818 18.8761317 43.4580057 19.6961078"
        />
        <polyline
          id="Fill-1266"
          fill="#9E9F9E"
          points="43.4580057 19.6961078 43.4580057 20.1421805 34.3044472 25.4624144 33.9200268 25.2444552 43.4580057 19.6961078"
        />
        <polyline
          id="Fill-1267"
          fill="#B4B5B4"
          points="40.2227087 17.8320313 30.6850925 23.384368 29.1873034 22.5284886 38.8159475 17.0160445 40.2227087 17.8320313"
        />
        <polyline
          id="Fill-1268"
          fill="#9E9F9E"
          points="40.2227087 17.8320313 40.2227087 18.281368 31.0695129 23.6019645 30.6850925 23.384368 40.2227087 17.8320313"
        />
        <polyline
          id="Fill-1269"
          fill="#B4B5B4"
          points="46.5587555 21.4546499 37.0207766 27.0037228 35.5229875 26.1511072 45.1512689 20.6386632 46.5587555 21.4546499"
        />
        <polyline
          id="Fill-1270"
          fill="#9E9F9E"
          points="46.5587555 21.4546499 46.5587555 21.904712 37.405197 27.2213192 37.0207766 27.0037228 46.5587555 21.4546499"
        />
        <polyline
          id="Fill-1271"
          fill="#B4B5B4"
          points="33.8036127 14.1397817 24.2221145 19.7178674 22.7174348 18.8616253 32.3932248 13.320531 33.8036127 14.1397817"
        />
        <polyline
          id="Fill-1272"
          fill="#9E9F9E"
          points="33.8036127 14.1397817 33.8036127 14.5931077 24.6105242 19.9390905 24.2221145 19.7178674 33.8036127 14.1397817"
        />
        <polyline
          id="Fill-1273"
          fill="#B4B5B4"
          points="30.5541719 12.2688147 20.9730364 17.8465377 19.5002709 16.9688986 29.1437841 11.4488386 30.5541719 12.2688147"
        />
        <polyline
          id="Fill-1274"
          fill="#9E9F9E"
          points="30.5541719 12.2688147 30.5541719 12.7221407 21.3570942 18.0673981 20.9730364 17.8465377 30.5541719 12.2688147"
        />
        <polyline
          id="Fill-1275"
          fill="#B4B5B4"
          points="36.9192315 15.9099291 27.3377334 21.4876521 25.8290644 20.628146 35.5081184 15.089953 36.9192315 15.9099291"
        />
        <polyline
          id="Fill-1276"
          fill="#9E9F9E"
          points="36.9192315 15.9099291 36.9192315 16.3592658 27.7257804 21.7052486 27.3377334 21.4876521 36.9192315 15.9099291"
        />
        <polyline
          id="Fill-1277"
          fill="#B4B5B4"
          points="24.3200329 8.64547068 14.7312815 14.2231937 13.2338551 13.3673142 22.9132717 7.82621995 24.3200329 8.64547068"
        />
        <polyline
          id="Fill-1278"
          fill="#9E9F9E"
          points="24.3200329 8.64547068 24.3200329 9.09154346 15.1160646 14.4447794 14.7312815 14.2231937 24.3200329 8.64547068"
        />
        <polyline
          id="Fill-1279"
          fill="#B4B5B4"
          points="21.0850986 6.7813942 11.5003365 12.3594799 10.0025474 11.5032377 19.6783374 5.96540741 21.0850986 6.7813942"
        />
        <polyline
          id="Fill-1280"
          fill="#9E9F9E"
          points="21.0850986 6.7813942 21.0850986 7.23109358 11.8811303 12.5767137 11.4967098 12.3594799 21.0850986 6.7813942"
        />
        <polyline
          id="Fill-1281"
          fill="#B4B5B4"
          points="27.4211453 10.4047382 17.8106343 15.996605 16.3197358 15.1370989 26.0140215 9.58875141 27.4211453 10.4047382"
        />
        <polyline
          id="Fill-1282"
          fill="#9E9F9E"
          points="27.4211453 10.4047382 27.4211453 10.850811 18.1986813 16.2178281 17.8106343 15.996605 27.4211453 10.4047382"
        />
        <polyline
          id="Fill-1283"
          fill="#B4B5B4"
          points="14.6663652 3.08950731 5.08450434 8.66759299 3.57946204 7.80772425 13.2556147 2.26989391 14.6663652 3.08950731"
        />
        <polyline
          id="Fill-1284"
          fill="#9E9F9E"
          points="14.6663652 3.08950731 14.6663652 3.54319596 5.47291405 8.88845341 5.08450434 8.66759299 14.6663652 3.08950731"
        />
        <polyline
          id="Fill-1285"
          fill="#B4B5B4"
          points="11.4165618 1.21817761 1.83542628 6.79590063 0.326757376 5.93675721 10.006174 0.398926874 11.4165618 1.21817761"
        />
        <polyline
          id="Fill-1286"
          fill="#9E9F9E"
          points="11.4165618 1.21817761 11.4165618 1.66787699 2.21948406 7.01349711 1.83542628 6.79590063 11.4165618 1.21817761"
        />
        <polyline
          id="Fill-1287"
          fill="#B4B5B4"
          points="17.7816214 4.85965465 8.17437431 10.4515214 6.6805745 9.59201536 16.3708709 4.03967859 17.7816214 4.85965465"
        />
        <polyline
          id="Fill-1288"
          fill="#9E9F9E"
          points="17.7816214 4.85965465 17.7816214 5.30899137 8.55915741 10.6727445 8.17437431 10.4515214 17.7816214 4.85965465"
        />
      </g>
    </g>
  </svg>
)

export const step11Image1 = (
  <svg
    width="70px"
    height="70px"
    viewBox="0 0 128 128"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    aria-hidden="true"
  >
    <g
      id="2.verwarming/verwarming_1.2"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Group" transform="translate(29.001401, 0.000000)">
        <polyline
          id="Fill-2513"
          fill="#DE482A"
          points="42.4426461 3.76260574 35.778754 1.5158245e-13 1.5158245e-13 81.2851283 8.70763679 86.2339371 42.4426461 3.76260574"
        />
        <polyline
          id="Fill-2514"
          fill="#DE482A"
          points="34.8267694 61.4898933 28.1628773 57.7272875 4.26881977 121.94847 12.9802343 126.897656 34.8267694 61.4898933"
        />
        <polyline
          id="Fill-2515"
          fill="#DE482A"
          points="67.4775741 22.2209069 61.1007885 18.3445919 29.9724036 40.470678 31.1434957 55.1244408 67.4775741 22.2209069"
        />
        <polyline
          id="Fill-2516"
          fill="#E67848"
          points="12.7006832 127.467714 67.4775741 22.2209069 32.6016943 50.5160043 42.4426461 3.76260574 8.70763679 86.2339371 34.8267694 61.4898933 12.7006832 127.467714"
        />
      </g>
    </g>
  </svg>
)
export const step11Image2 = (
  <svg
    width="70px"
    height="70px"
    viewBox="0 0 128 128"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    aria-hidden="true"
  >
    <g
      id="2.verwarming/verwarming_6.2"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Group" transform="translate(22.400000, 1.600000)">
        <path
          d="M8.67240958,69.7486395 C8.67240958,70.9981193 9.68672649,72.0127195 10.9359229,72.0127195 C12.185686,72.0127195 13.2000029,70.9981193 13.2000029,69.7486395 C13.2000029,68.4994431 12.185686,67.4851261 10.9359229,67.4851261 C9.68672649,67.4851261 8.67240958,68.4994431 8.67240958,69.7486395"
          id="Fill-747"
          fill="#777776"
        />
        <polygon
          id="Fill-748"
          fill="#777776"
          points="8.67240958 69.1765988 13.1997196 69.1765988 13.1997196 30.6155565 8.67240958 30.6155565"
        />
        <path
          d="M37.9657686,47.8246611 C37.9657686,49.0744242 38.9800855,50.0887412 40.229282,50.0887412 C41.4787617,50.0887412 42.493362,49.0744242 42.493362,47.8246611 C42.493362,46.5723481 41.4787617,45.5611478 40.229282,45.5611478 C38.9800855,45.5611478 37.9657686,46.5723481 37.9657686,47.8246611"
          id="Fill-749"
          fill="#777776"
        />
        <polygon
          id="Fill-750"
          fill="#777776"
          points="37.9657686 47.2523371 42.4930786 47.2523371 42.4930786 8.69129478 37.9657686 8.69129478"
        />
        <polyline
          id="Fill-751"
          fill="#F8F7F6"
          points="1.6656897 24.7447015 6.9497708 35.9648032 49.8854089 11.3404186 44.7656585 0.0642178034 1.6656897 24.7447015"
        />
        <path
          d="M8.77185797,32.4059108 C8.77185797,35.8514717 6.98377025,36.9675036 4.56102615,35.5933592 C1.75352161,34.0010516 0,31.5845408 0,28.1364299 C0,24.6908691 1.9742347,23.9428812 4.45931113,25.2008608 C7.00331994,26.4846233 8.77185797,28.9580833 8.77185797,32.4059108"
          id="Fill-752"
          fill="#8A8B8A"
        />
        <path
          d="M51.6618802,7.68547774 C51.6618802,11.0942059 49.8967421,12.1960714 47.4997809,10.8363767 C44.7228759,9.26361885 42.9917372,6.87544085 42.9917372,3.46671271 C42.9917372,0.0611011872 44.9413223,-0.678386839 47.4006158,0.565709683 C49.9137418,1.83502246 51.6618802,4.27986621 51.6618802,7.68547774"
          id="Fill-753"
          fill="#F8F7F6"
        />
        <path
          d="M11.7011939,27.8701009 C11.7011939,29.0654649 12.494231,30.0375658 13.4719985,30.0375658 C14.449766,30.0375658 15.2428032,29.0654649 15.2428032,27.8701009 C15.2428032,26.6741703 14.449766,25.7023527 13.4719985,25.7023527 C12.494231,25.7023527 11.7011939,26.6741703 11.7011939,27.8701009"
          id="Fill-754"
          fill="#2A90C3"
        />
        <path
          d="M17.0532739,24.6285367 C17.0532739,25.8273007 17.8465944,26.796285 18.8240785,26.796285 C19.8015627,26.796285 20.5948832,25.8273007 20.5948832,24.6285367 C20.5948832,23.4331728 19.8015627,22.4610718 18.8240785,22.4610718 C17.8465944,22.4610718 17.0532739,23.4331728 17.0532739,24.6285367"
          id="Fill-755"
          fill="#2A90C3"
        />
        <path
          d="M22.4053539,21.7754163 C22.4053539,22.9713469 23.1958411,23.9428812 24.1761585,23.9428812 C25.1536427,23.9428812 25.9466799,22.9713469 25.9466799,21.7754163 C25.9466799,20.5800523 25.1536427,19.6082347 24.1761585,19.6082347 C23.1958411,19.6082347 22.4053539,20.5800523 22.4053539,21.7754163"
          id="Fill-756"
          fill="#2A90C3"
        />
        <path
          d="M27.7546006,18.7296322 C27.7546006,19.9255629 28.5479211,20.8970972 29.5254053,20.8970972 C30.5057227,20.8970972 31.2964933,19.9255629 31.2964933,18.7296322 C31.2964933,17.5311517 30.5057227,16.5624507 29.5254053,16.5624507 C28.5479211,16.5624507 27.7546006,17.5311517 27.7546006,18.7296322"
          id="Fill-757"
          fill="#2A90C3"
        />
        <path
          d="M33.1063973,15.5934664 C33.1063973,16.7888303 33.9000011,17.7609313 34.8774853,17.7609313 C35.8549694,17.7609313 36.6480066,16.7888303 36.6480066,15.5934664 C36.6480066,14.3947024 35.8549694,13.4260015 34.8774853,13.4260015 C33.9000011,13.4260015 33.1063973,14.3947024 33.1063973,15.5934664"
          id="Fill-758"
          fill="#2A90C3"
        />
        <path
          d="M38.4587606,12.6355143 C38.4587606,13.8308782 39.2520811,14.8029792 40.229282,14.8029792 C41.2070495,14.8029792 42.0003699,13.8308782 42.0003699,12.6355143 C42.0003699,11.4395836 41.2070495,10.467766 40.229282,10.467766 C39.2520811,10.467766 38.4587606,11.4395836 38.4587606,12.6355143"
          id="Fill-759"
          fill="#2A90C3"
        />
        <path
          d="M43.8108406,9.78211045 C43.8108406,10.9780411 44.6041611,11.9495754 45.5816453,11.9495754 C46.5588461,11.9495754 47.3524499,10.9780411 47.3524499,9.78211045 C47.3524499,8.58362986 46.5588461,7.61464555 45.5816453,7.61464555 C44.6041611,7.61464555 43.8108406,8.58362986 43.8108406,9.78211045"
          id="Fill-760"
          fill="#2A90C3"
        />
        <polyline
          id="Fill-761"
          fill="#2A90C3"
          points="12.1573532 29.3204608 37.6059411 78.9627736 41.0622685 76.9253566 15.0728059 26.9461659 12.1573532 29.3204608"
        />
        <polyline
          id="Fill-762"
          fill="#2A90C3"
          points="17.4952667 26.0482971 42.940738 75.6928766 46.3976321 73.6529096 20.4078862 23.6740022 17.4952667 26.0482971"
        />
        <polyline
          id="Fill-763"
          fill="#2A90C3"
          points="22.7481817 23.0365125 48.193653 72.681092 51.650547 70.6439583 25.6608012 20.6650509 22.7481817 23.0365125"
        />
        <polyline
          id="Fill-764"
          fill="#2A90C3"
          points="28.0659789 20.0584441 53.5120169 69.7035902 56.9686276 67.6633399 30.9788817 17.6844325 28.0659789 20.0584441"
        />
        <polyline
          id="Fill-765"
          fill="#2A90C3"
          points="33.4013425 16.7862804 58.8499305 66.4308599 62.3034245 64.3911762 36.313962 14.4145354 33.4013425 16.7862804"
        />
        <polyline
          id="Fill-766"
          fill="#2A90C3"
          points="38.6542575 13.7770458 64.1028454 63.4219086 67.5566228 61.3819416 41.566877 11.4030342 38.6542575 13.7770458"
        />
        <polyline
          id="Fill-767"
          fill="#2A90C3"
          points="44.2301672 11.065873 69.6787551 60.7076192 73.1325325 58.6707689 47.14562 8.69129478 44.2301672 11.065873"
        />
        <polyline
          id="Fill-768"
          fill="#E4E4E3"
          points="36.3026289 84.3797359 80.5472458 58.3701571 77.5467944 65.2893284 33.4693414 90.8339648 36.3026289 84.3797359"
        />
        <polyline
          id="Fill-769"
          fill="#9E9F9E"
          points="33.8716682 71.6812249 37.6059411 78.9627736 41.113551 76.9253566 37.2914462 69.6752573 33.8716682 71.6812249"
        />
        <polyline
          id="Fill-770"
          fill="#9E9F9E"
          points="39.2917471 68.5728252 43.02602 75.8572073 46.5336299 73.8172403 42.7118084 66.5668577 39.2917471 68.5728252"
        />
        <polyline
          id="Fill-771"
          fill="#9E9F9E"
          points="44.5304956 65.5301578 48.2619352 72.8142565 51.7723784 70.7774062 47.9474403 63.5267402 44.5304956 65.5301578"
        />
        <polyline
          id="Fill-772"
          fill="#9E9F9E"
          points="49.8145768 62.4925903 53.5491329 69.7769724 57.0590095 67.7372887 53.2340714 60.4866228 49.8145768 62.4925903"
        />
        <polyline
          id="Fill-773"
          fill="#9E9F9E"
          points="55.2176559 59.3564244 58.9519288 66.6408065 62.4595387 64.6036728 58.6374339 57.3504569 55.2176559 59.3564244"
        />
        <polyline
          id="Fill-774"
          fill="#9E9F9E"
          points="60.4535712 56.3131904 64.187844 63.5975724 67.6954539 61.5576055 63.8733491 54.3072228 60.4535712 56.3131904"
        />
        <polyline
          id="Fill-775"
          fill="#9E9F9E"
          points="65.9218159 53.4235205 69.6560888 60.7076192 73.1636987 58.6707689 69.3413106 51.4172696 65.9218159 53.4235205"
        />
        <polyline
          id="Fill-776"
          fill="#8A8B8A"
          points="36.3026289 84.3797359 32.5513563 81.4645665 76.9773036 56.3471898 80.5472458 58.3701571 36.3026289 84.3797359"
        />
        <polyline
          id="Fill-777"
          fill="#8A8B8A"
          points="29.562238 88.2528399 32.5513563 81.4645665 36.3026289 84.3797359 33.4693414 90.8339648 29.562238 88.2528399"
        />
        <path
          d="M19.8667283,117.801478 C19.8667283,117.166538 19.1411234,116.651163 18.2460879,116.651163 C17.3507691,116.651163 16.6226142,117.166538 16.6226142,117.801478"
          id="Fill-778"
          fill="#E67848"
        />
        <path
          d="M16.6226142,123.201441 C16.6226142,123.83638 17.3507691,124.351755 18.2460879,124.351755 C19.1411234,124.351755 19.8667283,123.83638 19.8667283,123.201441 C19.8667283,122.566784 19.1411234,122.053959 18.2460879,122.053959 C17.3507691,122.053959 16.6226142,122.566784 16.6226142,123.201441"
          id="Fill-779"
          fill="#E67848"
        />
        <polygon
          id="Fill-780"
          fill="#E67848"
          points="16.6226142 123.201724 19.8667283 123.201724 19.8667283 117.801478 16.6226142 117.801478"
        />
        <path
          d="M25.7457998,115.098239 C25.7457998,114.463582 25.0201949,113.950757 24.1251594,113.950757 C23.2270072,113.950757 22.5016857,114.463582 22.5016857,115.098239"
          id="Fill-781"
          fill="#679CC7"
        />
        <path
          d="M22.5016857,120.501318 C22.5016857,121.135974 23.2270072,121.648799 24.1251594,121.648799 C25.0201949,121.648799 25.7457998,121.135974 25.7457998,120.501318 C25.7457998,119.866945 25.0201949,119.351003 24.1251594,119.351003 C23.2270072,119.351003 22.5016857,119.866945 22.5016857,120.501318"
          id="Fill-782"
          fill="#679CC7"
        />
        <polygon
          id="Fill-783"
          fill="#679CC7"
          points="22.5016857 120.501318 25.7457998 120.501318 25.7457998 115.098239 22.5016857 115.098239"
        />
        <path
          d="M33.4718914,109.312666 C33.4718914,112.049621 31.9450328,119.934944 20.7677137,119.934944 C8.77185797,119.934944 8.06325278,112.049621 8.06325278,109.312666 C8.06325278,106.575993 13.752494,104.357246 20.7677137,104.357246 C27.7857668,104.357246 33.4718914,106.575993 33.4718914,109.312666"
          id="Fill-784"
          fill="#777776"
        />
        <polygon
          id="Fill-785"
          fill="#777776"
          points="8.06325278 109.312666 33.4718914 109.312666 33.4718914 108.193517 8.06325278 108.193517"
        />
        <path
          d="M33.4718914,108.193517 C33.4718914,110.930473 27.7857668,113.148937 20.7677137,113.148937 C13.752494,113.148937 8.06325278,110.930473 8.06325278,108.193517 C8.06325278,105.456845 13.752494,103.238097 20.7677137,103.238097 C27.7857668,103.238097 33.4718914,105.456845 33.4718914,108.193517"
          id="Fill-786"
          fill="#777776"
        />
        <path
          d="M33.7696699,108.023803 C33.7696699,110.822808 27.9500974,113.095388 20.7677137,113.095388 C13.5881633,113.095388 7.76575759,110.822808 7.76575759,108.023803 C7.76575759,105.221398 13.5881633,102.952219 20.7677137,102.952219 C27.9500974,102.952219 33.7696699,105.221398 33.7696699,108.023803"
          id="Fill-787"
          fill="#E4E4E3"
        />
        <polygon
          id="Fill-788"
          fill="#E4E4E3"
          points="7.76575759 108.023803 33.7696699 108.023803 33.7696699 71.1681165 7.76575759 71.1681165"
        />
        <path
          d="M33.7696699,71.1681165 C33.7696699,73.9702378 27.9500974,76.2397011 20.7677137,76.2397011 C13.5881633,76.2397011 7.76575759,73.9702378 7.76575759,71.1681165 C7.76575759,68.3688285 13.5881633,66.0968153 20.7677137,66.0968153 C27.9500974,66.0968153 33.7696699,68.3688285 33.7696699,71.1681165"
          id="Fill-789"
          fill="#679CC7"
        />
        <path
          d="M20.7648804,66.9493515 C14.432483,66.9493515 9.18240132,68.8618205 7.81392348,71.428779 L7.4257631,71.428779 C7.4257631,68.233114 13.3954998,65.643206 20.7648804,65.643206 C28.1311445,65.643206 34.1068311,68.233114 34.1068311,71.428779 L33.721504,71.428779 C32.3558594,68.8618205 27.0944446,66.9493515 20.7648804,66.9493515"
          id="Fill-790"
          fill="#679CC7"
        />
        <path
          d="M7.77612806,71.8962714 C7.77612806,71.8962714 7.4257631,71.8651052 7.4257631,71.428779 C7.4257631,70.6609581 7.8257631,71.428779 7.8257631,71.428779"
          id="Fill-791"
          fill="#679CC7"
        />
        <path
          d="M20.7648804,75.520046 C14.432483,75.520046 9.18240132,73.6047437 7.81392348,71.0406186 L7.4257631,71.0406186 C7.4257631,74.2368502 13.3954998,76.8264749 20.7648804,76.8264749 C28.1311445,76.8264749 34.1068311,74.2368502 34.1068311,71.0406186 L33.721504,71.0406186 C32.3558594,73.6047437 27.0944446,75.520046 20.7648804,75.520046"
          id="Fill-792"
          fill="#1A6C95"
        />
        <path
          d="M7.77612806,70.5705762 C7.77612806,70.5705762 7.4257631,70.6042923 7.4257631,71.0406186 C7.4257631,71.8084395 7.8257631,71.0406186 7.8257631,71.0406186"
          id="Fill-793"
          fill="#1A6C95"
        />
      </g>
    </g>
  </svg>
)

export const step11Image3 = (
  <svg
    width="70px"
    height="70px"
    viewBox="0 0 128 128"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    aria-hidden="true"
  >
    <g
      id="2.verwarming/verwarming_6.3"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Group" transform="translate(41.600000, 0.000000)">
        <path
          d="M44.3270791,119.060675 C44.3270791,123.326257 35.4591592,126.789236 24.5145745,126.789236 C13.5738755,126.789236 4.7020699,123.326257 4.7020699,119.060675 C4.7020699,114.790776 13.5738755,111.328229 24.5145745,111.328229 C35.4591592,111.328229 44.3270791,114.790776 44.3270791,119.060675"
          id="Fill-794"
          fill="#777776"
        />
        <path
          d="M44.3270791,116.897663 C44.3270791,121.167994 35.4591592,124.630109 24.5145745,124.630109 C13.5738755,124.630109 4.7020699,121.167994 4.7020699,116.897663 C4.7020699,112.632513 13.5738755,109.169534 24.5145745,109.169534 C35.4591592,109.169534 44.3270791,112.632513 44.3270791,116.897663"
          id="Fill-795"
          fill="#E4E4E3"
        />
        <polygon
          id="Fill-796"
          fill="#E4E4E3"
          points="4.7020699 116.898095 44.3270791 116.898095 44.3270791 43.4722358 4.7020699 43.4722358"
        />
        <path
          d="M44.3270791,43.4722358 C44.3270791,47.7378175 35.4591592,51.2003646 24.5145745,51.2003646 C13.5738755,51.2003646 4.7020699,47.7378175 4.7020699,43.4722358 C4.7020699,39.2023367 13.5738755,35.744107 24.5145745,35.744107 C35.4591592,35.744107 44.3270791,39.2023367 44.3270791,43.4722358"
          id="Fill-797"
          fill="#777776"
        />
        <path
          d="M44.3270791,67.6276034 C44.3270791,71.8936169 35.4591592,75.3557322 24.5145745,75.3557322 C13.5738755,75.3557322 4.7020699,71.8936169 4.7020699,67.6276034 C4.7020699,63.358136 13.5738755,59.8994746 24.5145745,59.8994746 C35.4591592,59.8994746 44.3270791,63.358136 44.3270791,67.6276034"
          id="Fill-798"
          fill="#777776"
        />
        <polygon
          id="Fill-799"
          fill="#777776"
          points="4.7020699 67.6276034 44.3270791 67.6276034 44.3270791 43.415678 4.7020699 43.415678"
        />
        <path
          d="M5.75939881,1.73237086e-13 C2.57834555,1.73237086e-13 0,4.36531345 0,9.75341668 C0,15.1367708 2.57834555,19.5016525 5.75939881,19.5016525 C8.94174728,19.5016525 11.5235467,15.1367708 11.5235467,9.75341668 C11.5235467,4.36531345 8.94174728,1.73237086e-13 5.75939881,1.73237086e-13"
          id="Fill-800"
          fill="#9E9F9E"
        />
        <path
          d="M18.0639615,39.6681831 C18.0639615,42.3579173 21.1426926,44.5381995 24.9376788,44.5381995 C28.7369823,44.5381995 31.8152817,42.3579173 31.8152817,39.6681831 C31.8152817,36.9788806 28.7369823,34.7981667 24.9376788,34.7981667 C21.1426926,34.7981667 18.0639615,36.9788806 18.0639615,39.6681831"
          id="Fill-801"
          fill="#9E9F9E"
        />
        <path
          d="M18.3234366,40.7388959 L18.3234366,26.1115772 C18.3234366,26.1115772 18.3925149,22.6883184 11.1695207,19.7438581 L6.41607389,17.4811138 L6.41607389,1.07503021 L25.8184264,12.4513539 C25.8184264,12.4513539 31.693963,15.6462229 31.8109643,21.1124709 C31.9318512,26.5821728 31.8109643,39.6250092 31.8109643,39.6250092 L18.3234366,40.7388959"
          id="Fill-802"
          fill="#9E9F9E"
        />
        <path
          d="M6.83486076,25.3258122 C5.34536107,25.3258122 4.1403774,27.3679378 4.1403774,29.8892938 C4.1403774,32.4063324 5.34536107,34.4488898 6.83486076,34.4488898 C8.32436045,34.4488898 9.52848064,32.4063324 9.52848064,29.8892938 C9.52848064,27.3679378 8.32436045,25.3258122 6.83486076,25.3258122"
          id="Fill-803"
          fill="#E67848"
        />
        <path
          d="M12.5895104,43.8823879 C12.5895104,45.1383168 14.0319506,46.1572209 15.806398,46.1572209 C17.5808455,46.1572209 19.0185365,45.1383168 19.0185365,43.8823879 C19.0185365,42.6212781 17.5808455,41.6028057 15.806398,41.6028057 C14.0319506,41.6028057 12.5895104,42.6212781 12.5895104,43.8823879"
          id="Fill-804"
          fill="#E67848"
        />
        <path
          d="M12.7108291,44.378456 L12.7108291,37.5401414 C12.7108291,37.5401414 12.7410508,35.9379578 9.3644198,34.5607102 L7.14139548,33.5029496 L7.14139548,25.8309468 L16.2165501,31.1504036 C16.2165501,31.1504036 18.9619787,32.6437889 19.0185365,35.2040014 C19.0746626,37.7603283 19.0185365,43.8603692 19.0185365,43.8603692 L12.7108291,44.378456"
          id="Fill-805"
          fill="#E67848"
        />
        <path
          d="M33.101864,58.79854 L39.0210063,55.2889333 L39.2627801,83.8394044 C39.2541454,85.6354388 38.2002704,87.2117181 36.6546446,87.7854992 C34.9065332,88.4331078 33.3350031,87.5048689 33.1320858,87.3796645 L33.101864,58.79854"
          id="Fill-806"
          fill="#E4E4E3"
        />
        <polyline
          id="Fill-807"
          fill="#777776"
          points="39.0210063 55.2889333 37.7516935 54.6754322 31.8152817 58.3240588 32.2556555 86.8922312 33.1320858 87.3796645 33.101864 58.79854 39.0210063 55.2889333"
        />
      </g>
    </g>
  </svg>
)

export const step11Image4 = (
  <svg
    width="70px"
    height="70px"
    viewBox="0 0 128 128"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    aria-hidden="true"
  >
    <g
      id="2.verwarming/verwarming_6.4"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Group" transform="translate(30.400000, 0.000000)">
        <polyline
          id="Fill-822"
          fill="#F8F7F6"
          points="24.4438147 39.1172614 24.4438147 127.122152 66.7820766 102.678337 66.7820766 14.6674818 24.4438147 39.1172614"
        />
        <path
          d="M24.4438147,38.8249854 L24.4438147,126.829876 C31.6433473,124.819733 41.2049469,121.270668 51.2616261,114.792878 C57.6678382,110.659261 62.8035445,106.287647 66.7820766,102.386658 L66.7820766,14.3752058 C62.8393334,18.252336 57.7692401,22.5768274 51.4525002,26.6752523 C41.3242432,33.2299883 31.685101,36.8035094 24.4438147,38.8249854"
          id="Fill-823"
          fill="#E4E4E3"
        />
        <polyline
          id="Fill-824"
          fill="#C7C5BD"
          points="24.4438147 39.1172614 24.4438147 127.122152 -1.8698493e-15 112.819121 -1.8698493e-15 24.808265 24.4438147 39.1172614"
        />
        <path
          d="M41.37733,0 L66.7820766,14.6674818 C62.0579425,19.1231991 55.5443638,24.450376 47.0862551,29.3349636 C38.5863928,34.2499718 30.683012,37.2449057 24.4438147,39.1172614 L-9.57362844e-13,24.808265 L41.37733,0"
          id="Fill-825"
          fill="#C7C5BD"
        />
        <path
          d="M40.2559447,110.641963 L40.2559447,120.87699 C42.9347434,119.815253 46.0424124,118.353873 49.3409555,116.34373 C52.4724837,114.434989 55.085073,112.448706 57.1906529,110.641963 L57.1906529,92.8602508 L40.2559447,103.471658 L40.2559447,110.641963"
          id="Fill-826"
          fill="#C7C5BD"
        />
        <polyline
          id="Fill-827"
          fill="#E67848"
          points="47.6230885 106.829849 47.6230885 110.730839 52.0251225 108.022812 52.0251225 104.074701 47.6230885 106.829849"
        />
        <path
          d="M44.3120194,107.736501 C45.0403234,107.736501 45.6368049,108.709363 45.6368049,109.913659 C45.6368049,111.118552 45.0403234,112.096781 44.3120194,112.096781 C43.5789435,112.096781 42.9818655,111.118552 42.9818655,109.913659 C42.9818655,108.709363 43.5789435,107.736501 44.3120194,107.736501"
          id="Fill-828"
          fill="#636463"
        />
        <polygon
          id="Fill-829"
          fill="#636463"
          points="44.2231436 112.096781 45.0761122 112.096781 45.0761122 107.736501 44.2231436 107.736501"
        />
        <path
          d="M45.0761122,107.736501 C45.8091881,107.736501 46.4062661,108.709363 46.4062661,109.913659 C46.4062661,111.118552 45.8091881,112.096781 45.0761122,112.096781 C44.3484047,112.096781 43.7519232,111.118552 43.7519232,109.913659 C43.7519232,108.709363 44.3484047,107.736501 45.0761122,107.736501"
          id="Fill-830"
          fill="#777776"
        />
        <path
          d="M54.3991192,102.48806 C55.1327915,102.48806 55.7233083,103.465693 55.7233083,104.670586 C55.7233083,105.875479 55.1327915,106.853708 54.3991192,106.853708 C53.6648504,106.853708 53.0749301,105.875479 53.0749301,104.670586 C53.0749301,103.465693 53.6648504,102.48806 54.3991192,102.48806"
          id="Fill-831"
          fill="#636463"
        />
        <polygon
          id="Fill-832"
          fill="#636463"
          points="54.3090505 106.854305 55.1679839 106.854305 55.1679839 102.48806 54.3090505 102.48806"
        />
        <path
          d="M55.1685804,102.48806 C55.9016563,102.48806 56.4927695,103.465693 56.4927695,104.670586 C56.4927695,105.875479 55.9016563,106.853708 55.1685804,106.853708 C54.4349081,106.853708 53.8443913,105.875479 53.8443913,104.670586 C53.8443913,103.465693 54.4349081,102.48806 55.1685804,102.48806"
          id="Fill-833"
          fill="#777776"
        />
      </g>
    </g>
  </svg>
)

export const step11Image5 = (
  <svg
    width="70px"
    height="70px"
    viewBox="0 0 128 128"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    aria-hidden="true"
  >
    <g
      id="2.verwarming/verwarming_6.5"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Group" transform="translate(44.800000, 0.000000)">
        <path
          d="M36.35377,105.616392 C38.1117677,109.455481 31.5488971,120.591069 21.7034981,125.094271 C11.857662,129.593101 2.45340193,125.754012 0.695841477,121.915797 C-1.06171897,118.072773 5.50027725,111.313161 15.3465506,106.809959 C25.1923868,102.311129 34.6005816,101.773368 36.35377,105.616392"
          id="Fill-808"
          fill="#777776"
        />
        <path
          d="M0.0837557475,18.9188202 L0.0881277885,119.384386 C5.36518118,117.906636 18.2185443,116.36724 25.5902425,111.614832 C30.2897493,108.585007 33.6785182,106.259082 36.5946695,103.399767 L36.6383899,3.21488637 C37.8184038,5.95615603 30.5870481,13.6242786 25.6295909,16.1294581 C0.367938408,28.9093709 0.0837557475,18.9188202 0.0837557475,18.9188202"
          id="Fill-809"
          fill="#E4E4E3"
        />
        <path
          d="M36.3716954,2.43185384 C38.2905842,6.3054821 31.7937314,13.4319088 21.8652636,18.34652 C11.9319866,23.265066 2.33098478,24.1084327 0.411658817,20.2396137 C-1.50810435,16.3655483 4.98874846,9.23955877 14.9180906,4.32101273 C24.8465583,-0.597533312 34.4523694,-1.44177441 36.3716954,2.43185384"
          id="Fill-810"
          fill="#777776"
        />
        <path
          d="M36.3716954,102.774565 C38.2905842,106.648193 31.7937314,113.77462 21.8652636,118.693166 C11.9319866,123.611712 2.33098478,124.455516 0.411658817,120.581888 C-1.50810435,116.708259 4.98874846,109.581833 14.9180906,104.667659 C24.8465583,99.7491128 34.4523694,98.9009368 36.3716954,102.774565"
          id="Fill-811"
          fill="#E4E4E3"
        />
        <path
          d="M36.4921912,73.709237 C36.4921912,73.709237 36.730271,73.6305403 36.9192771,74.1508131 C37.259877,75.0693789 36.3804395,74.3038346 36.3804395,74.3038346"
          id="Fill-812"
          fill="#777776"
        />
        <path
          d="M20.2301203,85.242681 C11.4904105,87.9708345 3.43230189,87.9620904 0.525331881,85.4831432 L0.0400353383,85.6366019 C1.30792721,89.4533936 10.576654,89.9780385 20.749956,86.8039368 C30.9197604,83.6337699 38.1336279,77.9676049 36.8652988,74.1508131 L36.3804395,74.3038346 C35.5104033,77.9544887 28.9698301,82.5188995 20.2301203,85.242681"
          id="Fill-813"
          fill="#777776"
        />
        <path
          d="M0.375803377,84.9322661 C0.375803377,84.9322661 -0.158437814,85.116329 0.047039567,85.6366019 C0.40148805,86.5542932 0.617239301,85.4831432 0.617239301,85.4831432"
          id="Fill-814"
          fill="#777776"
        />
        <path
          d="M22.652231,97.3270021 L22.652231,116.472169 C24.2174216,116.034965 26.2985131,115.265486 28.4840964,113.853754 C29.8792146,112.952676 30.9984571,112.004381 31.8641212,111.156205 L31.8641212,92.0062283 C31.0028292,92.8504694 29.9010748,93.790021 28.528254,94.6819173 C26.3243082,96.1115747 24.2261657,96.8854259 22.652231,97.3270021"
          id="Fill-815"
          fill="#E4E4E3"
        />
        <polyline
          id="Fill-816"
          fill="#C7C5BD"
          points="22.652231 97.3882107 22.652231 116.538187 17.3314572 113.424857 17.3314572 94.2753175 22.652231 97.3882107"
        />
        <path
          d="M26.3330522,88.880219 L31.8641212,92.0718089 C30.8366916,93.0380299 29.4157783,94.197058 27.5795211,95.2633988 C25.7297106,96.3301767 24.0071265,96.9820481 22.652231,97.3882107 L17.3314572,94.2753175 L26.3330522,88.880219"
          id="Fill-817"
          fill="#C7C5BD"
        />
        <path
          d="M14.4196779,116.061635 C14.4196779,116.940415 13.8338245,117.648248 13.1080657,117.648248 C12.3862417,117.648248 11.8008254,116.940415 11.8008254,116.061635 C11.8008254,115.186789 12.3862417,114.478956 13.1080657,114.478956 C13.8338245,114.478956 14.4196779,115.186789 14.4196779,116.061635"
          id="Fill-818"
          fill="#DE482A"
        />
        <path
          d="M14.7606971,116.257939 C14.7606971,117.132785 14.1748436,117.840618 13.4490848,117.840618 C12.7276981,117.840618 12.1418446,117.132785 12.1418446,116.257939 C12.1418446,115.379159 12.7276981,114.671326 13.4490848,114.671326 C14.1748436,114.671326 14.7606971,115.379159 14.7606971,116.257939"
          id="Fill-819"
          fill="#E67848"
        />
        <path
          d="M35.6979639,105.030975 C35.6979639,105.904946 35.1125476,106.617589 34.3863516,106.617589 C33.6654021,106.617589 33.0795486,105.904946 33.0795486,105.030975 C33.0795486,104.15613 33.6654021,103.443487 34.3863516,103.443487 C35.1125476,103.443487 35.6979639,104.15613 35.6979639,105.030975"
          id="Fill-820"
          fill="#DE482A"
        />
        <path
          d="M36.0394203,105.223345 C36.0394203,106.102125 35.4491948,106.809959 34.727808,106.809959 C34.0020492,106.809959 33.4161957,106.102125 33.4161957,105.223345 C33.4161957,104.3485 34.0020492,103.635857 34.727808,103.635857 C35.4491948,103.635857 36.0394203,104.3485 36.0394203,105.223345"
          id="Fill-821"
          fill="#E67848"
        />
      </g>
    </g>
  </svg>
)

export const step12Image1 = (
  <svg
    width="70px"
    height="70px"
    viewBox="0 0 128 128"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    aria-hidden="true"
  >
    <g
      id="3.isolatie/isolatie_1.1"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Group" transform="translate(4.800000, 0.000000)">
        <polyline
          id="Fill-1431"
          fill="#9E9F9E"
          points="79.3448244 10.3312994 120.004045 34.102066 78.7472583 58.0912533 36.3571568 34.2096279 79.3448244 10.3312994"
        />
        <polyline
          id="Fill-1432"
          fill="#636463"
          points="78.3100048 102.768591 38.9163881 80.7534319 38.9163881 21.375969 78.7056347 45.5794559 78.3100048 102.768591"
        />
        <polyline
          id="Fill-1433"
          fill="#F8F7F6"
          points="78.7472583 58.1984031 78.7056347 105.039342 120.004045 80.5391323 120.004045 34.2096279 78.7472583 58.1984031"
        />
        <polyline
          id="Fill-1434"
          fill="#F8F7F6"
          points="39.3944409 127.029773 78.7884697 105.010494 78.7884697 45.637152 59.0893948 39.4966453 39.794192 69.8365177 39.3944409 127.029773"
        />
        <polyline
          id="Fill-1435"
          fill="#4D4E4C"
          points="0.078713877 105.010494 39.7900709 80.8605816 39.8683726 21.4381983 19.7320441 15.2972796 0.00453325993 45.637152 0.078713877 105.010494"
        />
        <polyline
          id="Fill-1436"
          fill="#E4E4E3"
          points="44.809626 89.2306279 54.8404939 83.4408308 54.8404939 118.396386 44.809626 123.976005 44.809626 89.2306279"
        />
        <polyline
          id="Fill-1437"
          fill="#E4E4E3"
          points="61.5662031 80.4072556 70.7027825 75.1321895 70.7027825 94.3078791 61.5662031 99.9414848 61.5662031 80.4072556"
        />
        <polyline
          id="Fill-1438"
          fill="#E4E4E3"
          points="91.6217165 64.3100617 111.35747 53.3807842 111.35747 72.5564737 91.6217165 83.8442909 91.6217165 64.3100617"
        />
        <polyline
          id="Fill-1439"
          fill="#E4E4E3"
          points="39.4686215 126.914381 0.0745927316 104.895102 0.0745927316 45.522172 39.8642515 69.7211256 39.4686215 126.914381"
        />
        <polyline
          id="Fill-1440"
          fill="#FFFFFE"
          points="32.594551 88.8968152 23.4579717 83.6176279 23.4579717 102.797439 32.594551 108.431044 32.594551 88.8968152"
        />
        <polyline
          id="Fill-1441"
          fill="#FFFFFE"
          points="15.0013813 80.4072556 5.86068086 75.1321895 5.86068086 94.3078791 15.0013813 99.9414848 15.0013813 80.4072556"
        />
        <polyline
          id="Fill-1442"
          fill="#2A90C3"
          points="20.0126941 -2.4804401e-13 6.20110024e-13 29.1818305 39.794192 53.3807842 59.0893948 22.9090351 20.0126941 -2.4804401e-13"
        />
        <polyline
          id="Fill-1443"
          fill="#1A6C95"
          points="20.0126941 8.26813365e-14 39.794192 6.58517822 78.7884697 29.054075 59.0893948 22.9090351 20.0126941 8.26813365e-14"
        />
      </g>
    </g>
  </svg>
)

export const step12Image2 = (
  <svg
    width="70px"
    height="70px"
    viewBox="0 0 128 128"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    aria-hidden="true"
  >
    <g
      id="3.isolatie/isolatie_1.2"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Group" transform="translate(4.800000, 0.000000)">
        <polyline
          id="Fill-1444"
          fill="#9E9F9E"
          points="79.339879 10.3312994 119.999512 34.102066 78.742725 58.0912533 36.3522114 34.2096279 79.339879 10.3312994"
        />
        <polyline
          id="Fill-1445"
          fill="#636463"
          points="78.3095926 102.768591 38.9114427 80.7534319 38.9114427 21.375969 78.7056347 45.5794559 78.3095926 102.768591"
        />
        <polyline
          id="Fill-1446"
          fill="#F8F7F6"
          points="78.742725 58.1984031 78.7056347 105.039342 119.999512 80.5391323 119.999512 34.2096279 78.742725 58.1984031"
        />
        <polyline
          id="Fill-1447"
          fill="#F8F7F6"
          points="39.3894956 127.029773 78.7839365 105.010494 78.7839365 45.637152 59.0889826 39.4966453 39.7937799 69.8365177 39.3894956 127.029773"
        />
        <polyline
          id="Fill-1448"
          fill="#4D4E4C"
          points="0.0741806171 105.010494 39.7855376 80.8605816 39.8634273 21.4381983 19.727923 15.2972796 -4.13406683e-14 45.637152 0.0741806171 105.010494"
        />
        <polyline
          id="Fill-1449"
          fill="#E4E4E3"
          points="44.8088017 89.2306279 54.8355485 83.4408308 54.8355485 118.396386 44.8088017 123.976005 44.8088017 89.2306279"
        />
        <polyline
          id="Fill-1450"
          fill="#E4E4E3"
          points="61.5616699 80.4072556 70.7023704 75.1321895 70.7023704 94.3078791 61.5616699 99.9414848 61.5616699 80.4072556"
        />
        <polyline
          id="Fill-1451"
          fill="#E4E4E3"
          points="91.6167711 64.3100617 111.353349 53.3807842 111.353349 72.5564737 91.6167711 83.8442909 91.6167711 64.3100617"
        />
        <polyline
          id="Fill-1452"
          fill="#E4E4E3"
          points="39.4640883 126.914381 0.0700594717 104.895102 0.0700594717 45.522172 39.8597182 69.7211256 39.4640883 126.914381"
        />
        <polyline
          id="Fill-1453"
          fill="#FFFFFE"
          points="32.5896057 88.8968152 23.4534384 83.6176279 23.4534384 102.797439 32.5896057 108.431044 32.5896057 88.8968152"
        />
        <polyline
          id="Fill-1454"
          fill="#FFFFFE"
          points="14.9968481 80.4072556 5.8561476 75.1321895 5.8561476 94.3078791 14.9968481 99.9414848 14.9968481 80.4072556"
        />
        <polyline
          id="Fill-1455"
          fill="#2A90C3"
          points="20.0081609 -2.4804401e-13 -5.2709352e-13 29.1818305 39.7896588 53.3807842 59.0889826 22.9090351 20.0081609 -2.4804401e-13"
        />
        <polyline
          id="Fill-1456"
          fill="#1A6C95"
          points="20.0081609 8.26813365e-14 39.7937799 6.58517822 78.7839365 29.054075 59.0889826 22.9090351 20.0081609 8.26813365e-14"
        />
        <polyline
          id="Fill-1457"
          fill="#E67848"
          points="78.7839365 29.054075 78.7839365 34.3987885 59.7607293 28.6213548 39.8634273 59.7685595 0.0700594717 35.0293237 2.17038508e-13 29.1818305 39.7896588 53.3807842 59.0889826 22.9090351 78.7839365 29.054075"
        />
      </g>
    </g>
  </svg>
)

export const step12Image3 = (
  <svg
    width="70px"
    height="70px"
    viewBox="0 0 128 128"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    aria-hidden="true"
  >
    <g
      id="3.isolatie/isolatie_1.3"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Group" transform="translate(4.800000, 0.000000)">
        <polyline
          id="Fill-1458"
          fill="#9E9F9E"
          points="79.3448244 10.3317115 120.004045 34.1024781 78.7472583 58.0916655 36.3571568 34.2137491 79.3448244 10.3317115"
        />
        <polyline
          id="Fill-1459"
          fill="#636463"
          points="78.3100048 102.769003 38.9163881 80.753844 38.9163881 21.3805023 78.7060468 45.579868 78.3100048 102.769003"
        />
        <polyline
          id="Fill-1460"
          fill="#F8F7F6"
          points="78.7472583 58.1992274 78.7060468 105.040166 120.004045 80.5399565 120.004045 34.2137491 78.7472583 58.1992274"
        />
        <polyline
          id="Fill-1461"
          fill="#F8F7F6"
          points="39.3944409 127.030186 78.7880576 105.015439 78.7880576 45.6420973 59.0893948 39.4970574 39.794192 69.841051 39.3944409 127.030186"
        />
        <polyline
          id="Fill-1462"
          fill="#4D4E4C"
          points="0.078713877 105.015439 39.7900709 80.8609938 39.8683726 21.4381983 19.7324563 15.2976917 0.00453325993 45.6420973 0.078713877 105.015439"
        />
        <polyline
          id="Fill-1463"
          fill="#E4E4E3"
          points="44.8092139 89.23104 54.8404939 83.4408308 54.8404939 118.396386 44.8092139 123.976417 44.8092139 89.23104"
        />
        <polyline
          id="Fill-1464"
          fill="#E4E4E3"
          points="61.5662031 80.4076678 70.7027825 75.1326017 70.7027825 94.3124123 61.5662031 99.942309 61.5662031 80.4076678"
        />
        <polyline
          id="Fill-1465"
          fill="#E4E4E3"
          points="91.6217165 64.310886 111.357882 53.3816084 111.357882 72.561419 91.6217165 83.844703 91.6217165 64.310886"
        />
        <polyline
          id="Fill-1466"
          fill="#E4E4E3"
          points="39.4686215 126.914794 0.0745927316 104.895514 0.0745927316 45.522172 39.8638394 69.7219499 39.4686215 126.914794"
        />
        <polyline
          id="Fill-1467"
          fill="#FFFFFE"
          points="32.594551 88.8972273 23.4579717 83.6221612 23.4579717 102.797851 32.594551 108.431456 32.594551 88.8972273"
        />
        <polyline
          id="Fill-1468"
          fill="#FFFFFE"
          points="14.9968481 80.4076678 5.86068086 75.1326017 5.86068086 94.3124123 14.9968481 99.942309 14.9968481 80.4076678"
        />
        <polyline
          id="Fill-1469"
          fill="#2A90C3"
          points="20.0126941 -1.65362673e-13 6.20110024e-13 29.1818305 39.794192 53.3816084 59.0893948 22.9098594 20.0126941 -1.65362673e-13"
        />
        <polyline
          id="Fill-1470"
          fill="#1A6C95"
          points="20.0126941 8.26813365e-14 39.794192 6.58600245 78.7880576 29.054075 59.0893948 22.9098594 20.0126941 8.26813365e-14"
        />
        <polyline
          id="Fill-1471"
          fill="#E67848"
          points="78.7880576 29.054075 78.7880576 38.1086436 59.7611415 32.3303856 39.8683726 63.4780025 0.0745927316 38.7387667 1.13686838e-13 29.1818305 39.794192 53.3816084 59.0893948 22.9098594 78.7880576 29.054075"
        />
      </g>
    </g>
  </svg>
)

export const step12Image4 = (
  <svg
    width="70px"
    height="70px"
    viewBox="0 0 128 128"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    aria-hidden="true"
  >
    <g
      id="3.isolatie/isolatie_1.4"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Group" transform="translate(4.800000, 0.000000)">
        <polyline
          id="Fill-1472"
          fill="#9E9F9E"
          points="79.339879 10.3317115 119.999099 34.1024781 78.742725 58.0916655 36.3526235 34.2137491 79.339879 10.3317115"
        />
        <polyline
          id="Fill-1473"
          fill="#636463"
          points="78.3100048 102.769003 38.9118548 80.753844 38.9118548 21.3805023 78.7056347 45.579868 78.3100048 102.769003"
        />
        <polyline
          id="Fill-1474"
          fill="#F8F7F6"
          points="78.742725 58.1992274 78.7056347 105.040166 119.999099 80.5399565 119.999099 34.2137491 78.742725 58.1992274"
        />
        <polyline
          id="Fill-1475"
          fill="#F8F7F6"
          points="39.3899077 127.030186 78.7839365 105.015439 78.7839365 45.6420973 59.0889826 39.4970574 39.7937799 69.841051 39.3899077 127.030186"
        />
        <polyline
          id="Fill-1476"
          fill="#4D4E4C"
          points="0.0737685025 105.015439 39.7855376 80.8609938 39.8638394 21.4381983 19.727923 15.2976917 -1.65362673e-13 45.6420973 0.0737685025 105.015439"
        />
        <polyline
          id="Fill-1477"
          fill="#E4E4E3"
          points="44.8046806 89.23104 54.8355485 83.4408308 54.8355485 118.396386 44.8046806 123.976417 44.8046806 89.23104"
        />
        <polyline
          id="Fill-1478"
          fill="#E4E4E3"
          points="61.5616699 80.4076678 70.7023704 75.1326017 70.7023704 94.3124123 61.5616699 99.942309 61.5616699 80.4076678"
        />
        <polyline
          id="Fill-1479"
          fill="#E4E4E3"
          points="91.6167711 64.310886 111.353349 53.3816084 111.353349 72.561419 91.6167711 83.844703 91.6167711 64.310886"
        />
        <polyline
          id="Fill-1480"
          fill="#E4E4E3"
          points="39.4640883 126.914794 0.0700594717 104.895514 0.0700594717 45.522172 39.8593061 69.7219499 39.4640883 126.914794"
        />
        <polyline
          id="Fill-1481"
          fill="#FFFFFE"
          points="32.5900178 88.8972273 23.4534384 83.6221612 23.4534384 102.797851 32.5900178 108.431456 32.5900178 88.8972273"
        />
        <polyline
          id="Fill-1482"
          fill="#FFFFFE"
          points="14.996436 80.4076678 5.8561476 75.1326017 5.8561476 94.3124123 14.996436 99.942309 14.996436 80.4076678"
        />
        <polyline
          id="Fill-1483"
          fill="#2A90C3"
          points="20.0081609 -1.65362673e-13 -5.2709352e-13 29.1818305 39.7896588 53.3816084 59.0889826 22.9098594 20.0081609 -1.65362673e-13"
        />
        <polyline
          id="Fill-1484"
          fill="#1A6C95"
          points="20.0081609 8.26813365e-14 39.7937799 6.58600245 78.7839365 29.054075 59.0889826 22.9098594 20.0081609 8.26813365e-14"
        />
        <polyline
          id="Fill-1485"
          fill="#E67848"
          points="78.7839365 29.054075 78.7839365 41.4051478 60.5849584 35.6273019 39.8638394 66.7749188 0.0700594717 42.035683 2.42876426e-13 29.1818305 39.7896588 53.3816084 59.0889826 22.9098594 78.7839365 29.054075"
        />
      </g>
    </g>
  </svg>
)

export const step13Image1 = (
  <svg
    width="70px"
    height="70px"
    viewBox="0 0 128 128"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    aria-hidden="true"
  >
    <g
      id="3.isolatie/isolatie_2.1"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Group" transform="translate(8.000000, 1.600000)">
        <polyline
          id="Fill-490"
          fill="#636463"
          points="111.95375 39.9362067 111.990016 83.8439118 73.2832294 60.8798676 73.2832294 17.4516001 111.95375 39.9362067"
        />
        <polyline
          id="Fill-491"
          fill="#4D4E4C"
          points="34.8444491 45.8983502 34.8085457 89.8056926 73.5189589 66.8383844 73.5189589 23.4137436 34.8444491 45.8983502"
        />
        <polyline
          id="Fill-1486"
          fill="#E4E4E3"
          points="36.9301114 126.942521 0.00398926874 106.303132 0.00398926874 50.6495692 37.3000254 73.3340019 36.9301114 126.942521"
        />
        <polyline
          id="Fill-1487"
          fill="#F8F7F6"
          points="73.8127142 62.421176 73.7764481 106.328518 112.486499 83.3615729 112.486499 39.9362067 73.8127142 62.421176"
        />
        <polyline
          id="Fill-1488"
          fill="#B4B5B4"
          points="18.757179 23.4137436 6.36646291e-14 50.7688846 37.2963988 73.4496907 55.3859192 44.8901532 18.757179 23.4137436"
        />
        <polyline
          id="Fill-1489"
          fill="#9E9F9E"
          points="18.757179 23.4137436 37.3000254 29.5858676 73.8526069 50.6495692 55.3859192 44.8901532 18.757179 23.4137436"
        />
        <polyline
          id="Fill-1490"
          fill="#F8F7F6"
          points="36.9228582 126.942521 73.8526069 106.303132 73.8526069 50.6495692 55.3859192 44.8901532 37.3000254 73.3340019 36.9228582 126.942521"
        />
        <polyline
          id="Fill-1491"
          fill="#E4E4E3"
          points="42.0037359 91.510561 51.4039037 86.0815289 51.4039037 118.847569 42.0037359 124.077138 42.0037359 91.510561"
        />
        <polyline
          id="Fill-1492"
          fill="#E4E4E3"
          points="57.7069483 83.2415322 66.2729963 78.2948389 66.2729963 96.2719345 57.7069483 101.552276 57.7069483 83.2415322"
        />
        <polyline
          id="Fill-1493"
          fill="#FFFFFE"
          points="30.550908 91.1946834 21.98486 86.2516168 21.98486 104.225086 30.550908 109.505427 30.550908 91.1946834"
        />
        <polyline
          id="Fill-1494"
          fill="#FFFFFE"
          points="14.0570951 83.2415322 5.49104709 78.2948389 5.49104709 96.2719345 14.0570951 101.552276 14.0570951 83.2415322"
        />
        <polyline
          id="Fill-1495"
          fill="#2A90C3"
          points="74.3712118 -2.54658516e-13 112.486499 22.2818792 73.8127142 44.7668485 34.0756083 22.3834242 74.3712118 -2.54658516e-13"
        />
        <polyline
          id="Fill-1496"
          fill="#E4E4E3"
          points="85.8784388 68.1512165 104.377766 57.9064117 104.377766 75.8835073 85.8784388 86.4583334 85.8784388 68.1512165"
        />
      </g>
    </g>
  </svg>
)

export const step13Image2 = (
  <svg
    width="70px"
    height="70px"
    viewBox="0 0 128 128"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    aria-hidden="true"
  >
    <g
      id="3.isolatie/isolatie_2.2"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Group" transform="translate(8.000000, 1.600000)">
        <polyline
          id="Fill-1497"
          fill="#636463"
          points="111.95375 40.4363159 111.990016 84.344021 73.2796028 61.3799768 73.2796028 17.9517093 111.95375 40.4363159"
        />
        <polyline
          id="Fill-1498"
          fill="#4D4E4C"
          points="34.8444491 46.3984594 34.8049191 90.3058018 73.5149697 67.3384937 73.5149697 23.9138528 34.8444491 46.3984594"
        />
        <polyline
          id="Fill-1499"
          fill="#E4E4E3"
          points="36.9301114 127.44263 -5.1159077e-13 106.803241 -5.1159077e-13 51.1496785 37.3000254 73.8341112 36.9301114 127.44263"
        />
        <polyline
          id="Fill-1500"
          fill="#F8F7F6"
          points="73.8127142 62.9212852 73.7728215 106.828628 112.482872 83.8616821 112.482872 40.4363159 73.8127142 62.9212852"
        />
        <polyline
          id="Fill-1501"
          fill="#B4B5B4"
          points="18.7535523 23.9138528 6.36646291e-14 51.2689939 37.2963988 73.9498 55.3859192 45.3902624 18.7535523 23.9138528"
        />
        <polyline
          id="Fill-1502"
          fill="#9E9F9E"
          points="18.7535523 23.9138528 37.3000254 30.0859769 73.8489803 51.1496785 55.3859192 45.3902624 18.7535523 23.9138528"
        />
        <polyline
          id="Fill-1503"
          fill="#F8F7F6"
          points="36.9224955 127.44263 73.8489803 106.803241 73.8489803 51.1496785 55.3859192 45.3902624 37.3000254 73.8341112 36.9224955 127.44263"
        />
        <polyline
          id="Fill-1504"
          fill="#E4E4E3"
          points="42.0001093 92.0106702 51.4002771 86.5816381 51.4002771 119.347678 42.0001093 124.577247 42.0001093 92.0106702"
        />
        <polyline
          id="Fill-1505"
          fill="#E4E4E3"
          points="57.7069483 83.7416414 66.2729963 78.7949482 66.2729963 96.7720438 57.7069483 102.052385 57.7069483 83.7416414"
        />
        <polyline
          id="Fill-1506"
          fill="#FFFFFE"
          points="30.550908 91.6947926 21.9844974 86.751726 21.9844974 104.725195 30.550908 110.005536 30.550908 91.6947926"
        />
        <polyline
          id="Fill-1507"
          fill="#FFFFFE"
          points="14.0570951 83.7416414 5.49068443 78.7949482 5.49068443 96.7720438 14.0570951 102.052385 14.0570951 83.7416414"
        />
        <polyline
          id="Fill-1508"
          fill="#2A90C3"
          points="73.5149697 -2.54658516e-13 112.482872 22.7819885 73.8127142 45.2669577 34.0756083 22.8835335 73.5149697 -2.54658516e-13"
        />
        <polyline
          id="Fill-1509"
          fill="#E4E4E3"
          points="85.8784388 68.6513258 104.377403 58.406521 104.377403 76.3836166 85.8784388 86.9584427 85.8784388 68.6513258"
        />
        <polyline
          id="Fill-1510"
          fill="#E67848"
          points="112.482872 22.7783618 112.482872 26.39409 91.4412927 38.9747929 73.8779931 49.4375569 34.0324516 26.4706114 34.0756083 22.8835335 73.8127142 45.2669577"
        />
      </g>
    </g>
  </svg>
)

export const step13Image3 = (
  <svg
    width="70px"
    height="70px"
    viewBox="0 0 128 128"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    aria-hidden="true"
  >
    <g
      id="3.isolatie/isolatie_2.3"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Group" transform="translate(8.000000, 1.600000)">
        <polyline
          id="Fill-1511"
          fill="#636463"
          points="111.953387 40.4366786 111.989653 84.344021 73.2792402 61.3803395 73.2792402 17.9517093 111.953387 40.4366786"
        />
        <polyline
          id="Fill-1512"
          fill="#4D4E4C"
          points="34.8444491 46.3988221 34.8081831 90.3061645 73.5182336 67.3388563 73.5182336 23.9142155 34.8444491 46.3988221"
        />
        <polyline
          id="Fill-1513"
          fill="#E4E4E3"
          points="36.9297487 127.439003 0.00326394715 106.803604 0.00326394715 51.1496785 37.2996627 73.8304846 36.9297487 127.439003"
        />
        <polyline
          id="Fill-1514"
          fill="#F8F7F6"
          points="73.8123515 62.9220105 73.7760854 106.82899 112.482872 83.8616821 112.482872 40.4366786 73.8123515 62.9220105"
        />
        <polyline
          id="Fill-1515"
          fill="#B4B5B4"
          points="18.7531897 23.9142155 3.22870619e-13 51.2693565 37.2956735 73.9505253 55.3855565 45.3909877 18.7531897 23.9142155"
        />
        <polyline
          id="Fill-1516"
          fill="#9E9F9E"
          points="18.7531897 23.9142155 37.2996627 30.0867022 73.8486176 51.1496785 55.3855565 45.3909877 18.7531897 23.9142155"
        />
        <polyline
          id="Fill-1517"
          fill="#F8F7F6"
          points="36.9224955 127.439003 73.8486176 106.803604 73.8486176 51.1496785 55.3855565 45.3909877 37.2996627 73.8304846 36.9224955 127.439003"
        />
        <polyline
          id="Fill-1518"
          fill="#E4E4E3"
          points="41.9997466 92.0070436 51.403541 86.5816381 51.403541 119.348041 41.9997466 124.57761 41.9997466 92.0070436"
        />
        <polyline
          id="Fill-1519"
          fill="#E4E4E3"
          points="57.7065856 83.7423667 66.2722709 78.7956735 66.2722709 96.7724064 57.7065856 102.05311 57.7065856 83.7423667"
        />
        <polyline
          id="Fill-1520"
          fill="#FFFFFE"
          points="30.5505453 91.6951553 21.9844974 86.7484621 21.9844974 104.725558 30.5505453 110.005899 30.5505453 91.6951553"
        />
        <polyline
          id="Fill-1521"
          fill="#FFFFFE"
          points="14.0563697 83.7423667 5.49068443 78.7956735 5.49068443 96.7724064 14.0563697 102.05311 14.0563697 83.7423667"
        />
        <polyline
          id="Fill-1522"
          fill="#2A90C3"
          points="73.5182336 4.36557457e-13 112.482872 22.7823511 73.8123515 45.267683 34.0756083 22.8838961 73.5182336 4.36557457e-13"
        />
        <polyline
          id="Fill-1523"
          fill="#E4E4E3"
          points="85.8780762 68.6484245 104.377403 58.406521 104.377403 76.3836166 85.8780762 86.9588053 85.8780762 68.6484245"
        />
        <polyline
          id="Fill-1524"
          fill="#E67848"
          points="112.482872 22.7790872 112.482872 29.2961016 91.4412927 41.8764419 73.8776305 52.3395685 34.0317263 29.3718978 34.0756083 22.8838961 73.8123515 45.267683"
        />
      </g>
    </g>
  </svg>
)

export const step13Image4 = (
  <svg
    width="70px"
    height="70px"
    viewBox="0 0 128 128"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    aria-hidden="true"
  >
    <g
      id="3.isolatie/isolatie_2.3"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Group" transform="translate(8.000000, 1.600000)">
        <polyline
          id="Fill-1511"
          fill="#636463"
          points="111.953387 40.4366786 111.989653 84.344021 73.2792402 61.3803395 73.2792402 17.9517093 111.953387 40.4366786"
        />
        <polyline
          id="Fill-1512"
          fill="#4D4E4C"
          points="34.8444491 46.3988221 34.8081831 90.3061645 73.5182336 67.3388563 73.5182336 23.9142155 34.8444491 46.3988221"
        />
        <polyline
          id="Fill-1513"
          fill="#E4E4E3"
          points="36.9297487 127.439003 0.00326394715 106.803604 0.00326394715 51.1496785 37.2996627 73.8304846 36.9297487 127.439003"
        />
        <polyline
          id="Fill-1514"
          fill="#F8F7F6"
          points="73.8123515 62.9220105 73.7760854 106.82899 112.482872 83.8616821 112.482872 40.4366786 73.8123515 62.9220105"
        />
        <polyline
          id="Fill-1515"
          fill="#B4B5B4"
          points="18.7531897 23.9142155 3.22870619e-13 51.2693565 37.2956735 73.9505253 55.3855565 45.3909877 18.7531897 23.9142155"
        />
        <polyline
          id="Fill-1516"
          fill="#9E9F9E"
          points="18.7531897 23.9142155 37.2996627 30.0867022 73.8486176 51.1496785 55.3855565 45.3909877 18.7531897 23.9142155"
        />
        <polyline
          id="Fill-1517"
          fill="#F8F7F6"
          points="36.9224955 127.439003 73.8486176 106.803604 73.8486176 51.1496785 55.3855565 45.3909877 37.2996627 73.8304846 36.9224955 127.439003"
        />
        <polyline
          id="Fill-1518"
          fill="#E4E4E3"
          points="41.9997466 92.0070436 51.403541 86.5816381 51.403541 119.348041 41.9997466 124.57761 41.9997466 92.0070436"
        />
        <polyline
          id="Fill-1519"
          fill="#E4E4E3"
          points="57.7065856 83.7423667 66.2722709 78.7956735 66.2722709 96.7724064 57.7065856 102.05311 57.7065856 83.7423667"
        />
        <polyline
          id="Fill-1520"
          fill="#FFFFFE"
          points="30.5505453 91.6951553 21.9844974 86.7484621 21.9844974 104.725558 30.5505453 110.005899 30.5505453 91.6951553"
        />
        <polyline
          id="Fill-1521"
          fill="#FFFFFE"
          points="14.0563697 83.7423667 5.49068443 78.7956735 5.49068443 96.7724064 14.0563697 102.05311 14.0563697 83.7423667"
        />
        <polyline
          id="Fill-1522"
          fill="#2A90C3"
          points="73.5182336 4.36557457e-13 112.482872 22.7823511 73.8123515 45.267683 34.0756083 22.8838961 73.5182336 4.36557457e-13"
        />
        <polyline
          id="Fill-1523"
          fill="#E4E4E3"
          points="85.8780762 68.6484245 104.377403 58.406521 104.377403 76.3836166 85.8780762 86.9588053 85.8780762 68.6484245"
        />
        <polyline
          id="Fill-1524"
          fill="#E67848"
          points="112.482872 22.7790872 112.482872 29.2961016 91.4412927 41.8764419 73.8776305 52.3395685 34.0317263 29.3718978 34.0756083 22.8838961 73.8123515 45.267683"
        />
      </g>
    </g>
  </svg>
)

export const step14Image1 = (
  <svg
    width="70px"
    height="70px"
    viewBox="0 0 128 128"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    aria-hidden="true"
  >
    <g
      id="3.isolatie/isolatie_3.1"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Group" transform="translate(1.600000, 3.200000)">
        <polyline
          id="Fill-834"
          fill="#E4E4E3"
          points="41.2742523 122.14286 0.00431739041 99.0754752 0.00431739041 36.8743998 41.6887218 62.226548 41.2742523 122.14286"
        />
        <polyline
          id="Fill-835"
          fill="#F8F7F6"
          points="82.4919469 50.0338057 82.4535221 99.1052652 125.718091 73.4383792 125.718091 24.9022762 82.4919469 50.0338057"
        />
        <polyline
          id="Fill-836"
          fill="#9E9F9E"
          points="83.1184002 3.89783444e-13 125.718091 24.9022762 82.4919469 50.0338057 38.0837008 25.01496 83.1184002 3.89783444e-13"
        />
        <polyline
          id="Fill-837"
          fill="#2A90C3"
          points="20.9609304 6.43679736 6.82121026e-13 37.0082389 41.6844044 62.3603871 61.9027437 30.4376024 20.9609304 6.43679736"
        />
        <polyline
          id="Fill-838"
          fill="#1A6C95"
          points="20.9609304 6.43679736 41.6887218 13.3359872 82.5355525 36.8743998 61.9027437 30.4376024 20.9609304 6.43679736"
        />
        <polyline
          id="Fill-839"
          fill="#F8F7F6"
          points="41.2656176 122.14286 82.5355525 99.0754752 82.5355525 36.8743998 61.9027437 30.4376024 41.6887218 62.226548 41.2656176 122.14286"
        />
        <polyline
          id="Fill-840"
          fill="#E4E4E3"
          points="46.9425542 82.5441873 57.4467651 76.4739364 57.4467651 113.098359 46.9425542 118.943674 46.9425542 82.5441873"
        />
        <polyline
          id="Fill-841"
          fill="#E4E4E3"
          points="64.493178 73.3002227 74.0691499 67.7743947 74.0691499 87.8627805 64.493178 93.7646532 64.493178 73.3002227"
        />
        <polyline
          id="Fill-842"
          fill="#E4E4E3"
          points="95.9794745 56.4364957 116.655889 44.9867763 116.655889 65.0760257 95.9794745 76.9009263 95.9794745 56.4364957"
        />
        <polyline
          id="Fill-843"
          fill="#FFFFFE"
          points="34.1419234 82.1940469 24.5698371 76.6639015 24.5698371 96.7570365 34.1419234 102.654592 34.1419234 82.1940469"
        />
        <polyline
          id="Fill-844"
          fill="#FFFFFE"
          points="15.7109837 73.3002227 6.13932917 67.7743947 6.13932917 87.8627805 15.7109837 93.7646532 15.7109837 73.3002227"
        />
      </g>
    </g>
  </svg>
)

export const step14Image2 = (
  <svg
    width="70px"
    height="70px"
    viewBox="0 0 128 128"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    aria-hidden="true"
  >
    <g
      id="3.isolatie/isolatie_3.2"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Group" transform="translate(3.200000, 3.200000)">
        <polyline
          id="Fill-845"
          fill="#E4E4E3"
          points="40.5575655 120.023022 0 97.356722 0 36.2358577 40.9634002 61.1467687 40.5575655 120.023022"
        />
        <polyline
          id="Fill-846"
          fill="#F8F7F6"
          points="81.0633224 49.1660103 81.0197167 97.3873755 123.533492 72.164749 123.533492 24.4705371 81.0633224 49.1660103"
        />
        <polyline
          id="Fill-847"
          fill="#2A90C3"
          points="81.6763918 0 123.533492 24.4705371 81.0633224 49.1660103 37.4231401 24.5827893 81.6763918 0"
        />
        <polyline
          id="Fill-848"
          fill="#B4B5B4"
          points="20.5982697 6.32454521 -6.92948344e-13 36.3696968 40.9590828 61.2806078 60.8277135 29.910449 20.5982697 6.32454521"
        />
        <polyline
          id="Fill-849"
          fill="#9E9F9E"
          points="20.5982697 6.32454521 40.9634002 13.1071656 81.1017471 36.2358577 60.8277135 29.910449 20.5982697 6.32454521"
        />
        <polyline
          id="Fill-850"
          fill="#F8F7F6"
          points="40.5489307 120.023022 81.1017471 97.356722 81.1017471 36.2358577 60.8277135 29.910449 40.9634002 61.1467687 40.5489307 120.023022"
        />
        <polyline
          id="Fill-851"
          fill="#E4E4E3"
          points="46.1269992 81.1108137 56.4498796 75.1480658 56.4498796 111.133947 46.1269992 116.879961 46.1269992 81.1108137"
        />
        <polyline
          id="Fill-852"
          fill="#E4E4E3"
          points="63.3749739 72.0313416 72.7821358 66.6000645 72.7821358 86.3387417 63.3749739 92.1374288 63.3749739 72.0313416"
        />
        <polyline
          id="Fill-853"
          fill="#E4E4E3"
          points="94.3133935 55.4568798 114.631033 44.2053287 114.631033 63.9491868 94.3133935 75.5668526 94.3133935 55.4568798"
        />
        <polyline
          id="Fill-854"
          fill="#FFFFFE"
          points="33.5504409 80.7649907 24.1424154 75.3337136 24.1424154 95.0775716 33.5504409 100.875395 33.5504409 80.7649907"
        />
        <polyline
          id="Fill-855"
          fill="#FFFFFE"
          points="15.4385564 72.0313416 6.0313944 66.6000645 6.0313944 86.3387417 15.4385564 92.1374288 15.4385564 72.0313416"
        />
      </g>
    </g>
  </svg>
)

export const step14Image3 = (
  <svg
    width="70px"
    height="70px"
    viewBox="0 0 128 128"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    aria-hidden="true"
  >
    <g
      id="3.isolatie/isolatie_3.3"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Group" transform="translate(3.200000, 3.200000)">
        <polyline
          id="Fill-856"
          fill="#E4E4E3"
          points="40.795022 120.722871 0.00431739041 97.9274811 0.00431739041 36.4478416 41.2051741 61.5055438 40.795022 120.722871"
        />
        <polyline
          id="Fill-857"
          fill="#F8F7F6"
          points="81.5382353 49.4513898 81.4950614 97.9529537 124.254496 72.5839676 124.254496 24.6181919 81.5382353 49.4513898"
        />
        <polyline
          id="Fill-858"
          fill="#1A6C95"
          points="82.1556221 -2.59855629e-13 124.254496 24.6181919 81.5382353 49.4513898 37.643327 24.7300123 82.1556221 -2.59855629e-13"
        />
        <polyline
          id="Fill-859"
          fill="#2A90C3"
          points="20.7191566 6.36426521 3.35646854e-13 36.581249 41.2008567 61.6393829 61.1813078 30.0878938 20.7191566 6.36426521"
        />
        <polyline
          id="Fill-860"
          fill="#1A6C95"
          points="20.7191566 6.36426521 41.2051741 13.1814247 81.5770918 36.4478416 61.1813078 30.0878938 20.7191566 6.36426521"
        />
        <polyline
          id="Fill-861"
          fill="#F8F7F6"
          points="40.7902729 120.722871 81.5770918 97.9274811 81.5770918 36.4478416 61.1813078 30.0878938 41.2051741 61.5055438 40.7902729 120.722871"
        />
        <polyline
          id="Fill-862"
          fill="#E4E4E3"
          points="46.3989948 81.5857266 56.7823187 75.5893031 56.7823187 111.785873 46.3989948 117.562973 46.3989948 81.5857266"
        />
        <polyline
          id="Fill-863"
          fill="#E4E4E3"
          points="63.7462694 72.4501285 73.2099892 66.9886296 73.2099892 86.8447399 63.7462694 92.6775343 63.7462694 72.4501285"
        />
        <polyline
          id="Fill-864"
          fill="#E4E4E3"
          points="94.8655878 55.7806841 115.300228 44.4648038 115.300228 64.3204824 94.8655878 76.0076582 94.8655878 55.7806841"
        />
        <polyline
          id="Fill-865"
          fill="#FFFFFE"
          points="33.7490408 81.236018 24.2853211 75.7749509 24.2853211 95.6301976 33.7490408 101.463424 33.7490408 81.236018"
        />
        <polyline
          id="Fill-866"
          fill="#FFFFFE"
          points="15.5296533 72.4501285 6.07025092 66.9886296 6.07025092 86.8447399 15.5296533 92.6775343 15.5296533 72.4501285"
        />
      </g>
    </g>
  </svg>
)

export const step15Image1 = (
  <svg
    width="70px"
    height="70px"
    viewBox="0 0 128 128"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    aria-hidden="true"
  >
    <g
      id="3.isolatie/isolatie_4.1"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Group" transform="translate(36.800000, 3.200000)">
        <polyline
          id="Fill-397"
          fill="#45596D"
          points="6.77787121 114.924615 5.74212925 114.428115 6.77787121 113.832316 6.77787121 114.924615"
        />
        <polyline
          id="Fill-867"
          fill="#BFD5E5"
          points="6.77787121 113.832316 6.77787121 36.4694285 50.5566417 11.1906759 51.1610764 88.2910657 6.77787121 113.832316"
        />
        <polyline
          id="Fill-868"
          fill="#466A84"
          points="6.77787121 114.924615 6.77787121 113.832316 51.1610764 88.2910657 52.0677284 88.7741816 6.77787121 114.924615"
        />
        <polyline
          id="Fill-886"
          fill="#737F8F"
          points="52.0677284 88.7741816 52.0677284 10.3185631 50.5566417 11.1906759 50.5566417 9.10969377 52.0677284 9.99907619 52.0677284 88.7741816"
        />
        <polyline
          id="Fill-887"
          fill="#60768B"
          points="52.0677284 88.7741816 52.0677284 88.7741816 51.1610764 88.2910657 50.5566417 11.1906759 52.0677284 10.3185631 52.0677284 88.7741816"
        />
        <path
          d="M52.0677284,88.7741816 L6.77787121,114.924615 L6.77787121,36.4733142 L52.0677284,10.3185631 L52.0677284,88.7741816 Z M3.151695,32.2768107 L3.151695,123.313305 L55.6943363,92.9663677 L55.6943363,1.9341909 L3.151695,32.2768107 L3.151695,32.2768107 Z"
          id="Fill-888"
          fill="#F8F7F6"
        />
        <polyline
          id="Fill-889"
          fill="#B4B5B4"
          points="3.151695 123.313305 -3.46474172e-13 121.456827 -3.46474172e-13 30.2005777 52.0677284 4.33092715e-13 55.6943363 1.9341909 3.151695 32.2768107"
        />
      </g>
    </g>
  </svg>
)

export const step15Image2 = (
  <svg
    width="70px"
    height="70px"
    viewBox="0 0 128 128"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    aria-hidden="true"
  >
    <g
      id="3.isolatie/isolatie_4.2"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Group" transform="translate(33.600000, 3.200000)">
        <polyline
          id="Fill-881"
          fill="#E8F0F5"
          points="1.39063145 109.169102 1.39063145 30.7182328 47.2715394 4.13606001 47.2715394 16.6819648 13.0000943 36.4685651 13.0000943 102.529387 1.39063145 109.169102"
        />
        <polyline
          id="Fill-882"
          fill="#45596D"
          points="1.39063145 109.169102 -3.43767343e-13 108.267199 -3.43767343e-13 30.2908111 45.7604527 3.25056324 47.2715394 4.13606001 1.39063145 30.3983141 1.39063145 109.169102"
        />
        <polyline
          id="Fill-883"
          fill="#41586C"
          points="1.39063145 109.169102 1.39063145 30.3983141 47.2715394 4.13606001 1.39063145 30.7182328 1.39063145 109.169102"
        />
        <polyline
          id="Fill-884"
          fill="#45596D"
          points="13.0000943 114.920298 11.9639206 114.427684 13.0000943 113.832316 13.0000943 114.920298"
        />
        <polyline
          id="Fill-885"
          fill="#737F8F"
          points="56.7697983 11.1863586 56.7697983 9.10969377 58.2808849 9.99864445 58.2808849 10.3185631 56.7697983 11.1863586"
        />
        <polyline
          id="Fill-890"
          fill="#BFD5E5"
          points="13.0000943 113.832316 13.0000943 102.529387 47.2715394 82.9107337 47.2715394 16.6819648 56.7697983 11.1863586 57.3738012 88.2858848 13.0000943 113.832316"
        />
        <polyline
          id="Fill-891"
          fill="#B1CCE1"
          points="13.0000943 102.529387 13.0000943 36.4685651 47.2715394 16.6819648 47.2715394 82.9107337 13.0000943 102.529387"
        />
        <polyline
          id="Fill-892"
          fill="#466A84"
          points="13.0000943 114.920298 13.0000943 113.832316 57.3738012 88.2858848 58.2808849 88.7694325 13.0000943 114.920298"
        />
        <polyline
          id="Fill-893"
          fill="#69869D"
          points="58.2808849 88.7694325 58.2808849 88.7694325 57.3738012 88.2858848 56.7697983 11.1863586 58.2808849 10.3185631 58.2808849 88.7694325"
        />
        <path
          d="M58.2808849,88.7694325 L13.0000943,114.924184 L13.0000943,36.4685651 L58.2808849,10.3185631 L58.2808849,88.7694325 Z M9.36916893,32.276379 L9.36916893,123.308988 L61.9070611,92.965936 L61.9070611,1.92944177 L9.36916893,32.276379 L9.36916893,32.276379 Z"
          id="Fill-894"
          fill="#F8F7F6"
        />
        <polyline
          id="Fill-895"
          fill="#B4B5B4"
          points="9.36916893 123.308988 6.20020437 121.456827 6.20020437 30.1953968 58.2808849 -5.0888394e-13 61.9070611 1.92944177 18.5647788 26.9616714 9.36916893 32.276379"
        />
      </g>
    </g>
  </svg>
)

export const step15Image3 = (
  <svg
    width="70px"
    height="70px"
    viewBox="0 0 128 128"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    aria-hidden="true"
  >
    <g
      id="3.isolatie/isolatie_4.3"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Group" transform="translate(30.400000, 1.600000)">
        <polyline
          id="Fill-869"
          fill="#E8F0F5"
          points="1.39019971 105.594303 1.39019971 27.1391161 46.6796251 0.988682404 46.6796251 2.23597649 2.77996769 27.5833756 2.77996769 104.791268 1.39019971 105.594303"
        />
        <polyline
          id="Fill-870"
          fill="#45596D"
          points="1.39019971 105.594303 -3.46474172e-13 104.688083 -3.46474172e-13 26.7112627 45.159472 0.0992999795 46.6796251 0.988682404 1.39019971 27.1391161 1.39019971 105.594303"
        />
        <path
          d="M2.77996769,106.038994 L2.77996769,104.791268 L12.7790439,99.0146 L12.7790439,100.262758 L2.77996769,106.038994 M46.6796251,12.7017626 L46.6796251,2.23597649 L48.0698248,1.43294188 L48.0698248,11.898728 L46.6796251,12.7017626"
          id="Fill-877"
          fill="#F6CBAC"
        />
        <polyline
          id="Fill-878"
          fill="#E9C3AA"
          points="2.77996769 104.791268 2.77996769 27.5833756 46.6796251 2.23597649 46.6796251 12.7017626 12.7790439 32.276379 12.7790439 99.0146 2.77996769 104.791268"
        />
        <polyline
          id="Fill-879"
          fill="#DE482A"
          points="2.77608203 106.038994 1.39019971 105.132342 1.39019971 27.1563857 46.5501034 0.543559453 48.0698248 1.43294188 2.77608203 27.5833756 2.77608203 106.038994"
        />
        <path
          d="M61.7041438,88.7698643 L16.410401,114.919866 L16.410401,36.4685651 L61.7041438,10.3185631 L61.7041438,88.7698643 M12.7790439,32.276379 L12.7790439,123.308988 L65.3350691,92.965936 L65.3350691,1.92944177 L12.7790439,32.276379"
          id="Fill-1750"
          fill="#F8F7F6"
        />
        <polyline
          id="Fill-1751"
          fill="#B4B5B4"
          points="12.7790439 123.308988 9.61482845 121.456827 9.61482845 30.1958285 61.7041438 -4.76401987e-13 65.3350691 1.92944177 21.9798346 26.9616714 12.7790439 32.276379"
        />
        <polyline
          id="Fill-1752"
          fill="#BFD5E5"
          points="16.410401 113.849153 16.410401 98.164074 48.0698248 79.884243 48.0698248 18.1891658 60.1973745 11.1859268 60.76727 88.3031543 16.410401 113.849153"
        />
        <polyline
          id="Fill-1753"
          fill="#BFB7B4"
          points="16.410401 98.164074 16.410401 96.91678 46.6796251 79.4438692 46.6796251 18.9917687 48.0698248 18.1891658 48.0698248 79.884243 16.410401 98.164074"
        />
        <polyline
          id="Fill-1754"
          fill="#B6B2B2"
          points="16.410401 96.91678 16.410401 36.4685651 46.6796251 18.9917687 46.6796251 79.4438692 16.410401 96.91678"
        />
        <polyline
          id="Fill-1755"
          fill="#466A84"
          points="16.410401 114.919866 16.410401 113.849153 60.76727 88.3031543 60.76727 88.3506456 61.6432686 88.8044034 16.410401 114.919866"
        />
        <polyline
          id="Fill-1756"
          fill="#69869D"
          points="61.6868742 88.7823847 60.76727 88.3031543 60.1973745 11.1859268 61.7041438 10.3185631 61.7041438 88.7698643 61.6868742 88.7823847"
        />
        <polyline
          id="Fill-1757"
          fill="#325D78"
          points="61.6432686 88.9126782 60.76727 88.3609042 60.76727 88.3031543 61.6868742 88.8859032 61.6432686 88.9126782"
        />
        <polyline
          id="Fill-1758"
          fill="#BBD1E0"
          points="16.410401 114.919866 16.410401 114.919866 61.6432686 88.8044034 61.6868742 88.7823847 61.7041438 88.7698643 61.7041438 10.3185631 61.7041438 88.7698643 16.410401 114.919866"
        />
      </g>
    </g>
  </svg>
)

export const step15Image4 = (
  <svg
    width="70px"
    height="70px"
    viewBox="0 0 128 128"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    aria-hidden="true"
  >
    <g
      id="3.isolatie/isolatie_4.4"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Group" transform="translate(28.800000, 1.600000)">
        <polyline
          id="Fill-233"
          fill="#E8F0F5"
          points="1.39019971 105.491117 1.39019971 27.0398161 46.6796251 0.884633295 46.6796251 2.13279086 2.78039943 27.48019 2.78039943 104.687651 1.39019971 105.491117"
        />
        <polyline
          id="Fill-234"
          fill="#45596D"
          points="1.39019971 105.491117 1.75943916e-13 104.588351 1.75943916e-13 26.6080771 45.1599037 -5.6302053e-13 46.6796251 0.884633295 1.39019971 27.0398161 1.39019971 105.491117"
        />
        <path
          d="M2.78039943,105.935809 L2.78039943,104.687651 L7.62407973,101.889982 L7.62407973,103.13814 L2.78039943,105.935809 M46.6796251,7.99105791 L46.6796251,2.13279086 L48.0693931,1.32975625 L48.0693931,7.17118547 L46.6796251,7.99105791"
          id="Fill-235"
          fill="#F6CBAC"
        />
        <polyline
          id="Fill-236"
          fill="#E9C3AA"
          points="2.78039943 104.687651 2.78039943 27.48019 46.6796251 2.13279086 46.6796251 7.99105791 7.62407973 31.0031805 7.62407973 101.889982 2.78039943 104.687651"
        />
        <polyline
          id="Fill-237"
          fill="#DE482A"
          points="2.78039943 105.935809 1.39019971 105.033042 1.39019971 27.0523366 46.5496717 0.440373822 48.0693931 1.32975625 2.78039943 27.48019 2.78039943 105.935809"
        />
        <path
          d="M9.01471118,109.885789 L9.01471118,102.334673 L17.3382082,97.5298494 L17.3382082,105.080965 L9.01471118,109.885789 M48.0693931,17.2350225 L48.0693931,8.88044034 L54.3041366,5.27973673 L54.3041366,13.6343189 L48.0693931,17.2350225"
          id="Fill-871"
          fill="#E8F0F5"
        />
        <path
          d="M9.01471118,102.334673 L9.01471118,101.086947 L17.3382082,96.2816918 L17.3382082,97.5298494 L9.01471118,102.334673 M46.6796251,18.0337397 L46.6796251,9.68347495 L48.0693931,8.88044034 L48.0693931,17.2350225 L46.6796251,18.0337397"
          id="Fill-872"
          fill="#E3C4AF"
        />
        <polyline
          id="Fill-873"
          fill="#D7BEAD"
          points="9.01471118 101.086947 9.01471118 31.4344878 46.6796251 9.68347495 46.6796251 18.0337397 17.3382082 34.974748 17.3382082 96.2816918 9.01471118 101.086947"
        />
        <path
          d="M9.01471118,109.885789 L7.62407973,108.983454 L7.62407973,103.13814 L9.01471118,102.334673 L9.01471118,109.885789 M48.0693931,8.88044034 L48.0693931,7.17118547 L52.7839834,4.3946717 L54.3041366,5.27973673 L48.0693931,8.88044034"
          id="Fill-874"
          fill="#45596D"
        />
        <path
          d="M7.62407973,103.13814 L7.62407973,101.889982 L9.01471118,101.086947 L9.01471118,102.334673 L7.62407973,103.13814 M46.6796251,9.68347495 L46.6796251,7.99105791 L48.0693931,7.17118547 L48.0693931,8.88044034 L46.6796251,9.68347495"
          id="Fill-875"
          fill="#465363"
        />
        <polyline
          id="Fill-876"
          fill="#445262"
          points="7.62407973 101.889982 7.62407973 31.0031805 46.6796251 7.99105791 46.6796251 9.68347495 9.01471118 31.4344878 9.01471118 101.086947 7.62407973 101.889982"
        />
        <polyline
          id="Fill-880"
          fill="#DE482A"
          points="20.0845002 117.100148 18.6943005 116.197814 18.6943005 38.2214256 63.8537724 11.6090311 65.3734939 12.4984135 20.0845002 38.649279 20.0845002 117.100148"
        />
        <path
          d="M66.2628763,91.4721189 L20.9738826,117.622553 L20.9738826,39.1716832 L66.2628763,13.0208177 L66.2628763,91.4721189 M17.3382082,34.974748 L17.3382082,126.011242 L69.8942334,95.664305 L69.8942334,4.63212817 L17.3382082,34.974748"
          id="Fill-1737"
          fill="#F8F7F6"
        />
        <polyline
          id="Fill-1738"
          fill="#B4B5B4"
          points="17.3382082 126.011242 14.1739927 124.155196 14.1739927 32.8980832 66.2628763 2.69836901 69.8942334 4.63212817 26.5389989 29.6647895 17.3382082 34.974748"
        />
        <polyline
          id="Fill-1739"
          fill="#BFD5E5"
          points="58.1984227 95.0944095 65.33032 90.975619 65.33032 90.9885712 58.1984227 95.0944095"
        />
        <polyline
          id="Fill-1740"
          fill="#BFB7B4"
          points="20.9738826 116.530685 20.9738826 102.982282 54.3041366 83.7353553 54.3041366 19.924325 64.756107 13.889045 65.33032 90.975619 58.1984227 95.0944095 20.9738826 116.530685"
        />
        <polyline
          id="Fill-1741"
          fill="#B6B2B2"
          points="20.9738826 102.982282 20.9738826 95.4311659 48.0693931 79.7849431 48.0693931 23.5250286 54.3041366 19.924325 54.3041366 83.7353553 20.9738826 102.982282"
        />
        <polyline
          id="Fill-1742"
          fill="#B6A29A"
          points="20.9738826 95.4311659 20.9738826 94.1834401 46.6796251 79.3402519 46.6796251 24.3280632 48.0693931 23.5250286 48.0693931 79.7849431 20.9738826 95.4311659"
        />
        <polyline
          id="Fill-1743"
          fill="#B19F99"
          points="20.9738826 94.1834401 20.9738826 39.1716832 46.6796251 24.3280632 46.6796251 79.3402519 20.9738826 94.1834401"
        />
        <polyline
          id="Fill-1744"
          fill="#466A84"
          points="20.9738826 117.622553 20.9738826 116.586811 58.1984227 95.0944095 65.33032 90.9885712 65.33032 91.0317451 66.2201341 91.4980233 20.9738826 117.622553"
        />
        <polyline
          id="Fill-1745"
          fill="#48657C"
          points="20.9738826 116.586811 20.9738826 116.530685 58.1984227 95.0944095 20.9738826 116.586811"
        />
        <polyline
          id="Fill-1746"
          fill="#69869D"
          points="66.2201341 91.4980233 66.2201341 91.4980233 66.2628763 91.4721189 65.33032 90.9885712 65.33032 90.975619 65.3734939 90.9497147 65.3734939 13.5307015 66.2628763 13.0208177 66.2628763 91.4721189 66.2201341 91.4980233"
        />
        <polyline
          id="Fill-1747"
          fill="#6B7B8D"
          points="65.33032 90.975619 64.756107 13.889045 65.3734939 13.5307015 65.3734939 90.9497147 65.33032 90.975619"
        />
        <polyline
          id="Fill-1748"
          fill="#325D78"
          points="66.2201341 91.598095 65.33032 91.0402257 65.33032 90.9885712 66.2628763 91.5671023 66.2201341 91.598095"
        />
        <polyline
          id="Fill-1749"
          fill="#BBD1E0"
          points="20.9738826 117.622553 20.9738826 117.622553 66.2201341 91.4980233 66.2628763 91.4721189 66.2628763 13.0208177 66.2628763 91.4721189 20.9738826 117.622553"
        />
      </g>
    </g>
  </svg>
)

export const step17Image1 = (
  <svg
    width="70px"
    height="70px"
    viewBox="0 0 128 128"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    aria-hidden="true"
  >
    <g
      id="3.isolatie/isolatie_6.1"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Group" transform="translate(17.600000, 3.200000)">
        <polyline
          id="Fill-912"
          fill="#E4E4E3"
          points="40.9902135 116.137348 3.82945138e-13 92.0156329 3.82945138e-13 30.2344578 41.4196802 55.4155238 40.9902135 116.137348"
        />
        <polyline
          id="Fill-913"
          fill="#B4B5B4"
          points="20.8529957 -2.87208853e-13 -3.82945138e-13 30.3685469 41.4196802 55.5496128 61.5091795 23.8401754 20.8529957 -2.87208853e-13"
        />
        <polyline
          id="Fill-914"
          fill="#9E9F9E"
          points="20.8529957 2.87208853e-13 41.4196802 6.85238028 81.9799498 30.2344578 61.5091795 23.8401754 20.8529957 2.87208853e-13"
        />
        <polyline
          id="Fill-915"
          fill="#FFFFFE"
          points="33.9278717 75.2425712 24.4318851 69.7554179 24.4318851 89.7113053 33.9278717 95.5711403 33.9278717 75.2425712"
        />
        <polyline
          id="Fill-916"
          fill="#FFFFFE"
          points="15.6034807 66.4151211 6.10749409 60.9227188 6.10749409 80.878129 15.6034807 86.7384412 15.6034807 66.4151211"
        />
        <polyline
          id="Fill-927"
          fill="#343534"
          points="40.9902135 116.137348 83.4115056 91.5432195 41.3242432 67.3260678 40.9902135 116.137348"
        />
        <polyline
          id="Fill-928"
          fill="#636463"
          points="81.9799498 30.2344578 81.6463973 90.5172712 41.3242432 67.3260678 41.4196802 55.5496128 61.5091795 23.8401754 81.9799498 30.2344578"
        />
        <polyline
          id="Fill-2614"
          fill="#E67848"
          points="51.8223188 122.837029 93.0511249 100.51478 93.0511249 38.7336044 72.5798774 32.3436167 52.5380967 63.313417 51.8223188 122.837029"
        />
        <polyline
          id="Fill-2615"
          fill="#E4E4E3"
          points="76.1110483 73.4817576 85.6070349 67.9941271 85.6070349 87.9452427 76.1110483 93.8098495 76.1110483 73.4817576"
        />
        <polyline
          id="Fill-2616"
          fill="#DE482A"
          points="47.7185256 120.451102 50.2476075 121.901746 50.676597 62.3967441 70.7665735 30.8213957 89.2336429 36.5762499 85.6070349 34.4866556 68.905551 29.2991747 48.482022 60.9270135 47.7185256 120.451102"
        />
        <polyline
          id="Fill-2618"
          fill="#DE482A"
          points="49.2932369 121.381614 51.8223188 122.837029 52.5380967 63.313417 72.5798774 32.3436167 93.0511249 38.7336044 89.2336429 36.5762499 70.7665735 30.8213957 50.3430445 61.8436864 49.2932369 121.381614"
        />
        <polyline
          id="Fill-2619"
          fill="#E4E4E3"
          points="60.1730608 82.3769679 70.6234179 76.3544128 70.6234179 112.730245 60.1730608 118.532818 60.1730608 82.3769679"
        />
      </g>
    </g>
  </svg>
)

export const step17Image2 = (
  <svg
    width="70px"
    height="70px"
    viewBox="0 0 128 128"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    aria-hidden="true"
  >
    <g
      id="3.isolatie/isolatie_6.2"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Group" transform="translate(20.800000, 3.200000)">
        <polyline
          id="Fill-896"
          fill="#E4E4E3"
          points="43.2674476 121.310036 -4.04219867e-13 97.1276125 -4.04219867e-13 31.9146536 43.6709077 58.4946677 43.2674476 121.310036"
        />
        <polyline
          id="Fill-897"
          fill="#B4B5B4"
          points="21.9616296 -2.02109934e-13 0 32.0551847 43.6709077 58.6357024 64.8764903 25.1646296 21.9616296 -2.02109934e-13"
        />
        <polyline
          id="Fill-898"
          fill="#9E9F9E"
          points="21.9616296 -1.01054967e-13 43.6709077 7.23357176 86.5353988 31.9146536 64.8764903 25.1646296 21.9616296 -1.01054967e-13"
        />
        <polyline
          id="Fill-899"
          fill="#F8F7F6"
          points="43.2674476 121.310036 86.5353988 97.1276125 86.5353988 31.9146536 64.8764903 25.1646296 43.6709077 58.4946677 43.2674476 121.310036"
        />
        <polyline
          id="Fill-900"
          fill="#E4E4E3"
          points="49.2115587 79.7909155 60.1921217 73.4337739 60.1921217 111.825952 49.2115587 117.955927 49.2115587 79.7909155"
        />
        <polyline
          id="Fill-901"
          fill="#E4E4E3"
          points="67.5964462 70.1043464 77.6199876 64.3068106 77.6199876 85.3718621 67.5964462 91.5567398 67.5964462 70.1043464"
        />
        <polyline
          id="Fill-902"
          fill="#FFFFFE"
          points="35.7628876 79.4232177 25.7393462 73.6307189 25.7393462 94.694763 35.7628876 100.880648 35.7628876 79.4232177"
        />
        <polyline
          id="Fill-903"
          fill="#FFFFFE"
          points="16.4713481 70.1043464 6.39743716 64.3068106 6.39743716 85.3718621 16.4713481 91.5567398 16.4713481 70.1043464"
        />
      </g>
    </g>
  </svg>
)

export const step17Image3 = (
  <svg
    width="70px"
    height="70px"
    viewBox="0 0 128 128"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    aria-hidden="true"
  >
    <g
      id="3.isolatie/isolatie_6.3"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Group" transform="translate(17.600000, 3.200000)">
        <polyline
          id="Fill-912"
          fill="#E4E4E3"
          points="40.9902135 116.137348 3.82945138e-13 92.0156329 3.82945138e-13 30.2344578 41.4196802 55.4155238 40.9902135 116.137348"
        />
        <polyline
          id="Fill-913"
          fill="#B4B5B4"
          points="20.8529957 -2.87208853e-13 -3.82945138e-13 30.3685469 41.4196802 55.5496128 61.5091795 23.8401754 20.8529957 -2.87208853e-13"
        />
        <polyline
          id="Fill-914"
          fill="#9E9F9E"
          points="20.8529957 2.87208853e-13 41.4196802 6.85238028 81.9799498 30.2344578 61.5091795 23.8401754 20.8529957 2.87208853e-13"
        />
        <polyline
          id="Fill-915"
          fill="#FFFFFE"
          points="33.9278717 75.2425712 24.4318851 69.7554179 24.4318851 89.7113053 33.9278717 95.5711403 33.9278717 75.2425712"
        />
        <polyline
          id="Fill-916"
          fill="#FFFFFE"
          points="15.6034807 66.4151211 6.10749409 60.9227188 6.10749409 80.878129 15.6034807 86.7384412 15.6034807 66.4151211"
        />
        <polyline
          id="Fill-927"
          fill="#343534"
          points="40.9902135 116.137348 83.4115056 91.5432195 41.3242432 67.3260678 40.9902135 116.137348"
        />
        <polyline
          id="Fill-928"
          fill="#636463"
          points="81.9799498 30.2344578 81.6463973 90.5172712 41.3242432 67.3260678 41.4196802 55.5496128 61.5091795 23.8401754 81.9799498 30.2344578"
        />
        <polyline
          id="Fill-2614"
          fill="#2A90C3"
          points="51.8223188 122.837029 93.0511249 100.51478 93.0511249 38.7336044 72.5798774 32.3436167 52.5380967 63.313417 51.8223188 122.837029"
        />
        <polyline
          id="Fill-2615"
          fill="#E4E4E3"
          points="76.1110483 73.4817576 85.6070349 67.9941271 85.6070349 87.9452427 76.1110483 93.8098495 76.1110483 73.4817576"
        />
        <polygon
          id="Fill-2616"
          fill="#E67848"
          points="50.2476075 121.901746 50.676597 62.3967441 70.7665735 30.8213957 89.2336429 36.5762499 85.6070349 34.4866556 68.905551 29.2991747 48.482022 60.9270135 47.7185256 120.451102"
        />
        <polygon
          id="Fill-2617"
          fill="#22749E"
          points="47.7185256 120.451102 48.482022 60.9270135 68.905551 29.2991747 85.6070349 34.4866556 81.6941158 32.2916035 66.9968099 27.7721819 46.2392513 59.4577601 45.1894437 118.996164"
        />
        <polyline
          id="Fill-2618"
          fill="#22749E"
          points="49.2932369 121.381614 51.8223188 122.837029 52.5380967 63.313417 72.5798774 32.3436167 93.0511249 38.7336044 89.2336429 36.5762499 70.7665735 30.8213957 50.3430445 61.8436864 49.2932369 121.381614"
        />
        <polyline
          id="Fill-2619"
          fill="#E4E4E3"
          points="60.1730608 82.3769679 70.6234179 76.3544128 70.6234179 112.730245 60.1730608 118.532818 60.1730608 82.3769679"
        />
      </g>
    </g>
  </svg>
)

export const step18Image1 = (
  <svg
    width="70px"
    height="70px"
    viewBox="0 0 128 128"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    aria-hidden="true"
  >
    <g
      id="3.isolatie/isolatie_7.1"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Group" transform="translate(12.800000, 1.600000)">
        <polyline
          id="Fill-961"
          fill="#F8F7F6"
          points="54.3609444 116.137348 95.3506807 92.0156329 95.3506807 30.2344578 53.950565 55.4155238 54.3609444 116.137348"
        />
        <polyline
          id="Fill-962"
          fill="#B4B5B4"
          points="74.536337 -3.82945138e-13 95.3559297 30.3685469 53.950565 55.5496128 33.8706095 23.8401754 74.536337 -3.82945138e-13"
        />
        <polyline
          id="Fill-963"
          fill="#9E9F9E"
          points="74.536337 9.57362844e-14 53.950565 6.85238028 13.3755027 30.2344578 33.8706095 23.8401754 74.536337 9.57362844e-14"
        />
        <polyline
          id="Fill-964"
          fill="#E4E4E3"
          points="61.4423736 75.2425712 70.9526757 69.7549407 70.9526757 89.7108281 61.4423736 95.5711403 61.4423736 75.2425712"
        />
        <polyline
          id="Fill-965"
          fill="#E4E4E3"
          points="79.7519718 66.4151211 89.2575021 60.9222416 89.2575021 80.8786062 79.7519718 86.7384412 79.7519718 66.4151211"
        />
        <polyline
          id="Fill-966"
          fill="#343534"
          points="54.3609444 116.137348 11.9391751 91.5432195 54.0460021 67.3313168 54.3609444 116.137348"
        />
        <polyline
          id="Fill-967"
          fill="#636463"
          points="13.3755027 30.2344578 13.7190761 90.5172712 54.0460021 67.3313168 53.950565 55.5496128 33.8706095 23.8401754 13.3755027 30.2344578"
        />
        <polyline
          id="Fill-968"
          fill="#E67848"
          points="41.2478935 123.371953 3.85936896e-13 101.049227 3.85936896e-13 39.2680519 20.4951067 32.8737695 40.5034845 63.8478644 41.2478935 123.371953"
        />
        <polyline
          id="Fill-969"
          fill="#E4E4E3"
          points="16.9639359 74.0166822 7.4536337 68.5238028 7.4536337 88.4796902 16.9639359 94.344297 16.9639359 74.0166822"
        />
        <polyline
          id="Fill-970"
          fill="#E4E4E3"
          points="31.4846832 81.1930713 21.9791529 75.700669 21.9791529 95.6565564 31.4846832 101.516391 31.4846832 81.1930713"
        />
        <polyline
          id="Fill-971"
          fill="#DE482A"
          points="45.3373712 120.981255 42.7939738 122.436193 42.3740507 62.9264197 20.8386801 32.1861455 2.38115443 37.9457716 7.4536337 35.0211031 24.1789769 29.8293275 44.592485 61.4571663 45.3373712 120.981255"
        />
        <polyline
          id="Fill-973"
          fill="#DE482A"
          points="43.7912909 121.916061 41.2478935 123.371953 40.5034845 63.8478644 20.4951067 32.8737695 3.82945138e-13 39.2680519 3.84134131 37.1106974 22.298867 31.3558432 42.722396 62.3776567 43.7912909 121.916061"
        />
      </g>
    </g>
  </svg>
)

export const step18Image2 = (
  <svg
    width="70px"
    height="70px"
    viewBox="0 0 128 128"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    aria-hidden="true"
  >
    <g
      id="3.isolatie/isolatie_7.2"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Group" transform="translate(20.800000, 3.200000)">
        <polyline
          id="Fill-945"
          fill="#F8F7F6"
          points="43.2624106 121.310036 86.5293545 97.1281162 86.5293545 31.9146536 42.8241955 58.4946677 43.2624106 121.310036"
        />
        <polyline
          id="Fill-946"
          fill="#B4B5B4"
          points="64.5536214 0 86.5348951 32.0551847 42.8292324 58.6351987 21.6337238 25.1696665 64.5536214 0"
        />
        <polyline
          id="Fill-947"
          fill="#9E9F9E"
          points="64.5536214 -3.03164901e-13 42.8241955 7.23860872 -6.06329801e-13 31.9146536 21.6337238 25.1696665 64.5536214 -3.03164901e-13"
        />
        <polyline
          id="Fill-948"
          fill="#E4E4E3"
          points="43.2674476 121.310036 -6.06329801e-13 97.1281162 -6.06329801e-13 31.9146536 21.6337238 25.1696665 42.8241955 58.4946677 43.2674476 121.310036"
        />
        <polyline
          id="Fill-949"
          fill="#E4E4E3"
          points="50.7367489 79.4282547 60.7708679 73.6302152 60.7708679 94.694763 50.7367489 100.880144 50.7367489 79.4282547"
        />
        <polyline
          id="Fill-950"
          fill="#E4E4E3"
          points="70.0590138 70.1043464 80.0971623 64.3068106 80.0971623 85.3713584 70.0590138 91.5617767 70.0590138 70.1043464"
        />
        <polyline
          id="Fill-951"
          fill="#FFFFFE"
          points="18.9893222 67.3340209 8.95066989 61.5415221 8.95066989 82.6060699 18.9893222 88.7914512 18.9893222 67.3340209"
        />
        <polyline
          id="Fill-952"
          fill="#FFFFFE"
          points="34.316274 74.9101056 24.2781254 69.1171031 24.2781254 90.1771177 34.316274 96.3670322 34.316274 74.9101056"
        />
      </g>
    </g>
  </svg>
)

export const step18Image3 = (
  <svg
    width="70px"
    height="70px"
    viewBox="0 0 128 128"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    aria-hidden="true"
  >
    <g
      id="3.isolatie/isolatie_7.3"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Group" transform="translate(17.600000, 3.200000)">
        <polyline
          id="Fill-961"
          fill="#F8F7F6"
          points="54.3609444 116.137348 95.3506807 92.0156329 95.3506807 30.2344578 53.950565 55.4155238 54.3609444 116.137348"
        />
        <polyline
          id="Fill-962"
          fill="#B4B5B4"
          points="74.536337 -3.82945138e-13 95.3559297 30.3685469 53.950565 55.5496128 33.8706095 23.8401754 74.536337 -3.82945138e-13"
        />
        <polyline
          id="Fill-963"
          fill="#9E9F9E"
          points="74.536337 9.57362844e-14 53.950565 6.85238028 13.3755027 30.2344578 33.8706095 23.8401754 74.536337 9.57362844e-14"
        />
        <polyline
          id="Fill-964"
          fill="#E4E4E3"
          points="61.4423736 75.2425712 70.9526757 69.7549407 70.9526757 89.7108281 61.4423736 95.5711403 61.4423736 75.2425712"
        />
        <polyline
          id="Fill-965"
          fill="#E4E4E3"
          points="79.7519718 66.4151211 89.2575021 60.9222416 89.2575021 80.8786062 79.7519718 86.7384412 79.7519718 66.4151211"
        />
        <polyline
          id="Fill-966"
          fill="#343534"
          points="54.3609444 116.137348 11.9391751 91.5432195 54.0460021 67.3313168 54.3609444 116.137348"
        />
        <polyline
          id="Fill-967"
          fill="#636463"
          points="13.3755027 30.2344578 13.7190761 90.5172712 54.0460021 67.3313168 53.950565 55.5496128 33.8706095 23.8401754 13.3755027 30.2344578"
        />
        <polyline
          id="Fill-968"
          fill="#2A90C3"
          points="41.2478935 123.371953 3.85936896e-13 101.049227 3.85936896e-13 39.2680519 20.4951067 32.8737695 40.5034845 63.8478644 41.2478935 123.371953"
        />
        <polyline
          id="Fill-969"
          fill="#E4E4E3"
          points="16.9639359 74.0166822 7.4536337 68.5238028 7.4536337 88.4796902 16.9639359 94.344297 16.9639359 74.0166822"
        />
        <polyline
          id="Fill-970"
          fill="#E4E4E3"
          points="31.4846832 81.1930713 21.9791529 75.700669 21.9791529 95.6565564 31.4846832 101.516391 31.4846832 81.1930713"
        />
        <polyline
          id="Fill-971"
          fill="#E67848"
          points="45.3373712 120.981255 42.7939738 122.436193 42.3740507 62.9264197 20.8386801 32.1861455 2.38115443 37.9457716 7.4536337 35.0211031 24.1789769 29.8293275 44.592485 61.4571663 45.3373712 120.981255"
        />
        <polyline
          id="Fill-972"
          fill="#22749E"
          points="47.8802914 119.530612 45.3373712 120.981255 44.592485 61.4571663 24.1789769 29.8293275 7.4536337 35.0211031 11.3856402 32.8260509 26.054315 28.3066294 46.8066246 59.9869585 47.8802914 119.530612"
        />
        <polyline
          id="Fill-973"
          fill="#22749E"
          points="43.7912909 121.916061 41.2478935 123.371953 40.5034845 63.8478644 20.4951067 32.8737695 3.82945138e-13 39.2680519 3.84134131 37.1106974 22.298867 31.3558432 42.722396 62.3776567 43.7912909 121.916061"
        />
      </g>
    </g>
  </svg>
)

export const step19Image1 = (
  <svg
    width="70px"
    height="70px"
    viewBox="0 0 128 128"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    aria-hidden="true"
  >
    <g
      id="3.isolatie/isolatie_8.1"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Group-Copy" transform="translate(16.000000, 0.000000)">
        <polyline
          id="Fill-917"
          fill="#636463"
          points="10.5803746 93.2407596 53.8170771 71.3125478 55.0708969 7.78419294 32.4292621 1.24332837e-14 11.0166583 31.4129195 10.5803746 93.2407596"
        />
        <polyline
          id="Fill-918"
          fill="#B4B5B4"
          points="32.5333753 1.98932539e-13 10.9026296 31.5512412 53.9211903 57.7133877 74.7834818 24.7739712 32.5333753 1.98932539e-13"
        />
        <polyline
          id="Fill-919"
          fill="#9E9F9E"
          points="32.5333753 -9.94662695e-14 53.9211903 7.12480968 96.0770992 31.4129195 74.7834818 24.7739712 32.5333753 -9.94662695e-14"
        />
        <polyline
          id="Fill-920"
          fill="#F8F7F6"
          points="53.4898644 119.402906 96.0770992 95.6011534 96.0770992 31.4129195 74.7834818 24.7739712 53.9211903 57.5750659 53.4898644 119.402906"
        />
        <polyline
          id="Fill-921"
          fill="#E4E4E3"
          points="59.3449894 78.5409748 70.18763 72.2798085 70.18763 110.072385 59.3449894 116.101528 59.3449894 78.5409748"
        />
        <polyline
          id="Fill-922"
          fill="#E4E4E3"
          points="77.4557192 69.0022275 87.3365526 63.301289 87.3365526 84.029225 77.4557192 90.1223229 77.4557192 69.0022275"
        />
        <polyline
          id="Fill-923"
          fill="#343534"
          points="53.4898644 119.402906 8.2398119 94.1926512 53.8170771 71.3125478 53.4898644 119.402906"
        />
        <polyline
          id="Fill-924"
          fill="#E67848"
          points="42.5877306 126.824686 7.95730156e-13 103.022933 7.95730156e-13 38.8342037 43.0140987 64.9963502 42.5877306 126.824686"
        />
        <polyline
          id="Fill-925"
          fill="#FFFFFE"
          points="35.2304015 85.5963757 25.3495681 79.8944457 25.3495681 100.623373 35.2304015 106.715975 35.2304015 85.5963757"
        />
        <polyline
          id="Fill-926"
          fill="#FFFFFE"
          points="16.2074423 76.4240075 6.33156665 70.7176155 6.33156665 91.451005 16.2074423 97.5391452 16.2074423 76.4240075"
        />
        <polyline
          id="Fill-2620"
          fill="#DE482A"
          points="47.3372732 62.5576237 46.6729321 124.340844 44.0304413 125.853459 45.0368684 64.0841207 2.29048923 37.4415665 3.78327344 36.5784189 4.41786786 36.2120398"
        />
        <polyline
          id="Fill-2623"
          fill="#DE482A"
          points="45.3938278 63.5139773 45.0715728 125.312567 42.4285862 126.824686 43.0929272 65.0409701 5.96797617e-13 38.8342037 2.29048923 37.4415665 45.3938278 63.5139773"
        />
      </g>
    </g>
  </svg>
)

export const step19Image2 = (
  <svg
    width="70px"
    height="70px"
    viewBox="0 0 128 128"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    aria-hidden="true"
  >
    <g
      id="3.isolatie/isolatie_8.2"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Group" transform="translate(19.200000, 0.000000)">
        <polyline
          id="Fill-929"
          fill="#E4E4E3"
          points="45.5499837 127.694775 0.0053020584 102.240122 0.0053020584 33.593842 46.0059607 61.5728042 45.5499837 127.694775"
        />
        <polyline
          id="Fill-930"
          fill="#B4B5B4"
          points="23.1328808 2.12747299e-13 2.12747299e-13 33.7422997 46.0059607 61.7212618 68.3170225 26.4943858 23.1328808 2.12747299e-13"
        />
        <polyline
          id="Fill-931"
          fill="#9E9F9E"
          points="23.1328808 2.12747299e-13 46.0059607 7.61905792 91.0893633 33.593842 68.3170225 26.4943858 23.1328808 2.12747299e-13"
        />
        <polyline
          id="Fill-932"
          fill="#F8F7F6"
          points="45.5446817 127.694775 91.0893633 102.240122 91.0893633 33.593842 68.3170225 26.4943858 46.0059607 61.5728042 45.5446817 127.694775"
        />
        <polyline
          id="Fill-933"
          fill="#E4E4E3"
          points="51.8064126 83.9952092 63.4020143 77.2987094 63.4020143 117.716301 51.8064126 124.164134 51.8064126 83.9952092"
        />
        <polyline
          id="Fill-934"
          fill="#E4E4E3"
          points="71.180134 73.7940488 81.7418344 67.6972119 81.7418344 89.8645878 71.180134 96.3813478 71.180134 73.7940488"
        />
        <polyline
          id="Fill-935"
          fill="#FFFFFE"
          points="37.6811988 83.6081589 27.1194985 77.5054897 27.1194985 99.6786979 37.6811988 106.189626 37.6811988 83.6081589"
        />
        <polyline
          id="Fill-936"
          fill="#FFFFFE"
          points="17.337731 73.7940488 6.77603064 67.6972119 6.77603064 89.8645878 17.337731 96.3813478 17.337731 73.7940488"
        />
      </g>
    </g>
  </svg>
)

export const step19Image3 = (
  <svg
    width="70px"
    height="70px"
    viewBox="0 0 128 128"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    aria-hidden="true"
  >
    <g
      id="3.isolatie/isolatie_8.3"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Group" transform="translate(16.000000, 1.600000)">
        <polyline
          id="Fill-917"
          fill="#636463"
          points="10.5803746 93.2407596 53.8170771 71.3125478 55.0708969 7.78419294 32.4292621 1.24332837e-14 11.0166583 31.4129195 10.5803746 93.2407596"
        />
        <polyline
          id="Fill-918"
          fill="#B4B5B4"
          points="32.5333753 1.98932539e-13 10.9026296 31.5512412 53.9211903 57.7133877 74.7834818 24.7739712 32.5333753 1.98932539e-13"
        />
        <polyline
          id="Fill-919"
          fill="#9E9F9E"
          points="32.5333753 -9.94662695e-14 53.9211903 7.12480968 96.0770992 31.4129195 74.7834818 24.7739712 32.5333753 -9.94662695e-14"
        />
        <polyline
          id="Fill-920"
          fill="#F8F7F6"
          points="53.4898644 119.402906 96.0770992 95.6011534 96.0770992 31.4129195 74.7834818 24.7739712 53.9211903 57.5750659 53.4898644 119.402906"
        />
        <polyline
          id="Fill-921"
          fill="#E4E4E3"
          points="59.3449894 78.5409748 70.18763 72.2798085 70.18763 110.072385 59.3449894 116.101528 59.3449894 78.5409748"
        />
        <polyline
          id="Fill-922"
          fill="#E4E4E3"
          points="77.4557192 69.0022275 87.3365526 63.301289 87.3365526 84.029225 77.4557192 90.1223229 77.4557192 69.0022275"
        />
        <polyline
          id="Fill-923"
          fill="#343534"
          points="53.4898644 119.402906 8.2398119 94.1926512 53.8170771 71.3125478 53.4898644 119.402906"
        />
        <polyline
          id="Fill-924"
          fill="#2A90C3"
          points="42.5877306 126.824686 7.95730156e-13 103.022933 7.95730156e-13 38.8342037 43.0140987 64.9963502 42.5877306 126.824686"
        />
        <polyline
          id="Fill-925"
          fill="#FFFFFE"
          points="35.2304015 85.5963757 25.3495681 79.8944457 25.3495681 100.623373 35.2304015 106.715975 35.2304015 85.5963757"
        />
        <polyline
          id="Fill-926"
          fill="#FFFFFE"
          points="16.2074423 76.4240075 6.33156665 70.7176155 6.33156665 91.451005 16.2074423 97.5391452 16.2074423 76.4240075"
        />
        <polyline
          id="Fill-2620"
          fill="#E67848"
          points="47.3372732 62.5576237 46.6729321 124.340844 44.0304413 125.853459 45.0368684 64.0841207 2.29048923 37.4415665 3.78327344 36.5784189 4.41786786 36.2120398"
        />
        <polyline
          id="Fill-2622"
          fill="#22749E"
          points="4.41786786 36.2120398 6.51996187 34.9820173 49.6376779 61.0301351 49.315423 122.82922 46.6729321 124.340844 47.3372732 62.5576237"
        />
        <polyline
          id="Fill-2623"
          fill="#22749E"
          points="45.3938278 63.5139773 45.0715728 125.312567 42.4285862 126.824686 43.0929272 65.0409701 5.96797617e-13 38.8342037 2.29048923 37.4415665 45.3938278 63.5139773"
        />
      </g>
    </g>
  </svg>
)

export const step20Image1 = (
  <svg
    width="70px"
    height="70px"
    viewBox="0 0 128 128"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    aria-hidden="true"
  >
    <g
      id="3.isolatie/isolatie_9.1"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <polyline
        id="Fill-1554"
        fill="#DE482A"
        points="71.245178 52.9533414 126.949876 85.2982208 56.7982598 125.804642 0.0371959789 94.2103773 71.245178 52.9533414"
      />
      <polyline
        id="Fill-1555"
        fill="#E67848"
        points="71.245178 51.227448 126.949876 83.5723274 56.7982598 124.078748 0.0371959789 92.4844839 71.245178 51.227448"
      />
      <polyline
        id="Fill-1557"
        fill="#DE482A"
        points="0.0371959789 92.4844839 1.56223112 93.3325522 0.0371959789 94.2103773 0.0371959789 92.4844839"
      />
      <polyline
        id="Fill-1558"
        fill="#EFEFEE"
        points="1.56223112 93.3325522 0.0371959789 92.4844839 0.0371959789 92.4993623 2.38742359e-12 92.4770447 2.38742359e-12 43.7577515 42.8572069 67.6822052 0.0371959789 92.4844839 1.56223112 93.3325522"
      />
      <polyline
        id="Fill-1559"
        fill="#E3A787"
        points="56.916543 124.24985 1.54735272 93.3399914 1.56223112 93.3325522 56.7982598 124.078748 56.916543 124.004356 56.916543 124.24985"
      />
      <polyline
        id="Fill-1560"
        fill="#E8BA9B"
        points="56.7982598 124.078748 1.56223112 93.3325522 0.0371959789 92.4844839 42.8572069 67.6822052 56.916543 75.5305567 56.916543 124.004356 56.7982598 124.078748"
      />
      <polyline
        id="Fill-1561"
        fill="#E3A787"
        points="1.54735272 93.5347403 0.0371959789 92.5027492 0.0371959789 92.4844839 1.56223112 93.5256077 1.54735272 93.5347403"
      />
      <polyline
        id="Fill-1562"
        fill="#EFEFEE"
        points="99.0156959 50.9068187 99.0156959 50.9068187 43.1101396 19.0670607 70.8129608 3.2 126.853167 34.9646221 99.0156959 50.9068187"
      />
      <polyline
        id="Fill-1563"
        fill="#FFFFFE"
        points="126.905241 83.5500098 71.9370233 51.6284206 76.6311558 44.1527728 99.0156959 50.9068187 126.853167 34.9646221 126.853167 71.7068101 126.905241 83.5500098"
      />
      <path
        d="M56.916543,124.24985 L56.916543,124.004356 L70.9996846,115.880755 L70.9996846,116.066735 L56.916543,124.24985 M84.1811956,108.404363 L84.1811956,108.263762 L118.49151,88.4524398 L84.1811956,108.404363"
        id="Fill-1564"
        fill="#F1B08E"
      />
      <path
        d="M56.916543,124.004356 L56.916543,75.5305567 L71.9370233,51.6284206 L126.905241,83.5500098 L126.905241,83.5656321 L118.49151,88.4524398 L84.1811956,108.263762 L84.1811956,78.0524441 L70.9996846,85.6709245 L70.9996846,115.880755 L56.916543,124.004356 M102.280759,70.0032342 L89.0992479,77.6135315 L89.0992479,92.8341261 L102.280759,85.2238288 L102.280759,70.0032342"
        id="Fill-1565"
        fill="#F5C4A3"
      />
      <polyline
        id="Fill-1566"
        fill="#E3A787"
        points="70.9996846 116.118809 70.9996846 115.880755 84.1811956 108.263762 84.1811956 108.508512 70.9996846 116.118809"
      />
      <polyline
        id="Fill-1567"
        fill="#E8BA9B"
        points="70.9996846 115.880755 70.9996846 85.6709245 84.1811956 78.0524441 84.1811956 108.263762 70.9996846 115.880755"
      />
      <polyline
        id="Fill-1568"
        fill="#E8BA9B"
        points="89.0992479 92.8341261 89.0992479 77.6135315 102.280759 70.0032342 102.280759 85.2238288 89.0992479 92.8341261"
      />
      <polyline
        id="Fill-1569"
        fill="#EFEFEE"
        points="42.8572069 67.6822052 1.1937118e-12 43.7577515 18.2409081 11.3526147 76.6311558 44.1527728 71.9370233 51.6284206 71.245178 51.227448 42.8572069 67.6822052"
      />
      <polyline
        id="Fill-1570"
        fill="#E8BA9B"
        points="56.916543 75.5305567 56.916543 75.5305567 42.8572069 67.6822052 71.245178 51.227448 71.9370233 51.6284206 56.916543 75.5305567"
      />
      <polyline
        id="Fill-1571"
        fill="#C2C2C1"
        points="99.0156959 50.9068187 76.6311558 44.1527728 18.2409081 11.3526147 42.9390381 18.9710951 43.1101396 19.0670607 99.0156959 50.9068187"
      />
    </g>
  </svg>
)

export const step20Image2 = (
  <svg
    width="70px"
    height="70px"
    viewBox="0 0 128 128"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    aria-hidden="true"
  >
    <g
      id="3.isolatie/isolatie_9.2"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Group" transform="translate(0.000000, 1.600000)">
        <polyline
          id="Fill-1540"
          fill="#9E9F9E"
          points="71.2302997 50.1104228 126.934998 82.4553022 56.7833814 122.961723 0.0297567831 91.3674587 71.2302997 50.1104228"
        />
        <polyline
          id="Fill-1541"
          fill="#B4B5B4"
          points="71.2302997 48.3837855 126.934998 80.7294088 56.7833814 121.23583 0.0297567831 89.6415653 71.2302997 48.3837855"
        />
        <polyline
          id="Fill-1543"
          fill="#9E9F9E"
          points="0.0297567831 89.6415653 1.54735272 90.4903775 0.0297567831 91.3674587 0.0297567831 89.6415653"
        />
        <polyline
          id="Fill-1544"
          fill="#EFEFEE"
          points="0.327324615 89.4712077 -2.98500825e-13 89.2844839 -2.98500825e-13 40.5651907 43.1540308 64.6533067 0.327324615 89.4712077"
        />
        <polyline
          id="Fill-1545"
          fill="#D1D2D0"
          points="56.9247262 121.057289 0.327324615 89.4712077 43.1540308 64.6533067 56.9247262 72.3379959 56.9247262 121.057289"
        />
        <polyline
          id="Fill-1546"
          fill="#EFEFEE"
          points="99.014952 47.7142579 99.014952 47.7142579 43.1101396 15.8752438 70.8137047 -5.9700165e-13 126.853167 31.7720613 99.014952 47.7142579"
        />
        <polyline
          id="Fill-1547"
          fill="#FFFFFE"
          points="126.607673 80.5441728 71.7733609 48.6969756 76.6311558 40.960212 99.014952 47.7142579 126.853167 31.7720613 126.853167 68.5068101 126.905241 80.3730713 126.607673 80.5441728"
        />
        <path
          d="M56.9247262,121.057289 L56.9247262,72.3379959 L71.7733609,48.6969756 L126.607673,80.5441728 L84.1819395,105.204363 L84.1819395,74.8598833 L70.9996846,82.4776198 L70.9996846,112.866735 L56.9247262,121.057289 M102.288198,66.8039782 L89.0992479,74.4209707 L89.0992479,89.6415653 L102.288198,82.031268 L102.288198,66.8039782"
          id="Fill-1548"
          fill="#DFDFDE"
        />
        <polyline
          id="Fill-1549"
          fill="#D1D2D0"
          points="70.9996846 112.926248 70.9996846 82.4776198 84.1819395 74.8598833 84.1819395 105.308512 70.9996846 112.926248"
        />
        <polyline
          id="Fill-1550"
          fill="#D1D2D0"
          points="89.0992479 89.6415653 89.0992479 74.4209707 102.288198 66.8039782 102.288198 82.031268 89.0992479 89.6415653"
        />
        <polyline
          id="Fill-1551"
          fill="#EFEFEE"
          points="43.1540308 64.6533067 -8.95502476e-13 40.5651907 18.2409081 8.16005386 76.6311558 40.960212 71.7733609 48.6969756 71.2302997 48.3837855 43.1540308 64.6533067"
        />
        <polyline
          id="Fill-1552"
          fill="#D1D2D0"
          points="56.9247262 72.3379959 56.9247262 72.3379959 43.1540308 64.6533067 71.2302997 48.3837855 71.7733609 48.6969756 56.9247262 72.3379959"
        />
        <polyline
          id="Fill-1553"
          fill="#C2C2C1"
          points="99.014952 47.7142579 76.6311558 40.960212 18.2409081 8.16005386 42.9390381 15.7785343 43.1101396 15.8752438 99.014952 47.7142579"
        />
      </g>
    </g>
  </svg>
)

export const step20Image3 = (
  <svg
    width="70px"
    height="70px"
    viewBox="0 0 128 128"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    aria-hidden="true"
  >
    <g
      id="3.isolatie/isolatie_9.3"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Group" transform="translate(1.600000, 3.200000)">
        <polyline
          id="Fill-974"
          fill="#9E9F9E"
          points="35.2841056 120.776088 33.7880833 121.639034 35.2841056 122.501981 35.2841056 120.776088"
        />
        <polyline
          id="Fill-1539"
          fill="#9E9F9E"
          points="71.2079821 49.7689637 126.905241 82.1138431 56.7610638 122.620264 2.3880066e-12 91.0267436 71.2079821 49.7689637"
        />
        <polyline
          id="Fill-1572"
          fill="#DE482A"
          points="126.905241 82.1138431 71.2079821 49.7689637 45.0889657 65.3615181 98.450317 98.5470266 126.905241 82.1212823 126.905241 82.1138431"
        />
        <polyline
          id="Fill-1573"
          fill="#E67848"
          points="71.2079821 48.0430703 126.905241 80.3879497 56.7610638 120.894371 2.3880066e-12 89.3001062 71.2079821 48.0430703"
        />
        <path
          d="M40.4394683,65.8748226 C40.4394683,65.8748226 46.3461897,83.6388782 65.3607742,88.4594771 C84.3671755,93.280076 96.5005038,89.4414509 98.450317,96.8211332 L56.7610638,120.894371 L2.3880066e-12,89.3001062 L40.4394683,65.8748226"
          id="Fill-1575"
          fill="#B4B5B4"
        />
        <polyline
          id="Fill-1576"
          fill="#DE482A"
          points="126.905241 80.3514976 125.387645 81.2285788 126.905241 82.1138431 126.905241 80.3514976"
        />
        <polyline
          id="Fill-1577"
          fill="#9E9F9E"
          points="98.450317 96.8211332 98.450317 98.5470266 97.0584435 97.6171271 98.450317 96.8211332"
        />
        <polyline
          id="Fill-1578"
          fill="#C6C7C6"
          points="56.9247262 121.058777 10.2437726 94.9985302 56.7610638 120.894371 56.9247262 120.797661 56.9247262 121.058777"
        />
        <polyline
          id="Fill-1579"
          fill="#EFEFEE"
          points="0.0148783916 89.292667 -8.95502476e-13 89.2852278 -8.95502476e-13 40.5659346 42.8423285 64.4762538 40.4394683 65.8748226 0.0148783916 89.292667"
        />
        <path
          d="M56.9247262,85.1200221 C44.5979787,78.2462052 40.4692251,65.9715321 40.4394683,65.8748226 L42.8423285,64.4762538 L56.9247262,72.3394837 L56.9247262,85.1200221"
          id="Fill-1580"
          fill="#E8BA9B"
        />
        <path
          d="M56.7610638,120.894371 L10.2437726,94.9985302 L0.0148783916,89.292667 L40.4394683,65.8748226 C40.4692251,65.9715321 44.5979787,78.2462052 56.9247262,85.1200221 L56.9247262,120.797661 L56.7610638,120.894371"
          id="Fill-1581"
          fill="#D1D2D0"
        />
        <polyline
          id="Fill-1582"
          fill="#EFEFEE"
          points="99.014952 47.7157457 99.014952 47.7157457 43.1101396 15.8752438 70.8137047 7.46252063e-13 126.853167 31.7728052 99.014952 47.7157457"
        />
        <path
          d="M56.9247262,121.058777 L56.9247262,120.797661 L70.9996846,112.66662 L70.9996846,112.874918 L56.9247262,121.058777 M84.1819395,105.212546 L84.1819395,105.057067 L97.0145522,97.6543231 L97.0963834,97.7063975 L84.1819395,105.212546"
          id="Fill-1583"
          fill="#D4D5D4"
        />
        <polyline
          id="Fill-1584"
          fill="#F1B08E"
          points="97.2572102 97.8762612 97.141682 97.8027433 97.2036472 97.7617833 97.3202256 97.8353012 97.2572102 97.8762612"
        />
        <polyline
          id="Fill-1585"
          fill="#FFFFFE"
          points="126.87474 80.3730713 71.9221449 48.4589214 76.6311558 40.960212 99.014952 47.7157457 126.853167 31.7728052 126.853167 68.5149932 126.905241 80.3514976 126.87474 80.3730713"
        />
        <polyline
          id="Fill-1586"
          fill="#F1B08E"
          points="98.450317 96.9178427 98.450317 96.8211332 122.769048 82.7841146 98.450317 96.9178427"
        />
        <path
          d="M98.450317,96.8211332 C97.2518626,92.3055413 92.2452838,91.993839 84.1819395,91.3235675 L84.1819395,74.8606272 L70.9996846,82.4791076 L70.9996846,89.6943836 C69.1993992,89.3596198 67.3098435,88.9579032 65.3607742,88.4594771 C62.1909329,87.6567879 59.3945392,86.4955294 56.9247262,85.1200221 L56.9247262,72.3394837 L71.9221449,48.4589214 L126.87474,80.3730713 L125.387645,81.2285788 L125.409219,81.2434572 L122.769048,82.7841146 L98.450317,96.8211332 M102.288198,66.8121613 L89.1066871,74.4217146 L89.1066871,89.6423092 L102.288198,82.0320119 L102.288198,66.8121613"
          id="Fill-1587"
          fill="#F5C4A3"
        />
        <path
          d="M56.9247262,120.797661 L56.9247262,85.1200221 C59.3945392,86.4955294 62.1909329,87.6567879 65.3607742,88.4594771 C67.3098435,88.9579032 69.1993992,89.3596198 70.9996846,89.6943836 L70.9996846,112.66662 L56.9247262,120.797661 M84.1819395,105.057067 L84.1819395,91.3235675 C92.2452838,91.993839 97.2518626,92.3055413 98.450317,96.8211332 L97.0584435,97.6171271 L97.0584435,97.6253102 L97.0145522,97.6543231 L84.1819395,105.057067"
          id="Fill-1588"
          fill="#DFDFDE"
        />
        <polyline
          id="Fill-1589"
          fill="#F1B08E"
          points="125.409219 81.401754 125.387645 81.3842351 126.87474 80.3769 126.905241 80.3514976 126.905241 80.3769 125.409219 81.401754"
        />
        <polyline
          id="Fill-1590"
          fill="#D4D5D4"
          points="97.1410186 97.8713896 97.0584435 97.8075165 97.0584435 97.7974793 98.450317 96.8211332 98.450317 96.9397546 97.1410186 97.8713896"
        />
        <polyline
          id="Fill-1591"
          fill="#C6C7C6"
          points="70.9996846 112.926992 70.9996846 112.66662 84.1819395 105.057067 84.1819395 105.316695 70.9996846 112.926992"
        />
        <path
          d="M84.1819395,91.3235675 C80.4251456,91.0111212 76.0062633,90.625027 70.9996846,89.6943836 L70.9996846,82.4791076 L84.1819395,74.8606272 L84.1819395,91.3235675"
          id="Fill-1592"
          fill="#E8BA9B"
        />
        <path
          d="M70.9996846,112.66662 L70.9996846,89.6943836 C76.0062633,90.625027 80.4251456,91.0111212 84.1819395,91.3235675 L84.1819395,105.057067 L70.9996846,112.66662"
          id="Fill-1593"
          fill="#D1D2D0"
        />
        <polyline
          id="Fill-1594"
          fill="#E8BA9B"
          points="89.1066871 89.6423092 89.1066871 74.4217146 102.288198 66.8121613 102.288198 82.0320119 89.1066871 89.6423092"
        />
        <polyline
          id="Fill-1595"
          fill="#EFEFEE"
          points="42.8423285 64.4762538 1.1940033e-12 40.5659346 18.2409081 8.16079778 76.6311558 40.960212 71.9221449 48.4589214 71.2079821 48.0430703 42.8423285 64.4762538"
        />
        <polyline
          id="Fill-1596"
          fill="#E8BA9B"
          points="56.9247262 72.3394837 56.9247262 72.3394837 42.8423285 64.4762538 71.2079821 48.0430703 71.9221449 48.4589214 56.9247262 72.3394837"
        />
        <polyline
          id="Fill-1597"
          fill="#C2C2C1"
          points="99.014952 47.7157457 76.6311558 40.960212 18.2409081 8.16079778 42.9382942 15.7785343 43.1101396 15.8752438 99.014952 47.7157457"
        />
      </g>
    </g>
  </svg>
)

export const step21Image1 = (
  <svg
    width="70px"
    height="70px"
    viewBox="0 0 128 128"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    aria-hidden="true"
  >
    <g
      id="3.isolatie/isolatie_10.1"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Group" transform="translate(6.400000, 0.000000)">
        <polyline
          id="Fill-1759"
          fill="#45596D"
          points="4.41615072 108.019651 4.41615072 107.324929 33.2212399 90.7365975 33.8181191 91.0425925 4.41615072 108.019651"
        />
        <polyline
          id="Fill-1760"
          fill="#737F8F"
          points="33.8181191 91.0425925 33.2212399 90.7328198 33.2212399 90.7139312 33.0773089 69.0566596 33.8407854 68.6218445 33.8407854 91.0316372 33.8181191 91.0425925"
        />
        <path
          d="M33.8407854,91.0316372 L4.41615072,108.019651 L4.41615072,57.0472985 L33.8407854,40.0589069 L33.8407854,91.0316372 M2.05507784,54.3235649 L2.05507784,113.470896 L36.2014805,93.7553708 L36.2014805,34.6072841 L2.05507784,54.3235649"
          id="Fill-1761"
          fill="#F8F7F6"
        />
        <polyline
          id="Fill-1762"
          fill="#B4B5B4"
          points="2.05507784 113.470896 1.87109587e-13 112.265804 1.87109587e-13 52.9745423 33.8407854 33.35346 36.2014805 34.6072841 2.05507784 54.3235649 2.05507784 113.470896"
        />
        <polyline
          id="Fill-1763"
          fill="#FFFFFE"
          points="4.04933443 57.1039643 4.41615072 107.324929 33.2212399 90.7365975 32.8888008 40.6100758 4.04933443 57.1039643"
        />
        <polyline
          id="Fill-1764"
          fill="#C7D6E3"
          points="4.08425803 85.6672796 4.08425803 57.1039643 4.3781247 85.5497926 4.08425803 85.6672796"
        />
        <polyline
          id="Fill-1765"
          fill="#CCDBE8"
          points="32.7921387 40.7846447 32.9521387 40.6934447 32.7921387 40.7846447"
        />
        <polyline
          id="Fill-1766"
          fill="#73889E"
          points="33.0773089 69.0566596 32.8888008 40.6100758 32.8510236 40.6289644 33.8407854 40.0589069 33.8407854 68.6218445 33.0773089 69.0566596"
        />
        <path
          d="M33.9185662,68.6218445 L33.9185662,40.0589069 L33.9185662,68.6218445 M4.04933443,57.1039643 L33.8407854,40.0589069 L32.8510236,40.6289644 L32.7376921,40.6935633 L4.04933443,57.1039643"
          id="Fill-1767"
          fill="#C7D6E3"
        />
        <polyline
          id="Fill-1768"
          fill="#CCDBE8"
          points="4.25748662 85.5497926 4.04933443 57.1039643 32.7376921 40.6935633 32.8510236 40.6289644 32.8888008 40.6100758 33.0773089 69.0566596 4.25748662 85.5497926"
        />
        <path
          d="M64.5343551,74.666191 L64.5343551,73.9714689 L80.862024,64.5683545 L81.4400147,64.9049491 L64.5343551,74.666191 M85.0813557,62.8041609 L84.5037429,62.4717218 L93.339822,57.3793598 L93.9367012,57.6891326 L85.0813557,62.8041609"
          id="Fill-1769"
          fill="#45596D"
        />
        <path
          d="M98.3716665,57.6891326 L94.1963834,57.3793598 L94.1963834,57.360849 L94.0887188,55.2185059 C95.6669233,55.1206631 97.2950211,54.9993984 98.5292243,54.867556 L98.5292243,57.6777994 L98.3716665,57.6891326 M98.5292243,42.2609379 C97.1348373,41.9288767 95.4831058,41.5586604 93.4611134,41.154067 L93.195891,35.7065996 L98.5292243,35.2683845 L98.5292243,42.2609379"
          id="Fill-1770"
          fill="#737F8F"
        />
        <path
          d="M93.9631452,57.6777994 L64.5343551,74.666191 L64.5343551,23.6938386 L93.9631452,6.70506921 L93.9631452,57.6777994 M62.1774377,20.9701049 L62.1774377,80.1174361 L96.3200626,60.4019109 L96.3200626,1.25420191 L62.1774377,20.9701049"
          id="Fill-1771"
          fill="#F8F7F6"
        />
        <polyline
          id="Fill-1772"
          fill="#B4B5B4"
          points="62.1774377 80.1174361 60.1185821 78.9123445 60.1185821 19.6210823 93.9631452 -5.25801624e-13 96.3200626 1.25420191 68.1537854 17.5172719 62.1774377 20.9701049"
        />
        <polyline
          id="Fill-1773"
          fill="#FFFFFE"
          points="64.1716943 23.7505043 64.5343551 73.9714689 93.339822 57.3793598 93.0073829 7.25661584 64.1716943 23.7505043"
        />
        <path
          d="M77.8625171,51.7316735 L108.692462,69.438209 C108.692462,69.438209 113.104835,72.9363746 113.765936,78.2474664 C114.427036,83.5630914 112.628843,85.2101759 112.628843,85.2101759 C112.628843,85.2101759 111.140423,86.9025929 109.108011,87.0121467 C107.381595,87.1103673 105.485181,86.1655604 105.485181,86.1655604 C105.485181,86.1655604 104.280089,85.6181693 104.178091,84.768183 C104.178091,84.768183 103.989205,83.9140413 104.332977,83.4720484 C104.67675,83.0266557 105.137631,82.7013943 105.439848,82.6299954 C105.738288,82.5582188 106.199169,82.5733297 106.199169,82.5733297 C106.199169,82.5733297 106.742783,82.7920595 107.287152,83.0716105 C107.831143,83.3549392 108.635797,83.7176 109.270453,83.3436061 C109.905109,82.9733899 110.00333,82.6107291 110.00333,82.6107291 C110.00333,82.6107291 110.509544,82.0402938 110.373546,80.4083203 C110.237548,78.7801244 109.866954,77.503634 109.866954,77.503634 C109.866954,77.503634 109.270453,75.2177377 108.012473,73.9144254 C106.750338,72.6077132 106.123615,72.2182307 106.123615,72.2182307 L101.563911,69.438209 L75.0254519,54.1531898 C75.0254519,54.1531898 74.4210172,53.7569074 74.2736863,53.2960259 C74.1225776,52.8385445 74.1225776,52.4532174 74.1225776,52.4532174 C74.1225776,52.4532174 74.1410884,51.8336718 74.3832401,51.5427877 C74.6287916,51.2519035 75.0896731,50.9802857 75.0896731,50.9802857 C75.0896731,50.9802857 75.4255121,50.8023552 75.8187724,50.7759112 C76.2116549,50.7460672 76.6649809,50.9727302 76.6649809,50.9727302 L77.8625171,51.7316735"
          id="Fill-1774"
          fill="#679CC7"
        />
        <path
          d="M96.5958359,77.8322953 C96.0333339,76.5399385 94.9978618,74.8025666 94.5562468,74.0810227 C94.420249,73.8615374 94.2653626,73.653763 94.0915876,73.4610994 C93.6344839,72.9511077 93.1169367,72.2144529 92.3005722,71.4743983 C92.062576,71.2549129 91.7263592,70.9678065 91.2960773,70.6546338 L65.6676701,55.7020536 C65.6676701,55.7020536 65.0673909,55.3053934 64.9162822,54.8482897 C64.7651736,54.3874083 64.7651736,54.0020812 64.7651736,54.0020812 C64.7651736,54.0020812 64.7840621,53.3825356 65.025836,53.0920292 C65.2713876,52.8049228 65.732269,52.5325494 65.732269,52.5325494 C65.732269,52.5325494 66.0684858,52.351219 66.4609905,52.3251528 C66.8580286,52.298331 67.3075768,52.521594 67.3075768,52.521594 L68.505113,53.2846928 L92.5956118,67.1145355 C92.8147194,67.2773551 93.1320476,67.5153513 93.5060415,67.8213463 C94.1218093,68.3234048 96.2939964,70.2164186 98.2546313,73.2763691 C99.0403964,74.4999715 99.9546038,76.5550493 100.260599,77.2614823 C100.335775,77.4318574 100.396597,77.6014768 100.449485,77.7790295 C100.702592,78.6705706 101.461913,81.5382353 101.344803,83.7368664 C101.205028,86.3733348 100.661037,87.6086481 100.661037,87.6086481 C100.661037,87.6086481 99.8408945,89.3841749 98.6584692,90.3248264 C97.4764217,91.2654778 96.2071089,91.5907392 96.2071089,91.5907392 C96.2071089,91.5907392 95.153126,91.8816234 93.3171557,91.5907392 C91.4811854,91.2994773 89.5885494,90.2080949 89.5885494,90.2080949 C89.5885494,90.2080949 88.6626311,89.6826146 88.8632278,88.5379664 C89.0634468,87.3936961 89.6981032,87.2270988 89.6981032,87.2270988 C89.6981032,87.2270988 90.1703178,86.664219 91.1714127,87.0193243 C92.1721298,87.3748075 93.3545551,88.1379062 94.0160333,88.0997513 C94.1406979,88.0921959 94.2763179,88.0963513 94.4240267,88.103529 C95.0624608,88.1224176 95.9045138,88.1416839 96.7318337,87.2119879 C97.752195,86.063562 97.7333064,84.1750815 97.7333064,84.1750815 C97.7333064,84.1750815 97.7858167,81.5193467 97.3895342,80.1933682 C97.0873169,79.1956732 96.8262767,78.4439076 96.7133229,78.1303572 C96.6793235,78.0249589 96.6415463,77.9301382 96.5958359,77.8322953"
          id="Fill-1775"
          fill="#679CC7"
        />
        <path
          d="M71.1381815,44.9472722 C71.1381815,44.9472722 69.6342725,44.1837957 70.0955317,42.8502617 C70.5564131,41.5129501 71.4589096,41.5280609 71.4589096,41.5280609 C71.4589096,41.5280609 72.1808313,41.3731745 72.694223,41.6682142 C73.2079924,41.9590984 89.7547689,51.5201214 89.7547689,51.5201214 C89.7547689,51.5201214 91.3791871,52.4872168 91.7834028,51.9961136 C92.1838407,51.5087882 92.4180591,50.5571814 92.4025705,49.4805322 C92.3916151,48.4072829 92.3198385,47.882558 92.1721298,47.3079673 C92.0251766,46.7337544 91.6965153,45.257045 90.060764,42.8993721 C88.4250127,40.5424547 87.1028119,40.1533498 87.1028119,40.1533498 C87.1028119,40.1533498 86.5055549,39.6962461 86.434156,39.1141 C86.3623794,38.5553757 86.4681555,38.2493807 86.4681555,38.2493807 C86.4681555,38.2493807 86.6264418,37.5690139 87.1670331,37.2973961 C87.7072465,37.021245 88.1753056,37.0023564 88.1753056,37.0023564 C88.1753056,37.0023564 88.6172985,36.9759124 88.9535152,37.1534651 C89.2901098,37.3347955 90.5930443,37.9887182 91.8551794,39.4276505 C93.1169367,40.8707382 93.8838132,42.0493858 94.299362,42.8691503 C94.7145331,43.6889148 95.2286803,44.7580086 95.4666765,45.6990378 C95.7046726,46.643467 95.7534051,46.605312 95.9237802,47.6974499 C96.0937774,48.7854323 95.9804459,50.4208058 95.9804459,50.4208058 C95.9804459,50.4208058 95.9086693,52.0074468 95.3907443,52.9786977 C94.8697972,53.9491931 94.5033587,54.4062968 94.0458772,54.7991794 C93.5887735,55.1958396 92.5540569,55.5093901 92.5540569,55.5093901 C92.5540569,55.5093901 91.4811854,55.7553194 90.6274215,55.6000553 C89.7774352,55.4493244 89.0936685,55.1584402 89.0936685,55.1584402 C89.0936685,55.1584402 88.4023464,54.8751115 88.0959736,54.7160696 C87.7899785,54.5574055 71.1381815,44.9472722 71.1381815,44.9472722"
          id="Fill-1776"
          fill="#679CC7"
        />
        <path
          d="M80.4955855,80.9035789 C80.4955855,80.9035789 82.0214053,73.7255396 89.2447772,74.0882004 C89.2447772,74.0882004 88.9727816,81.8476303 80.4955855,80.9035789"
          id="Fill-1777"
          fill="#408F51"
        />
        <path
          d="M102.274122,55.0753305 C102.274122,55.0753305 106.406944,60.4245772 113.27861,56.4235975 C113.27861,56.4235975 109.757401,49.8541483 102.274122,55.0753305"
          id="Fill-1778"
          fill="#408F51"
        />
        <path
          d="M102.274122,87.0193243 C102.274122,87.0193243 101.080363,93.1732247 109.013568,95.5573417 C109.013568,95.5573417 111.163089,88.6818974 102.274122,87.0193243"
          id="Fill-1779"
          fill="#408F51"
        />
        <path
          d="M19.1643564,83.6269348 L49.9943016,101.33347 C49.9943016,101.33347 54.4066746,104.831636 55.067775,110.143105 C55.7247199,115.457975 53.9306823,117.108837 53.9306823,117.108837 C53.9306823,117.108837 52.4384843,118.797854 50.4060727,118.90703 C48.683434,119.005251 46.7866424,118.060822 46.7866424,118.060822 C46.7866424,118.060822 45.5819286,117.513053 45.4799303,116.663067 C45.4799303,116.663067 45.2906667,115.80968 45.6348166,115.367688 C45.9785889,114.921539 46.4394703,114.597033 46.7375321,114.524879 C47.0401272,114.453102 47.5010087,114.471991 47.5010087,114.471991 C47.5010087,114.471991 48.0446221,114.687699 48.5852133,114.966872 C49.1292045,115.250201 49.9376359,115.612861 50.5719145,115.239245 C51.2031709,114.869029 51.3051693,114.50599 51.3051693,114.50599 C51.3051693,114.50599 51.8113833,113.935555 51.6750077,112.307737 C51.5393877,110.675764 51.1691715,109.398518 51.1691715,109.398518 C51.1691715,109.398518 50.5719145,107.112999 49.3105349,105.810065 C48.0525553,104.502597 47.4216766,104.11387 47.4216766,104.11387 L42.8653726,101.33347 L16.3272912,86.0488289 C16.3272912,86.0488289 15.7224788,85.6517909 15.5713701,85.1946872 C15.4244169,84.7341836 15.4244169,84.3488565 15.4244169,84.3488565 C15.4244169,84.3488565 15.4433055,83.7289332 15.6850794,83.438049 C15.9306309,83.1475426 16.3877347,82.8751692 16.3877347,82.8751692 C16.3877347,82.8751692 16.7277291,82.6976165 17.1206117,82.6715503 C17.5134942,82.6413286 17.9630425,82.8676138 17.9630425,82.8676138 L19.1643564,83.6269348"
          id="Fill-1780"
          fill="#679CC7"
        />
        <path
          d="M37.898053,109.727179 C37.3313955,108.435578 36.2963012,106.69745 35.8580861,105.975906 C35.7220883,105.757176 35.5672019,105.549024 35.3934269,105.356361 C34.9321677,104.846369 34.418776,104.110092 33.6027892,103.369282 C33.3647931,103.15433 33.0247986,102.863068 32.5979166,102.553295 L6.96988715,87.597315 C6.96988715,87.597315 6.36545249,87.2006547 6.21812154,86.743551 C6.0666351,86.2826696 6.0666351,85.8973425 6.0666351,85.8973425 C6.0666351,85.8973425 6.08590146,85.2819525 6.32767532,84.9906905 C6.5732269,84.6998063 7.03410833,84.4281885 7.03410833,84.4281885 C7.03410833,84.4281885 7.37032511,84.2506358 7.76320763,84.2200363 C8.15986788,84.1935923 8.60903838,84.4164776 8.60903838,84.4164776 L9.80695232,85.1799541 L33.8936734,99.0101746 C34.112781,99.1722387 34.4338869,99.4102348 34.8075031,99.7162299 C35.4236487,100.222822 37.5958357,102.111302 39.5564706,105.171253 C40.3418579,106.395233 41.2564431,108.450311 41.5624381,109.157121 C41.6376147,109.326741 41.6984359,109.497116 41.7475463,109.678446 C42.004431,110.565832 42.7633743,113.433497 42.6466428,115.63175 C42.5068673,118.268974 41.9590984,119.504287 41.9590984,119.504287 C41.9590984,119.504287 41.1427338,121.279436 39.9606863,122.220465 C38.778261,123.160739 37.5085704,123.485623 37.5085704,123.485623 C37.5085704,123.485623 36.4511876,123.776507 34.618995,123.485623 C32.7830247,123.194739 30.8903887,122.106756 30.8903887,122.106756 C30.8903887,122.106756 29.9648482,121.578254 30.1650671,120.433606 C30.3652861,119.28858 30.9995647,119.122738 30.9995647,119.122738 C30.9995647,119.122738 31.4721571,118.563636 32.473252,118.914963 C33.4701914,119.269691 34.6563944,120.033168 35.3178726,119.995013 C35.978973,119.961013 37.0178451,120.252275 38.0336731,119.107627 C39.0540343,117.958823 39.034768,116.069965 39.034768,116.069965 C39.034768,116.069965 39.087656,113.418008 38.6875958,112.088252 C38.3887784,111.091312 38.128116,110.339547 38.0151622,110.025618 C37.9811628,109.919842 37.9433856,109.829555 37.898053,109.727179"
          id="Fill-1781"
          fill="#679CC7"
        />
        <path
          d="M12.4400208,76.8421558 C12.4400208,76.8421558 10.9364896,76.079057 11.397371,74.7455231 C11.8544747,73.4085892 12.7611267,73.4233223 12.7611267,73.4233223 C12.7611267,73.4233223 13.4826706,73.2684359 13.99644,73.5634755 C14.5098317,73.853982 31.0566083,83.4195382 31.0566083,83.4195382 C31.0566083,83.4195382 32.6810264,84.3828559 33.0814644,83.8955305 C33.48568,83.4044273 33.7198985,82.4524427 33.7044098,81.3791934 C33.6934544,80.302922 33.6216778,79.7774416 33.4743469,79.2036064 C33.3270159,78.6290158 32.9983546,77.1519286 31.3626033,74.7950112 C29.726852,72.4373382 28.4046512,72.0486112 28.4046512,72.0486112 C28.4046512,72.0486112 27.807772,71.5915075 27.7359954,71.0097391 C27.6642187,70.4506371 27.7699948,70.1442642 27.7699948,70.1442642 C27.7699948,70.1442642 27.9282811,69.4642753 28.4688724,69.1922797 C29.0087081,68.9165063 29.4775227,68.8976178 29.4775227,68.8976178 C29.4775227,68.8976178 29.9195156,68.8715515 30.2557323,69.0528819 C30.5877936,69.2304346 31.8948836,69.8839796 33.1570187,71.3232896 C34.4149983,72.7663773 35.1856525,73.9450249 35.6012013,74.7644117 C36.0167502,75.5841762 36.5301418,76.6536477 36.768138,77.5939214 C37.0065119,78.5383506 37.0556222,78.5047289 37.2252417,79.5923335 C37.3956167,80.6840936 37.2822852,82.3160672 37.2822852,82.3160672 C37.2822852,82.3160672 37.2105086,83.9027081 36.6888059,84.8735813 C36.1716365,85.8448322 35.805198,86.3015582 35.3480943,86.6948185 C34.8909906,87.0914787 33.8555185,87.4046514 33.8555185,87.4046514 C33.8555185,87.4046514 32.779247,87.6543585 31.9292608,87.4994721 C31.0792746,87.344208 30.3955078,87.0533238 30.3955078,87.0533238 C30.3955078,87.0533238 29.7041857,86.769995 29.3981907,86.6113309 C29.0918178,86.4526669 12.4400208,76.8421558 12.4400208,76.8421558"
          id="Fill-1782"
          fill="#679CC7"
        />
        <path
          d="M21.7970471,112.798462 C21.7970471,112.798462 23.3232446,105.624956 30.5428388,105.983839 C30.5428388,105.983839 30.2742431,113.743269 21.7970471,112.798462"
          id="Fill-1783"
          fill="#408F51"
        />
        <path
          d="M43.5759611,86.970214 C43.5759611,86.970214 47.7084053,92.3194607 54.5804496,88.3192366 C54.5804496,88.3192366 51.0592399,81.7494097 43.5759611,86.970214"
          id="Fill-1784"
          fill="#408F51"
        />
        <path
          d="M43.5759611,118.914963 C43.5759611,118.914963 42.3822026,125.068864 50.3154075,127.452225 C50.3154075,127.452225 52.4649283,120.576781 43.5759611,118.914963"
          id="Fill-1785"
          fill="#408F51"
        />
        <polyline
          id="Fill-1786"
          fill="#73889E"
          points="93.195891 35.7065996 93.0073829 7.25661584 93.9631452 6.70506921 93.9631452 35.2683845 93.195891 35.7065996"
        />
        <path
          d="M64.2074735,52.3138196 L64.2074735,23.7505043 L64.4954735,52.1963326 L64.2074735,52.3138196 M94.0409261,35.2683845 L94.0409261,6.70506921 L94.0409261,35.2683845 M64.1716943,23.7505043 L93.9631452,6.70506921 L93.0073829,7.25661584 L64.1716943,23.7505043"
          id="Fill-1787"
          fill="#C7D6E3"
        />
        <path
          d="M64.375691,52.1963326 L64.1716943,23.7505043 L93.0073829,7.25661584 L93.195891,35.7065996 L89.8035015,37.648346 C89.3996636,37.3876835 89.0936685,37.2290194 88.9535152,37.1534651 C88.700786,37.0178451 88.3793023,37.0023564 88.2436823,37.0023564 C88.1979719,37.0023564 88.1753056,37.0023564 88.1753056,37.0023564 C88.1753056,37.0023564 87.7072465,37.021245 87.1670331,37.2973961 C86.6264418,37.5690139 86.4681555,38.2493807 86.4681555,38.2493807 C86.4681555,38.2493807 86.3623794,38.5553757 86.434156,39.1141 C86.4492669,39.2542533 86.4979994,39.3826957 86.5588207,39.5035826 L77.7148083,44.5657228 C75.0099632,43.0013704 72.8721534,41.7702126 72.694223,41.6682142 C72.4452714,41.5242832 72.1430541,41.4868838 71.9009025,41.4868838 C71.6481732,41.4868838 71.4589096,41.5280609 71.4589096,41.5280609 C71.4177325,41.5280609 70.54508,41.5435496 70.0955317,42.8502617 C69.6342725,44.1837957 71.1381815,44.9472722 71.1381815,44.9472722 C71.1381815,44.9472722 72.3315622,45.6348166 74.0810227,46.643467 L64.375691,52.1963326"
          id="Fill-1788"
          fill="#CCDBE8"
        />
        <path
          d="M74.0810227,46.643467 C72.3315622,45.6348166 71.1381815,44.9472722 71.1381815,44.9472722 C71.1381815,44.9472722 69.6342725,44.1837957 70.0955317,42.8502617 C70.54508,41.5435496 71.4177325,41.5280609 71.4589096,41.5280609 C71.4589096,41.5280609 71.6481732,41.4868838 71.9009025,41.4868838 C72.1430541,41.4868838 72.4452714,41.5242832 72.694223,41.6682142 C72.8721534,41.7702126 75.0099632,43.0013704 77.7148083,44.5657228 L74.0810227,46.643467 M86.5588207,39.5035826 C86.4979994,39.3826957 86.4492669,39.2542533 86.434156,39.1141 C86.3623794,38.5553757 86.4681555,38.2493807 86.4681555,38.2493807 C86.4681555,38.2493807 86.6264418,37.5690139 87.1670331,37.2973961 C87.7072465,37.021245 88.1753056,37.0023564 88.1753056,37.0023564 C88.1753056,37.0023564 88.1979719,37.0023564 88.2436823,37.0023564 C88.3793023,37.0023564 88.700786,37.0178451 88.9535152,37.1534651 C89.0936685,37.2290194 89.3996636,37.3876835 89.8035015,37.648346 L86.5588207,39.5035826"
          id="Fill-1789"
          fill="#679CC7"
        />
      </g>
    </g>
  </svg>
)

export const step21Image2 = (
  <svg
    width="70px"
    height="70px"
    viewBox="0 0 128 128"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    aria-hidden="true"
  >
    <g
      id="3.isolatie/isolatie_10.2"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Group" transform="translate(19.200000, 3.200000)">
        <path
          d="M32.4907806,101.87867 L4.23950469,118.187526 L4.23950469,69.2537053 L32.4907806,52.9448494 L32.4907806,101.87867 M1.97686399,66.638921 L1.97686399,123.421084 L34.7577732,104.493455 L34.7577732,47.7120168 L1.97686399,66.638921"
          id="Fill-1790"
          fill="#F8F7F6"
        />
        <polyline
          id="Fill-1791"
          fill="#B4B5B4"
          points="1.97686399 123.421084 4.72937245e-13 122.264196 4.72937245e-13 65.344222 32.4907806 46.5076203 34.7577732 47.7120168 7.71415776 63.3281906 1.97686399 66.638921 1.97686399 123.421084"
        />
        <polyline
          id="Fill-1792"
          fill="#FFFFFE"
          points="3.89135033 69.3081044 4.23950469 117.52023 31.8963795 101.592531 31.5736114 53.4743342 3.89135033 69.3081044"
        />
        <path
          d="M36.5271427,102.029182 L33.7360316,101.609854 L33.7360316,101.583742 L33.7360316,101.609854 L36.5449205,102.029182 L36.5271427,102.029182 M31.4249205,53.6457816 L31.9760316,53.5541336 L31.4249205,53.6457816"
          id="Fill-1793"
          fill="#CCDBE8"
        />
        <polyline
          id="Fill-1794"
          fill="#526C85"
          points="4.23950469 118.187526 4.23950469 117.52023 31.8963795 101.592531 32.465757 101.88955 4.23950469 118.187526"
        />
        <polyline
          id="Fill-1795"
          fill="#73889E"
          points="32.4693836 101.88955 31.8963795 101.592531 31.8963795 101.574035 31.5736114 53.4743342 31.5373454 53.4928299 32.4907806 52.9448494 32.4907806 101.87867 32.4693836 101.88955"
        />
        <path
          d="M4.23950469,118.187526 L3.89135033,69.3081044 L4.23950469,117.52023 L4.23950469,118.187526 L32.465757,101.88955 L32.4693836,101.88955 L32.4907806,101.87867 L32.4907806,52.9448494 L32.4947699,101.904057 L4.23950469,118.187526 M3.89135033,69.3081044 L32.4907806,52.9448494 L31.5373454,53.4928299 L31.4249205,53.5577461 L3.89135033,69.3081044"
          id="Fill-1796"
          fill="#C7D6E3"
        />
        <polyline
          id="Fill-1797"
          fill="#CCDBE8"
          points="4.23950469 117.52023 4.23950469 117.52023 3.89135033 69.3081044 31.4249205 53.5577461 31.5373454 53.4928299 31.5736114 53.4743342 31.8963795 101.574035 31.8963795 101.592531 4.23950469 117.52023"
        />
        <path
          d="M90.2046194,69.8560849 L61.9573328,86.1682048 L61.9573328,37.2343838 L90.2046194,20.9255278 L90.2046194,69.8560849 M59.6903402,34.6195994 L59.6903402,91.4017627 L92.4716121,72.4741332 L92.4716121,15.6926952 L59.6903402,34.6195994"
          id="Fill-1798"
          fill="#F8F7F6"
        />
        <polyline
          id="Fill-1799"
          fill="#B4B5B4"
          points="59.6903402 91.4017627 57.7174655 90.2448748 57.7174655 33.3249004 90.2046194 14.4882987 92.4716121 15.6926952 59.6903402 34.6195994 59.6903402 91.4017627"
        />
        <polyline
          id="Fill-1800"
          fill="#FFFFFE"
          points="61.6055518 37.2887829 61.9573328 85.5009089 89.6098557 69.5732095 89.2907142 21.4550126 61.6055518 37.2887829"
        />
        <polyline
          id="Fill-1801"
          fill="#CCDBE8"
          points="90.1828598 70.0075461 89.6098557 69.5882181 89.6098557 69.5779781 89.6098557 69.5882181 90.1828598 70.0075461"
        />
        <polyline
          id="Fill-1802"
          fill="#526C85"
          points="61.9573328 86.1682048 61.9573328 85.5009089 89.6098557 69.5732095 90.1828598 69.8702287 61.9573328 86.1682048"
        />
        <polyline
          id="Fill-1803"
          fill="#CCDBE8"
          points="89.197844 21.6220867 89.351956 21.5355587 89.197844 21.6220867"
        />
        <polyline
          id="Fill-1804"
          fill="#73889E"
          points="90.1828598 69.8702287 89.6098557 69.5732095 89.6098557 69.5659563 89.2907142 21.4550126 89.2548108 21.4735083 90.2046194 20.9255278 90.2046194 69.8560849 90.1828598 69.8702287"
        />
        <path
          d="M61.9573328,86.1682048 L61.6055518,37.2887829 L61.9573328,85.5009089 L61.9573328,86.1682048 L90.1828598,69.8702287 L90.2046194,69.8560849 L90.2046194,20.9255278 L90.2046194,69.8847351 L61.9573328,86.1682048 M61.6055518,37.2887829 L90.2046194,20.9255278 L89.2548108,21.4735083 L89.1456499,21.534798 L61.6055518,37.2887829"
          id="Fill-1805"
          fill="#C7D6E3"
        />
        <polyline
          id="Fill-1806"
          fill="#CCDBE8"
          points="61.9573328 85.5009089 61.9573328 85.5009089 61.6055518 37.2887829 89.1456499 21.534798 89.2548108 21.4735083 89.2907142 21.4550126 89.6098557 69.5659563 89.6098557 69.5732095 61.9573328 85.5009089"
        />
        <polyline
          id="Fill-1807"
          fill="#9E9F9E"
          points="32.4947699 44.176074 32.4907806 38.2425808 4.24349396 54.5514367 4.24349396 60.4591811 32.4947699 44.176074"
        />
        <path
          d="M32.4907806,44.1503251 L4.24349396,60.4591811 L4.24349396,54.5514367 L32.4907806,38.2425808 L32.4907806,44.1503251 Z M1.97686399,51.9370151 L1.97686399,65.6923763 L34.7577732,46.7651095 L34.7577732,33.0097482 L1.97686399,51.9370151 L1.97686399,51.9370151 Z"
          id="Fill-1808"
          fill="#F8F7F6"
        />
        <polyline
          id="Fill-1809"
          fill="#B4B5B4"
          points="1.97686399 65.6923763 4.72937245e-13 64.5354884 4.72937245e-13 50.6383267 32.4907806 31.8053517 34.7577732 33.0097482 7.71415776 48.6222954 1.97686399 51.9370151"
        />
        <path
          d="M6.43396516,54.0585807 C7.14115371,54.0585807 7.71053115,55.0011361 7.71053115,56.1656399 C7.71053115,57.3261545 7.14115371,58.2690725 6.43396516,58.2690725 C5.72677661,58.2690725 5.15377255,57.3261545 5.15377255,56.1656399 C5.15377255,55.0011361 5.72677661,54.0585807 6.43396516,54.0585807"
          id="Fill-1810"
          fill="#636463"
        />
        <polygon
          id="Fill-1811"
          fill="#636463"
          points="6.34692657 58.2690725 7.17741979 58.2690725 7.17741979 54.0585807 6.34692657 54.0585807"
        />
        <path
          d="M7.17741979,54.0585807 C7.88098173,54.0585807 8.45398578,55.0011361 8.45398578,56.1656399 C8.45398578,57.3261545 7.88098173,58.2690725 7.17741979,58.2690725 C6.47023124,58.2690725 5.89722718,57.3261545 5.89722718,56.1656399 C5.89722718,55.0011361 6.47023124,54.0585807 7.17741979,54.0585807"
          id="Fill-1812"
          fill="#777776"
        />
        <polyline
          id="Fill-1813"
          fill="#777776"
          points="10.006174 56.7604036 10.0025474 51.6392705 9.14304129 52.1328519 9.14304129 57.2387532 10.006174 56.7604036"
        />
        <polyline
          id="Fill-1814"
          fill="#777776"
          points="11.1920748 56.0459619 11.1920748 50.9284554 10.3325687 51.4220367 10.3325687 56.5243114 11.1920748 56.0459619"
        />
        <polyline
          id="Fill-1815"
          fill="#777776"
          points="12.3525893 55.4004256 12.3489627 50.2832818 11.4930832 50.7765005 11.4930832 55.8787752 12.3525893 55.4004256"
        />
        <polyline
          id="Fill-1816"
          fill="#777776"
          points="13.5638764 54.7182607 13.5638764 49.6014795 12.7043703 50.0943356 12.7043703 55.1969729 13.5638764 54.7182607"
        />
        <polyline
          id="Fill-1817"
          fill="#777776"
          points="14.8005497 54.021952 14.8005497 48.9015442 13.9410436 49.3944002 13.9410436 54.5006642 14.8005497 54.021952"
        />
        <polyline
          id="Fill-1818"
          fill="#777776"
          points="15.9864505 53.3075102 15.9864505 48.1903664 15.1269444 48.6835851 15.1269444 53.7902117 15.9864505 53.3075102"
        />
        <polyline
          id="Fill-1819"
          fill="#777776"
          points="17.146965 52.661974 17.146965 47.5448302 16.2874589 48.0380488 16.2874589 53.1446755 17.146965 52.661974"
        />
        <polyline
          id="Fill-1820"
          fill="#777776"
          points="18.3582521 51.9805343 18.3582521 46.8630279 17.498746 47.3566092 17.498746 52.4625105 18.3582521 51.9805343"
        />
        <polyline
          id="Fill-1821"
          fill="#777776"
          points="19.580419 51.3056226 19.5767924 46.1848522 18.7172863 46.6780709 18.7172863 51.7846975 19.580419 51.3056226"
        />
        <polyline
          id="Fill-1822"
          fill="#777776"
          points="20.7663198 50.5911808 20.7663198 45.474037 19.9068137 45.9672557 19.9068137 51.0738824 20.7663198 50.5911808"
        />
        <polyline
          id="Fill-1823"
          fill="#777776"
          points="21.9268343 49.9456446 21.9232077 44.8285008 21.0669656 45.3217195 21.0669656 50.4283461 21.9268343 49.9456446"
        />
        <polyline
          id="Fill-1824"
          fill="#777776"
          points="23.1381214 49.2678316 23.1381214 44.1470612 22.2786153 44.6402799 22.2786153 49.7461812 23.1381214 49.2678316"
        />
        <polyline
          id="Fill-1825"
          fill="#777776"
          points="24.45458 48.5062439 24.45458 43.3854735 23.5947113 43.8823188 23.5947113 48.9845935 24.45458 48.5062439"
        />
        <polyline
          id="Fill-1826"
          fill="#777776"
          points="25.6437448 47.7914395 25.6437448 42.6742957 24.7846014 43.1675144 24.7846014 48.274141 25.6437448 47.7914395"
        />
        <polyline
          id="Fill-1827"
          fill="#777776"
          points="26.804622 47.146266 26.8009954 42.0287595 25.9451159 42.5223408 25.9451159 47.6286048 26.804622 47.146266"
        />
        <polyline
          id="Fill-1828"
          fill="#777776"
          points="28.0155464 46.4677276 28.0155464 41.3469572 27.156403 41.8405385 27.156403 46.9464399 28.0155464 46.4677276"
        />
        <polyline
          id="Fill-1829"
          fill="#777776"
          points="29.274342 45.7065026 29.274342 40.5893588 28.4148359 41.0825775 28.4148359 46.1848522 29.274342 45.7065026"
        />
        <polyline
          id="Fill-1830"
          fill="#777776"
          points="30.4635067 44.9956874 30.4602428 39.8745544 29.6043633 40.3681357 29.6043633 45.474037 30.4635067 44.9956874"
        />
        <polyline
          id="Fill-1831"
          fill="#777776"
          points="31.6243839 44.3501512 31.6207573 39.2293808 30.7612513 39.7225995 30.7612513 44.8285008 31.6243839 44.3501512"
        />
        <polyline
          id="Fill-1832"
          fill="#9E9F9E"
          points="90.2086087 12.3707224 90.2046194 6.43759176 61.9573328 22.746085 61.9573328 28.6538294 90.2086087 12.3707224"
        />
        <path
          d="M90.2046194,12.3453361 L61.9573328,28.6538294 L61.9573328,22.746085 L90.2046194,6.43759176 L90.2046194,12.3453361 Z M59.6903402,20.1313007 L59.6903402,33.8873873 L92.4716121,14.9597578 L92.4716121,1.2043965 L59.6903402,20.1313007 L59.6903402,20.1313007 Z"
          id="Fill-1833"
          fill="#F8F7F6"
        />
        <polyline
          id="Fill-1834"
          fill="#B4B5B4"
          points="59.6903402 33.8873873 57.7174655 32.7304994 57.7174655 18.8329751 90.2046194 5.09317033e-13 92.4716121 1.2043965 59.6903402 20.1313007"
        />
        <path
          d="M64.1474413,22.2528664 C64.8549926,22.2528664 65.4279966,23.1957844 65.4279966,24.3599256 C65.4279966,25.5208028 64.8549926,26.4633582 64.1474413,26.4633582 C63.4442421,26.4633582 62.871238,25.5208028 62.871238,24.3599256 C62.871238,23.1957844 63.4442421,22.2528664 64.1474413,22.2528664"
          id="Fill-1835"
          fill="#636463"
        />
        <polygon
          id="Fill-1836"
          fill="#636463"
          points="64.064392 26.4633582 64.8912586 26.4633582 64.8912586 22.2528664 64.064392 22.2528664"
        />
        <path
          d="M64.8912586,22.2528664 C65.5948206,22.2528664 66.1678246,23.1957844 66.1678246,24.3599256 C66.1678246,25.5208028 65.5948206,26.4633582 64.8912586,26.4633582 C64.1840701,26.4633582 63.611066,25.5208028 63.611066,24.3599256 C63.611066,23.1957844 64.1840701,22.2528664 64.8912586,22.2528664"
          id="Fill-1837"
          fill="#777776"
        />
        <polyline
          id="Fill-1838"
          fill="#777776"
          points="67.7200128 24.9550519 67.7200128 19.8339189 66.8605067 20.3271375 66.8605067 25.4337642 67.7200128 24.9550519"
        />
        <polyline
          id="Fill-1839"
          fill="#777776"
          points="68.9059136 24.2406102 68.9059136 19.1234664 68.0464075 19.616685 68.0464075 24.7189598 68.9059136 24.2406102"
        />
        <polyline
          id="Fill-1840"
          fill="#777776"
          points="70.0664282 23.595074 70.0664282 18.4739409 69.2069221 18.9711488 69.2069221 24.0737862 70.0664282 23.595074"
        />
        <polyline
          id="Fill-1841"
          fill="#777776"
          points="71.2777152 22.912909 71.2777152 17.7961279 70.4182091 18.2889839 70.4182091 23.3916212 71.2777152 22.912909"
        />
        <polyline
          id="Fill-1842"
          fill="#777776"
          points="72.5143885 22.2169629 72.5143885 17.0958299 71.6548825 17.5894112 71.6548825 22.6953125 72.5143885 22.2169629"
        />
        <polyline
          id="Fill-1843"
          fill="#777776"
          points="73.7039159 21.5025212 73.7002893 16.3850147 72.8444099 16.878596 72.8444099 21.98486 73.7039159 21.5025212"
        />
        <polyline
          id="Fill-1844"
          fill="#777776"
          points="74.8644305 20.856985 74.8608039 15.7398411 74.0012978 16.2330598 74.0012978 21.3389612 74.8644305 20.856985"
        />
        <polyline
          id="Fill-1845"
          fill="#777776"
          points="76.0757175 20.17482 76.0720909 15.0580389 75.2162115 15.5508949 75.2162115 20.6575215 76.0757175 20.17482"
        />
        <polyline
          id="Fill-1846"
          fill="#777776"
          points="77.2942578 19.5006336 77.2906312 14.3798632 76.4347517 14.8730818 76.4347517 19.9789832 77.2942578 19.5006336"
        />
        <polyline
          id="Fill-1847"
          fill="#777776"
          points="78.4801586 18.7858292 78.4801586 13.6686853 77.6206525 14.161904 77.6206525 19.268168 78.4801586 18.7858292"
        />
        <polyline
          id="Fill-1848"
          fill="#777776"
          points="79.6406731 18.1406556 79.6406731 13.0231491 78.7808044 13.5167305 78.7808044 18.6229945 79.6406731 18.1406556"
        />
        <polyline
          id="Fill-1849"
          fill="#777776"
          points="80.8519602 17.4584907 80.8519602 12.3413468 79.9924541 12.8345655 79.9924541 17.9408295 80.8519602 17.4584907"
        />
        <polyline
          id="Fill-1850"
          fill="#777776"
          points="82.1720455 16.7008923 82.1684189 11.5797592 81.3125394 12.0733405 81.3125394 17.1792418 82.1720455 16.7008923"
        />
        <polyline
          id="Fill-1851"
          fill="#777776"
          points="83.3579463 15.9864505 83.3579463 10.868944 82.4980775 11.3625254 82.4980775 16.4684267 83.3579463 15.9864505"
        />
        <polyline
          id="Fill-1852"
          fill="#777776"
          points="84.5184608 15.3409143 84.5184608 10.2237705 83.6589548 10.7169891 83.6589548 15.8228905 84.5184608 15.3409143"
        />
        <polyline
          id="Fill-1853"
          fill="#777776"
          points="85.7297479 14.6623759 85.7297479 9.54160551 84.8698791 10.0348242 84.8698791 15.1414508 85.7297479 14.6623759"
        />
        <polyline
          id="Fill-1854"
          fill="#777776"
          points="86.9918075 13.9011509 86.9878182 8.78001784 86.1323014 9.27722579 86.1323014 14.3798632 86.9918075 13.9011509"
        />
        <polyline
          id="Fill-1855"
          fill="#777776"
          points="88.1777083 13.1867092 88.1777083 8.06956534 87.3178395 8.56278402 87.3178395 13.6686853 88.1777083 13.1867092"
        />
        <polyline
          id="Fill-1856"
          fill="#777776"
          points="89.3378601 12.5411729 89.3345962 7.42366646 88.4787167 7.91724781 88.4787167 13.0231491 89.3378601 12.5411729"
        />
      </g>
    </g>
  </svg>
)

export const step21Image3 = (
  <svg
    width="70px"
    height="70px"
    viewBox="0 0 128 128"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    aria-hidden="true"
  >
    <g
      id="3.isolatie/isolatie_10.3"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Group" transform="translate(16.000000, 1.600000)">
        <path
          d="M18.6451231,27.0875614 C28.9809558,21.1249913 37.386153,25.9089138 37.4182442,37.7807216 C37.450152,49.6573293 29.1036205,64.1157619 18.7677878,70.0836652 C8.43728843,76.0462353 0.0320911863,71.2628461 8.02495325e-13,59.3857051 C-0.0319077774,47.513364 8.31462374,33.0554648 18.6451231,27.0875614"
          id="Fill-2637"
          fill="#8A8B8A"
        />
        <polyline
          id="Fill-2638"
          fill="#8A8B8A"
          points="6.55411892 72.0996326 6.55411892 40.8953378 33.3008858 26.7137008 57.6738245 40.7401403 32.1163717 55.4759018 33.3008858 87.2193878 6.55411892 72.0996326"
        />
        <polyline
          id="Fill-2639"
          fill="#C7C5BD"
          points="96.6705264 91.0065264 96.6705264 10.1118363 36.1963056 45.4333977 36.1963056 126.323288 96.6705264 91.0065264"
        />
        <polyline
          id="Fill-2640"
          fill="#9E9F9E"
          points="93.7052411 88.7185635 93.7052411 17.5303828 39.4447864 47.9085576 39.4447864 119.101538 93.7052411 88.7185635"
        />
        <polyline
          id="Fill-2641"
          fill="#F8F7F6"
          points="18.6824559 35.3215614 36.1963056 45.4333977 36.1963056 126.323288 18.6824559 116.211452 18.6824559 35.3215614"
        />
        <polyline
          id="Fill-2642"
          fill="#C7C5BD"
          points="96.6705264 10.1118363 79.1561434 0 18.6824559 35.3215614 36.1963056 45.4333977 96.6705264 10.1118363"
        />
        <path
          d="M40.1007757,82.8994577 C40.1007757,103.704454 50.8840678,110.440878 65.5136976,102.142346 C82.4627565,92.5313018 93.0492517,77.9507378 93.0492517,57.1398748 C93.0492517,36.3354117 81.134778,31.8282846 66.1216877,39.4126952 C50.7720696,47.1720362 40.1007757,62.0949946 40.1007757,82.8994577"
          id="Fill-2643"
          fill="#8A8B8A"
        />
        <path
          d="M67.5669977,71.02285 C67.5669977,71.02285 63.4177315,40.1374834 67.1136717,39.6574912 L67.5669977,71.02285"
          id="Fill-2644"
          fill="#636463"
        />
        <path
          d="M66.8683423,70.5535243 C66.8683423,70.5535243 57.1138336,44.1480852 60.6497763,42.9641043 L66.8683423,70.5535243"
          id="Fill-2645"
          fill="#636463"
        />
        <path
          d="M66.8683423,70.7823206 C66.8683423,70.7823206 51.0712648,50.6919792 54.121882,48.5640137 L66.8683423,70.7823206"
          id="Fill-2646"
          fill="#636463"
        />
        <path
          d="M66.6656789,70.6596559 C66.6656789,70.6596559 46.5006721,57.3430715 48.772102,54.3932526 L66.6656789,70.6596559"
          id="Fill-2647"
          fill="#636463"
        />
        <path
          d="M65.5824965,69.5770068 C65.5824965,69.5770068 69.732296,100.462373 66.0363558,100.947165 L65.5824965,69.5770068"
          id="Fill-2648"
          fill="#636463"
        />
        <path
          d="M66.2816852,70.0463325 C66.2816852,70.0463325 76.0361939,96.4565715 72.5002511,97.6357524 L66.2816852,70.0463325"
          id="Fill-2649"
          fill="#636463"
        />
        <path
          d="M66.2816852,69.8228694 C66.2816852,69.8228694 82.0787627,89.9078776 79.0276121,92.0358431 L66.2816852,69.8228694"
          id="Fill-2650"
          fill="#636463"
        />
        <path
          d="M66.4838152,69.9450008 C66.4838152,69.9450008 86.6493554,83.2626518 84.3773922,86.2066042 L66.4838152,69.9450008"
          id="Fill-2651"
          fill="#636463"
        />
        <path
          d="M58.4951446,73.8809371 C58.4951446,80.4568306 61.9078893,82.5853295 66.5323478,79.961372 C71.892261,76.9262211 75.2362068,72.3129625 75.2362068,65.7317357 C75.2362068,59.1563755 71.4709345,57.726532 66.7243447,60.1264931 C61.8710899,62.5803201 58.4951446,67.2997103 58.4951446,73.8809371"
          id="Fill-2652"
          fill="#F2F1F0"
        />
        <polyline
          id="Fill-2653"
          fill="#C7C5BD"
          points="96.6225272 10.1118363 79.1076108 0 18.6344566 35.3215614 36.1488397 45.4333977 96.6225272 10.1118363"
        />
        <path
          d="M36.2608379,53.3159367 C44.9806967,47.9618901 54.7885379,42.4419795 65.695028,37.0335337 C76.5908516,31.6314878 87.0066829,20.3570037 96.6865262,16.591198 C96.6918594,17.1138562 96.7025259,17.6370478 96.7131924,18.1543727 C86.6968213,22.975628 76.4628536,34.8634355 66.041689,40.2921476 C55.7266561,45.6739271 45.8020168,51.0599733 36.2608379,56.4252197 C36.2608379,55.3905698 36.2608379,54.35112 36.2608379,53.3159367"
          id="Fill-2654"
          fill="#636463"
        />
        <path
          d="M36.2608379,58.2977227 C44.9806967,52.9431428 54.7885379,47.4232321 65.695028,42.0147864 C76.5908516,36.6127405 87.0066829,25.3377231 96.6865262,21.5724507 C96.6918594,22.0956422 96.7025259,22.6183004 96.7131924,23.1356254 C86.6968213,27.9568807 76.4628536,39.8441549 66.041689,45.2739336 C55.7266561,50.6551798 45.8020168,56.0417593 36.2608379,61.4070057 C36.2608379,60.3718225 36.2608379,59.3318393 36.2608379,58.2977227"
          id="Fill-2655"
          fill="#636463"
        />
        <path
          d="M36.2608379,64.4250902 C44.9806967,59.0705102 54.7885379,53.5511329 65.695028,48.1432205 C76.5908516,42.740108 87.0066829,31.4656239 96.6865262,27.7003515 C96.6918594,28.223543 96.7025259,28.7456679 96.7131924,29.2635262 C86.6968213,34.0842481 76.4628536,45.9720556 66.041689,51.4013011 C55.7266561,56.7825473 45.8020168,62.1691267 36.2608379,67.5349065 C36.2608379,66.4997233 36.2608379,65.4597401 36.2608379,64.4250902"
          id="Fill-2656"
          fill="#636463"
        />
        <path
          d="M36.2608379,69.8436691 C44.9806967,64.4890891 54.7885379,58.9691785 65.695028,53.5671327 C76.5908516,48.1640201 87.0066829,36.889536 96.6865262,33.124797 C96.6918594,33.6469219 96.7025259,34.1642468 96.7131924,34.6874384 C86.6968213,39.5086936 76.4628536,51.3965011 66.041689,56.8252132 C55.7266561,62.2011262 45.8020168,67.5930389 36.2608379,72.9582853 C36.2608379,71.9188355 36.2608379,70.8836523 36.2608379,69.8436691"
          id="Fill-2657"
          fill="#636463"
        />
        <path
          d="M36.2608379,75.3315803 C44.9806967,69.9770003 54.7885379,64.4570897 65.695028,59.0550438 C76.5908516,53.6524646 87.0066829,42.3774472 96.6865262,38.6127081 C96.6918594,39.1353663 96.7025259,39.6526913 96.7131924,40.1753495 C86.6968213,44.9966048 76.4628536,56.883879 66.041689,62.3131244 C55.7266561,67.6890373 45.8020168,73.08095 36.2608379,78.4461965 C36.2608379,77.4067467 36.2608379,76.3715634 36.2608379,75.3315803"
          id="Fill-2658"
          fill="#636463"
        />
        <path
          d="M36.2608379,80.3128329 C44.9806967,74.958253 54.7885379,69.4383423 65.695028,64.0362965 C76.5908516,58.633184 87.0066829,47.3586998 96.6865262,43.5934275 C96.6918594,44.1160857 96.7025259,44.6334106 96.7131924,45.1566022 C86.6968213,49.9773241 76.4628536,61.8651316 66.041689,67.2949104 C55.7266561,72.67029 45.8020168,78.062736 36.2608379,83.4274492 C36.2608379,82.387466 36.2608379,81.3533494 36.2608379,80.3128329"
          id="Fill-2659"
          fill="#636463"
        />
        <path
          d="M36.2608379,86.441267 C44.9806967,81.0866871 54.7885379,75.5667764 65.695028,70.1636639 C76.5908516,64.7616181 87.0066829,53.487134 96.6865262,49.7213283 C96.6918594,50.2386532 96.7025259,50.7618447 96.7131924,51.2839696 C86.6968213,56.0998916 76.4628536,67.9876992 66.041689,73.4228112 C55.7266561,78.7987241 45.8020168,84.1901035 36.2608379,89.5558833 C36.2608379,88.5153668 36.2608379,87.4807169 36.2608379,86.441267"
          id="Fill-2660"
          fill="#636463"
        />
        <path
          d="M36.2608379,91.8646459 C44.9806967,86.5105992 54.7885379,80.9901553 65.695028,75.5822429 C76.5908516,70.1855302 87.0066829,58.9051796 96.6865262,55.1399072 C96.6918594,55.6630987 96.7025259,56.1857569 96.7131924,56.7084151 C86.6968213,61.5243371 76.4628536,73.4121447 66.041689,78.84619 C55.7266561,84.2226363 45.8020168,89.6086824 36.2608379,94.9797954 C36.2608379,93.939279 36.2608379,92.904629 36.2608379,91.8646459"
          id="Fill-2661"
          fill="#636463"
        />
        <path
          d="M36.2608379,98.1045449 C44.9806967,92.7504982 54.7885379,87.2305876 65.695028,81.8226752 C76.5908516,76.4248959 87.0066829,65.1450785 96.6865262,61.3803395 C96.6918594,61.9024644 96.7025259,62.4251226 96.7131924,62.9477808 C86.6968213,67.7637028 76.4628536,79.6520436 66.041689,85.0866223 C55.7266561,90.4625353 45.8020168,95.8485814 36.2608379,101.219161 C36.2608379,100.179711 36.2608379,99.1391948 36.2608379,98.1045449"
          id="Fill-2662"
          fill="#636463"
        />
        <path
          d="M36.2608379,103.086331 C44.9806967,97.7312176 54.7885379,92.2118403 65.695028,86.8033945 C76.5908516,81.4066819 87.0066829,70.1263312 96.6865262,66.3615922 C96.6918594,66.883717 96.7025259,67.4069086 96.7131924,67.9295668 C86.6968213,72.7449555 76.4628536,84.632763 66.041689,90.067875 C55.7266561,95.4432546 45.8020168,100.830367 36.2608379,106.200414 C36.2608379,105.160964 36.2608379,104.125781 36.2608379,103.086331"
          id="Fill-2663"
          fill="#636463"
        />
        <path
          d="M36.2608379,109.213698 C44.9806967,103.859118 54.7885379,98.3392077 65.695028,92.9312953 C76.5908516,87.5345827 87.0066829,76.2547653 96.6865262,72.4889596 C96.6918594,73.0121511 96.7025259,73.5348093 96.7131924,74.0521343 C86.6968213,78.8733896 76.4628536,90.7611971 66.041689,96.1957758 C55.7266561,101.571155 45.8020168,106.957735 36.2608379,112.323515 C36.2608379,111.288331 36.2608379,110.248348 36.2608379,109.213698"
          id="Fill-2664"
          fill="#636463"
        />
        <path
          d="M36.2608379,114.63761 C44.9806967,109.283031 54.7885379,103.757787 65.695028,98.3557408 C76.5908516,92.9531616 87.0066829,81.6786775 96.6865262,77.9128718 C96.6918594,78.4360633 96.7025259,78.9533883 96.7131924,79.4755132 C86.6968213,84.2973017 76.4628536,96.1851093 66.041689,101.613821 C55.7266561,106.995068 45.8020168,112.381647 36.2608379,117.746893 C36.2608379,116.712244 36.2608379,115.672794 36.2608379,114.63761"
          id="Fill-2665"
          fill="#636463"
        />
      </g>
    </g>
  </svg>
)

export const step21Image4 = (
  <svg
    width="70px"
    height="70px"
    viewBox="0 0 128 128"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    aria-hidden="true"
  >
    <g
      id="3.isolatie/isolatie_10.4"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Group" transform="translate(17.600000, 1.600000)">
        <polyline
          id="Fill-196"
          fill="#9E9F9E"
          points="49.8302408 10.3682131 2.37996146 33.3683549 47.4952881 60.9432037 92.5497396 35.1007078 49.8302408 10.3682131"
        />
        <polyline
          id="Fill-197"
          fill="#777776"
          points="31.1596859 20.3838033 33.1187018 23.8258428 35.8354198 22.2845344 33.8760801 18.8392569 31.1596859 20.3838033"
        />
        <path
          d="M33.7465583,18.913408 C33.0733692,19.2958209 32.9665138,20.3773272 33.507267,21.3293118 C34.0480201,22.2780583 35.0288233,22.7407746 35.7055742,22.3554476 C36.379411,21.9736823 36.4859426,20.8918522 35.9455132,19.9434295 C35.4047601,18.9914449 34.4203951,18.531319 33.7465583,18.913408"
          id="Fill-198"
          fill="#777776"
        />
        <polyline
          id="Fill-199"
          fill="#777776"
          points="31.4219674 25.3117806 33.3809833 28.7570582 36.0977012 27.2125118 34.1419234 23.7672342 31.4219674 25.3117806"
        />
        <path
          d="M34.0091636,23.842033 C33.3356507,24.2273601 33.2287953,25.3088664 33.7692246,26.2576129 C34.3103016,27.2095975 35.2914286,27.6693996 35.9681795,27.2869867 C36.6416924,26.9052215 36.7485478,25.8233914 36.2077947,24.8714068 C35.6670415,23.919746 34.6826765,23.4596201 34.0091636,23.842033"
          id="Fill-200"
          fill="#777776"
        />
        <path
          d="M22.2612205,36.6708348 C22.2612205,37.4450508 23.148768,38.0729073 24.2432265,38.0729073 C25.3344469,38.0729073 26.2216707,37.4450508 26.2216707,36.6708348 C26.2216707,35.8972664 25.3344469,35.2687623 24.2432265,35.2687623 C23.148768,35.2687623 22.2612205,35.8972664 22.2612205,36.6708348"
          id="Fill-201"
          fill="#777776"
        />
        <polygon
          id="Fill-202"
          fill="#777776"
          points="22.2612205 36.6708348 26.2216707 36.6708348 26.2216707 33.5461235 22.2612205 33.5461235"
        />
        <path
          d="M26.6779109,34.1257332 C26.6779109,34.8996254 27.5654584,35.5281295 28.6566789,35.5281295 C29.7511373,35.5281295 30.6383611,34.8996254 30.6383611,34.1257332 C30.6383611,33.3518409 29.7511373,32.7239844 28.6566789,32.7239844 C27.5654584,32.7239844 26.6779109,33.3518409 26.6779109,34.1257332"
          id="Fill-203"
          fill="#777776"
        />
        <polygon
          id="Fill-204"
          fill="#777776"
          points="26.6779109 34.126057 30.6380373 34.126057 30.6380373 31.0013457 26.6779109 31.0013457"
        />
        <polyline
          id="Fill-205"
          fill="#F8F7F6"
          points="24.0683722 23.7481298 24.0683722 36.473638 33.4943148 31.0301642 33.4943148 18.3049798 24.0683722 23.7481298"
        />
        <path
          d="M24.0683722,23.6830451 L24.0683722,36.4085533 C25.6712034,35.9584654 27.8018356,35.1687067 30.0389993,33.7274539 C31.4669762,32.8081735 32.6103291,31.8331989 33.4943148,30.9654034 L33.4943148,18.2402189 C32.6168052,19.1044526 31.4896425,20.0661513 30.0814177,20.9792794 C27.8277399,22.4399605 25.6809175,23.2329572 24.0683722,23.6830451"
          id="Fill-206"
          fill="#E4E4E3"
        />
        <polyline
          id="Fill-207"
          fill="#C7C5BD"
          points="24.0683722 23.7481298 24.0683722 36.473638 18.6248984 33.2870801 18.6248984 20.5648099 24.0683722 23.7481298"
        />
        <path
          d="M27.8406921,15.0410327 L33.4943148,18.3049798 C32.4448651,19.2990589 30.9945458,20.4838588 29.1100048,21.572165 C27.2157498,22.6662997 25.4574926,23.3333365 24.0683722,23.7481298 L18.6248984,20.5648099 L27.8406921,15.0410327"
          id="Fill-208"
          fill="#C7C5BD"
        />
        <path
          d="M21.7920281,20.8821381 C21.7920281,21.6563541 22.6792518,22.2845344 23.7737103,22.2845344 C24.8681688,22.2845344 25.7550687,21.6563541 25.7550687,20.8821381 C25.7550687,20.1082458 24.8681688,19.4803893 23.7737103,19.4803893 C22.6792518,19.4803893 21.7920281,20.1082458 21.7920281,20.8821381"
          id="Fill-209"
          fill="#777776"
        />
        <polygon
          id="Fill-210"
          fill="#777776"
          points="21.7920281 20.8824619 25.7550687 20.8824619 25.7550687 17.7577506 21.7920281 17.7577506"
        />
        <path
          d="M21.7920281,17.9099386 C21.7920281,18.6838308 22.6792518,19.3116873 23.7737103,19.3116873 C24.8681688,19.3116873 25.7550687,18.6838308 25.7550687,17.9099386 C25.7550687,17.1328083 24.8681688,16.5043042 23.7737103,16.5043042 C22.6792518,16.5043042 21.7920281,17.1328083 21.7920281,17.9099386"
          id="Fill-211"
          fill="#636463"
        />
        <path
          d="M26.4483337,18.4830722 C26.4483337,19.2569644 27.3355574,19.8848209 28.4300159,19.8848209 C29.5241505,19.8848209 30.4081362,19.2569644 30.4081362,18.4830722 C30.4081362,17.7059419 29.5241505,17.0774378 28.4300159,17.0774378 C27.3355574,17.0774378 26.4483337,17.7059419 26.4483337,18.4830722"
          id="Fill-212"
          fill="#2A90C3"
        />
        <polygon
          id="Fill-213"
          fill="#2A90C3"
          points="26.4483337 18.4827484 30.4081362 18.4827484 30.4081362 15.354799 26.4483337 15.354799"
        />
        <path
          d="M26.4483337,15.5073108 C26.4483337,16.281203 27.3355574,16.9090595 28.4300159,16.9090595 C29.5241505,16.9090595 30.4081362,16.281203 30.4081362,15.5073108 C30.4081362,14.7330948 29.5241505,14.1049145 28.4300159,14.1049145 C27.3355574,14.1049145 26.4483337,14.7330948 26.4483337,15.5073108"
          id="Fill-214"
          fill="#1A6C95"
        />
        <polyline
          id="Fill-215"
          fill="#777776"
          points="20.0046285 24.7292567 21.9604063 28.1745343 19.2469265 29.7190807 17.2879106 26.2738032 20.0046285 24.7292567"
        />
        <path
          d="M17.4206703,26.1990044 C18.0906214,25.8169153 19.0753102,26.2770412 19.6157395,27.2290258 C20.1568165,28.1774485 20.0499611,29.2592786 19.3764482,29.6442819 C18.7029353,30.026371 17.7182464,29.5668927 17.1778171,28.6149081 C16.637064,27.6629235 16.7468336,26.5814172 17.4206703,26.1990044"
          id="Fill-216"
          fill="#636463"
        />
        <path
          d="M19.9074872,24.7839797 C20.5810001,24.4022144 21.5621271,24.8649307 22.1028802,25.8140011 C22.6433096,26.7659857 22.5367779,27.8471682 21.8629412,28.2292572 C21.1897521,28.6116701 20.2053871,28.1515442 19.664634,27.1995596 C19.1238808,26.2511369 19.2339743,25.1693068 19.9074872,24.7839797"
          id="Fill-217"
          fill="#777776"
        />
        <path
          d="M20.043485,29.9583721 C20.7169979,29.5766068 21.7013629,30.0360851 22.2421161,30.9848316 C22.7828692,31.9368162 22.6760138,33.0183225 22.0021771,33.4007354 C21.328988,33.7828244 20.3442992,33.3230223 19.8038698,32.3710378 C19.2631167,31.4219674 19.3699721,30.3407849 20.043485,29.9583721"
          id="Fill-218"
          fill="#777776"
        />
        <polyline
          id="Fill-219"
          fill="#777776"
          points="20.0208187 29.9713242 21.9762727 33.4133637 19.2598786 34.9579102 17.3041008 31.5158707 20.0208187 29.9713242"
        />
        <path
          d="M17.4336225,31.4417195 C18.1071354,31.0596304 19.0915004,31.5194325 19.6322535,32.4678552 C20.1730067,33.4198398 20.0661513,34.5013461 19.3923146,34.8834352 C18.7191255,35.265848 17.7344367,34.8057222 17.1940073,33.8569756 C16.6529304,32.9053148 16.7601096,31.8238085 17.4336225,31.4417195"
          id="Fill-220"
          fill="#636463"
        />
        <polyline
          id="Fill-2666"
          fill="#F8F7F6"
          points="47.6963706 125.762668 92.5562156 100.437936 93.0160177 34.8154363 70.1262931 26.0892347 48.1561727 60.6388277 47.6963706 125.762668"
        />
        <polyline
          id="Fill-2667"
          fill="#E4E4E3"
          points="47.7028467 125.762668 2.84623963 100.693741 2.84623963 33.0863214 48.1561727 60.6388277 47.7028467 125.762668"
        />
        <path
          d="M48.2209752,60.7294312 L48.1290895,60.6796027 L48.3256609,60.565317 L48.2209752,60.7294312 M2.93042874,33.1025116 L25.625547,0 L46.2615938,12.0976517 L33.4943148,18.2855515 L33.4943148,18.2402189 C33.4813626,18.2564092 33.4684105,18.2690375 33.4554583,18.2819897 L30.4081362,16.5240563 L30.4081362,15.354799 L30.3987459,15.354799 C30.2918905,14.6521437 29.4532374,14.1049145 28.4300159,14.1049145 C27.4064705,14.1049145 26.5681412,14.6521437 26.460962,15.354799 L26.4483337,15.354799 L26.4483337,15.8728858 L24.9426438,16.7762998 C24.6156014,16.6050073 24.2105223,16.5043042 23.7737103,16.5043042 C22.7504888,16.5043042 21.9118357,17.0518572 21.8049803,17.7577506 L21.7920281,17.7577506 L21.7920281,18.6644026 L18.6248984,20.5648099 L18.6248984,25.493111 L2.93042874,33.1025116"
          id="Fill-2668"
          fill="#97BDDB"
        />
        <path
          d="M48.091088,60.603533 L2.91423853,33.1255017 L2.93042874,33.1025116 L18.6248984,25.493111 L18.6248984,25.5125393 L17.2879106,26.2738032 L17.2940628,26.2831935 C16.7342052,26.7238911 16.6726824,27.7241225 17.1778171,28.6149081 C17.536916,29.2492407 18.0941832,29.6637102 18.6248984,29.7579372 L18.6248984,30.7646447 L17.4562888,31.4284435 C17.4494889,31.4320053 17.4400986,31.4384814 17.4336225,31.4417195 C17.4271464,31.4449575 17.4206703,31.4481956 17.4141942,31.4543478 L17.3041008,31.5158707 L17.3105769,31.5259086 C16.7503954,31.9659586 16.6888726,32.9668376 17.1940073,33.8569756 C17.6049149,34.5790592 18.2719518,35.0197568 18.8648374,35.0197568 C19.0005114,35.0197568 19.1300331,34.9970905 19.2566406,34.9485198 L19.2598786,34.9579102 L20.3867175,34.3200157 L22.2612205,35.414798 L22.2612205,36.6708348 C22.2612205,37.4450508 23.148768,38.0729073 24.2432265,38.0729073 C25.3344469,38.0729073 26.2216707,37.4450508 26.2216707,36.6708348 L26.2216707,35.6835556 C26.5940456,35.5375198 26.9761346,35.3756177 27.3711759,35.191373 C27.7173226,35.401522 28.1677344,35.5281295 28.6566789,35.5281295 C29.7511373,35.5281295 30.6383611,34.8996254 30.6383611,34.1257332 L30.6383611,33.3259366 C31.7069152,32.5847486 32.6002912,31.8267228 33.3288508,31.1240675 L33.4943148,31.0301642 L33.4943148,28.6890593 L35.9455132,27.2999389 C35.9519893,27.2934628 35.9584654,27.2905486 35.9681795,27.2869867 C35.9743318,27.2837487 35.9811317,27.2772726 35.9876078,27.2740346 L36.0977012,27.2125118 L36.0912251,27.2031214 C36.6514066,26.7627476 36.7129294,25.7618686 36.2077947,24.8714068 C35.7965632,24.1493233 35.1262884,23.7089494 34.5337266,23.7089494 C34.4009668,23.7089494 34.268207,23.7316157 34.1448376,23.7772721 L34.1419234,23.7672342 L34.0447821,23.8226047 C34.0315061,23.8290808 34.0221158,23.8352331 34.0091636,23.842033 C33.9994495,23.8485091 33.9864973,23.8546614 33.9767832,23.8646993 L33.4943148,24.1363711 L33.4943148,23.6118082 L35.8354198,22.2845344 L35.8289437,22.2712584 C36.3891251,21.8344465 36.4506479,20.8303294 35.9455132,19.9434295 C35.5342818,19.2177841 34.8669212,18.7774102 34.2714451,18.7774102 C34.1383615,18.7774102 34.0056018,18.8000765 33.8825561,18.8486472 L33.8760801,18.8392569 L33.7727865,18.9007797 C33.7627486,18.9040177 33.7565963,18.91017 33.7465583,18.913408 C33.7404061,18.9169699 33.7306919,18.9231222 33.7242159,18.926684 L33.4943148,19.0562057 L33.4943148,18.2855515 L46.2615938,12.0976517 L70.1262931,26.0892347 L48.2303238,60.5225819 L48.091088,60.603533"
          id="Fill-2669"
          fill="#809EB4"
        />
        <path
          d="M33.4943148,23.6118082 L33.4943148,21.3098835 C33.5069605,21.3160358 33.5126511,21.3225119 33.5196063,21.3293118 C34.3219773,22.0510715 35.6244867,22.4914453 36.7815703,22.4914453 C37.1489285,22.4914453 37.4966859,22.4493508 37.8121967,22.3554476 C37.8950261,22.3327813 37.9772233,22.3039627 38.0530977,22.2712584 L38.0657434,22.2845344 L33.4943148,23.6118082 M33.4943148,19.2194375 L33.4943148,19.1376089 L33.943238,18.9547518 C33.7782113,19.0274375 33.6270949,19.1188661 33.4943148,19.2194375 M34.0380809,18.9801161 L34.2397801,18.893259 L34.2524259,18.9065161 C34.1771838,18.9293733 34.1070001,18.9526876 34.0380809,18.9801161"
          id="Fill-2670"
          fill="#728DA1"
        />
        <path
          d="M35.1777733,22.4914453 C34.5852114,22.4914453 33.9181746,22.0510715 33.507267,21.3293118 C33.5037051,21.3225119 33.5007909,21.3160358 33.4943148,21.3098835 L33.4943148,19.1141667 C33.5623137,19.0429298 33.6397029,18.9781689 33.7242159,18.926684 C33.7306919,18.9231222 33.7404061,18.9169699 33.7465583,18.913408 C33.7565963,18.91017 33.7627486,18.9040177 33.7727865,18.9007797 C33.8080812,18.8813514 33.8440234,18.8648374 33.8825561,18.8486472 C34.0056018,18.8000765 34.1383615,18.7774102 34.2714451,18.7774102 C34.8669212,18.7774102 35.5342818,19.2177841 35.9455132,19.9434295 C36.4506479,20.8303294 36.3891251,21.8344465 35.8289437,22.2712584 C35.7900872,22.3039627 35.7479926,22.3327813 35.7055742,22.3554476 C35.5439959,22.4493508 35.3659036,22.4914453 35.1777733,22.4914453"
          id="Fill-2671"
          fill="#728DA1"
        />
        <path
          d="M33.4943148,28.6890593 L33.4943148,25.5837762 C33.5966602,25.807525 33.7558642,26.037426 33.977044,26.2576129 C34.6997164,26.9829345 35.8704342,27.4200703 36.9115145,27.4200703 C37.223668,27.4200703 37.525587,27.3812138 37.7985081,27.2999389 L33.4943148,28.6890593 M37.8724243,27.3553044 C37.9349687,27.3237616 37.9975131,27.2917616 38.0543717,27.2551902 L38.0657434,27.2684473 L37.8724243,27.3553044 M33.4943148,24.5216982 L33.4943148,24.1363711 L34.3415074,23.8646993 C33.9321258,24.0071732 33.6478329,24.2403123 33.4943148,24.5216982 M34.4609104,23.9006745 L34.6314861,23.8225031 L34.6366034,23.8366745 C34.5803134,23.8545031 34.517769,23.8773602 34.4609104,23.9006745"
          id="Fill-2672"
          fill="#728DA1"
        />
        <path
          d="M35.4403785,27.4200703 C34.8474929,27.4200703 34.1807799,26.9829345 33.7692246,26.2576129 C33.6432648,26.037426 33.5525996,25.807525 33.4943148,25.5837762 L33.4943148,24.5216982 C33.581742,24.2403123 33.7436441,24.0071732 33.9767832,23.8646993 C33.9864973,23.8546614 33.9994495,23.8485091 34.0091636,23.842033 C34.0221158,23.8352331 34.0315061,23.8290808 34.0447821,23.8226047 C34.0771625,23.8060907 34.112781,23.7899005 34.1448376,23.7772721 C34.268207,23.7316157 34.4009668,23.7089494 34.5337266,23.7089494 C35.1262884,23.7089494 35.7965632,24.1493233 36.2077947,24.8714068 C36.7129294,25.7618686 36.6514066,26.7627476 36.0912251,27.2031214 C36.0588447,27.2290258 36.0232262,27.2516921 35.9876078,27.2740346 C35.9811317,27.2772726 35.9743318,27.2837487 35.9681795,27.2869867 C35.9584654,27.2905486 35.9519893,27.2934628 35.9455132,27.2999389 C35.7900872,27.3812138 35.6181471,27.4200703 35.4403785,27.4200703"
          id="Fill-2673"
          fill="#728DA1"
        />
        <path
          d="M24.2432265,38.0729073 C23.148768,38.0729073 22.2612205,37.4450508 22.2612205,36.6708348 L26.2216707,36.6708348 C26.2216707,37.4450508 25.3344469,38.0729073 24.2432265,38.0729073"
          id="Fill-2674"
          fill="#728DA1"
        />
        <path
          d="M26.2216707,36.6708348 L22.2612205,36.6708348 L22.2612205,35.414798 L24.0683722,36.473638 L24.2950352,36.3441163 C24.8778829,36.1721762 25.5287295,35.9584654 26.2216707,35.6835556 L26.2216707,36.6708348"
          id="Fill-2675"
          fill="#728DA1"
        />
        <path
          d="M28.6566789,35.5281295 C28.1677344,35.5281295 27.7173226,35.401522 27.3711759,35.191373 C28.0220225,34.8931493 28.7020115,34.5402026 29.3949526,34.1257332 L30.6383611,34.1257332 C30.6383611,34.8996254 29.7511373,35.5281295 28.6566789,35.5281295"
          id="Fill-2676"
          fill="#728DA1"
        />
        <path
          d="M30.6383611,34.1257332 L29.3949526,34.1257332 C29.6086634,33.9994495 29.8223743,33.8670135 30.0389993,33.7274539 C30.2465579,33.5946941 30.4440785,33.4622582 30.6383611,33.3259366 L30.6383611,34.1257332"
          id="Fill-2677"
          fill="#728DA1"
        />
        <path
          d="M24.088373,36.566975 L24.088373,36.4750893 C24.1930587,36.4435464 24.2986587,36.4161179 24.408373,36.3841179 L24.088373,36.566975 M33.3614521,31.2234047 C33.444195,31.1502619 33.5219092,31.0725476 33.5950521,30.9994047 L33.5950521,31.0908333 L33.3614521,31.2234047 M29.1164809,21.568927 C29.4014287,21.403463 29.6795766,21.2350847 29.9454199,21.0670303 C29.6669482,21.2451227 29.3913908,21.4099391 29.1164809,21.568927"
          id="Fill-2678"
          fill="#95BBD7"
        />
        <path
          d="M24.0683722,36.4085533 L24.0683722,23.7481298 C25.4574926,23.3333365 27.2157498,22.6662997 29.1100048,21.572165 C29.1132429,21.572165 29.1132429,21.572165 29.1164809,21.568927 C29.3913908,21.4099391 29.6669482,21.2451227 29.9454199,21.0670303 C31.4281197,20.1244361 32.6070911,19.1468709 33.4943148,18.3049798 L33.4943148,30.9654034 C33.4425061,31.0172121 33.3874594,31.0722588 33.3288508,31.1240675 C32.6002912,31.8267228 31.7069152,32.5847486 30.6383611,33.3259366 C30.4440785,33.4622582 30.2465579,33.5946941 30.0389993,33.7274539 C29.8223743,33.8670135 29.6086634,33.9994495 29.3949526,34.1257332 C28.7020115,34.5402026 28.0220225,34.8931493 27.3711759,35.191373 C26.9761346,35.3756177 26.5940456,35.5375198 26.2216707,35.6835556 C25.5287295,35.9584654 24.8778829,36.1721762 24.2950352,36.3441163 C24.2173222,36.3667826 24.1425234,36.3862108 24.0683722,36.4085533 M33.5689844,18.3849829 L33.5141273,18.3525258 C33.532413,18.3342401 33.5506987,18.3164115 33.5689844,18.2935544 L33.5689844,18.3849829"
          id="Fill-2679"
          fill="#92B6D1"
        />
        <path
          d="M24.0683722,36.473638 L22.2612205,35.414798 L20.3867175,34.3200157 L21.9762727,33.4133637 C21.9863107,33.4104495 21.9927868,33.4072115 22.0021771,33.4007354 C22.6760138,33.0183225 22.7828692,31.9368162 22.2421161,30.9848316 C21.8308846,30.2627481 21.1638478,29.8223743 20.571286,29.8223743 C20.3834795,29.8223743 20.2053871,29.8677069 20.043485,29.9583721 C20.0370089,29.9619339 20.0305328,29.96841 20.0208187,29.9713242 L18.6248984,30.7646447 L18.6248984,29.7579372 C18.6996972,29.7705656 18.7774102,29.7770417 18.8486472,29.7770417 C18.984645,29.7770417 19.1174047,29.7543754 19.2404504,29.7058047 L19.2469265,29.7190807 L21.8308846,28.2454474 C21.8438368,28.2425332 21.8535509,28.2360571 21.8629412,28.2292572 C21.8729792,28.2231049 21.8826933,28.2166288 21.8956455,28.2098289 L21.9604063,28.1745343 L21.9604063,28.1677344 C22.5464921,27.7403127 22.6174052,26.717415 22.1028802,25.8140011 C21.6916488,25.0915937 21.0242882,24.6512199 20.4317263,24.6512199 C20.2827763,24.6512199 20.1406263,24.6771242 20.0078665,24.7357328 L20.0046285,24.7292567 L19.9139633,24.7810654 C19.9107252,24.7839797 19.9074872,24.7839797 19.9074872,24.7839797 C19.9039253,24.7872177 19.9010111,24.7872177 19.8977731,24.7904557 L18.6248984,25.5125393 L18.6248984,20.5648099 L24.0683722,23.7481298 L24.0683722,36.473638"
          id="Fill-2680"
          fill="#84A9BF"
        />
        <path
          d="M24.0683722,23.7481298 L24.0683722,23.7481298 L18.6248984,20.5648099 L21.7920281,18.6644026 L21.7920281,20.8821381 C21.7920281,21.6563541 22.6792518,22.2845344 23.7737103,22.2845344 C24.8681688,22.2845344 25.7550687,21.6563541 25.7550687,20.8821381 L25.7550687,17.7577506 L25.7424403,17.7577506 C25.6809175,17.3562333 25.3826938,17.0032866 24.9426438,16.7762998 L26.4483337,15.8728858 L26.4483337,18.4830722 C26.4483337,19.2569644 27.3355574,19.8848209 28.4300159,19.8848209 C29.5241505,19.8848209 30.4081362,19.2569644 30.4081362,18.4830722 L30.4081362,16.5240563 L33.4554583,18.2819897 L33.4943148,18.3049798 C32.6070911,19.1468709 31.4281197,20.1244361 29.9454199,21.0670303 C29.6795766,21.2350847 29.4014287,21.403463 29.1164809,21.568927 C29.1132429,21.572165 29.1132429,21.572165 29.1100048,21.572165 C27.2157498,22.6662997 25.4574926,23.3333365 24.0683722,23.7481298"
          id="Fill-2681"
          fill="#84A9BF"
        />
        <path
          d="M23.7737103,22.2845344 C22.6792518,22.2845344 21.7920281,21.6563541 21.7920281,20.8821381 L25.7550687,20.8821381 C25.7550687,21.6563541 24.8681688,22.2845344 23.7737103,22.2845344"
          id="Fill-2682"
          fill="#728DA1"
        />
        <path
          d="M26.3634567,22.3291791 L21.7920281,22.3291791 L21.7920281,17.7577506 L21.8069686,17.7577506 C21.7994984,17.8283426 21.7920281,17.90462 21.7920281,17.9804235 C21.7920281,19.1127392 22.8154544,20.0313837 24.0779291,20.0313837 C25.3404039,20.0313837 26.3634567,19.1127392 26.3634567,17.9804235 L26.3634567,22.3291791 M26.4069023,17.9804235 C26.4069023,17.90462 26.3977594,17.8283426 26.3890737,17.7577506 L26.4069023,17.7577506 L26.4069023,17.9804235"
          id="Fill-2683"
          fill="#728DA1"
        />
        <path
          d="M23.7737103,19.3116873 C22.6792518,19.3116873 21.7920281,18.6838308 21.7920281,17.9099386 C21.7920281,17.8581299 21.7985042,17.8059974 21.8049803,17.7577506 C21.9118357,17.0518572 22.7504888,16.5043042 23.7737103,16.5043042 C24.2105223,16.5043042 24.6156014,16.6050073 24.9426438,16.7762998 C25.3826938,17.0032866 25.6809175,17.3562333 25.7424403,17.7577506 C25.7485926,17.8059974 25.7550687,17.8581299 25.7550687,17.9099386 C25.7550687,18.6838308 24.8681688,19.3116873 23.7737103,19.3116873"
          id="Fill-2684"
          fill="#6B8498"
        />
        <path
          d="M28.4300159,19.8848209 C27.3355574,19.8848209 26.4483337,19.2569644 26.4483337,18.4830722 L30.4081362,18.4830722 C30.4081362,19.2569644 29.5241505,19.8848209 28.4300159,19.8848209"
          id="Fill-2685"
          fill="#2B91C3"
        />
        <path
          d="M31.0197622,19.9262276 L26.4483337,19.9262276 L26.4483337,15.354799 L26.4629126,15.354799 C26.45581,15.4305084 26.4483337,15.501486 26.4483337,15.5776686 C26.4483337,16.7085778 27.4725968,17.6260812 28.7361039,17.6260812 C29.9992373,17.6260812 31.0197622,16.7085778 31.0197622,15.5776686 L31.0197622,19.9262276 M31.0626325,15.5776686 C31.0626325,15.501486 31.0585182,15.4305084 31.0493754,15.354799 L31.0626325,15.354799 L31.0626325,15.5776686"
          id="Fill-2686"
          fill="#2B91C3"
        />
        <path
          d="M28.4300159,16.9090595 C27.3355574,16.9090595 26.4483337,16.281203 26.4483337,15.5073108 C26.4483337,15.4551783 26.4548097,15.4066077 26.460962,15.354799 C26.5681412,14.6521437 27.4064705,14.1049145 28.4300159,14.1049145 C29.4532374,14.1049145 30.2918905,14.6521437 30.3987459,15.354799 C30.405222,15.4066077 30.4081362,15.4551783 30.4081362,15.5073108 C30.4081362,16.281203 29.5241505,16.9090595 28.4300159,16.9090595"
          id="Fill-2687"
          fill="#257EAB"
        />
        <path
          d="M19.2469265,29.7190807 L19.2404504,29.7058047 C19.2854592,29.6896145 19.3307918,29.6669482 19.3764482,29.6442819 C20.0499611,29.2592786 20.1568165,28.1774485 19.6157395,27.2290258 C19.2048319,26.5033804 18.5377951,26.0630066 17.9452332,26.0630066 C17.7574268,26.0630066 17.5793344,26.1083392 17.4206703,26.1990044 C17.3753377,26.2249087 17.3332432,26.2543749 17.2940628,26.2831935 L17.2879106,26.2738032 L18.6248984,25.5125393 L19.8977731,24.7904557 C19.2307362,25.1757828 19.1271189,26.2543749 19.664634,27.1995596 C20.0755416,27.9248812 20.7461403,28.365255 21.3387021,28.365255 C21.5135564,28.365255 21.6786966,28.3263985 21.8308846,28.2454474 L19.2469265,29.7190807 M21.9489809,28.2851652 C21.9759523,28.2673367 22.0084095,28.2485938 22.0404095,28.2257367 L22.0404095,28.2353367 L21.9489809,28.2851652 M19.9612985,24.8584018 L20.0892985,24.7852589 L20.0938699,24.7944018 C20.0481556,24.8126875 20.0024413,24.8350875 19.9612985,24.8584018"
          id="Fill-2688"
          fill="#728DA1"
        />
        <path
          d="M18.8486472,29.7770417 C18.7774102,29.7770417 18.6996972,29.7705656 18.6248984,29.7579372 C18.0941832,29.6637102 17.536916,29.2492407 17.1778171,28.6149081 C16.6726824,27.7241225 16.7342052,26.7238911 17.2940628,26.2831935 C17.3332432,26.2543749 17.3753377,26.2249087 17.4206703,26.1990044 C17.5793344,26.1083392 17.7574268,26.0630066 17.9452332,26.0630066 C18.5377951,26.0630066 19.2048319,26.5033804 19.6157395,27.2290258 C20.1568165,28.1774485 20.0499611,29.2592786 19.3764482,29.6442819 C19.3307918,29.6669482 19.2854592,29.6896145 19.2404504,29.7058047 C19.1174047,29.7543754 18.984645,29.7770417 18.8486472,29.7770417"
          id="Fill-2689"
          fill="#6B8498"
        />
        <path
          d="M21.3387021,28.365255 C20.7461403,28.365255 20.0755416,27.9248812 19.664634,27.1995596 C19.1271189,26.2543749 19.2307362,25.1757828 19.8977731,24.7904557 C19.9010111,24.7872177 19.9039253,24.7872177 19.9074872,24.7839797 C19.9074872,24.7839797 19.9107252,24.7839797 19.9139633,24.7810654 C19.9431057,24.7645514 19.9754861,24.748685 20.0078665,24.7357328 C20.1406263,24.6771242 20.2827763,24.6512199 20.4317263,24.6512199 C21.0242882,24.6512199 21.6916488,25.0915937 22.1028802,25.8140011 C22.6174052,26.717415 22.5464921,27.7403127 21.9604063,28.1677344 C21.93774,28.1839246 21.9147499,28.1972006 21.8956455,28.2098289 C21.8826933,28.2166288 21.8729792,28.2231049 21.8629412,28.2292572 C21.8535509,28.2360571 21.8438368,28.2425332 21.8308846,28.2454474 C21.6786966,28.3263985 21.5135564,28.365255 21.3387021,28.365255"
          id="Fill-2690"
          fill="#728DA1"
        />
        <path
          d="M21.9762727,33.4133637 L20.0208187,29.9713242 C20.0305328,29.96841 20.0370089,29.9619339 20.043485,29.9583721 C20.2053871,29.8677069 20.3834795,29.8223743 20.571286,29.8223743 C21.1638478,29.8223743 21.8308846,30.2627481 22.2421161,30.9848316 C22.7828692,31.9368162 22.6760138,33.0183225 22.0021771,33.4007354 C21.9927868,33.4072115 21.9863107,33.4104495 21.9762727,33.4133637"
          id="Fill-2691"
          fill="#728DA1"
        />
        <path
          d="M19.2598786,34.9579102 L19.2566406,34.9485198 C19.3019732,34.9323296 19.346982,34.9096633 19.3923146,34.8834352 C20.0661513,34.5013461 20.1730067,33.4198398 19.6322535,32.4678552 C19.2210221,31.7457717 18.5539853,31.3057217 17.9581854,31.3057217 C17.7797693,31.3057217 17.611391,31.3474924 17.4562888,31.4284435 L18.6248984,30.7646447 L20.0208187,29.9713242 L21.9762727,33.4133637 L20.3867175,34.3200157 L19.2598786,34.9579102 M17.3572454,31.6073118 L17.3481025,31.5931404 L17.5035311,31.5062832 C17.4532454,31.5337118 17.4025025,31.5702832 17.3572454,31.6073118"
          id="Fill-2692"
          fill="#728DA1"
        />
        <path
          d="M18.8648374,35.0197568 C18.2719518,35.0197568 17.6049149,34.5790592 17.1940073,33.8569756 C16.6888726,32.9668376 16.7503954,31.9659586 17.3105769,31.5259086 C17.3426335,31.4996804 17.3785758,31.4737761 17.4141942,31.4543478 C17.4206703,31.4481956 17.4271464,31.4449575 17.4336225,31.4417195 C17.4400986,31.4384814 17.4494889,31.4320053 17.4562888,31.4284435 C17.611391,31.3474924 17.7797693,31.3057217 17.9581854,31.3057217 C18.5539853,31.3057217 19.2210221,31.7457717 19.6322535,32.4678552 C20.1730067,33.4198398 20.0661513,34.5013461 19.3923146,34.8834352 C19.346982,34.9096633 19.3019732,34.9323296 19.2566406,34.9485198 C19.1300331,34.9970905 19.0005114,35.0197568 18.8648374,35.0197568"
          id="Fill-2693"
          fill="#6B8498"
        />
        <polyline
          id="Fill-2694"
          fill="#95BBD7"
          points="48.1529346 60.7813016 48.1561727 60.6388277 48.2303238 60.5225819 70.1262931 26.0892347 48.1529346 60.7813016"
        />
        <polyline
          id="Fill-2695"
          fill="#809EB4"
          points="2.91357561 33.3003598 2.90900418 33.2957884 2.91357561 33.291217 2.91357561 33.3003598"
        />
        <polyline
          id="Fill-2696"
          fill="#92B6D1"
          points="48.1496966 60.7848634 2.84623963 33.2323571 2.84623963 33.2258811 2.91423853 33.1255017 48.091088 60.603533 48.1561727 60.6388277 48.1529346 60.7813016 48.1496966 60.7848634"
        />
        <polyline
          id="Fill-2697"
          fill="#1A6C95"
          points="25.625547 -1.29927815e-13 47.3596141 7.04921919 93.0160177 34.8154363 70.1262931 26.0892347 25.625547 -1.29927815e-13"
        />
        <polyline
          id="Fill-2698"
          fill="#E4E4E3"
          points="55.1309169 81.783571 66.5514938 75.187354 66.5514938 114.992614 55.1309169 121.345654 55.1309169 81.783571"
        />
        <polyline
          id="Fill-2699"
          fill="#E4E4E3"
          points="74.2091413 71.7356004 84.6129728 65.7293548 84.6129728 87.5667155 74.2091413 93.9809545 74.2091413 71.7356004"
        />
        <polyline
          id="Fill-2700"
          fill="#FFFFFE"
          points="21.1861903 71.7356004 10.7794445 65.7293548 10.7794445 87.5667155 21.1861903 93.9809545 21.1861903 71.7356004"
        />
        <polyline
          id="Fill-2701"
          fill="#43566A"
          points="40.1743971 101.914483 28.8894941 95.3992172 29.122957 95.2761716 40.4331167 101.791114 40.1743971 101.914483"
        />
        <polyline
          id="Fill-2702"
          fill="#6E7988"
          points="28.8894941 95.3992172 28.8894941 75.7669637 29.346637 75.5467768 29.1712035 95.2761716 28.8894941 95.3992172"
        />
        <path
          d="M28.8894941,95.3862651 L39.863545,101.723115 L39.863545,82.7125655 L28.8894941,76.3757157 L28.8894941,95.3862651 Z M40.7439689,81.6961439 L40.7439689,103.756606 L28.0090703,96.4030105 L28.0090703,74.3454629 L40.7439689,81.6961439 L40.7439689,81.6961439 Z"
          id="Fill-2703"
          fill="#F8F7F6"
        />
        <polyline
          id="Fill-2704"
          fill="#FFFFFE"
          points="39.9995428 82.7352318 39.863545 101.464071 29.122957 95.2761716 29.2460026 76.5829505 39.9995428 82.7352318"
        />
        <polyline
          id="Fill-2705"
          fill="#455A6D"
          points="20.7040457 92.3331145 15.5102251 89.3314488 20.7040457 92.3036483 20.7040457 92.3331145"
        />
        <path
          d="M9.72675679,85.9930267 L20.7040457,92.3331145 L20.7040457,73.3222414 L9.72675679,66.9853916 L9.72675679,85.9930267 M21.5815553,72.3058197 L21.5815553,94.3633673 L8.84633295,87.0094483 L8.84633295,64.9522245 L21.5815553,72.3058197"
          id="Fill-2706"
          fill="#F8F7F6"
        />
        <polyline
          id="Fill-2707"
          fill="#B4B5B4"
          points="21.5815553 94.3633673 22.3486477 93.9129556 22.3486477 71.800685 9.72675679 64.4823845 8.84633295 64.9522245 19.3534581 71.0170787 21.5815553 72.3058197 21.5815553 94.3633673"
        />
        <polyline
          id="Fill-2708"
          fill="#FFFFFE"
          points="20.8400435 73.3416696 20.7040457 92.070833 9.96021968 85.8861713 10.0829415 67.1893883 20.8400435 73.3416696"
        />
        <polyline
          id="Fill-2709"
          fill="#C0CEDA"
          points="9.7574622 86.091573 9.7574622 86.091573 10.0728908 85.9265445 10.0728908 85.9174016 10.0728908 85.931573 9.7574622 86.091573"
        />
        <polyline
          id="Fill-2710"
          fill="#506A82"
          points="10.7794445 86.6014549 9.73679473 85.9995028 9.96021968 85.8861713 10.7794445 86.3586017 10.7794445 86.6014549"
        />
        <polyline
          id="Fill-2711"
          fill="#516C84"
          points="20.7040457 92.3036483 15.5102251 89.3314488 10.7794445 86.6014549 10.7794445 86.3586017 20.7040457 92.070833 20.7040457 92.3036483"
        />
        <polyline
          id="Fill-2712"
          fill="#6F8499"
          points="9.73963991 85.9995028 9.72675679 85.9930267 9.72675679 66.9853916 10.1838997 67.1893883 10.0263932 85.8761333 10.0263932 85.8826094 9.73963991 85.9995028"
        />
        <path
          d="M20.9347139,92.3816851 L20.7427139,92.3036483 L20.7427139,92.070833 L20.9347139,73.3416696 L20.9347139,92.3816851 M15.5102251,89.3314488 L9.72675679,86.0250833 L9.72675679,85.9930267 L9.73679473,85.9995028 L10.7794445,86.6014549 L15.5102251,89.3314488 M20.8400435,73.3416696 L10.0829415,67.1893883 L9.72675679,66.9853916 L20.8400435,73.3416696"
          id="Fill-2713"
          fill="#C7D6E3"
        />
        <polyline
          id="Fill-2714"
          fill="#CCDBE8"
          points="20.7040457 92.070833 20.7040457 92.070833 10.7794445 86.3586017 9.96021968 85.8861713 9.96021968 85.8761333 10.0829415 67.1893883 20.8400435 73.3416696 20.7040457 92.070833"
        />
        <polyline
          id="Fill-2715"
          fill="#F8F7F6"
          points="47.4664695 125.681394 92.3230766 100.353423 92.7861167 34.7344852 69.8963921 26.0082836 47.9230336 60.5578766 47.4664695 125.681394"
        />
        <polyline
          id="Fill-2716"
          fill="#E4E4E3"
          points="54.897454 81.6990581 66.3183548 75.1067268 66.3183548 114.911987 54.897454 121.264703 54.897454 81.6990581"
        />
        <polyline
          id="Fill-2717"
          fill="#E4E4E3"
          points="73.979564 71.6546493 84.3833956 65.6480799 84.3833956 87.4854406 73.979564 93.9003272 73.979564 71.6546493"
        />
        <path
          d="M23.6539027,16.1027869 C23.6668549,15.8437435 23.673331,15.5882619 23.673331,15.3321327 C23.673331,12.3563714 22.7796312,10.1353978 21.2933695,8.83370459 L27.7403127,8.70094483 C28.0317366,9.90517295 28.1904007,11.2457227 28.1904007,12.7222702 C28.1904007,13.8170525 27.6172671,15.7854587 27.4456508,17.5116593"
          id="Fill-2842"
          fill="#DE482A"
        />
        <path
          d="M-1.62409768e-13,21.0670303 L1.74206703,11.8580366 L3.13442544,13.1075973 C5.37191302,9.7950795 8.10158311,6.88407901 11.0805825,4.80849357 C11.6083835,4.43935669 12.1488128,4.09320991 12.6931278,3.77911976 C16.5039804,1.57725065 19.9916763,1.15306704 22.688966,2.2313353 C25.1466405,3.20922423 29.5665689,5.13553589 31.0492687,9.36474361 L21.2933695,8.83370459 C19.2825449,7.0722093 16.6176357,7.42515596 13.1335016,9.43889479 C10.5786859,10.9125281 8.57433736,13.5447331 6.70598666,16.3100216 L7.3147387,16.8572509 L-1.62409768e-13,21.0670303"
          id="Fill-2843"
          fill="#DE482A"
        />
        <path
          d="M27.4456508,17.5116593 C27.4456508,10.5142488 22.5335399,7.6773995 16.4686857,11.1777238 C13.9138699,12.6513571 11.5630509,15.0183664 9.69470017,17.7865691 L11.0899728,19.0364537 L3.77555791,23.2459093 L5.51762495,14.0369156 L6.90674531,15.2868001 C9.14714713,11.9742823 11.877141,9.06328182 14.8529024,6.98769638 C15.3839414,6.6185595 15.9243707,6.27241272 16.4686857,5.95832257 C25.0265091,1.01706925 31.9627206,5.02544244 31.9627206,14.901473"
          id="Fill-2844"
          fill="#E67848"
        />
        <polyline
          id="Fill-2845"
          fill="#DE482A"
          points="5.51762495 14.0369156 1.74206703 11.8580366 3.23804475e-13 21.0670303 3.77555791 23.2459093 5.51762495 14.0369156"
        />
        <polyline
          id="Fill-2846"
          fill="#3C96C6"
          points="41.054821 86.8184038 39.7987842 85.6886506 36.385887 83.7199206 37.6454857 84.8467595 41.054821 86.8184038"
        />
        <path
          d="M14.8593784,77.078371 L18.6184223,76.7513287 C19.8265361,79.4097618 17.8283399,80.099465 17.8283399,81.6896678 C17.8283399,85.1025649 19.1206428,87.4174417 21.1703239,88.3341316 C21.1573717,90.1341596 22.8152496,91.8729886 24.6447438,92.3975515 C25.9011044,92.899772 27.1995596,93.0422459 28.5077289,93.0257318 C28.2583996,93.9356219 28.0058323,94.8717401 27.7532649,95.0171282 C23.5179049,97.4618505 19.7225949,94.6026587 17.1551508,92.6569188 C15.0309947,91.0476115 13.7451679,88.0945165 13.7451679,84.0466391 C13.7451679,81.8029993 14.1405329,79.43599 14.8593784,77.078371"
          id="Fill-2847"
          fill="#1A6C95"
        />
        <path
          d="M24.6447438,92.3975515 C22.8152496,91.8729886 21.1573717,90.1341596 21.1702485,88.3341316 C22.922105,89.1174142 25.2275915,88.877799 27.7532649,87.4206797 C30.0619894,86.0898442 32.1825837,83.9559739 33.8666897,81.4597667 L32.6070911,80.329366 L39.2224125,76.5217515 L37.6454857,84.8467595 L37.0752664,85.5267485 C35.0518134,88.5183763 31.8914836,89.344401 29.197432,91.2124279 C28.967531,91.37433 28.7376299,92.1903168 28.5077289,93.0257318 C27.1995596,93.0422459 25.9011044,92.899772 24.6447438,92.3975515"
          id="Fill-2848"
          fill="#1A6C95"
        />
        <path
          d="M18.2719518,79.0503391 L22.0316433,78.7200587 C21.5232705,80.3908888 21.2415608,82.0685188 21.2415608,83.661312 C21.2415608,89.9884477 25.6841556,92.5533014 31.166162,89.3894098 C33.4716485,88.0585742 35.5954808,85.9250278 37.2795869,83.4284968 L36.0199882,82.298096 L42.6353097,78.4904815 L41.054821,86.8184038 L39.7987842,85.6886506 C37.7750074,88.6838402 35.3043807,91.3128072 32.6070911,93.1811579 C32.1343368,93.5214762 31.6518685,93.8255284 31.166162,94.1040001 C23.4272397,98.572823 17.1583888,94.9523673 17.1583888,86.018931 C17.1583888,83.7714055 17.5534301,81.40472 18.2719518,79.0503391"
          id="Fill-2849"
          fill="#2A90C3"
        />
        <polyline
          id="Fill-2850"
          fill="#1A6C95"
          points="42.6353097 78.4904815 39.2224125 76.5217515 32.6070911 80.329366 36.0199882 82.298096 42.6353097 78.4904815"
        />
        <polyline
          id="Fill-2851"
          fill="#1A6C95"
          points="37.2795869 83.4284968 36.0199882 82.298096 32.6070911 80.329366 33.8666897 81.4597667 37.2795869 83.4284968"
        />
        <polyline
          id="Fill-2852"
          fill="#77C9E0"
          points="18.2719518 79.0503391 14.8593784 77.078371 18.6184223 76.7513287 22.0316433 78.7200587 18.2719518 79.0503391"
        />
        <polyline
          id="Fill-2853"
          fill="#B4B5B4"
          points="40.6860079 81.6961439 38.4549964 80.4106409 27.9507855 74.3454629 28.8315332 73.8762705 41.4531002 81.1939234 41.4531002 103.306518 40.6860079 103.756606"
        />
        <polyline
          id="Fill-2854"
          fill="#F8F7F6"
          points="32.2282401 76.8131753 32.2282401 78.286161 39.9995428 82.7352318 39.9218298 93.3883926 40.6892459 93.6024273 40.7439689 81.6961439 32.2282401 76.8131753"
        />
        <polyline
          id="Fill-2855"
          fill="#E4E4E3"
          points="35.7573829 53.2463759 32.5034737 75.9709604 41.4531002 81.1939234 41.4531002 89.3764576 47.7481793 85.5332246 47.9230336 60.5578766 35.7573829 53.2463759"
        />
      </g>
    </g>
  </svg>
)

export const step21Image5 = (
  <svg
    width="70px"
    height="70px"
    viewBox="0 0 128 128"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    aria-hidden="true"
  >
    <g
      id="3.isolatie/isolatie_10.5"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Group" transform="translate(22.400000, 1.600000)">
        <polyline
          id="Fill-221"
          fill="#9E9F9E"
          points="45.1775911 20.6713728 2.32190649 41.4483267 43.068894 66.3520095 83.765577 43.0104004 45.1775911 20.6713728"
        />
        <polyline
          id="Fill-2718"
          fill="#F8F7F6"
          points="42.8319946 125.155703 83.3473472 102.282043 83.765577 43.0104004 63.0883548 35.128085 43.2443751 66.3376786 42.8319946 125.155703"
        />
        <polyline
          id="Fill-2719"
          fill="#E4E4E3"
          points="42.9519067 125.343175 2.43333694 102.69998 2.43333694 41.6355065 43.3584377 66.5245659 42.9519067 125.343175"
        />
        <polyline
          id="Fill-2720"
          fill="#E4E4E3"
          points="49.544144 85.4326468 59.8595039 79.4753583 59.8595039 115.428204 49.544144 121.166434 49.544144 85.4326468"
        />
        <polyline
          id="Fill-2721"
          fill="#E4E4E3"
          points="66.7793058 76.3602776 76.176315 70.9323569 76.176315 90.6564246 66.7793058 96.4502233 66.7793058 76.3602776"
        />
        <polyline
          id="Fill-2722"
          fill="#FFFFFE"
          points="18.8846835 76.3602776 9.48474965 70.9323569 9.48474965 90.6564246 18.8846835 96.4502233 18.8846835 76.3602776"
        />
        <polyline
          id="Fill-2723"
          fill="#43566A"
          points="35.7571845 103.44285 25.8509879 97.7253854 25.8688285 97.7163189 35.7571845 103.37295 35.7571845 103.44285"
        />
        <polyline
          id="Fill-2724"
          fill="#6E7988"
          points="25.9086762 97.7253854 25.900831 97.7192436 25.900831 80.5484248 25.900831 97.7016955 25.9338633 97.7163189 25.9086762 97.7253854"
        />
        <path
          d="M25.845431,97.7192436 L35.7571845,103.44285 L35.7571845,86.2720311 L25.845431,80.5484248 L25.845431,97.7192436 M36.5526985,85.3536803 L36.5526985,105.279551 L25.049917,98.6378868 L25.049917,78.7146481 L36.5526985,85.3536803"
          id="Fill-2725"
          fill="#F8F7F6"
        />
        <polyline
          id="Fill-2726"
          fill="#FFFFFE"
          points="35.8800212 86.2925039 35.7571845 103.209168 26.0527911 97.6198043 26.1642215 80.735897 35.8800212 86.2925039"
        />
        <polyline
          id="Fill-2727"
          fill="#C0CEDA"
          points="25.8911691 97.7975522 25.8911691 97.7975522 26.1508852 97.6612941 26.1508852 97.653449 26.1508852 97.6612941 25.8911691 97.7975522"
        />
        <polyline
          id="Fill-2728"
          fill="#506A82"
          points="35.7571845 103.37295 25.8688285 97.7163189 26.0527911 97.6198043 35.7571845 103.209168 35.7571845 103.37295"
        />
        <polyline
          id="Fill-2729"
          fill="#6F8499"
          points="25.8754603 97.7163189 25.845431 97.7016955 25.845431 80.5484248 26.2583342 80.735897 26.2545805 80.735897 26.1115659 97.6142474 26.1115659 97.6198043 25.8754603 97.7163189"
        />
        <path
          d="M35.9655299,103.44285 L35.7921106,103.37295 L35.7921106,103.209168 L35.9655299,86.2925039 L35.9655299,103.44285 M35.8800212,86.2925039 L26.1671462,80.735897 L25.845431,80.5484248 L35.8800212,86.2925039"
          id="Fill-2730"
          fill="#C7D6E3"
        />
        <polyline
          id="Fill-2731"
          fill="#CCDBE8"
          points="35.7571845 103.209168 35.7571845 103.209168 26.0527911 97.6198043 26.0527911 97.6142474 26.1642215 80.735897 26.1671462 80.735897 35.8800212 86.2925039 35.7571845 103.209168"
        />
        <polyline
          id="Fill-2732"
          fill="#43566A"
          points="9.48474965 89.7848688 8.54592614 89.2405851 8.56347425 89.2321036 9.48474965 89.7611789 9.48474965 89.7848688"
        />
        <polyline
          id="Fill-2733"
          fill="#455A6D"
          points="18.4489056 94.9612667 9.48474965 89.7848688 9.48474965 89.7611789 18.4489056 94.8910743 18.4489056 94.9612667"
        />
        <polyline
          id="Fill-2734"
          fill="#6E7988"
          points="8.60433704 89.2405851 8.59194995 89.2379529 8.59194995 72.0671342 8.59194995 89.2174801 8.62911124 89.2321036 8.60433704 89.2405851"
        />
        <path
          d="M8.53715209,89.2379529 L18.4489056,94.9612667 L18.4489056,77.7907404 L8.53715209,72.0671342 L8.53715209,89.2379529 M19.2444196,76.8723897 L19.2444196,96.7950435 L7.74163809,90.1563037 L7.74163809,70.2301403 L19.2444196,76.8723897"
          id="Fill-2735"
          fill="#F8F7F6"
        />
        <polyline
          id="Fill-2736"
          fill="#B4B5B4"
          points="19.2444196 96.7950435 19.9375696 96.3914371 19.9375696 76.416139 8.53715209 69.8060611 7.74163809 70.2301403 17.2293124 75.7080731 19.2444196 76.8723897 19.2444196 96.7950435"
        />
        <polyline
          id="Fill-2737"
          fill="#FFFFFE"
          points="18.5717423 77.8079961 18.4489056 94.727292 8.74480464 89.1385137 8.85886731 72.2510968 18.5717423 77.8079961"
        />
        <polyline
          id="Fill-2738"
          fill="#506A82"
          points="9.48474965 89.7611789 8.56347425 89.2321036 8.74480464 89.1385137 9.48474965 89.5623004 9.48474965 89.7611789"
        />
        <polyline
          id="Fill-2739"
          fill="#516C84"
          points="18.4489056 94.8910743 9.48474965 89.7611789 9.48474965 89.5623004 18.4489056 94.727292 18.4489056 94.8910743"
        />
        <polyline
          id="Fill-2740"
          fill="#6F8499"
          points="8.57093508 89.2321036 8.53715209 89.2174801 8.53715209 72.0671342 8.95005532 72.2510968 8.80366236 89.1385137 8.57093508 89.2321036"
        />
        <path
          d="M18.657251,94.9612667 L18.4838317,94.8910743 L18.4838317,94.727292 L18.657251,77.8079961 L18.657251,94.9612667 M18.5717423,77.8079961 L8.53715209,72.0671342 L18.5717423,77.8079961"
          id="Fill-2741"
          fill="#C7D6E3"
        />
        <polyline
          id="Fill-2742"
          fill="#CCDBE8"
          points="18.4489056 94.727292 18.4489056 94.727292 9.48474965 89.5623004 8.74480464 89.1385137 8.85886731 72.2510968 18.5717423 77.8079961 18.4489056 94.727292"
        />
        <polyline
          id="Fill-2743"
          fill="#B4B5B4"
          points="36.4971295 85.356605 34.484947 84.1928733 24.9940555 78.7146481 25.789862 78.2905689 37.1902795 84.9003544 37.1902795 104.873313 36.4971295 105.279551"
        />
        <polyline
          id="Fill-2744"
          fill="#F8F7F6"
          points="42.6211249 125.082585 83.1399872 102.205709 83.5552923 42.9372833 62.8807023 35.0549679 43.0367225 66.2613443 42.6211249 125.082585"
        />
        <polyline
          id="Fill-2745"
          fill="#E4E4E3"
          points="49.3364915 85.356605 59.6515589 79.4022412 59.6515589 115.355087 49.3364915 121.093317 49.3364915 85.356605"
        />
        <polyline
          id="Fill-2746"
          fill="#E4E4E3"
          points="66.5687286 76.2842358 75.9683699 70.8589473 75.9683699 90.583015 66.5687286 96.3771062 66.5687286 76.2842358"
        />
        <polyline
          id="Fill-2747"
          fill="#F8F7F6"
          points="28.8578553 80.9435496 28.8578553 82.2739883 35.8800212 86.2925039 35.8098288 95.9150061 36.5026864 96.1077428 36.5526985 85.356605 28.8578553 80.9435496"
        />
        <polyline
          id="Fill-2787"
          fill="#F8F7F6"
          points="22.3036389 39.3484037 22.3036389 51.3893271 31.2239245 46.2392513 31.2239245 34.198328 22.3036389 39.3484037"
        />
        <path
          d="M22.3036389,39.2872779 L22.3036389,51.3282012 C23.8183326,50.904122 25.8334398,50.1580352 27.954128,48.7925003 C29.3053319,47.9209445 30.3842478,46.9996691 31.2239245,46.1778329 L31.2239245,34.1336925 C30.3933143,34.9528964 29.3255123,35.8621806 27.9950736,36.7281795 C25.8600544,38.1086303 23.8303238,38.860274 22.3036389,39.2872779"
          id="Fill-2788"
          fill="#E4E4E3"
        />
        <polyline
          id="Fill-2789"
          fill="#C7C5BD"
          points="22.3036389 39.3484037 22.3036389 51.3893271 17.150346 48.3771952 17.150346 36.3333472 22.3036389 39.3484037"
        />
        <path
          d="M25.8714607,31.1066447 L31.2239245,34.198328 C30.229532,35.1339343 28.8578553,36.2573054 27.0737982,37.2867941 C25.2838917,38.3221322 23.6168219,38.9535714 22.3036389,39.3484037 L17.150346,36.3333472 L25.8714607,31.1066447"
          id="Fill-2790"
          fill="#C7C5BD"
        />
        <path
          d="M20.1478544,36.6345896 C20.1478544,37.3686853 20.9875311,37.9623961 22.0228692,37.9623961 C23.0582073,37.9623961 23.8972991,37.3686853 23.8972991,36.6345896 C23.8972991,35.9002015 23.0582073,35.3064907 22.0228692,35.3064907 C20.9875311,35.3064907 20.1478544,35.9002015 20.1478544,36.6345896"
          id="Fill-2791"
          fill="#777776"
        />
        <polygon
          id="Fill-2792"
          fill="#777776"
          points="20.1478544 36.6345896 23.8972991 36.6345896 23.8972991 19.4842437 20.1478544 19.4842437"
        />
        <path
          d="M24.9767999,34.3267216 C24.9767999,35.058185 25.8158917,35.6548205 26.8512297,35.6548205 C27.8865678,35.6548205 28.7262446,35.058185 28.7262446,34.3267216 C28.7262446,33.592626 27.8865678,32.9992076 26.8512297,32.9992076 C25.8158917,32.9992076 24.9767999,33.592626 24.9767999,34.3267216"
          id="Fill-2793"
          fill="#777776"
        />
        <polygon
          id="Fill-2794"
          fill="#777776"
          points="24.9767999 34.3267216 28.7262446 34.3267216 28.7262446 25.1578378 24.9767999 25.1578378"
        />
        <path
          d="M28.7350186,29.9221478 L28.7350186,25.8629791 C28.7350186,25.8629791 28.2612198,25.4269087 30.3084985,24.4003447 L39.3428468,19.9343525 L38.4478936,16.4218072 L26.6233969,22.0111705 C26.6233969,22.0111705 25.0235948,22.9584756 24.9914233,24.4763865 C24.9592518,25.9942974 24.9914233,29.6124238 24.9914233,29.6124238 L28.7350186,29.9221478"
          id="Fill-2795"
          fill="#777776"
        />
        <path
          d="M26.5083647,27.9783614 C26.5083647,27.9783614 26.6111776,27.9911614 26.6111776,28.1765549 C26.6111776,28.5068775 26.5042357,28.1765549 26.5042357,28.1765549 L26.5083647,27.9783614"
          id="Fill-2796"
          fill="#4D4E4C"
        />
        <path
          d="M28.7768874,25.9854139 C28.7768874,25.9854139 28.847081,25.993672 28.847081,26.121672 C28.847081,26.3442268 28.7723455,26.121672 28.7723455,26.121672 L28.7768874,25.9854139"
          id="Fill-2797"
          fill="#4D4E4C"
        />
        <path
          d="M28.7645865,26.408846 C28.7645865,26.408846 28.8343671,26.421646 28.8343671,26.5455169 C28.8343671,26.7726137 28.7645865,26.5455169 28.7645865,26.5455169 L28.7645865,26.408846"
          id="Fill-2798"
          fill="#4D4E4C"
        />
        <path
          d="M26.8456728,26.7108449 C25.9331715,26.7108449 25.1727537,26.3160126 24.9767999,25.7866448 L24.9270803,25.7866448 C24.9270803,26.4476234 25.7840126,26.983133 26.8456728,26.983133 C27.9044084,26.983133 28.763973,26.4476234 28.763973,25.7866448 L28.7145458,25.7866448 C28.5156673,26.3160126 27.7552495,26.7108449 26.8456728,26.7108449"
          id="Fill-2799"
          fill="#777776"
        />
        <path
          d="M25.0427123,25.7160238 C25.0427123,25.7160238 24.9770607,25.7242818 24.9770607,25.8522818 C24.9770607,26.0752496 25.0472543,25.8522818 25.0472543,25.8522818 L25.0427123,25.7160238"
          id="Fill-2800"
          fill="#777776"
        />
        <path
          d="M26.8456728,27.1319994 C25.9331715,27.1319994 25.1727537,26.7371671 24.9767999,26.2077993 L24.9270803,26.2077993 C24.9270803,26.8687779 25.7840126,27.4042875 26.8456728,27.4042875 C27.9044084,27.4042875 28.763973,26.8687779 28.763973,26.2077993 L28.7145458,26.2077993 C28.5156673,26.7371671 27.7552495,27.1319994 26.8456728,27.1319994"
          id="Fill-2801"
          fill="#777776"
        />
        <path
          d="M25.0427123,26.1369106 C25.0427123,26.1369106 24.9770607,26.1455816 24.9770607,26.2731687 C24.9770607,26.5002654 25.0472543,26.2731687 25.0472543,26.2731687 L25.0427123,26.1369106"
          id="Fill-2802"
          fill="#777776"
        />
        <path
          d="M26.8512297,26.5268823 C25.9360962,26.5268823 25.1753859,26.1317575 24.9767999,25.5997575 L24.9270803,25.5997575 C24.9270803,26.2607361 25.7869373,26.7959532 26.8512297,26.7959532 C27.9131824,26.7959532 28.7759642,26.2607361 28.7759642,25.5997575 L28.7230274,25.5997575 C28.5270736,26.1317575 27.7640236,26.5268823 26.8512297,26.5268823"
          id="Fill-2803"
          fill="#4D4E4C"
        />
        <path
          d="M25.0427123,25.5288688 C25.0427123,25.5288688 24.9770607,25.540843 24.9770607,25.6651269 C24.9770607,25.8922237 25.0472543,25.6651269 25.0472543,25.6651269 L25.0427123,25.5288688"
          id="Fill-2804"
          fill="#4D4E4C"
        />
        <path
          d="M26.8512297,26.9655849 C25.9360962,26.9655849 25.1753859,26.5704601 24.9767999,26.0413848 L24.9270803,26.0413848 C24.9270803,26.7023633 25.7869373,27.237288 26.8512297,27.237288 C27.9131824,27.237288 28.7759642,26.7023633 28.7759642,26.0413848 L28.7230274,26.0413848 C28.5270736,26.5704601 27.7640236,26.9655849 26.8512297,26.9655849"
          id="Fill-2805"
          fill="#4D4E4C"
        />
        <path
          d="M25.0427123,25.970411 C25.0427123,25.970411 24.9770607,25.9786691 24.9770607,26.107082 C24.9770607,26.3300497 25.0472543,26.107082 25.0472543,26.107082 L25.0427123,25.970411"
          id="Fill-2806"
          fill="#4D4E4C"
        />
        <path
          d="M26.8456728,27.4042875 C25.9331715,27.4042875 25.1727537,27.0091627 24.9767999,26.4800874 L24.9270803,26.4800874 C24.9270803,27.1410659 25.7840126,27.6759906 26.8456728,27.6759906 C27.9044084,27.6759906 28.763973,27.1410659 28.763973,26.4800874 L28.7145458,26.4800874 C28.5156673,27.0091627 27.7552495,27.4042875 26.8456728,27.4042875"
          id="Fill-2807"
          fill="#4D4E4C"
        />
        <path
          d="M25.0427123,26.408846 C25.0427123,26.408846 24.9770607,26.421646 24.9770607,26.5455169 C24.9770607,26.7726137 25.0472543,26.5455169 25.0472543,26.5455169 L25.0427123,26.408846"
          id="Fill-2808"
          fill="#4D4E4C"
        />
        <path
          d="M28.7768874,25.5434674 C28.7768874,25.5434674 28.847081,25.5521384 28.847081,25.6797255 C28.847081,25.9026932 28.7723455,25.6797255 28.7723455,25.6797255 L28.7768874,25.5434674"
          id="Fill-2809"
          fill="#4D4E4C"
        />
        <path
          d="M2.45088505,41.3839837 L2.31927427,41.302385 L22.8973497,11.5641999 L34.5024951,18.288048 L26.6233969,22.0111705 C26.6233969,22.0111705 25.0235948,22.9584756 24.9914233,24.4763865 C24.9855739,24.6723403 24.9826493,24.9033903 24.9826493,25.1578378 L24.9767999,25.1578378 L24.9767999,25.5997575 L24.9735827,25.503243 C24.9735827,25.503243 24.9270803,25.5117246 24.9270803,25.5997575 C24.9270803,25.6056069 24.9270803,25.6111638 24.9270803,25.6140885 C24.9270803,25.6521094 24.9300049,25.6901303 24.9358543,25.7252265 C24.9300049,25.7401424 24.9270803,25.7606151 24.9270803,25.7866448 C24.9270803,25.7924942 24.9270803,25.7954189 24.9270803,25.8015607 C24.9270803,25.8568372 24.9329296,25.9094816 24.947553,25.965343 C24.9358543,25.9770418 24.9270803,26.0001468 24.9270803,26.0413848 C24.9270803,26.0472342 24.9270803,26.0498664 24.9270803,26.0560082 C24.9270803,26.0881797 24.9300049,26.1203513 24.9358543,26.1522303 C24.9300049,26.1671462 24.9270803,26.1846943 24.9270803,26.2077993 C24.9270803,26.2136487 24.9270803,26.2165734 24.9270803,26.2227152 C24.9270803,26.2809164 24.9358543,26.3426272 24.9504777,26.3981962 C24.9384865,26.4125272 24.9270803,26.4359246 24.9270803,26.4800874 C24.9270803,26.4859367 24.9270803,26.488569 24.9270803,26.4947108 C24.9270803,26.5824513 24.9446284,26.6698994 24.9767999,26.7547152 C24.9767999,26.7637817 24.9767999,26.7722633 24.9767999,26.7842545 L24.9767999,30.466139 L23.8972991,30.9870251 L23.8972991,19.4842437 L20.1478544,19.4842437 L20.1478544,32.805886 L2.45088505,41.3839837 M28.7350186,28.6440609 L28.7350186,26.6906646 C28.7525667,26.6263216 28.763973,26.5619785 28.763973,26.4947108 C28.763973,26.488569 28.763973,26.4859367 28.763973,26.4800874 C28.763973,26.4359246 28.7525667,26.4125272 28.740868,26.3981962 C28.7554914,26.3367779 28.763973,26.2721424 28.763973,26.2077993 L28.7554914,26.2077993 C28.763973,26.1729956 28.7698223,26.1378994 28.7730395,26.1028032 C28.7759642,26.090812 28.7759642,26.0761885 28.7759642,26.0560082 C28.7759642,26.0527911 28.7759642,26.0527911 28.7759642,26.0498664 C28.7759642,26.0472342 28.7759642,26.0443095 28.7759642,26.0413848 C28.7730395,25.9942974 28.7554914,25.9738246 28.7437927,25.965343 C28.7584161,25.9068493 28.763973,25.8480632 28.763973,25.7866448 L28.7525667,25.7866448 C28.7613408,25.7459917 28.7698223,25.7050462 28.7730395,25.6611759 C28.7759642,25.6494772 28.7759642,25.6345613 28.7759642,25.6140885 C28.7759642,25.6140885 28.7759642,25.6111638 28.7759642,25.6085316 C28.7759642,25.6056069 28.7759642,25.6026822 28.7759642,25.5997575 C28.7730395,25.5585195 28.7584161,25.5383392 28.7464249,25.5295651 C28.8783281,25.2923733 29.2673111,24.9209384 30.3084985,24.4003447 L38.2636385,20.466645 L41.6065521,22.4027856 L28.7350186,28.6440609"
          id="Fill-2810"
          fill="#97BDDB"
        />
        <path
          d="M43.0718187,66.0770892 L2.45088505,41.3839837 L20.1478544,32.805886 L20.1478544,34.5375913 L17.150346,36.3333472 L17.150346,48.3771952 L22.3036389,51.3893271 L22.5142161,51.2664903 C24.0058049,50.8339296 25.9331715,50.0939846 27.954128,48.7925003 C29.2205161,47.9735888 30.2529295,47.1137318 31.0659916,46.329624 L31.2239245,46.2392513 L31.2239245,34.1336925 C31.2122258,34.1486084 31.1976024,34.1603071 31.1859036,34.1749305 L28.7262446,32.7535342 L28.7262446,29.9192231 L28.7350186,29.9221478 L28.7350186,28.6440609 L41.6065521,22.4027856 L63.0912795,34.8531647 L62.9450453,35.0783654 L62.8807023,35.0549679 L53.0625387,50.4972985 L43.0718187,66.0770892 M23.8972991,32.288217 L23.8972991,30.9870251 L24.9767999,30.466139 L24.9767999,31.6418619 L23.8972991,32.288217"
          id="Fill-2811"
          fill="#809EB4"
        />
        <polyline
          id="Fill-2812"
          fill="#97BDDB"
          points="28.786462 25.6448958 28.786462 25.6279667 28.786462 25.6448958"
        />
        <polyline
          id="Fill-2813"
          fill="#95BBD7"
          points="53.0625387 50.4972985 62.8807023 35.0549679 62.9450453 35.0783654 53.0625387 50.4972985"
        />
        <path
          d="M22.3204997,51.4748358 L22.3204997,51.388539 C22.4154675,51.3596358 22.5186933,51.3348616 22.6177901,51.3014164 L22.3204997,51.4748358 M31.0936916,46.4210943 C31.1717303,46.3471846 31.2464658,46.2769911 31.3166594,46.2067975 L31.3166594,46.2935072 L31.0936916,46.4210943 M26.9392627,37.3657606 C26.9860577,37.339146 27.0299279,37.3131163 27.0737982,37.2867941 C27.4042875,37.0993219 27.7172286,36.9062927 28.0184711,36.7106314 C28.0094045,36.7161883 28.000923,36.7220377 27.9950736,36.7281795 C27.6411869,36.9560124 27.2873001,37.1698068 26.9392627,37.3657606"
          id="Fill-2814"
          fill="#95BBD7"
        />
        <path
          d="M22.3036389,51.3282012 L22.3036389,39.3484037 C23.5843579,38.9655626 25.1987834,38.3540112 26.9392627,37.3657606 C27.2873001,37.1698068 27.6411869,36.9560124 27.9950736,36.7281795 C28.000923,36.7220377 28.0094045,36.7161883 28.0184711,36.7106314 C29.3492022,35.8507744 30.4137871,34.961378 31.2239245,34.198328 L31.2239245,46.1778329 C31.1742049,46.2275526 31.1212681,46.2772722 31.0659916,46.329624 C30.2529295,47.1137318 29.2205161,47.9735888 27.954128,48.7925003 C25.9331715,50.0939846 24.0058049,50.8339296 22.5142161,51.2664903 C22.4440237,51.2901803 22.3709066,51.3077284 22.3036389,51.3282012 M31.2919702,34.2718535 L31.2382928,34.2388212 C31.2548089,34.218176 31.2754541,34.2016599 31.2919702,34.1806018 L31.2919702,34.2718535"
          id="Fill-2815"
          fill="#92B6D1"
        />
        <polyline
          id="Fill-2816"
          fill="#84A9BF"
          points="22.3036389 51.3893271 17.150346 48.3771952 17.150346 36.3333472 22.3036389 39.3484037 22.3036389 51.3893271"
        />
        <path
          d="M22.3036389,39.3484037 L22.3036389,39.3484037 L17.150346,36.3333472 L20.1478544,34.5375913 L20.1478544,36.6345896 C20.1478544,37.3686853 20.9875311,37.9623961 22.0228692,37.9623961 C23.0582073,37.9623961 23.8972991,37.3686853 23.8972991,36.6345896 L23.8972991,32.288217 L24.9767999,31.6418619 L24.9767999,34.3267216 C24.9767999,35.058185 25.8158917,35.6548205 26.8512297,35.6548205 C27.8865678,35.6548205 28.7262446,35.058185 28.7262446,34.3267216 L28.7262446,32.7535342 L31.1859036,34.1749305 L31.2239245,34.198328 C30.4137871,34.961378 29.3492022,35.8507744 28.0184711,36.7106314 C27.7172286,36.9062927 27.4042875,37.0993219 27.0737982,37.2867941 C27.0299279,37.3131163 26.9860577,37.339146 26.9392627,37.3657606 C25.1987834,38.3540112 23.5843579,38.9655626 22.3036389,39.3484037"
          id="Fill-2817"
          fill="#84A9BF"
        />
        <path
          d="M22.0228692,37.9623961 C20.9875311,37.9623961 20.1478544,37.3686853 20.1478544,36.6345896 L23.8972991,36.6345896 C23.8972991,37.3686853 23.0582073,37.9623961 22.0228692,37.9623961"
          id="Fill-2818"
          fill="#728DA1"
        />
        <polygon
          id="Fill-2819"
          fill="#728DA1"
          points="20.1478544 36.6345896 23.8972991 36.6345896 23.8972991 19.4842437 20.1478544 19.4842437"
        />
        <path
          d="M26.8512297,35.6548205 C25.8158917,35.6548205 24.9767999,35.058185 24.9767999,34.3267216 L28.7262446,34.3267216 C28.7262446,35.058185 27.8865678,35.6548205 26.8512297,35.6548205"
          id="Fill-2820"
          fill="#728DA1"
        />
        <path
          d="M29.1058321,34.3267216 L24.9767999,34.3267216 L24.9767999,26.7842545 C24.9796986,28.208283 24.9929038,29.6124238 24.9929038,29.6124238 L29.1058321,29.9192231 L29.1058321,34.3267216 M29.1071462,25.7568004 C29.1154043,25.71551 29.1315075,25.6659617 29.1566946,25.6122842 L29.1566946,25.6250842 L29.1521527,25.6498584 C29.1401785,25.6870197 29.1232494,25.7237681 29.1071462,25.7568004 M25.0250207,25.6056069 C25.0213045,25.6026822 25.0213045,25.6026822 25.0213045,25.5997575 L25.0213045,25.1578378 L25.0295626,25.1578378 C25.0250207,25.3014398 25.0250207,25.4503062 25.0250207,25.6056069"
          id="Fill-2821"
          fill="#728DA1"
        />
        <path
          d="M28.7350186,29.9221478 L28.7262446,29.9192231 L24.9914233,29.6124238 C24.9914233,29.6124238 24.9794321,28.208283 24.9767999,26.7842545 C24.9767999,26.7722633 24.9767999,26.7637817 24.9767999,26.7547152 C25.1753859,27.2814507 25.9360962,27.6759906 26.8456728,27.6759906 C27.7900533,27.6759906 28.574161,27.2519114 28.7350186,26.6906646 L28.7350186,29.9221478 M26.5083647,27.9780335 L26.5042357,28.1762271 C26.5042357,28.1762271 26.5537841,28.3252852 26.5822744,28.3252852 C26.5992034,28.3252852 26.6111776,28.287711 26.6111776,28.1762271 C26.6111776,27.9908335 26.5083647,27.9780335 26.5083647,27.9780335 M26.8512297,26.5268823 C25.9390209,26.5268823 25.1786031,26.1317575 24.9794321,25.6056069 C24.9794321,25.4503062 24.9794321,25.3014398 24.9826493,25.1578378 C24.9826493,24.9033903 24.9855739,24.6723403 24.9914233,24.4763865 C25.0235948,22.9584756 26.6233969,22.0111705 26.6233969,22.0111705 L34.5024951,18.288048 L38.2636385,20.466645 L30.3084985,24.4003447 C29.2673111,24.9209384 28.8783281,25.2923733 28.7464249,25.5295651 C28.7350186,25.5175739 28.7262446,25.5175739 28.7262446,25.5175739 L28.7262446,25.5731429 C28.708404,25.6111638 28.6969977,25.64626 28.6911483,25.6755069 C28.454249,26.1671462 27.7201533,26.5268823 26.8512297,26.5268823 M28.6989529,26.280414 C28.7402432,26.2056786 28.7732755,26.1317689 28.7976368,26.0570334 L28.7976368,26.0739624 C28.7732755,26.1437431 28.7402432,26.2139366 28.6989529,26.280414"
          id="Fill-2822"
          fill="#728DA1"
        />
        <path
          d="M26.5822744,28.3252852 C26.5537841,28.3252852 26.5042357,28.1762271 26.5042357,28.1762271 L26.5083647,27.9780335 C26.5083647,27.9780335 26.6111776,27.9908335 26.6111776,28.1762271 C26.6111776,28.287711 26.5992034,28.3252852 26.5822744,28.3252852"
          id="Fill-2823"
          fill="#637C8E"
        />
        <path
          d="M29.4290919,27.9059882 C29.4290919,27.6541172 29.4703822,27.4063753 29.4703822,27.1586333 C29.4703822,27.1999237 29.4703822,27.1999237 29.4703822,27.245343 C29.4703822,27.5302462 29.4703822,27.7366979 29.4290919,27.9059882 M29.4703822,27.0388914 L28.7230274,27.0388914 L28.7230274,26.8696011 C28.8510274,26.5805688 28.933608,26.2543753 29.0161887,25.965343 C29.18135,26.085085 29.4290919,26.3741172 29.4703822,27.0388914"
          id="Fill-2824"
          fill="#637C8E"
        />
        <path
          d="M29.4123523,27.5543253 L28.7145458,27.5543253 C28.8342878,27.1785833 28.9622878,26.8069704 29.0861587,26.3981962 C29.25132,26.6005188 29.4123523,26.9308414 29.4123523,27.5543253"
          id="Fill-2825"
          fill="#637C8E"
        />
        <path
          d="M26.8512297,26.9655849 C25.9360962,26.9655849 25.1753859,26.5704601 24.9767999,26.0413848 L24.9735827,25.9445778 C24.9735827,25.9445778 24.9592518,25.9477949 24.947553,25.965343 C24.9329296,25.9094816 24.9270803,25.8568372 24.9270803,25.8015607 C24.9270803,25.8422138 24.9329296,25.8568372 24.9384865,25.8568372 C24.9446284,25.8568372 24.9534024,25.8422138 24.9621765,25.8278829 C25.1318081,26.3806481 25.9124062,26.7959532 26.8512297,26.7959532 C27.8108185,26.7959532 28.6092572,26.3572507 28.7525667,25.7866448 L28.763973,25.7866448 C28.763973,25.8480632 28.7584161,25.9068493 28.7437927,25.965343 C28.7379433,25.9858158 28.7320939,26.0089208 28.7230274,26.0293936 C28.7057718,26.0823304 28.6823743,26.1346822 28.6531275,26.187619 C28.3840565,26.640945 27.6792077,26.9655849 26.8512297,26.9655849"
          id="Fill-2826"
          fill="#728DA1"
        />
        <path
          d="M26.8456728,27.4042875 C26.0326107,27.4042875 25.3391682,27.0910538 25.058691,26.6494266 C25.3423854,27.0910538 26.035243,27.4042875 26.8456728,27.4042875 C27.6558103,27.4042875 28.3489603,27.0910538 28.6294375,26.6465019 C28.3489603,27.0910538 27.6558103,27.4042875 26.8456728,27.4042875"
          id="Fill-2827"
          fill="#728DA1"
        />
        <path
          d="M24.9961748,25.9441525 C24.9883297,25.9441525 24.9800716,25.9235073 24.9800716,25.8661138 C24.9800716,25.8574428 24.9800716,25.8533138 24.9800716,25.8450557 C24.9800716,25.8083073 24.9842006,25.7794041 24.9924587,25.7583461 C25.0007168,25.8083073 25.0131038,25.8574428 25.02962,25.9032751 C25.0172329,25.9235073 25.0048458,25.9441525 24.9961748,25.9441525"
          id="Fill-2828"
          fill="#728DA1"
        />
        <path
          d="M26.8456728,27.4042875 C26.035243,27.4042875 25.3423854,27.0910538 25.058691,26.6494266 C25.0265195,26.5938576 24.9972727,26.538581 24.9767999,26.4800874 L24.9735827,26.3832803 C24.9735827,26.3832803 24.9621765,26.3864975 24.9504777,26.3981962 C24.9358543,26.3426272 24.9270803,26.2809164 24.9270803,26.2227152 C24.9270803,26.2636608 24.9329296,26.2782842 24.9384865,26.2782842 C24.9446284,26.2782842 24.9504777,26.2692177 24.9560346,26.2578114 C25.1198169,26.8132089 25.9068493,27.237288 26.8512297,27.237288 C27.8225172,27.237288 28.6268053,26.7898114 28.7554914,26.2077993 L28.763973,26.2077993 C28.763973,26.2721424 28.7554914,26.3367779 28.740868,26.3981962 C28.7320939,26.4271506 28.7230274,26.4534727 28.7145458,26.4800874 C28.6911483,26.538581 28.6648262,26.5938576 28.6294375,26.6465019 C28.3489603,27.0910538 27.6558103,27.4042875 26.8456728,27.4042875"
          id="Fill-2829"
          fill="#728DA1"
        />
        <path
          d="M24.9974394,26.3644553 C24.9895942,26.3644553 24.9813362,26.3438102 24.9813362,26.2860037 C24.9813362,26.2773327 24.9813362,26.2732037 24.9813362,26.2649456 C24.9813362,26.2323263 24.9854652,26.2075521 24.9937233,26.186494 C24.9974394,26.2364553 25.0102394,26.2860037 25.0222136,26.3355521 C25.0143684,26.3516553 25.0061103,26.3644553 24.9974394,26.3644553"
          id="Fill-2830"
          fill="#728DA1"
        />
        <path
          d="M26.9912826,29.7287898 C25.9841251,29.7287898 25.1467096,28.2952383 24.964731,26.3872013 C24.9521808,26.275142 24.9427681,26.1550064 24.9364929,26.0328516 C24.9302178,25.9117064 24.9270803,25.7804658 24.9270803,25.6492252 C24.9270803,25.8006567 24.9333554,25.8410384 24.9393168,25.8410384 C24.9553183,25.8410384 24.9804188,25.5997575 24.9804188,25.5997575 C24.9804188,25.609853 24.9804188,25.609853 24.9832426,25.6199484 C25.1969106,27.4361169 26.0126769,28.8000099 26.9912826,28.8000099 C27.9234525,28.8000099 28.7109806,27.5582716 28.9651232,25.8612293 C28.9773597,25.7804658 28.9902237,25.6906164 28.9993226,25.5997575 L28.9993226,25.6492252 C28.9993226,25.6492252 29.0244231,25.8925251 29.0404247,25.8925251 C29.0466998,25.8925251 29.0495236,25.8723342 29.052975,25.8117616 C29.0495236,25.9631931 29.0404247,26.1045292 29.031012,26.2448557 C28.8772715,28.2144748 28.0207169,29.7287898 26.9912826,29.7287898"
          id="Fill-2831"
          fill="#637C8E"
        />
        <path
          d="M24.9931639,25.7641386 C24.9853188,25.7641386 24.9770607,25.7476225 24.9770607,25.685687 C24.9770607,25.681558 24.9770607,25.6737128 24.9770607,25.6654547 C24.9770607,25.5411709 25.0427123,25.5291967 25.0427123,25.5291967 L25.0472543,25.6654547 C25.0472543,25.6654547 25.014222,25.7641386 24.9931639,25.7641386"
          id="Fill-2832"
          fill="#637C8E"
        />
        <path
          d="M26.8512297,27.237288 C25.9068493,27.237288 25.1198169,26.8132089 24.9560346,26.2578114 C24.947553,26.2227152 24.9384865,26.187619 24.9358543,26.1522303 C24.9300049,26.1203513 24.9270803,26.0881797 24.9270803,26.0560082 C24.9270803,26.0966613 24.9329296,26.1112847 24.9384865,26.1112847 C24.9534024,26.1112847 24.9767999,26.0413848 24.9767999,26.0413848 C25.1753859,26.5704601 25.9360962,26.9655849 26.8512297,26.9655849 C27.6792077,26.9655849 28.3840565,26.640945 28.6531275,26.187619 C28.6823743,26.1405316 28.7057718,26.090812 28.7230274,26.0413848 L28.7759642,26.0413848 C28.7759642,26.0443095 28.7759642,26.0472342 28.7759642,26.0498664 C28.7759642,26.0674145 28.7730395,26.0849626 28.7730395,26.1028032 C28.7698223,26.1378994 28.763973,26.1729956 28.7554914,26.2077993 C28.6268053,26.7898114 27.8225172,27.237288 26.8512297,27.237288"
          id="Fill-2833"
          fill="#637C8E"
        />
        <path
          d="M24.9931639,26.2058261 C24.9853188,26.2058261 24.9770607,26.1851809 24.9770607,26.1277874 C24.9770607,26.1191164 24.9770607,26.1154003 24.9770607,26.1071422 C24.9770607,26.0489229 24.9894478,26.0163035 25.0059639,25.9997874 C25.0224801,25.9750132 25.0427123,25.9704713 25.0427123,25.9704713 L25.0472543,26.1071422 C25.0472543,26.1071422 25.014222,26.2058261 24.9931639,26.2058261"
          id="Fill-2834"
          fill="#637C8E"
        />
        <path
          d="M26.8456728,27.6759906 C25.9360962,27.6759906 25.1753859,27.2814507 24.9767999,26.7547152 C24.9446284,26.6698994 24.9270803,26.5824513 24.9270803,26.4947108 C24.9270803,26.5353639 24.9329296,26.5499873 24.9384865,26.5499873 C24.9534024,26.5499873 24.9767999,26.4800874 24.9767999,26.4800874 C24.9972727,26.538581 25.0265195,26.5938576 25.058691,26.6494266 C25.3391682,27.0910538 26.0326107,27.4042875 26.8456728,27.4042875 C27.6558103,27.4042875 28.3489603,27.0910538 28.6294375,26.6465019 C28.6648262,26.5938576 28.6911483,26.538581 28.7145458,26.4800874 L28.763973,26.4800874 C28.763973,26.4859367 28.763973,26.488569 28.763973,26.4947108 C28.763973,26.5619785 28.7525667,26.6263216 28.7350186,26.6906646 C28.574161,27.2519114 27.7900533,27.6759906 26.8456728,27.6759906"
          id="Fill-2835"
          fill="#637C8E"
        />
        <path
          d="M24.9931639,26.6445287 C24.9853188,26.6445287 24.9770607,26.6238835 24.9770607,26.56649 C24.9770607,26.557819 24.9770607,26.5541029 24.9770607,26.5458448 C24.9770607,26.4834964 24.9931639,26.4504642 25.010093,26.4302319 C25.0266091,26.4137158 25.0427123,26.4091738 25.0427123,26.4091738 L25.0472543,26.5458448 C25.0472543,26.5458448 25.014222,26.6445287 24.9931639,26.6445287"
          id="Fill-2836"
          fill="#637C8E"
        />
        <path
          d="M28.8264358,25.7791749 C28.8053777,25.7791749 28.7723455,25.6796653 28.7723455,25.6796653 L28.7723455,25.659433 L28.7768874,25.6346588 L28.7768874,25.5434072 C28.7768874,25.5434072 28.7892745,25.5434072 28.8053777,25.5603362 C28.8223068,25.5727233 28.8429519,25.6012136 28.847081,25.659433 C28.847081,25.663562 28.847081,25.6676911 28.847081,25.6718201 C28.847081,25.6755362 28.847081,25.6796653 28.847081,25.6796653 C28.847081,25.7085685 28.847081,25.7296266 28.8429519,25.7461427 C28.83841,25.7709169 28.8346939,25.7791749 28.8264358,25.7791749"
          id="Fill-2837"
          fill="#637C8E"
        />
        <polyline
          id="Fill-2838"
          fill="#1A6C95"
          points="22.8973497 11.5641999 42.5275351 17.9312365 83.765577 43.0104004 63.0912795 35.128085 22.8973497 11.5641999"
        />
        <polygon
          id="Fill-2839"
          fill="#777776"
          points="20.1422975 22.0050286 23.8888175 22.0050286 23.8888175 19.1944075 20.1422975 19.1944075"
        />
        <path
          d="M20.1422975,19.4842437 C20.1422975,20.221264 20.9846065,20.8178995 22.0228692,20.8178995 C23.0640567,20.8178995 23.9063656,20.221264 23.9063656,19.4842437 C23.9063656,18.7472233 23.0640567,18.1505878 22.0228692,18.1505878 C20.9846065,18.1505878 20.1422975,18.7472233 20.1422975,19.4842437"
          id="Fill-2840"
          fill="#636463"
        />
        <path
          d="M20.1422975,22.3913794 C20.1422975,23.1283997 20.9846065,23.7250352 22.0228692,23.7250352 C23.0640567,23.7250352 23.9063656,23.1283997 23.9063656,22.3913794 C23.9063656,21.6543591 23.0640567,21.0577236 22.0228692,21.0577236 C20.9846065,21.0577236 20.1422975,21.6543591 20.1422975,22.3913794"
          id="Fill-2841"
          fill="#777776"
        />
        <path
          d="M46.5814393,4.00067501 L49.6494326,5.81397898 C49.6494326,5.81397898 46.6428577,7.45501908 44.6540727,9.31511799 C42.6620705,11.1749244 40.8636824,14.2399931 40.4805489,15.2460843 C39.9073108,16.7581459 39.3136,18.6825878 39.5943697,17.7934839 L36.2924016,17.2673333 C36.2924016,17.2673333 38.111555,11.7306144 39.1088721,10.4089497 C39.1088721,10.4089497 40.6238584,8.15372604 41.9926104,6.95782282 C43.4929732,5.53028465 46.5814393,4.00067501 46.5814393,4.00067501"
          id="Fill-2856"
          fill="#DE482A"
        />
        <polyline
          id="Fill-2857"
          fill="#DE482A"
          points="46.5814393 4.00067501 46.5814393 2.3470831e-13 49.6494326 1.83377676 49.6494326 5.81397898 46.5814393 4.00067501"
        />
        <path
          d="M46.6077615,12.2746056 L46.6077615,13.8480855 L49.7459472,15.4420381 L49.7459472,11.1898403 C49.7459472,11.1898403 47.6430995,11.3328574 46.6077615,12.2746056"
          id="Fill-2858"
          fill="#DE482A"
        />
        <polyline
          id="Fill-2859"
          fill="#DE482A"
          points="46.5814393 2.3470831e-13 54.6623407 2.11454641 57.8587277 3.95124785 49.6494326 1.83377676 46.5814393 2.3470831e-13"
        />
        <path
          d="M47.8215053,12.0406308 L49.6318845,11.2597403 L49.7459472,15.4420381 L57.8587277,3.95124785 L49.6494326,1.83377676 L49.6494326,5.81397898 C49.6494326,5.81397898 47.5027147,6.9812203 46.7452216,7.54831649 C45.9877285,8.1189223 43.3584377,10.0401471 41.8434515,12.6928353 C41.8434515,12.6928353 39.5943697,15.4420381 39.5943697,20.5456114 L43.6538308,18.1941656 C43.6538308,18.1941656 43.2589985,14.2516918 47.8215053,12.0406308"
          id="Fill-2860"
          fill="#E67848"
        />
        <path
          d="M46.5814393,4.00067501 C45.7625278,4.31361618 44.928993,4.70874096 44.1042321,5.20593721 C38.318915,8.68894318 35.7571845,15.4420381 35.7571845,18.1271904 L39.5943697,20.5456114 C39.5943697,20.5456114 39.5943697,15.0007033 42.5190535,11.6516479 C43.6538308,10.3472389 43.1829567,10.2799712 43.2706972,10.1077073 C44.031115,8.58365456 45.1220221,6.49250563 46.5814393,4.00067501"
          id="Fill-2861"
          fill="#DE482A"
        />
        <path
          d="M10.8242548,19.2444196 L13.8919557,21.0577236 C13.8919557,21.0577236 10.8856732,22.6981787 8.8968882,24.5612023 C6.90517852,26.4215937 5.10649796,29.4834452 4.72336438,30.4898289 C4.15012635,32.001598 3.55641553,33.9260399 3.83689271,33.036936 L0.53521714,32.510493 C0.53521714,32.510493 2.35437048,26.9740665 3.35168767,25.6521094 C3.35168767,25.6521094 4.86959857,23.3971781 6.23542592,22.2009825 C7.73578872,20.7740292 10.8242548,19.2444196 10.8242548,19.2444196"
          id="Fill-2862"
          fill="#1A6C95"
        />
        <polyline
          id="Fill-2863"
          fill="#1A6C95"
          points="10.8242548 19.2444196 10.8242548 15.2431596 13.8919557 17.0798611 13.8919557 21.0577236 10.8242548 19.2444196"
        />
        <path
          d="M10.850577,27.5183501 L10.850577,29.09183 L13.9884703,30.6854902 L13.9884703,26.433 C13.9884703,26.433 11.8859151,26.5792342 10.850577,27.5183501"
          id="Fill-2864"
          fill="#1A6C95"
        />
        <polyline
          id="Fill-2865"
          fill="#1A6C95"
          points="10.8242548 15.2431596 18.9051563 17.357706 22.1018357 19.1944075 13.8919557 17.0798611 10.8242548 15.2431596"
        />
        <path
          d="M12.0643208,27.2843754 L13.8747001,26.5061171 L13.9884703,30.6854902 L22.1018357,19.1944075 L13.8919557,17.0798611 L13.8919557,21.0577236 C13.8919557,21.0577236 11.7455302,22.2246724 10.9880371,22.7946933 C10.230544,23.3620819 7.60125327,25.2838917 6.08626704,27.9365799 C6.08626704,27.9365799 3.83689271,30.6854902 3.83689271,35.789356 L7.89664633,33.4379102 C7.89664633,33.4379102 7.50181402,29.4954364 12.0643208,27.2843754"
          id="Fill-2866"
          fill="#2A90C3"
        />
        <path
          d="M10.8242548,19.2444196 C10.0050509,19.5573608 9.17180848,19.9519006 8.34675517,20.4490969 C2.56202303,23.9326878 4.09822713e-13,30.6854902 4.09822713e-13,33.37035 L3.83689271,35.789356 C3.83689271,35.789356 3.83689271,30.2467877 6.76186901,26.8951 C7.89957102,25.590691 7.42547977,25.5266404 7.51351275,25.3508669 C8.27393055,23.8273991 9.36454515,21.7391749 10.8242548,19.2444196"
          id="Fill-2867"
          fill="#1A6C95"
        />
      </g>
    </g>
  </svg>
)

export const step22Image1 = (
  <svg
    width="70px"
    height="70px"
    viewBox="0 0 128 128"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    aria-hidden="true"
  >
    <g
      id="4.greenenergy/greenenergy_1.1"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Group" transform="translate(24.000000, 1.600000)">
        <path
          d="M22.0073599,30.8544132 C21.2471671,30.8055935 20.6125107,30.1744242 20.6090158,29.0201865 C20.6055365,27.3951872 21.7772098,25.3970657 23.1929818,24.5807302 C24.6052666,23.7612563 25.7312586,24.4346197 25.7385967,26.0592704 C25.7420687,27.210021 25.1419348,28.5560504 24.277477,29.5394191 L24.2879384,33.078849 C24.2914255,33.8041706 23.7892798,34.6898998 23.1581105,35.0525606 C22.5265926,35.4152214 22.0178213,35.1153289 22.0178213,34.3934944 L22.0073599,30.8544132 M23.1581105,22.1536926 C19.4757086,24.2811863 16.5011927,29.4313183 16.5150923,33.6611986 C16.5256025,37.8914275 19.5210412,39.5997691 23.199956,37.472624 C26.8823579,35.3458277 29.8568739,30.1949983 29.84644,25.965118 C29.832464,21.7355865 26.8405125,20.0300347 23.1581105,22.1536926"
          id="Fill-149"
          fill="#FFFFFE"
        />
        <path
          d="M15.0854207,53.1894362 C15.0714722,53.1894362 15.0610109,53.1894362 15.0505495,53.1894362 C9.11511741,53.1685135 5.02855793,48.4535744 5.0076352,40.307655 C5.0076352,40.2623224 5.0076352,40.2169898 5.0076352,40.172006 C5.0390193,28.6645 13.1221705,14.7051978 23.1197522,8.9343579 C23.227853,8.87124097 23.3394409,8.80847276 23.447193,8.74570455 C23.454516,8.74570455 23.4580031,8.74256614 23.4614902,8.7387303 C26.2543271,7.18696055 28.8944279,6.44803918 31.2447488,6.44071623 C31.2552102,6.44071623 31.2656716,6.44071623 31.2761329,6.44071623 C31.2865943,6.44071623 31.2970557,6.44071623 31.3110042,6.44071623 C37.2460876,6.45815184 41.3291599,11.1727422 41.3539185,19.3224974 C41.3539185,19.3674813 41.3539185,19.4128139 41.3539185,19.4550081 C41.3225344,30.9621653 33.2358961,44.9246059 23.2379657,50.6961432 C23.1438133,50.7481014 23.049661,50.8038953 22.9523703,50.8562022 C22.9105248,50.8806121 22.8686793,50.9050219 22.8268339,50.9259447 C20.0615453,52.4536532 17.446203,53.1821132 15.1133177,53.1894362 C15.1025076,53.1894362 15.0958821,53.1894362 15.0854207,53.1894362 M28.6569548,14.0007989 C26.997433,14.0007989 25.1213608,14.5416517 23.1371878,15.6854281 C16.3512464,19.6049544 10.8625148,29.110503 10.8868435,36.9111972 C10.9008731,42.4348001 13.6731359,45.6255177 17.7042501,45.6255177 C19.3641207,45.6255177 21.2367058,45.0850136 23.2208788,43.9377501 C30.0099586,40.0185725 35.4955518,30.5158136 35.4746887,22.7151194 C35.4568447,17.1918652 32.6849306,14.0007989 28.6569548,14.0007989"
          id="Fill-150"
          fill="#F0A980"
        />
        <path
          d="M12.853662,59.6298037 C5.25835934,59.6263166 0.0276748049,53.6110294 -6.92779113e-13,43.1949929 C-0.0417189433,28.486308 10.3007392,10.5694699 23.1023166,3.17711779 C26.8405125,1.02172705 30.3726194,0 33.5040558,0 C41.0993585,0 46.330043,6.01528722 46.3580666,16.4313237 C46.3997855,31.1403573 36.0569786,49.0568467 23.25575,56.4498962 C19.5175541,58.6080767 15.9850985,59.6298037 12.853662,59.6298037 M15.0854207,53.1894362 L15.0854207,53.1894362 C15.0958821,53.1894362 15.1025076,53.1894362 15.1133177,53.1894362 C17.446203,53.1821132 20.0615453,52.4536532 22.8268339,50.9259447 C22.8686793,50.9050219 22.9105248,50.8806121 22.9523703,50.8562022 C23.049661,50.8038953 23.1438133,50.7481014 23.2379657,50.6961432 C33.2358961,44.9246059 41.3225344,30.9621653 41.3539185,19.4550081 C41.3539185,19.4128139 41.3539185,19.3674813 41.3539185,19.3224974 C41.3291599,11.1727422 37.2460876,6.45815184 31.3110042,6.44071623 C31.2970557,6.44071623 31.2865943,6.44071623 31.2761329,6.44071623 C31.2656716,6.44071623 31.2552102,6.44071623 31.2447488,6.44071623 C28.8944279,6.44803918 26.2543271,7.18696055 23.4614902,8.7387303 C23.4580031,8.74256614 23.454516,8.74570455 23.447193,8.74570455 C23.3394409,8.80847276 23.227853,8.87124097 23.1197522,8.9343579 C13.1221705,14.7051978 5.0390193,28.6645 5.0076352,40.172006 C5.0076352,40.2169898 5.0076352,40.2623224 5.0076352,40.307655 C5.02855793,48.4570616 9.11511741,53.1685135 15.0505495,53.1894362 C15.0610109,53.1894362 15.0714722,53.1894362 15.0854207,53.1894362"
          id="Fill-151"
          fill="#FEEEE0"
        />
        <path
          d="M15.1133177,53.1894362 C17.446203,53.1821132 20.0615453,52.4536532 22.8268339,50.9259447 C20.0615453,52.4536532 17.446203,53.1821132 15.1133177,53.1894362 M22.9653657,50.960955 C23.1027195,50.8871089 23.2356426,50.8083396 23.3685657,50.7349858 C23.2356426,50.8083396 23.1027195,50.8871089 22.9653657,50.960955 M5.0076352,40.172006 C5.0390193,28.6645 13.1221705,14.7051978 23.1197522,8.9343579 C23.227853,8.87124097 23.3394409,8.80847276 23.447193,8.74570455 C23.3394409,8.80847276 23.227853,8.87124097 23.1197522,8.9343579 C13.1221705,14.7051978 5.0390193,28.6645 5.0076352,40.172006 M41.4257162,19.5540889 C41.4257162,19.4945197 41.4257162,19.4305197 41.4257162,19.367012 C41.4257162,19.4305197 41.4257162,19.4945197 41.4257162,19.5540889 M23.4614902,8.7387303 C26.2543271,7.18696055 28.8944279,6.44803918 31.2447488,6.44071623 C28.8944279,6.44803918 26.2543271,7.18696055 23.4614902,8.7387303"
          id="Fill-152"
          fill="#EFA47A"
        />
        <path
          d="M23.1406749,15.6854281 C16.3512464,19.6084415 10.8625148,29.110503 10.8868435,36.9111972 C10.9078474,44.7122401 16.4314502,47.8607635 23.2208788,43.9415859 C30.0099586,40.0185725 35.4955518,30.5158136 35.4746887,22.7151194 C35.4537063,14.9144252 29.9301035,11.7655531 23.1406749,15.6854281"
          id="Fill-153"
          fill="#E67848"
        />
        <polyline
          id="Fill-736"
          fill="#F8F7F6"
          points="46.9193668 123.953275 80.4968744 105.185579 80.4968744 54.5807983 63.7098642 49.3427908 47.2611049 75.207131 46.9193668 123.953275"
        />
        <polyline
          id="Fill-737"
          fill="#E4E4E3"
          points="46.9263411 123.953275 13.3449976 105.185579 13.3449976 54.5807983 47.2611049 75.207131 46.9263411 123.953275"
        />
        <polyline
          id="Fill-738"
          fill="#B4B5B4"
          points="30.3973779 29.8149019 13.3449976 54.6888991 47.2576178 75.3152318 63.7098642 49.3427908 30.3973779 29.8149019"
        />
        <polyline
          id="Fill-739"
          fill="#9E9F9E"
          points="30.3973779 29.8149019 47.2611049 35.4291699 80.4968744 54.5807983 63.7098642 49.3427908 30.3973779 29.8149019"
        />
        <polyline
          id="Fill-740"
          fill="#E4E4E3"
          points="52.4848152 91.0316953 61.0317537 86.0974162 61.0317537 115.891047 52.4848152 120.647482 52.4848152 91.0316953"
        />
        <polyline
          id="Fill-741"
          fill="#E4E4E3"
          points="66.764584 83.5131093 74.5548168 79.0147206 74.5548168 95.3623534 66.764584 100.164122 66.764584 83.5131093"
        />
        <polyline
          id="Fill-742"
          fill="#FFFFFE"
          points="42.06843 90.7457512 34.282033 86.2508496 34.282033 102.594647 42.06843 107.396415 42.06843 90.7457512"
        />
        <polyline
          id="Fill-743"
          fill="#FFFFFE"
          points="27.0741497 83.5131093 19.2839169 79.0147206 19.2839169 95.3623534 27.0741497 100.164122 27.0741497 83.5131093"
        />
        <polyline
          id="Fill-744"
          fill="#2A90C3"
          points="31.3981822 34.2261125 17.9863584 54.3890065 25.239923 58.7719715 38.1771494 38.3478919 31.3981822 34.2261125"
        />
        <polyline
          id="Fill-745"
          fill="#2A90C3"
          points="40.4856248 39.6729987 27.0741497 59.8358927 34.3308527 64.2153705 47.264592 43.7947781 40.4856248 39.6729987"
        />
        <polyline
          id="Fill-746"
          fill="#2A90C3"
          points="49.6319998 45.1582432 36.8241457 65.3242756 44.0808487 69.7044509 57.014588 49.2803713 49.6319998 45.1582432"
        />
      </g>
    </g>
  </svg>
)

export const step22Image2 = (
  <svg
    width="70px"
    height="70px"
    viewBox="0 0 128 128"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    aria-hidden="true"
  >
    <g
      id="4.greenenergy/greenenergy_1.2"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Group" transform="translate(24.000000, 1.600000)">
        <path
          d="M22.0073599,30.8544132 C21.2471671,30.8055935 20.6125107,30.1744242 20.6090158,29.0201865 C20.6055365,27.3951872 21.7772098,25.3970657 23.1929818,24.5807302 C24.6052666,23.7612563 25.7312586,24.4346197 25.7385967,26.0592704 C25.7420687,27.210021 25.1419348,28.5560504 24.277477,29.5394191 L24.2879384,33.078849 C24.2914255,33.8041706 23.7892798,34.6898998 23.1581105,35.0525606 C22.5265926,35.4152214 22.0178213,35.1153289 22.0178213,34.3934944 L22.0073599,30.8544132 M23.1581105,22.1536926 C19.4757086,24.2811863 16.5011927,29.4313183 16.5150923,33.6611986 C16.5256025,37.8914275 19.5210412,39.5997691 23.199956,37.472624 C26.8823579,35.3458277 29.8568739,30.1949983 29.84644,25.965118 C29.832464,21.7355865 26.8405125,20.0300347 23.1581105,22.1536926"
          id="Fill-149"
          fill="#FFFFFE"
        />
        <path
          d="M15.0854207,53.1894362 C15.0714722,53.1894362 15.0610109,53.1894362 15.0505495,53.1894362 C9.11511741,53.1685135 5.02855793,48.4535744 5.0076352,40.307655 C5.0076352,40.2623224 5.0076352,40.2169898 5.0076352,40.172006 C5.0390193,28.6645 13.1221705,14.7051978 23.1197522,8.9343579 C23.227853,8.87124097 23.3394409,8.80847276 23.447193,8.74570455 C23.454516,8.74570455 23.4580031,8.74256614 23.4614902,8.7387303 C26.2543271,7.18696055 28.8944279,6.44803918 31.2447488,6.44071623 C31.2552102,6.44071623 31.2656716,6.44071623 31.2761329,6.44071623 C31.2865943,6.44071623 31.2970557,6.44071623 31.3110042,6.44071623 C37.2460876,6.45815184 41.3291599,11.1727422 41.3539185,19.3224974 C41.3539185,19.3674813 41.3539185,19.4128139 41.3539185,19.4550081 C41.3225344,30.9621653 33.2358961,44.9246059 23.2379657,50.6961432 C23.1438133,50.7481014 23.049661,50.8038953 22.9523703,50.8562022 C22.9105248,50.8806121 22.8686793,50.9050219 22.8268339,50.9259447 C20.0615453,52.4536532 17.446203,53.1821132 15.1133177,53.1894362 C15.1025076,53.1894362 15.0958821,53.1894362 15.0854207,53.1894362 M28.6569548,14.0007989 C26.997433,14.0007989 25.1213608,14.5416517 23.1371878,15.6854281 C16.3512464,19.6049544 10.8625148,29.110503 10.8868435,36.9111972 C10.9008731,42.4348001 13.6731359,45.6255177 17.7042501,45.6255177 C19.3641207,45.6255177 21.2367058,45.0850136 23.2208788,43.9377501 C30.0099586,40.0185725 35.4955518,30.5158136 35.4746887,22.7151194 C35.4568447,17.1918652 32.6849306,14.0007989 28.6569548,14.0007989"
          id="Fill-150"
          fill="#F0A980"
        />
        <path
          d="M12.853662,59.6298037 C5.25835934,59.6263166 0.0276748049,53.6110294 -6.92779167e-13,43.1949929 C-0.0417189433,28.486308 10.3007392,10.5694699 23.1023166,3.17711779 C26.8405125,1.02172705 30.3726194,0 33.5040558,0 C41.0993585,0 46.330043,6.01528722 46.3580666,16.4313237 C46.3997855,31.1403573 36.0569786,49.0568467 23.25575,56.4498962 C19.5175541,58.6080767 15.9850985,59.6298037 12.853662,59.6298037 M15.0854207,53.1894362 L15.0854207,53.1894362 C15.0958821,53.1894362 15.1025076,53.1894362 15.1133177,53.1894362 C17.446203,53.1821132 20.0615453,52.4536532 22.8268339,50.9259447 C22.8686793,50.9050219 22.9105248,50.8806121 22.9523703,50.8562022 C23.049661,50.8038953 23.1438133,50.7481014 23.2379657,50.6961432 C33.2358961,44.9246059 41.3225344,30.9621653 41.3539185,19.4550081 C41.3539185,19.4128139 41.3539185,19.3674813 41.3539185,19.3224974 C41.3291599,11.1727422 37.2460876,6.45815184 31.3110042,6.44071623 C31.2970557,6.44071623 31.2865943,6.44071623 31.2761329,6.44071623 C31.2656716,6.44071623 31.2552102,6.44071623 31.2447488,6.44071623 C28.8944279,6.44803918 26.2543271,7.18696055 23.4614902,8.7387303 C23.4580031,8.74256614 23.454516,8.74570455 23.447193,8.74570455 C23.3394409,8.80847276 23.227853,8.87124097 23.1197522,8.9343579 C13.1221705,14.7051978 5.0390193,28.6645 5.0076352,40.172006 C5.0076352,40.2169898 5.0076352,40.2623224 5.0076352,40.307655 C5.02855793,48.4570616 9.11511741,53.1685135 15.0505495,53.1894362 C15.0610109,53.1894362 15.0714722,53.1894362 15.0854207,53.1894362"
          id="Fill-151"
          fill="#FEEEE0"
        />
        <path
          d="M15.1133177,53.1894362 C17.446203,53.1821132 20.0615453,52.4536532 22.8268339,50.9259447 C20.0615453,52.4536532 17.446203,53.1821132 15.1133177,53.1894362 M22.9653657,50.960955 C23.1027195,50.8871089 23.2356426,50.8083396 23.3685657,50.7349858 C23.2356426,50.8083396 23.1027195,50.8871089 22.9653657,50.960955 M5.0076352,40.172006 C5.0390193,28.6645 13.1221705,14.7051978 23.1197522,8.9343579 C23.227853,8.87124097 23.3394409,8.80847276 23.447193,8.74570455 C23.3394409,8.80847276 23.227853,8.87124097 23.1197522,8.9343579 C13.1221705,14.7051978 5.0390193,28.6645 5.0076352,40.172006 M41.4257162,19.5540889 C41.4257162,19.4945197 41.4257162,19.4305197 41.4257162,19.367012 C41.4257162,19.4305197 41.4257162,19.4945197 41.4257162,19.5540889 M23.4614902,8.7387303 C26.2543271,7.18696055 28.8944279,6.44803918 31.2447488,6.44071623 C28.8944279,6.44803918 26.2543271,7.18696055 23.4614902,8.7387303"
          id="Fill-152"
          fill="#EFA47A"
        />
        <path
          d="M23.1406749,15.6854281 C16.3512464,19.6084415 10.8625148,29.110503 10.8868435,36.9111972 C10.9078474,44.7122401 16.4314502,47.8607635 23.2208788,43.9415859 C30.0099586,40.0185725 35.4955518,30.5158136 35.4746887,22.7151194 C35.4537063,14.9144252 29.9301035,11.7655531 23.1406749,15.6854281"
          id="Fill-153"
          fill="#E67848"
        />
        <polyline
          id="Fill-736"
          fill="#F8F7F6"
          points="46.9193668 123.953275 80.4968744 105.185579 80.4968744 54.5807983 63.7098642 49.3427908 47.2611049 75.207131 46.9193668 123.953275"
        />
        <polyline
          id="Fill-737"
          fill="#E4E4E3"
          points="46.9263411 123.953275 13.3449976 105.185579 13.3449976 54.5807983 47.2611049 75.207131 46.9263411 123.953275"
        />
        <polyline
          id="Fill-738"
          fill="#B4B5B4"
          points="30.3973779 29.8149019 13.3449976 54.6888991 47.2576178 75.3152318 63.7098642 49.3427908 30.3973779 29.8149019"
        />
        <polyline
          id="Fill-739"
          fill="#9E9F9E"
          points="30.3973779 29.8149019 47.2611049 35.4291699 80.4968744 54.5807983 63.7098642 49.3427908 30.3973779 29.8149019"
        />
        <polyline
          id="Fill-740"
          fill="#E4E4E3"
          points="52.4848152 91.0316953 61.0317537 86.0974162 61.0317537 115.891047 52.4848152 120.647482 52.4848152 91.0316953"
        />
        <polyline
          id="Fill-741"
          fill="#E4E4E3"
          points="66.764584 83.5131093 74.5548168 79.0147206 74.5548168 95.3623534 66.764584 100.164122 66.764584 83.5131093"
        />
        <polyline
          id="Fill-742"
          fill="#FFFFFE"
          points="42.06843 90.7457512 34.282033 86.2508496 34.282033 102.594647 42.06843 107.396415 42.06843 90.7457512"
        />
        <polyline
          id="Fill-743"
          fill="#FFFFFE"
          points="27.0741497 83.5131093 19.2839169 79.0147206 19.2839169 95.3623534 27.0741497 100.164122 27.0741497 83.5131093"
        />
      </g>
    </g>
  </svg>
)

export const step24Image1 = (
  <svg
    width="70px"
    height="70px"
    viewBox="0 0 128 128"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    aria-hidden="true"
  >
    <g
      id="4.greenenergy/greenenergy_2.1"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Group" transform="translate(20.800000, 3.200000)">
        <polyline
          id="Fill-2749"
          fill="#F8F7F6"
          points="31.1674953 49.8759924 31.1674953 122.733479 85.1506213 91.5611841 85.1506213 18.7031638 31.1674953 49.8759924"
        />
        <path
          d="M31.1674953,49.4978652 L31.1674953,122.360685 C40.3460134,119.789527 52.537816,115.2728 65.364275,107.006267 C73.5348093,101.736486 80.0787034,96.163243 85.1506213,91.1878568 L85.1506213,18.3303699 C80.1213694,23.2742898 73.6628073,28.7888672 65.6042711,34.0095827 C52.6972801,42.3721139 40.4046791,46.9213736 31.1674953,49.4978652"
          id="Fill-2750"
          fill="#E4E4E3"
        />
        <polyline
          id="Fill-2751"
          fill="#C7C5BD"
          points="31.1674953 49.8759924 31.1674953 122.733479 7.45651906e-13 104.494308 7.45651906e-13 31.6314878 31.1674953 49.8759924"
        />
        <path
          d="M52.7618124,2.13998753e-13 L85.1506213,18.7031638 C79.1293854,24.3830719 70.8255199,31.1722953 60.0411612,37.4073943 C49.2045366,43.6739595 39.1246998,47.492031 31.1674953,49.8759924 L-1.20374299e-13,31.6314878 L52.7618124,2.13998753e-13"
          id="Fill-2752"
          fill="#C7C5BD"
        />
        <polyline
          id="Fill-2753"
          fill="#9E9F9E"
          points="77.1294178 49.2632023 77.1240846 42.4201131 44.5806115 61.2144755 44.5806115 68.0196986 77.1294178 49.2632023"
        />
        <path
          d="M77.1240846,49.2312029 L44.5806115,68.0196986 L44.5806115,61.2144755 L77.1240846,42.4201131 L77.1240846,49.2312029 Z M41.9721204,58.201191 L41.9721204,84.2701022 L79.7373756,62.4629886 L79.7373756,36.3935441 L41.9721204,58.201191 L41.9721204,58.201191 Z"
          id="Fill-2754"
          fill="#F8F7F6"
        />
        <polyline
          id="Fill-2755"
          fill="#B4B5B4"
          points="41.9721204 84.2701022 39.6953573 82.9367904 39.6953573 56.7078818 77.1240846 35.0074332 79.7373756 36.3935441 48.5805467 54.3825861 41.9721204 58.201191"
        />
        <polyline
          id="Fill-2756"
          fill="#9E9F9E"
          points="77.1294178 59.9451627 77.1240846 53.1026068 44.5806115 71.8975025 44.5806115 78.7021923 77.1294178 59.9451627"
        />
        <polyline
          id="Fill-2757"
          fill="#777776"
          points="50.4578497 64.2810925 50.4519831 58.3883879 45.887257 61.0011456 45.887257 66.8789171 50.4578497 64.2810925"
        />
        <polyline
          id="Fill-2758"
          fill="#777776"
          points="55.8278961 61.203809 55.8230961 55.3057712 51.2578367 57.9190622 51.2578367 63.8011003 55.8278961 61.203809"
        />
        <polyline
          id="Fill-2759"
          fill="#777776"
          points="61.4710047 57.9771946 61.4656714 52.0839567 56.900412 54.697781 56.900412 60.5750192 61.4710047 57.9771946"
        />
        <polyline
          id="Fill-2760"
          fill="#777776"
          points="66.8629174 54.7564467 66.8629174 48.8573422 62.2971246 51.4706333 62.2971246 57.3532047 66.8629174 54.7564467"
        />
        <polyline
          id="Fill-2761"
          fill="#777776"
          points="72.25963 51.6791632 72.2548301 45.7859253 67.6895707 48.3992163 67.6895707 54.2759212 72.25963 51.6791632"
        />
        <polyline
          id="Fill-2762"
          fill="#E67848"
          points="72.9694852 45.3005998 72.9694852 51.2738365 75.283581 49.9565245 75.283581 43.9027558 72.9694852 45.3005998"
        />
        <path
          d="M61.4443384,100.925833 C58.6550503,102.680471 56.0412259,103.043665 54.1217903,102.125813 L51.0711731,107.45426 L51.0279738,97.5877532 L59.9190298,91.9926438 L56.1958901,98.4944052 C57.5718678,99.1503946 59.4390376,98.8943987 61.4278054,97.6410857 C65.5136059,95.0699273 68.820219,89.2945542 68.798886,84.7612942 C68.777553,80.227501 65.4389404,78.6275269 61.3590065,81.1986853 C59.3803719,82.4413318 57.5244019,84.4679657 56.1324245,86.8999263 L54.2764545,85.64128 C56.2278896,82.2328018 58.5750516,79.6520436 61.3430068,77.9075385 C67.0597142,74.3129301 71.7321719,76.5475606 71.7589527,82.8946578 C71.7855043,89.2412217 67.156246,97.331224 61.4443384,100.925833"
          id="Fill-2781"
          fill="#E67848"
        />
        <path
          d="M56.5697507,87.1985881 L55.8598955,86.7127293 L59.4870368,80.9368228 L66.1909283,79.1293854 L68.0895642,80.4461641 C68.0895642,80.4461641 60.8043488,82.617329 60.463021,84.1474375 C60.1264931,85.6786127 56.5697507,87.1985881 56.5697507,87.1985881"
          id="Fill-2782"
          fill="#E67848"
        />
        <path
          d="M68.6762213,76.7294243 L71.5348417,78.1427347 C71.5348417,78.1427347 70.1481975,77.694742 69.2682118,77.5022118 C68.3828928,77.3155481 68.6762213,76.7294243 68.6762213,76.7294243"
          id="Fill-2783"
          fill="#E67848"
        />
        <polyline
          id="Fill-2784"
          fill="#E67848"
          points="71.9716347 86.2119374 70.7295214 92.6912992 64.4682895 99.4271901 63.9717642 98.9471979 68.862885 90.8945283 71.129515 85.7314119 71.9716347 86.2119374"
        />
        <polyline
          id="Fill-2785"
          fill="#E67848"
          points="62.4629886 93.2998226 59.9190298 91.9926438 51.0711731 107.45426 53.6151319 108.760906 62.4629886 93.2998226"
        />
        <path
          d="M63.982964,102.232478 C61.1990091,103.98765 58.5857181,104.35031 56.6657492,103.432459 L53.6151319,108.760906 L53.5719326,98.8943987 L62.4629886,93.2998226 L58.7398489,99.8005174 C60.1158266,100.456507 61.9829964,100.200511 63.9717642,98.9471979 C68.0575647,96.3765728 71.3588446,90.6006664 71.3428448,86.0679397 C71.3215118,81.5341465 67.9828992,79.9341724 63.8970987,82.5053308 C61.9243307,83.747444 60.0683607,85.7746112 58.6763833,88.2065718 L56.5697507,87.1985881 C58.5158525,83.7959765 61.1190104,80.9581558 63.8869656,79.2141841 C69.6042063,75.6195756 74.2761307,77.8547394 74.3029616,84.20077 C74.3347964,90.5473339 69.7002048,98.6384029 63.982964,102.232478"
          id="Fill-2786"
          fill="#DE482A"
        />
      </g>
    </g>
  </svg>
)

export const step24Image2 = (
  <svg
    width="70px"
    height="70px"
    viewBox="0 0 128 128"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    aria-hidden="true"
  >
    <g
      id="4.greenenergy/greenenergy_2.2"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Group" transform="translate(19.200000, 1.600000)">
        <polyline
          id="Fill-2748"
          fill="#E67848"
          points="80.1107029 19.6903478 72.8249542 24.2497407 77.0062198 22.3089721 80.1107029 19.6903478"
        />
        <polyline
          id="Fill-2763"
          fill="#F8F7F6"
          points="32.2714775 51.6359639 32.2714775 127.069409 88.1639058 94.7984651 88.1639058 19.3591532 32.2714775 51.6359639"
        />
        <path
          d="M32.2714775,51.2466369 L32.2714775,126.685949 C41.7753236,124.024658 54.3991192,119.346868 67.6735709,110.787539 C76.1369005,105.336428 82.9106575,99.5658545 88.1639058,94.4086047 L88.1639058,18.9756928 C82.9586568,24.0902766 76.2654318,29.8021841 67.9237002,35.2095632 C54.5591166,43.8654231 41.8339893,48.5805467 32.2714775,51.2466369"
          id="Fill-2764"
          fill="#E4E4E3"
        />
        <polyline
          id="Fill-2765"
          fill="#C7C5BD"
          points="32.2714775 51.6359639 32.2714775 127.069409 0 108.184382 0 32.7461365 32.2714775 51.6359639"
        />
        <path
          d="M54.6284488,0 L88.1639058,19.3591532 C81.9293401,25.2417246 73.332146,32.2709441 62.1643268,38.7247063 C50.9431751,45.2147346 40.5054775,49.1666706 32.2714775,51.6359639 L0,32.7461365 L54.6284488,0"
          id="Fill-2766"
          fill="#C7C5BD"
        />
        <polyline
          id="Fill-2767"
          fill="#9E9F9E"
          points="79.8600403 51.0018409 79.854707 43.9192889 46.1592526 63.3749739 46.1592526 70.4201931 79.8600403 51.0018409"
        />
        <path
          d="M79.854707,50.9645081 L46.1592526,70.4201931 L46.1592526,63.3749739 L79.854707,43.9192889 L79.854707,50.9645081 Z M43.4552964,60.254491 L43.4552964,87.246054 L82.5586632,64.6704195 L82.5586632,37.6788566 L43.4552964,60.254491 L43.4552964,60.254491 Z"
          id="Fill-2768"
          fill="#F8F7F6"
        />
        <polyline
          id="Fill-2769"
          fill="#B4B5B4"
          points="43.4552964 87.246054 41.1033345 85.864743 41.1033345 58.7083827 79.854707 36.2447465 82.5586632 37.6788566 50.3031855 56.302555 43.4552964 60.254491"
        />
        <polyline
          id="Fill-2770"
          fill="#9E9F9E"
          points="79.8600403 62.0576618 79.854707 54.9804431 46.1592526 74.4355948 46.1592526 81.4813473 79.8600403 62.0576618"
        />
        <polyline
          id="Fill-2771"
          fill="#777776"
          points="52.2386208 66.5535891 52.2386208 60.4464879 47.513364 63.1563107 47.513364 69.2410122 52.2386208 66.5535891"
        />
        <polyline
          id="Fill-2772"
          fill="#777776"
          points="57.8017308 63.3643074 57.8017308 57.2630728 53.0711407 59.9664957 53.0711407 66.0575971 57.8017308 63.3643074"
        />
        <polyline
          id="Fill-2773"
          fill="#777776"
          points="63.6469694 60.0256947 63.6416362 53.919127 58.9110461 56.6278831 58.9110461 62.7136512 63.6469694 60.0256947"
        />
        <polyline
          id="Fill-2774"
          fill="#777776"
          points="69.230879 56.6870821 69.230879 50.5805143 64.500289 53.2898038 64.500289 59.3750386 69.230879 56.6870821"
        />
        <polyline
          id="Fill-2775"
          fill="#777776"
          points="74.8147886 53.5084669 74.8147886 47.4018991 70.0841986 50.105322 70.0841986 56.1964234 74.8147886 53.5084669"
        />
        <polyline
          id="Fill-2776"
          fill="#E67848"
          points="75.5502434 46.9005739 75.5502434 53.0818072 77.9502045 51.7159626 77.9502045 45.4547307 75.5502434 46.9005739"
        />
        <path
          d="M63.3856403,80.4034981 C60.7456831,82.0626713 58.2763897,84.8306264 56.4737523,87.9767088 L53.5617994,86.5799315 L53.6044654,95.9285801 L62.0203291,90.6326658 L58.4630534,88.9318934 C59.7536992,86.6812631 61.5131373,84.7020952 63.3963068,83.5186477 C67.2682441,81.0866871 70.4308596,82.6013292 70.4468593,86.8940597 C70.4681923,91.1878568 67.3322431,96.6592349 63.465639,99.0970621 C61.593136,100.27571 59.8283646,100.569038 58.4945195,99.9338486 L56.5217515,103.384459 C58.3825214,104.275645 60.857148,103.859118 63.4763055,102.211678 C68.8943511,98.8032002 73.2788135,91.1398576 73.2522683,85.128755 C73.2249477,79.1133857 68.798886,76.9960866 63.3856403,80.4034981"
          id="Fill-2777"
          fill="#2A90C3"
        />
        <polyline
          id="Fill-2778"
          fill="#2A90C3"
          points="53.6044654 95.9285801 55.7857634 97.2890914 64.2064271 91.9926438 62.0203291 90.6326658 59.9296963 89.6305487 67.5930389 82.6013292 60.3350231 84.4727656 57.2844058 88.6812308 53.6044654 95.9285801"
        />
        <polyline
          id="Fill-2779"
          fill="#2A90C3"
          points="58.7083827 104.744971 56.5217515 103.384459 58.4945195 99.9338486 59.5297028 100.920499 65.4229407 99.2623928 71.3689777 87.9340429 73.2521473 89.7692131 70.3401944 97.8325493 63.7909671 103.006332 58.7083827 104.744971"
        />
        <path
          d="M65.5722716,81.7640094 C62.9269811,83.4274492 60.463021,86.1900711 58.6603835,89.3366868 L55.7484307,87.9452427 L55.7857634,97.2890914 L64.2064271,91.9926438 L60.6496846,90.291338 C61.9349972,88.0407078 63.6944353,86.0679397 65.5824048,84.8780923 C69.4495422,82.4461317 72.6121576,83.9607739 72.6334906,88.2540377 C72.6494903,92.5473015 69.5188744,98.0250795 65.6522703,100.45704 C63.7803006,101.635154 62.0149959,101.928483 60.6811508,101.293827 L58.7083827,104.744971 C60.5691526,105.63509 63.0443125,105.21963 65.6629368,103.571123 C71.0809824,100.163712 75.4654448,92.4998356 75.4383711,86.4892663 C75.4121123,80.4781636 70.9855173,78.3560646 65.5722716,81.7640094"
          id="Fill-2780"
          fill="#1A6C95"
        />
      </g>
    </g>
  </svg>
)

export const step25Image1 = (
  <svg
    width="70px"
    height="70px"
    viewBox="0 0 128 128"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    aria-hidden="true"
  >
    <g
      id="4.greenenergy/greenenergy_3.1"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Group" transform="translate(20.800000, 3.200000)">
        <polyline
          id="Fill-2749"
          fill="#F8F7F6"
          points="31.1674953 49.8759924 31.1674953 122.733479 85.1506213 91.5611841 85.1506213 18.7031638 31.1674953 49.8759924"
        />
        <path
          d="M31.1674953,49.4978652 L31.1674953,122.360685 C40.3460134,119.789527 52.537816,115.2728 65.364275,107.006267 C73.5348093,101.736486 80.0787034,96.163243 85.1506213,91.1878568 L85.1506213,18.3303699 C80.1213694,23.2742898 73.6628073,28.7888672 65.6042711,34.0095827 C52.6972801,42.3721139 40.4046791,46.9213736 31.1674953,49.4978652"
          id="Fill-2750"
          fill="#E4E4E3"
        />
        <polyline
          id="Fill-2751"
          fill="#C7C5BD"
          points="31.1674953 49.8759924 31.1674953 122.733479 7.45651906e-13 104.494308 7.45651906e-13 31.6314878 31.1674953 49.8759924"
        />
        <path
          d="M52.7618124,2.13998753e-13 L85.1506213,18.7031638 C79.1293854,24.3830719 70.8255199,31.1722953 60.0411612,37.4073943 C49.2045366,43.6739595 39.1246998,47.492031 31.1674953,49.8759924 L-1.20374299e-13,31.6314878 L52.7618124,2.13998753e-13"
          id="Fill-2752"
          fill="#C7C5BD"
        />
        <polyline
          id="Fill-2753"
          fill="#9E9F9E"
          points="77.1294178 49.2632023 77.1240846 42.4201131 44.5806115 61.2144755 44.5806115 68.0196986 77.1294178 49.2632023"
        />
        <path
          d="M77.1240846,49.2312029 L44.5806115,68.0196986 L44.5806115,61.2144755 L77.1240846,42.4201131 L77.1240846,49.2312029 Z M41.9721204,58.201191 L41.9721204,84.2701022 L79.7373756,62.4629886 L79.7373756,36.3935441 L41.9721204,58.201191 L41.9721204,58.201191 Z"
          id="Fill-2754"
          fill="#F8F7F6"
        />
        <polyline
          id="Fill-2755"
          fill="#B4B5B4"
          points="41.9721204 84.2701022 39.6953573 82.9367904 39.6953573 56.7078818 77.1240846 35.0074332 79.7373756 36.3935441 48.5805467 54.3825861 41.9721204 58.201191"
        />
        <polyline
          id="Fill-2756"
          fill="#9E9F9E"
          points="77.1294178 59.9451627 77.1240846 53.1026068 44.5806115 71.8975025 44.5806115 78.7021923 77.1294178 59.9451627"
        />
        <polyline
          id="Fill-2757"
          fill="#777776"
          points="50.4578497 64.2810925 50.4519831 58.3883879 45.887257 61.0011456 45.887257 66.8789171 50.4578497 64.2810925"
        />
        <polyline
          id="Fill-2758"
          fill="#777776"
          points="55.8278961 61.203809 55.8230961 55.3057712 51.2578367 57.9190622 51.2578367 63.8011003 55.8278961 61.203809"
        />
        <polyline
          id="Fill-2759"
          fill="#777776"
          points="61.4710047 57.9771946 61.4656714 52.0839567 56.900412 54.697781 56.900412 60.5750192 61.4710047 57.9771946"
        />
        <polyline
          id="Fill-2760"
          fill="#777776"
          points="66.8629174 54.7564467 66.8629174 48.8573422 62.2971246 51.4706333 62.2971246 57.3532047 66.8629174 54.7564467"
        />
        <polyline
          id="Fill-2761"
          fill="#777776"
          points="72.25963 51.6791632 72.2548301 45.7859253 67.6895707 48.3992163 67.6895707 54.2759212 72.25963 51.6791632"
        />
        <polyline
          id="Fill-2762"
          fill="#E67848"
          points="72.9694852 45.3005998 72.9694852 51.2738365 75.283581 49.9565245 75.283581 43.9027558 72.9694852 45.3005998"
        />
      </g>
      <polyline
        id="Fill-1900"
        fill="#E67848"
        points="77.6696814 108.8 89.6 85.6581249 82.0038316 91.8810243 84.1480953 81.6 76.8 99.7333333 82.4882869 94.2930455 77.6696814 108.8"
      />
    </g>
  </svg>
)

export const step25Image2 = (
  <svg
    width="70px"
    height="70px"
    viewBox="0 0 128 128"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    aria-hidden="true"
  >
    <g
      id="4.greenenergy/greenenergy_3.2"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Group" transform="translate(38.400000, 1.600000)">
        <path
          d="M18.4109755,121.003262 L11.7677175,26.893098 C11.7083162,26.3397277 11.3862984,25.845446 10.9048349,25.5675103 L2.61365883,20.7994587 C1.45064318,20.1304121 1.27407663e-13,20.9682836 1.27407663e-13,22.3095033 L1.27407663e-13,114.240888 C1.27407663e-13,116.595057 1.25336821,118.767895 3.29208463,119.943417 L7.12503406,122.157211 L12.1616422,125.06475"
          id="Fill-1901"
          fill="#C7C5BD"
        />
        <path
          d="M41.565304,5.9678828 L12.9710635,22.4783281 C10.7829059,23.7445145 9.43230704,26.0830514 9.43230704,28.6126104 L9.43230704,118.142618 C9.43230704,125.867918 15.12827,128.03169 21.0030622,124.823705 L48.649695,108.860378 C50.8381653,107.594191 52.1887642,105.258781 52.1887642,102.726721 L52.1887642,12.1018524 C52.1887642,6.64974763 46.2861471,3.24167407 41.565304,5.9678828"
          id="Fill-1902"
          fill="#E4E4E3"
        />
        <path
          d="M47.2928434,5.20535722 L38.4764345,0.143425387 C38.1419112,-0.0472841683 37.7323546,-0.0472841683 37.3947049,0.140299001 L0.947295007,20.7588157 C0.199776076,21.1840042 1.61946803,21.5028956 2.37917987,21.9061994 L11.2424846,26.614537 C11.5676288,26.7896146 11.9615534,26.7833619 12.2835712,26.6051578 L48.8310254,6.74353921 C49.5688526,6.33085624 48.0275442,5.62741935 47.2928434,5.20535722"
          id="Fill-1903"
          fill="#E4E4E3"
        />
        <path
          d="M8.2911761,85.678537 L9.43230704,86.1912643 L20.0839047,94.0569392 L20.0839047,119.696745 C20.0839047,122.350734 19.211643,128.140801 13.3305979,125.742863 L6.41190538,121.809869 C5.83071019,121.475346 5.47398953,120.856321 5.47398953,120.184461 L5.47398953,87.3039451 C5.47398953,85.8595547 7.03749525,84.9560291 8.2911761,85.678537"
          id="Fill-1904"
          fill="#DE482A"
        />
        <path
          d="M45.1575217,14.4497685 C47.6802027,14.7064448 49.3843958,18.2858443 48.9623337,22.4408115 C48.5402715,26.5957787 46.1517125,29.7599941 43.6287189,29.5001914 C41.1025988,29.2441404 39.4018448,25.667242 39.8239069,21.5125874 C40.245969,17.3544938 42.6345281,14.1934048 45.1575217,14.4497685"
          id="Fill-1905"
          fill="#777776"
        />
        <path
          d="M33.2613097,44.9417253 C34.205791,44.9417253 34.9717556,45.7073773 34.9717556,46.6515459 C34.9717556,47.5957145 34.205791,48.3616791 33.2613097,48.3616791 C32.3174537,48.3616791 31.5514891,47.5957145 31.5514891,46.6515459 C31.5514891,45.7073773 32.3174537,44.9417253 33.2613097,44.9417253"
          id="Fill-1906"
          fill="#E67848"
        />
        <polyline
          id="Fill-1907"
          fill="#9E9F9E"
          points="36.7819332 30.0754465 36.7756804 20.4961993 24.814127 27.2463796 24.814127 36.7815448 36.7819332 30.0754465"
        />
        <path
          d="M44.7757899,18.2139374 C46.0360362,18.3421192 46.8895396,20.1304121 46.6769454,22.2097715 C46.4643511,24.2853793 45.2700716,25.8673307 44.010138,25.7391489 C42.747078,25.610967 41.8963883,23.8226742 42.1061688,21.74394 C42.3187631,19.6645806 43.5130426,18.0857556 44.7757899,18.2139374"
          id="Fill-1908"
          fill="#636463"
        />
        <path
          d="M24.0759872,77.809423 L9.43230704,86.1912643 L9.43230704,119.506035 C9.43230704,122.804373 12.5274293,128.41905 19.8306674,125.44273 L26.4054575,122.131887 C27.1276527,121.71639 27.5715995,120.947299 27.5715995,120.115368 L27.5715995,79.8290685 C27.5715995,78.0342102 25.6301137,76.9152766 24.0759872,77.809423"
          id="Fill-1909"
          fill="#E67848"
        />
        <path
          d="M18.977164,76.0989771 L14.3000903,78.7970484 C13.9405559,79.0068289 13.7213962,79.3879354 13.7213962,79.8006184 L13.7213962,94.4477375 C13.7213962,95.7107975 14.6530593,96.0640792 15.6131725,95.5391589 L20.1370533,92.9283138 C20.4934613,92.722285 20.7151221,92.3408659 20.7151221,91.9250565 L20.7151221,77.1025471 C20.7151221,76.2087133 19.7493814,75.6522166 18.977164,76.0989771"
          id="Fill-1910"
          fill="#E67848"
        />
      </g>
    </g>
  </svg>
)

export const step27Image1 = (
  <svg
    width="70px"
    height="70px"
    viewBox="0 0 128 128"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    aria-hidden="true"
  >
    <g
      id="5.climate/climate_1.2"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Group" transform="translate(3.200000, 0.000000)">
        <path
          d="M11.5230288,14.6480448 C10.4230414,14.5804528 9.50642253,13.6627185 9.49972146,11.9934415 C9.49526873,9.6366445 11.1906457,6.74334995 13.2407133,5.55903994 C15.2927886,4.37495301 16.9259273,5.34667167 16.9326367,7.70302251 C16.9370811,9.37252263 16.0693158,11.3201984 14.81786,12.7467688 L14.8312445,17.8757302 C14.835706,18.9257485 14.1062478,20.2064273 13.1914135,20.7340018 C12.2768023,21.2617994 11.5408748,20.8270245 11.5386441,19.7770062 L11.5230288,14.6480448 M13.1938673,2.04492512 C7.86012231,5.12426499 3.54806496,12.5912849 3.56585584,18.7202956 C3.58375711,24.8490831 7.92258356,27.3218796 13.2563286,24.2423167 C18.5920813,21.1611922 22.8999002,13.6961799 22.8821094,7.56694621 C22.8664388,1.43815864 18.5298431,-1.0357532 13.1938673,2.04492512"
          id="Fill-111"
          fill="#FFFFFE"
        />
        <polyline
          id="Fill-2851"
          fill="#E4E4E3"
          points="44.4378793 127.515086 0.70830862 102.771506 0.70830862 50.159499 44.8773389 75.8397747 44.4378793 127.515086"
        />
        <polyline
          id="Fill-2852"
          fill="#F8F7F6"
          points="88.1161426 50.159499 88.0713043 102.802737 120.749918 83.2972024 120.749918 31.2317311 88.1161426 50.159499"
        />
        <polyline
          id="Fill-2853"
          fill="#75B86A"
          points="77.5021908 5.63220884 120.749918 31.2317311 44.6698783 75.8397747 0.70830862 50.159499 77.5021908 5.63220884"
        />
        <polyline
          id="Fill-2854"
          fill="#F8F7F6"
          points="44.8773389 75.8397747 44.4311871 127.515086 88.1605347 102.771506 88.1605347 50.159499"
        />
        <polyline
          id="Fill-2855"
          fill="#E4E4E3"
          points="97.4538771 60.7435587 114.900867 50.6926504 114.900867 72.2457988 97.4538771 82.6969052 97.4538771 60.7435587"
        />
        <polyline
          id="Fill-2856"
          fill="#FFFFFF"
          points="36.8843059 84.6577424 26.7390366 78.7286078 26.7390366 100.281979 36.8843059 106.612874 36.8843059 84.6577424"
        />
        <polyline
          id="Fill-2857"
          fill="#FFFFFF"
          points="17.3520023 75.1212472 7.20874065 69.1896588 7.20874065 90.7432532 17.3520023 97.0741476 17.3520023 75.1212472"
        />
        <polyline
          id="Fill-2858"
          fill="#E4E4E3"
          points="50.4453136 85.0349638 61.5768015 78.5253856 61.5768015 117.813515 50.4453136 124.084179 50.4453136 85.0349638"
        />
        <polyline
          id="Fill-2859"
          fill="#2A90C3"
          points="69.0431523 75.1212472 79.1861908 69.1896588 79.1861908 90.7432532 69.0431523 97.0741476 69.0431523 75.1212472"
        />
        <path
          d="M67.6400048,37.8403549 C68.0772336,37.5867176 68.7910765,37.5867176 69.2283053,37.8403549 C69.6675417,38.0937692 69.6675417,38.5051212 69.2283053,38.7580892 C68.7910765,39.0115035 68.0772336,39.0115035 67.6400048,38.7580892 C67.2003222,38.5051212 67.2003222,38.0937692 67.6400048,37.8403549 Z M40.9534336,40.7874108 C41.3926701,40.5337735 42.1042822,40.5337735 42.5439649,40.7874108 C42.9832013,41.040825 42.9832013,41.4519539 42.5439649,41.7053682 C42.1042822,41.9587824 41.3926701,41.9587824 40.9534336,41.7053682 C40.5162048,41.4519539 40.5162048,41.040825 40.9534336,40.7874108 Z M78.9008767,24.7959911 C79.3381055,24.5425768 80.0519484,24.5425768 80.4891772,24.7959911 C80.9286368,25.0491822 80.9286368,25.4605342 80.4891772,25.7141715 C80.0519484,25.9673627 79.3381055,25.9673627 78.9008767,25.7141715 C78.4614172,25.4605342 78.4614172,25.0491822 78.9008767,24.7959911 Z M100.559317,30.7724178 C100.996323,30.5190036 101.710389,30.5190036 102.147617,30.7724178 C102.587077,31.0256089 102.587077,31.4369609 102.147617,31.6905982 C101.710389,31.9437894 100.996323,31.9437894 100.559317,31.6905982 C100.119857,31.4369609 100.119857,31.0256089 100.559317,30.7724178 Z M98.7568635,20.2579578 C99.1963231,20.0040974 99.9079352,20.0040974 100.347395,20.2579578 C100.786631,20.5107028 100.786631,20.9222779 100.347395,21.175469 C99.9079352,21.4293294 99.1963231,21.4293294 98.7568635,21.175469 C98.3194117,20.9222779 98.3194117,20.5107028 98.7568635,20.2579578 Z M94.8661966,31.7445826 C95.3058792,31.4909453 96.0174914,31.4909453 96.4569509,31.7445826 C96.8941797,31.9979968 96.8941797,32.4093488 96.4569509,32.6627631 C96.0174914,32.9164004 95.3058792,32.9164004 94.8661966,32.6627631 C94.4269601,32.4093488 94.4269601,31.9979968 94.8661966,31.7445826 Z M61.1730341,22.1516492 C61.6102629,21.8980119 62.3241058,21.8980119 62.7611115,22.1516492 C63.2007942,22.4050635 63.2007942,22.8161924 62.7611115,23.0693835 C62.3241058,23.3230208 61.6102629,23.3230208 61.1730341,23.0693835 C60.7335746,22.8161924 60.7335746,22.4050635 61.1730341,22.1516492 Z M72.6636743,14.4579842 C73.1029108,14.2041238 73.814746,14.2041238 74.2542055,14.4579842 C74.6936651,14.7107292 74.6936651,15.1223042 74.2542055,15.3754954 C73.814746,15.6293558 73.1029108,15.6293558 72.6636743,15.3754954 C72.2264455,15.1223042 72.2264455,14.7107292 72.6636743,14.4579842 Z M94.085654,17.5545009 C94.5228828,17.3006405 95.2367257,17.3006405 95.6737314,17.5545009 C96.113414,17.807469 96.113414,18.219044 95.6737314,18.4722352 C95.2367257,18.7258725 94.5228828,18.7258725 94.085654,18.4722352 C93.6461944,18.219044 93.6461944,17.807469 94.085654,17.5545009 Z M48.2611774,45.5784121 C48.6986292,45.325444 49.4124721,45.325444 49.8519317,45.5784121 C50.2889374,45.8318264 50.2889374,46.2431783 49.8519317,46.4968156 C49.4124721,46.7500068 48.6986292,46.7500068 48.2611774,46.4968156 C47.8219409,46.2431783 47.8219409,45.8320494 48.2611774,45.5784121 Z M101.998157,34.1236872 C102.437616,33.870273 103.149228,33.870273 103.588688,34.1236872 C104.028147,34.3773245 104.028147,34.7884534 103.588688,35.0418676 C103.149228,35.2948357 102.437616,35.2948357 101.998157,35.0418676 C101.560928,34.7884534 101.560928,34.3773245 101.998157,34.1236872 Z M49.6489326,30.4295501 C50.0881691,30.176582 50.8000043,30.176582 51.2394639,30.4295501 C51.6789234,30.6827413 51.6789234,31.0943163 51.2394639,31.3479536 C50.8000043,31.6009217 50.0881691,31.6009217 49.6489326,31.3479536 C49.2117038,31.0943163 49.2117038,30.6827413 49.6489326,30.4295501 Z M24.0485181,46.227563 C24.4859699,45.9741488 25.1998128,45.9741488 25.6370416,46.227563 C26.0765012,46.4805311 26.0765012,46.8918831 25.6370416,47.1450742 C25.1998128,47.3989346 24.4859699,47.3989346 24.0485181,47.1450742 C23.6092816,46.8918831 23.6092816,46.4805311 24.0485181,46.227563 Z M85.4883084,37.8401319 C85.9253141,37.5867176 86.639157,37.5867176 87.0763858,37.8401319 C87.5160684,38.0937692 87.5160684,38.5048981 87.0763858,38.7583123 C86.639157,39.0115035 85.9253141,39.0115035 85.4883084,38.7583123 C85.0488488,38.5048981 85.0488488,38.0937692 85.4883084,37.8401319 Z M89.2582913,39.4897782 C89.6955201,39.2361409 90.4091399,39.2361409 90.8465917,39.4897782 C91.2860513,39.7427463 91.2860513,40.1540983 90.8465917,40.4072894 C90.4091399,40.6607037 89.6955201,40.6607037 89.2582913,40.4072894 C88.8188317,40.1540983 88.8188317,39.7427463 89.2582913,39.4897782 Z M62.8461035,50.4316516 C63.285563,50.1786835 63.9971752,50.1786835 64.4366347,50.4316516 C64.8760943,50.6850659 64.8760943,51.0964178 64.4366347,51.349609 C63.9971752,51.6030232 63.285563,51.6030232 62.8461035,51.349609 C62.4066439,51.0964178 62.4066439,50.6850659 62.8461035,50.4316516 Z M29.2017947,51.3121322 C29.6412542,51.0582719 30.3528664,51.0582719 30.7923259,51.3121322 C31.2293316,51.5651003 31.2293316,51.9766754 30.7923259,52.2298665 C30.3528664,52.4832808 29.6412542,52.4832808 29.2017947,52.2298665 C28.762112,51.9766754 28.762112,51.5651003 29.2017947,51.3121322 Z M32.3826341,56.8961684 C32.8200859,56.6427542 33.5339288,56.6427542 33.9733884,56.8961684 C34.4106172,57.1495827 34.4106172,57.5607116 33.9733884,57.8141258 C33.5339288,58.06754 32.8200859,58.06754 32.3826341,57.8141258 C31.9433976,57.5607116 31.9433976,57.1495827 32.3826341,56.8961684 Z M62.8461035,57.8219335 C63.285563,57.5685192 63.9971752,57.5685192 64.4366347,57.8219335 C64.8760943,58.0753477 64.8760943,58.4866997 64.4366347,58.7398908 C63.9971752,58.9933051 63.285563,58.9933051 62.8461035,58.7398908 C62.4066439,58.4866997 62.4066439,58.0753477 62.8461035,57.8219335 L62.8461035,57.8219335 Z"
          id="Fill-2860"
          fill="#9ECB94"
        />
        <path
          d="M30.3260972,36.262539 C30.763326,36.0089017 31.4771689,36.0089017 31.9166285,36.262539 C32.3536342,36.5157302 32.3536342,36.9268591 31.9166285,37.1802733 C31.4771689,37.4334645 30.763326,37.4334645 30.3260972,37.1802733 C29.8866377,36.9268591 29.8866377,36.5157302 30.3260972,36.262539 Z M51.0386955,26.0940698 C51.4759243,25.8408786 52.1895442,25.8408786 52.6267729,26.0940698 C53.0664556,26.3477071 53.0664556,26.7586129 52.6267729,27.0122502 C52.1895442,27.2656645 51.4759243,27.2656645 51.0386955,27.0122502 C50.599236,26.7586129 50.599236,26.3477071 51.0386955,26.0940698 Z M63.9704061,26.7429976 C64.4098656,26.4898065 65.1214778,26.4898065 65.5609373,26.7429976 C65.9981661,26.9966349 65.9981661,27.4075408 65.5609373,27.6611781 C65.1214778,27.9143692 64.4098656,27.9143692 63.9704061,27.6611781 C63.5309465,27.4075408 63.5309465,26.9966349 63.9704061,26.7429976 Z M69.518304,19.8274213 C69.9577635,19.5740071 70.6693757,19.5740071 71.1086121,19.8274213 C71.5482947,20.0808356 71.5482947,20.4919645 71.1086121,20.7456018 C70.6693757,20.9985699 69.9577635,20.9985699 69.518304,20.7456018 C69.0788444,20.4919645 69.0788444,20.0808356 69.518304,19.8274213 Z M36.6859915,37.8403549 C37.125451,37.5864946 37.8370632,37.5864946 38.2765227,37.8403549 C38.7157592,38.0935461 38.7157592,38.5048981 38.2765227,38.7578662 C37.8370632,39.0115035 37.125451,39.0115035 36.6859915,38.7578662 C36.2485396,38.5048981 36.2485396,38.0935461 36.6859915,37.8403549 Z M105.018604,28.3730133 C105.458064,28.1195991 106.169453,28.1195991 106.609136,28.3730133 C107.048595,28.6259814 107.048595,29.0375564 106.609136,29.2911937 C106.169453,29.544608 105.458064,29.544608 105.018604,29.2911937 C104.579145,29.0375564 104.579145,28.6259814 105.018604,28.3730133 Z M108.034591,30.182382 C108.47405,29.9289678 109.185662,29.9289678 109.625122,30.182382 C110.062128,30.4360193 110.062128,30.8471482 109.625122,31.1003394 C109.185662,31.3535305 108.47405,31.3535305 108.034591,31.1003394 C107.594908,30.8471482 107.594908,30.4360193 108.034591,30.182382 Z M43.2020388,29.1314714 C43.6412753,28.8785033 44.3528874,28.8785033 44.79257,29.1314714 C45.2320296,29.3851087 45.2320296,29.7962376 44.79257,30.0494288 C44.3528874,30.3030661 43.6412753,30.3030661 43.2020388,30.0494288 C42.7625793,29.7962376 42.7625793,29.3851087 43.2020388,29.1314714 Z M79.7483421,11.3799827 C80.1880247,11.1270147 80.8996369,11.1270147 81.3390964,11.3799827 C81.7763252,11.633397 81.7763252,12.044749 81.3390964,12.2981632 C80.8996369,12.5513544 80.1880247,12.5513544 79.7483421,12.2981632 C79.3091057,12.044749 79.3091057,11.633397 79.7483421,11.3799827 Z M75.0728941,30.4295501 C75.5101229,30.1768051 76.2239658,30.1768051 76.6611946,30.4295501 C77.1006541,30.6827413 77.1006541,31.0943163 76.6611946,31.3477306 C76.2239658,31.6011448 75.5101229,31.6011448 75.0728941,31.3477306 C74.6334346,31.0943163 74.6334346,30.6827413 75.0728941,30.4295501 Z M55.2169073,39.4893321 C55.6541361,39.2361409 56.367756,39.2361409 56.8052078,39.4893321 C57.2446674,39.7423001 57.2446674,40.1538752 56.8052078,40.4068433 C56.367756,40.6609267 55.6541361,40.6609267 55.2169073,40.4068433 C54.7772247,40.1538752 54.7772247,39.7423001 55.2169073,39.4893321 Z M74.3766742,42.7183559 C74.8141261,42.4651647 75.527969,42.4651647 75.9651978,42.7183559 C76.4046573,42.971547 76.4046573,43.3831221 75.9651978,43.6360902 C75.527969,43.8897275 74.8141261,43.8897275 74.3766742,43.6360902 C73.9374377,43.3831221 73.9374377,42.971547 74.3766742,42.7183559 Z M85.158156,45.2105599 C85.5976156,44.9571457 86.3092277,44.9571457 86.7486873,45.2105599 C87.1859161,45.4641973 87.1859161,45.8751031 86.7486873,46.1285173 C86.3092277,46.3819315 85.5976156,46.3819315 85.158156,46.1285173 C84.7186965,45.8751031 84.7186965,45.4641973 85.158156,45.2105599 Z M13.4637892,45.5788583 C13.9030256,45.3249979 14.6148609,45.3249979 15.0543204,45.5788583 C15.4915492,45.8318264 15.4915492,46.2434014 15.0543204,46.4968156 C14.6148609,46.7497837 13.9030256,46.7497837 13.4637892,46.4968156 C13.0241066,46.2434014 13.0241066,45.8318264 13.4637892,45.5788583 Z M9.59788365,47.2351969 C10.0373432,46.9822288 10.7489553,46.9822288 11.1884149,47.2351969 C11.6278744,47.4883881 11.6278744,47.9001862 11.1884149,48.1531543 C10.7489553,48.4067916 10.0373432,48.4067916 9.59788365,48.1531543 C9.15820103,47.9001862 9.15820103,47.4883881 9.59788365,47.2351969 Z M39.2335184,49.7427932 C39.6727548,49.4900482 40.384367,49.4900482 40.8240496,49.7427932 C41.2612784,49.9966536 41.2612784,50.4080056 40.8240496,50.6614198 C40.384367,50.9143879 39.6727548,50.9143879 39.2335184,50.6614198 C38.7940588,50.4080056 38.7940588,49.9966536 39.2335184,49.7427932 Z M42.0777362,62.9593717 C42.5169727,62.7072959 43.2285848,62.7072959 43.6682675,62.9593717 C44.107727,63.2134551 44.107727,63.6239148 43.6682675,63.8784444 C43.2285848,64.1305202 42.5169727,64.1305202 42.0777362,63.8784444 C41.6382767,63.6239148 41.6382767,63.2134551 42.0777362,62.9593717 Z M35.5614658,64.3022887 C36.0011484,64.047759 36.7149913,64.047759 37.1522201,64.3022887 C37.5916797,64.5541414 37.5916797,64.9670549 37.1522201,65.2189076 C36.7149913,65.4734372 36.0011484,65.4734372 35.5614658,65.2189076 C35.124237,64.9670549 35.124237,64.5541414 35.5614658,64.3022887 Z M53.4099925,64.3266039 C53.8469982,64.0747512 54.5610642,64.0747512 54.9982929,64.3266039 C55.4377525,64.5809105 55.4377525,64.9913701 54.9982929,65.2458998 C54.5610642,65.4977525 53.8469982,65.4977525 53.4099925,65.2458998 C52.9705329,64.9913701 52.9705329,64.5809105 53.4099925,64.3266039 L53.4099925,64.3266039 Z"
          id="Fill-2861"
          fill="#51A146"
        />
        <path
          d="M73.0897493,50.5360512 C73.0897493,49.0024043 74.3322821,47.7592022 75.8668213,47.7592022 C75.8668213,49.2930722 74.6245115,50.5362742 73.0897493,50.5362742 L73.0897493,50.5360512"
          id="Fill-2862"
          fill="#51A146"
        />
        <path
          d="M73.0897493,50.5360512 C73.0897493,49.0024043 71.8472165,47.7592022 70.3124542,47.7592022 C70.3124542,49.2930722 71.5572178,50.5362742 73.0897493,50.5362742 L73.0897493,50.5360512"
          id="Fill-2863"
          fill="#51A146"
        />
        <path
          d="M19.5359155,53.6845446 C19.5359155,52.1511207 20.7784483,50.9079187 22.3132105,50.9079187 C22.3132105,52.4413425 21.068447,53.6845446 19.5359155,53.6845446 L19.5359155,53.6840984 L19.5359155,53.6845446"
          id="Fill-2864"
          fill="#9ECB94"
        />
        <path
          d="M19.5359155,53.6845446 C19.5359155,52.1511207 18.2933826,50.9079187 16.7586204,50.9079187 C16.7586204,52.4413425 18.0011532,53.6845446 19.5359155,53.6845446 L19.5359155,53.6840984 L19.5359155,53.6845446"
          id="Fill-2865"
          fill="#9ECB94"
        />
        <path
          d="M46.7734841,38.1096076 C46.7734841,36.5761838 48.0182477,35.3329817 49.5507792,35.3329817 C49.5507792,36.8659594 48.3080233,38.1096076 46.7754918,38.1096076 L46.7734841,38.1096076 L46.7734841,38.1089383 L46.7734841,38.1096076"
          id="Fill-2866"
          fill="#9ECB94"
        />
        <path
          d="M46.7734841,38.1096076 C46.7734841,36.5761838 45.5309513,35.3329817 43.9984198,35.3329817 C43.9984198,36.8659594 45.2407295,38.1096076 46.7734841,38.1096076 L46.7734841,38.1089383 L46.7734841,38.1096076"
          id="Fill-2867"
          fill="#9ECB94"
        />
        <path
          d="M50.4453136,56.4613935 C50.4453136,54.9279697 51.6876234,53.6845446 53.2201549,53.6845446 C53.2201549,55.2184145 51.9778451,56.4618396 50.4453136,56.4618396 L50.4453136,56.4613935"
          id="Fill-2868"
          fill="#51A146"
        />
        <path
          d="M50.4453136,56.4613935 C50.4453136,54.9279697 49.20055,53.6845446 47.6677954,53.6845446 C47.6677954,55.2184145 48.9105513,56.4618396 50.4430829,56.4618396 L50.4453136,56.4618396 L50.4453136,56.4613935"
          id="Fill-2869"
          fill="#51A146"
        />
        <path
          d="M69.5584576,32.9264388 C69.5584576,31.3923457 70.8009904,30.1493668 72.3357527,30.1493668 L72.3357527,30.1495898 C72.3357527,31.6830137 71.0932199,32.9264388 69.5584576,32.9264388"
          id="Fill-2870"
          fill="#51A146"
        />
        <path
          d="M69.5584576,32.9264388 C69.5584576,31.3923457 68.3159248,30.1493668 66.7811625,30.1493668 L66.7811625,30.1495898 C66.7811625,31.6830137 68.0259261,32.9264388 69.5584576,32.9264388"
          id="Fill-2871"
          fill="#51A146"
        />
        <path
          d="M82.472099,18.7528647 C82.472099,17.2189947 83.7148549,15.9755696 85.2496172,15.9755696 L85.2496172,15.9760157 C85.2496172,17.5094395 84.0046305,18.7528647 82.472099,18.7528647"
          id="Fill-2872"
          fill="#51A146"
        />
        <path
          d="M82.472099,18.7528647 C82.472099,17.2189947 81.2275585,15.9755696 79.695027,15.9755696 L79.695027,15.9760157 C79.695027,17.5094395 80.9375598,18.7528647 82.472099,18.7528647"
          id="Fill-2873"
          fill="#51A146"
        />
        <path
          d="M91.1767441,28.5907354 C91.1767441,27.0568654 92.4192769,25.8134403 93.9540392,25.8134403 L93.9540392,25.8138865 C93.9540392,27.3473103 92.7090525,28.5907354 91.1767441,28.5907354"
          id="Fill-2874"
          fill="#51A146"
        />
        <path
          d="M91.1767441,28.5907354 C91.1767441,27.0568654 89.9319805,25.8134403 88.399449,25.8134403 L88.399449,25.8138865 C88.399449,27.3473103 89.6419818,28.5907354 91.1767441,28.5907354"
          id="Fill-2875"
          fill="#51A146"
        />
        <polyline
          id="Fill-2876"
          fill="#2A90C3"
          points="23.1073608 17.3581941 0.63469357 50.1345145 45.3234907 77.3118527 66.9975462 43.0913388 23.1073608 17.3581941"
        />
        <polyline
          id="Fill-2877"
          fill="#1A6C95"
          points="23.1073608 17.3581941 45.3279522 24.7560605 89.1199842 49.9917459 66.9975462 43.0913388 23.1073608 17.3581941"
        />
        <polyline
          id="Fill-2878"
          fill="#F8F7F6"
          points="44.6587245 127.457087 88.9033775 102.729345 88.9033775 49.9326308 66.7811625 43.0322237 45.1115686 77.1113074 44.6587245 127.457087"
        />
        <polyline
          id="Fill-2879"
          fill="#E4E4E3"
          points="54.5566026 82.5855903 65.6903213 76.0782429 65.6903213 115.366372 54.5566026 121.635028 54.5566026 82.5855903"
        />
        <polyline
          id="Fill-2880"
          fill="#E4E4E3"
          points="73.1566721 72.6720968 83.2999337 66.7427391 83.2999337 88.2963336 73.1566721 94.6272279 73.1566721 72.6720968"
        />
      </g>
    </g>
  </svg>
)

export const step27Image2 = (
  <svg
    width="70px"
    height="70px"
    viewBox="0 0 128 128"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    aria-hidden="true"
  >
    <g
      id="5.climate/climate_1.1"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Group" transform="translate(3.200000, 0.000000)">
        <path
          d="M11.5230288,14.6480448 C10.4230414,14.5804528 9.50642253,13.6627185 9.49972146,11.9934415 C9.49526873,9.6366445 11.1906457,6.74334995 13.2407133,5.55903994 C15.2927886,4.37495301 16.9259273,5.34667167 16.9326367,7.70302251 C16.9370811,9.37252263 16.0693158,11.3201984 14.81786,12.7467688 L14.8312445,17.8757302 C14.835706,18.9257485 14.1062478,20.2064273 13.1914135,20.7340018 C12.2768023,21.2617994 11.5408748,20.8270245 11.5386441,19.7770062 L11.5230288,14.6480448 M13.1938673,2.04492512 C7.86012231,5.12426499 3.54806496,12.5912849 3.56585584,18.7202956 C3.58375711,24.8490831 7.92258356,27.3218796 13.2563286,24.2423167 C18.5920813,21.1611922 22.8999002,13.6961799 22.8821094,7.56694621 C22.8664388,1.43815864 18.5298431,-1.0357532 13.1938673,2.04492512"
          id="Fill-111"
          fill="#FFFFFE"
        />
        <polyline
          id="Fill-2851"
          fill="#E4E4E3"
          points="44.4378793 127.515086 0.70830862 102.771506 0.70830862 50.159499 44.8773389 75.8397747 44.4378793 127.515086"
        />
        <polyline
          id="Fill-2852"
          fill="#F8F7F6"
          points="88.1161426 50.159499 88.0713043 102.802737 120.749918 83.2972024 120.749918 31.2317311 88.1161426 50.159499"
        />
        <polyline
          id="Fill-2853"
          fill="#9E9F9E"
          points="77.5021908 5.63220884 120.749918 31.2317311 44.6698783 75.8397747 0.70830862 50.159499 77.5021908 5.63220884"
        />
        <polyline
          id="Fill-2854"
          fill="#F8F7F6"
          points="44.8773389 75.8397747 44.4311871 127.515086 88.1605347 102.771506 88.1605347 50.159499"
        />
        <polyline
          id="Fill-2855"
          fill="#E4E4E3"
          points="97.4538771 60.7435587 114.900867 50.6926504 114.900867 72.2457988 97.4538771 82.6969052 97.4538771 60.7435587"
        />
        <polyline
          id="Fill-2856"
          fill="#FFFFFF"
          points="36.8843059 84.6577424 26.7390366 78.7286078 26.7390366 100.281979 36.8843059 106.612874 36.8843059 84.6577424"
        />
        <polyline
          id="Fill-2857"
          fill="#FFFFFF"
          points="17.3520023 75.1212472 7.20874065 69.1896588 7.20874065 90.7432532 17.3520023 97.0741476 17.3520023 75.1212472"
        />
        <polyline
          id="Fill-2858"
          fill="#E4E4E3"
          points="50.4453136 85.0349638 61.5768015 78.5253856 61.5768015 117.813515 50.4453136 124.084179 50.4453136 85.0349638"
        />
        <polyline
          id="Fill-2859"
          fill="#2A90C3"
          points="69.0431523 75.1212472 79.1861908 69.1896588 79.1861908 90.7432532 69.0431523 97.0741476 69.0431523 75.1212472"
        />
        <path
          d="M73.0897493,50.5360512 C73.0897493,49.0024043 74.3322821,47.7592022 75.8668213,47.7592022 C75.8668213,49.2930722 74.6245115,50.5362742 73.0897493,50.5362742 L73.0897493,50.5360512"
          id="Fill-2862"
          fill="#51A146"
        />
        <path
          d="M73.0897493,50.5360512 C73.0897493,49.0024043 71.8472165,47.7592022 70.3124542,47.7592022 C70.3124542,49.2930722 71.5572178,50.5362742 73.0897493,50.5362742 L73.0897493,50.5360512"
          id="Fill-2863"
          fill="#51A146"
        />
        <path
          d="M19.5359155,53.6845446 C19.5359155,52.1511207 20.7784483,50.9079187 22.3132105,50.9079187 C22.3132105,52.4413425 21.068447,53.6845446 19.5359155,53.6845446 L19.5359155,53.6840984 L19.5359155,53.6845446"
          id="Fill-2864"
          fill="#9ECB94"
        />
        <path
          d="M19.5359155,53.6845446 C19.5359155,52.1511207 18.2933826,50.9079187 16.7586204,50.9079187 C16.7586204,52.4413425 18.0011532,53.6845446 19.5359155,53.6845446 L19.5359155,53.6840984 L19.5359155,53.6845446"
          id="Fill-2865"
          fill="#9ECB94"
        />
        <path
          d="M46.7734841,38.1096076 C46.7734841,36.5761838 48.0182477,35.3329817 49.5507792,35.3329817 C49.5507792,36.8659594 48.3080233,38.1096076 46.7754918,38.1096076 L46.7734841,38.1096076 L46.7734841,38.1089383 L46.7734841,38.1096076"
          id="Fill-2866"
          fill="#9ECB94"
        />
        <path
          d="M46.7734841,38.1096076 C46.7734841,36.5761838 45.5309513,35.3329817 43.9984198,35.3329817 C43.9984198,36.8659594 45.2407295,38.1096076 46.7734841,38.1096076 L46.7734841,38.1089383 L46.7734841,38.1096076"
          id="Fill-2867"
          fill="#9ECB94"
        />
        <path
          d="M50.4453136,56.4613935 C50.4453136,54.9279697 51.6876234,53.6845446 53.2201549,53.6845446 C53.2201549,55.2184145 51.9778451,56.4618396 50.4453136,56.4618396 L50.4453136,56.4613935"
          id="Fill-2868"
          fill="#51A146"
        />
        <path
          d="M50.4453136,56.4613935 C50.4453136,54.9279697 49.20055,53.6845446 47.6677954,53.6845446 C47.6677954,55.2184145 48.9105513,56.4618396 50.4430829,56.4618396 L50.4453136,56.4618396 L50.4453136,56.4613935"
          id="Fill-2869"
          fill="#51A146"
        />
        <polyline
          id="Fill-2876"
          fill="#2A90C3"
          points="23.1073608 17.3581941 0.63469357 50.1345145 45.3234907 77.3118527 66.9975462 43.0913388 23.1073608 17.3581941"
        />
        <polyline
          id="Fill-2877"
          fill="#1A6C95"
          points="23.1073608 17.3581941 45.3279522 24.7560605 89.1199842 49.9917459 66.9975462 43.0913388 23.1073608 17.3581941"
        />
        <polyline
          id="Fill-2878"
          fill="#F8F7F6"
          points="44.6587245 127.457087 88.9033775 102.729345 88.9033775 49.9326308 66.7811625 43.0322237 45.1115686 77.1113074 44.6587245 127.457087"
        />
        <polyline
          id="Fill-2879"
          fill="#E4E4E3"
          points="54.5566026 82.5855903 65.6903213 76.0782429 65.6903213 115.366372 54.5566026 121.635028 54.5566026 82.5855903"
        />
        <polyline
          id="Fill-2880"
          fill="#E4E4E3"
          points="73.1566721 72.6720968 83.2999337 66.7427391 83.2999337 88.2963336 73.1566721 94.6272279 73.1566721 72.6720968"
        />
      </g>
    </g>
  </svg>
)

export const step28Image1 = (
  <svg
    width="70px"
    height="70px"
    viewBox="0 0 128 128"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    aria-hidden="true"
  >
    <g
      id="5.climate/climate_2.1"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Group" transform="translate(1.600000, 12.800000)">
        <polyline
          id="Fill-388"
          fill="#9E9F9E"
          points="55.981639 30.6311 1.37802228e-14 63.1384201 70.501808 103.844622 127.54368 72.0950428 55.981639 30.6311"
        />
        <polyline
          id="Fill-389"
          fill="#B4B5B4"
          points="55.981639 28.8971968 1.37802228e-14 61.4020442 70.501808 102.110718 127.54368 70.3614143 55.981639 28.8971968"
        />
        <polyline
          id="Fill-2143"
          fill="#E4E4E3"
          points="67.0757624 80.782692 38.2607138 64.6800032 38.2607138 21.2541205 67.36699 38.9530663 67.0757624 80.782692"
        />
        <polyline
          id="Fill-2144"
          fill="#B4B5B4"
          points="52.8935274 5.5120891e-13 38.2607138 21.3447857 67.3642426 39.0462041 81.4775171 16.7590499 52.8935274 5.5120891e-13"
        />
        <polyline
          id="Fill-2145"
          fill="#9E9F9E"
          points="52.8935274 1.72252784e-15 67.36699 4.81871794 95.8853161 21.2541205 81.4775171 16.7590499 52.8935274 1.72252784e-15"
        />
        <polyline
          id="Fill-2146"
          fill="#F8F7F6"
          points="67.0702676 80.782692 95.8853161 64.6800032 95.8853161 21.2541205 81.4775171 16.7590499 67.3642426 38.9530663 67.0702676 80.782692"
        />
        <polyline
          id="Fill-2147"
          fill="#E4E4E3"
          points="71.0345347 53.1353013 78.3704482 48.9015112 78.3704482 74.4690972 71.0345347 78.5517786 71.0345347 53.1353013"
        />
        <polyline
          id="Fill-2148"
          fill="#E4E4E3"
          points="83.2880736 46.684335 89.9725715 42.8239207 89.9725715 56.8522997 83.2880736 60.9709724 83.2880736 46.684335"
        />
        <polyline
          id="Fill-2149"
          fill="#FFFFFE"
          points="62.0974188 52.89078 55.4156684 49.0333879 55.4156684 63.0587446 62.0974188 67.17989 62.0974188 52.89078"
        />
        <polyline
          id="Fill-2150"
          fill="#FFFFFE"
          points="49.2284554 46.684335 42.5439576 42.8239207 42.5439576 56.8522997 49.2284554 60.9709724 49.2284554 46.684335"
        />
      </g>
    </g>
  </svg>
)

export const step28Image2 = (
  <svg
    width="70px"
    height="70px"
    viewBox="0 0 128 128"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    aria-hidden="true"
  >
    <g
      id="5.climate/climate_2.2"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Group" transform="translate(0.000000, 12.800000)">
        <polyline
          id="Fill-262"
          fill="#54A044"
          points="122.628933 59.3604046 124.120269 60.2226435 122.628933 61.089808 122.628933 59.3604046"
        />
        <polyline
          id="Fill-318"
          fill="#54A044"
          points="55.9347081 30.5053631 0.177865859 62.8821486 70.3965707 103.427355 127.209389 71.8055419 55.9347081 30.5053631"
        />
        <polyline
          id="Fill-319"
          fill="#75B86A"
          points="55.9347081 28.7784224 0.177865859 61.1554816 70.3965707 101.698226 127.209389 70.0761385 55.9347081 28.7784224"
        />
        <polyline
          id="Fill-320"
          fill="#54A044"
          points="0.207966235 61.1554816 1.69902942 62.0177205 0.207966235 62.8821486 0.207966235 61.1554816"
        />
        <polyline
          id="Fill-321"
          fill="#54A044"
          points="127.209389 70.0761385 125.688225 70.9244218 127.209389 71.8055419 127.209389 70.0761385"
        />
        <path
          d="M84.5546931,78.1761497 C84.8146509,78.0256479 85.2360562,78.0256479 85.4932775,78.1761497 C85.7529617,78.326378 85.7529617,78.570191 85.4932775,78.7179565 C85.2360562,78.8681848 84.8146509,78.8681848 84.5546931,78.7179565 C84.2947353,78.570191 84.2947353,78.326378 84.5546931,78.1761497 Z M68.7766232,79.9192352 C69.036581,79.7684596 69.4579862,79.7684596 69.717944,79.9192352 C69.9776282,80.066727 69.9776282,80.3102664 69.717944,80.4610419 C69.4579862,80.6112702 69.036581,80.6112702 68.7766232,80.4610419 C68.5194018,80.3102664 68.5194018,80.066727 68.7766232,79.9192352 Z M91.212349,70.464707 C91.4723068,70.3142051 91.890702,70.3142051 92.1509335,70.464707 C92.4106176,70.6124725 92.4106176,70.8562855 92.1509335,71.0065138 C91.890702,71.1572893 91.4723068,71.1572893 91.212349,71.0065138 C90.9523912,70.8562855 90.9523912,70.6124725 91.212349,70.464707 Z M111.797996,69.2497464 C112.058228,69.0992445 112.479359,69.0992445 112.736854,69.2497464 C112.996812,69.3975118 112.996812,69.6410513 112.736854,69.7915531 C112.479359,69.9423287 112.058228,69.9423287 111.797996,69.7915531 C111.538312,69.6410513 111.538312,69.3975118 111.797996,69.2497464 Z M108.095924,64.3518679 C108.355608,64.201366 108.777287,64.201366 109.034234,64.3518679 C109.294466,64.5020961 109.294466,64.7459092 109.034234,64.8936746 C108.777287,65.0439029 108.355608,65.0439029 108.095924,64.8936746 C107.835966,64.7459092 107.835966,64.5020961 108.095924,64.3518679 Z M100.852679,57.8748142 C101.112636,57.7270487 101.534042,57.7270487 101.793999,57.8748142 C102.053957,58.0253161 102.053957,58.2688555 101.793999,58.4190837 C101.534042,58.5698593 101.112636,58.5698593 100.852679,58.4190837 C100.595457,58.2688555 100.595457,58.0253161 100.852679,57.8748142 Z M80.7319453,68.8997611 C80.9919031,68.7489856 81.410572,68.7489856 81.6705298,68.8997611 C81.9302139,69.0499893 81.9302139,69.2938024 81.6705298,69.4443042 C81.410572,69.5917961 80.9919031,69.5917961 80.7319453,69.4443042 C80.4719875,69.2938024 80.4719875,69.0499893 80.7319453,68.8997611 Z M87.5264211,64.3518679 C87.7836425,64.201366 88.2050478,64.201366 88.464732,64.3518679 C88.7249634,64.5020961 88.7249634,64.7459092 88.464732,64.8936746 C88.2050478,65.0439029 87.7836425,65.0439029 87.5264211,64.8936746 C87.2661897,64.7459092 87.2661897,64.5020961 87.5264211,64.3518679 Z M100.190197,66.182518 C100.447692,66.0320161 100.869097,66.0320161 101.129055,66.182518 C101.389013,66.3327463 101.389013,66.5762857 101.129055,66.7240512 C100.869097,66.874553 100.447692,66.874553 100.190197,66.7240512 C99.9305125,66.5762857 99.9305125,66.3327463 100.190197,66.182518 Z M73.0973954,82.7511333 C73.3573532,82.600905 73.7787584,82.600905 74.0387162,82.7511333 C74.2959376,82.9016352 74.2959376,83.1424382 74.0387162,83.29294 C73.7787584,83.4434419 73.3573532,83.4434419 73.0973954,83.29294 C72.8374376,83.1424382 72.8374376,82.9016352 73.0973954,82.7511333 Z M110.011402,72.5498422 C110.271086,72.3993403 110.692765,72.3993403 110.952449,72.5498422 C111.209671,72.6976076 111.209671,72.9414207 110.952449,73.0916489 C110.692765,73.2421508 110.271086,73.2421508 110.011402,73.0916489 C109.751444,72.9414207 109.751444,72.6976076 110.011402,72.5498422 Z M73.9183147,73.7949032 C74.1782725,73.6446749 74.5996778,73.6446749 74.8596356,73.7949032 C75.116857,73.9426686 75.116857,74.1864817 74.8596356,74.3367099 C74.5996778,74.4872118 74.1782725,74.4872118 73.9183147,74.3367099 C73.6583569,74.1864817 73.6583569,73.9426686 73.9183147,73.7949032 Z M58.7832983,83.1345026 C59.0432561,82.9837271 59.4643877,82.9837271 59.7218827,83.1345026 C59.9818405,83.2847309 59.9818405,83.5285439 59.7218827,83.6763094 C59.4643877,83.8265376 59.0432561,83.8265376 58.7832983,83.6763094 C58.5233405,83.5285439 58.5233405,83.2847309 58.7832983,83.1345026 Z M95.1062431,78.1761497 C95.3662009,78.0256479 95.7876062,78.0256479 96.047564,78.1761497 C96.3047854,78.326378 96.3047854,78.5674546 96.047564,78.7179565 C95.7876062,78.8681848 95.3662009,78.8681848 95.1062431,78.7179565 C94.8462853,78.5674546 94.8462853,78.326378 95.1062431,78.1761497 Z M97.3361337,79.1500337 C97.5933551,78.9995318 98.015034,78.9995318 98.2749918,79.1500337 C98.5349496,79.3005356 98.5349496,79.544075 98.2749918,79.6918405 C98.015034,79.8423424 97.5933551,79.8423424 97.3361337,79.6918405 C97.0764496,79.544075 97.0764496,79.3005356 97.3361337,79.1500337 Z M81.7195113,85.6191518 C81.9797427,85.4713864 82.401148,85.4713864 82.6611058,85.6191518 C82.9210636,85.7696537 82.9210636,86.0131931 82.6611058,86.163695 C82.401148,86.3114605 81.9797427,86.3114605 81.7195113,86.163695 C81.4598271,86.0131931 81.4598271,85.7696537 81.7195113,85.6191518 Z M61.8289091,86.1418038 C62.0885932,85.991302 62.5102721,85.991302 62.7702299,86.1418038 C63.0301877,86.2892957 63.0301877,86.5331087 62.7702299,86.6836106 C62.5102721,86.8341125 62.0885932,86.8341125 61.8289091,86.6836106 C61.5716877,86.5331087 61.5716877,86.2892957 61.8289091,86.1418038 Z M63.7088144,89.441626 C63.9687722,89.2913977 64.3899038,89.2913977 64.6501352,89.441626 C64.9098194,89.5921279 64.9098194,89.8359409 64.6501352,89.9834328 C64.3899038,90.1342083 63.9687722,90.1342083 63.7088144,89.9834328 C63.451593,89.8359409 63.451593,89.5921279 63.7088144,89.441626 Z M81.7195113,89.9891792 C81.9797427,89.8386773 82.401148,89.8386773 82.6611058,89.9891792 C82.9210636,90.1394074 82.9210636,90.3829468 82.6611058,90.5307123 C82.401148,90.6812142 81.9797427,90.6812142 81.7195113,90.5307123 C81.4598271,90.3829468 81.4598271,90.1394074 81.7195113,89.9891792 L81.7195113,89.9891792 Z"
          id="Fill-322"
          fill="#9ECB94"
        />
        <path
          d="M62.4938537,77.2430381 C62.7538115,77.0925362 63.1752168,77.0925362 63.434901,77.2430381 C63.692396,77.39354 63.692396,77.634343 63.434901,77.7845712 C63.1752168,77.9353467 62.7538115,77.9353467 62.4938537,77.7845712 C62.233896,77.634343 62.233896,77.39354 62.4938537,77.2430381 Z M74.7392341,71.231172 C74.9991919,71.0803965 75.4205971,71.0803965 75.6805549,71.231172 C75.9377763,71.3814003 75.9377763,71.6252133 75.6805549,71.7729788 C75.4205971,71.923207 74.9991919,71.923207 74.7392341,71.7729788 C74.4792763,71.6252133 74.4792763,71.3814003 74.7392341,71.231172 Z M83.5777991,72.1640101 C83.8377569,72.0162446 84.2591621,72.0162446 84.5163835,72.1640101 C84.7763413,72.3147856 84.7763413,72.5580513 84.5163835,72.7088269 C84.2591621,72.8590551 83.8377569,72.8590551 83.5777991,72.7088269 C83.3175676,72.5580513 83.3175676,72.3147856 83.5777991,72.1640101 Z M85.6656706,67.5260894 C85.9256284,67.3753138 86.3470337,67.3753138 86.6042551,67.5260894 C86.8642129,67.6763176 86.8642129,67.919857 86.6042551,68.0676225 C86.3470337,68.2181244 85.9256284,68.2181244 85.6656706,68.0676225 C85.4057128,67.919857 85.4057128,67.6763176 85.6656706,67.5260894 Z M99.2327311,63.156062 C99.4926889,63.0055601 99.9138205,63.0055601 100.171042,63.156062 C100.431273,63.3035539 100.431273,63.5473669 100.171042,63.6978688 C99.9138205,63.8483707 99.4926889,63.8483707 99.2327311,63.6978688 C98.9727733,63.5473669 98.9727733,63.3035539 99.2327311,63.156062 Z M66.2561271,78.1761497 C66.5133485,78.0256479 66.9350274,78.0256479 67.1949852,78.1761497 C67.454943,78.326378 67.454943,78.5674546 67.1949852,78.7179565 C66.9350274,78.8681848 66.5133485,78.8681848 66.2561271,78.7179565 C65.996443,78.5674546 65.996443,78.326378 66.2561271,78.1761497 Z M114.433421,67.8295559 C114.693379,67.6817904 115.114784,67.6817904 115.374742,67.8295559 C115.6347,67.9800578 115.6347,68.2235972 115.374742,68.3743727 C115.114784,68.5218645 114.693379,68.5218645 114.433421,68.3743727 C114.1762,68.2235972 114.1762,67.9800578 114.433421,67.8295559 Z M116.217279,68.8997611 C116.47751,68.7519956 116.898915,68.7519956 117.158873,68.8997611 C117.416095,69.0499893 117.416095,69.2938024 117.158873,69.4443042 C116.898915,69.5917961 116.47751,69.5917961 116.217279,69.4443042 C115.957595,69.2938024 115.957595,69.0499893 116.217279,68.8997611 Z M70.1065125,73.026249 C70.3664703,72.8784835 70.7878756,72.8784835 71.0475597,73.026249 C71.3077912,73.1767509 71.3077912,73.4202903 71.0475597,73.5707922 C70.7878756,73.7185577 70.3664703,73.7185577 70.1065125,73.5707922 C69.8465547,73.4202903 69.8465547,73.1767509 70.1065125,73.026249 Z M95.1062431,58.643742 C95.3662009,58.4929665 95.7876062,58.4929665 96.047564,58.643742 C96.3047854,58.7942439 96.3047854,59.0375096 96.047564,59.1855488 C95.7876062,59.335777 95.3662009,59.335777 95.1062431,59.1855488 C94.8462853,59.0375096 94.8462853,58.7942439 95.1062431,58.643742 Z M88.949348,73.7949032 C89.2093058,73.6446749 89.6307111,73.6446749 89.8879325,73.7949032 C90.1478903,73.9426686 90.1478903,74.1864817 89.8879325,74.3367099 C89.6307111,74.4872118 89.2093058,74.4872118 88.949348,74.3367099 C88.6893902,74.1864817 88.6893902,73.9426686 88.949348,73.7949032 Z M77.2099277,79.1500337 C77.4701591,78.9995318 77.888828,78.9995318 78.1487858,79.1500337 C78.4084699,79.3005356 78.4084699,79.544075 78.1487858,79.6918405 C77.888828,79.8423424 77.4701591,79.8423424 77.2099277,79.6918405 C76.9502435,79.544075 76.9502435,79.3005356 77.2099277,79.1500337 Z M88.5358783,81.0600394 C88.7961097,80.9095375 89.2172414,80.9095375 89.4774728,81.0600394 C89.7374306,81.2078049 89.7374306,81.4513443 89.4774728,81.6018462 C89.2172414,81.7523481 88.7961097,81.7523481 88.5358783,81.6018462 C88.2789305,81.4513443 88.2789305,81.2078049 88.5358783,81.0600394 Z M94.9119589,82.5322215 C95.1719167,82.3819932 95.593322,82.3819932 95.8505434,82.5322215 C96.1102275,82.6827233 96.1102275,82.9262627 95.8505434,83.0770383 C95.593322,83.2248037 95.1719167,83.2248037 94.9119589,83.0770383 C94.6520011,82.9262627 94.6520011,82.6827233 94.9119589,82.5322215 Z M52.5251564,82.7511333 C52.7851142,82.600905 53.2065195,82.600905 53.4664773,82.7511333 C53.7236987,82.9016352 53.7236987,83.1424382 53.4664773,83.29294 C53.2065195,83.4434419 52.7851142,83.4434419 52.5251564,83.29294 C52.2651986,83.1424382 52.2651986,82.9016352 52.5251564,82.7511333 Z M50.2402642,83.7307637 C50.4999484,83.5805355 50.9216273,83.5805355 51.1788487,83.7307637 C51.4388065,83.8785292 51.4388065,84.1223422 51.1788487,84.2725705 C50.9216273,84.423346 50.4999484,84.423346 50.2402642,84.2725705 C49.9800328,84.1223422 49.9800328,83.8785292 50.2402642,83.7307637 Z M67.7614196,85.2138913 C68.018641,85.0636631 68.4400462,85.0636631 68.6997304,85.2138913 C68.9599618,85.3616568 68.9599618,85.6051962 68.6997304,85.7556981 C68.4400462,85.9062 68.018641,85.9062 67.7614196,85.7556981 C67.5014618,85.6051962 67.5014618,85.3616568 67.7614196,85.2138913 Z M69.4415679,93.0265808 C69.701252,92.8758053 70.1229309,92.8758053 70.3828887,93.0265808 C70.6428465,93.176809 70.6428465,93.4206221 70.3828887,93.5683876 C70.1229309,93.7186158 69.701252,93.7186158 69.4415679,93.5683876 C69.1813364,93.4206221 69.1813364,93.176809 69.4415679,93.0265808 Z M65.5914561,93.8198625 C65.8486775,93.6696343 66.2700828,93.6696343 66.5300406,93.8198625 C66.7899983,93.9703644 66.7899983,94.2139038 66.5300406,94.3616693 C66.2700828,94.5124448 65.8486775,94.5124448 65.5914561,94.3616693 C65.3314983,94.2139038 65.3314983,93.9703644 65.5914561,93.8198625 Z M76.1402697,93.8362809 C76.4002275,93.685779 76.8216328,93.685779 77.0815906,93.8362809 C77.3415484,93.9840464 77.3415484,94.2275858 77.0815906,94.3780877 C76.8216328,94.5285896 76.4002275,94.5285896 76.1402697,94.3780877 C75.8827747,94.2275858 75.8827747,93.9840464 76.1402697,93.8362809 L76.1402697,93.8362809 Z"
          id="Fill-323"
          fill="#51A146"
        />
        <path
          d="M87.7781697,85.6818154 C87.7781697,84.7733313 88.5112507,84.0399767 89.417272,84.0399767 L89.4200084,84.0399767 C89.4200084,84.9457243 88.6839174,85.6818154 87.7781697,85.6818154"
          id="Fill-324"
          fill="#51A146"
        />
        <path
          d="M87.7781697,85.6818154 C87.7781697,84.7733313 87.0420787,84.0399767 86.136331,84.0399767 C86.136331,84.9457243 86.869412,85.6818154 87.7781697,85.6818154"
          id="Fill-325"
          fill="#51A146"
        />
        <path
          d="M56.1153104,87.5428395 C56.1153104,86.6368182 56.8514014,85.9010008 57.7571491,85.9010008 C57.7571491,86.8064749 57.0207844,87.5428395 56.1153104,87.5428395"
          id="Fill-326"
          fill="#9ECB94"
        />
        <path
          d="M104.459251,77.6918073 C104.459251,76.785786 105.195342,76.0499686 106.10109,76.0499686 C106.10109,76.9554427 105.364725,77.6918073 104.459251,77.6918073"
          id="Fill-327"
          fill="#9ECB94"
        />
        <path
          d="M104.459251,77.6918073 C104.459251,76.785786 103.722886,76.0499686 102.817412,76.0499686 C102.817412,76.9554427 103.553503,77.6918073 104.459251,77.6918073"
          id="Fill-328"
          fill="#9ECB94"
        />
        <path
          d="M72.2190117,78.3345872 C72.2190117,77.4291131 72.9551027,76.6927485 73.8608504,76.6927485 C73.8608504,77.5987698 73.1244857,78.3345872 72.2190117,78.3345872"
          id="Fill-329"
          fill="#9ECB94"
        />
        <path
          d="M72.2190117,78.3345872 C72.2190117,77.4291131 71.4829206,76.6927485 70.577173,76.6927485 C70.577173,77.5987698 71.313264,78.3345872 72.2190117,78.3345872"
          id="Fill-330"
          fill="#9ECB94"
        />
        <path
          d="M74.3889751,89.1846782 C74.3889751,88.2786569 75.1223298,87.5428395 76.0308138,87.5428395 C76.0308138,88.4483136 75.2944492,89.1846782 74.3889751,89.1846782"
          id="Fill-331"
          fill="#51A146"
        />
        <path
          d="M74.3889751,89.1846782 C74.3889751,88.2786569 73.6526105,87.5428395 72.7471364,87.5428395 C72.7471364,88.4483136 73.4804911,89.1846782 74.3889751,89.1846782"
          id="Fill-332"
          fill="#51A146"
        />
        <path
          d="M85.6875618,75.2698216 C85.6875618,74.3640739 86.4236528,73.6279829 87.3294005,73.6279829 C87.3294005,74.5367406 86.5960459,75.2698216 85.6900246,75.2698216 L85.6875618,75.2698216"
          id="Fill-333"
          fill="#51A146"
        />
        <path
          d="M85.6875618,75.2698216 C85.6875618,74.3640739 84.9542072,73.6279829 84.0481859,73.6279829 C84.0481859,74.5367406 84.7818141,75.2698216 85.6900246,75.2698216 L85.6875618,75.2698216"
          id="Fill-334"
          fill="#51A146"
        />
        <path
          d="M93.3218381,66.8909714 C93.3218381,65.9824873 94.0579291,65.2491327 94.9636768,65.2491327 C94.9636768,66.1548804 94.2305958,66.8909714 93.3248482,66.8909714 L93.3218381,66.8909714"
          id="Fill-335"
          fill="#51A146"
        />
        <path
          d="M93.3218381,66.8909714 C93.3218381,65.9824873 92.5887571,65.2491327 91.6830095,65.2491327 C91.6830095,66.1548804 92.4160904,66.8909714 93.3248482,66.8909714 L93.3218381,66.8909714"
          id="Fill-336"
          fill="#51A146"
        />
        <path
          d="M98.4692761,72.7058168 C98.4692761,71.8000691 99.2053671,71.0639781 100.111115,71.0639781 L100.111115,71.0669882 C100.111115,71.9724622 99.3777602,72.7058168 98.4692761,72.7058168"
          id="Fill-337"
          fill="#51A146"
        />
        <path
          d="M98.4692761,72.7058168 C98.4692761,71.8000691 97.7359215,71.0639781 96.8274374,71.0639781 L96.8274374,71.0669882 C96.8274374,71.9724622 97.5635284,72.7058168 98.4692761,72.7058168"
          id="Fill-338"
          fill="#51A146"
        />
        <path
          d="M56.1153104,87.5428395 C56.1153104,86.6368182 55.3789457,85.9010008 54.4734717,85.9010008 C54.4734717,86.8064749 55.2095627,87.5428395 56.1153104,87.5428395"
          id="Fill-339"
          fill="#9ECB94"
        />
        <path
          d="M60.1074412,64.9319842 C60.3676726,64.7812087 60.7890779,64.7812087 61.0490357,64.9319842 C61.3089935,65.0822125 61.3089935,65.3257519 61.0490357,65.473791 C60.7890779,65.6240192 60.3676726,65.6240192 60.1074412,65.473791 C59.8502198,65.3257519 59.8502198,65.0822125 60.1074412,64.9319842 Z M44.3323813,66.674796 C44.5920655,66.5242941 45.011008,66.5242941 45.2709658,66.674796 C45.5309236,66.8225615 45.5309236,67.0661009 45.2709658,67.2168764 C45.011008,67.3673783 44.5920655,67.3673783 44.3323813,67.2168764 C44.0721499,67.0661009 44.0721499,66.8225615 44.3323813,66.674796 Z M66.7653708,57.2205415 C67.0253286,57.0703132 67.4467338,57.0703132 67.7066916,57.2205415 C67.963913,57.3685806 67.963913,57.61212 67.7066916,57.7623483 C67.4467338,57.9131238 67.0253286,57.9131238 66.7653708,57.7623483 C66.505413,57.61212 66.505413,57.3685806 66.7653708,57.2205415 Z M87.351018,56.0058545 C87.6112495,55.8553526 88.0326547,55.8553526 88.2923389,56.0058545 C88.5498339,56.1533463 88.5498339,56.3971594 88.2923389,56.5476613 C88.0326547,56.6978895 87.6112495,56.6978895 87.351018,56.5476613 C87.0913339,56.3971594 87.0913339,56.1533463 87.351018,56.0058545 Z M83.6489454,51.1077024 C83.9089032,50.9569268 84.3303085,50.9569268 84.5902663,51.1077024 C84.8502241,51.2579306 84.8502241,51.50147 84.5902663,51.6492355 C84.3303085,51.7997374 83.9089032,51.7997374 83.6489454,51.6492355 C83.3889876,51.50147 83.3889876,51.2579306 83.6489454,51.1077024 Z M76.4081631,44.6333851 C76.6683945,44.4828832 77.0895262,44.4828832 77.3467476,44.6333851 C77.606979,44.7811506 77.606979,45.02469 77.3467476,45.1749182 C77.0895262,45.3254201 76.6683945,45.3254201 76.4081631,45.1749182 C76.1484789,45.02469 76.1484789,44.7811506 76.4081631,44.6333851 Z M56.2849671,55.6555956 C56.5449249,55.50482 56.9663301,55.50482 57.2260143,55.6555956 C57.4832357,55.8060974 57.4832357,56.0496368 57.2260143,56.2001387 C56.9663301,56.3479042 56.5449249,56.3479042 56.2849671,56.2001387 C56.0250093,56.0496368 56.0250093,55.8060974 56.2849671,55.6555956 Z M63.0794429,51.1077024 C63.339127,50.9569268 63.7608059,50.9569268 64.0180273,51.1077024 C64.2779851,51.2579306 64.2779851,51.50147 64.0180273,51.6492355 C63.7608059,51.7997374 63.339127,51.7997374 63.0794429,51.6492355 C62.8192115,51.50147 62.8192115,51.2579306 63.0794429,51.1077024 Z M75.7432184,52.9380789 C76.0034499,52.787577 76.4248551,52.787577 76.6820765,52.9380789 C76.9420343,53.0885808 76.9420343,53.3321202 76.6820765,53.4798856 C76.4248551,53.6303875 76.0034499,53.6303875 75.7432184,53.4798856 C75.4835343,53.3321202 75.4835343,53.0885808 75.7432184,52.9380789 Z M48.6504171,69.5069678 C48.9103749,69.3564659 49.3317802,69.3564659 49.591738,69.5069678 C49.8516958,69.6577433 49.8516958,69.8982726 49.591738,70.0487745 C49.3317802,70.1995501 48.9103749,70.1995501 48.6504171,70.0487745 C48.3931957,69.8982726 48.3931957,69.6577433 48.6504171,69.5069678 Z M85.5671603,59.3056766 C85.824108,59.1551747 86.245787,59.1551747 86.5057447,59.3056766 C86.7657025,59.4561785 86.7657025,59.6969815 86.5057447,59.8474834 C86.245787,59.9979853 85.824108,59.9979853 85.5671603,59.8474834 C85.3072025,59.6969815 85.3072025,59.4561785 85.5671603,59.3056766 Z M49.4713365,60.5507376 C49.7312942,60.4002358 50.1526995,60.4002358 50.4126573,60.5507376 C50.6726151,60.7012395 50.6726151,60.9420425 50.4126573,61.0925444 C50.1526995,61.2433199 49.7312942,61.2433199 49.4713365,61.0925444 C49.2141151,60.9420425 49.2141151,60.7012395 49.4713365,60.5507376 Z M34.33632,69.8900635 C34.5962778,69.7395616 35.0174095,69.7395616 35.2776409,69.8900635 C35.5348623,70.040839 35.5348623,70.2843784 35.2776409,70.4321439 C35.0174095,70.5826457 34.5962778,70.5826457 34.33632,70.4321439 C34.0763622,70.2843784 34.0763622,70.040839 34.33632,69.8900635 Z M70.6592649,64.9319842 C70.9192227,64.7812087 71.3406279,64.7812087 71.6003121,64.9319842 C71.8605435,65.0822125 71.8605435,65.3230155 71.6003121,65.473791 C71.3406279,65.6240192 70.9192227,65.6240192 70.6592649,65.473791 C70.4020435,65.3230155 70.4020435,65.0822125 70.6592649,64.9319842 Z M72.8894291,65.9058682 C73.1493869,65.7553663 73.5707922,65.7553663 73.8280136,65.9058682 C74.0879714,66.0563701 74.0879714,66.3001831 73.8280136,66.4504114 C73.5707922,66.5981769 73.1493869,66.5981769 72.8894291,66.4504114 C72.6294713,66.3001831 72.6294713,66.0563701 72.8894291,65.9058682 Z M57.2755431,72.3747127 C57.5327645,72.2269472 57.9541697,72.2269472 58.2138539,72.3747127 C58.4740853,72.5254882 58.4740853,72.768754 58.2138539,72.9192559 C57.9541697,73.067295 57.5327645,73.067295 57.2755431,72.9192559 C57.0155853,72.768754 57.0155853,72.5254882 57.2755431,72.3747127 Z M37.3846672,72.8976383 C37.6418886,72.7471364 38.0632939,72.7471364 38.3232517,72.8976383 C38.5832095,73.0454038 38.5832095,73.2889432 38.3232517,73.4394451 C38.0632939,73.5896733 37.6418886,73.5896733 37.3846672,73.4394451 C37.1247094,73.2889432 37.1247094,73.0454038 37.3846672,72.8976383 Z M39.2645725,76.1977341 C39.5245303,76.0469586 39.9459356,76.0469586 40.203157,76.1977341 C40.4631148,76.3479623 40.4631148,76.5917754 40.203157,76.7395409 C39.9459356,76.8897691 39.5245303,76.8897691 39.2645725,76.7395409 C39.0046147,76.5917754 39.0046147,76.3479623 39.2645725,76.1977341 Z M57.2755431,76.74474 C57.5327645,76.5942382 57.9541697,76.5942382 58.2138539,76.74474 C58.4740853,76.8952419 58.4740853,77.1387813 58.2138539,77.2865468 C57.9541697,77.4370487 57.5327645,77.4370487 57.2755431,77.2865468 C57.0155853,77.1387813 57.0155853,76.8952419 57.2755431,76.74474 L57.2755431,76.74474 Z"
          id="Fill-340"
          fill="#9ECB94"
        />
        <path
          d="M38.0496119,63.9988726 C38.3065596,63.8483707 38.7282386,63.8483707 38.9879227,63.9988726 C39.2481541,64.1491008 39.2481541,64.3926402 38.9879227,64.5406793 C38.7282386,64.6909076 38.3065596,64.6909076 38.0496119,64.5406793 C37.7896541,64.3926402 37.7896541,64.1491008 38.0496119,63.9988726 Z M50.2922558,57.9867329 C50.5522136,57.836231 50.9736189,57.836231 51.2335767,57.9867329 C51.4935345,58.1375084 51.4935345,58.3810478 51.2335767,58.5288133 C50.9736189,58.6793152 50.5522136,58.6793152 50.2922558,58.5288133 C50.0350344,58.3810478 50.0350344,58.1375084 50.2922558,57.9867329 Z M57.9404878,58.3701022 C58.1977091,58.2220631 58.6188408,58.2220631 58.8790722,58.3701022 C59.13903,58.5203305 59.13903,58.7638699 58.8790722,58.9143717 C58.6188408,59.0621372 58.1977091,59.0621372 57.9404878,58.9143717 C57.68053,58.7638699 57.68053,58.5203305 57.9404878,58.3701022 Z M61.2186924,54.2816502 C61.4786502,54.1311483 61.9000554,54.1311483 62.1597396,54.2816502 C62.419971,54.4321521 62.419971,54.6759651 62.1597396,54.8261934 C61.9000554,54.9739589 61.4786502,54.9739589 61.2186924,54.8261934 C60.9587346,54.6759651 60.9587346,54.4321521 61.2186924,54.2816502 Z M74.7854792,49.9118965 C75.0457106,49.7613946 75.4668422,49.7613946 75.7270737,49.9118965 C75.9842951,50.059662 75.9842951,50.3032014 75.7270737,50.4537033 C75.4668422,50.6039315 75.0457106,50.6039315 74.7854792,50.4537033 C74.525795,50.3032014 74.525795,50.059662 74.7854792,49.9118965 Z M41.8091489,64.9319842 C42.0693803,64.7812087 42.4907856,64.7812087 42.748007,64.9319842 C43.0079648,65.0822125 43.0079648,65.3230155 42.748007,65.473791 C42.4907856,65.6240192 42.0693803,65.6240192 41.8091489,65.473791 C41.5494647,65.3230155 41.5494647,65.0822125 41.8091489,64.9319842 Z M89.9891792,54.5853904 C90.2488633,54.4378985 90.6705423,54.4378985 90.92749,54.5853904 C91.1877214,54.7358922 91.1877214,54.9797053 90.92749,55.1299335 C90.6705423,55.277699 90.2488633,55.277699 89.9891792,55.1299335 C89.7289478,54.9797053 89.7289478,54.7358922 89.9891792,54.5853904 Z M91.7705742,55.6555956 C92.030532,55.5078301 92.4519372,55.5078301 92.7116214,55.6555956 C92.9718528,55.8060974 92.9718528,56.0496368 92.7116214,56.2001387 C92.4519372,56.3479042 92.030532,56.3479042 91.7705742,56.2001387 C91.5133528,56.0496368 91.5133528,55.8060974 91.7705742,55.6555956 Z M45.6622707,59.7818099 C45.9192184,59.6340444 46.3408973,59.6340444 46.6005815,59.7818099 C46.8608129,59.9325854 46.8608129,60.1758511 46.6005815,60.326353 C46.3408973,60.4741185 45.9192184,60.4741185 45.6622707,60.326353 C45.4023129,60.1758511 45.4023129,59.9325854 45.6622707,59.7818099 Z M70.6592649,45.3993028 C70.9192227,45.2490746 71.3406279,45.2490746 71.6003121,45.3993028 C71.8605435,45.5498047 71.8605435,45.7933441 71.6003121,45.9411096 C71.3406279,46.0916115 70.9192227,46.0916115 70.6592649,45.9411096 C70.4020435,45.7933441 70.4020435,45.5498047 70.6592649,45.3993028 Z M64.5023698,60.5507376 C64.7623276,60.4002358 65.1837328,60.4002358 65.443417,60.5507376 C65.700912,60.7012395 65.700912,60.9420425 65.443417,61.0925444 C65.1837328,61.2433199 64.7623276,61.2433199 64.5023698,61.0925444 C64.242412,60.9420425 64.242412,60.7012395 64.5023698,60.5507376 Z M52.7629494,65.9058682 C53.0231808,65.7553663 53.4445861,65.7553663 53.7045439,65.9058682 C53.9617653,66.0563701 53.9617653,66.3001831 53.7045439,66.4504114 C53.4445861,66.5981769 53.0231808,66.5981769 52.7629494,66.4504114 C52.5032653,66.3001831 52.5032653,66.0563701 52.7629494,65.9058682 Z M64.0919101,67.8161475 C64.3518679,67.665372 64.7705367,67.665372 65.0304945,67.8161475 C65.2904523,67.9663758 65.2904523,68.2071788 65.0304945,68.3579543 C64.7705367,68.5081825 64.3518679,68.5081825 64.0919101,68.3579543 C63.8319523,68.2071788 63.8319523,67.9663758 64.0919101,67.8161475 Z M70.4649806,69.2880559 C70.7249384,69.1405641 71.1463437,69.1405641 71.4063015,69.2880559 C71.6662593,69.4385578 71.6662593,69.6823709 71.4063015,69.8325991 C71.1463437,69.9803646 70.7249384,69.9803646 70.4649806,69.8325991 C70.2050228,69.6823709 70.2050228,69.4385578 70.4649806,69.2880559 Z M28.0781782,69.5069678 C28.338136,69.3564659 28.7595412,69.3564659 29.019499,69.5069678 C29.2794568,69.6577433 29.2794568,69.8982726 29.019499,70.0487745 C28.7595412,70.1995501 28.338136,70.1995501 28.0781782,70.0487745 C27.8209568,69.8982726 27.8209568,69.6577433 28.0781782,69.5069678 Z M25.793286,70.4865982 C26.0532438,70.3363699 26.4746491,70.3363699 26.7346068,70.4865982 C26.9918282,70.6343637 26.9918282,70.8781767 26.7346068,71.028405 C26.4746491,71.1791805 26.0532438,71.1791805 25.793286,71.028405 C25.5333282,70.8781767 25.5333282,70.6343637 25.793286,70.4865982 Z M43.3144413,71.9669894 C43.5743991,71.8192239 43.9958044,71.8192239 44.2557622,71.9669894 C44.5129836,72.1174913 44.5129836,72.3610307 44.2557622,72.5115326 C43.9958044,72.6623081 43.5743991,72.6623081 43.3144413,72.5115326 C43.0544835,72.3610307 43.0544835,72.1174913 43.3144413,71.9669894 Z M44.997326,79.7824153 C45.2545474,79.6316397 45.6759527,79.6316397 45.9359105,79.7824153 C46.1955946,79.9329171 46.1955946,80.1761829 45.9359105,80.324222 C45.6759527,80.4744503 45.2545474,80.4744503 44.997326,80.324222 C44.7373682,80.1761829 44.7373682,79.9329171 44.997326,79.7824153 Z M41.1444778,80.575697 C41.404162,80.4251951 41.8258409,80.4251951 42.0855251,80.575697 C42.3430201,80.7261989 42.3430201,80.9700119 42.0855251,81.1177774 C41.8258409,81.2680057 41.404162,81.2680057 41.1444778,81.1177774 C40.88452,80.9700119 40.88452,80.7261989 41.1444778,80.575697 Z M51.6960279,80.5921154 C51.9559857,80.4416135 52.377391,80.4416135 52.6346123,80.5921154 C52.8945701,80.7401545 52.8945701,80.9834203 52.6346123,81.1339222 C52.377391,81.284424 51.9559857,81.284424 51.6960279,81.1339222 C51.4357965,80.9834203 51.4357965,80.7401545 51.6960279,80.5921154 L51.6960279,80.5921154 Z"
          id="Fill-341"
          fill="#51A146"
        />
        <path
          d="M63.3311915,72.4376498 C63.3311915,71.5319022 64.0672825,70.7958111 64.9730302,70.7958111 C64.9730302,71.7018325 64.2369392,72.4376498 63.3311915,72.4376498"
          id="Fill-342"
          fill="#51A146"
        />
        <path
          d="M63.3311915,72.4376498 C63.3311915,71.5319022 62.5951005,70.7958111 61.6893528,70.7958111 C61.6893528,71.7018325 62.4254438,72.4376498 63.3311915,72.4376498"
          id="Fill-343"
          fill="#51A146"
        />
        <path
          d="M31.6683321,74.298674 C31.6683321,73.3926527 32.4044232,72.6568353 33.3101708,72.6568353 C33.3101708,73.5650457 32.5768162,74.298674 31.6683321,74.298674"
          id="Fill-344"
          fill="#9ECB94"
        />
        <path
          d="M31.6683321,74.298674 C31.6683321,73.3926527 30.9349775,72.6568353 30.0264934,72.6568353 C30.0264934,73.5650457 30.7625845,74.298674 31.6683321,74.298674"
          id="Fill-345"
          fill="#9ECB94"
        />
        <path
          d="M80.011999,64.4476418 C80.011999,63.5416205 80.7483637,62.8058031 81.6538377,62.8058031 C81.6538377,63.7140135 80.9207568,64.4476418 80.011999,64.4476418"
          id="Fill-346"
          fill="#9ECB94"
        />
        <path
          d="M80.011999,64.4476418 C80.011999,63.5416205 79.2789181,62.8058031 78.3701603,62.8058031 C78.3701603,63.7140135 79.106525,64.4476418 80.011999,64.4476418"
          id="Fill-347"
          fill="#9ECB94"
        />
        <path
          d="M47.7720334,65.0906953 C47.7720334,64.1849476 48.5081244,63.4488566 49.4138721,63.4488566 C49.4138721,64.3543306 48.6805175,65.0906953 47.7720334,65.0906953"
          id="Fill-348"
          fill="#9ECB94"
        />
        <path
          d="M47.7720334,65.0906953 C47.7720334,64.1849476 47.0386788,63.4488566 46.1301947,63.4488566 C46.1301947,64.3543306 46.8662857,65.0906953 47.7720334,65.0906953"
          id="Fill-349"
          fill="#9ECB94"
        />
        <path
          d="M49.9419969,75.9405127 C49.9419969,75.0344914 50.6780879,74.298674 51.5838356,74.298674 C51.5838356,75.2068844 50.850481,75.9405127 49.9419969,75.9405127"
          id="Fill-350"
          fill="#51A146"
        />
        <path
          d="M49.9419969,75.9405127 C49.9419969,75.0344914 49.2086423,74.298674 48.3001582,74.298674 C48.3001582,75.2068844 49.0362492,75.9405127 49.9419969,75.9405127"
          id="Fill-351"
          fill="#51A146"
        />
        <path
          d="M61.2433199,62.0256561 C61.2433199,61.1199084 61.9766746,60.3838174 62.8851586,60.3838174 C62.8851586,61.2923015 62.1490676,62.0256561 61.2433199,62.0256561"
          id="Fill-352"
          fill="#51A146"
        />
        <path
          d="M61.2433199,62.0256561 C61.2433199,61.1199084 60.5072289,60.3838174 59.6014812,60.3838174 C59.6014812,61.2923015 60.3375723,62.0256561 61.2433199,62.0256561"
          id="Fill-353"
          fill="#51A146"
        />
        <path
          d="M68.8778699,53.6468059 C68.8778699,52.7410582 69.6109509,52.0049672 70.5197086,52.0049672 C70.5197086,52.9107149 69.7836176,53.6468059 68.8778699,53.6468059"
          id="Fill-354"
          fill="#51A146"
        />
        <path
          d="M68.8778699,53.6468059 C68.8778699,52.7410582 68.1417789,52.0049672 67.2360312,52.0049672 C67.2360312,52.9107149 67.9691122,53.6468059 68.8778699,53.6468059"
          id="Fill-355"
          fill="#51A146"
        />
        <path
          d="M74.0250342,59.4619249 C74.0250342,58.5559036 74.7583888,57.8200862 75.6668729,57.8200862 L75.6668729,57.8228226 C75.6668729,58.7285703 74.9307819,59.4619249 74.0250342,59.4619249"
          id="Fill-356"
          fill="#51A146"
        />
        <path
          d="M74.0250342,59.4619249 C74.0250342,58.5559036 73.2889432,57.8200862 72.3831955,57.8200862 L72.3831955,57.8228226 C72.3831955,58.7285703 73.1165501,59.4619249 74.0250342,59.4619249"
          id="Fill-357"
          fill="#51A146"
        />
        <path
          d="M41.8066861,53.7373807 C42.0639075,53.5868788 42.4853128,53.5868788 42.7449969,53.7373807 C43.0052284,53.8876089 43.0052284,54.1311483 42.7449969,54.2791874 C42.4853128,54.4294157 42.0639075,54.4294157 41.8066861,54.2791874 C41.5467283,54.1311483 41.5467283,53.8876089 41.8066861,53.7373807 Z M26.0286162,55.4801925 C26.2883004,55.3296906 26.7099793,55.3296906 26.9699371,55.4801925 C27.2271585,55.6306943 27.2271585,55.8714973 26.9699371,56.0219992 C26.7099793,56.1725011 26.2883004,56.1725011 26.0286162,56.0219992 C25.7686584,55.8714973 25.7686584,55.6306943 26.0286162,55.4801925 Z M48.4616057,46.0259379 C48.7215634,45.8757097 49.1429687,45.8757097 49.4026529,46.0259379 C49.6628843,46.1737034 49.6628843,46.4172428 49.4026529,46.5677447 C49.1429687,46.7185202 48.7215634,46.7185202 48.4616057,46.5677447 C48.2041106,46.4172428 48.2041106,46.1737034 48.4616057,46.0259379 Z M69.050263,44.8109773 C69.3074844,44.6604754 69.7288896,44.6604754 69.9888474,44.8109773 C70.2488052,44.9617528 70.2488052,45.2050186 69.9888474,45.3527841 C69.7288896,45.5035596 69.3074844,45.5035596 69.050263,45.3527841 C68.7900315,45.2050186 68.7900315,44.9617528 69.050263,44.8109773 Z M65.3479167,39.9130988 C65.6051381,39.7625969 66.0262697,39.7625969 66.2865011,39.9130988 C66.5464589,40.0633271 66.5464589,40.3068665 66.2865011,40.4546319 C66.0262697,40.6051338 65.6051381,40.6051338 65.3479167,40.4546319 C65.0879589,40.3068665 65.0879589,40.0633271 65.3479167,39.9130988 Z M58.1046716,33.4385079 C58.3646294,33.2882797 58.7860347,33.2882797 59.0459925,33.4385079 C59.3032139,33.5862734 59.3032139,33.8300864 59.0459925,33.9803147 C58.7860347,34.1308166 58.3646294,34.1308166 58.1046716,33.9803147 C57.8447138,33.8300864 57.8447138,33.5862734 58.1046716,33.4385079 Z M37.9809283,44.460992 C38.2411597,44.3132265 38.662565,44.3132265 38.9222492,44.460992 C39.1824806,44.6114939 39.1824806,44.8550333 38.9222492,45.0052615 C38.662565,45.153027 38.2411597,45.153027 37.9809283,45.0052615 C37.7239805,44.8550333 37.7239805,44.6114939 37.9809283,44.460992 Z M44.7756778,39.9130988 C45.0356356,39.7625969 45.4570408,39.7625969 45.7169986,39.9130988 C45.9769564,40.0633271 45.9769564,40.3068665 45.7169986,40.4546319 C45.4570408,40.6051338 45.0356356,40.6051338 44.7756778,40.4546319 C44.51572,40.3068665 44.51572,40.0633271 44.7756778,39.9130988 Z M57.4394533,41.7434753 C57.6996847,41.5929734 58.12109,41.5929734 58.3810478,41.7434753 C58.6410056,41.8939772 58.6410056,42.1375166 58.3810478,42.2852821 C58.12109,42.435784 57.6996847,42.435784 57.4394533,42.2852821 C57.1797692,42.1375166 57.1797692,41.8939772 57.4394533,41.7434753 Z M30.3491147,58.3123642 C30.6066098,58.1618623 31.0277414,58.1618623 31.2879728,58.3123642 C31.547657,58.4628661 31.547657,58.7036691 31.2879728,58.854171 C31.0277414,59.0046729 30.6066098,59.0046729 30.3491147,58.854171 C30.0894306,58.7036691 30.0894306,58.4628661 30.3491147,58.3123642 Z M67.2631215,48.1110731 C67.523353,47.9605712 67.9444846,47.9605712 68.2019796,48.1110731 C68.4619374,48.2618486 68.4619374,48.502378 68.2019796,48.6528799 C67.9444846,48.8036554 67.523353,48.8036554 67.2631215,48.6528799 C67.0034374,48.502378 67.0034374,48.2618486 67.2631215,48.1110731 Z M31.1700341,49.3561341 C31.4302655,49.2056322 31.8486608,49.2056322 32.1088922,49.3561341 C32.3685763,49.506636 32.3685763,49.747439 32.1088922,49.8979409 C31.8486608,50.0484428 31.4302655,50.0484428 31.1700341,49.8979409 C30.9103499,49.747439 30.9103499,49.506636 31.1700341,49.3561341 Z M16.0325549,58.6957336 C16.2925127,58.544958 16.713918,58.544958 16.9738758,58.6957336 C17.2335599,58.8462354 17.2335599,59.0897748 16.9738758,59.2375403 C16.713918,59.3880422 16.2925127,59.3880422 16.0325549,59.2375403 C15.7753335,59.0897748 15.7753335,58.8462354 16.0325549,58.6957336 Z M52.3582362,53.7373807 C52.618194,53.5868788 53.0368628,53.5868788 53.2968206,53.7373807 C53.5567784,53.8876089 53.5567784,54.1311483 53.2968206,54.2791874 C53.0368628,54.4294157 52.618194,54.4294157 52.3582362,54.2791874 C52.0982784,54.1311483 52.0982784,53.8876089 52.3582362,53.7373807 Z M54.5853904,54.7112647 C54.8456218,54.5634992 55.2670271,54.5634992 55.5269849,54.7112647 C55.7869427,54.8617665 55.7869427,55.105306 55.5269849,55.2558078 C55.2670271,55.4035733 54.8456218,55.4035733 54.5853904,55.2558078 C54.3257062,55.105306 54.3257062,54.8617665 54.5853904,54.7112647 Z M38.971778,61.1803828 C39.2317358,61.0326173 39.653141,61.0326173 39.9103624,61.1803828 C40.1703202,61.3308847 40.1703202,61.5744241 39.9103624,61.7246523 C39.653141,61.8751542 39.2317358,61.8751542 38.971778,61.7246523 C38.7115465,61.5744241 38.7115465,61.3308847 38.971778,61.1803828 Z M19.0806285,61.7027611 C19.3408599,61.5525329 19.7622652,61.5525329 20.0194866,61.7027611 C20.2794444,61.8508003 20.2794444,62.0943397 20.0194866,62.2445679 C19.7622652,62.3953434 19.3408599,62.3953434 19.0806285,62.2445679 C18.8209443,62.0943397 18.8209443,61.8508003 19.0806285,61.7027611 Z M20.9608074,65.0031306 C21.2207652,64.8526287 21.6421705,64.8526287 21.9018546,65.0031306 C22.1620861,65.1536324 22.1620861,65.3968982 21.9018546,65.5449373 C21.6421705,65.6954392 21.2207652,65.6954392 20.9608074,65.5449373 C20.7008496,65.3968982 20.7008496,65.1536324 20.9608074,65.0031306 Z M38.971778,65.5501365 C39.2317358,65.3996346 39.653141,65.3996346 39.9103624,65.5501365 C40.1703202,65.7006384 40.1703202,65.9441778 39.9103624,66.0919433 C39.653141,66.2424451 39.2317358,66.2424451 38.971778,66.0919433 C38.7115465,65.9441778 38.7115465,65.7006384 38.971778,65.5501365 L38.971778,65.5501365 Z"
          id="Fill-358"
          fill="#9ECB94"
        />
        <path
          d="M19.7458468,52.8039954 C20.0058046,52.6537671 20.4244734,52.6537671 20.6844312,52.8039954 C20.944389,52.9547709 20.944389,53.1980367 20.6844312,53.3458021 C20.4244734,53.496304 20.0058046,53.496304 19.7458468,53.3458021 C19.485889,53.1980367 19.485889,52.9547709 19.7458468,52.8039954 Z M31.9909534,46.792403 C32.2511849,46.6416275 32.6695801,46.6416275 32.9298115,46.792403 C33.1894957,46.9429049 33.1894957,47.1864443 32.9298115,47.3366725 C32.6695801,47.4847116 32.2511849,47.4847116 31.9909534,47.3366725 C31.7312693,47.1864443 31.7312693,46.9429049 31.9909534,46.792403 Z M39.6367226,47.175225 C39.8966804,47.0274595 40.3180857,47.0274595 40.5753071,47.175225 C40.8349912,47.3257269 40.8349912,47.5692663 40.5753071,47.7200418 C40.3180857,47.8675337 39.8966804,47.8675337 39.6367226,47.7200418 C39.3767648,47.5692663 39.3767648,47.3257269 39.6367226,47.175225 Z M42.9176636,43.0870467 C43.174885,42.9392812 43.5962903,42.9392812 43.8562481,43.0870467 C44.1162059,43.2375485 44.1162059,43.481088 43.8562481,43.6315898 C43.5962903,43.7793553 43.174885,43.7793553 42.9176636,43.6315898 C42.6577058,43.481088 42.6577058,43.2375485 42.9176636,43.0870467 Z M56.4847241,38.7170193 C56.7419455,38.5667911 57.1630771,38.5667911 57.4233086,38.7170193 C57.6829927,38.8677948 57.6829927,39.1085979 57.4233086,39.2588261 C57.1630771,39.4096016 56.7419455,39.4096016 56.4847241,39.2588261 C56.2247663,39.1085979 56.2247663,38.8677948 56.4847241,38.7170193 Z M23.5053838,53.7373807 C23.7656152,53.5868788 24.1870205,53.5868788 24.4469783,53.7373807 C24.706936,53.8876089 24.706936,54.1311483 24.4469783,54.2791874 C24.1870205,54.4294157 23.7656152,54.4294157 23.5053838,54.2791874 C23.2456996,54.1311483 23.2456996,53.8876089 23.5053838,53.7373807 Z M71.6854141,43.3907868 C71.9453719,43.243295 72.3667771,43.243295 72.6264613,43.3907868 C72.8839563,43.5415623 72.8839563,43.7848281 72.6264613,43.9356036 C72.3667771,44.0861055 71.9453719,44.0861055 71.6854141,43.9356036 C71.4254563,43.7848281 71.4254563,43.5415623 71.6854141,43.3907868 Z M73.4695455,44.460992 C73.7267669,44.3132265 74.1481721,44.3132265 74.4081299,44.460992 C74.6680877,44.6114939 74.6680877,44.8550333 74.4081299,45.0052615 C74.1481721,45.153027 73.7267669,45.153027 73.4695455,45.0052615 C73.209314,44.8550333 73.209314,44.6114939 73.4695455,44.460992 Z M27.3585056,48.58748 C27.6184633,48.4397145 28.039595,48.4397145 28.2968164,48.58748 C28.5570478,48.7379818 28.5570478,48.9812476 28.2968164,49.1317495 C28.039595,49.2822514 27.6184633,49.2822514 27.3585056,49.1317495 C27.0985478,48.9812476 27.0985478,48.7379818 27.3585056,48.58748 Z M52.3582362,34.2046993 C52.618194,34.0541974 53.0368628,34.0541974 53.2968206,34.2046993 C53.5567784,34.3552012 53.5567784,34.5987406 53.2968206,34.7465061 C53.0368628,34.8970079 52.618194,34.8970079 52.3582362,34.7465061 C52.0982784,34.5987406 52.0982784,34.3552012 52.3582362,34.2046993 Z M46.1986046,49.3561341 C46.4585624,49.2056322 46.8799677,49.2056322 47.1399255,49.3561341 C47.3998833,49.506636 47.3998833,49.747439 47.1399255,49.8979409 C46.8799677,50.0484428 46.4585624,50.0484428 46.1986046,49.8979409 C45.9413832,49.747439 45.9413832,49.506636 46.1986046,49.3561341 Z M34.4594579,54.7112647 C34.7194157,54.5634992 35.140821,54.5634992 35.4007788,54.7112647 C35.6607366,54.8617665 35.6607366,55.105306 35.4007788,55.2558078 C35.140821,55.4035733 34.7194157,55.4035733 34.4594579,55.2558078 C34.2019629,55.105306 34.2019629,54.8617665 34.4594579,54.7112647 Z M45.788145,56.621544 C46.0481028,56.4710421 46.469508,56.4710421 46.7294658,56.621544 C46.9866872,56.7717722 46.9866872,57.0153116 46.7294658,57.1633508 C46.469508,57.313579 46.0481028,57.313579 45.788145,57.1633508 C45.5279135,57.0153116 45.5279135,56.7717722 45.788145,56.621544 Z M52.1639519,58.0934524 C52.4211733,57.9456869 52.8425786,57.9456869 53.1022627,58.0934524 C53.3624942,58.2442279 53.3624942,58.4874937 53.1022627,58.6382692 C52.8425786,58.7860347 52.4211733,58.7860347 52.1639519,58.6382692 C51.9039941,58.4874937 51.9039941,58.2442279 52.1639519,58.0934524 Z M9.77714946,58.3123642 C10.0343709,58.1618623 10.4557761,58.1618623 10.7157339,58.3123642 C10.9756917,58.4628661 10.9756917,58.7066791 10.7157339,58.854171 C10.4557761,59.0046729 10.0343709,59.0046729 9.77714946,58.854171 C9.51719167,58.7066791 9.51719167,58.4628661 9.77714946,58.3123642 Z M7.48952087,59.2919946 C7.74947867,59.1414928 8.17088393,59.1414928 8.43084173,59.2919946 C8.69079952,59.4427702 8.69079952,59.6832995 8.43084173,59.8338014 C8.17088393,59.9845769 7.74947867,59.9845769 7.48952087,59.8338014 C7.23229948,59.6832995 7.23229948,59.4427702 7.48952087,59.2919946 Z M25.0106762,60.7751223 C25.270634,60.6246204 25.6917656,60.6246204 25.9519971,60.7751223 C26.2116812,60.9228878 26.2116812,61.1664272 25.9519971,61.316929 C25.6917656,61.4674309 25.270634,61.4674309 25.0106762,61.316929 C24.7534548,61.1664272 24.7534548,60.9228878 25.0106762,60.7751223 Z M26.6932872,68.5878117 C26.9535187,68.4373098 27.3749239,68.4373098 27.6346081,68.5878117 C27.8921031,68.73804 27.8921031,68.9815794 27.6346081,69.1296185 C27.3749239,69.2798467 26.9535187,69.2798467 26.6932872,69.1296185 C26.4336031,68.9815794 26.4336031,68.73804 26.6932872,68.5878117 Z M22.8407127,69.3810935 C23.1006705,69.2305916 23.5220758,69.2305916 23.7817599,69.3810935 C24.0419914,69.531869 24.0419914,69.7751347 23.7817599,69.9229002 C23.5220758,70.0736758 23.1006705,70.0736758 22.8407127,69.9229002 C22.5807549,69.7751347 22.5807549,69.531869 22.8407127,69.3810935 Z M33.3922628,69.3975118 C33.6519469,69.2472836 34.0736258,69.2472836 34.3335836,69.3975118 C34.590805,69.5452773 34.590805,69.7890904 34.3335836,69.9393186 C34.0736258,70.0900941 33.6519469,70.0900941 33.3922628,69.9393186 C33.132305,69.7890904 33.132305,69.5452773 33.3922628,69.3975118 L33.3922628,69.3975118 Z"
          id="Fill-359"
          fill="#51A146"
        />
        <path
          d="M45.0274264,61.2433199 C45.0274264,60.3375723 45.7635174,59.6014812 46.6692651,59.6014812 C46.6692651,60.5072289 45.9359105,61.2433199 45.0274264,61.2433199"
          id="Fill-360"
          fill="#51A146"
        />
        <path
          d="M45.0274264,61.2433199 C45.0274264,60.3375723 44.2940717,59.6014812 43.3855877,59.6014812 C43.3855877,60.5072289 44.1216787,61.2433199 45.0274264,61.2433199"
          id="Fill-361"
          fill="#51A146"
        />
        <path
          d="M13.3673034,63.1040705 C13.3673034,62.1980491 14.100658,61.4622318 15.0091421,61.4622318 C15.0091421,62.3704422 14.2730511,63.1040705 13.3673034,63.1040705"
          id="Fill-362"
          fill="#9ECB94"
        />
        <path
          d="M13.3673034,63.1040705 C13.3673034,62.1980491 12.6312124,61.4622318 11.7254647,61.4622318 C11.7254647,62.3704422 12.4588193,63.1040705 13.3673034,63.1040705"
          id="Fill-363"
          fill="#9ECB94"
        />
        <path
          d="M61.711244,53.2530383 C61.711244,52.3470169 62.4445986,51.6111996 63.3503463,51.6111996 L63.3530827,51.6111996 C63.3530827,52.51941 62.6169917,53.2530383 61.711244,53.2530383"
          id="Fill-364"
          fill="#9ECB94"
        />
        <path
          d="M61.711244,53.2530383 C61.711244,52.3470169 60.9751529,51.6111996 60.0694053,51.6111996 C60.0694053,52.51941 60.8027599,53.2530383 61.7085076,53.2530383 L61.711244,53.2530383"
          id="Fill-365"
          fill="#9ECB94"
        />
        <path
          d="M29.4710047,53.8958181 C29.4710047,52.9903441 30.2043593,52.2539794 31.1128434,52.2539794 C31.1128434,53.1624635 30.3767524,53.8958181 29.4710047,53.8958181"
          id="Fill-366"
          fill="#9ECB94"
        />
        <path
          d="M29.4710047,53.8958181 C29.4710047,52.9903441 28.7349137,52.2539794 27.829166,52.2539794 C27.829166,53.1624635 28.5625206,53.8958181 29.4710047,53.8958181"
          id="Fill-367"
          fill="#9ECB94"
        />
        <path
          d="M31.6409682,64.7459092 C31.6409682,63.8398878 32.3740491,63.1040705 33.2800705,63.1040705 L33.2828069,63.1040705 C33.2828069,64.0122809 32.5467158,64.7459092 31.6409682,64.7459092"
          id="Fill-368"
          fill="#51A146"
        />
        <path
          d="M31.6409682,64.7459092 C31.6409682,63.8398878 30.9048771,63.1040705 29.9991295,63.1040705 C29.9991295,64.0122809 30.7322104,64.7459092 31.6382318,64.7459092 L31.6409682,64.7459092"
          id="Fill-369"
          fill="#51A146"
        />
        <path
          d="M42.9395548,50.8310525 C42.9395548,49.9253049 43.6756458,49.1892138 44.5813935,49.1892138 C44.5813935,50.0979716 43.8477653,50.8310525 42.9395548,50.8310525"
          id="Fill-370"
          fill="#51A146"
        />
        <path
          d="M42.9395548,50.8310525 C42.9395548,49.9253049 42.2059266,49.1892138 41.2977161,49.1892138 C41.2977161,50.0979716 42.0338071,50.8310525 42.9395548,50.8310525"
          id="Fill-371"
          fill="#51A146"
        />
        <path
          d="M50.5741048,42.4522024 C50.5741048,41.5467283 51.3101958,40.8103637 52.2159435,40.8103637 C52.2159435,41.7161113 51.4825889,42.4522024 50.5741048,42.4522024"
          id="Fill-372"
          fill="#51A146"
        />
        <path
          d="M50.5741048,42.4522024 C50.5741048,41.5467283 49.8407502,40.8103637 48.9322661,40.8103637 C48.9322661,41.7161113 49.6683571,42.4522024 50.5741048,42.4522024"
          id="Fill-373"
          fill="#51A146"
        />
        <path
          d="M55.7212691,48.2700578 C55.7212691,47.3613001 56.4546237,46.6282191 57.3631078,46.6282191 C57.3631078,47.5336931 56.6270168,48.2700578 55.7212691,48.2700578"
          id="Fill-374"
          fill="#51A146"
        />
        <path
          d="M55.7212691,48.2700578 C55.7212691,47.3613001 54.9851781,46.6282191 54.0794304,46.6282191 C54.0794304,47.5336931 54.812785,48.2700578 55.7212691,48.2700578"
          id="Fill-375"
          fill="#51A146"
        />
        <path
          d="M55.7568423,30.3244872 L-2.50111043e-13,62.70182 L49.832541,91.5543988 C49.832541,90.9794816 49.832541,90.4021016 49.832541,89.8274581 C59.2895319,84.5626286 67.1211025,78.3373236 76.5808298,73.0727678 C86.0597119,67.7967191 95.538594,62.5212177 105.017476,57.2427063 C88.5990891,48.2700578 72.1779657,39.2974093 55.7568423,30.3244872"
          id="Fill-376"
          fill="#9E9F9E"
        />
        <polyline
          id="Fill-377"
          fill="#B4B5B4"
          points="56.0304821 28.5978201 0.273639783 60.9751529 49.832541 89.8274581 106.724988 58.2083811 56.0304821 28.5978201"
        />
        <polyline
          id="Fill-378"
          fill="#9E9F9E"
          points="0.0301003762 60.9751529 1.5214372 61.8341082 0.0301003762 62.70182 0.0301003762 60.9751529"
        />
        <line
          x1="105.017476"
          y1="57.2479055"
          x2="103.498502"
          y2="58.0934524"
          id="Fill-379"
          fill="#9E9F9E"
        />
        <path
          d="M40.9173568,41.0429575 C42.4853128,40.1372098 45.0356356,40.1372098 46.6035915,41.0429575 C48.1742839,41.9517152 48.1742839,43.4208872 46.6035915,44.3296449 C45.0356356,45.2353926 42.4853128,45.2353926 40.9173568,44.3296449 C39.3463908,43.4208872 39.3463908,41.9517152 40.9173568,41.0429575"
          id="Fill-2225"
          fill="#71A241"
        />
        <polyline
          id="Fill-2226"
          fill="#E4E4E3"
          points="66.9842826 80.4580319 38.2849421 64.4202778 38.2849421 21.1657636 67.2743408 38.7939121 66.9842826 80.4580319"
        />
        <polyline
          id="Fill-2227"
          fill="#B4B5B4"
          points="52.858997 -4.85063841e-13 38.2849421 21.2588011 67.2716044 38.8869496 81.3282064 16.6890168 52.858997 -4.85063841e-13"
        />
        <polyline
          id="Fill-2228"
          fill="#9E9F9E"
          points="52.858997 -8.48861722e-13 67.2743408 4.7969054 95.6781503 21.1657636 81.3282064 16.6890168 52.858997 -8.48861722e-13"
        />
        <polyline
          id="Fill-2229"
          fill="#F8F7F6"
          points="66.9788098 80.4580319 95.6781503 64.4202778 95.6781503 21.1657636 81.3282064 16.6890168 67.2743408 38.7939121 66.9788098 80.4580319"
        />
        <polyline
          id="Fill-2230"
          fill="#E4E4E3"
          points="70.9274319 52.9216605 78.2336141 48.702135 78.2336141 74.1697897 70.9274319 78.2336141 70.9274319 52.9216605"
        />
        <polyline
          id="Fill-2231"
          fill="#E4E4E3"
          points="83.1314926 46.493862 89.7894221 42.652233 89.7894221 56.621544 83.1314926 60.7261407 83.1314926 46.493862"
        />
        <polyline
          id="Fill-2232"
          fill="#FFFFFE"
          points="62.0259297 52.6781211 55.3710102 48.8334821 55.3710102 62.8058031 62.0259297 66.9073898 62.0259297 52.6781211"
        />
        <polyline
          id="Fill-2233"
          fill="#FFFFFE"
          points="49.2086423 46.493862 42.5537227 42.652233 42.5537227 56.621544 49.2086423 60.7261407 49.2086423 46.493862"
        />
        <path
          d="M56.139938,87.5756763 C56.139938,86.6669186 55.403847,85.9338376 54.4980993,85.9338376 C54.4980993,86.8393116 55.2341903,87.5756763 56.139938,87.5756763 L56.139938,87.5726663 L56.139938,87.5756763"
          id="Fill-2234"
          fill="#9ECB94"
        />
        <path
          d="M93.3218381,66.8909714 C93.3218381,65.9824873 94.0579291,65.2491327 94.9636768,65.2491327 C94.9636768,66.1548804 94.2305958,66.8909714 93.3248482,66.8909714 L93.3218381,66.8909714"
          id="Fill-2235"
          fill="#51A146"
        />
        <path
          d="M93.3218381,66.8909714 C93.3218381,65.9824873 92.5887571,65.2491327 91.6830095,65.2491327 C91.6830095,66.1548804 92.4160904,66.8909714 93.3248482,66.8909714 L93.3218381,66.8909714"
          id="Fill-2236"
          fill="#51A146"
        />
        <path
          d="M72.7396012,83.264845 C71.0586704,83.264845 69.624532,84.4149899 69.0514251,86.0331343 C68.9609345,86.0251928 68.8701698,86.0167037 68.7772113,86.0167037 C67.9326326,86.0167037 67.1483811,86.3099906 66.5067207,86.8081129 C65.8623182,86.3099906 65.0808087,86.0167037 64.233488,86.0167037 C63.7316767,86.0167037 63.2545446,86.1237767 62.8130603,86.3099906 C62.4319031,85.9591964 61.9904188,85.6883647 61.5078025,85.5155691 C60.86861,84.0587189 59.5142679,83.0539851 57.9427484,83.0539851 C55.7547962,83.0539851 53.9806326,84.9982777 53.9806326,87.394413 C53.9806326,89.3192627 55.1268465,90.9486347 56.7087861,91.5185041 C57.3479786,92.9726159 58.7025949,93.9776235 60.2738402,93.9776235 C60.7729094,93.9776235 61.2500415,93.8708243 61.6912515,93.687075 C62.3798025,94.3171901 63.2652389,94.6975594 64.233488,94.6975594 C65.0808087,94.6975594 65.8623182,94.4048202 66.5067207,93.9091625 C67.1483811,94.4048202 67.9326326,94.6975594 68.7772113,94.6975594 C70.4581421,94.6975594 71.8922804,93.5504268 72.4653874,91.9317347 C72.5558779,91.9372116 72.6463685,91.9457008 72.7396012,91.9457008 C74.9250855,91.9457008 76.699249,90.0041466 76.699249,87.6052729 C76.699249,85.2091376 74.9250855,83.264845 72.7396012,83.264845"
          id="Fill-3440"
          fill="#428849"
        />
        <path
          d="M72.3197798,78.387409 C70.6936918,78.5793737 69.4542452,79.9595476 69.1035257,81.7392599 C69.0157773,81.7450107 68.9280289,81.7450107 68.8372641,81.7556906 C68.0201069,81.851536 67.3019408,82.2543605 66.7422704,82.8510667 C66.05701,82.399224 65.264532,82.1804227 64.4473748,82.2762681 C63.9620163,82.3337753 63.5147735,82.5008202 63.1116792,82.747006 C62.7003584,82.4211316 62.2369371,82.1828873 61.7491106,82.0544544 C60.9484062,80.5893888 59.5142679,79.6772144 57.9951232,79.8579514 C55.8806603,80.1071495 54.4111484,82.369375 54.7127836,84.9079092 C54.9568339,86.9477734 56.2648339,88.5415456 57.8662427,88.9632654 C58.6669471,90.4310695 60.1038276,91.3402316 61.6229723,91.1597684 C62.1055886,91.1022612 62.5525572,90.9349425 62.9556515,90.6884828 C63.7012389,91.2799859 64.6036767,91.5814882 65.5387459,91.4716768 C66.3556289,91.3730929 67.0770855,90.9732806 67.6362075,90.3763006 C68.3192742,90.8256787 69.1142201,91.0472185 69.9316515,90.9513731 C71.5549974,90.7569438 72.794444,89.3767699 73.1454377,87.5967837 C73.2359282,87.5943191 73.3234025,87.5913069 73.4114251,87.5803531 C75.5256138,87.3314289 76.9926578,85.0692033 76.6910226,82.5306692 C76.3893874,79.992135 74.4315006,78.1354725 72.3197798,78.387409"
          id="Fill-3441"
          fill="#4E9C52"
        />
        <path
          d="M71.8730855,79.3130018 C70.3895886,79.3130018 69.1254628,80.129057 68.617893,81.2819404 C68.5386452,81.2764635 68.458849,81.2709866 68.3768591,81.2709866 C67.6279811,81.2709866 66.9372364,81.4818465 66.3693396,81.8323669 C65.8019911,81.4818465 65.1109723,81.2709866 64.3623685,81.2709866 C63.9208842,81.2709866 63.4985949,81.347663 63.1092113,81.4791081 C62.7719282,81.22991 62.3825446,81.0384931 61.954771,80.9125248 C61.3898905,79.8771205 60.1943182,79.1623876 58.8067962,79.1623876 C56.8735886,79.1623876 55.3078276,80.5453 55.3078276,82.2513483 C55.3078276,83.6233069 56.3196767,84.7816671 57.7154251,85.1872301 C58.2803056,86.2220867 59.4758779,86.9395581 60.8661421,86.9395581 C61.3076264,86.9395581 61.7299157,86.8631556 62.1192993,86.7317104 C62.7253119,87.1805408 63.5068213,87.4516464 64.3623685,87.4516464 C65.1109723,87.4516464 65.8019911,87.2435249 66.3693396,86.8902661 C66.9372364,87.2435249 67.6279811,87.4516464 68.3768591,87.4516464 C69.8603559,87.4516464 71.1272238,86.6355912 71.6345194,85.4829817 C71.7140415,85.4857201 71.7932893,85.4936616 71.8730855,85.4936616 C73.8060188,85.4936616 75.372054,84.1082846 75.372054,82.4022363 C75.372054,80.696188 73.8060188,79.3130018 71.8730855,79.3130018"
          id="Fill-3442"
          fill="#70BA64"
        />
        <path
          d="M59.8460666,81.254556 C61.0934654,81.254556 62.1576893,80.5672075 62.5854628,79.5977996 C62.6512742,79.6035503 62.7195534,79.6062888 62.7883811,79.6062888 C63.4163308,79.6062888 63.9973899,79.4310286 64.4747962,79.1350032 C64.9519282,79.4310286 65.5329874,79.6062888 66.1612113,79.6062888 C66.5341421,79.6062888 66.8878779,79.5433046 67.2166603,79.4334932 C67.4993748,79.6418885 67.8284314,79.8031826 68.1876515,79.9072434 C68.6620415,80.7780674 69.6684062,81.3807981 70.833815,81.3807981 C72.4599031,81.3807981 73.7761295,80.216961 73.7761295,78.7820182 C73.7761295,77.6315995 72.9260666,76.6569886 71.7524314,76.3146835 C71.2752993,75.4438595 70.2716767,74.8411288 69.1035257,74.8411288 C68.7305949,74.8411288 68.3768591,74.9068514 68.0505446,75.016389 C67.5377647,74.6387581 66.8796515,74.4111937 66.1612113,74.4111937 C65.5329874,74.4111937 64.9519282,74.5864539 64.4747962,74.8824793 C63.9973899,74.5864539 63.4163308,74.4111937 62.7883811,74.4111937 C61.537966,74.4111937 60.4740163,75.098816 60.0489849,76.0679501 C59.9801572,76.0624732 59.9146201,76.0600086 59.8460666,76.0600086 C58.2227207,76.0600086 56.9037521,77.2208334 56.9037521,78.65605 C56.9037521,80.0909927 58.2227207,81.254556 59.8460666,81.254556"
          id="Fill-3443"
          fill="#88C37D"
        />
        <path
          d="M59.2729597,77.0841853 C60.5203584,77.0841853 61.5845823,77.7712599 62.0120817,78.7409416 C62.0809094,78.7351909 62.1464465,78.7324525 62.2152742,78.7324525 C62.8432238,78.7324525 63.4245572,78.9077127 63.901415,79.2034642 C64.3815635,78.9077127 64.9626226,78.7324525 65.5908465,78.7324525 C65.9610352,78.7324525 66.3175132,78.7957104 66.6438276,78.9049742 C66.9262679,78.6968527 67.2553245,78.5355586 67.6145446,78.4314979 C68.0889345,77.5604 69.0950251,76.9579432 70.263176,76.9579432 C71.8867962,76.9579432 73.2030226,78.1217803 73.2030226,79.556723 C73.2030226,80.7071418 72.3529597,81.6817527 71.1793245,82.0240577 C70.7049345,82.8948817 69.6985698,83.4976124 68.5304188,83.4976124 C68.1602301,83.4976124 67.8037521,83.4318899 67.4774377,83.3223523 C66.9671257,83.6999832 66.3092867,83.9272737 65.5908465,83.9272737 C64.9626226,83.9272737 64.3815635,83.7520136 63.901415,83.456262 C63.4245572,83.7520136 62.8432238,83.9272737 62.2152742,83.9272737 C60.9676012,83.9272737 59.9033773,83.2401991 59.4758779,82.2707912 C59.4097924,82.2762681 59.3415132,82.2787327 59.2729597,82.2787327 C57.6496138,82.2787327 56.3333874,81.1179078 56.3333874,79.6829651 C56.3333874,78.2477485 57.6496138,77.0841853 59.2729597,77.0841853"
          id="Fill-3444"
          fill="#88C37D"
        />
        <path
          d="M75.1609094,94.0156878 C74.3163308,94.0156878 73.5951484,94.5937726 73.3044817,95.4098278 C73.2606075,95.4043509 73.2139911,95.4013386 73.1673748,95.4013386 C72.7423433,95.4013386 72.3474754,95.5494882 72.0239031,95.7984124 C71.7003308,95.5494882 71.3051886,95.4013386 70.8801572,95.4013386 C70.6281547,95.4013386 70.3895886,95.453369 70.1672012,95.5494882 C69.9755257,95.3712158 69.7534125,95.2345676 69.5093622,95.1466637 C69.1857899,94.4155001 68.5057396,93.9091625 67.7160037,93.9091625 C66.6136641,93.9091625 65.7224691,94.8865118 65.7224691,96.0944378 C65.7224691,97.0638457 66.2983182,97.8826394 67.0935383,98.1699017 C67.4143685,98.9013392 68.097161,99.4079506 68.8868968,99.4079506 C69.1388993,99.4079506 69.3804817,99.3531818 69.6025949,99.2600748 C69.9481043,99.5774601 70.3950729,99.7694247 70.8801572,99.7694247 C71.3051886,99.7694247 71.7003308,99.621549 72.0239031,99.372077 C72.3474754,99.621549 72.7423433,99.7694247 73.1673748,99.7694247 C74.0146955,99.7694247 74.7356037,99.1916138 75.0238025,98.3780232 C75.0704188,98.3810355 75.114293,98.3837739 75.1609094,98.3837739 C76.2605069,98.3837739 77.154444,97.4058769 77.154444,96.2009632 C77.154444,94.9935848 76.2605069,94.0156878 75.1609094,94.0156878"
          id="Fill-3445"
          fill="#428849"
        />
        <path
          d="M74.9497647,91.5593069 C74.1326075,91.6578907 73.5073999,92.3534545 73.3319031,93.2491984 C73.2880289,93.2491984 73.2441547,93.251663 73.1975383,93.2571398 C72.7862176,93.3039672 72.4242553,93.5063379 72.1445572,93.8078402 C71.7990477,93.5802758 71.3986955,93.4707382 70.9873748,93.5175655 C70.7433245,93.5474145 70.5184691,93.6323062 70.3155509,93.7558098 C70.1098905,93.5915034 69.8768087,93.4707382 69.6300163,93.4077541 C69.226922,92.6683752 68.5057396,92.2113295 67.740683,92.301698 C66.6767333,92.4276663 65.9388238,93.5638452 66.0899157,94.8426968 C66.2133119,95.8696119 66.8714251,96.6722487 67.6776138,96.8828348 C68.0807081,97.6224875 68.8018905,98.0798071 69.5669471,97.9891647 C69.8109974,97.9593157 70.0358528,97.8768886 70.2384968,97.7509204 C70.6117018,98.0494104 71.0668968,98.2002984 71.5385446,98.1455296 C71.9498654,98.0959639 72.3118276,97.8963316 72.5942679,97.5948293 C72.936761,97.8223937 73.3373874,97.9316574 73.7487081,97.8826394 C74.5658654,97.7865201 75.1883308,97.0909563 75.3665698,96.1954863 C75.410444,96.1927479 75.4543182,96.1927479 75.5009345,96.1875448 C76.5618679,96.0613027 77.3022452,94.92485 77.1489597,93.6462722 C76.9978679,92.3671467 76.0137144,91.4333386 74.9497647,91.5593069"
          id="Fill-3446"
          fill="#428849"
        />
        <path
          d="M74.7249094,92.0275801 C73.9787735,92.0275801 73.3425974,92.4383462 73.0878528,93.0191694 C73.0464465,93.0161571 73.0055886,93.0136925 72.9671987,93.0136925 C72.5887836,93.0136925 72.240532,93.1177532 71.9550754,93.295478 C71.6701672,93.1177532 71.3219157,93.0136925 70.9459685,93.0136925 C70.7241295,93.0136925 70.5102427,93.0517568 70.3155509,93.1177532 C70.1455383,92.991785 69.9481043,92.8956657 69.7342176,92.8326816 C69.4490352,92.3123779 68.8485069,91.9509038 68.1492616,91.9509038 C67.1782704,91.9509038 66.3888087,92.6464677 66.3888087,93.5063379 C66.3888087,94.1964249 66.8988465,94.7797127 67.6008339,94.9823572 C67.8857421,95.5056732 68.4865446,95.864135 69.1857899,95.864135 C69.4079031,95.864135 69.6190477,95.8260707 69.8164817,95.7600743 C70.1208591,95.9873648 70.5154528,96.1245607 70.9459685,96.1245607 C71.3219157,96.1245607 71.6701672,96.0174877 71.9550754,95.8394891 C72.240532,96.0174877 72.5887836,96.1245607 72.9671987,96.1245607 C73.7130603,96.1245607 74.3492364,95.7110562 74.6042553,95.130233 C74.6451132,95.1329715 74.6865194,95.1359837 74.7249094,95.1359837 C75.6983685,95.1359837 76.4853622,94.4401461 76.4853622,93.5802758 C76.4853622,92.723144 75.6983685,92.0275801 74.7249094,92.0275801"
          id="Fill-3447"
          fill="#428849"
        />
        <path
          d="M68.67301,93.0052033 C69.3006855,93.0052033 69.8356767,92.6574214 70.0520314,92.1702529 C70.0852113,92.1727175 70.1181169,92.1754559 70.1537647,92.1754559 C70.4688364,92.1754559 70.7625194,92.0878258 71.0010855,91.9372116 C71.2423937,92.0878258 71.5355282,92.1754559 71.8511484,92.1754559 C72.0373396,92.1754559 72.2158528,92.1425946 72.3831232,92.0878258 C72.5229723,92.1921604 72.6902427,92.2740398 72.8712238,92.3260701 C73.1097899,92.7642206 73.6143433,93.0681875 74.2039031,93.0681875 C75.0210603,93.0681875 75.6819157,92.4824351 75.6819157,91.7594868 C75.6819157,91.1816759 75.2541421,90.6884828 74.6643081,90.5186995 C74.4260163,90.0808229 73.9187207,89.7765822 73.3319031,89.7765822 C73.1454377,89.7765822 72.9671987,89.8094435 72.7999282,89.8644862 C72.5446352,89.6752599 72.2131106,89.5602454 71.8511484,89.5602454 C71.5355282,89.5602454 71.2423937,89.6481494 71.0010855,89.7987636 C70.7625194,89.6481494 70.4688364,89.5602454 70.1537647,89.5602454 C69.5255408,89.5602454 68.9883559,89.9055628 68.7744691,90.3927313 C68.7415635,90.3927313 68.7059157,90.3899928 68.67301,90.3899928 C67.8558528,90.3899928 67.1919811,90.9732806 67.1919811,91.6962289 C67.1919811,92.4191771 67.8558528,93.0052033 68.67301,93.0052033"
          id="Fill-3448"
          fill="#428849"
        />
        <path
          d="M68.3850855,90.9048196 C69.0130352,90.9048196 69.5477521,91.2501369 69.7643811,91.7403178 C69.7972867,91.7373055 69.8301924,91.7348409 69.865566,91.7348409 C70.1811861,91.7348409 70.4745949,91.8221971 70.7128867,91.9728113 C70.9544691,91.8221971 71.2478779,91.7348409 71.5629496,91.7348409 C71.749415,91.7348409 71.927654,91.7674283 72.0951987,91.8221971 C72.2350477,91.715398 72.4023182,91.6359832 72.5832993,91.5839528 C72.8215911,91.1433378 73.3264188,90.8418355 73.9159786,90.8418355 C74.7331358,90.8418355 75.3939911,91.4278617 75.3939911,92.1480715 C75.3939911,92.7288947 74.9662176,93.2190755 74.3763836,93.3913234 C74.1380918,93.8297477 73.6307962,94.1337146 73.0439786,94.1337146 C72.8575132,94.1337146 72.6792742,94.1005795 72.5120037,94.0430722 C72.2569849,94.234763 71.9251861,94.3500514 71.5629496,94.3500514 C71.2478779,94.3500514 70.9544691,94.2624213 70.7128867,94.1118071 C70.4745949,94.2624213 70.1811861,94.3500514 69.865566,94.3500514 C69.2378905,94.3500514 68.7004314,94.004734 68.4865446,93.5148271 C68.4536389,93.5175655 68.4179911,93.5200301 68.3850855,93.5200301 C67.5679282,93.5200301 66.9043308,92.9342777 66.9043308,92.2137941 C66.9043308,91.4908458 67.5679282,90.9048196 68.3850855,90.9048196"
          id="Fill-3449"
          fill="#428849"
        />
      </g>
    </g>
  </svg>
)

export const step28Image3 = (
  <svg
    width="70px"
    height="70px"
    viewBox="0 0 128 128"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    aria-hidden="true"
  >
    <g
      id="5.climate/climate_2.3"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Group" transform="translate(0.000000, 11.200000)">
        <polyline
          id="Fill-260"
          fill="#54A044"
          points="55.7620414 30.5080995 7.57912251e-15 62.8851586 70.2104956 103.427629 127.045205 71.8058156 55.7620414 30.5080995"
        />
        <polyline
          id="Fill-261"
          fill="#75B86A"
          points="55.7620414 28.7814324 7.57912251e-15 61.1557552 70.2104956 101.701236 127.045205 70.0794222 55.7620414 28.7814324"
        />
        <polyline
          id="Fill-263"
          fill="#54A044"
          points="127.045205 70.0794222 125.513096 70.9249691 127.045205 71.8058156 127.045205 70.0794222"
        />
        <path
          d="M84.3847628,78.1761497 C84.6313122,78.0283843 85.0691359,78.0283843 85.315138,78.1761497 C85.5887778,78.3266516 85.5887778,78.5704647 85.315138,78.7209665 C85.0691359,78.8684584 84.6313122,78.8684584 84.3847628,78.7209665 C84.1113966,78.5704647 84.1113966,78.3266516 84.3847628,78.1761497 Z M68.5960209,79.9192352 C68.8696607,79.7687333 69.2801204,79.7687333 69.5537602,79.9192352 C69.800036,80.069737 69.800036,80.3132764 69.5537602,80.4610419 C69.2801204,80.6115438 68.8696607,80.6115438 68.5960209,80.4610419 C68.3494715,80.3132764 68.3494715,80.069737 68.5960209,79.9192352 Z M91.0344832,70.4649806 C91.3081229,70.3144788 91.7185826,70.3144788 91.9648584,70.4649806 C92.2384982,70.6154825 92.2384982,70.8592956 91.9648584,71.0067874 C91.7185826,71.1572893 91.3081229,71.1572893 91.0344832,71.0067874 C90.7882074,70.8592956 90.7882074,70.6154825 91.0344832,70.4649806 Z M111.612195,69.25002 C111.885561,69.0995181 112.296021,69.0995181 112.569934,69.25002 C112.815936,69.4007955 112.815936,69.6440613 112.569934,69.7945632 C112.296021,69.9426023 111.885561,69.9426023 111.612195,69.7945632 C111.365919,69.6440613 111.365919,69.4007955 111.612195,69.25002 Z M107.918058,64.3518679 C108.191424,64.2041024 108.601884,64.2041024 108.848433,64.3518679 C109.121799,64.5023698 109.121799,64.7461828 108.848433,64.8966847 C108.601884,65.0471866 108.191424,65.0471866 107.918058,64.8966847 C107.671782,64.7461828 107.671782,64.5023698 107.918058,64.3518679 Z M100.666604,57.8775506 C100.940243,57.7273224 101.350703,57.7273224 101.624069,57.8775506 C101.870619,58.0283261 101.870619,58.2718655 101.624069,58.4193574 C101.350703,58.5701329 100.940243,58.5701329 100.666604,58.4193574 C100.420328,58.2718655 100.420328,58.0283261 100.666604,57.8775506 Z M80.5540795,68.9024975 C80.8000816,68.7522692 81.2381789,68.7522692 81.4841811,68.9024975 C81.7580945,69.050263 81.7580945,69.294076 81.4841811,69.4443042 C81.2381789,69.5950798 80.8000816,69.5950798 80.5540795,69.4443042 C80.3078037,69.294076 80.3078037,69.050263 80.5540795,68.9024975 Z M87.3403461,64.3518679 C87.6139859,64.2041024 88.0244455,64.2041024 88.2980853,64.3518679 C88.5443611,64.5023698 88.5443611,64.7461828 88.2980853,64.8966847 C88.0244455,65.0471866 87.6139859,65.0471866 87.3403461,64.8966847 C87.0940703,64.7461828 87.0940703,64.5023698 87.3403461,64.3518679 Z M100.009868,66.1827917 C100.283508,66.0347525 100.693968,66.0347525 100.940243,66.1827917 C101.213609,66.3332935 101.213609,66.5765593 100.940243,66.7273348 C100.693968,66.8775631 100.283508,66.8775631 100.009868,66.7273348 C99.7635923,66.5765593 99.7635923,66.3332935 100.009868,66.1827917 Z M72.9195295,82.7516806 C73.1931693,82.6011787 73.603629,82.6011787 73.8499048,82.7516806 C74.1232709,82.9021824 74.1232709,83.1457218 73.8499048,83.2959501 C73.603629,83.4439892 73.1931693,83.4439892 72.9195295,83.2959501 C72.6732537,83.1457218 72.6732537,82.9021824 72.9195295,82.7516806 Z M109.833263,72.5501158 C110.107176,72.3998875 110.517636,72.3998875 110.763638,72.5501158 C111.037278,72.7006177 111.037278,72.9441571 110.763638,73.0949326 C110.517636,73.2424244 110.107176,73.2424244 109.833263,73.0949326 C109.58726,72.9441571 109.58726,72.7006177 109.833263,72.5501158 Z M73.7404488,73.7954504 C74.0140886,73.647685 74.4245483,73.647685 74.6708241,73.7954504 C74.9441903,73.9459523 74.9441903,74.1894917 74.6708241,74.3399936 C74.4245483,74.4877591 74.0140886,74.4877591 73.7404488,74.3399936 C73.494173,74.1894917 73.494173,73.9459523 73.7404488,73.7954504 Z M58.6081688,83.1345026 C58.8544446,82.9867371 59.2922683,82.9867371 59.5385441,83.1345026 C59.8121839,83.2850045 59.8121839,83.5288175 59.5385441,83.6790458 C59.2922683,83.8298213 58.8544446,83.8298213 58.6081688,83.6790458 C58.334529,83.5288175 58.334529,83.2850045 58.6081688,83.1345026 Z M94.9201681,78.1761497 C95.1938079,78.0283843 95.6042675,78.0283843 95.8776337,78.1761497 C96.1241831,78.3266516 96.1241831,78.5704647 95.8776337,78.7209665 C95.6042675,78.8684584 95.1938079,78.8684584 94.9201681,78.7209665 C94.6738923,78.5704647 94.6738923,78.3266516 94.9201681,78.1761497 Z M97.1640143,79.1530438 C97.4102901,79.0028155 97.8481138,79.0028155 98.0943896,79.1530438 C98.3680294,79.3008092 98.3680294,79.5446223 98.0943896,79.6948505 C97.8481138,79.8453524 97.4102901,79.8453524 97.1640143,79.6948505 C96.8903745,79.5446223 96.8903745,79.3008092 97.1640143,79.1530438 Z M81.5391827,85.6218882 C81.8128225,85.47166 82.2232821,85.47166 82.4969219,85.6218882 C82.7429241,85.7696537 82.7429241,86.0134668 82.4969219,86.1639687 C82.2232821,86.3144705 81.8128225,86.3144705 81.5391827,86.1639687 C81.2929069,86.0134668 81.2929069,85.7696537 81.5391827,85.6218882 Z M61.6455704,86.1418038 C61.9189366,85.9915756 62.3293962,85.9915756 62.603036,86.1418038 C62.8495855,86.2925794 62.8495855,86.5358451 62.603036,86.6836106 C62.3293962,86.8343861 61.9189366,86.8343861 61.6455704,86.6836106 C61.399021,86.5358451 61.399021,86.2925794 61.6455704,86.1418038 Z M63.5336849,89.4418996 C63.7799607,89.2941341 64.2177844,89.2941341 64.4640602,89.4418996 C64.7377,89.5926751 64.7377,89.8359409 64.4640602,89.9867164 C64.2177844,90.1369447 63.7799607,90.1369447 63.5336849,89.9867164 C63.2874091,89.8359409 63.2874091,89.5926751 63.5336849,89.4418996 Z M81.5391827,89.9894528 C81.8128225,89.8414137 82.2232821,89.8414137 82.4969219,89.9894528 C82.7429241,90.1399547 82.7429241,90.3832205 82.4969219,90.533996 C82.2232821,90.6842242 81.8128225,90.6842242 81.5391827,90.533996 C81.2929069,90.3832205 81.2929069,90.1399547 81.5391827,89.9894528 L81.5391827,89.9894528 Z"
          id="Fill-264"
          fill="#9ECB94"
        />
        <path
          d="M62.3293962,77.2430381 C62.5759457,77.0952726 62.9864054,77.0952726 63.2600451,77.2430381 C63.5063209,77.3938136 63.5063209,77.6370794 63.2600451,77.7878549 C62.9864054,77.9356204 62.5759457,77.9356204 62.3293962,77.7878549 C62.0560301,77.6370794 62.0560301,77.3938136 62.3293962,77.2430381 Z M74.5613682,71.231172 C74.835008,71.0834066 75.2454677,71.0834066 75.4917435,71.231172 C75.7651096,71.3816739 75.7651096,71.625487 75.4917435,71.7757152 C75.2454677,71.9264907 74.835008,71.9264907 74.5613682,71.7757152 C74.3150924,71.625487 74.3150924,71.3816739 74.5613682,71.231172 Z M82.1959182,71.6170041 C82.4695579,71.4667759 82.8800176,71.4667759 83.1533838,71.6170041 C83.3999332,71.767506 83.3999332,72.008309 83.1533838,72.1588109 C82.8800176,72.3093128 82.4695579,72.3093128 82.1959182,72.1588109 C81.9496424,72.008309 81.9496424,71.767506 82.1959182,71.6170041 Z M85.4795956,67.526363 C85.7532353,67.3785975 86.163695,67.3785975 86.4370612,67.526363 C86.6836106,67.6765912 86.6836106,67.9204043 86.4370612,68.0706325 C86.163695,68.2211344 85.7532353,68.2211344 85.4795956,68.0706325 C85.2333198,67.9204043 85.2333198,67.6765912 85.4795956,67.526363 Z M99.0521288,63.156062 C99.3257686,63.0058338 99.7362283,63.0058338 99.9822304,63.156062 C100.256144,63.3068375 100.256144,63.5501033 99.9822304,63.6978688 C99.7362283,63.8486443 99.3257686,63.8486443 99.0521288,63.6978688 C98.805853,63.5501033 98.805853,63.3068375 99.0521288,63.156062 Z M66.0785349,78.1761497 C66.3245371,78.0283843 66.7626344,78.0283843 67.0089102,78.1761497 C67.28255,78.3266516 67.28255,78.5704647 67.0089102,78.7209665 C66.7626344,78.8684584 66.3245371,78.8684584 66.0785349,78.7209665 C65.8322591,78.5704647 65.8322591,78.3266516 66.0785349,78.1761497 Z M114.266501,67.8325659 C114.512777,67.682064 114.9506,67.682064 115.196876,67.8325659 C115.470516,67.9803314 115.470516,68.2238708 115.196876,68.3746463 C114.9506,68.5248746 114.512777,68.5248746 114.266501,68.3746463 C113.992861,68.2238708 113.992861,67.9803314 114.266501,67.8325659 Z M116.045159,68.9024975 C116.291435,68.7522692 116.729259,68.7522692 116.975535,68.9024975 C117.249174,69.050263 117.249174,69.294076 116.975535,69.4443042 C116.729259,69.5950798 116.291435,69.5950798 116.045159,69.4443042 C115.77152,69.294076 115.77152,69.050263 116.045159,68.9024975 Z M69.9368559,73.0289854 C70.1831317,72.8787572 70.6209553,72.8787572 70.8672311,73.0289854 C71.1408709,73.1767509 71.1408709,73.4205639 70.8672311,73.5710658 C70.6209553,73.7215677 70.1831317,73.7215677 69.9368559,73.5710658 C69.6632161,73.4205639 69.6632161,73.1767509 69.9368559,73.0289854 Z M94.9201681,58.6440156 C95.1938079,58.4962502 95.6042675,58.4962502 95.8776337,58.6440156 C96.1241831,58.7945175 96.1241831,59.0380569 95.8776337,59.1882852 C95.6042675,59.3390607 95.1938079,59.3390607 94.9201681,59.1882852 C94.6738923,59.0380569 94.6738923,58.7945175 94.9201681,58.6440156 Z M88.763273,73.7954504 C89.0369127,73.647685 89.4473724,73.647685 89.7207386,73.7954504 C89.967288,73.9459523 89.967288,74.1894917 89.7207386,74.3399936 C89.4473724,74.4877591 89.0369127,74.4877591 88.763273,74.3399936 C88.5169972,74.1894917 88.5169972,73.9459523 88.763273,73.7954504 Z M77.0241263,79.1530438 C77.297766,79.0028155 77.7082257,79.0028155 77.9818655,79.1530438 C78.2278677,79.3008092 78.2278677,79.5446223 77.9818655,79.6948505 C77.7082257,79.8453524 77.297766,79.8453524 77.0241263,79.6948505 C76.7778504,79.5446223 76.7778504,79.3008092 77.0241263,79.1530438 Z M88.3528133,81.0603131 C88.6264531,80.9125476 89.0369127,80.9125476 89.3102789,81.0603131 C89.5568283,81.2108149 89.5568283,81.4543543 89.3102789,81.6048562 C89.0369127,81.7526217 88.6264531,81.7526217 88.3528133,81.6048562 C88.1065375,81.4543543 88.1065375,81.2108149 88.3528133,81.0603131 Z M94.7286202,82.5355051 C95.00226,82.3847296 95.4127197,82.3847296 95.6863595,82.5355051 C95.9326353,82.682997 95.9326353,82.9265364 95.6863595,83.0773119 C95.4127197,83.2275401 95.00226,83.2275401 94.7286202,83.0773119 C94.4823444,82.9265364 94.4823444,82.682997 94.7286202,82.5355051 Z M52.3415441,82.7516806 C52.6154576,82.6011787 53.0259172,82.6011787 53.2992834,82.7516806 C53.5458328,82.9021824 53.5458328,83.1457218 53.2992834,83.2959501 C53.0259172,83.4439892 52.6154576,83.4439892 52.3415441,83.2959501 C52.095542,83.1457218 52.095542,82.9021824 52.3415441,82.7516806 Z M50.0706076,83.7310373 C50.3166097,83.5805355 50.754707,83.5805355 51.0009828,83.7310373 C51.2746226,83.8815392 51.2746226,84.1253523 51.0009828,84.2728441 C50.754707,84.423346 50.3166097,84.423346 50.0706076,84.2728441 C49.7969678,84.1253523 49.7969678,83.8815392 50.0706076,83.7310373 Z M67.5835537,85.2144386 C67.8571935,85.0639367 68.2676532,85.0639367 68.513929,85.2144386 C68.7872951,85.3649405 68.7872951,85.6084799 68.513929,85.7562454 C68.2676532,85.9067473 67.8571935,85.9067473 67.5835537,85.7562454 C67.3372779,85.6084799 67.3372779,85.3649405 67.5835537,85.2144386 Z M69.2527564,93.0268544 C69.5263962,92.8788153 69.9368559,92.8788153 70.2104956,93.0268544 C70.4567714,93.1770827 70.4567714,93.4206221 70.2104956,93.5713976 C69.9368559,93.7218995 69.5263962,93.7218995 69.2527564,93.5713976 C69.0064806,93.4206221 69.0064806,93.1770827 69.2527564,93.0268544 Z M65.4217994,93.8201362 C65.6680752,93.6723707 66.1058989,93.6723707 66.3521747,93.8201362 C66.6258145,93.970638 66.6258145,94.2141774 66.3521747,94.364953 C66.1058989,94.5151812 65.6680752,94.5151812 65.4217994,94.364953 C65.1481596,94.2141774 65.1481596,93.970638 65.4217994,93.8201362 Z M75.9569311,93.8368282 C76.2305709,93.6863263 76.6410306,93.6863263 76.9146703,93.8368282 C77.1609461,93.9870564 77.1609461,94.2305958 76.9146703,94.3783613 C76.6410306,94.5288632 76.2305709,94.5288632 75.9569311,94.3783613 C75.7106553,94.2305958 75.7106553,93.9870564 75.9569311,93.8368282 L75.9569311,93.8368282 Z"
          id="Fill-265"
          fill="#51A146"
        />
        <path
          d="M87.6139859,85.6823626 C87.6139859,84.7763413 88.3254493,84.0405239 89.2284606,84.0405239 L89.2558246,84.0405239 C89.2558246,84.9487344 88.5169972,85.6823626 87.6139859,85.6823626"
          id="Fill-266"
          fill="#51A146"
        />
        <path
          d="M87.6139859,85.6823626 C87.6139859,84.7763413 86.8751585,84.0405239 85.9721472,84.0405239 C85.9721472,84.9487344 86.6836106,85.6823626 87.6139859,85.6823626"
          id="Fill-267"
          fill="#51A146"
        />
        <path
          d="M55.9264989,87.5458496 C55.9264989,86.6370918 56.6653264,85.9040109 57.5683376,85.9040109 C57.5683376,86.8094849 56.8566006,87.5458496 55.9264989,87.5458496 L55.9264989,87.5428395 L55.9264989,87.5458496"
          id="Fill-268"
          fill="#9ECB94"
        />
        <path
          d="M55.9264989,87.5458496 C55.9264989,86.6370918 55.2147619,85.9040109 54.2846602,85.9040109 C54.2846602,86.8094849 55.0234877,87.5458496 55.9264989,87.5458496 L55.9264989,87.5428395 L55.9264989,87.5458496"
          id="Fill-269"
          fill="#9ECB94"
        />
        <path
          d="M104.278649,77.6948174 C104.278649,76.7860596 105.017202,76.0529787 105.920487,76.0529787 C105.920487,76.9584527 105.18166,77.6948174 104.278649,77.6948174 L104.278649,77.6918073 L104.278649,77.6948174"
          id="Fill-270"
          fill="#9ECB94"
        />
        <path
          d="M104.278649,77.6948174 C104.278649,76.7860596 103.539821,76.0529787 102.63681,76.0529787 C102.63681,76.9584527 103.375364,77.6948174 104.278649,77.6948174 L104.278649,77.6918073 L104.278649,77.6948174"
          id="Fill-271"
          fill="#9ECB94"
        />
        <path
          d="M72.0436086,78.3348608 C72.0436086,77.4293868 72.7827096,76.6957585 73.6854473,76.6957585 C73.6854473,77.6017798 72.9468935,78.3348608 72.0436086,78.3348608"
          id="Fill-272"
          fill="#9ECB94"
        />
        <path
          d="M72.0436086,78.3348608 C72.0436086,77.4293868 71.3050548,76.6957585 70.4017699,76.6957585 C70.4017699,77.6017798 71.1408709,78.3348608 72.0436086,78.3348608"
          id="Fill-273"
          fill="#9ECB94"
        />
        <path
          d="M74.2056365,89.1846782 C74.2056365,88.2789305 74.9441903,87.5458496 75.8474752,87.5458496 C75.8474752,88.4513236 75.1086478,89.1876883 74.2056365,89.1876883 L74.2056365,89.1846782"
          id="Fill-274"
          fill="#51A146"
        />
        <path
          d="M74.2056365,89.1846782 C74.2056365,88.2789305 73.4668091,87.5458496 72.5637978,87.5458496 C72.5637978,88.4513236 73.3023516,89.1876883 74.2056365,89.1876883 L74.2056365,89.1846782"
          id="Fill-275"
          fill="#51A146"
        />
        <path
          d="M85.5069595,75.2731053 C85.5069595,74.3643476 86.245787,73.6312666 87.1487982,73.6312666 C87.1487982,74.5370143 86.4096972,75.2731053 85.5069595,75.2731053"
          id="Fill-276"
          fill="#51A146"
        />
        <path
          d="M85.5069595,75.2731053 C85.5069595,74.3643476 84.7678585,73.6312666 83.8651208,73.6312666 C83.8651208,74.5370143 84.6039483,75.2731053 85.5069595,75.2731053"
          id="Fill-277"
          fill="#51A146"
        />
        <path
          d="M93.1415095,66.8915187 C93.1415095,65.9854974 93.8803369,65.24968 94.7833482,65.24968 C94.7833482,66.1578904 94.0445208,66.8915187 93.1415095,66.8915187"
          id="Fill-278"
          fill="#51A146"
        />
        <path
          d="M93.1415095,66.8915187 C93.1415095,65.9854974 92.4026821,65.24968 91.4996708,65.24968 C91.4996708,66.1578904 92.2384982,66.8915187 93.1415095,66.8915187"
          id="Fill-279"
          fill="#51A146"
        />
        <path
          d="M98.2859374,72.7091005 C98.2859374,71.8030792 99.0247648,71.0672618 99.9277761,71.0672618 C99.9277761,71.9727358 99.1889487,72.7091005 98.2859374,72.7091005"
          id="Fill-280"
          fill="#51A146"
        />
        <path
          d="M98.2859374,72.7091005 C98.2859374,71.8030792 97.54711,71.0672618 96.6440987,71.0672618 C96.6440987,71.9727358 97.3829261,72.7091005 98.2859374,72.7091005"
          id="Fill-281"
          fill="#51A146"
        />
        <path
          d="M59.9216398,64.9322579 C60.1952796,64.7844924 60.6057392,64.7844924 60.879379,64.9322579 C61.1256548,65.0827597 61.1256548,65.3262991 60.879379,65.4765274 C60.6057392,65.6242929 60.1952796,65.6242929 59.9216398,65.4765274 C59.675364,65.3262991 59.675364,65.0827597 59.9216398,64.9322579 Z M44.1545155,66.6750696 C44.4144733,66.5245678 44.8358785,66.5245678 45.0955627,66.6750696 C45.3637297,66.8255715 45.3637297,67.0693846 45.0955627,67.2168764 C44.8358785,67.3673783 44.4144733,67.3673783 44.1545155,67.2168764 C43.8945577,67.0693846 43.8945577,66.8255715 44.1545155,66.6750696 Z M66.5984505,57.2208151 C66.8444527,57.0703132 67.28255,57.0703132 67.5285521,57.2208151 C67.7751016,57.3715906 67.7751016,57.6148564 67.5285521,57.7626219 C67.28255,57.9133974 66.8444527,57.9133974 66.5984505,57.7626219 C66.3245371,57.6148564 66.3245371,57.3715906 66.5984505,57.2208151 Z M87.1761622,56.0058545 C87.422438,55.8556262 87.8602617,55.8556262 88.1065375,56.0058545 C88.3801773,56.1563564 88.3801773,56.3998958 88.1065375,56.5506713 C87.8602617,56.6984368 87.422438,56.6984368 87.1761622,56.5506713 C86.9025224,56.3998958 86.9025224,56.1563564 87.1761622,56.0058545 Z M83.4820251,51.107976 C83.7283009,50.9602105 84.1661246,50.9602105 84.4124004,51.107976 C84.6860402,51.2582042 84.6860402,51.5020173 84.4124004,51.6522455 C84.1661246,51.8027474 83.7283009,51.8027474 83.4820251,51.6522455 C83.2083854,51.5020173 83.2083854,51.2582042 83.4820251,51.107976 Z M76.2305709,44.6336587 C76.5042107,44.4831568 76.9146703,44.4831568 77.1609461,44.6336587 C77.4345859,44.7841606 77.4345859,45.0274264 77.1609461,45.1754655 C76.9146703,45.3259674 76.5042107,45.3259674 76.2305709,45.1754655 C75.9842951,45.0274264 75.9842951,44.7841606 76.2305709,44.6336587 Z M56.1180468,55.658332 C56.3643226,55.5081037 56.8021463,55.5081037 57.0484221,55.658332 C57.2944242,55.8060974 57.2944242,56.0499105 57.0484221,56.2001387 C56.8021463,56.3509142 56.3643226,56.3509142 56.1180468,56.2001387 C55.844407,56.0499105 55.844407,55.8060974 56.1180468,55.658332 Z M62.9043134,51.107976 C63.1503156,50.9602105 63.5884129,50.9602105 63.834415,51.107976 C64.1083285,51.2582042 64.1083285,51.5020173 63.834415,51.6522455 C63.5884129,51.8027474 63.1503156,51.8027474 62.9043134,51.6522455 C62.6304,51.5020173 62.6304,51.2582042 62.9043134,51.107976 Z M75.5738354,52.9410889 C75.8201112,52.7908607 76.2579349,52.7908607 76.5042107,52.9410889 C76.7778504,53.0888544 76.7778504,53.3323938 76.5042107,53.4828957 C76.2579349,53.6333976 75.8201112,53.6333976 75.5738354,53.4828957 C75.3001956,53.3323938 75.3001956,53.0888544 75.5738354,52.9410889 Z M48.4834968,69.5072414 C48.7297726,69.3594759 49.1675963,69.3594759 49.4138721,69.5072414 C49.6875119,69.6577433 49.6875119,69.9012827 49.4138721,70.0517846 C49.1675963,70.1995501 48.7297726,70.1995501 48.4834968,70.0517846 C48.2098571,69.9012827 48.2098571,69.6577433 48.4834968,69.5072414 Z M85.3975036,59.3059503 C85.6437794,59.1581848 86.0816031,59.1581848 86.3278789,59.3059503 C86.6015187,59.4564522 86.6015187,59.6999916 86.3278789,59.8504934 C86.0816031,59.9982589 85.6437794,59.9982589 85.3975036,59.8504934 C85.1238638,59.6999916 85.1238638,59.4564522 85.3975036,59.3059503 Z M49.3044162,60.5510113 C49.550692,60.4032458 49.9885156,60.4032458 50.2347914,60.5510113 C50.5084312,60.7017868 50.5084312,60.9450526 50.2347914,61.0955545 C49.9885156,61.2433199 49.550692,61.2433199 49.3044162,61.0955545 C49.0307764,60.9450526 49.0307764,60.7017868 49.3044162,60.5510113 Z M34.1611906,69.8906107 C34.4181383,69.7428453 34.8398172,69.7428453 35.099775,69.8906107 C35.3594592,70.0411126 35.3594592,70.284652 35.099775,70.4348803 C34.8398172,70.5856558 34.4181383,70.5856558 34.1611906,70.4348803 C33.9012328,70.284652 33.9012328,70.0411126 34.1611906,69.8906107 Z M70.4841354,64.9322579 C70.7304112,64.7844924 71.1682349,64.7844924 71.4145107,64.9322579 C71.6881505,65.0827597 71.6881505,65.3262991 71.4145107,65.4765274 C71.1682349,65.6242929 70.7304112,65.6242929 70.4841354,65.4765274 C70.2378596,65.3262991 70.2378596,65.0827597 70.4841354,64.9322579 Z M72.7006177,65.9088782 C72.9742575,65.7583764 73.3847171,65.7583764 73.6583569,65.9088782 C73.9046327,66.0566437 73.9046327,66.3001831 73.6583569,66.450685 C73.3847171,66.6011869 72.9742575,66.6011869 72.7006177,66.450685 C72.4540682,66.3001831 72.4540682,66.0566437 72.7006177,65.9088782 Z M57.10315,72.3779964 C57.3494258,72.2274945 57.7872495,72.2274945 58.0335253,72.3779964 C58.3071651,72.5282246 58.3071651,72.7693013 58.0335253,72.9198031 C57.7872495,73.0700314 57.3494258,73.0700314 57.10315,72.9198031 C56.8295102,72.7693013 56.8295102,72.5282246 57.10315,72.3779964 Z M37.2065277,72.8976383 C37.4667592,72.7474101 37.8878908,72.7474101 38.1481222,72.8976383 C38.4053436,73.0484138 38.4053436,73.2919532 38.1481222,73.4397187 C37.8878908,73.5902206 37.4667592,73.5902206 37.2065277,73.4397187 C36.9468436,73.2919532 36.9468436,73.0484138 37.2065277,72.8976383 Z M39.0867067,76.2004705 C39.3466645,76.0499686 39.7680697,76.0499686 40.0277539,76.2004705 C40.2879853,76.348236 40.2879853,76.5917754 40.0277539,76.7425509 C39.7680697,76.8930528 39.3466645,76.8930528 39.0867067,76.7425509 C38.8294853,76.5917754 38.8294853,76.348236 39.0867067,76.2004705 Z M57.10315,76.7477501 C57.3494258,76.5975218 57.7872495,76.5975218 58.0335253,76.7477501 C58.3071651,76.8955156 58.3071651,77.139055 58.0335253,77.2895568 C57.7872495,77.4400587 57.3494258,77.4400587 57.10315,77.2895568 C56.8295102,77.139055 56.8295102,76.8955156 57.10315,76.7477501 L57.10315,76.7477501 Z"
          id="Fill-282"
          fill="#9ECB94"
        />
        <path
          d="M37.871746,63.9988726 C38.1317038,63.8513807 38.5528355,63.8513807 38.8103305,63.9988726 C39.0702883,64.1496481 39.0702883,64.3929138 38.8103305,64.5436894 C38.5528355,64.6914548 38.1317038,64.6914548 37.871746,64.5436894 C37.6115146,64.3929138 37.6115146,64.1496481 37.871746,63.9988726 Z M50.1253355,57.9897429 C50.3716113,57.8395147 50.809435,57.8395147 51.0557108,57.9897429 C51.3293506,58.137782 51.3293506,58.3813214 51.0557108,58.5315497 C50.809435,58.6823252 50.3716113,58.6823252 50.1253355,58.5315497 C49.8516958,58.3813214 49.8516958,58.137782 50.1253355,57.9897429 Z M57.7598855,58.3728386 C58.0335253,58.2223367 58.443985,58.2223367 58.6902608,58.3728386 C58.9639005,58.5236141 58.9639005,58.7641435 58.6902608,58.9146454 C58.443985,59.0654209 58.0335253,59.0654209 57.7598855,58.9146454 C57.5136097,58.7641435 57.5136097,58.5236141 57.7598855,58.3728386 Z M61.0435629,54.2846602 C61.2898387,54.134432 61.7276624,54.134432 61.9739382,54.2846602 C62.2475779,54.4326994 62.2475779,54.6759651 61.9739382,54.826467 C61.7276624,54.9769689 61.2898387,54.9769689 61.0435629,54.826467 C60.7699231,54.6759651 60.7699231,54.4326994 61.0435629,54.2846602 Z M74.6160962,49.9118965 C74.862372,49.7616683 75.3001956,49.7616683 75.5464714,49.9118965 C75.8201112,50.062672 75.8201112,50.3062114 75.5464714,50.4567133 C75.3001956,50.6044788 74.862372,50.6044788 74.6160962,50.4567133 C74.3424564,50.3062114 74.3424564,50.062672 74.6160962,49.9118965 Z M41.631283,64.9322579 C41.8915145,64.7844924 42.3126461,64.7844924 42.5728775,64.9322579 C42.8325617,65.0827597 42.8325617,65.3262991 42.5728775,65.4765274 C42.3126461,65.6242929 41.8915145,65.6242929 41.631283,65.4765274 C41.3743353,65.3262991 41.3743353,65.0827597 41.631283,64.9322579 Z M89.8031041,54.5884004 C90.0767439,54.4378985 90.4872036,54.4378985 90.7608434,54.5884004 C91.0071192,54.7361659 91.0071192,54.9797053 90.7608434,55.1302072 C90.4872036,55.2807091 90.0767439,55.2807091 89.8031041,55.1302072 C89.5568283,54.9797053 89.5568283,54.7361659 89.8031041,54.5884004 Z M91.5817627,55.658332 C91.8554025,55.5081037 92.2658622,55.5081037 92.539502,55.658332 C92.7857778,55.8060974 92.7857778,56.0499105 92.539502,56.2001387 C92.2658622,56.3509142 91.8554025,56.3509142 91.5817627,56.2001387 C91.3352133,56.0499105 91.3352133,55.8060974 91.5817627,55.658332 Z M45.4734592,59.7850935 C45.747099,59.6345917 46.1575587,59.6345917 46.4311985,59.7850935 C46.6774743,59.932859 46.6774743,60.1763984 46.4311985,60.3269003 C46.1575587,60.4771285 45.747099,60.4771285 45.4734592,60.3269003 C45.2271834,60.1763984 45.2271834,59.932859 45.4734592,59.7850935 Z M70.4841354,45.3998501 C70.7304112,45.2520846 71.1682349,45.2520846 71.4145107,45.3998501 C71.6881505,45.550352 71.6881505,45.7938914 71.4145107,45.9441196 C71.1682349,46.0946215 70.7304112,46.0946215 70.4841354,45.9441196 C70.2378596,45.7938914 70.2378596,45.550352 70.4841354,45.3998501 Z M64.3272403,60.5510113 C64.5735161,60.4032458 65.0113398,60.4032458 65.2576156,60.5510113 C65.5312553,60.7017868 65.5312553,60.9450526 65.2576156,61.0955545 C65.0113398,61.2433199 64.5735161,61.2433199 64.3272403,61.0955545 C64.0536005,60.9450526 64.0536005,60.7017868 64.3272403,60.5510113 Z M52.5880936,65.9088782 C52.8343694,65.7583764 53.272193,65.7583764 53.5184689,65.9088782 C53.7921086,66.0566437 53.7921086,66.3001831 53.5184689,66.450685 C53.272193,66.6011869 52.8343694,66.6011869 52.5880936,66.450685 C52.3144538,66.3001831 52.3144538,66.0566437 52.5880936,65.9088782 Z M63.9167806,67.8161475 C64.1630564,67.6683821 64.6008801,67.6683821 64.8471559,67.8161475 C65.1207957,67.9666494 65.1207957,68.2101888 64.8471559,68.3606907 C64.6008801,68.5084562 64.1630564,68.5084562 63.9167806,68.3606907 C63.6431408,68.2101888 63.6431408,67.9666494 63.9167806,67.8161475 Z M70.2925876,69.291066 C70.5385897,69.1405641 70.976687,69.1405641 71.2226892,69.291066 C71.4966026,69.4415679 71.4966026,69.6823709 71.2226892,69.8331464 C70.976687,69.9836483 70.5385897,69.9836483 70.2925876,69.8331464 C70.0186742,69.6823709 70.0186742,69.4415679 70.2925876,69.291066 Z M27.9030487,69.5072414 C28.1630065,69.3594759 28.5844118,69.3594759 28.8416332,69.5072414 C29.101591,69.6577433 29.101591,69.9012827 28.8416332,70.0517846 C28.5844118,70.1995501 28.1630065,70.1995501 27.9030487,70.0517846 C27.6430909,69.9012827 27.6430909,69.6577433 27.9030487,69.5072414 Z M25.6178829,70.4868718 C25.8753779,70.3391063 26.2967832,70.3391063 26.556741,70.4868718 C26.8166988,70.6376473 26.8166988,70.8809131 26.556741,71.0286786 C26.2967832,71.1794541 25.8753779,71.1794541 25.6178829,71.0286786 C25.3581987,70.8809131 25.3581987,70.6376473 25.6178829,70.4868718 Z M43.1393119,71.9699994 C43.3965333,71.8197712 43.8179385,71.8197712 44.0778963,71.9699994 C44.3375805,72.1205013 44.3375805,72.3640407 44.0778963,72.5118062 C43.8179385,72.6623081 43.3965333,72.6623081 43.1393119,72.5118062 C42.8793541,72.3640407 42.8793541,72.1205013 43.1393119,71.9699994 Z M44.8191865,79.7826889 C45.0794179,79.6349234 45.5005496,79.6349234 45.747099,79.7826889 C46.0207388,79.9331908 46.0207388,80.1767302 45.747099,80.3269584 C45.5005496,80.477734 45.0794179,80.477734 44.8191865,80.3269584 C44.5595023,80.1767302 44.5595023,79.9331908 44.8191865,79.7826889 Z M40.9663383,80.578707 C41.2265698,80.4282052 41.647975,80.4282052 41.9079328,80.578707 C42.1678906,80.7264725 42.1678906,80.9700119 41.9079328,81.1207874 C41.647975,81.2712893 41.2265698,81.2712893 40.9663383,81.1207874 C40.7091169,80.9700119 40.7091169,80.7264725 40.9663383,80.578707 Z M51.5206248,80.592389 C51.7671742,80.4418871 52.2049979,80.4418871 52.4512737,80.592389 C52.7249135,80.7428909 52.7249135,80.9864303 52.4512737,81.1341958 C52.2049979,81.2846977 51.7671742,81.2846977 51.5206248,81.1341958 C51.246985,80.9864303 51.246985,80.7428909 51.5206248,80.592389 L51.5206248,80.592389 Z"
          id="Fill-283"
          fill="#51A146"
        />
        <path
          d="M63.1503156,72.4379235 C63.1503156,71.5324494 63.8894166,70.7960848 64.7921543,70.7960848 C64.7921543,71.7048425 64.0536005,72.4379235 63.1503156,72.4379235"
          id="Fill-284"
          fill="#51A146"
        />
        <path
          d="M63.1503156,72.4379235 C63.1503156,71.5324494 62.4117618,70.7960848 61.5084769,70.7960848 C61.5084769,71.7048425 62.2475779,72.4379235 63.1503156,72.4379235"
          id="Fill-285"
          fill="#51A146"
        />
        <path
          d="M31.4932027,74.3014104 C31.4932027,73.3929263 32.2265573,72.6595717 33.1350414,72.6595717 C33.1350414,73.5653194 32.3989504,74.3014104 31.4932027,74.3014104 L31.4932027,74.2989476 L31.4932027,74.3014104"
          id="Fill-286"
          fill="#9ECB94"
        />
        <path
          d="M31.4932027,74.3014104 C31.4932027,73.3929263 30.7571117,72.6595717 29.851364,72.6595717 C29.851364,73.5653194 30.5847186,74.3014104 31.4932027,74.3014104 L31.4932027,74.2989476 L31.4932027,74.3014104"
          id="Fill-287"
          fill="#9ECB94"
        />
        <path
          d="M79.8423424,64.4503782 C79.8423424,63.5418941 80.5814434,62.8085395 81.4841811,62.8085395 C81.4841811,63.7142872 80.7456273,64.4503782 79.8423424,64.4503782 L79.8423424,64.4479154 L79.8423424,64.4503782"
          id="Fill-288"
          fill="#9ECB94"
        />
        <path
          d="M79.8423424,64.4503782 C79.8423424,63.5418941 79.1037886,62.8085395 78.2005037,62.8085395 C78.2005037,63.7142872 78.9396047,64.4503782 79.8423424,64.4503782 L79.8423424,64.4479154 L79.8423424,64.4503782"
          id="Fill-289"
          fill="#9ECB94"
        />
        <path
          d="M47.6078495,65.0934317 C47.6078495,64.1852212 48.319313,63.451593 49.2496882,63.451593 C49.2496882,64.3576143 48.5108608,65.0934317 47.6078495,65.0934317 L47.6078495,65.0909689 L47.6078495,65.0934317"
          id="Fill-290"
          fill="#9ECB94"
        />
        <path
          d="M47.6078495,65.0934317 C47.6078495,64.1852212 46.8690221,63.451593 45.9660108,63.451593 C45.9660108,64.3576143 46.6774743,65.0934317 47.6078495,65.0934317 L47.6078495,65.0909689 L47.6078495,65.0934317"
          id="Fill-291"
          fill="#9ECB94"
        />
        <path
          d="M49.7696038,75.9407863 C49.7696038,75.034765 50.5084312,74.3014104 51.4114425,74.3014104 C51.4114425,75.2071581 50.6726151,75.9432491 49.7696038,75.9432491 L49.7696038,75.9407863"
          id="Fill-292"
          fill="#51A146"
        />
        <path
          d="M49.7696038,75.9407863 C49.7696038,75.034765 49.0307764,74.3014104 48.1277651,74.3014104 C48.1277651,75.2071581 48.8665925,75.9432491 49.7696038,75.9432491 L49.7696038,75.9407863"
          id="Fill-293"
          fill="#51A146"
        />
        <path
          d="M61.0709269,62.0286661 C61.0709269,61.120182 61.8094806,60.3868274 62.7127656,60.3868274 C62.7127656,61.2925751 61.9739382,62.0286661 61.0709269,62.0286661"
          id="Fill-294"
          fill="#51A146"
        />
        <path
          d="M61.0709269,62.0286661 C61.0709269,61.120182 60.3320995,60.3868274 59.4290882,60.3868274 C59.4290882,61.2925751 60.1676419,62.0286661 61.0709269,62.0286661"
          id="Fill-295"
          fill="#51A146"
        />
        <path
          d="M68.7054768,53.6470795 C68.7054768,52.7413319 69.4443042,52.0052408 70.3473155,52.0052408 L70.3473155,52.0079772 C70.3473155,52.9139986 69.6082145,53.6470795 68.7054768,53.6470795"
          id="Fill-296"
          fill="#51A146"
        />
        <path
          d="M68.7054768,53.6470795 C68.7054768,52.7413319 67.9663758,52.0052408 67.0636381,52.0052408 L67.0636381,52.0079772 C67.0636381,52.9139986 67.8024655,53.6470795 68.7054768,53.6470795"
          id="Fill-297"
          fill="#51A146"
        />
        <path
          d="M73.8499048,59.464935 C73.8499048,58.5589137 74.5887322,57.8230963 75.4917435,57.8230963 C75.4917435,58.728844 74.752916,59.464935 73.8499048,59.464935"
          id="Fill-298"
          fill="#51A146"
        />
        <path
          d="M73.8499048,59.464935 C73.8499048,58.5589137 73.1110773,57.8230963 72.2080661,57.8230963 C72.2080661,58.728844 72.9468935,59.464935 73.8499048,59.464935"
          id="Fill-299"
          fill="#51A146"
        />
        <path
          d="M41.6288203,53.7403907 C41.8887781,53.5898888 42.3101833,53.5898888 42.5701411,53.7403907 C42.8273625,53.8881562 42.8273625,54.131422 42.5701411,54.2821975 C42.3101833,54.429963 41.8887781,54.429963 41.6288203,54.2821975 C41.3688625,54.131422 41.3688625,53.8881562 41.6288203,53.7403907 Z M25.8534867,55.4804661 C26.1107081,55.3299642 26.5321134,55.3299642 26.7920712,55.4804661 C27.052029,55.630968 27.052029,55.8745074 26.7920712,56.0222729 C26.5321134,56.1727747 26.1107081,56.1727747 25.8534867,56.0222729 C25.5932553,55.8745074 25.5932553,55.630968 25.8534867,55.4804661 Z M48.291949,46.0264852 C48.5382248,45.8757097 48.9760484,45.8757097 49.2223242,46.0264852 C49.4956904,46.1769871 49.4956904,46.4205265 49.2223242,46.5710284 C48.9760484,46.7187939 48.5382248,46.7187939 48.291949,46.5710284 C48.0183092,46.4205265 48.0183092,46.1769871 48.291949,46.0264852 Z M68.8696607,44.8112509 C69.1433005,44.6634855 69.5537602,44.6634855 69.800036,44.8112509 C70.0736758,44.9617528 70.0736758,45.2055659 69.800036,45.3560677 C69.5537602,45.5035596 69.1433005,45.5035596 68.8696607,45.3560677 C68.6233849,45.2055659 68.6233849,44.9617528 68.8696607,44.8112509 Z M65.1755236,39.9161089 C65.4217994,39.7653333 65.8596231,39.7653333 66.1058989,39.9161089 C66.3795387,40.0638743 66.3795387,40.3071401 66.1058989,40.4579156 C65.8596231,40.6081439 65.4217994,40.6081439 65.1755236,40.4579156 C64.9018838,40.3071401 64.9018838,40.0638743 65.1755236,39.9161089 Z M57.9240694,33.4390552 C58.1977091,33.2885533 58.6081688,33.2885533 58.8818086,33.4390552 C59.1280844,33.5895571 59.1280844,33.8330965 58.8818086,33.980862 C58.6081688,34.1313638 58.1977091,34.1313638 57.9240694,33.980862 C57.6775199,33.8330965 57.6775199,33.5895571 57.9240694,33.4390552 Z M37.8060725,44.4637284 C38.0657566,44.3135002 38.4874355,44.3135002 38.7446569,44.4637284 C39.0046147,44.6145039 39.0046147,44.8553069 38.7446569,45.0055352 C38.4874355,45.1563107 38.0657566,45.1563107 37.8060725,45.0055352 C37.545841,44.8553069 37.545841,44.6145039 37.8060725,44.4637284 Z M44.6005483,39.9161089 C44.8605061,39.7653333 45.2819114,39.7653333 45.5281872,39.9161089 C45.8015533,40.0638743 45.8015533,40.3071401 45.5281872,40.4579156 C45.2819114,40.6081439 44.8605061,40.6081439 44.6005483,40.4579156 C44.3405905,40.3071401 44.3405905,40.0638743 44.6005483,39.9161089 Z M57.2670602,41.7464854 C57.5136097,41.5959835 57.9514333,41.5959835 58.1977091,41.7464854 C58.4713489,41.8945245 58.4713489,42.1377903 58.1977091,42.2882921 C57.9514333,42.438794 57.5136097,42.438794 57.2670602,42.2882921 C56.9934205,42.1377903 56.9934205,41.8945245 57.2670602,41.7464854 Z M30.1715225,58.3129115 C30.4314803,58.1648724 30.8528856,58.1648724 31.1128434,58.3129115 C31.3728012,58.4631397 31.3728012,58.7066791 31.1128434,58.857181 C30.8528856,59.0049465 30.4314803,59.0049465 30.1715225,58.857181 C29.9115647,58.7066791 29.9115647,58.4631397 30.1715225,58.3129115 Z M67.0910021,48.1113467 C67.3372779,47.9635812 67.7751016,47.9635812 68.0213774,48.1113467 C68.2950172,48.2621222 68.2950172,48.505388 68.0213774,48.6558899 C67.7751016,48.803929 67.3372779,48.803929 67.0910021,48.6558899 C66.8173623,48.505388 66.8173623,48.2621222 67.0910021,48.1113467 Z M30.9924419,49.3566814 C31.2523997,49.2089159 31.6738049,49.2089159 31.9337627,49.3566814 C32.1937205,49.5071833 32.1937205,49.750449 31.9337627,49.9009509 C31.6738049,50.0487164 31.2523997,50.0487164 30.9924419,49.9009509 C30.7324841,49.750449 30.7324841,49.5071833 30.9924419,49.3566814 Z M15.8571518,58.69847 C16.1173832,58.5482417 16.5387885,58.5482417 16.7960099,58.69847 C17.0559677,58.8462354 17.0559677,59.0897748 16.7960099,59.2402767 C16.5387885,59.3910522 16.1173832,59.3910522 15.8571518,59.2402767 C15.5974677,59.0897748 15.5974677,58.8462354 15.8571518,58.69847 Z M52.1776339,53.7373807 C52.4512737,53.5898888 52.8617334,53.5898888 53.1080092,53.7373807 C53.381649,53.8881562 53.381649,54.131422 53.1080092,54.2821975 C52.8617334,54.429963 52.4512737,54.429963 52.1776339,54.2821975 C51.9310845,54.131422 51.9310845,53.8881562 52.1776339,53.7373807 Z M54.4212065,54.7142747 C54.6677559,54.5637728 55.0782156,54.5637728 55.3515818,54.7142747 C55.5981312,54.8620402 55.5981312,55.1055796 55.3515818,55.2560815 C55.0782156,55.4065834 54.6677559,55.4065834 54.4212065,55.2560815 C54.1478404,55.1055796 54.1478404,54.8620402 54.4212065,54.7142747 Z M38.7939121,61.1833928 C39.0535963,61.0328909 39.4752752,61.0328909 39.7349593,61.1833928 C39.9951908,61.3338947 39.9951908,61.5746977 39.7349593,61.724926 C39.4752752,61.8757015 39.0535963,61.8757015 38.7939121,61.724926 C38.5366907,61.5746977 38.5366907,61.3338947 38.7939121,61.1833928 Z M18.9030362,61.7030348 C19.162994,61.5525329 19.5843993,61.5525329 19.8443571,61.7030348 C20.1043149,61.8538103 20.1043149,62.0973497 19.8443571,62.2448415 C19.5843993,62.3956171 19.162994,62.3956171 18.9030362,62.2448415 C18.6455412,62.0973497 18.6455412,61.8538103 18.9030362,61.7030348 Z M20.785678,65.0061406 C21.0428993,64.8553651 21.4643046,64.8553651 21.7239888,65.0061406 C21.9842202,65.1539061 21.9842202,65.3971719 21.7239888,65.5479474 C21.4643046,65.6984493 21.0428993,65.6984493 20.785678,65.5479474 C20.5257202,65.3971719 20.5257202,65.1539061 20.785678,65.0061406 Z M38.7939121,65.5531465 C39.0535963,65.4026446 39.4752752,65.4026446 39.7349593,65.5531465 C39.9951908,65.7011857 39.9951908,65.9444514 39.7349593,66.0949533 C39.4752752,66.2454552 39.0535963,66.2454552 38.7939121,66.0949533 C38.5366907,65.9444514 38.5366907,65.7011857 38.7939121,65.5531465 L38.7939121,65.5531465 Z"
          id="Fill-300"
          fill="#9ECB94"
        />
        <path
          d="M19.5679809,52.8072791 C19.8276651,52.6567772 20.249344,52.6567772 20.5093018,52.8072791 C20.7692596,52.9550445 20.7692596,53.1985839 20.5093018,53.3490858 C20.249344,53.4993141 19.8276651,53.4993141 19.5679809,53.3490858 C19.3107595,53.1985839 19.3107595,52.9550445 19.5679809,52.8072791 Z M31.8133612,46.7951394 C32.073319,46.6449111 32.4947243,46.6449111 32.7546821,46.7951394 C33.0146399,46.9429049 33.0146399,47.1864443 32.7546821,47.3369461 C32.4947243,47.4877217 32.073319,47.4877217 31.8133612,47.3369461 C31.5534034,47.1864443 31.5534034,46.9429049 31.8133612,46.7951394 Z M39.4585831,47.1782351 C39.7188146,47.0277332 40.1402198,47.0277332 40.399904,47.1782351 C40.6601354,47.3287369 40.6601354,47.56954 40.399904,47.7200418 C40.1402198,47.8705437 39.7188146,47.8705437 39.4585831,47.7200418 C39.2016354,47.56954 39.2016354,47.3287369 39.4585831,47.1782351 Z M42.7397978,43.0900567 C42.9994819,42.9398285 43.4211608,42.9398285 43.6811186,43.0900567 C43.93834,43.2378222 43.93834,43.4813616 43.6811186,43.6318635 C43.4211608,43.7823654 42.9994819,43.7823654 42.7397978,43.6318635 C42.47984,43.4813616 42.47984,43.2378222 42.7397978,43.0900567 Z M56.3095946,38.717293 C56.5558704,38.5670647 56.9934205,38.5670647 57.2399699,38.717293 C57.5136097,38.8680685 57.5136097,39.1116079 57.2399699,39.2621098 C56.9934205,39.4098753 56.5558704,39.4098753 56.3095946,39.2621098 C56.0356812,39.1116079 56.0356812,38.8680685 56.3095946,38.717293 Z M23.3305279,53.7373807 C23.5902121,53.5898888 24.0091546,53.5898888 24.2691124,53.7373807 C24.5287966,53.8881562 24.5287966,54.131422 24.2691124,54.2821975 C24.0091546,54.4326994 23.5902121,54.4326994 23.3305279,54.2821975 C23.0705701,54.131422 23.0705701,53.8881562 23.3305279,53.7373807 Z M71.4966026,43.3937969 C71.7699688,43.243295 72.1804284,43.243295 72.4540682,43.3937969 C72.7006177,43.5442987 72.7006177,43.7878382 72.4540682,43.9356036 C72.1804284,44.0861055 71.7699688,44.0861055 71.4966026,43.9356036 C71.2500532,43.7878382 71.2500532,43.5442987 71.4966026,43.3937969 Z M73.3023516,44.4637284 C73.548901,44.3135002 73.9593607,44.3135002 74.2327268,44.4637284 C74.4792763,44.6145039 74.4792763,44.8580433 74.2327268,45.0055352 C73.9593607,45.1563107 73.548901,45.1563107 73.3023516,45.0055352 C73.0289854,44.8580433 73.0289854,44.6145039 73.3023516,44.4637284 Z M27.1806397,48.5902164 C27.4403238,48.4399881 27.8620028,48.4399881 28.1219605,48.5902164 C28.3816447,48.7409919 28.3816447,48.9842576 28.1219605,49.1320231 C27.8620028,49.2827986 27.4403238,49.2827986 27.1806397,49.1320231 C26.9234183,48.9842576 26.9234183,48.7409919 27.1806397,48.5902164 Z M52.1776339,34.2077093 C52.4512737,34.0574811 52.8617334,34.0574811 53.1080092,34.2077093 C53.381649,34.3554748 53.381649,34.5992879 53.1080092,34.7495161 C52.8617334,34.900018 52.4512737,34.900018 52.1776339,34.7495161 C51.9310845,34.5992879 51.9310845,34.3554748 52.1776339,34.2077093 Z M46.0207388,49.3566814 C46.2943786,49.2089159 46.7048382,49.2089159 46.951114,49.3566814 C47.2247538,49.5071833 47.2247538,49.750449 46.951114,49.9009509 C46.7048382,50.0487164 46.2943786,50.0487164 46.0207388,49.9009509 C45.7741893,49.750449 45.7741893,49.5071833 46.0207388,49.3566814 Z M34.2843285,54.7142747 C34.5442863,54.5637728 34.9656915,54.5637728 35.2229129,54.7142747 C35.4828707,54.8620402 35.4828707,55.1055796 35.2229129,55.2560815 C34.9656915,55.4065834 34.5442863,55.4065834 34.2843285,55.2560815 C34.0243707,55.1055796 34.0243707,54.8620402 34.2843285,54.7142747 Z M45.6102791,56.621544 C45.8839189,56.4737785 46.2943786,56.4737785 46.5406544,56.621544 C46.8142942,56.7720459 46.8142942,57.0155853 46.5406544,57.1663608 C46.2943786,57.3141263 45.8839189,57.3141263 45.6102791,57.1663608 C45.3637297,57.0155853 45.3637297,56.7720459 45.6102791,56.621544 Z M51.9860861,58.0964624 C52.2323619,57.9459605 52.6701855,57.9459605 52.9164613,58.0964624 C53.1898275,58.2469643 53.1898275,58.4877673 52.9164613,58.6382692 C52.6701855,58.7887711 52.2323619,58.7887711 51.9860861,58.6382692 C51.7398103,58.4877673 51.7398103,58.2469643 51.9860861,58.0964624 Z M9.5992836,58.3129115 C9.85896776,58.1648724 10.2806467,58.1648724 10.5403308,58.3129115 C10.7975522,58.4631397 10.7975522,58.7066791 10.5403308,58.857181 C10.2806467,59.0049465 9.85896776,59.0049465 9.5992836,58.857181 C9.33932581,58.7066791 9.33932581,58.4631397 9.5992836,58.3129115 Z M7.31439141,59.2925419 C7.57434921,59.1447764 7.99575447,59.1447764 8.25571227,59.2925419 C8.51266002,59.4430438 8.51266002,59.6865832 8.25571227,59.8368115 C7.99575447,59.9848506 7.57434921,59.9848506 7.31439141,59.8368115 C7.05443362,59.6865832 7.05443362,59.4430438 7.31439141,59.2925419 Z M24.8355467,60.7756695 C25.0955045,60.624894 25.5169098,60.624894 25.7741312,60.7756695 C26.0338154,60.9258978 26.0338154,61.1694372 25.7741312,61.3174763 C25.5169098,61.4677046 25.0955045,61.4677046 24.8355467,61.3174763 C24.575589,61.1694372 24.575589,60.9258978 24.8355467,60.7756695 Z M26.515695,68.5908218 C26.7756528,68.4403199 27.1967844,68.4403199 27.4570159,68.5908218 C27.7169737,68.7385872 27.7169737,68.9821267 27.4570159,69.1326285 C27.1967844,69.2831304 26.7756528,69.2831304 26.515695,69.1326285 C26.2582,68.9821267 26.2582,68.7385872 26.515695,68.5908218 Z M22.6655833,69.3841035 C22.9252674,69.2336016 23.3469463,69.2336016 23.6041677,69.3841035 C23.8641255,69.5321426 23.8641255,69.7754084 23.6041677,69.9259103 C23.3469463,70.0764121 22.9252674,70.0764121 22.6655833,69.9259103 C22.4053518,69.7754084 22.4053518,69.5321426 22.6655833,69.3841035 Z M33.2168597,69.3977855 C33.4743547,69.2472836 33.89576,69.2472836 34.1557178,69.3977855 C34.4156756,69.5482874 34.4156756,69.7918268 34.1557178,69.9426023 C33.89576,70.0900941 33.4743547,70.0900941 33.2168597,69.9426023 C32.9571755,69.7918268 32.9571755,69.5482874 33.2168597,69.3977855 L33.2168597,69.3977855 Z"
          id="Fill-301"
          fill="#51A146"
        />
        <path
          d="M44.8522969,61.2433199 C44.8522969,60.3378459 45.5829151,59.6014812 46.4859264,59.6014812 C46.4859264,60.5099653 45.747099,61.2433199 44.8522969,61.2433199"
          id="Fill-302"
          fill="#51A146"
        />
        <path
          d="M44.8522969,61.2433199 C44.8522969,60.3378459 44.1162059,59.6014812 43.2104582,59.6014812 C43.2104582,60.5099653 43.9438128,61.2433199 44.8522969,61.2433199"
          id="Fill-303"
          fill="#51A146"
        />
        <path
          d="M13.1891639,63.1070805 C13.1891639,62.1983228 13.9252549,61.4652418 14.8310026,61.4652418 C14.8310026,62.3709895 14.0951852,63.1070805 13.1891639,63.1070805"
          id="Fill-304"
          fill="#9ECB94"
        />
        <path
          d="M13.1891639,63.1070805 C13.1891639,62.1983228 12.4533465,61.4652418 11.5473252,61.4652418 C11.5473252,62.3709895 12.2834162,63.1070805 13.1891639,63.1070805"
          id="Fill-305"
          fill="#9ECB94"
        />
        <path
          d="M61.5361145,53.2560483 C61.5361145,52.3472906 62.2749419,51.6142096 63.1779532,51.6142096 C63.1779532,52.5199573 62.4391258,53.2560483 61.5361145,53.2560483"
          id="Fill-306"
          fill="#9ECB94"
        />
        <path
          d="M61.5361145,53.2560483 C61.5361145,52.3472906 60.7972871,51.6142096 59.8942758,51.6142096 C59.8942758,52.5199573 60.6331032,53.2560483 61.5361145,53.2560483"
          id="Fill-307"
          fill="#9ECB94"
        />
        <path
          d="M29.2928652,53.8988281 C29.2928652,52.9903441 30.0292298,52.2569894 30.9347039,52.2569894 C30.9347039,53.1627371 30.2016229,53.8988281 29.2928652,53.8988281"
          id="Fill-308"
          fill="#9ECB94"
        />
        <path
          d="M29.2928652,53.8988281 C29.2928652,52.9903441 28.5597842,52.2569894 27.6510265,52.2569894 C27.6510265,53.1627371 28.3873911,53.8988281 29.2928652,53.8988281"
          id="Fill-309"
          fill="#9ECB94"
        />
        <path
          d="M31.4631023,64.7489192 C31.4631023,63.8401615 32.1991933,63.1070805 33.104941,63.1070805 C33.104941,64.0128282 32.36885,64.7489192 31.4631023,64.7489192"
          id="Fill-310"
          fill="#51A146"
        />
        <path
          d="M31.4631023,64.7489192 C31.4631023,63.8401615 30.7270113,63.1070805 29.8212636,63.1070805 C29.8212636,64.0128282 30.5573546,64.7489192 31.4631023,64.7489192"
          id="Fill-311"
          fill="#51A146"
        />
        <path
          d="M42.7644254,50.8340626 C42.7644254,49.9258521 43.4975063,49.1922239 44.4062641,49.1922239 C44.4062641,50.0982452 43.670173,50.8340626 42.7644254,50.8340626"
          id="Fill-312"
          fill="#51A146"
        />
        <path
          d="M42.7644254,50.8340626 C42.7644254,49.9258521 42.0283343,49.1922239 41.1225867,49.1922239 C41.1225867,50.0982452 41.8556676,50.8340626 42.7644254,50.8340626"
          id="Fill-313"
          fill="#51A146"
        />
        <path
          d="M50.3989753,42.4552124 C50.3989753,41.5467283 51.1375291,40.8133737 52.040814,40.8133737 C52.040814,41.719395 51.3019866,42.4552124 50.3989753,42.4552124"
          id="Fill-314"
          fill="#51A146"
        />
        <path
          d="M50.3989753,42.4552124 C50.3989753,41.5467283 49.6601479,40.8133737 48.7571366,40.8133737 C48.7571366,41.719395 49.4956904,42.4552124 50.3989753,42.4552124"
          id="Fill-315"
          fill="#51A146"
        />
        <path
          d="M55.5434032,48.2700578 C55.5434032,47.3643101 56.2822307,46.6284927 57.1852419,46.6284927 C57.1852419,47.5339668 56.4461409,48.2700578 55.5434032,48.2700578"
          id="Fill-316"
          fill="#51A146"
        />
        <path
          d="M55.5434032,48.2700578 C55.5434032,47.3643101 54.8043022,46.6284927 53.9015645,46.6284927 C53.9015645,47.5339668 54.640392,48.2700578 55.5434032,48.2700578"
          id="Fill-317"
          fill="#51A146"
        />
        <polyline
          id="Fill-388"
          fill="#9E9F9E"
          points="105.947851 59.464935 49.8516958 91.6611183 70.2104956 103.427629 127.045205 71.8058156 105.947851 59.464935"
        />
        <polyline
          id="Fill-389"
          fill="#B4B5B4"
          points="106.549585 58.2414915 49.8787861 89.9563424 70.2104956 101.703698 127.045205 70.0821586 106.549585 58.2414915"
        />
        <polyline
          id="Fill-391"
          fill="#9E9F9E"
          points="127.045205 70.0821586 125.513096 70.9274319 127.045205 71.811562 127.045205 70.0821586"
        />
        <path
          d="M40.739491,41.0462412 C42.3101833,40.1404935 44.8577697,40.1404935 46.4311985,41.0462412 C47.9909452,41.9517152 47.9909452,43.4241709 46.4311985,44.3299186 C44.8577697,45.2353926 42.3101833,45.2353926 40.739491,44.3299186 C39.171535,43.4241709 39.171535,41.9517152 40.739491,41.0462412"
          id="Fill-2213"
          fill="#71A241"
        />
        <path
          d="M44.9234433,42.6880799 C44.9234433,43.1146843 44.3241721,43.4624804 43.5853447,43.4624804 C42.8437809,43.4624804 42.2445098,43.1146843 42.2445098,42.6880799 L42.2445098,26.2694192 C42.2445098,25.8428148 42.8437809,25.4952923 43.5853447,25.4952923 C44.3241721,25.4952923 44.9234433,25.8428148 44.9234433,26.2694192 L44.9234433,42.6880799"
          id="Fill-2214"
          fill="#66493C"
        />
        <polyline
          id="Fill-2215"
          fill="#136053"
          points="43.5853447 39.4041288 43.5853447 26.2694192 49.2770522 22.9857418 54.9687597 32.836774 43.5853447 39.4041288"
        />
        <polyline
          id="Fill-2216"
          fill="#167061"
          points="43.5853447 26.2694192 52.122906 21.3439031 46.8963861 11.2195048 43.5853447 13.1347096 43.5853447 26.2694192"
        />
        <polyline
          id="Fill-2217"
          fill="#E4E4E3"
          points="66.8173623 80.4583055 38.1098126 64.4202778 38.1098126 21.1687736 67.0910021 38.7966485 66.8173623 80.4583055"
        />
        <polyline
          id="Fill-2218"
          fill="#B4B5B4"
          points="52.6975495 0 38.1070762 21.2593484 67.0910021 38.8899597 81.156087 16.6920268 52.6975495 0"
        />
        <polyline
          id="Fill-2219"
          fill="#9E9F9E"
          points="52.6975495 -4.85063841e-13 67.0910021 4.79991544 95.4948116 21.1687736 81.156087 16.6920268 52.6975495 -4.85063841e-13"
        />
        <polyline
          id="Fill-2220"
          fill="#F8F7F6"
          points="66.7899983 80.4583055 95.4948116 64.4202778 95.4948116 21.1687736 81.156087 16.6920268 67.0910021 38.7966485 66.7899983 80.4583055"
        />
        <polyline
          id="Fill-2221"
          fill="#E4E4E3"
          points="70.7577752 52.9219341 78.0639574 48.7051451 78.0639574 74.1700633 70.7577752 78.2336141 70.7577752 52.9219341"
        />
        <polyline
          id="Fill-2222"
          fill="#E4E4E3"
          points="82.9621096 46.4971456 89.6115563 42.6525067 89.6115563 56.624554 82.9621096 60.7261407 82.9621096 46.4971456"
        />
        <polyline
          id="Fill-2223"
          fill="#FFFFFE"
          points="61.8371183 52.6783947 55.1876715 48.8364922 55.1876715 62.8060767 61.8371183 66.9106735 61.8371183 52.6783947"
        />
        <polyline
          id="Fill-2224"
          fill="#FFFFFE"
          points="49.0307764 46.4971456 42.3755832 42.6525067 42.3755832 56.624554 49.0307764 60.7261407 49.0307764 46.4971456"
        />
        <polyline
          id="Fill-2237"
          fill="#9E9F9E"
          points="49.8787861 89.9563424 49.8516958 91.6611183 51.3567146 90.8076358 49.8787861 89.9563424"
        />
        <path
          d="M27.6473042,56.9690012 C25.9663733,56.9690012 24.5349771,58.1166815 23.9591281,59.7348259 C23.8686375,59.729349 23.7781469,59.7211337 23.6876564,59.7211337 C22.8403356,59.7211337 22.0588262,60.0141468 21.4144237,60.5100783 C20.7700211,60.0141468 19.9882375,59.7211337 19.1409167,59.7211337 C18.6391054,59.7211337 18.1622476,59.8279328 17.7235054,60.0114083 C17.3423482,59.6636264 16.8978476,59.3925208 16.4155054,59.2172607 C15.7765872,57.7631488 14.4219708,56.7581413 12.8507255,56.7581413 C10.6624991,56.7581413 8.89107774,58.6996954 8.89107774,61.098843 C8.89107774,63.0209542 10.0345494,64.6503262 11.6167633,65.2199218 C12.2556815,66.6740336 13.6102979,67.6817796 15.1815432,67.6817796 C15.6833545,67.6817796 16.1604865,67.5749805 16.5992287,67.3887665 C17.2875054,68.0213462 18.1732161,68.4019894 19.1409167,68.4019894 C19.9882375,68.4019894 20.7700211,68.1092502 21.4144237,67.6133186 C22.0588262,68.1092502 22.8403356,68.4019894 23.6876564,68.4019894 C25.365845,68.4019894 26.7999834,67.2518445 27.3758325,65.6334263 C27.466323,65.6419154 27.5537972,65.6501308 27.6473042,65.6501308 C29.8327884,65.6501308 31.606952,63.7055643 31.606952,61.3097029 C31.606952,58.9105553 29.8327884,56.9690012 27.6473042,56.9690012"
          id="Fill-3450"
          fill="#428849"
        />
        <path
          d="M27.227757,52.0893744 C25.6044111,52.2807914 24.3622224,53.6639776 24.0112287,55.4439638 C23.9234803,55.4467022 23.8357318,55.4494406 23.7479834,55.4573821 C22.928084,55.555966 22.2096438,55.9557782 21.6502476,56.5554967 C20.964713,56.103654 20.172235,55.8818404 19.3550777,55.9804242 C18.8697193,56.0379315 18.4227507,56.2025117 18.0196564,56.4514359 C17.6083356,56.123097 17.1449142,55.8873172 16.6568136,55.7588844 C15.855835,54.2910804 14.4219708,53.3816444 12.9028262,53.559643 C10.7886375,53.8115795 9.31885133,56.0735312 9.62322868,58.6120653 C9.86453686,60.6494649 11.175279,62.2462495 12.7739457,62.664957 C13.5773922,64.1330348 15.0115306,65.0449355 16.5306752,64.8639246 C17.0130174,64.8064173 17.4630023,64.6393725 17.8630803,64.3929128 C18.6092161,64.9819513 19.5113796,65.2859182 20.4461746,65.1733683 C21.2663482,65.0775229 21.9847884,64.6777106 22.5441847,64.0779922 C23.229445,64.5298348 24.0221972,64.7516485 24.8393545,64.6533385 C26.4627004,64.4613738 27.7021469,63.0787353 28.0556086,61.2984753 C28.1436312,61.2957368 28.2313796,61.2957368 28.3191281,61.2850569 C30.4330425,61.0328466 31.9031029,58.7711687 31.6014677,56.2326346 C31.2995582,53.6941004 29.3419457,51.8399025 27.227757,52.0893744"
          id="Fill-3451"
          fill="#4E9C52"
        />
        <path
          d="M26.7835306,53.0149672 C25.2972916,53.0149672 24.0328916,53.833487 23.5258702,54.9863704 C23.4463482,54.9811673 23.3668262,54.9756905 23.284562,54.9756905 C22.5387004,54.9756905 21.8476815,55.1835381 21.2773167,55.5367969 C20.7096941,55.1835381 20.0186752,54.9756905 19.2700715,54.9756905 C18.8285872,54.9756905 18.4062979,55.0496284 18.01664,55.1835381 C17.6796312,54.93434 17.2899733,54.7399108 16.862474,54.6166809 C16.2975935,53.5815505 15.1020211,52.864353 13.7144991,52.864353 C11.7840337,52.864353 10.2155306,54.2497299 10.2155306,55.9557782 C10.2155306,57.3249984 11.2273796,58.4863709 12.6231281,58.8913863 C13.1880086,59.9265167 14.3860488,60.6415235 15.773845,60.6415235 C16.2153293,60.6415235 16.6376186,60.5673117 17.0270023,60.4331281 C17.6330148,60.8849708 18.4172664,61.1563502 19.2700715,61.1563502 C20.0186752,61.1563502 20.7096941,60.9452165 21.2773167,60.59497 C21.8476815,60.9452165 22.5387004,61.1563502 23.284562,61.1563502 C24.7680589,61.1563502 26.0349268,60.3372827 26.5422224,59.1843994 C26.6217444,59.1898762 26.7012664,59.1953531 26.7835306,59.1953531 C28.713996,59.1953531 30.279757,57.8127146 30.279757,56.1063925 C30.279757,54.3976057 28.713996,53.0149672 26.7835306,53.0149672"
          id="Fill-3452"
          fill="#70BA64"
        />
        <path
          d="M14.7537696,54.9592598 C16.0014425,54.9592598 17.065118,54.2716375 17.4931658,53.3022296 C17.5617193,53.304968 17.6275306,53.3104449 17.696084,53.3104449 C18.3237595,53.3104449 18.905367,53.1354586 19.3824991,52.8369686 C19.8623733,53.1354586 20.4409645,53.3104449 21.0716564,53.3104449 C21.441845,53.3104449 21.7953067,53.2477346 22.1246375,53.1354586 C22.4068035,53.3460446 22.7361343,53.5076126 23.0953545,53.6119472 C23.5694702,54.4824974 24.5761092,55.0849542 25.7412438,55.0849542 C27.3673318,55.0849542 28.6838325,53.9211171 28.6838325,52.4861744 C28.6838325,51.333291 27.8337696,50.3584063 26.6598601,50.0188397 C26.1830023,49.1480157 25.1793796,48.5455588 24.0112287,48.5455588 C23.6407658,48.5455588 23.284562,48.6088168 22.9579733,48.720819 C22.4482098,48.3429142 21.7898224,48.1131591 21.0716564,48.1131591 C20.4409645,48.1131591 19.8623733,48.2881454 19.3824991,48.5866354 C18.905367,48.2881454 18.3237595,48.1131591 17.696084,48.1131591 C16.4481369,48.1131591 15.3844614,48.8005076 14.9564136,49.7696416 C14.8881343,49.767177 14.8220488,49.7617001 14.7537696,49.7617001 C13.1304237,49.7617001 11.8141972,50.9255373 11.8141972,52.3602061 C11.8141972,53.7951488 13.1304237,54.9592598 14.7537696,54.9592598"
          id="Fill-3453"
          fill="#88C37D"
        />
        <path
          d="M14.1834048,50.785603 C15.4310777,50.785603 16.4950274,51.4756899 16.9200589,52.4426332 C16.9883381,52.4396209 17.0544237,52.434144 17.1229771,52.434144 C17.7509268,52.434144 18.3322601,52.609678 18.8093922,52.908168 C19.2892664,52.609678 19.8705998,52.434144 20.4985494,52.434144 C20.8714803,52.434144 21.2252161,52.497402 21.5515306,52.609678 C21.836713,52.3988181 22.1627532,52.2372502 22.5219733,52.1329156 C22.9966375,51.2623654 24.0030023,50.6596347 25.1711532,50.6596347 C26.7942249,50.6596347 28.1107255,51.8234718 28.1107255,53.2586884 C28.1107255,54.4112979 27.2634048,55.3864565 26.0870274,55.7257493 C25.6123633,56.5965733 24.6062727,57.1990301 23.4381218,57.1990301 C23.0676589,57.1990301 22.7141972,57.136046 22.3851406,57.0240438 C21.8751029,57.4019486 21.2167155,57.6319776 20.4985494,57.6319776 C19.8705998,57.6319776 19.2892664,57.4567174 18.8093922,57.1579535 C18.3322601,57.4567174 17.7509268,57.6319776 17.1229771,57.6319776 C15.8750299,57.6319776 14.8113545,56.944629 14.3835809,55.9749473 C14.3177696,55.9776858 14.2489419,55.9831627 14.1834048,55.9831627 C12.5573167,55.9831627 11.2410903,54.8193255 11.2410903,53.3843828 C11.2410903,51.9494401 12.5573167,50.785603 14.1834048,50.785603"
          id="Fill-3454"
          fill="#88C37D"
        />
        <path
          d="M30.0686123,67.7201178 C29.2237595,67.7201178 28.5028513,68.2979287 28.2121847,69.1112455 C28.1683104,69.1087809 28.1216941,69.1030301 28.0748035,69.1030301 C27.6500463,69.1030301 27.2551784,69.2509059 26.9313318,69.5003778 C26.6080337,69.2509059 26.2159079,69.1030301 25.7881343,69.1030301 C25.5355834,69.1030301 25.2972916,69.157799 25.0751784,69.2509059 C24.8832287,69.0756457 24.6611155,68.9387237 24.4167909,68.8513675 C24.0959608,68.1202039 23.4134425,67.6133186 22.6237067,67.6133186 C21.521367,67.6133186 20.6301721,68.5912157 20.6301721,69.7958555 C20.6301721,70.7652634 21.2060211,71.5867955 22.000967,71.8715933 C22.3248136,72.6027569 23.0045897,73.1096422 23.7973419,73.1096422 C24.0468765,73.1096422 24.2879104,73.0576118 24.5102979,72.9645048 C24.8555331,73.28189 25.3027759,73.4735809 25.7881343,73.4735809 C26.2159079,73.4735809 26.6080337,73.3257051 26.9313318,73.076507 C27.2551784,73.3257051 27.6500463,73.4735809 28.0748035,73.4735809 C28.9221243,73.4735809 29.6435809,72.89577 29.9312312,72.0799886 C29.9778476,72.082727 30.0217218,72.0879301 30.0686123,72.0879301 C31.170952,72.0879301 32.0621469,71.1105807 32.0621469,69.9026547 C32.0621469,68.6980148 31.170952,67.7201178 30.0686123,67.7201178"
          id="Fill-3465"
          fill="#428849"
        />
        <path
          d="M29.8574677,65.2640107 C29.0403104,65.3598561 28.417845,66.0554199 28.239606,66.9508899 C28.1954576,66.9533545 28.1518576,66.9533545 28.1052413,66.9588314 C27.6939205,67.0083972 27.3319582,67.2107679 27.0519859,67.5122702 C26.7064765,67.2849796 26.3091406,67.1727036 25.8950777,67.2217217 C25.6537696,67.2493799 25.4258979,67.3339977 25.225996,67.459966 C25.0175935,67.2931949 24.7842375,67.175442 24.5377193,67.1097194 C24.1346249,66.3728052 23.4134425,65.9127472 22.6483859,66.0031157 C21.584162,66.1293578 20.846801,67.2682751 20.9973444,68.5474006 C21.1210148,69.5713034 21.7791281,70.3739403 22.5853167,70.5872648 C22.9884111,71.3239052 23.7093193,71.784237 24.4746501,71.6938685 C24.7184262,71.6634718 24.9432815,71.578854 25.146474,71.4553504 C25.5194048,71.7511019 25.9745998,71.9044546 26.4462476,71.8496858 C26.8575683,71.8006677 27.2195306,71.5980231 27.5016966,71.2965208 C27.8447381,71.5238114 28.2450903,71.6363613 28.6564111,71.5867955 C29.4735683,71.4909501 30.0987759,70.7956601 30.2742727,69.9001901 C30.3178727,69.8971778 30.3617469,69.8971778 30.4083633,69.891701 C31.4725872,69.7657327 32.2102224,68.6265415 32.0594048,67.3476899 C31.905845,66.0718506 30.9214174,65.1380424 29.8574677,65.2640107"
          id="Fill-3466"
          fill="#428849"
        />
        <path
          d="M29.6350803,65.7295455 C28.8867507,65.7295455 28.2505746,66.1403116 27.9955557,66.7205871 C27.9544237,66.7178486 27.9160337,66.7151102 27.8746274,66.7151102 C27.4992287,66.7151102 27.1509771,66.8219094 26.8630526,66.999908 C26.5778702,66.8219094 26.2293444,66.7151102 25.8539457,66.7151102 C25.6315582,66.7151102 25.4204136,66.7534484 25.2232538,66.8219094 C25.0532413,66.6959411 24.8585494,66.5976311 24.6419205,66.5373854 C24.3594803,66.0143433 23.7559356,65.6556076 23.0569645,65.6556076 C22.0862476,65.6556076 21.2965117,66.3511715 21.2965117,67.2083033 C21.2965117,67.8983903 21.8065494,68.481678 22.5085369,68.6870611 C22.7937193,69.2073647 23.3942476,69.568565 24.0934928,69.568565 C24.315606,69.568565 24.5294928,69.5302268 24.7241847,69.4645043 C25.0313042,69.6893302 25.4234299,69.8262522 25.8539457,69.8262522 C26.2293444,69.8262522 26.5778702,69.7219177 26.8630526,69.5441929 C27.1509771,69.7219177 27.4992287,69.8262522 27.8746274,69.8262522 C28.6204891,69.8262522 29.2569394,69.4154862 29.5144262,68.8349368 C29.5530903,68.8374014 29.5942224,68.8401399 29.6350803,68.8401399 C30.6060715,68.8401399 31.3958073,68.1448499 31.3958073,67.2849796 C31.3958073,66.4251094 30.6060715,65.7295455 29.6350803,65.7295455"
          id="Fill-3467"
          fill="#428849"
        />
        <path
          d="M23.580713,66.7071687 C24.2086626,66.7071687 24.7433796,66.3618514 24.9600086,65.874409 C24.9929142,65.874409 25.0258199,65.8774213 25.0611935,65.8774213 C25.3768136,65.8774213 25.6702224,65.7895174 25.9115306,65.6419154 C26.1500966,65.7895174 26.4435054,65.8774213 26.7588513,65.8774213 C26.9480589,65.8774213 27.1262979,65.8472985 27.2908262,65.7895174 C27.4334174,65.8963166 27.5976715,65.9784698 27.7786526,66.0305001 C28.0174928,66.4686506 28.5247884,66.769879 29.111606,66.769879 C29.9287633,66.769879 30.5896186,66.1868651 30.5896186,65.463643 C30.5896186,64.8830936 30.1645872,64.3929128 29.5722853,64.2203911 C29.333445,63.7822406 28.8261494,63.4810122 28.239606,63.4810122 C28.0531406,63.4810122 27.8746274,63.5114089 27.7103733,63.5689161 C27.4526123,63.3769515 27.1208136,63.261937 26.7588513,63.261937 C26.4435054,63.261937 26.1500966,63.3523055 25.9115306,63.5001813 C25.6702224,63.3523055 25.3768136,63.261937 25.0611935,63.261937 C24.433518,63.261937 23.898801,63.6099927 23.6821721,64.0971613 C23.6492664,64.0946967 23.6163608,64.0919582 23.580713,64.0919582 C22.7635557,64.0919582 22.0999582,64.6777106 22.0999582,65.4009327 C22.0999582,66.1208687 22.7635557,66.7071687 23.580713,66.7071687"
          id="Fill-3468"
          fill="#428849"
        />
        <path
          d="M23.2927884,64.6092496 C23.9207381,64.6092496 24.4554551,64.9545669 24.672084,65.4417355 C24.7049897,65.4392709 24.7376211,65.4365324 24.7735432,65.4365324 C25.0888891,65.4365324 25.3820237,65.5266271 25.623606,65.6747767 C25.8621721,65.5266271 26.1555809,65.4365324 26.4709268,65.4365324 C26.6598601,65.4365324 26.8383733,65.4693937 27.0029016,65.5266271 C27.1454928,65.4198279 27.3100211,65.3379486 27.4910023,65.2859182 C27.7295683,64.8474939 28.2368639,64.5438009 28.8236815,64.5438009 C29.6408387,64.5438009 30.3044362,65.1295533 30.3044362,65.8525015 C30.3044362,66.4330509 29.8766626,66.9232317 29.2843608,67.0932888 C29.0457947,67.5311654 28.5382249,67.8354061 27.9516815,67.8354061 C27.7652161,67.8354061 27.5869771,67.8025448 27.4224488,67.7475022 C27.1646878,67.9394669 26.8328891,68.0517429 26.4709268,68.0517429 C26.1555809,68.0517429 25.8621721,67.963839 25.623606,67.8159632 C25.3820237,67.963839 25.0888891,68.0517429 24.7735432,68.0517429 C24.1455935,68.0517429 23.6108765,67.7064256 23.3942476,67.2192571 C23.3613419,67.2217217 23.3284362,67.2247339 23.2927884,67.2247339 C22.475357,67.2247339 21.8120337,66.6384339 21.8120337,65.9154856 C21.8120337,65.1928112 22.475357,64.6092496 23.2927884,64.6092496"
          id="Fill-3469"
          fill="#428849"
        />
      </g>
    </g>
  </svg>
)

export const step28Image4 = (
  <svg
    width="70px"
    height="70px"
    viewBox="0 0 128 128"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    aria-hidden="true"
  >
    <g
      id="5.climate/climate_2.4"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Group" transform="translate(0.000000, 12.800000)">
        <path
          d="M40.739491,41.0459675 C42.3101833,40.1402198 44.8577697,40.1402198 46.4311985,41.0459675 C47.9909452,41.9514416 47.9909452,43.4238972 46.4311985,44.3296449 C44.8577697,45.235119 42.3101833,45.235119 40.739491,44.3296449 C39.171535,43.4238972 39.171535,41.9514416 40.739491,41.0459675"
          id="Fill-380"
          fill="#71A241"
        />
        <path
          d="M44.9234433,42.6878062 C44.9234433,43.1144106 44.3241721,43.4619332 43.5853447,43.4619332 C42.8437809,43.4619332 42.2445098,43.1144106 42.2445098,42.6878062 L42.2445098,26.2694192 C42.2445098,25.8425412 42.8437809,25.4950186 43.5853447,25.4950186 C44.3241721,25.4950186 44.9234433,25.8425412 44.9234433,26.2694192 L44.9234433,42.6878062"
          id="Fill-381"
          fill="#66493C"
        />
        <polyline
          id="Fill-382"
          fill="#136053"
          points="43.5853447 39.4041288 43.5853447 26.2694192 49.2770522 22.9857418 54.9687597 32.836774 43.5853447 39.4041288"
        />
        <polyline
          id="Fill-383"
          fill="#167061"
          points="43.5853447 26.2694192 52.122906 21.3439031 46.8963861 11.2192311 43.5853447 13.1347096 43.5853447 26.2694192"
        />
        <polyline
          id="Fill-2147"
          fill="#54A044"
          points="55.7620414 30.5080995 1.13686838e-13 62.884885 70.2104956 103.427629 127.045205 71.8055419 55.7620414 30.5080995"
        />
        <polyline
          id="Fill-2148"
          fill="#75B86A"
          points="55.7620414 28.7811588 1.13686838e-13 61.1554816 70.2104956 101.700688 127.045205 70.0788749 55.7620414 28.7811588"
        />
        <polyline
          id="Fill-2150"
          fill="#54A044"
          points="127.045205 70.0788749 125.513096 70.9246955 127.045205 71.8055419 127.045205 70.0788749"
        />
        <path
          d="M84.3847628,78.1761497 C84.6313122,78.0283843 85.0691359,78.0283843 85.315138,78.1761497 C85.5887778,78.3266516 85.5887778,78.570191 85.315138,78.7206929 C85.0691359,78.8684584 84.6313122,78.8684584 84.3847628,78.7206929 C84.1113966,78.570191 84.1113966,78.3266516 84.3847628,78.1761497 Z M68.5960209,79.9189615 C68.8696607,79.7687333 69.2801204,79.7687333 69.5537602,79.9189615 C69.800036,80.069737 69.800036,80.3130028 69.5537602,80.4607683 C69.2801204,80.6112702 68.8696607,80.6112702 68.5960209,80.4607683 C68.3494715,80.3130028 68.3494715,80.069737 68.5960209,79.9189615 Z M91.0344832,70.464707 C91.3081229,70.3142051 91.7185826,70.3142051 91.9648584,70.464707 C92.2384982,70.6152089 92.2384982,70.8587483 91.9648584,71.0065138 C91.7185826,71.1570157 91.3081229,71.1570157 91.0344832,71.0065138 C90.7882074,70.8587483 90.7882074,70.6152089 91.0344832,70.464707 Z M111.612195,69.2497464 C111.885561,69.1019809 112.296021,69.1019809 112.569934,69.2497464 C112.815936,69.4002482 112.815936,69.6437877 112.569934,69.7942895 C112.296021,69.942055 111.885561,69.942055 111.612195,69.7942895 C111.365919,69.6437877 111.365919,69.4002482 111.612195,69.2497464 Z M107.918058,64.3518679 C108.191424,64.2041024 108.601884,64.2041024 108.848433,64.3518679 C109.121799,64.5023698 109.121799,64.7459092 108.848433,64.896411 C108.601884,65.0469129 108.191424,65.0469129 107.918058,64.896411 C107.671782,64.7459092 107.671782,64.5023698 107.918058,64.3518679 Z M100.666604,57.877277 C100.940243,57.7270487 101.350703,57.7270487 101.624069,57.877277 C101.870619,58.0277788 101.870619,58.2715919 101.624069,58.4193574 C101.350703,58.5695856 100.940243,58.5695856 100.666604,58.4193574 C100.420328,58.2715919 100.420328,58.0277788 100.666604,57.877277 Z M80.5540795,68.9022238 C80.8000816,68.7519956 81.2381789,68.7519956 81.4841811,68.9022238 C81.7580945,69.0527257 81.7580945,69.2938024 81.4841811,69.4440306 C81.2381789,69.5945325 80.8000816,69.5945325 80.5540795,69.4440306 C80.3078037,69.2938024 80.3078037,69.0527257 80.5540795,68.9022238 Z M87.3403461,64.3518679 C87.6139859,64.2041024 88.0244455,64.2041024 88.2980853,64.3518679 C88.5443611,64.5023698 88.5443611,64.7459092 88.2980853,64.896411 C88.0244455,65.0469129 87.6139859,65.0469129 87.3403461,64.896411 C87.0940703,64.7459092 87.0940703,64.5023698 87.3403461,64.3518679 Z M100.009868,66.182518 C100.283508,66.0347525 100.693968,66.0347525 100.940243,66.182518 C101.213609,66.3330199 101.213609,66.5765593 100.940243,66.7267876 C100.693968,66.8775631 100.283508,66.8775631 100.009868,66.7267876 C99.7635923,66.5765593 99.7635923,66.3330199 100.009868,66.182518 Z M72.9195295,82.7514069 C73.1931693,82.600905 73.603629,82.600905 73.8499048,82.7514069 C74.1232709,82.9019088 74.1232709,83.1451746 73.8499048,83.2959501 C73.603629,83.4437156 73.1931693,83.4437156 72.9195295,83.2959501 C72.6732537,83.1451746 72.6732537,82.9019088 72.9195295,82.7514069 Z M109.833263,72.5501158 C110.107176,72.4020767 110.517636,72.4020767 110.763638,72.5501158 C111.037278,72.700344 111.037278,72.9438834 110.763638,73.0943853 C110.517636,73.2421508 110.107176,73.2421508 109.833263,73.0943853 C109.58726,72.9438834 109.58726,72.700344 109.833263,72.5501158 Z M73.7404488,73.7951768 C74.0140886,73.6474113 74.4245483,73.6474113 74.6708241,73.7951768 C74.9441903,73.9456787 74.9441903,74.1889445 74.6708241,74.33972 C74.4245483,74.4874855 74.0140886,74.4874855 73.7404488,74.33972 C73.494173,74.1889445 73.494173,73.9456787 73.7404488,73.7951768 Z M58.6081688,83.1369654 C58.8544446,82.9864635 59.2922683,82.9864635 59.5385441,83.1369654 C59.8121839,83.2847309 59.8121839,83.5285439 59.5385441,83.6787721 C59.2922683,83.829274 58.8544446,83.829274 58.6081688,83.6787721 C58.334529,83.5285439 58.334529,83.2847309 58.6081688,83.1369654 Z M94.9201681,78.1761497 C95.1938079,78.0283843 95.6042675,78.0283843 95.8776337,78.1761497 C96.1241831,78.3266516 96.1241831,78.570191 95.8776337,78.7206929 C95.6042675,78.8684584 95.1938079,78.8684584 94.9201681,78.7206929 C94.6738923,78.570191 94.6738923,78.3266516 94.9201681,78.1761497 Z M97.1640143,79.1530438 C97.4102901,79.0025419 97.8481138,79.0025419 98.0943896,79.1530438 C98.3680294,79.3008092 98.3680294,79.5443487 98.0943896,79.6948505 C97.8481138,79.8450788 97.4102901,79.8450788 97.1640143,79.6948505 C96.8903745,79.5443487 96.8903745,79.3008092 97.1640143,79.1530438 Z M81.5391827,85.6218882 C81.8128225,85.4711127 82.2232821,85.4711127 82.4969219,85.6218882 C82.7429241,85.7723901 82.7429241,86.0129195 82.4969219,86.163695 C82.2232821,86.3141969 81.8128225,86.3141969 81.5391827,86.163695 C81.2929069,86.0129195 81.2929069,85.7723901 81.5391827,85.6218882 Z M61.6455704,86.1415302 C61.9189366,85.991302 62.3293962,85.991302 62.603036,86.1415302 C62.8495855,86.2920321 62.8495855,86.5358451 62.603036,86.6836106 C62.3293962,86.8338388 61.9189366,86.8338388 61.6455704,86.6836106 C61.399021,86.5358451 61.399021,86.2920321 61.6455704,86.1415302 Z M63.5336849,89.441626 C63.7799607,89.2938605 64.2177844,89.2938605 64.4640602,89.441626 C64.7377,89.5921279 64.7377,89.8356673 64.4640602,89.9861692 C64.2177844,90.1369447 63.7799607,90.1369447 63.5336849,89.9861692 C63.2874091,89.8356673 63.2874091,89.5921279 63.5336849,89.441626 Z M81.5391827,89.9891792 C81.8128225,89.8414137 82.2232821,89.8414137 82.4969219,89.9891792 C82.7429241,90.1396811 82.7429241,90.3832205 82.4969219,90.5334487 C82.2232821,90.6842242 81.8128225,90.6842242 81.5391827,90.5334487 C81.2929069,90.3832205 81.2929069,90.1396811 81.5391827,89.9891792 L81.5391827,89.9891792 Z"
          id="Fill-2151"
          fill="#9ECB94"
        />
        <path
          d="M62.3293962,77.2430381 C62.5759457,77.0952726 62.9864054,77.0952726 63.2600451,77.2430381 C63.5063209,77.3932663 63.5063209,77.6370794 63.2600451,77.7873076 C62.9864054,77.9350731 62.5759457,77.9350731 62.3293962,77.7873076 C62.0560301,77.6370794 62.0560301,77.3932663 62.3293962,77.2430381 Z M74.5613682,71.2336348 C74.835008,71.0831329 75.2454677,71.0831329 75.4917435,71.2336348 C75.7651096,71.3814003 75.7651096,71.6252133 75.4917435,71.7754416 C75.2454677,71.9259434 74.835008,71.9259434 74.5613682,71.7754416 C74.3150924,71.6252133 74.3150924,71.3814003 74.5613682,71.2336348 Z M82.1959182,71.6170041 C82.4695579,71.4665022 82.8800176,71.4665022 83.1533838,71.6170041 C83.3999332,71.7672324 83.3999332,72.008309 83.1533838,72.1588109 C82.8800176,72.3090391 82.4695579,72.3090391 82.1959182,72.1588109 C81.9496424,72.008309 81.9496424,71.7672324 82.1959182,71.6170041 Z M85.4795956,67.5288258 C85.7532353,67.3783239 86.163695,67.3783239 86.4370612,67.5288258 C86.6836106,67.6765912 86.6836106,67.9201307 86.4370612,68.0706325 C86.163695,68.2208608 85.7532353,68.2208608 85.4795956,68.0706325 C85.2333198,67.9201307 85.2333198,67.6765912 85.4795956,67.5288258 Z M99.0521288,63.1557884 C99.3257686,63.0055601 99.7362283,63.0055601 99.9822304,63.1557884 C100.256144,63.3062903 100.256144,63.5501033 99.9822304,63.6975952 C99.7362283,63.848097 99.3257686,63.848097 99.0521288,63.6975952 C98.805853,63.5501033 98.805853,63.3062903 99.0521288,63.1557884 Z M66.0785349,78.1761497 C66.3245371,78.0283843 66.7626344,78.0283843 67.0089102,78.1761497 C67.28255,78.3266516 67.28255,78.570191 67.0089102,78.7206929 C66.7626344,78.8711948 66.3245371,78.8711948 66.0785349,78.7206929 C65.8322591,78.570191 65.8322591,78.3266516 66.0785349,78.1761497 Z M114.266501,67.8322923 C114.512777,67.6817904 114.9506,67.6817904 115.196876,67.8322923 C115.470516,67.9830678 115.470516,68.2235972 115.196876,68.3740991 C114.9506,68.5248746 114.512777,68.5248746 114.266501,68.3740991 C113.992861,68.2235972 113.992861,67.9830678 114.266501,67.8322923 Z M116.045159,68.9022238 C116.291435,68.7519956 116.729259,68.7519956 116.975535,68.9022238 C117.249174,69.0527257 117.249174,69.2938024 116.975535,69.4440306 C116.729259,69.5945325 116.291435,69.5945325 116.045159,69.4440306 C115.77152,69.2938024 115.77152,69.0527257 116.045159,68.9022238 Z M69.9368559,73.0289854 C70.1831317,72.8782099 70.6209553,72.8782099 70.8672311,73.0289854 C71.1408709,73.1794873 71.1408709,73.4200167 70.8672311,73.5707922 C70.6209553,73.7212941 70.1831317,73.7212941 69.9368559,73.5707922 C69.6632161,73.4200167 69.6632161,73.1794873 69.9368559,73.0289854 Z M94.9201681,58.6464784 C95.1938079,58.4957029 95.6042675,58.4957029 95.8776337,58.6464784 C96.1241831,58.7942439 96.1241831,59.0377833 95.8776337,59.1882852 C95.6042675,59.3385134 95.1938079,59.3385134 94.9201681,59.1882852 C94.6738923,59.0377833 94.6738923,58.7942439 94.9201681,58.6464784 Z M88.763273,73.7951768 C89.0369127,73.6474113 89.4473724,73.6474113 89.7207386,73.7951768 C89.967288,73.9456787 89.967288,74.1889445 89.7207386,74.33972 C89.4473724,74.4874855 89.0369127,74.4874855 88.763273,74.33972 C88.5169972,74.1889445 88.5169972,73.9456787 88.763273,73.7951768 Z M77.0241263,79.1530438 C77.297766,79.0025419 77.7082257,79.0025419 77.9818655,79.1530438 C78.2278677,79.3008092 78.2278677,79.5443487 77.9818655,79.6948505 C77.7082257,79.8450788 77.297766,79.8450788 77.0241263,79.6948505 C76.7778504,79.5443487 76.7778504,79.3008092 77.0241263,79.1530438 Z M88.3528133,81.0600394 C88.6264531,80.9122739 89.0369127,80.9122739 89.3102789,81.0600394 C89.5568283,81.2105413 89.5568283,81.4540807 89.3102789,81.6045826 C89.0369127,81.7523481 88.6264531,81.7523481 88.3528133,81.6045826 C88.1065375,81.4540807 88.1065375,81.2105413 88.3528133,81.0600394 Z M94.7286202,82.5349578 C95.00226,82.384456 95.4127197,82.384456 95.6863595,82.5349578 C95.9326353,82.6854597 95.9326353,82.9262627 95.6863595,83.0767646 C95.4127197,83.2275401 95.00226,83.2275401 94.7286202,83.0767646 C94.4823444,82.9262627 94.4823444,82.6854597 94.7286202,82.5349578 Z M52.3415441,82.7514069 C52.6154576,82.600905 53.0259172,82.600905 53.2992834,82.7514069 C53.5458328,82.9019088 53.5458328,83.1451746 53.2992834,83.2959501 C53.0259172,83.4437156 52.6154576,83.4437156 52.3415441,83.2959501 C52.095542,83.1451746 52.095542,82.9019088 52.3415441,82.7514069 Z M50.0706076,83.7307637 C50.3166097,83.5829982 50.754707,83.5829982 51.0009828,83.7307637 C51.2746226,83.8812656 51.2746226,84.124805 51.0009828,84.2755805 C50.754707,84.4230724 50.3166097,84.4230724 50.0706076,84.2755805 C49.7969678,84.124805 49.7969678,83.8812656 50.0706076,83.7307637 Z M67.5835537,85.214165 C67.8571935,85.0636631 68.2676532,85.0636631 68.513929,85.214165 C68.7872951,85.3646669 68.7872951,85.6079326 68.513929,85.7559717 C68.2676532,85.9064736 67.8571935,85.9064736 67.5835537,85.7559717 C67.3372779,85.6079326 67.3372779,85.3646669 67.5835537,85.214165 Z M69.2527564,93.0293172 C69.5263962,92.8788153 69.9368559,92.8788153 70.2104956,93.0293172 C70.4567714,93.1770827 70.4567714,93.4206221 70.2104956,93.571124 C69.9368559,93.7216258 69.5263962,93.7216258 69.2527564,93.571124 C69.0064806,93.4206221 69.0064806,93.1770827 69.2527564,93.0293172 Z M65.4217994,93.8201362 C65.6680752,93.672097 66.1058989,93.672097 66.3521747,93.8201362 C66.6258145,93.9703644 66.6258145,94.2139038 66.3521747,94.3644057 C66.1058989,94.5151812 65.6680752,94.5151812 65.4217994,94.3644057 C65.1481596,94.2139038 65.1481596,93.9703644 65.4217994,93.8201362 Z M75.9569311,93.8365545 C76.2305709,93.685779 76.6410306,93.685779 76.9146703,93.8365545 C77.1609461,93.9870564 77.1609461,94.2305958 76.9146703,94.3783613 C76.6410306,94.5288632 76.2305709,94.5288632 75.9569311,94.3783613 C75.7106553,94.2305958 75.7106553,93.9870564 75.9569311,93.8365545 L75.9569311,93.8365545 Z"
          id="Fill-2152"
          fill="#51A146"
        />
        <path
          d="M87.6139859,85.6818154 C87.6139859,84.7760677 88.3254493,84.0399767 89.2284606,84.0399767 L89.2558246,84.0399767 C89.2558246,84.9487344 88.5169972,85.6818154 87.6139859,85.6818154"
          id="Fill-2153"
          fill="#51A146"
        />
        <path
          d="M87.6139859,85.6818154 C87.6139859,84.7760677 86.8751585,84.0399767 85.9721472,84.0399767 C85.9721472,84.9487344 86.6836106,85.6818154 87.6139859,85.6818154"
          id="Fill-2154"
          fill="#51A146"
        />
        <path
          d="M55.9264989,87.5455759 C55.9264989,86.6370918 56.6653264,85.9037372 57.5683376,85.9037372 C57.5683376,86.8092113 56.8566006,87.5455759 55.9264989,87.5455759"
          id="Fill-2155"
          fill="#9ECB94"
        />
        <path
          d="M55.9264989,87.5455759 C55.9264989,86.6370918 55.2147619,85.9037372 54.2846602,85.9037372 C54.2846602,86.8092113 55.0234877,87.5455759 55.9264989,87.5455759"
          id="Fill-2156"
          fill="#9ECB94"
        />
        <path
          d="M104.278649,77.6945437 C104.278649,76.7860596 105.017202,76.052705 105.920487,76.052705 C105.920487,76.9581791 105.18166,77.6945437 104.278649,77.6945437"
          id="Fill-2157"
          fill="#9ECB94"
        />
        <path
          d="M104.278649,77.6945437 C104.278649,76.7860596 103.539821,76.052705 102.63681,76.052705 C102.63681,76.9581791 103.375364,77.6945437 104.278649,77.6945437"
          id="Fill-2158"
          fill="#9ECB94"
        />
        <path
          d="M72.0436086,78.3373236 C72.0436086,77.4291131 72.7827096,76.6954849 73.6854473,76.6954849 C73.6854473,77.6015062 72.9468935,78.3373236 72.0436086,78.3373236 L72.0436086,78.3345872 L72.0436086,78.3373236"
          id="Fill-2159"
          fill="#9ECB94"
        />
        <path
          d="M72.0436086,78.3373236 C72.0436086,77.4291131 71.3050548,76.6954849 70.4017699,76.6954849 C70.4017699,77.6015062 71.1408709,78.3373236 72.0436086,78.3373236 L72.0436086,78.3345872 L72.0436086,78.3373236"
          id="Fill-2160"
          fill="#9ECB94"
        />
        <path
          d="M74.2056365,89.1874146 C74.2056365,88.2789305 74.9441903,87.5455759 75.8474752,87.5455759 C75.8474752,88.45105 75.1086478,89.1874146 74.2056365,89.1874146"
          id="Fill-2161"
          fill="#51A146"
        />
        <path
          d="M74.2056365,89.1874146 C74.2056365,88.2789305 73.4668091,87.5455759 72.5637978,87.5455759 C72.5637978,88.45105 73.3023516,89.1874146 74.2056365,89.1874146"
          id="Fill-2162"
          fill="#51A146"
        />
        <path
          d="M85.5069595,75.272558 C85.5069595,74.3640739 86.245787,73.6307193 87.1487982,73.6307193 C87.1487982,74.536467 86.4096972,75.272558 85.5069595,75.272558"
          id="Fill-2163"
          fill="#51A146"
        />
        <path
          d="M85.5069595,75.272558 C85.5069595,74.3640739 84.7678585,73.6307193 83.8651208,73.6307193 C83.8651208,74.536467 84.6039483,75.272558 85.5069595,75.272558"
          id="Fill-2164"
          fill="#51A146"
        />
        <path
          d="M93.1415095,66.8912451 C93.1415095,65.9852237 93.8803369,65.2494064 94.7833482,65.2494064 L94.7833482,65.2521428 C94.7833482,66.1576168 94.0445208,66.8912451 93.1415095,66.8912451"
          id="Fill-2165"
          fill="#51A146"
        />
        <path
          d="M93.1415095,66.8912451 C93.1415095,65.9852237 92.4026821,65.2494064 91.4996708,65.2494064 L91.4996708,65.2521428 C91.4996708,66.1576168 92.2384982,66.8912451 93.1415095,66.8912451"
          id="Fill-2166"
          fill="#51A146"
        />
        <path
          d="M98.2859374,72.7088269 C98.2859374,71.8030792 99.0247648,71.0669882 99.9277761,71.0669882 C99.9277761,71.9724622 99.1889487,72.7088269 98.2859374,72.7088269"
          id="Fill-2167"
          fill="#51A146"
        />
        <path
          d="M98.2859374,72.7088269 C98.2859374,71.8030792 97.54711,71.0669882 96.6440987,71.0669882 C96.6440987,71.9724622 97.3829261,72.7088269 98.2859374,72.7088269"
          id="Fill-2168"
          fill="#51A146"
        />
        <path
          d="M59.9216398,64.9317106 C60.1952796,64.7842187 60.6057392,64.7842187 60.879379,64.9317106 C61.1256548,65.0824861 61.1256548,65.3260255 60.879379,65.4765274 C60.6057392,65.6242929 60.1952796,65.6242929 59.9216398,65.4765274 C59.675364,65.3260255 59.675364,65.0824861 59.9216398,64.9317106 Z M44.1545155,66.674796 C44.4144733,66.5245678 44.8358785,66.5245678 45.0955627,66.674796 C45.3637297,66.8252979 45.3637297,67.0688373 45.0955627,67.2196128 C44.8358785,67.3673783 44.4144733,67.3673783 44.1545155,67.2196128 C43.8945577,67.0688373 43.8945577,66.8252979 44.1545155,66.674796 Z M66.5984505,57.2205415 C66.8444527,57.0700396 67.28255,57.0700396 67.5285521,57.2205415 C67.7751016,57.3710434 67.7751016,57.6145828 67.5285521,57.7623483 C67.28255,57.9128501 66.8444527,57.9128501 66.5984505,57.7623483 C66.3245371,57.6145828 66.3245371,57.3710434 66.5984505,57.2205415 Z M87.1761622,56.0058545 C87.422438,55.8578154 87.8602617,55.8578154 88.1065375,56.0058545 C88.3801773,56.1560827 88.3801773,56.3996221 88.1065375,56.550124 C87.8602617,56.6978895 87.422438,56.6978895 87.1761622,56.550124 C86.9025224,56.3996221 86.9025224,56.1560827 87.1761622,56.0058545 Z M83.4820251,51.1104388 C83.7283009,50.9599369 84.1661246,50.9599369 84.4124004,51.1104388 C84.6860402,51.2582042 84.6860402,51.5017436 84.4124004,51.6522455 C84.1661246,51.8024738 83.7283009,51.8024738 83.4820251,51.6522455 C83.2083854,51.5017436 83.2083854,51.2582042 83.4820251,51.1104388 Z M76.2305709,44.6333851 C76.5042107,44.4826096 76.9146703,44.4826096 77.1609461,44.6333851 C77.4345859,44.783887 77.4345859,45.0274264 77.1609461,45.1751919 C76.9146703,45.3256937 76.5042107,45.3256937 76.2305709,45.1751919 C75.9842951,45.0274264 75.9842951,44.783887 76.2305709,44.6333851 Z M56.1180468,55.658332 C56.3643226,55.5075564 56.8021463,55.5075564 57.0484221,55.658332 C57.2944242,55.8088338 57.2944242,56.0493632 57.0484221,56.2001387 C56.8021463,56.3506406 56.3643226,56.3506406 56.1180468,56.2001387 C55.844407,56.0493632 55.844407,55.8088338 56.1180468,55.658332 Z M62.9043134,51.1104388 C63.1503156,50.9599369 63.5884129,50.9599369 63.834415,51.1104388 C64.1083285,51.2582042 64.1083285,51.5017436 63.834415,51.6522455 C63.5884129,51.8024738 63.1503156,51.8024738 62.9043134,51.6522455 C62.6304,51.5017436 62.6304,51.2582042 62.9043134,51.1104388 Z M75.5738354,52.9410889 C75.8201112,52.790587 76.2579349,52.790587 76.5042107,52.9410889 C76.7778504,53.0888544 76.7778504,53.3323938 76.5042107,53.4828957 C76.2579349,53.6331239 75.8201112,53.6331239 75.5738354,53.4828957 C75.3001956,53.3323938 75.3001956,53.0888544 75.5738354,52.9410889 Z M48.4834968,69.5072414 C48.7297726,69.3594759 49.1675963,69.3594759 49.4138721,69.5072414 C49.6875119,69.6574696 49.6875119,69.9012827 49.4138721,70.0515109 C49.1675963,70.1992764 48.7297726,70.1992764 48.4834968,70.0515109 C48.2098571,69.9012827 48.2098571,69.6574696 48.4834968,69.5072414 Z M85.3975036,59.3056766 C85.6437794,59.1581848 86.0816031,59.1581848 86.3278789,59.3056766 C86.6015187,59.4561785 86.6015187,59.6999916 86.3278789,59.8502198 C86.0816031,59.9979853 85.6437794,59.9979853 85.3975036,59.8502198 C85.1238638,59.6999916 85.1238638,59.4561785 85.3975036,59.3056766 Z M49.3044162,60.5510113 C49.550692,60.4032458 49.9885156,60.4032458 50.2347914,60.5510113 C50.5084312,60.7012395 50.5084312,60.9450526 50.2347914,61.0952808 C49.9885156,61.2430463 49.550692,61.2430463 49.3044162,61.0952808 C49.0307764,60.9450526 49.0307764,60.7012395 49.3044162,60.5510113 Z M34.1611906,69.8900635 C34.4181383,69.742298 34.8398172,69.742298 35.099775,69.8900635 C35.3594592,70.040839 35.3594592,70.2841047 35.099775,70.4348803 C34.8398172,70.5853821 34.4181383,70.5853821 34.1611906,70.4348803 C33.9012328,70.2841047 33.9012328,70.040839 34.1611906,69.8900635 Z M70.4841354,64.9317106 C70.7304112,64.7842187 71.1682349,64.7842187 71.4145107,64.9317106 C71.6881505,65.0824861 71.6881505,65.3260255 71.4145107,65.4765274 C71.1682349,65.6242929 70.7304112,65.6242929 70.4841354,65.4765274 C70.2378596,65.3260255 70.2378596,65.0824861 70.4841354,64.9317106 Z M72.7006177,65.9088782 C72.9742575,65.7581027 73.3847171,65.7581027 73.6583569,65.9088782 C73.9046327,66.0591065 73.9046327,66.2999095 73.6583569,66.4504114 C73.3847171,66.6009133 72.9742575,66.6009133 72.7006177,66.4504114 C72.4540682,66.2999095 72.4540682,66.0591065 72.7006177,65.9088782 Z M57.10315,72.3777227 C57.3494258,72.2272208 57.7872495,72.2272208 58.0335253,72.3777227 C58.3071651,72.5282246 58.3071651,72.771764 58.0335253,72.9195295 C57.7872495,73.0700314 57.3494258,73.0700314 57.10315,72.9195295 C56.8295102,72.771764 56.8295102,72.5282246 57.10315,72.3777227 Z M37.2065277,72.8976383 C37.4667592,72.7468628 37.8878908,72.7468628 38.1481222,72.8976383 C38.4053436,73.0481402 38.4053436,73.2916796 38.1481222,73.4394451 C37.8878908,73.589947 37.4667592,73.589947 37.2065277,73.4394451 C36.9468436,73.2916796 36.9468436,73.0481402 37.2065277,72.8976383 Z M39.0867067,76.2004705 C39.3466645,76.0499686 39.7680697,76.0499686 40.0277539,76.2004705 C40.2879853,76.348236 40.2879853,76.5917754 40.0277539,76.7422773 C39.7680697,76.8927792 39.3466645,76.8927792 39.0867067,76.7422773 C38.8294853,76.5917754 38.8294853,76.348236 39.0867067,76.2004705 Z M57.10315,76.7477501 C57.3494258,76.5972482 57.7872495,76.5972482 58.0335253,76.7477501 C58.3071651,76.8955156 58.3071651,77.139055 58.0335253,77.2895568 C57.7872495,77.4397851 57.3494258,77.4397851 57.10315,77.2895568 C56.8295102,77.139055 56.8295102,76.8955156 57.10315,76.7477501 L57.10315,76.7477501 Z"
          id="Fill-2169"
          fill="#9ECB94"
        />
        <path
          d="M37.871746,64.001609 C38.1317038,63.8511071 38.5528355,63.8511071 38.8103305,64.001609 C39.0702883,64.1493744 39.0702883,64.3929138 38.8103305,64.5431421 C38.5528355,64.6911812 38.1317038,64.6911812 37.871746,64.5431421 C37.6115146,64.3929138 37.6115146,64.1493744 37.871746,64.001609 Z M50.1253355,57.9897429 C50.3716113,57.8389674 50.809435,57.8389674 51.0557108,57.9897429 C51.3293506,58.1375084 51.3293506,58.3807742 51.0557108,58.5315497 C50.809435,58.6820516 50.3716113,58.6820516 50.1253355,58.5315497 C49.8516958,58.3807742 49.8516958,58.1375084 50.1253355,57.9897429 Z M57.7598855,58.372565 C58.0335253,58.2220631 58.443985,58.2220631 58.6902608,58.372565 C58.9639005,58.5230669 58.9639005,58.7638699 58.6902608,58.9143717 C58.443985,59.0648736 58.0335253,59.0648736 57.7598855,58.9143717 C57.5136097,58.7638699 57.5136097,58.5230669 57.7598855,58.372565 Z M61.0435629,54.2846602 C61.2898387,54.1338847 61.7276624,54.1338847 61.9739382,54.2846602 C62.2475779,54.4324257 62.2475779,54.6756915 61.9739382,54.826467 C61.7276624,54.9766953 61.2898387,54.9766953 61.0435629,54.826467 C60.7699231,54.6756915 60.7699231,54.4324257 61.0435629,54.2846602 Z M74.6160962,49.9118965 C74.862372,49.764131 75.3001956,49.764131 75.5464714,49.9118965 C75.8201112,50.0623984 75.8201112,50.3059378 75.5464714,50.4564397 C75.3001956,50.6042052 74.862372,50.6042052 74.6160962,50.4564397 C74.3424564,50.3059378 74.3424564,50.0623984 74.6160962,49.9118965 Z M41.631283,64.9317106 C41.8915145,64.7842187 42.3126461,64.7842187 42.5728775,64.9317106 C42.8325617,65.0824861 42.8325617,65.3260255 42.5728775,65.4765274 C42.3126461,65.6242929 41.8915145,65.6242929 41.631283,65.4765274 C41.3743353,65.3260255 41.3743353,65.0824861 41.631283,64.9317106 Z M89.8031041,54.5881268 C90.0767439,54.4378985 90.4872036,54.4378985 90.7608434,54.5881268 C91.0071192,54.7386286 91.0071192,54.9797053 90.7608434,55.1299335 C90.4872036,55.2804354 90.0767439,55.2804354 89.8031041,55.1299335 C89.5568283,54.9797053 89.5568283,54.7386286 89.8031041,54.5881268 Z M91.5817627,55.658332 C91.8554025,55.5075564 92.2658622,55.5075564 92.539502,55.658332 C92.7857778,55.8088338 92.7857778,56.0493632 92.539502,56.2001387 C92.2658622,56.3506406 91.8554025,56.3506406 91.5817627,56.2001387 C91.3352133,56.0493632 91.3352133,55.8088338 91.5817627,55.658332 Z M45.4734592,59.7848199 C45.747099,59.634318 46.1575587,59.634318 46.4311985,59.7848199 C46.6774743,59.9353218 46.6774743,60.1761248 46.4311985,60.3266267 C46.1575587,60.4771285 45.747099,60.4771285 45.4734592,60.3266267 C45.2271834,60.1761248 45.2271834,59.9353218 45.4734592,59.7848199 Z M70.4841354,45.3995765 C70.7304112,45.2515374 71.1682349,45.2515374 71.4145107,45.3995765 C71.6881505,45.5500784 71.6881505,45.7933441 71.4145107,45.9441196 C71.1682349,46.0946215 70.7304112,46.0946215 70.4841354,45.9441196 C70.2378596,45.7933441 70.2378596,45.5500784 70.4841354,45.3995765 Z M64.3272403,60.5510113 C64.5735161,60.4032458 65.0113398,60.4032458 65.2576156,60.5510113 C65.5312553,60.7012395 65.5312553,60.9450526 65.2576156,61.0952808 C65.0113398,61.2430463 64.5735161,61.2430463 64.3272403,61.0952808 C64.0536005,60.9450526 64.0536005,60.7012395 64.3272403,60.5510113 Z M52.5880936,65.9088782 C52.8343694,65.7581027 53.272193,65.7581027 53.5184689,65.9088782 C53.7921086,66.0566437 53.7921086,66.2999095 53.5184689,66.4504114 C53.272193,66.6009133 52.8343694,66.6009133 52.5880936,66.4504114 C52.3144538,66.2999095 52.3144538,66.0566437 52.5880936,65.9088782 Z M63.9167806,67.8158739 C64.1630564,67.6681084 64.6008801,67.6681084 64.8471559,67.8158739 C65.1207957,67.9663758 65.1207957,68.2099152 64.8471559,68.3604171 C64.6008801,68.5081825 64.1630564,68.5081825 63.9167806,68.3604171 C63.6431408,68.2099152 63.6431408,67.9663758 63.9167806,67.8158739 Z M70.2925876,69.2907923 C70.5385897,69.1405641 70.976687,69.1405641 71.2226892,69.2907923 C71.4966026,69.4412942 71.4966026,69.6823709 71.2226892,69.8325991 C70.976687,69.9833746 70.5385897,69.9833746 70.2925876,69.8325991 C70.0186742,69.6823709 70.0186742,69.4412942 70.2925876,69.2907923 Z M27.9030487,69.5072414 C28.1630065,69.3594759 28.5844118,69.3594759 28.8416332,69.5072414 C29.101591,69.6574696 29.101591,69.9012827 28.8416332,70.0515109 C28.5844118,70.1992764 28.1630065,70.1992764 27.9030487,70.0515109 C27.6430909,69.9012827 27.6430909,69.6574696 27.9030487,69.5072414 Z M25.6178829,70.4865982 C25.8753779,70.3388327 26.2967832,70.3388327 26.556741,70.4865982 C26.8166988,70.6371001 26.8166988,70.8809131 26.556741,71.0311414 C26.2967832,71.1789068 25.8753779,71.1789068 25.6178829,71.0311414 C25.3581987,70.8809131 25.3581987,70.6371001 25.6178829,70.4865982 Z M43.1393119,71.9699994 C43.3965333,71.8194976 43.8179385,71.8194976 44.0778963,71.9699994 C44.3375805,72.1202277 44.3375805,72.3640407 44.0778963,72.5118062 C43.8179385,72.6620345 43.3965333,72.6620345 43.1393119,72.5118062 C42.8793541,72.3640407 42.8793541,72.1202277 43.1393119,71.9699994 Z M44.8191865,79.7851517 C45.0794179,79.6343761 45.5005496,79.6343761 45.747099,79.7851517 C46.0207388,79.9329171 46.0207388,80.1764566 45.747099,80.3269584 C45.5005496,80.4771867 45.0794179,80.4771867 44.8191865,80.3269584 C44.5595023,80.1764566 44.5595023,79.9329171 44.8191865,79.7851517 Z M40.9663383,80.5784334 C41.2265698,80.4279315 41.647975,80.4279315 41.9079328,80.5784334 C42.1678906,80.7261989 42.1678906,80.9700119 41.9079328,81.1202402 C41.647975,81.2710157 41.2265698,81.2710157 40.9663383,81.1202402 C40.7091169,80.9700119 40.7091169,80.7261989 40.9663383,80.5784334 Z M51.5206248,80.5921154 C51.7671742,80.4418871 52.2049979,80.4418871 52.4512737,80.5921154 C52.7249135,80.7426173 52.7249135,80.9861567 52.4512737,81.1339222 C52.2049979,81.284424 51.7671742,81.284424 51.5206248,81.1339222 C51.246985,80.9861567 51.246985,80.7426173 51.5206248,80.5921154 L51.5206248,80.5921154 Z"
          id="Fill-2170"
          fill="#51A146"
        />
        <path
          d="M63.1503156,72.4379235 C63.1503156,71.5319022 63.8894166,70.7985475 64.7921543,70.7985475 C64.7921543,71.7042952 64.0536005,72.4403862 63.1503156,72.4403862 L63.1503156,72.4379235"
          id="Fill-2171"
          fill="#51A146"
        />
        <path
          d="M63.1503156,72.4379235 C63.1503156,71.5319022 62.4117618,70.7985475 61.5084769,70.7985475 C61.5084769,71.7042952 62.2475779,72.4403862 63.1503156,72.4403862 L63.1503156,72.4379235"
          id="Fill-2172"
          fill="#51A146"
        />
        <path
          d="M31.4932027,74.3014104 C31.4932027,73.3926527 32.2265573,72.6595717 33.1350414,72.6595717 C33.1350414,73.5650457 32.3989504,74.3014104 31.4932027,74.3014104"
          id="Fill-2173"
          fill="#9ECB94"
        />
        <path
          d="M31.4932027,74.3014104 C31.4932027,73.3926527 30.7571117,72.6595717 29.851364,72.6595717 C29.851364,73.5650457 30.5847186,74.3014104 31.4932027,74.3014104"
          id="Fill-2174"
          fill="#9ECB94"
        />
        <path
          d="M79.8423424,64.4503782 C79.8423424,63.5416205 80.5814434,62.8085395 81.4841811,62.8085395 C81.4841811,63.7140135 80.7456273,64.4503782 79.8423424,64.4503782"
          id="Fill-2175"
          fill="#9ECB94"
        />
        <path
          d="M79.8423424,64.4503782 C79.8423424,63.5416205 79.1037886,62.8085395 78.2005037,62.8085395 C78.2005037,63.7140135 78.9396047,64.4503782 79.8423424,64.4503782"
          id="Fill-2176"
          fill="#9ECB94"
        />
        <path
          d="M47.6078495,65.0931581 C47.6078495,64.184674 48.319313,63.4513194 49.2496882,63.4513194 C49.2496882,64.3573407 48.5108608,65.0931581 47.6078495,65.0931581 L47.6078495,65.0904217 L47.6078495,65.0931581"
          id="Fill-2177"
          fill="#9ECB94"
        />
        <path
          d="M47.6078495,65.0931581 C47.6078495,64.184674 46.8690221,63.4513194 45.9660108,63.4513194 C45.9660108,64.3573407 46.6774743,65.0931581 47.6078495,65.0931581 L47.6078495,65.0904217 L47.6078495,65.0931581"
          id="Fill-2178"
          fill="#9ECB94"
        />
        <path
          d="M49.7696038,75.9432491 C49.7696038,75.0344914 50.5084312,74.3014104 51.4114425,74.3014104 C51.4114425,75.2068844 50.6726151,75.9432491 49.7696038,75.9432491"
          id="Fill-2179"
          fill="#51A146"
        />
        <path
          d="M49.7696038,75.9432491 C49.7696038,75.0344914 49.0307764,74.3014104 48.1277651,74.3014104 C48.1277651,75.2068844 48.8665925,75.9432491 49.7696038,75.9432491"
          id="Fill-2180"
          fill="#51A146"
        />
        <path
          d="M61.0709269,62.0283925 C61.0709269,61.1199084 61.8094806,60.3865538 62.7127656,60.3865538 C62.7127656,61.2925751 61.9739382,62.0283925 61.0709269,62.0283925"
          id="Fill-2181"
          fill="#51A146"
        />
        <path
          d="M61.0709269,62.0283925 C61.0709269,61.1199084 60.3320995,60.3865538 59.4290882,60.3865538 C59.4290882,61.2925751 60.1676419,62.0283925 61.0709269,62.0283925"
          id="Fill-2182"
          fill="#51A146"
        />
        <path
          d="M68.7054768,53.6470795 C68.7054768,52.7410582 69.4443042,52.0052408 70.3473155,52.0052408 L70.3473155,52.0077036 C70.3473155,52.9134513 69.6082145,53.6470795 68.7054768,53.6470795"
          id="Fill-2183"
          fill="#51A146"
        />
        <path
          d="M68.7054768,53.6470795 C68.7054768,52.7410582 67.9663758,52.0052408 67.0636381,52.0052408 L67.0636381,52.0077036 C67.0636381,52.9134513 67.8024655,53.6470795 68.7054768,53.6470795"
          id="Fill-2184"
          fill="#51A146"
        />
        <path
          d="M73.8499048,59.4643877 C73.8499048,58.55864 74.5887322,57.822549 75.4917435,57.822549 C75.4917435,58.7282967 74.752916,59.4643877 73.8499048,59.4643877"
          id="Fill-2185"
          fill="#51A146"
        />
        <path
          d="M73.8499048,59.4643877 C73.8499048,58.55864 73.1110773,57.822549 72.2080661,57.822549 C72.2080661,58.7282967 72.9468935,59.4643877 73.8499048,59.4643877"
          id="Fill-2186"
          fill="#51A146"
        />
        <path
          d="M41.6288203,53.7401171 C41.8887781,53.5896152 42.3101833,53.5896152 42.5701411,53.7401171 C42.8273625,53.8878826 42.8273625,54.131422 42.5701411,54.2816502 C42.3101833,54.4324257 41.8887781,54.4324257 41.6288203,54.2816502 C41.3688625,54.131422 41.3688625,53.8878826 41.6288203,53.7401171 Z M25.8534867,55.4801925 C26.1107081,55.3299642 26.5321134,55.3299642 26.7920712,55.4801925 C27.052029,55.6306943 27.052029,55.8745074 26.7920712,56.0247356 C26.5321134,56.1725011 26.1107081,56.1725011 25.8534867,56.0247356 C25.5932553,55.8745074 25.5932553,55.6306943 25.8534867,55.4801925 Z M48.291949,46.0259379 C48.5382248,45.8781725 48.9760484,45.8781725 49.2223242,46.0259379 C49.4956904,46.1767135 49.4956904,46.4199792 49.2223242,46.5707547 C48.9760484,46.7185202 48.5382248,46.7185202 48.291949,46.5707547 C48.0183092,46.4199792 48.0183092,46.1767135 48.291949,46.0259379 Z M68.8696607,44.8109773 C69.1433005,44.6632118 69.5537602,44.6632118 69.800036,44.8109773 C70.0736758,44.9614792 70.0736758,45.2050186 69.800036,45.3557941 C69.5537602,45.5060224 69.1433005,45.5060224 68.8696607,45.3557941 C68.6233849,45.2050186 68.6233849,44.9614792 68.8696607,44.8109773 Z M65.1755236,39.9155616 C65.4217994,39.7653333 65.8596231,39.7653333 66.1058989,39.9155616 C66.3795387,40.0636007 66.3795387,40.3071401 66.1058989,40.4573683 C65.8596231,40.6081439 65.4217994,40.6081439 65.1755236,40.4573683 C64.9018838,40.3071401 64.9018838,40.0636007 65.1755236,39.9155616 Z M57.9240694,33.4387815 C58.1977091,33.2882797 58.6081688,33.2882797 58.8818086,33.4387815 C59.1280844,33.5892834 59.1280844,33.8328228 58.8818086,33.9833247 C58.6081688,34.1310902 58.1977091,34.1310902 57.9240694,33.9833247 C57.6775199,33.8328228 57.6775199,33.5892834 57.9240694,33.4387815 Z M37.8060725,44.4637284 C38.0657566,44.3132265 38.4874355,44.3132265 38.7446569,44.4637284 C39.0046147,44.6139567 39.0046147,44.8577697 38.7446569,45.0055352 C38.4874355,45.1557634 38.0657566,45.1557634 37.8060725,45.0055352 C37.545841,44.8577697 37.545841,44.6139567 37.8060725,44.4637284 Z M44.6005483,39.9155616 C44.8605061,39.7653333 45.2819114,39.7653333 45.5281872,39.9155616 C45.8015533,40.0636007 45.8015533,40.3071401 45.5281872,40.4573683 C45.2819114,40.6081439 44.8605061,40.6081439 44.6005483,40.4573683 C44.3405905,40.3071401 44.3405905,40.0636007 44.6005483,39.9155616 Z M57.2670602,41.7462117 C57.5136097,41.5959835 57.9514333,41.5959835 58.1977091,41.7462117 C58.4713489,41.8939772 58.4713489,42.1377903 58.1977091,42.2880185 C57.9514333,42.4385204 57.5136097,42.4385204 57.2670602,42.2880185 C56.9934205,42.1377903 56.9934205,41.8939772 57.2670602,41.7462117 Z M30.1715225,58.3123642 C30.4314803,58.1645987 30.8528856,58.1645987 31.1128434,58.3123642 C31.3728012,58.4631397 31.3728012,58.7064055 31.1128434,58.8569074 C30.8528856,59.0049465 30.4314803,59.0049465 30.1715225,58.8569074 C29.9115647,58.7064055 29.9115647,58.4631397 30.1715225,58.3123642 Z M67.0910021,48.1110731 C67.3372779,47.9633076 67.7751016,47.9633076 68.0213774,48.1110731 C68.2950172,48.261575 68.2950172,48.5051144 68.0213774,48.6556163 C67.7751016,48.8033817 67.3372779,48.8033817 67.0910021,48.6556163 C66.8173623,48.5051144 66.8173623,48.261575 67.0910021,48.1110731 Z M30.9924419,49.3561341 C31.2523997,49.2083686 31.6738049,49.2083686 31.9337627,49.3561341 C32.1937205,49.5069096 32.1937205,49.7501754 31.9337627,49.9009509 C31.6738049,50.0511792 31.2523997,50.0511792 30.9924419,49.9009509 C30.7324841,49.7501754 30.7324841,49.5069096 30.9924419,49.3561341 Z M15.8571518,58.6981963 C16.1173832,58.5479681 16.5387885,58.5479681 16.7960099,58.6981963 C17.0559677,58.8459618 17.0559677,59.0897748 16.7960099,59.2402767 C16.5387885,59.390505 16.1173832,59.390505 15.8571518,59.2402767 C15.5974677,59.0897748 15.5974677,58.8459618 15.8571518,58.6981963 Z M52.1776339,53.7373807 C52.4512737,53.5896152 52.8617334,53.5896152 53.1080092,53.7373807 C53.381649,53.8878826 53.381649,54.131422 53.1080092,54.2816502 C52.8617334,54.4324257 52.4512737,54.4324257 52.1776339,54.2816502 C51.9310845,54.131422 51.9310845,53.8878826 52.1776339,53.7373807 Z M54.4212065,54.7142747 C54.6677559,54.5637728 55.0782156,54.5637728 55.3515818,54.7142747 C55.5981312,54.8645029 55.5981312,55.1055796 55.3515818,55.2558078 C55.0782156,55.4063097 54.6677559,55.4063097 54.4212065,55.2558078 C54.1478404,55.1055796 54.1478404,54.8645029 54.4212065,54.7142747 Z M38.7939121,61.1831192 C39.0535963,61.0323437 39.4752752,61.0323437 39.7349593,61.1831192 C39.9951908,61.3336211 39.9951908,61.5771605 39.7349593,61.724926 C39.4752752,61.8751542 39.0535963,61.8751542 38.7939121,61.724926 C38.5366907,61.5771605 38.5366907,61.3336211 38.7939121,61.1831192 Z M18.9030362,61.7030348 C19.162994,61.5525329 19.5843993,61.5525329 19.8443571,61.7030348 C20.1043149,61.853263 20.1043149,62.0970761 19.8443571,62.2448415 C19.5843993,62.3950698 19.162994,62.3950698 18.9030362,62.2448415 C18.6455412,62.0970761 18.6455412,61.853263 18.9030362,61.7030348 Z M20.785678,65.0055933 C21.0428993,64.8550914 21.4643046,64.8550914 21.7239888,65.0055933 C21.9842202,65.1533588 21.9842202,65.3971719 21.7239888,65.5474001 C21.4643046,65.6981756 21.0428993,65.6981756 20.785678,65.5474001 C20.5257202,65.3971719 20.5257202,65.1533588 20.785678,65.0055933 Z M38.7939121,65.5528729 C39.0535963,65.4026446 39.4752752,65.4026446 39.7349593,65.5528729 C39.9951908,65.7006384 39.9951908,65.9444514 39.7349593,66.0946797 C39.4752752,66.2451815 39.0535963,66.2451815 38.7939121,66.0946797 C38.5366907,65.9444514 38.5366907,65.7006384 38.7939121,65.5528729 L38.7939121,65.5528729 Z"
          id="Fill-2187"
          fill="#9ECB94"
        />
        <path
          d="M19.5679809,52.8070054 C19.8276651,52.6565035 20.249344,52.6565035 20.5093018,52.8070054 C20.7692596,52.9544973 20.7692596,53.1983103 20.5093018,53.3488122 C20.249344,53.4993141 19.8276651,53.4993141 19.5679809,53.3488122 C19.3107595,53.1983103 19.3107595,52.9544973 19.5679809,52.8070054 Z M31.8133612,46.7948657 C32.073319,46.6446375 32.4947243,46.6446375 32.7546821,46.7948657 C33.0146399,46.9453676 33.0146399,47.1864443 32.7546821,47.3369461 C32.4947243,47.4871744 32.073319,47.4871744 31.8133612,47.3369461 C31.5534034,47.1864443 31.5534034,46.9453676 31.8133612,46.7948657 Z M39.4585831,47.1779614 C39.7188146,47.0277332 40.1402198,47.0277332 40.399904,47.1779614 C40.6601354,47.3284633 40.6601354,47.5720027 40.399904,47.7197682 C40.1402198,47.8705437 39.7188146,47.8705437 39.4585831,47.7197682 C39.2016354,47.5720027 39.2016354,47.3284633 39.4585831,47.1779614 Z M42.7397978,43.0900567 C42.9994819,42.9395548 43.4211608,42.9395548 43.6811186,43.0900567 C43.93834,43.2402849 43.93834,43.4813616 43.6811186,43.6318635 C43.4211608,43.7820917 42.9994819,43.7820917 42.7397978,43.6318635 C42.47984,43.4813616 42.47984,43.2402849 42.7397978,43.0900567 Z M56.3095946,38.717293 C56.5558704,38.5695275 56.9934205,38.5695275 57.2399699,38.717293 C57.5136097,38.8675212 57.5136097,39.1113343 57.2399699,39.2618361 C56.9934205,39.409328 56.5558704,39.409328 56.3095946,39.2618361 C56.0356812,39.1113343 56.0356812,38.8675212 56.3095946,38.717293 Z M23.3305279,53.7401171 C23.5902121,53.5896152 24.0091546,53.5896152 24.2691124,53.7401171 C24.5287966,53.8878826 24.5287966,54.131422 24.2691124,54.2816502 C24.0091546,54.4324257 23.5902121,54.4324257 23.3305279,54.2816502 C23.0705701,54.131422 23.0705701,53.8878826 23.3305279,53.7401171 Z M71.4966026,43.3935232 C71.7699688,43.2430213 72.1804284,43.2430213 72.4540682,43.3935232 C72.7006177,43.5440251 72.7006177,43.7875645 72.4540682,43.93533 C72.1804284,44.0858319 71.7699688,44.0858319 71.4966026,43.93533 C71.2500532,43.7875645 71.2500532,43.5440251 71.4966026,43.3935232 Z M73.3023516,44.4637284 C73.548901,44.3132265 73.9593607,44.3132265 74.2327268,44.4637284 C74.4792763,44.6139567 74.4792763,44.8577697 74.2327268,45.0055352 C73.9593607,45.1557634 73.548901,45.1557634 73.3023516,45.0055352 C73.0289854,44.8577697 73.0289854,44.6139567 73.3023516,44.4637284 Z M27.1806397,48.5902164 C27.4403238,48.4394408 27.8620028,48.4394408 28.1219605,48.5902164 C28.3816447,48.7404446 28.3816447,48.9842576 28.1219605,49.1320231 C27.8620028,49.2822514 27.4403238,49.2822514 27.1806397,49.1320231 C26.9234183,48.9842576 26.9234183,48.7404446 27.1806397,48.5902164 Z M52.1776339,34.2077093 C52.4512737,34.0572075 52.8617334,34.0572075 53.1080092,34.2077093 C53.381649,34.3554748 53.381649,34.5990142 53.1080092,34.7495161 C52.8617334,34.8997443 52.4512737,34.8997443 52.1776339,34.7495161 C51.9310845,34.5990142 51.9310845,34.3554748 52.1776339,34.2077093 Z M46.0207388,49.3561341 C46.2943786,49.2083686 46.7048382,49.2083686 46.951114,49.3561341 C47.2247538,49.5069096 47.2247538,49.7501754 46.951114,49.9009509 C46.7048382,50.0511792 46.2943786,50.0511792 46.0207388,49.9009509 C45.7741893,49.7501754 45.7741893,49.5069096 46.0207388,49.3561341 Z M34.2843285,54.7142747 C34.5442863,54.5637728 34.9656915,54.5637728 35.2229129,54.7142747 C35.4828707,54.8620402 35.4828707,55.1055796 35.2229129,55.2558078 C34.9656915,55.4063097 34.5442863,55.4063097 34.2843285,55.2558078 C34.0243707,55.1055796 34.0243707,54.8620402 34.2843285,54.7142747 Z M45.6102791,56.621544 C45.8839189,56.4735049 46.2943786,56.4735049 46.5406544,56.621544 C46.8142942,56.7717722 46.8142942,57.0153116 46.5406544,57.1658135 C46.2943786,57.316589 45.8839189,57.316589 45.6102791,57.1658135 C45.3637297,57.0153116 45.3637297,56.7717722 45.6102791,56.621544 Z M51.9860861,58.0961888 C52.2323619,57.9456869 52.6701855,57.9456869 52.9164613,58.0961888 C53.1898275,58.2466907 53.1898275,58.4874937 52.9164613,58.6379956 C52.6701855,58.7884974 52.2323619,58.7884974 51.9860861,58.6379956 C51.7398103,58.4874937 51.7398103,58.2466907 51.9860861,58.0961888 Z M9.5992836,58.3123642 C9.85896776,58.1645987 10.2806467,58.1645987 10.5403308,58.3123642 C10.7975522,58.4631397 10.7975522,58.7064055 10.5403308,58.8569074 C10.2806467,59.0049465 9.85896776,59.0049465 9.5992836,58.8569074 C9.33932581,58.7064055 9.33932581,58.4631397 9.5992836,58.3123642 Z M7.31439141,59.2919946 C7.57434921,59.1442292 7.99575447,59.1442292 8.25571227,59.2919946 C8.51266002,59.4427702 8.51266002,59.6860359 8.25571227,59.8368115 C7.99575447,59.9845769 7.57434921,59.9845769 7.31439141,59.8368115 C7.05443362,59.6860359 7.05443362,59.4427702 7.31439141,59.2919946 Z M24.8355467,60.7751223 C25.0955045,60.624894 25.5169098,60.624894 25.7741312,60.7751223 C26.0338154,60.9258978 26.0338154,61.1691636 25.7741312,61.3196654 C25.5169098,61.4677046 25.0955045,61.4677046 24.8355467,61.3196654 C24.575589,61.1691636 24.575589,60.9258978 24.8355467,60.7751223 Z M26.515695,68.5905481 C26.7756528,68.4400462 27.1967844,68.4400462 27.4570159,68.5905481 C27.7169737,68.7383136 27.7169737,68.981853 27.4570159,69.1323549 C27.1967844,69.2828568 26.7756528,69.2828568 26.515695,69.1323549 C26.2582,68.981853 26.2582,68.7383136 26.515695,68.5905481 Z M22.6655833,69.3838299 C22.9252674,69.233328 23.3469463,69.233328 23.6041677,69.3838299 C23.8641255,69.5315953 23.8641255,69.7751347 23.6041677,69.9256366 C23.3469463,70.0761385 22.9252674,70.0761385 22.6655833,69.9256366 C22.4053518,69.7751347 22.4053518,69.5315953 22.6655833,69.3838299 Z M33.2168597,69.3977855 C33.4743547,69.2497464 33.89576,69.2497464 34.1557178,69.3977855 C34.4156756,69.5480137 34.4156756,69.7915531 34.1557178,69.942055 C33.89576,70.0898205 33.4743547,70.0898205 33.2168597,69.942055 C32.9571755,69.7915531 32.9571755,69.5480137 33.2168597,69.3977855 L33.2168597,69.3977855 Z"
          id="Fill-2188"
          fill="#51A146"
        />
        <path
          d="M44.8522969,61.2457827 C44.8522969,60.3375723 45.5829151,59.603944 46.4859264,59.603944 C46.4859264,60.5099653 45.747099,61.2457827 44.8522969,61.2457827"
          id="Fill-2189"
          fill="#51A146"
        />
        <path
          d="M44.8522969,61.2457827 C44.8522969,60.3375723 44.1162059,59.603944 43.2104582,59.603944 C43.2104582,60.5099653 43.9438128,61.2457827 44.8522969,61.2457827"
          id="Fill-2190"
          fill="#51A146"
        />
        <path
          d="M13.1891639,63.1065332 C13.1891639,62.1980491 13.9252549,61.4646945 14.8310026,61.4646945 C14.8310026,62.3704422 14.0951852,63.1065332 13.1891639,63.1065332"
          id="Fill-2191"
          fill="#9ECB94"
        />
        <path
          d="M13.1891639,63.1065332 C13.1891639,62.1980491 12.4533465,61.4646945 11.5473252,61.4646945 C11.5473252,62.3704422 12.2834162,63.1065332 13.1891639,63.1065332"
          id="Fill-2192"
          fill="#9ECB94"
        />
        <path
          d="M61.5361145,53.255501 C61.5361145,52.3470169 62.2749419,51.6136623 63.1779532,51.6136623 C63.1779532,52.51941 62.4391258,53.255501 61.5361145,53.255501"
          id="Fill-2193"
          fill="#9ECB94"
        />
        <path
          d="M61.5361145,53.255501 C61.5361145,52.3470169 60.7972871,51.6136623 59.8942758,51.6136623 C59.8942758,52.51941 60.6331032,53.255501 61.5361145,53.255501"
          id="Fill-2194"
          fill="#9ECB94"
        />
        <path
          d="M29.2928652,53.8985545 C29.2928652,52.9903441 30.0292298,52.2567158 30.9347039,52.2567158 C30.9347039,53.1627371 30.2016229,53.8985545 29.2928652,53.8985545"
          id="Fill-2195"
          fill="#9ECB94"
        />
        <path
          d="M29.2928652,53.8985545 C29.2928652,52.9903441 28.5597842,52.2567158 27.6510265,52.2567158 C27.6510265,53.1627371 28.3873911,53.8985545 29.2928652,53.8985545"
          id="Fill-2196"
          fill="#9ECB94"
        />
        <path
          d="M31.4631023,64.7483719 C31.4631023,63.8398878 32.1991933,63.1065332 33.104941,63.1065332 C33.104941,64.0122809 32.36885,64.7483719 31.4631023,64.7483719"
          id="Fill-2197"
          fill="#51A146"
        />
        <path
          d="M31.4631023,64.7483719 C31.4631023,63.8398878 30.7270113,63.1065332 29.8212636,63.1065332 C29.8212636,64.0122809 30.5573546,64.7483719 31.4631023,64.7483719"
          id="Fill-2198"
          fill="#51A146"
        />
        <path
          d="M42.7644254,50.8337889 C42.7644254,49.9253049 43.4975063,49.1919502 44.4062641,49.1919502 C44.4062641,50.0976979 43.670173,50.8337889 42.7644254,50.8337889"
          id="Fill-2199"
          fill="#51A146"
        />
        <path
          d="M42.7644254,50.8337889 C42.7644254,49.9253049 42.0283343,49.1919502 41.1225867,49.1919502 C41.1225867,50.0976979 41.8556676,50.8337889 42.7644254,50.8337889"
          id="Fill-2200"
          fill="#51A146"
        />
        <path
          d="M50.3989753,42.4552124 C50.3989753,41.5464547 51.1375291,40.8133737 52.040814,40.8133737 C52.040814,41.7191214 51.3019866,42.4552124 50.3989753,42.4552124"
          id="Fill-2201"
          fill="#51A146"
        />
        <path
          d="M50.3989753,42.4552124 C50.3989753,41.5464547 49.6601479,40.8133737 48.7571366,40.8133737 C48.7571366,41.7191214 49.4956904,42.4552124 50.3989753,42.4552124"
          id="Fill-2202"
          fill="#51A146"
        />
        <path
          d="M55.5434032,48.2700578 C55.5434032,47.3640365 56.2822307,46.6282191 57.1852419,46.6282191 C57.1852419,47.5364295 56.4461409,48.2700578 55.5434032,48.2700578"
          id="Fill-2203"
          fill="#51A146"
        />
        <path
          d="M55.5434032,48.2700578 C55.5434032,47.3640365 54.8043022,46.6282191 53.9015645,46.6282191 C53.9015645,47.5364295 54.640392,48.2700578 55.5434032,48.2700578"
          id="Fill-2204"
          fill="#51A146"
        />
        <polyline
          id="Fill-2205"
          fill="#E4E4E3"
          points="66.8173623 80.4583055 38.1098126 64.4202778 38.1098126 21.1687736 67.0910021 38.7966485 66.8173623 80.4583055"
        />
        <polyline
          id="Fill-2206"
          fill="#B4B5B4"
          points="52.6975495 8.48861722e-13 38.1070762 21.2590748 67.0910021 38.8894124 81.156087 16.6917532 52.6975495 8.48861722e-13"
        />
        <polyline
          id="Fill-2207"
          fill="#9E9F9E"
          points="52.6975495 -4.85063841e-13 67.0910021 4.79936816 95.4948116 21.1687736 81.156087 16.6917532 52.6975495 -4.85063841e-13"
        />
        <polyline
          id="Fill-2208"
          fill="#F8F7F6"
          points="66.7899983 80.4583055 95.4948116 64.4202778 95.4948116 21.1687736 81.156087 16.6917532 67.0910021 38.7966485 66.7899983 80.4583055"
        />
        <polyline
          id="Fill-2209"
          fill="#E4E4E3"
          points="70.7577752 52.9219341 78.0639574 48.7051451 78.0639574 74.1700633 70.7577752 78.2363505 70.7577752 52.9219341"
        />
        <polyline
          id="Fill-2210"
          fill="#E4E4E3"
          points="82.9621096 46.496872 89.6115563 42.6519594 89.6115563 56.6240068 82.9621096 60.7261407 82.9621096 46.496872"
        />
        <polyline
          id="Fill-2211"
          fill="#FFFFFE"
          points="61.8371183 52.6783947 55.1876715 48.8364922 55.1876715 62.8055295 61.8371183 66.9101262 61.8371183 52.6783947"
        />
        <polyline
          id="Fill-2212"
          fill="#FFFFFE"
          points="49.0307764 46.496872 42.3755832 42.6519594 42.3755832 56.6240068 49.0307764 60.7261407 49.0307764 46.496872"
        />
        <path
          d="M77.5377696,87.6390446 C75.8376438,87.6390446 74.4117318,88.7861773 73.8358828,90.4045955 C73.7536186,90.3993924 73.6713545,90.3911771 73.5616689,90.3911771 C72.711606,90.3911771 71.9438073,90.6839164 71.2856941,91.1798479 C70.6550023,90.6839164 69.8597821,90.3911771 69.0097193,90.3911771 C68.5161343,90.3911771 68.0499708,90.4977024 67.6112287,90.6839164 C67.2273293,90.333396 66.7885872,90.0625643 66.2950023,89.8870303 C65.6640362,88.4329185 64.2932413,87.4281847 62.7302224,87.4281847 C60.5365117,87.4281847 58.7815432,89.369465 58.7815432,91.7683387 C58.7815432,93.6907238 59.9055457,95.3203697 61.4962601,95.8896914 C62.126952,97.3440771 63.4980211,98.3518231 65.06104,98.3518231 C65.5546249,98.3518231 66.0482098,98.2447501 66.4866777,98.0585361 C67.1724865,98.6911158 68.0499708,99.071759 69.0097193,99.071759 C69.8597821,99.071759 70.6550023,98.7790198 71.2856941,98.2830882 C71.9438073,98.7790198 72.711606,99.071759 73.5616689,99.071759 C75.2343733,99.071759 76.6877067,97.921888 77.2635557,96.3031959 C77.3458199,96.3114112 77.428084,96.3199004 77.5377696,96.3199004 C79.7040589,96.3199004 81.4864488,94.3756078 81.4864488,91.9791987 C81.4864488,89.5803249 79.7040589,87.6390446 77.5377696,87.6390446"
          id="Fill-3455"
          fill="#428849"
        />
        <path
          d="M77.0990274,82.759144 C75.4811658,82.950561 74.2472035,84.3337472 73.8904513,86.1134595 C73.8084614,86.116198 73.7261972,86.1192102 73.6162375,86.1298902 C72.8212916,86.2257356 72.0809142,86.6258217 71.5324865,87.2255401 C70.846952,86.7734236 70.0517318,86.5518838 69.2290903,86.6501938 C68.7629268,86.7077011 68.2967633,86.8747459 67.9128639,87.1212056 C67.5015432,86.7928666 67.0351054,86.5570869 66.5417947,86.4283802 C65.7465746,84.96085 64.2932413,84.051414 62.7847909,84.2296864 C60.6736186,84.4816229 59.1928639,86.7433008 59.4942249,89.2821088 C59.7412916,91.3192345 61.057518,92.9160191 62.6479582,93.3347266 C63.4431784,94.8028045 64.8965117,95.7147051 66.4046878,95.533968 C66.8979985,95.4764608 67.3367406,95.3094159 67.7480614,95.0626824 C68.488713,95.6514471 69.3933444,95.955414 70.3256715,95.8431379 C71.148313,95.7472925 71.8612689,95.3474802 72.4373922,94.7480356 C73.0952312,95.1996045 73.8904513,95.4214181 74.7130928,95.3231081 C76.3312287,95.1311434 77.5923381,93.7509695 77.9490903,91.9685187 C78.0310803,91.9657803 78.1136186,91.9657803 78.1958828,91.9545527 C80.3073293,91.7026162 81.788084,89.4409383 81.4864488,86.9024042 C81.1848136,84.36387 79.210474,82.5096721 77.0990274,82.759144"
          id="Fill-3456"
          fill="#4E9C52"
        />
        <path
          d="M76.6602853,83.684463 C75.1795306,83.684463 73.9178727,84.5032566 73.3971406,85.6564138 C73.3148765,85.650937 73.2600337,85.6451862 73.1777696,85.6451862 C72.4099708,85.6451862 71.7244362,85.8533077 71.148313,86.2065665 C70.5998853,85.8533077 69.8872035,85.6451862 69.1468262,85.6451862 C68.708084,85.6451862 68.2967633,85.7218626 67.8854425,85.8533077 C67.5563859,85.6041096 67.1724865,85.4096804 66.7337444,85.2867244 C66.1853167,84.2513201 64.9785016,83.5338488 63.6074325,83.5338488 C61.6607884,83.5338488 60.0977696,84.9194996 60.0977696,86.6258217 C60.0977696,87.994768 61.1123608,89.1558667 62.5105771,89.5614297 C63.059279,90.5965601 64.2658199,91.3112931 65.6640362,91.3112931 C66.1027784,91.3112931 66.5140991,91.2373552 66.8979985,91.1028978 C67.5015432,91.5550143 68.2967633,91.825846 69.1468262,91.825846 C69.8872035,91.825846 70.5998853,91.6177245 71.148313,91.2644657 C71.7244362,91.6177245 72.4099708,91.825846 73.1777696,91.825846 C74.6585243,91.825846 75.9199079,91.0073262 76.4134928,89.854169 C76.4954828,89.8596459 76.5780211,89.8651227 76.6602853,89.8651227 C78.6072035,89.8651227 80.1702224,88.4822104 80.1702224,86.7764359 C80.1702224,85.0673753 78.6072035,83.684463 76.6602853,83.684463"
          id="Fill-3457"
          fill="#70BA64"
        />
        <path
          d="M64.6222979,85.6287556 C65.8836815,85.6287556 66.9531155,84.9414071 67.3644362,83.9719992 C67.4464262,83.9750115 67.5015432,83.9802145 67.5838073,83.9802145 C68.2144991,83.9802145 68.7903482,83.8052282 69.2565117,83.5067382 C69.7500966,83.8052282 70.3256715,83.9802145 70.9566375,83.9802145 C71.3131155,83.9802145 71.6695935,83.9175042 71.9986501,83.8052282 C72.3002853,84.0160881 72.6293419,84.1773822 72.9858199,84.281443 C73.4519834,85.152267 74.4665746,85.7547238 75.6182727,85.7547238 C77.2361343,85.7547238 78.5520865,84.5911606 78.5520865,83.155944 C78.5520865,82.0030606 77.7022979,81.0281759 76.5505998,80.6888831 C76.0570148,79.8177853 75.069845,79.2156022 73.8904513,79.2156022 C73.506552,79.2156022 73.1777696,79.2783125 72.848713,79.3905886 C72.3277067,79.0129577 71.6695935,78.7829287 70.9566375,78.7829287 C70.3256715,78.7829287 69.7500966,78.957915 69.2565117,79.256405 C68.7903482,78.957915 68.2144991,78.7829287 67.5838073,78.7829287 C66.3224237,78.7829287 65.2527155,79.4700033 64.8413947,80.4394112 C64.7594048,80.4369466 64.704562,80.4314697 64.6222979,80.4314697 C63.0044362,80.4314697 61.6879356,81.595033 61.6879356,83.0299757 C61.6879356,84.4651923 63.0044362,85.6287556 64.6222979,85.6287556"
          id="Fill-3458"
          fill="#88C37D"
        />
        <path
          d="M64.0738702,81.4553726 C65.3078325,81.4553726 66.3772664,82.1457334 66.7885872,83.1124028 C66.8708513,83.1093905 66.9254199,83.1039136 67.0079582,83.1039136 C67.6386501,83.1039136 68.2144991,83.2794477 68.6803884,83.5776638 C69.1742476,83.2794477 69.7500966,83.1039136 70.3807884,83.1039136 C70.7369922,83.1039136 71.0937444,83.1668978 71.4225268,83.2794477 C71.7244362,83.0683139 72.0534928,82.9070198 72.4099708,82.8026852 C72.8761343,81.9318612 73.8904513,81.3294043 75.0424237,81.3294043 C76.6877067,81.3294043 78.0036589,82.4932414 78.0036589,83.928458 C78.0036589,85.0813414 77.1538702,86.0559523 75.9744765,86.3955189 C75.4811658,87.2663429 74.493996,87.8687998 73.3148765,87.8687998 C72.9583985,87.8687998 72.6019205,87.8058156 72.2725897,87.6938134 C71.7518576,88.0714443 71.0937444,88.3014733 70.3807884,88.3014733 C69.7500966,88.3014733 69.1742476,88.1262131 68.6803884,87.8277232 C68.2144991,88.1262131 67.6386501,88.3014733 67.0079582,88.3014733 C65.7465746,88.3014733 64.704562,87.6143987 64.2658199,86.6449908 C64.2109771,86.6474554 64.128713,86.6529323 64.0738702,86.6529323 C62.4285872,86.6529323 61.1123608,85.4890951 61.1123608,84.0544263 C61.1123608,82.6192097 62.4285872,81.4553726 64.0738702,81.4553726"
          id="Fill-3459"
          fill="#88C37D"
        />
        <path
          d="M117.57299,64.6742104 C115.900285,64.6742104 114.474373,65.8243553 113.898524,67.4427735 C113.788565,67.4348321 113.706575,67.4263429 113.62431,67.4263429 C112.774248,67.4263429 111.979027,67.7220944 111.348061,68.218026 C110.690222,67.7220944 109.922424,67.4263429 109.072361,67.4263429 C108.578502,67.4263429 108.085191,67.5331421 107.646175,67.719356 C107.262549,67.3688356 106.823533,67.0980039 106.357644,66.9252083 C105.699256,65.4686319 104.355609,64.4636243 102.792864,64.4636243 C100.599153,64.4636243 98.8167633,66.4079169 98.8167633,68.8040522 C98.8167633,70.7289019 99.9684614,72.3585477 101.558902,72.9278695 C102.189593,74.3819813 103.532967,75.3872627 105.123682,75.3872627 C105.617266,75.3872627 106.08343,75.2801897 106.521898,75.096988 C107.207432,75.7268293 108.112612,76.1099371 109.072361,76.1099371 C109.922424,76.1099371 110.690222,75.8141855 111.348061,75.3185278 C111.979027,75.8141855 112.774248,76.1099371 113.62431,76.1099371 C115.297015,76.1099371 116.722927,74.960066 117.298776,73.3413739 C117.408461,73.3471247 117.490451,73.3550661 117.57299,73.3550661 C119.7667,73.3550661 121.54909,71.4137858 121.54909,69.0149121 C121.54909,66.6187768 119.7667,64.6742104 117.57299,64.6742104"
          id="Fill-3460"
          fill="#428849"
        />
        <path
          d="M117.161669,59.797322 C115.543807,59.988739 114.282424,61.3689129 113.953367,63.1488991 C113.843682,63.154376 113.761417,63.154376 113.679153,63.1653298 C112.856512,63.2611752 112.143282,63.6639998 111.567707,64.2607059 C110.909319,63.8091371 110.114099,63.5900619 109.291458,63.6856334 C108.798147,63.7434145 108.359405,63.9101855 107.948084,64.1566452 C107.536763,63.8310446 107.0706,63.5925265 106.577015,63.4640936 C105.781795,61.9990281 104.355609,61.0871274 102.820011,61.2678645 C100.708839,61.5167887 99.2555054,63.7787404 99.5571406,66.3172746 C99.8036589,68.3574126 101.092738,69.9514587 102.710326,70.3731785 C103.505546,71.8409825 104.931732,72.7498708 106.467329,72.5694076 C106.933219,72.5119004 107.399656,72.347594 107.783556,72.0983959 C108.551354,72.6896252 109.45626,72.9911274 110.388587,72.881316 C111.183807,72.7827321 111.924185,72.3831937 112.472612,71.7859399 C113.158147,72.2353179 113.953367,72.4571316 114.776009,72.3612862 C116.393596,72.1665831 117.627558,70.7864091 117.98431,69.0064229 C118.066575,69.0039583 118.148839,69.0012199 118.258524,68.9899923 C120.369697,68.7410681 121.823304,66.4791164 121.521669,63.9405822 C121.21976,61.4020481 119.272841,59.5451117 117.161669,59.797322"
          id="Fill-3461"
          fill="#4E9C52"
        />
        <path
          d="M116.722927,60.722641 C115.242172,60.722641 113.953367,61.5386962 113.459782,62.6915796 C113.377244,62.689115 113.295254,62.6806258 113.21299,62.6806258 C112.472612,62.6806258 111.787078,62.8914857 111.211229,63.2420061 C110.635105,62.8914857 109.949845,62.6806258 109.209468,62.6806258 C108.770726,62.6806258 108.331983,62.7573022 107.948084,62.8887473 C107.618753,62.6395492 107.207432,62.4481323 106.796112,62.3246286 C106.220537,61.2870336 105.041417,60.5720268 103.642653,60.5720268 C101.72343,60.5720268 100.160411,61.9549392 100.160411,63.6612613 C100.160411,65.0332199 101.147581,66.1913063 102.546071,66.5968693 C103.121646,67.6317259 104.328187,68.3494711 105.699256,68.3494711 C106.138273,68.3494711 106.577015,68.2727948 106.960914,68.1413497 C107.564185,68.5904539 108.359405,68.8612856 109.209468,68.8612856 C109.949845,68.8612856 110.635105,68.6531641 111.211229,68.2999053 C111.787078,68.6531641 112.472612,68.8612856 113.21299,68.8612856 C114.693744,68.8612856 115.955128,68.0455042 116.476134,66.8926209 C116.558398,66.8953593 116.640663,66.9035746 116.722927,66.9035746 C118.642424,66.9035746 120.205443,65.5179238 120.205443,63.8118755 C120.205443,62.1058272 118.642424,60.722641 116.722927,60.722641"
          id="Fill-3462"
          fill="#70BA64"
        />
        <path
          d="M104.684939,62.664469 C105.946323,62.664469 106.988336,61.9771205 107.427078,61.0077127 C107.481921,61.0131895 107.564185,61.0183926 107.618753,61.0183926 C108.249719,61.0183926 108.825568,60.8406678 109.319153,60.5449163 C109.785317,60.8406678 110.361166,61.0183926 110.991858,61.0183926 C111.375757,61.0183926 111.731961,60.9529439 112.061292,60.8431324 C112.335505,61.0515277 112.664562,61.2158341 113.02104,61.3168826 C113.514351,62.1879804 114.501795,62.7901635 115.680914,62.7901635 C117.298776,62.7901635 118.615002,61.6293386 118.615002,60.194122 C118.615002,59.0412387 117.764939,58.0663539 116.58582,57.7243227 C116.119656,56.8532249 115.105065,56.250768 113.953367,56.250768 C113.569468,56.250768 113.21299,56.3164906 112.883933,56.4260282 C112.390348,56.0481234 111.731961,55.8211067 110.991858,55.8211067 C110.361166,55.8211067 109.785317,55.9963669 109.319153,56.2918446 C108.825568,55.9963669 108.249719,55.8211067 107.618753,55.8211067 C106.384791,55.8211067 105.315631,56.5081814 104.876615,57.4775893 C104.822046,57.4721124 104.766929,57.4693739 104.684939,57.4693739 C103.067078,57.4693739 101.750851,58.6304726 101.750851,60.0654154 C101.750851,61.5003581 103.067078,62.664469 104.684939,62.664469"
          id="Fill-3463"
          fill="#88C37D"
        />
        <path
          d="M104.10909,58.4935506 C105.370474,58.4935506 106.412212,59.181173 106.851229,60.1505808 C106.906071,60.1448301 106.988336,60.1420917 107.043178,60.1420917 C107.67387,60.1420917 108.277141,60.3176257 108.743304,60.6131034 C109.209468,60.3176257 109.812464,60.1420917 110.416009,60.1420917 C110.799908,60.1420917 111.156386,60.2050758 111.485443,60.3148873 C111.759382,60.106492 112.088713,59.9451978 112.445191,59.8411371 C112.938776,58.9700392 113.925671,58.3675824 115.105065,58.3675824 C116.722927,58.3675824 118.038879,59.5314195 118.038879,60.9663622 C118.038879,62.1165071 117.18909,63.0941303 116.009971,63.4336969 C115.543807,64.3045209 114.529216,64.9072517 113.377244,64.9072517 C112.993344,64.9072517 112.637141,64.8415291 112.308084,64.7317176 C111.814499,65.1096224 111.156386,65.3369129 110.416009,65.3369129 C109.812464,65.3369129 109.209468,65.1616528 108.743304,64.8659012 C108.277141,65.1616528 107.67387,65.3369129 107.043178,65.3369129 C105.809216,65.3369129 104.739508,64.6498383 104.328187,63.6804304 C104.246197,63.6856334 104.191354,63.6913842 104.10909,63.6913842 C102.491229,63.6913842 101.174728,62.5272732 101.174728,61.0923305 C101.174728,59.6573877 102.491229,58.4935506 104.10909,58.4935506"
          id="Fill-3464"
          fill="#88C37D"
        />
      </g>
    </g>
  </svg>
)

export const step29Image1 = (
  <svg
    width="70px"
    height="70px"
    viewBox="0 0 128 128"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    aria-hidden="true"
  >
    <g
      id="5.climate/climate_3.2"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Group" transform="translate(1.600000, 3.200000)">
        <path
          d="M80.275457,115.098244 C80.275457,119.281096 71.5838499,122.672219 60.858402,122.672219 C50.1354044,122.672219 41.4437974,119.281096 41.4437974,115.098244 C41.4437974,110.915148 50.1354044,107.52623 60.858402,107.52623 C71.5838499,107.52623 80.275457,110.915148 80.275457,115.098244"
          id="Fill-2270"
          fill="#777776"
        />
        <path
          d="M80.275457,112.983295 C80.275457,117.166391 71.5838499,120.557515 60.858402,120.557515 C50.1354044,120.557515 41.4437974,117.166391 41.4437974,112.983295 C41.4437974,108.800689 50.1354044,105.40932 60.858402,105.40932 C71.5838499,105.40932 80.275457,108.800689 80.275457,112.983295"
          id="Fill-2271"
          fill="#E4E4E3"
        />
        <polygon
          id="Fill-2272"
          fill="#E4E4E3"
          points="41.4437974 112.983295 80.275457 112.983295 80.275457 41.0269825 41.4437974 41.0269825"
        />
        <path
          d="M80.275457,41.0269825 C80.275457,45.2100788 71.5838499,48.6012023 60.858402,48.6012023 C50.1354044,48.6012023 41.4437974,45.2100788 41.4437974,41.0269825 C41.4437974,36.8443764 50.1354044,33.4527628 60.858402,33.4527628 C71.5838499,33.4527628 80.275457,36.8443764 80.275457,41.0269825"
          id="Fill-2273"
          fill="#777776"
        />
        <path
          d="M80.275457,64.6981957 C80.275457,68.8808018 71.5838499,72.2724154 60.858402,72.2724154 C50.1354044,72.2724154 41.4437974,68.8808018 41.4437974,64.6981957 C41.4437974,60.5153445 50.1354044,57.1237309 60.858402,57.1237309 C71.5838499,57.1237309 80.275457,60.5153445 80.275457,64.6981957"
          id="Fill-2274"
          fill="#777776"
        />
        <polygon
          id="Fill-2275"
          fill="#777776"
          points="41.4437974 64.6981957 80.275457 64.6981957 80.275457 40.9733186 41.4437974 40.9733186"
        />
        <polyline
          id="Fill-2276"
          fill="#54A044"
          points="55.5116057 1.71994332 -9.83237515e-14 33.9526466 69.907769 74.3158129 126.46815 42.8353857 55.5116057 1.71994332"
        />
        <polyline
          id="Fill-2277"
          fill="#75B86A"
          points="55.5116057 3.93295006e-13 -9.83237515e-14 32.2324583 69.907769 72.598075 126.46815 41.1151973 55.5116057 3.93295006e-13"
        />
        <polyline
          id="Fill-2278"
          fill="#54A044"
          points="0.0318553401 32.2324583 1.51680427 33.0901021 0.0318553401 33.9526466 0.0318553401 32.2324583"
        />
        <polyline
          id="Fill-2279"
          fill="#54A044"
          points="126.46815 41.1151973 124.953797 41.9583837 126.46815 42.8353857 126.46815 41.1151973"
        />
        <path
          d="M84.0025317,49.1772938 C84.2620302,49.0275737 84.6810505,49.0275737 84.9385887,49.1772938 C85.1956368,49.3267689 85.1956368,49.5691145 84.9385887,49.7188346 C84.6810505,49.8680646 84.2620302,49.8680646 84.0025317,49.7188346 C83.7449936,49.5691145 83.7449936,49.3267689 84.0025317,49.1772938 Z M68.2953987,50.9119396 C68.5551422,50.7627096 68.9741625,50.7627096 69.2314556,50.9119396 C69.4911991,51.0616597 69.4911991,51.3040053 69.2314556,51.4537254 C68.9741625,51.6029555 68.5551422,51.6029555 68.2953987,51.4537254 C68.0378605,51.3040053 68.0378605,51.0616597 68.2953987,50.9119396 Z M90.6308929,41.4999118 C90.888186,41.3506818 91.3072063,41.3506818 91.5669498,41.4999118 C91.8242429,41.6493869 91.8242429,41.8922226 91.5669498,42.0416977 C91.3072063,42.1887223 90.888186,42.1887223 90.6308929,42.0416977 C90.3711493,41.8922226 90.3711493,41.6493869 90.6308929,41.4999118 Z M111.126129,40.2918593 C111.383422,40.1423843 111.802442,40.1423843 112.05949,40.2918593 C112.319479,40.439129 112.319479,40.6814746 112.05949,40.8309497 C111.802442,40.9804247 111.383422,40.9804247 111.126129,40.8309497 C110.866385,40.6814746 110.866385,40.439129 111.126129,40.2918593 Z M107.438015,35.4155419 C107.698004,35.2663119 108.116779,35.2663119 108.374317,35.4155419 C108.633816,35.5650169 108.633816,35.8051572 108.374317,35.9548773 C108.116779,36.1041073 107.698004,36.1041073 107.438015,35.9548773 C107.180967,35.8051572 107.180967,35.5650169 107.438015,35.4155419 Z M100.229152,28.9685111 C100.488895,28.8190361 100.907916,28.8190361 101.165209,28.9685111 C101.424952,29.1179862 101.424952,29.3608219 101.165209,29.5078465 C100.907916,29.6570766 100.488895,29.6570766 100.229152,29.5078465 C99.9718588,29.3608219 99.9718588,29.1179862 100.229152,28.9685111 Z M80.1970438,39.943901 C80.4540919,39.794671 80.8733572,39.794671 81.1331007,39.943901 C81.3903939,40.093376 81.3903939,40.3362118 81.1331007,40.4832364 C80.8733572,40.6324664 80.4540919,40.6324664 80.1970438,40.4832364 C79.9373003,40.3362118 79.9373003,40.093376 80.1970438,39.943901 Z M86.9601776,35.4155419 C87.2172256,35.2663119 87.6389413,35.2663119 87.8962345,35.4155419 C88.1535276,35.5650169 88.1535276,35.8051572 87.8962345,35.9548773 C87.6389413,36.1041073 87.2172256,36.1041073 86.9601776,35.9548773 C86.7026394,35.8051572 86.7026394,35.5650169 86.9601776,35.4155419 Z M99.5672959,37.2386475 C99.8272845,37.0891724 100.246305,37.0891724 100.503598,37.2386475 C100.763341,37.3856721 100.763341,37.6282628 100.503598,37.7779829 C100.246305,37.9272129 99.8272845,37.9272129 99.5672959,37.7779829 C99.3102479,37.6282628 99.3102479,37.3856721 99.5672959,37.2386475 Z M72.5958696,53.7323624 C72.8556131,53.5831324 73.2746334,53.5831324 73.5316815,53.7323624 C73.7916701,53.8818375 73.7916701,54.1244281 73.5316815,54.2741482 C73.2746334,54.4211729 72.8556131,54.4211729 72.5958696,54.2741482 C72.3385765,54.1244281 72.3385765,53.8818375 72.5958696,53.7323624 Z M109.34713,43.5754098 C109.604424,43.4286301 110.025649,43.4286301 110.283187,43.5754098 C110.54048,43.7251299 110.54048,43.9674755 110.283187,44.1169505 C110.025649,44.2666706 109.604424,44.2666706 109.34713,44.1169505 C109.089837,43.9674755 109.089837,43.7251299 109.34713,43.5754098 Z M73.4143068,44.8155626 C73.6715999,44.6660876 74.0906202,44.6660876 74.3503637,44.8155626 C74.6076568,44.9650377 74.6076568,45.2073833 74.3503637,45.3568584 C74.0906202,45.5065785 73.6715999,45.5065785 73.4143068,45.3568584 C73.1570137,45.2073833 73.1570137,44.9650377 73.4143068,44.8155626 Z M58.3442805,54.1146265 C58.6040241,53.9653965 59.0230443,53.9653965 59.2803374,54.1146265 C59.540081,54.2641016 59.540081,54.5044868 59.2803374,54.6537169 C59.0230443,54.803437 58.6040241,54.803437 58.3442805,54.6537169 C58.0869874,54.5044868 58.0869874,54.2641016 58.3442805,54.1146265 Z M94.5074427,49.1772938 C94.7669412,49.0275737 95.1859615,49.0275737 95.4434997,49.1772938 C95.7007928,49.3267689 95.7007928,49.5691145 95.4434997,49.7188346 C95.1859615,49.8680646 94.7669412,49.8680646 94.5074427,49.7188346 C94.2501496,49.5691145 94.2501496,49.3267689 94.5074427,49.1772938 Z M96.7272699,50.1476565 C96.984808,49.9979364 97.4038283,49.9979364 97.6635718,50.1476565 C97.9208649,50.2971315 97.9208649,50.5397222 97.6635718,50.6889522 C97.4038283,50.8384273 96.984808,50.8384273 96.7272699,50.6889522 C96.4677714,50.5397222 96.4677714,50.2971315 96.7272699,50.1476565 Z M81.1821089,56.5897864 C81.439157,56.4400663 81.8584223,56.4400663 82.1181659,56.5897864 C82.375459,56.736566 82.375459,56.9794017 82.1181659,57.1288768 C81.8584223,57.2783518 81.439157,57.2783518 81.1821089,57.1288768 C80.9221204,56.9794017 80.9221204,56.736566 81.1821089,56.5897864 Z M61.3778891,57.106578 C61.6376326,56.957348 62.0566529,56.957348 62.313946,57.106578 C62.5736895,57.2560531 62.5736895,57.4988888 62.313946,57.6483639 C62.0566529,57.7953885 61.6376326,57.7953885 61.3778891,57.6483639 C61.1203509,57.4988888 61.1203509,57.2560531 61.3778891,57.106578 Z M63.2500029,60.3928239 C63.5095014,60.2455543 63.9285216,60.2455543 64.1860598,60.3928239 C64.4458034,60.542054 64.4458034,60.7846446 64.1860598,60.9343647 C63.9285216,61.0835947 63.5095014,61.0835947 63.2500029,60.9343647 C62.9927098,60.7846446 62.9927098,60.542054 63.2500029,60.3928239 Z M81.1821089,60.9392655 C81.439157,60.7895454 81.8584223,60.7895454 82.1181659,60.9392655 C82.375459,61.0887406 82.375459,61.3286358 82.1181659,61.4781109 C81.8584223,61.627831 81.439157,61.627831 81.1821089,61.4781109 C80.9221204,61.3286358 80.9221204,61.0887406 81.1821089,60.9392655 L81.1821089,60.9392655 Z"
          id="Fill-2280"
          fill="#9ECB94"
        />
        <path
          d="M62.0392549,48.2485881 C62.2992435,48.098868 62.7182638,48.098868 62.9755569,48.2485881 C63.2353004,48.3978182 63.2353004,48.6406539 62.9755569,48.7901289 C62.7182638,48.9371536 62.2992435,48.9371536 62.0392549,48.7901289 C61.7822068,48.6406539 61.7822068,48.3978182 62.0392549,48.2485881 Z M74.2302936,42.264685 C74.4897921,42.1149649 74.9088123,42.1149649 75.1663505,42.264685 C75.426094,42.413915 75.426094,42.6540553 75.1663505,42.8035304 C74.9088123,42.9530054 74.4897921,42.9530054 74.2302936,42.8035304 C73.9730004,42.6540553 73.9730004,42.413915 74.2302936,42.264685 Z M81.8437199,42.6467041 C82.101013,42.497229 82.5200332,42.497229 82.7797768,42.6467041 C83.0370699,42.7964242 83.0370699,43.0363194 82.7797768,43.1857944 C82.5200332,43.3352695 82.101013,43.3352695 81.8437199,43.1857944 C81.5839763,43.0363194 81.5839763,42.7964242 81.8437199,42.6467041 Z M85.107667,38.5765718 C85.3674105,38.4270967 85.7864308,38.4270967 86.0437239,38.5765718 C86.3032224,38.7235964 86.3032224,38.9661871 86.0437239,39.1159072 C85.7864308,39.2653822 85.3674105,39.2653822 85.107667,39.1159072 C84.8503739,38.9661871 84.8503739,38.7235964 85.107667,38.5765718 Z M98.6143312,34.2248873 C98.8740747,34.0751672 99.293095,34.0751672 99.5501431,34.2248873 C99.8101317,34.3743623 99.8101317,34.6142576 99.5501431,34.7637326 C99.293095,34.9134527 98.8740747,34.9134527 98.6143312,34.7637326 C98.3570381,34.6142576 98.3570381,34.3743623 98.6143312,34.2248873 Z M65.7837276,49.1772938 C66.0434712,49.0275737 66.4624914,49.0275737 66.7195395,49.1772938 C66.9795281,49.3267689 66.9795281,49.5691145 66.7195395,49.7188346 C66.4624914,49.8680646 66.0434712,49.8680646 65.7837276,49.7188346 C65.5264345,49.5691145 65.5264345,49.3267689 65.7837276,49.1772938 Z M113.750519,38.8779723 C114.007812,38.7284972 114.426832,38.7284972 114.68633,38.8779723 C114.943869,39.0274474 114.943869,39.2702831 114.68633,39.4195131 C114.426832,39.5692332 114.007812,39.5692332 113.750519,39.4195131 C113.493225,39.2702831 113.493225,39.0274474 113.750519,38.8779723 Z M115.524371,39.943901 C115.784359,39.794671 116.203135,39.794671 116.460673,39.943901 C116.720171,40.093376 116.720171,40.3362118 116.460673,40.4832364 C116.203135,40.6324664 115.784359,40.6324664 115.524371,40.4832364 C115.267323,40.3362118 115.267323,40.093376 115.524371,39.943901 Z M69.6186205,44.0507894 C69.878364,43.9040098 70.2973843,43.9040098 70.5546774,44.0507894 C70.8141759,44.2002645 70.8141759,44.4428552 70.5546774,44.5925753 C70.2973843,44.7418053 69.878364,44.7418053 69.6186205,44.5925753 C69.3613274,44.4428552 69.3613274,44.2002645 69.6186205,44.0507894 Z M94.5074427,29.7330393 C94.7669412,29.5838093 95.1859615,29.5838093 95.4434997,29.7330393 C95.7007928,29.8825143 95.7007928,30.1226546 95.4434997,30.2721297 C95.1859615,30.4218498 94.7669412,30.4218498 94.5074427,30.2721297 C94.2501496,30.1226546 94.2501496,29.8825143 94.5074427,29.7330393 Z M88.376515,44.8155626 C88.6360135,44.6660876 89.0550337,44.6660876 89.3125719,44.8155626 C89.5723154,44.9650377 89.5723154,45.2073833 89.3125719,45.3568584 C89.0550337,45.5065785 88.6360135,45.5065785 88.376515,45.3568584 C88.1192218,45.2073833 88.1192218,44.9650377 88.376515,44.8155626 Z M76.690261,50.1476565 C76.9477991,50.0003868 77.3668194,50.0003868 77.6265629,50.1476565 C77.883856,50.2971315 77.883856,50.5397222 77.6265629,50.6889522 C77.3668194,50.8384273 76.9477991,50.8384273 76.690261,50.6889522 C76.4332129,50.5397222 76.4332129,50.2971315 76.690261,50.1476565 Z M87.9670513,52.0491753 C88.2270399,51.8997002 88.6460602,51.8997002 88.9031083,52.0491753 C89.1630968,52.1984053 89.1630968,52.4409959 88.9031083,52.5880206 C88.6460602,52.7374956 88.2270399,52.7374956 87.9670513,52.5880206 C87.7100032,52.4409959 87.7100032,52.1984053 87.9670513,52.0491753 Z M94.3138603,53.5169713 C94.5733588,53.3672512 94.9926241,53.3672512 95.2499172,53.5169713 C95.5069653,53.663996 95.5069653,53.9065866 95.2499172,54.0558166 C94.9926241,54.2055367 94.5733588,54.2055367 94.3138603,54.0558166 C94.0565672,53.9065866 94.0565672,53.663996 94.3138603,53.5169713 Z M52.1150913,53.7323624 C52.3750799,53.5831324 52.7941001,53.5831324 53.0513933,53.7323624 C53.3086864,53.8818375 53.3086864,54.1244281 53.0513933,54.2741482 C52.7941001,54.4211729 52.3750799,54.4211729 52.1150913,54.2741482 C51.8580432,54.1244281 51.8580432,53.8818375 52.1150913,53.7323624 Z M49.8413551,54.7078709 C50.0984032,54.5583959 50.5176685,54.5583959 50.777167,54.7078709 C51.0347052,54.857101 51.0347052,55.0996916 50.777167,55.2469613 C50.5176685,55.3961913 50.0984032,55.3961913 49.8413551,55.2469613 C49.5816116,55.0996916 49.5816116,54.857101 49.8413551,54.7078709 Z M67.283134,56.1827732 C67.5406722,56.0335432 67.9596924,56.0335432 68.219436,56.1827732 C68.476484,56.3322482 68.476484,56.575084 68.219436,56.724559 C67.9596924,56.873789 67.5406722,56.873789 67.283134,56.724559 C67.0260859,56.575084 67.0260859,56.3322482 67.283134,56.1827732 Z M68.9567646,63.9630724 C69.2167531,63.8135974 69.6357734,63.8135974 69.8930665,63.9630724 C70.1528101,64.1125475 70.1528101,64.3524427 69.8930665,64.5021628 C69.6357734,64.6513928 69.2167531,64.6513928 68.9567646,64.5021628 C68.6997165,64.3524427 68.6997165,64.1125475 68.9567646,63.9630724 Z M65.1221167,64.7521047 C65.3818603,64.6023846 65.8006355,64.6023846 66.0581736,64.7521047 C66.3176721,64.9013347 66.3176721,65.1439254 66.0581736,65.2936455 C65.8006355,65.4428755 65.3818603,65.4428755 65.1221167,65.2936455 C64.8648236,65.1439254 64.8648236,64.9013347 65.1221167,64.7521047 Z M75.6270277,64.7665621 C75.8843209,64.6197825 76.3057915,64.6197825 76.5628396,64.7665621 C76.8203778,64.9162822 76.8203778,65.1586279 76.5628396,65.3081029 C76.3057915,65.457578 75.8843209,65.457578 75.6270277,65.3081029 C75.3694895,65.1586279 75.3694895,64.9162822 75.6270277,64.7665621 L75.6270277,64.7665621 Z"
          id="Fill-2281"
          fill="#51A146"
        />
        <path
          d="M87.2101195,56.6510467 C87.2101195,55.7468451 87.9427923,55.0163777 88.8445434,55.0163777 C88.8445434,55.9181288 88.114321,56.6510467 87.2101195,56.6510467"
          id="Fill-2282"
          fill="#51A146"
        />
        <path
          d="M87.2101195,56.6510467 C87.2101195,55.7468451 86.479897,55.0163777 85.5756955,55.0163777 C85.5756955,55.9181288 86.3083683,56.6510467 87.2101195,56.6510467"
          id="Fill-2283"
          fill="#51A146"
        />
        <path
          d="M55.6904857,58.5035572 C55.6904857,57.601561 56.4207081,56.8688882 57.3249096,56.8688882 C57.3249096,57.7706394 56.5919918,58.5035572 55.6904857,58.5035572"
          id="Fill-2284"
          fill="#9ECB94"
        />
        <path
          d="M55.6904857,58.5035572 C55.6904857,57.601561 54.9575678,56.8688882 54.0558166,56.8688882 C54.0558166,57.7706394 54.786039,58.5035572 55.6904857,58.5035572"
          id="Fill-2285"
          fill="#9ECB94"
        />
        <path
          d="M103.819004,48.6970133 C103.819004,47.7925667 104.551676,47.0623443 105.453428,47.0623443 C105.453428,47.9640955 104.720755,48.6970133 103.819004,48.6970133"
          id="Fill-2286"
          fill="#9ECB94"
        />
        <path
          d="M103.819004,48.6970133 C103.819004,47.7925667 103.086331,47.0623443 102.18458,47.0623443 C102.18458,47.9640955 102.917253,48.6970133 103.819004,48.6970133"
          id="Fill-2287"
          fill="#9ECB94"
        />
        <path
          d="M71.7210729,49.3363255 C71.7210729,48.4345743 72.4537458,47.7021465 73.3554969,47.7021465 C73.3554969,48.6036527 72.6252745,49.3363255 71.7235234,49.3363255 L71.7210729,49.3363255"
          id="Fill-2288"
          fill="#9ECB94"
        />
        <path
          d="M71.7210729,49.3363255 C71.7210729,48.4345743 70.9908505,47.7021465 70.086649,47.7021465 C70.086649,48.6036527 70.8193218,49.3363255 71.7210729,49.3363255"
          id="Fill-2289"
          fill="#9ECB94"
        />
        <path
          d="M73.8823353,60.1379812 C73.8823353,59.2362301 74.6125577,58.5035572 75.5167592,58.5035572 C75.5167592,59.4050634 74.7840864,60.1379812 73.8823353,60.1379812"
          id="Fill-2290"
          fill="#51A146"
        />
        <path
          d="M73.8823353,60.1379812 C73.8823353,59.2362301 73.1496624,58.5035572 72.2479113,58.5035572 C72.2479113,59.4050634 72.9781337,60.1379812 73.8823353,60.1379812"
          id="Fill-2291"
          fill="#51A146"
        />
        <path
          d="M85.1321711,46.2858091 C85.1321711,45.3816075 85.8645989,44.6511401 86.7665951,44.6511401 C86.7665951,45.5531363 86.0336772,46.2858091 85.1321711,46.2858091"
          id="Fill-2292"
          fill="#51A146"
        />
        <path
          d="M85.1321711,46.2858091 C85.1321711,45.3816075 84.3994983,44.6511401 83.4977471,44.6511401 C83.4977471,45.5531363 84.2301749,46.2858091 85.1321711,46.2858091"
          id="Fill-2293"
          fill="#51A146"
        />
        <path
          d="M92.7333453,37.9419154 C92.7333453,37.0401642 93.4635677,36.3077364 94.3677693,36.3077364 C94.3677693,37.211938 93.6348515,37.9419154 92.7333453,37.9419154"
          id="Fill-2294"
          fill="#51A146"
        />
        <path
          d="M92.7333453,37.9419154 C92.7333453,37.0401642 92.0004275,36.3077364 91.0989213,36.3077364 C91.0989213,37.211938 91.8291438,37.9419154 92.7333453,37.9419154"
          id="Fill-2295"
          fill="#51A146"
        />
        <path
          d="M97.8571543,43.7349315 C97.8571543,42.8304849 98.5873767,42.0978121 99.4915783,42.0978121 L99.4915783,42.1002625 C99.4915783,43.0020136 98.7589054,43.7349315 97.8571543,43.7349315"
          id="Fill-2296"
          fill="#51A146"
        />
        <path
          d="M97.8571543,43.7349315 C97.8571543,42.8304849 97.1244814,42.0978121 96.2224852,42.0978121 L96.2224852,42.1002625 C96.2224852,43.0020136 96.9529527,43.7349315 97.8571543,43.7349315"
          id="Fill-2297"
          fill="#51A146"
        />
        <path
          d="M59.6648069,35.9916335 C59.9247955,35.8446088 60.3438157,35.8446088 60.6008638,35.9916335 C60.858402,36.1411085 60.858402,36.3836992 60.6008638,36.5329292 C60.3438157,36.6824042 59.9247955,36.6824042 59.6648069,36.5329292 C59.4077588,36.3836992 59.4077588,36.1411085 59.6648069,35.9916335 Z M43.9579189,37.7265243 C44.2174174,37.5768042 44.6366827,37.5768042 44.8939758,37.7265243 C45.1537193,37.8757543 45.1537193,38.118345 44.8939758,38.2680651 C44.6366827,38.4175401 44.2174174,38.4175401 43.9579189,38.2680651 C43.7006257,38.118345 43.7006257,37.8757543 43.9579189,37.7265243 Z M66.2934131,28.3142515 C66.5507062,28.1650214 66.9697265,28.1650214 67.22947,28.3142515 C67.4865181,28.4637265 67.4865181,28.7065622 67.22947,28.8560373 C66.9697265,29.0052673 66.5507062,29.0052673 66.2934131,28.8560373 C66.0336695,28.7065622 66.0336695,28.4637265 66.2934131,28.3142515 Z M86.7886488,27.1061989 C87.0459419,26.9569689 87.4649622,26.9569689 87.7247057,27.1061989 C87.9819988,27.255919 87.9819988,27.4960593 87.7247057,27.6452893 C87.4649622,27.7947644 87.0459419,27.7947644 86.7886488,27.6452893 C86.5289053,27.4960593 86.5289053,27.255919 86.7886488,27.1061989 Z M83.1007806,22.2298815 C83.3605241,22.0804064 83.7795444,22.0804064 84.0368375,22.2298815 C84.296336,22.3796016 84.296336,22.6221923 84.0368375,22.7692169 C83.7795444,22.9184469 83.3605241,22.9184469 83.1007806,22.7692169 C82.8432424,22.6221923 82.8432424,22.3796016 83.1007806,22.2298815 Z M75.8916721,15.7828508 C76.1514156,15.6333757 76.5704359,15.6333757 76.827484,15.7828508 C77.0874725,15.9323258 77.0874725,16.1751615 76.827484,16.3243915 C76.5704359,16.4714162 76.1514156,16.4714162 75.8916721,16.3243915 C75.634379,16.1751615 75.634379,15.9323258 75.8916721,15.7828508 Z M55.859564,26.7582406 C56.1168571,26.6087656 56.5358774,26.6087656 56.7953759,26.7582406 C57.0529141,26.9077157 57.0529141,27.1503063 56.7953759,27.2997814 C56.5358774,27.446806 56.1168571,27.446806 55.859564,27.2997814 C55.5998205,27.1503063 55.5998205,26.9077157 55.859564,26.7582406 Z M62.6224527,22.2298815 C62.8824413,22.0804064 63.3014615,22.0804064 63.5587547,22.2298815 C63.8160478,22.3796016 63.8160478,22.6221923 63.5587547,22.7692169 C63.3014615,22.9184469 62.8824413,22.9184469 62.6224527,22.7692169 C62.3654046,22.6221923 62.3654046,22.3796016 62.6224527,22.2298815 Z M75.2300612,24.0529871 C75.4898047,23.9035121 75.9085799,23.9035121 76.1661181,24.0529871 C76.4256166,24.2024622 76.4256166,24.4428475 76.1661181,24.5920775 C75.9085799,24.7415525 75.4898047,24.7415525 75.2300612,24.5920775 C74.972768,24.4428475 74.972768,24.2024622 75.2300612,24.0529871 Z M48.2583898,40.546702 C48.5181333,40.397227 48.9371536,40.397227 49.1942017,40.546702 C49.4541902,40.6961771 49.4541902,40.9390128 49.1942017,41.0884879 C48.9371536,41.2352675 48.5181333,41.2352675 48.2583898,41.0884879 C48.0010967,40.9390128 48.0010967,40.6961771 48.2583898,40.546702 Z M85.0096506,30.3921998 C85.2669437,30.2429698 85.6859639,30.2429698 85.9454625,30.3921998 C86.2030006,30.5392244 86.2030006,30.7818151 85.9454625,30.9315352 C85.6859639,31.0810103 85.2669437,31.0810103 85.0096506,30.9315352 C84.7523574,30.7818151 84.7523574,30.5392244 85.0096506,30.3921998 Z M49.0765819,31.6296572 C49.3341201,31.4828776 49.7531404,31.4828776 50.0126389,31.6296572 C50.270177,31.7793773 50.270177,32.021723 50.0126389,32.171198 C49.7531404,32.3209181 49.3341201,32.3209181 49.0765819,32.171198 C48.8195339,32.021723 48.8195339,31.7793773 49.0765819,31.6296572 Z M34.0065557,40.9289661 C34.2665443,40.7797361 34.6855645,40.7797361 34.9426126,40.9289661 C35.2026012,41.0784412 35.2026012,41.3212769 34.9426126,41.4707519 C34.6855645,41.6175315 34.2665443,41.6175315 34.0065557,41.4707519 C33.7495076,41.3212769 33.7495076,41.0784412 34.0065557,40.9289661 Z M70.1699629,35.9916335 C70.4297065,35.8446088 70.8487267,35.8446088 71.1060198,35.9916335 C71.363313,36.1411085 71.363313,36.3836992 71.1060198,36.5329292 C70.8487267,36.6824042 70.4297065,36.6824042 70.1699629,36.5329292 C69.9126698,36.3836992 69.9126698,36.1411085 70.1699629,35.9916335 Z M72.3900351,36.9642015 C72.6470832,36.8149715 73.0661034,36.8149715 73.326092,36.9642015 C73.5833851,37.1114712 73.5833851,37.3540618 73.326092,37.5032919 C73.0661034,37.6527669 72.6470832,37.6527669 72.3900351,37.5032919 C72.1302915,37.3540618 72.1302915,37.1114712 72.3900351,36.9642015 Z M56.8446291,43.403881 C57.1019223,43.2544059 57.5209425,43.2544059 57.7806861,43.403881 C58.0379792,43.5533561 58.0379792,43.7961918 57.7806861,43.9429714 C57.5209425,44.0926915 57.1019223,44.0926915 56.8446291,43.9429714 C56.5848856,43.7961918 56.5848856,43.5533561 56.8446291,43.403881 Z M37.0404093,43.9209177 C37.3001528,43.7714426 37.719173,43.7714426 37.9764662,43.9209177 C38.2362097,44.0703927 38.2362097,44.3132284 37.9764662,44.4627035 C37.719173,44.6119335 37.3001528,44.6119335 37.0404093,44.4627035 C36.7831161,44.3132284 36.7831161,44.0703927 37.0404093,43.9209177 Z M38.9125231,47.2093689 C39.1722666,47.0598939 39.5912869,47.0598939 39.84858,47.2093689 C40.1083236,47.3566386 40.1083236,47.5992293 39.84858,47.7484593 C39.5912869,47.8979344 39.1722666,47.8979344 38.9125231,47.7484593 C38.65523,47.5992293 38.65523,47.3566386 38.9125231,47.2093689 Z M56.8446291,47.7536052 C57.1019223,47.6038851 57.5209425,47.6038851 57.7806861,47.7536052 C58.0379792,47.9030802 58.0379792,48.1456709 57.7806861,48.2924505 C57.5209425,48.4421706 57.1019223,48.4421706 56.8446291,48.2924505 C56.5848856,48.1456709 56.5848856,47.9030802 56.8446291,47.7536052 L56.8446291,47.7536052 Z"
          id="Fill-2298"
          fill="#9ECB94"
        />
        <path
          d="M37.7020202,35.0626827 C37.9617637,34.9156581 38.380784,34.9156581 38.6380771,35.0626827 C38.8978206,35.2121578 38.8978206,35.4549935 38.6380771,35.6042235 C38.380784,35.7536986 37.9617637,35.7536986 37.7020202,35.6042235 C37.444482,35.4549935 37.444482,35.2121578 37.7020202,35.0626827 Z M49.8928138,29.0790247 C50.1525573,28.9293046 50.5715776,28.9293046 50.8286256,29.0790247 C51.0886142,29.2284997 51.0886142,29.4708453 50.8286256,29.6203204 C50.5715776,29.7675901 50.1525573,29.7675901 49.8928138,29.6203204 C49.6355206,29.4708453 49.6355206,29.2284997 49.8928138,29.0790247 Z M57.50624,29.4612887 C57.7635332,29.3115686 58.1825534,29.3115686 58.442297,29.4612887 C58.6995901,29.6107638 58.6995901,29.850659 58.442297,30.0001341 C58.1825534,30.1496091 57.7635332,30.1496091 57.50624,30.0001341 C57.2462515,29.8531094 57.2462515,29.6107638 57.50624,29.4612887 Z M60.7723926,25.3909114 C61.0299307,25.2414363 61.448951,25.2414363 61.7062441,25.3909114 C61.9659877,25.5403865 61.9659877,25.7807718 61.7062441,25.9302468 C61.448951,26.0794768 61.0299307,26.0794768 60.7723926,25.9302468 C60.5128941,25.7807718 60.5128941,25.5403865 60.7723926,25.3909114 Z M74.2793018,21.0392269 C74.5363499,20.8897518 74.9553701,20.8897518 75.2129083,21.0392269 C75.4726518,21.1884569 75.4726518,21.4285972 75.2129083,21.5780722 C74.9553701,21.7277923 74.5363499,21.7277923 74.2793018,21.5780722 C74.0195583,21.4285972 74.0195583,21.1884569 74.2793018,21.0392269 Z M41.4462478,35.9916335 C41.7057463,35.8446088 42.1247666,35.8446088 42.3823047,35.9916335 C42.6420483,36.1411085 42.6420483,36.3836992 42.3823047,36.5329292 C42.1247666,36.6824042 41.7057463,36.6824042 41.4462478,36.5329292 C41.1889547,36.3836992 41.1889547,36.1411085 41.4462478,35.9916335 Z M89.4130387,25.6923119 C89.6703319,25.5455323 90.0915575,25.5455323 90.3490957,25.6923119 C90.6063888,25.841787 90.6063888,26.0846227 90.3490957,26.2338527 C90.0915575,26.3835728 89.6703319,26.3835728 89.4130387,26.2338527 C89.1557456,26.0846227 89.1557456,25.841787 89.4130387,25.6923119 Z M91.1871361,26.7582406 C91.4468797,26.6087656 91.8658999,26.6087656 92.1231931,26.7582406 C92.3826916,26.9077157 92.3826916,27.1503063 92.1231931,27.2997814 C91.8658999,27.446806 91.4468797,27.446806 91.1871361,27.2997814 C90.929598,27.1503063 90.929598,26.9077157 91.1871361,26.7582406 Z M45.2811407,30.8675795 C45.5408842,30.7181044 45.9599045,30.7181044 46.2171976,30.8675795 C46.4769412,31.0148492 46.4769412,31.2571948 46.2171976,31.4069149 C45.9599045,31.5561449 45.5408842,31.5561449 45.2811407,31.4069149 C45.0238476,31.2571948 45.0238476,31.0148492 45.2811407,30.8675795 Z M70.1699629,16.547624 C70.4297065,16.3981489 70.8487267,16.3981489 71.1060198,16.547624 C71.363313,16.697099 71.363313,16.9369942 71.1060198,17.0864693 C70.8487267,17.2359443 70.4297065,17.2359443 70.1699629,17.0864693 C69.9126698,16.9369942 69.9126698,16.697099 70.1699629,16.547624 Z M64.0390352,31.6296572 C64.2987787,31.4828776 64.717799,31.4828776 64.9750921,31.6296572 C65.2348356,31.7793773 65.2348356,32.021723 64.9750921,32.171198 C64.717799,32.3209181 64.2987787,32.3209181 64.0390352,32.171198 C63.781742,32.021723 63.781742,31.7793773 64.0390352,31.6296572 Z M52.3530262,36.9642015 C52.6103193,36.8149715 53.03179,36.8149715 53.2890831,36.9642015 C53.5463762,37.1114712 53.5463762,37.3540618 53.2890831,37.5032919 C53.03179,37.6527669 52.6103193,37.6527669 52.3530262,37.5032919 C52.0957331,37.3540618 52.0957331,37.1114712 52.3530262,36.9642015 Z M63.6298166,38.8632698 C63.8895601,38.7140398 64.3085804,38.7140398 64.5656284,38.8632698 C64.825617,39.0129899 64.825617,39.2553356 64.5656284,39.4048106 C64.3085804,39.5545307 63.8895601,39.5545307 63.6298166,39.4048106 C63.3725234,39.2553356 63.3725234,39.0129899 63.6298166,38.8632698 Z M69.9763805,40.3310659 C70.236124,40.1818359 70.6551443,40.1818359 70.9121924,40.3310659 C71.1697305,40.4805409 71.1697305,40.7209262 70.9121924,40.8701563 C70.6551443,41.0198764 70.236124,41.0198764 69.9763805,40.8701563 C69.7190873,40.7209262 69.7190873,40.4805409 69.9763805,40.3310659 Z M27.7778565,40.546702 C28.0376001,40.397227 28.4566203,40.397227 28.7139135,40.546702 C28.9712066,40.6961771 28.9712066,40.9390128 28.7139135,41.0884879 C28.4566203,41.2352675 28.0376001,41.2352675 27.7778565,41.0884879 C27.5203184,40.9390128 27.5203184,40.6961771 27.7778565,40.546702 Z M25.5036303,41.5222106 C25.7611685,41.3727355 26.1801887,41.3727355 26.4399323,41.5222106 C26.6972254,41.6714406 26.6972254,41.9140313 26.4399323,42.0635063 C26.1801887,42.2129814 25.7611685,42.2129814 25.5036303,42.0635063 C25.2441318,41.9140313 25.2441318,41.6714406 25.5036303,41.5222106 Z M42.9456542,42.9971128 C43.2031924,42.8500882 43.624663,42.8500882 43.8817111,42.9971128 C44.1392493,43.1465879 44.1392493,43.3891785 43.8817111,43.5386536 C43.624663,43.6881287 43.2031924,43.6881287 42.9456542,43.5386536 C42.6886061,43.3891785 42.6886061,43.1465879 42.9456542,42.9971128 Z M44.6195298,50.7774121 C44.8792733,50.627937 45.2982936,50.627937 45.5555867,50.7774121 C45.8150852,50.9266421 45.8150852,51.1692327 45.5555867,51.3187078 C45.2982936,51.4659775 44.8792733,51.4659775 44.6195298,51.3187078 C44.3622367,51.1692327 44.3622367,50.9266421 44.6195298,50.7774121 Z M40.7846369,51.5686497 C41.0443805,51.4191746 41.4634007,51.4191746 41.7206938,51.5686497 C41.9804374,51.7159194 41.9804374,51.958265 41.7206938,52.1079851 C41.4634007,52.2572151 41.0443805,52.2572151 40.7846369,52.1079851 C40.5273438,51.958265 40.5273438,51.7159194 40.7846369,51.5686497 Z M51.2895479,51.5835972 C51.546841,51.4341221 51.9680667,51.4341221 52.2256048,51.5835972 C52.4826529,51.7306219 52.4826529,51.9729675 52.2256048,52.1226876 C51.9680667,52.2719176 51.546841,52.2719176 51.2895479,52.1226876 C51.0320097,51.9729675 51.0320097,51.7306219 51.2895479,51.5835972 L51.2895479,51.5835972 Z"
          id="Fill-2299"
          fill="#51A146"
        />
        <path
          d="M62.8723946,43.4651413 C62.8723946,42.5633901 63.6053125,41.8309623 64.5070636,41.8309623 C64.5070636,42.7324684 63.7768412,43.4651413 62.8750901,43.4651413 L62.8723946,43.4651413"
          id="Fill-2300"
          fill="#51A146"
        />
        <path
          d="M62.8723946,43.4651413 C62.8723946,42.5633901 62.1421722,41.8309623 61.2379706,41.8309623 C61.2379706,42.7324684 61.9708885,43.4651413 62.8723946,43.4651413 L62.8750901,43.4651413 L62.8723946,43.4651413"
          id="Fill-2301"
          fill="#51A146"
        />
        <path
          d="M31.3527608,45.3178969 C31.3527608,44.4161457 32.0829832,43.6832278 32.9871848,43.6832278 C32.9871848,44.5876744 32.254757,45.3178969 31.3527608,45.3178969"
          id="Fill-2302"
          fill="#9ECB94"
        />
        <path
          d="M31.3527608,45.3178969 C31.3527608,44.4161457 30.620333,43.6832278 29.7185819,43.6832278 C29.7185819,44.5876744 30.4485592,45.3178969 31.3527608,45.3178969"
          id="Fill-2303"
          fill="#9ECB94"
        />
        <path
          d="M79.4815239,35.5113529 C79.4815239,34.6096018 80.2141967,33.876929 81.1159479,33.876929 C81.1159479,34.7784351 80.383275,35.5113529 79.4815239,35.5113529"
          id="Fill-2304"
          fill="#9ECB94"
        />
        <path
          d="M79.4815239,35.5113529 C79.4815239,34.6096018 78.748606,33.876929 77.8470999,33.876929 C77.8470999,34.7784351 78.5795277,35.5113529 79.4815239,35.5113529"
          id="Fill-2305"
          fill="#9ECB94"
        />
        <path
          d="M47.3835931,36.1506651 C47.3835931,35.2489139 48.116266,34.5162411 49.0180171,34.5162411 L49.0204675,34.5162411 C49.0204675,35.4179923 48.2875497,36.1506651 47.3860435,36.1506651 L47.3835931,36.1506651"
          id="Fill-2306"
          fill="#9ECB94"
        />
        <path
          d="M47.3835931,36.1506651 C47.3835931,35.2489139 46.6531257,34.5162411 45.7489241,34.5162411 C45.7489241,35.4179923 46.481842,36.1506651 47.3835931,36.1506651"
          id="Fill-2307"
          fill="#9ECB94"
        />
        <path
          d="M49.5448554,46.9523208 C49.5448554,46.0505697 50.2772832,45.3178969 51.1792794,45.3178969 C51.1792794,46.2218534 50.4463616,46.9523208 49.5448554,46.9523208"
          id="Fill-2308"
          fill="#51A146"
        />
        <path
          d="M49.5448554,46.9523208 C49.5448554,46.0505697 48.8119376,45.3178969 47.9104315,45.3178969 C47.9104315,46.2218534 48.6406539,46.9523208 49.5448554,46.9523208"
          id="Fill-2309"
          fill="#51A146"
        />
        <path
          d="M60.7946913,33.0999037 C60.7946913,32.1983976 61.5273641,31.4657248 62.4291153,31.4657248 C62.4291153,32.3674759 61.6964425,33.0999037 60.7946913,33.0999037"
          id="Fill-2310"
          fill="#51A146"
        />
        <path
          d="M60.7946913,33.0999037 C60.7946913,32.1983976 60.0620185,31.4657248 59.1602673,31.4657248 C59.1602673,32.3674759 59.8929401,33.0999037 60.7946913,33.0999037"
          id="Fill-2311"
          fill="#51A146"
        />
        <path
          d="M68.3958655,24.7587054 C68.3958655,23.8545038 69.1258429,23.1242814 70.0302895,23.1242814 C70.0302895,24.0262776 69.2976167,24.7587054 68.3958655,24.7587054"
          id="Fill-2312"
          fill="#51A146"
        />
        <path
          d="M68.3958655,24.7587054 C68.3958655,23.8545038 67.6631927,23.1242814 66.7614415,23.1242814 C66.7614415,24.0262776 67.491664,24.7587054 68.3958655,24.7587054"
          id="Fill-2313"
          fill="#51A146"
        />
        <path
          d="M73.5194294,30.5492711 C73.5194294,29.6450695 74.2498969,28.9148471 75.1538534,28.9148471 C75.1538534,29.8163533 74.4214256,30.5492711 73.5194294,30.5492711"
          id="Fill-2314"
          fill="#51A146"
        />
        <path
          d="M73.5194294,30.5492711 C73.5194294,29.6450695 72.7870016,28.9148471 71.8852505,28.9148471 C71.8852505,29.8163533 72.6154729,30.5492711 73.5194294,30.5492711"
          id="Fill-2315"
          fill="#51A146"
        />
        <path
          d="M41.4437974,24.8471652 C41.7010906,24.6974452 42.1201108,24.6974452 42.3796093,24.8471652 C42.6371475,24.9966403 42.6371475,25.2389859 42.3796093,25.388461 C42.1201108,25.537936 41.7010906,25.537936 41.4437974,25.388461 C41.1865043,25.2389859 41.1865043,24.9966403 41.4437974,24.8471652 Z M25.7364193,26.5820561 C25.9964079,26.432336 26.4154281,26.432336 26.6724762,26.5820561 C26.9300144,26.7312861 26.9300144,26.9738768 26.6724762,27.1235969 C26.4154281,27.2730719 25.9964079,27.2730719 25.7364193,27.1235969 C25.4793712,26.9738768 25.4793712,26.7312861 25.7364193,26.5820561 Z M48.0719135,17.1697833 C48.3294517,17.0203082 48.7484719,17.0203082 49.0082155,17.1697833 C49.2655086,17.3192583 49.2655086,17.562094 49.0082155,17.7115691 C48.7484719,17.8607991 48.3294517,17.8607991 48.0719135,17.7115691 C47.812415,17.562094 47.812415,17.3192583 48.0719135,17.1697833 Z M68.5649439,15.9619758 C68.8244424,15.8125007 69.2434626,15.8125007 69.5010008,15.9619758 C69.7607443,16.1114508 69.7607443,16.3513461 69.5010008,16.5008211 C69.2434626,16.6502962 68.8244424,16.6502962 68.5649439,16.5008211 C68.3074057,16.3513461 68.3074057,16.1114508 68.5649439,15.9619758 Z M64.8795261,11.0856583 C65.1392696,10.9359382 65.5582899,10.9359382 65.815583,11.0856583 C66.0753265,11.2348884 66.0753265,11.477479 65.815583,11.6247487 C65.5582899,11.7739787 65.1392696,11.7739787 64.8795261,11.6247487 C64.6222329,11.477479 64.6222329,11.2348884 64.8795261,11.0856583 Z M57.6704176,4.63838255 C57.9299161,4.4889075 58.3489363,4.4889075 58.6064745,4.63838255 C58.8635226,4.78785761 58.8635226,5.03069332 58.6064745,5.17747292 C58.3489363,5.32694798 57.9299161,5.32694798 57.6704176,5.17747292 C57.4131244,5.03069332 57.4131244,4.78785761 57.6704176,4.63838255 Z M37.6383095,15.6137724 C37.8956026,15.4642974 38.3146229,15.4642974 38.5743664,15.6137724 C38.8314145,15.7632475 38.8314145,16.0060832 38.5743664,16.1531078 C38.3146229,16.3023378 37.8956026,16.3023378 37.6383095,16.1531078 C37.3785659,16.0060832 37.3785659,15.7632475 37.6383095,15.6137724 Z M44.4011982,11.0856583 C44.6587364,10.9359382 45.0777566,10.9359382 45.3375001,11.0856583 C45.5947933,11.2348884 45.5947933,11.477479 45.3375001,11.6247487 C45.0777566,11.7739787 44.6587364,11.7739787 44.4011982,11.6247487 C44.1441501,11.477479 44.1441501,11.2348884 44.4011982,11.0856583 Z M57.0088067,12.9085189 C57.2685502,12.7590439 57.6875704,12.7590439 57.9446185,12.9085189 C58.2021567,13.0557886 58.2021567,13.2981342 57.9446185,13.4476093 C57.6875704,13.5970843 57.2685502,13.5970843 57.0088067,13.4476093 C56.7515135,13.2981342 56.7515135,13.0557886 57.0088067,12.9085189 Z M30.0371353,29.4022338 C30.2966338,29.2527588 30.715654,29.2527588 30.9731922,29.4022338 C31.2329357,29.5517089 31.2329357,29.7945446 30.9731922,29.9440197 C30.715654,30.0907993 30.2966338,30.0907993 30.0371353,29.9440197 C29.7795971,29.7945446 29.7795971,29.5517089 30.0371353,29.4022338 Z M66.7883961,19.2479766 C67.0456892,19.0985016 67.4647094,19.0985016 67.724453,19.2479766 C67.9817461,19.3950013 67.9817461,19.6375919 67.724453,19.787067 C67.4647094,19.9365421 67.0456892,19.9365421 66.7883961,19.787067 C66.5311029,19.6375919 66.5311029,19.3950013 66.7883961,19.2479766 Z M30.8555725,20.485189 C31.1126206,20.335714 31.5316408,20.335714 31.7916294,20.485189 C32.0489225,20.6349091 32.0489225,20.8772548 31.7916294,21.0267298 C31.5316408,21.1764499 31.1126206,21.1764499 30.8555725,21.0267298 C30.5958289,20.8772548 30.5958289,20.6349091 30.8555725,20.485189 Z M15.7855462,29.7844979 C16.0452897,29.6352679 16.46431,29.6352679 16.7216031,29.7844979 C16.9813467,29.933973 16.9813467,30.1768087 16.7216031,30.3238333 C16.46431,30.4730633 16.0452897,30.4730633 15.7855462,30.3238333 C15.528008,30.1768087 15.528008,29.933973 15.7855462,29.7844979 Z M51.9487084,24.8471652 C52.2060015,24.6974452 52.6274722,24.6974452 52.8847653,24.8471652 C53.1420585,24.9966403 53.1420585,25.2389859 52.8847653,25.388461 C52.6274722,25.537936 52.2060015,25.537936 51.9487084,25.388461 C51.6914153,25.2389859 51.6914153,24.9966403 51.9487084,24.8471652 Z M54.1685355,25.8175279 C54.4260737,25.6705033 54.8450939,25.6705033 55.1023871,25.8175279 C55.3621306,25.9667579 55.3621306,26.2095936 55.1023871,26.3588237 C54.8450939,26.5082987 54.4260737,26.5082987 54.1685355,26.3588237 C53.909037,26.2095936 53.909037,25.9667579 54.1685355,25.8175279 Z M38.6233746,32.2596578 C38.8806678,32.1099377 39.299688,32.1099377 39.5594315,32.2596578 C39.8167247,32.4088879 39.8167247,32.6492732 39.5594315,32.7985032 C39.299688,32.9482233 38.8806678,32.9482233 38.6233746,32.7985032 C38.363386,32.6492732 38.363386,32.4088879 38.6233746,32.2596578 Z M18.8191547,32.7764495 C19.0788983,32.6272195 19.4979185,32.6272195 19.7549666,32.7764495 C20.0149552,32.9259245 20.0149552,33.1687602 19.7549666,33.3182353 C19.4979185,33.4650149 19.0788983,33.4650149 18.8191547,33.3182353 C18.5618616,33.1687602 18.5618616,32.9259245 18.8191547,32.7764495 Z M20.6912686,36.0649007 C20.9510121,35.9154257 21.3700324,35.9154257 21.6273255,36.0649007 C21.887069,36.2121704 21.887069,36.454516 21.6273255,36.6039911 C21.3700324,36.7534662 20.9510121,36.7534662 20.6912686,36.6039911 C20.4339754,36.454516 20.4339754,36.2121704 20.6912686,36.0649007 Z M38.6233746,36.609137 C38.8806678,36.4594169 39.299688,36.4594169 39.5594315,36.609137 C39.8167247,36.758612 39.8167247,37.0012027 39.5594315,37.1479823 C39.299688,37.2977024 38.8806678,37.2977024 38.6233746,37.1479823 C38.363386,37.0012027 38.363386,36.758612 38.6233746,36.609137 L38.6233746,36.609137 Z"
          id="Fill-2316"
          fill="#9ECB94"
        />
        <path
          d="M19.4807657,23.9182145 C19.7405092,23.7687395 20.1595294,23.7687395 20.4168226,23.9182145 C20.6765661,24.0676896 20.6765661,24.3105253 20.4168226,24.4600003 C20.1595294,24.6092304 19.7405092,24.6092304 19.4807657,24.4600003 C19.2232275,24.3105253 19.2232275,24.0676896 19.4807657,23.9182145 Z M31.6715593,17.9345565 C31.9310578,17.7848364 32.350323,17.7848364 32.6076162,17.9345565 C32.8673597,18.0840315 32.8673597,18.3263771 32.6076162,18.4760972 C32.350323,18.6228768 31.9310578,18.6228768 31.6715593,18.4760972 C31.4140211,18.3263771 31.4140211,18.0840315 31.6715593,17.9345565 Z M39.2849855,18.3168205 C39.5422787,18.1673455 39.9612989,18.1673455 40.2207974,18.3168205 C40.4783356,18.4662956 40.4783356,18.7061908 40.2207974,18.8556659 C39.9612989,19.0051409 39.5422787,19.0051409 39.2849855,18.8556659 C39.025242,18.7061908 39.025242,18.4662956 39.2849855,18.3168205 Z M42.5489327,14.2464432 C42.8084312,14.0969681 43.2274514,14.0969681 43.4849896,14.2464432 C43.7447331,14.3959183 43.7447331,14.6363036 43.4849896,14.7855336 C43.2274514,14.9350086 42.8084312,14.9350086 42.5489327,14.7855336 C42.2916396,14.6363036 42.2916396,14.3959183 42.5489327,14.2464432 Z M56.0555969,9.89475871 C56.3153404,9.74503861 56.7343607,9.74503861 56.9914087,9.89475871 C57.2513973,10.0439887 57.2513973,10.284129 56.9914087,10.433604 C56.7343607,10.5833241 56.3153404,10.5833241 56.0555969,10.433604 C55.7983037,10.284129 55.7983037,10.0439887 56.0555969,9.89475871 Z M23.2249933,24.8471652 C23.4847369,24.6974452 23.9037571,24.6974452 24.1610502,24.8471652 C24.4205487,24.9966403 24.4205487,25.2389859 24.1610502,25.388461 C23.9037571,25.537936 23.4847369,25.537936 23.2249933,25.388461 C22.9677002,25.2389859 22.9677002,24.9966403 23.2249933,24.8471652 Z M71.1917842,14.5478437 C71.4488323,14.4008191 71.8680976,14.4008191 72.1278411,14.5478437 C72.3851343,14.6973188 72.3851343,14.9399094 72.1278411,15.0893845 C71.8680976,15.2391046 71.4488323,15.2391046 71.1917842,15.0893845 C70.9320407,14.9399094 70.9320407,14.6973188 71.1917842,14.5478437 Z M72.9658816,15.6137724 C73.2256252,15.4642974 73.6446454,15.4642974 73.9019385,15.6137724 C74.1592317,15.7632475 74.1592317,16.0060832 73.9019385,16.1531078 C73.6446454,16.3023378 73.2256252,16.3023378 72.9658816,16.1531078 C72.7085885,16.0060832 72.7085885,15.7632475 72.9658816,15.6137724 Z M27.0598862,19.7233563 C27.3196297,19.5736362 27.7384049,19.5736362 27.9959431,19.7233563 C28.2554416,19.870381 28.2554416,20.1127266 27.9959431,20.2624467 C27.7384049,20.4116767 27.3196297,20.4116767 27.0598862,20.2624467 C26.802593,20.1127266 26.802593,19.870381 27.0598862,19.7233563 Z M51.9487084,5.40315576 C52.2060015,5.2536807 52.6250218,5.2536807 52.8847653,5.40315576 C53.1420585,5.55263081 53.1420585,5.79252603 52.8847653,5.94200109 C52.6250218,6.09147614 52.2060015,6.09147614 51.9487084,5.94200109 C51.6914153,5.79252603 51.6914153,5.55263081 51.9487084,5.40315576 Z M45.8177807,20.485189 C46.0775242,20.3384094 46.4965444,20.3384094 46.7538376,20.485189 C47.0135811,20.6349091 47.0135811,20.8772548 46.7538376,21.0267298 C46.4965444,21.1764499 46.0775242,21.1764499 45.8177807,21.0267298 C45.5604875,20.8772548 45.5604875,20.6349091 45.8177807,20.485189 Z M34.1317717,25.8175279 C34.3890648,25.6705033 34.808085,25.6705033 35.0678286,25.8175279 C35.3248767,25.9667579 35.3248767,26.2095936 35.0678286,26.3588237 C34.808085,26.5082987 34.3890648,26.5082987 34.1317717,26.3588237 C33.8720281,26.2095936 33.8720281,25.9667579 34.1317717,25.8175279 Z M45.4085621,27.7188016 C45.6658552,27.5695716 46.0870808,27.5695716 46.344619,27.7188016 C46.6016671,27.8685217 46.6016671,28.1108674 46.344619,28.258137 C46.0870808,28.4076121 45.6658552,28.4076121 45.4085621,28.258137 C45.1510239,28.1108674 45.1510239,27.8685217 45.4085621,27.7188016 Z M51.755126,29.1865977 C52.0124191,29.0373677 52.4311943,29.0373677 52.6911829,29.1865977 C52.948231,29.3360727 52.948231,29.576458 52.6911829,29.7256881 C52.4311943,29.8754082 52.0124191,29.8754082 51.755126,29.7256881 C51.4975878,29.576458 51.4975878,29.3360727 51.755126,29.1865977 Z M9.55660202,29.4022338 C9.81389515,29.2527588 10.2329154,29.2527588 10.4926589,29.4022338 C10.749707,29.5517089 10.749707,29.7945446 10.4926589,29.9440197 C10.2329154,30.0907993 9.81389515,30.0907993 9.55660202,29.9440197 C9.29906385,29.7945446 9.29906385,29.5517089 9.55660202,29.4022338 Z M7.28262082,30.3777424 C7.53991395,30.2282673 7.95893419,30.2282673 8.21622733,30.3777424 C8.47597087,30.5269724 8.47597087,30.769563 8.21622733,30.9168327 C7.95893419,31.0663078 7.53991395,31.0663078 7.28262082,30.9168327 C7.02263224,30.769563 7.02263224,30.5269724 7.28262082,30.3777424 Z M24.7246447,31.8528897 C24.9816928,31.70562 25.400713,31.70562 25.6607016,31.8528897 C25.9179948,32.0021197 25.9179948,32.2447103 25.6607016,32.3941854 C25.400713,32.5436604 24.9816928,32.5436604 24.7246447,32.3941854 C24.4649012,32.2447103 24.4649012,32.0021197 24.7246447,31.8528897 Z M26.3982753,39.6329439 C26.6580188,39.4834688 27.0770391,39.4834688 27.3343322,39.6329439 C27.5940757,39.7821739 27.5940757,40.0247645 27.3343322,40.1742396 C27.0770391,40.3215093 26.6580188,40.3215093 26.3982753,40.1742396 C26.1409821,40.0247645 26.1409821,39.7821739 26.3982753,39.6329439 Z M22.5631374,40.4219761 C22.823126,40.2747064 23.2421462,40.2747064 23.4994393,40.4219761 C23.7591829,40.5714512 23.7591829,40.8137968 23.4994393,40.9635169 C23.2421462,41.1127469 22.823126,41.1127469 22.5631374,40.9635169 C22.3060893,40.8137968 22.3060893,40.5714512 22.5631374,40.4219761 Z M33.0680484,40.439129 C33.3255865,40.2896539 33.7446068,40.2896539 34.0043503,40.439129 C34.2616434,40.5861537 34.2616434,40.8284993 34.0043503,40.9782194 C33.7446068,41.1274494 33.3255865,41.1274494 33.0680484,40.9782194 C32.8085499,40.8284993 32.8085499,40.5861537 33.0680484,40.439129 L33.0680484,40.439129 Z"
          id="Fill-2317"
          fill="#51A146"
        />
        <path
          d="M44.6513851,32.3209181 C44.6513851,31.4167165 45.3840579,30.6864941 46.2855641,30.6864941 C46.2855641,31.5880002 45.5555867,32.3209181 44.6513851,32.3209181"
          id="Fill-2318"
          fill="#51A146"
        />
        <path
          d="M44.6513851,32.3209181 C44.6513851,31.4167165 43.9211627,30.6864941 43.0169611,30.6864941 C43.0169611,31.5880002 43.749634,32.3209181 44.6513851,32.3209181"
          id="Fill-2319"
          fill="#51A146"
        />
        <path
          d="M13.1317513,34.1734287 C13.1317513,33.2716775 13.8619737,32.5387596 14.7661753,32.5387596 C14.7661753,33.4432062 14.0335025,34.1734287 13.1317513,34.1734287"
          id="Fill-2320"
          fill="#9ECB94"
        />
        <path
          d="M13.1317513,34.1734287 C13.1317513,33.2716775 12.3990785,32.5387596 11.4973274,32.5387596 C11.4973274,33.4432062 12.2275498,34.1734287 13.1317513,34.1734287"
          id="Fill-2321"
          fill="#9ECB94"
        />
        <path
          d="M61.2602694,24.3668847 C61.2602694,23.4651336 61.9904918,22.7322157 62.8946933,22.7322157 C62.8946933,23.6339669 62.1620205,24.3668847 61.2602694,24.3668847"
          id="Fill-2322"
          fill="#9ECB94"
        />
        <path
          d="M61.2602694,24.3668847 C61.2602694,23.4651336 60.5275965,22.7322157 59.6258454,22.7322157 C59.6258454,23.6339669 60.3560678,24.3668847 61.2602694,24.3668847"
          id="Fill-2323"
          fill="#9ECB94"
        />
        <path
          d="M29.1620936,25.0061969 C29.1620936,24.1044457 29.8950114,23.3717729 30.7965176,23.3717729 C30.7965176,24.2735241 30.0662952,25.0061969 29.1620936,25.0061969"
          id="Fill-2324"
          fill="#9ECB94"
        />
        <path
          d="M29.1620936,25.0061969 C29.1620936,24.1044457 28.4321162,23.3717729 27.5279146,23.3717729 C27.5279146,24.2735241 28.2603424,25.0061969 29.1620936,25.0061969"
          id="Fill-2325"
          fill="#9ECB94"
        />
        <path
          d="M31.3236009,35.8078526 C31.3236009,34.9061015 32.0538233,34.1734287 32.9580249,34.1734287 C32.9580249,35.0776302 32.2253521,35.8078526 31.3236009,35.8078526"
          id="Fill-2326"
          fill="#51A146"
        />
        <path
          d="M31.3236009,35.8078526 C31.3236009,34.9061015 30.5909281,34.1734287 29.6891769,34.1734287 C29.6891769,35.0776302 30.4193993,35.8078526 31.3236009,35.8078526"
          id="Fill-2327"
          fill="#51A146"
        />
        <path
          d="M42.5734368,21.9554355 C42.5734368,21.0539294 43.3036592,20.3212565 44.2078608,20.3212565 C44.2078608,21.2230077 43.475188,21.9554355 42.5734368,21.9554355"
          id="Fill-2328"
          fill="#51A146"
        />
        <path
          d="M42.5734368,21.9554355 C42.5734368,21.0539294 41.840764,20.3212565 40.9390128,20.3212565 C40.9390128,21.2230077 41.6714406,21.9554355 42.5734368,21.9554355"
          id="Fill-2329"
          fill="#51A146"
        />
        <path
          d="M50.174611,13.6142372 C50.174611,12.7100356 50.9048334,11.9798132 51.809035,11.9798132 C51.809035,12.8818094 51.0763622,13.6142372 50.174611,13.6142372"
          id="Fill-2330"
          fill="#51A146"
        />
        <path
          d="M50.174611,13.6142372 C50.174611,12.7100356 49.4419382,11.9798132 48.540187,11.9798132 C48.540187,12.8818094 49.2704094,13.6142372 50.174611,13.6142372"
          id="Fill-2331"
          fill="#51A146"
        />
        <path
          d="M55.2959695,19.4048029 C55.2959695,18.5006013 56.0286424,17.7701339 56.9328439,17.7701339 C56.9328439,18.6718851 56.2001711,19.4048029 55.2984199,19.4048029 L55.2959695,19.4048029"
          id="Fill-2332"
          fill="#51A146"
        />
        <path
          d="M55.2959695,19.4048029 C55.2959695,18.5006013 54.5657471,17.7701339 53.663996,17.7701339 C53.663996,18.6718851 54.3942184,19.4048029 55.2984199,19.4048029 L55.2959695,19.4048029"
          id="Fill-2333"
          fill="#51A146"
        />
        <path
          d="M41.4781032,34.8715507 C41.4781032,42.5364356 50.2530242,48.7506773 61.0737931,48.7506773 C71.8950521,48.7506773 80.6699731,42.5364356 80.6699731,34.8715507 C80.6699731,27.2069108 71.8950521,20.9926691 61.0737931,20.9926691 C50.2530242,20.9926691 41.4781032,27.2069108 41.4781032,34.8715507"
          id="Fill-2334"
          fill="#636463"
        />
        <path
          d="M41.2649046,35.6850871 C41.2526654,41.7697021 50.037388,48.909954 60.858402,48.909954 C71.6816213,48.909954 80.6650723,42.1517211 80.7092768,35.6850871 C80.7434854,30.6347905 71.6816213,26.5401541 60.858402,26.5401541 C50.037388,26.5401541 41.2747191,30.6347905 41.2649046,35.6850871"
          id="Fill-2335"
          fill="#2A90C3"
        />
      </g>
    </g>
  </svg>
)

export const step29Image2 = (
  <svg
    width="70px"
    height="70px"
    viewBox="0 0 128 128"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    aria-hidden="true"
  >
    <g
      id="5.climate/climate_3.1"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Group" transform="translate(0.000000, 6.400000)">
        <polyline
          id="Fill-2336"
          fill="#54A044"
          points="55.5116057 1.72018836 7.37428137e-14 33.9528917 69.9053186 74.316058 126.46815 42.8356307 55.5116057 1.72018836"
        />
        <polyline
          id="Fill-2337"
          fill="#75B86A"
          points="55.5116057 2.94971255e-13 7.37428137e-14 32.2327033 69.9053186 72.5961146 126.46815 41.1154424 55.5116057 2.94971255e-13"
        />
        <polyline
          id="Fill-2338"
          fill="#54A044"
          points="0.0318553401 32.2327033 1.51680427 33.0905921 0.0318553401 33.9528917 0.0318553401 32.2327033"
        />
        <polyline
          id="Fill-2339"
          fill="#54A044"
          points="126.46815 41.1154424 124.953552 41.9586287 126.46815 42.8356307 126.46815 41.1154424"
        />
        <path
          d="M84.0022867,49.1775389 C84.2598249,49.0280638 84.6812955,49.0280638 84.9385887,49.1775389 C85.1958818,49.3243185 85.1958818,49.5669091 84.9385887,49.7163842 C84.6812955,49.8661043 84.2598249,49.8661043 84.0022867,49.7163842 C83.7452386,49.5669091 83.7452386,49.3243185 84.0022867,49.1775389 Z M68.2953987,50.9124297 C68.5551422,50.7629546 68.9741625,50.7629546 69.2314556,50.9124297 C69.4911991,51.0592093 69.4911991,51.3018 69.2314556,51.4515201 C68.9741625,51.6009951 68.5551422,51.6009951 68.2953987,51.4515201 C68.0381056,51.3018 68.0381056,51.0592093 68.2953987,50.9124297 Z M90.6308929,41.4977065 C90.887941,41.3506818 91.3069612,41.3506818 91.5669498,41.4977065 C91.8242429,41.6471815 91.8242429,41.8900172 91.5669498,42.0392472 C91.3069612,42.1887223 90.887941,42.1887223 90.6308929,42.0392472 C90.3711493,41.8900172 90.3711493,41.6471815 90.6308929,41.4977065 Z M111.123433,40.289899 C111.383422,40.1404239 111.802442,40.1404239 112.059735,40.289899 C112.319479,40.439129 112.319479,40.6817197 112.059735,40.8287443 C111.802442,40.9782194 111.383422,40.9782194 111.123433,40.8287443 C110.866385,40.6817197 110.866385,40.439129 111.123433,40.289899 Z M107.43826,35.4135815 C107.697759,35.2641065 108.117024,35.2641065 108.374317,35.4135815 C108.633816,35.5628116 108.633816,35.8054022 108.374317,35.9548773 C108.117024,36.1043523 107.697759,36.1043523 107.43826,35.9548773 C107.180967,35.8054022 107.180967,35.5628116 107.43826,35.4135815 Z M100.229152,28.9663058 C100.488895,28.8168307 100.907916,28.8168307 101.164964,28.9663058 C101.424952,29.1157808 101.424952,29.3583715 101.164964,29.5078465 C100.907916,29.6573216 100.488895,29.6573216 100.229152,29.5078465 C99.9718588,29.3583715 99.9718588,29.1157808 100.229152,28.9663058 Z M80.1970438,39.9419407 C80.4543369,39.7922206 80.8733572,39.7922206 81.1328557,39.9419407 C81.3903939,40.0911707 81.3903939,40.3337613 81.1328557,40.4832364 C80.8733572,40.6327115 80.4543369,40.6327115 80.1970438,40.4832364 C79.9373003,40.3337613 79.9373003,40.0911707 80.1970438,39.9419407 Z M86.9601776,35.4135815 C87.2174707,35.2641065 87.6389413,35.2641065 87.8959894,35.4135815 C88.1535276,35.5628116 88.1535276,35.8054022 87.8959894,35.9548773 C87.6389413,36.1043523 87.2174707,36.1043523 86.9601776,35.9548773 C86.7028844,35.8054022 86.7028844,35.5628116 86.9601776,35.4135815 Z M99.567541,37.2364421 C99.8270395,37.0869671 100.24606,37.0869671 100.503598,37.2364421 C100.760646,37.3859172 100.760646,37.6285078 100.503598,37.7779829 C100.24606,37.9250076 99.8270395,37.9250076 99.567541,37.7779829 C99.3102479,37.6285078 99.3102479,37.3859172 99.567541,37.2364421 Z M72.5956246,53.730157 C72.8556131,53.5831324 73.2746334,53.5831324 73.5316815,53.730157 C73.7916701,53.8796321 73.7916701,54.1224678 73.5316815,54.2719429 C73.2746334,54.4211729 72.8556131,54.4211729 72.5956246,54.2719429 C72.3385765,54.1224678 72.3385765,53.8796321 72.5956246,53.730157 Z M109.346885,43.5756548 C109.604424,43.4264248 110.023444,43.4264248 110.282942,43.5756548 C110.54048,43.7251299 110.54048,43.9655152 110.282942,44.1147452 C110.023444,44.2644653 109.604424,44.2644653 109.346885,44.1147452 C109.089837,43.9655152 109.089837,43.7251299 109.346885,43.5756548 Z M73.4140618,44.8158077 C73.6715999,44.6660876 74.0906202,44.6660876 74.3503637,44.8158077 C74.6076568,44.9652827 74.6076568,45.205178 74.3503637,45.354653 C74.0906202,45.5043731 73.6715999,45.5043731 73.4140618,45.354653 C73.1545633,45.205178 73.1545633,44.9652827 73.4140618,44.8158077 Z M58.3440355,54.1124211 C58.6040241,53.9631911 59.0230443,53.9631911 59.2803374,54.1124211 C59.540081,54.2618962 59.540081,54.5047319 59.2803374,54.6539619 C59.0230443,54.803437 58.6040241,54.803437 58.3440355,54.6539619 C58.0869874,54.5047319 58.0869874,54.2618962 58.3440355,54.1124211 Z M94.5074427,49.1775389 C94.7669412,49.0280638 95.1862065,49.0280638 95.4434997,49.1775389 C95.7007928,49.3267689 95.7007928,49.5669091 95.4434997,49.7163842 C95.1862065,49.8661043 94.7669412,49.8661043 94.5074427,49.7163842 C94.2501496,49.5669091 94.2501496,49.3267689 94.5074427,49.1775389 Z M96.7275149,50.1479015 C96.984563,49.9984265 97.4038283,49.9984265 97.6635718,50.1479015 C97.9208649,50.2973766 97.9208649,50.5397222 97.6635718,50.6867469 C97.4038283,50.8362219 96.984563,50.8362219 96.7275149,50.6867469 C96.4675263,50.5397222 96.4675263,50.2973766 96.7275149,50.1479015 Z M81.1821089,56.587581 C81.4394021,56.4378609 81.8584223,56.4378609 82.1179208,56.587581 C82.375459,56.7368111 82.375459,56.9794017 82.1179208,57.1291218 C81.8584223,57.2785969 81.4394021,57.2785969 81.1821089,57.1291218 C80.9223654,56.9794017 80.9223654,56.7368111 81.1821089,56.587581 Z M61.3778891,57.1068231 C61.6376326,56.957348 62.0566529,56.957348 62.313946,57.1068231 C62.5736895,57.2538477 62.5736895,57.4966834 62.313946,57.6461585 C62.0566529,57.7953885 61.6376326,57.7953885 61.3778891,57.6461585 C61.1205959,57.4966834 61.1205959,57.2538477 61.3778891,57.1068231 Z M63.2500029,60.3928239 C63.5097464,60.2433489 63.9287667,60.2433489 64.1860598,60.3928239 C64.4458034,60.542299 64.4458034,60.7848897 64.1860598,60.9321594 C63.9287667,61.0813894 63.5097464,61.0813894 63.2500029,60.9321594 C62.9927098,60.7848897 62.9927098,60.542299 63.2500029,60.3928239 Z M81.1821089,60.9370602 C81.4394021,60.7873401 81.8584223,60.7873401 82.1179208,60.9370602 C82.375459,61.0862902 82.375459,61.3288809 82.1179208,61.4783559 C81.8584223,61.627831 81.4394021,61.627831 81.1821089,61.4783559 C80.9223654,61.3288809 80.9223654,61.0862902 81.1821089,60.9370602 L81.1821089,60.9370602 Z"
          id="Fill-2340"
          fill="#9ECB94"
        />
        <path
          d="M62.0395,48.2485881 C62.2989985,48.0991131 62.7180187,48.0991131 62.9755569,48.2485881 C63.2350554,48.3958578 63.2350554,48.6384485 62.9755569,48.7876785 C62.7180187,48.9371536 62.2989985,48.9371536 62.0395,48.7876785 C61.7822068,48.6384485 61.7822068,48.3958578 62.0395,48.2485881 Z M74.2300485,42.2624797 C74.4900371,42.1127596 74.9090574,42.1127596 75.1663505,42.2624797 C75.426094,42.4119547 75.426094,42.6543003 75.1663505,42.8040204 C74.9090574,42.9532505 74.4900371,42.9532505 74.2300485,42.8040204 C73.9730004,42.6543003 73.9730004,42.4119547 74.2300485,42.2624797 Z M81.8437199,42.6444987 C82.101013,42.4952687 82.5197882,42.4952687 82.7797768,42.6444987 C83.0368249,42.7942188 83.0368249,43.0365644 82.7797768,43.1862845 C82.5197882,43.3355145 82.101013,43.3355145 81.8437199,43.1862845 C81.5839763,43.0365644 81.5839763,42.7942188 81.8437199,42.6444987 Z M85.107667,38.5743664 C85.3674105,38.4248913 85.7864308,38.4248913 86.0434789,38.5743664 C86.3034675,38.7238415 86.3034675,38.9666772 86.0434789,39.1159072 C85.7864308,39.2629318 85.3674105,39.2629318 85.107667,39.1159072 C84.8503739,38.9666772 84.8503739,38.7238415 85.107667,38.5743664 Z M98.6143312,34.2226819 C98.8740747,34.0729618 99.293095,34.0729618 99.5503881,34.2226819 C99.8101317,34.372157 99.8101317,34.6147476 99.5503881,34.7639777 C99.293095,34.9112473 98.8740747,34.9112473 98.6143312,34.7639777 C98.356793,34.6147476 98.356793,34.372157 98.6143312,34.2226819 Z M65.7837276,49.1775389 C66.0434712,49.0280638 66.4624914,49.0280638 66.7197846,49.1775389 C66.9795281,49.3243185 66.9795281,49.5669091 66.7197846,49.7163842 C66.4624914,49.8661043 66.0434712,49.8661043 65.7837276,49.7163842 C65.5261895,49.5669091 65.5261895,49.3243185 65.7837276,49.1775389 Z M113.750519,38.8784624 C114.007812,38.7287423 114.426587,38.7287423 114.686575,38.8784624 C114.943624,39.025487 114.943624,39.2680777 114.686575,39.4173077 C114.426587,39.5670278 114.007812,39.5670278 113.750519,39.4173077 C113.49298,39.2680777 113.49298,39.025487 113.750519,38.8784624 Z M115.524616,39.9419407 C115.784114,39.7922206 116.20338,39.7922206 116.460673,39.9419407 C116.720171,40.0911707 116.720171,40.3337613 116.460673,40.4832364 C116.20338,40.6327115 115.784114,40.6327115 115.524616,40.4832364 C115.267323,40.3337613 115.267323,40.0911707 115.524616,39.9419407 Z M69.6186205,44.0512795 C69.878364,43.9018045 70.2973843,43.9018045 70.5544324,44.0512795 C70.814421,44.2005095 70.814421,44.4431002 70.5544324,44.5903699 C70.2973843,44.7395999 69.878364,44.7395999 69.6186205,44.5903699 C69.3613274,44.4431002 69.3613274,44.2005095 69.6186205,44.0512795 Z M94.5074427,29.731079 C94.7669412,29.5816039 95.1862065,29.5816039 95.4434997,29.731079 C95.7007928,29.880554 95.7007928,30.1231447 95.4434997,30.2723747 C95.1862065,30.4193993 94.7669412,30.4193993 94.5074427,30.2723747 C94.2501496,30.1231447 94.2501496,29.880554 94.5074427,29.731079 Z M88.376515,44.8158077 C88.6360135,44.6660876 89.0552788,44.6660876 89.3125719,44.8158077 C89.5723154,44.9652827 89.5723154,45.205178 89.3125719,45.354653 C89.0552788,45.5043731 88.6360135,45.5043731 88.376515,45.354653 C88.1192218,45.205178 88.1192218,44.9652827 88.376515,44.8158077 Z M76.690261,50.1479015 C76.9477991,49.9984265 77.3668194,49.9984265 77.6265629,50.1479015 C77.883856,50.2973766 77.883856,50.5375168 77.6265629,50.6867469 C77.3668194,50.8362219 76.9477991,50.8362219 76.690261,50.6867469 C76.4332129,50.5375168 76.4332129,50.2973766 76.690261,50.1479015 Z M87.9670513,52.0467248 C88.2270399,51.8997002 88.6460602,51.8997002 88.9031083,52.0467248 C89.1606464,52.1964449 89.1606464,52.4390356 88.9031083,52.5882656 C88.6460602,52.7379857 88.2270399,52.7379857 87.9670513,52.5882656 C87.7100032,52.4390356 87.7100032,52.1964449 87.9670513,52.0467248 Z M94.3136152,53.5145209 C94.5736038,53.3650458 94.9926241,53.3650458 95.2499172,53.5145209 C95.5072103,53.663996 95.5072103,53.9068317 95.2499172,54.0563067 C94.9926241,54.2033314 94.5736038,54.2033314 94.3136152,54.0563067 C94.0565672,53.9068317 94.0565672,53.663996 94.3136152,53.5145209 Z M52.1153363,53.730157 C52.3748348,53.5831324 52.7938551,53.5831324 53.0513933,53.730157 C53.3086864,53.8796321 53.3086864,54.1224678 53.0513933,54.2719429 C52.7938551,54.4211729 52.3748348,54.4211729 52.1153363,54.2719429 C51.8580432,54.1224678 51.8580432,53.8796321 52.1153363,53.730157 Z M49.8413551,54.7056656 C50.0986483,54.5586409 50.5176685,54.5586409 50.777167,54.7056656 C51.0347052,54.8548956 51.0347052,55.0974863 50.777167,55.2469613 C50.5176685,55.3964364 50.0986483,55.3964364 49.8413551,55.2469613 C49.5816116,55.0974863 49.5816116,54.8548956 49.8413551,54.7056656 Z M67.283134,56.1830182 C67.5406722,56.0335432 67.9596924,56.0335432 68.219436,56.1830182 C68.4767291,56.3324933 68.4767291,56.5726335 68.219436,56.7221086 C67.9596924,56.8715837 67.5406722,56.8715837 67.283134,56.7221086 C67.0260859,56.5726335 67.0260859,56.3324933 67.283134,56.1830182 Z M68.9570096,63.9608671 C69.2165081,63.8138424 69.6355283,63.8138424 69.8930665,63.9608671 C70.152565,64.1100971 70.152565,64.3526877 69.8930665,64.5021628 C69.6355283,64.6516379 69.2165081,64.6516379 68.9570096,64.5021628 C68.6997165,64.3526877 68.6997165,64.1100971 68.9570096,63.9608671 Z M65.1221167,64.7521047 C65.3818603,64.6026296 65.8008805,64.6026296 66.0579286,64.7521047 C66.3179172,64.9015798 66.3179172,65.14172 66.0579286,65.2914401 C65.8008805,65.4406701 65.3818603,65.4406701 65.1221167,65.2914401 C64.8648236,65.14172 64.8648236,64.9015798 65.1221167,64.7521047 Z M75.6270277,64.7670522 C75.8840758,64.6175772 76.3057915,64.6175772 76.5630846,64.7670522 C76.8203778,64.9165273 76.8203778,65.1591179 76.5630846,65.3061426 C76.3057915,65.4553726 75.8840758,65.4553726 75.6270277,65.3061426 C75.3672842,65.1591179 75.3672842,64.9165273 75.6270277,64.7670522 L75.6270277,64.7670522 Z"
          id="Fill-2341"
          fill="#51A146"
        />
        <path
          d="M87.2101195,56.6488413 C87.2101195,55.7470902 87.9427923,55.0144173 88.8445434,55.0144173 C88.8445434,55.9186189 88.114321,56.6488413 87.2101195,56.6488413"
          id="Fill-2342"
          fill="#51A146"
        />
        <path
          d="M87.2101195,56.6488413 C87.2101195,55.7470902 86.479897,55.0144173 85.5756955,55.0144173 C85.5756955,55.9186189 86.3081232,56.6488413 87.2101195,56.6488413"
          id="Fill-2343"
          fill="#51A146"
        />
        <path
          d="M55.6904857,58.5035572 C55.6904857,57.5996007 56.4207081,56.8691332 57.3249096,56.8691332 C57.3249096,57.7711295 56.5922368,58.5035572 55.6904857,58.5035572 L55.6904857,58.5013519 L55.6904857,58.5035572"
          id="Fill-2344"
          fill="#9ECB94"
        />
        <path
          d="M55.6904857,58.5035572 C55.6904857,57.5996007 54.9578128,56.8691332 54.0560617,56.8691332 C54.0560617,57.7711295 54.786039,58.5035572 55.6904857,58.5035572 L55.6904857,58.5013519 L55.6904857,58.5035572"
          id="Fill-2345"
          fill="#9ECB94"
        />
        <path
          d="M103.818759,48.6948079 C103.818759,47.7930568 104.549226,47.0601389 105.453428,47.0601389 C105.453428,47.9645855 104.720755,48.6948079 103.818759,48.6948079"
          id="Fill-2346"
          fill="#9ECB94"
        />
        <path
          d="M103.818759,48.6948079 C103.818759,47.7930568 103.086331,47.0601389 102.184335,47.0601389 C102.184335,47.9645855 102.914557,48.6948079 103.818759,48.6948079"
          id="Fill-2347"
          fill="#9ECB94"
        />
        <path
          d="M71.7210729,49.3341201 C71.7210729,48.432369 72.4537458,47.6999412 73.3554969,47.6999412 C73.3554969,48.6038977 72.6252745,49.3341201 71.7210729,49.3341201"
          id="Fill-2348"
          fill="#9ECB94"
        />
        <path
          d="M71.7210729,49.3341201 C71.7210729,48.432369 70.9908505,47.6999412 70.086649,47.6999412 C70.086649,48.6038977 70.8193218,49.3341201 71.7210729,49.3341201"
          id="Fill-2349"
          fill="#9ECB94"
        />
        <path
          d="M73.8820902,60.1357758 C73.8820902,59.2340247 74.6123126,58.5035572 75.5165142,58.5035572 C75.5165142,59.4055534 74.7840864,60.1382263 73.8820902,60.1382263 L73.8820902,60.1357758"
          id="Fill-2350"
          fill="#51A146"
        />
        <path
          d="M73.8820902,60.1357758 C73.8820902,59.2340247 73.1496624,58.5035572 72.2479113,58.5035572 C72.2479113,59.4055534 72.9781337,60.1382263 73.8820902,60.1382263 L73.8820902,60.1357758"
          id="Fill-2351"
          fill="#51A146"
        />
        <path
          d="M85.1321711,46.2833587 C85.1321711,45.3818526 85.8648439,44.6491798 86.7665951,44.6491798 C86.7665951,45.5533813 86.0339223,46.2833587 85.1321711,46.2833587"
          id="Fill-2352"
          fill="#51A146"
        />
        <path
          d="M85.1321711,46.2833587 C85.1321711,45.3818526 84.3994983,44.6491798 83.4977471,44.6491798 C83.4977471,45.5533813 84.2304199,46.2833587 85.1321711,46.2833587"
          id="Fill-2353"
          fill="#51A146"
        />
        <path
          d="M92.7333453,37.9421604 C92.7333453,37.0379589 93.4635677,36.3077364 94.3677693,36.3077364 C94.3677693,37.2094876 93.6350965,37.9421604 92.7333453,37.9421604"
          id="Fill-2354"
          fill="#51A146"
        />
        <path
          d="M92.7333453,37.9421604 C92.7333453,37.0379589 92.0006725,36.3077364 91.0989213,36.3077364 C91.0989213,37.2094876 91.8291438,37.9421604 92.7333453,37.9421604"
          id="Fill-2355"
          fill="#51A146"
        />
        <path
          d="M97.8569092,43.7327261 C97.8569092,42.830975 98.5871316,42.0980571 99.4915783,42.0980571 C99.4915783,42.9998083 98.7589054,43.7327261 97.8569092,43.7327261"
          id="Fill-2356"
          fill="#51A146"
        />
        <path
          d="M97.8569092,43.7327261 C97.8569092,42.830975 97.1244814,42.0980571 96.2227303,42.0980571 C96.2227303,42.9998083 96.9527076,43.7327261 97.8569092,43.7327261"
          id="Fill-2357"
          fill="#51A146"
        />
        <path
          d="M59.6648069,35.9916335 C59.9223451,35.8424034 60.3438157,35.8424034 60.6008638,35.9916335 C60.858402,36.1413535 60.858402,36.3836992 60.6008638,36.5309689 C60.3438157,36.6804439 59.9223451,36.6804439 59.6648069,36.5309689 C59.4077588,36.3836992 59.4077588,36.1413535 59.6648069,35.9916335 Z M43.9576738,37.7265243 C44.2176624,37.5770492 44.6366827,37.5770492 44.8939758,37.7265243 C45.1537193,37.8759993 45.1537193,38.1161396 44.8939758,38.2658597 C44.6366827,38.4153347 44.2176624,38.4153347 43.9576738,38.2658597 C43.7006257,38.1161396 43.7006257,37.8759993 43.9576738,37.7265243 Z M66.293168,28.3144965 C66.5507062,28.1650214 66.9697265,28.1650214 67.22947,28.3144965 C67.4867631,28.4642166 67.4867631,28.7041118 67.22947,28.8535869 C66.9697265,29.0030619 66.5507062,29.0030619 66.293168,28.8535869 C66.0336695,28.7041118 66.0336695,28.4642166 66.293168,28.3144965 Z M86.7886488,27.1039936 C87.0459419,26.9547636 87.4649622,26.9547636 87.7222553,27.1039936 C87.9819988,27.2537137 87.9819988,27.4960593 87.7222553,27.6455344 C87.4649622,27.7952545 87.0459419,27.7952545 86.7886488,27.6455344 C86.5286602,27.4960593 86.5286602,27.2537137 86.7886488,27.1039936 Z M83.1007806,22.2279212 C83.3605241,22.0806515 83.7795444,22.0806515 84.0365925,22.2279212 C84.296581,22.3771512 84.296581,22.6197419 84.0365925,22.7692169 C83.7795444,22.918692 83.3605241,22.918692 83.1007806,22.7692169 C82.8434875,22.6197419 82.8434875,22.3771512 83.1007806,22.2279212 Z M75.8916721,15.7833408 C76.1514156,15.6336207 76.5704359,15.6336207 76.827729,15.7833408 C77.0847771,15.9303655 77.0847771,16.1727111 76.827729,16.3221862 C76.5704359,16.4719063 76.1514156,16.4719063 75.8916721,16.3221862 C75.6341339,16.1727111 75.6341339,15.9303655 75.8916721,15.7833408 Z M55.859564,26.7587307 C56.1168571,26.6090106 56.5356323,26.6090106 56.7956209,26.7587307 C57.052669,26.9055103 57.052669,27.148101 56.7956209,27.297576 C56.5356323,27.4472961 56.1168571,27.4472961 55.859564,27.297576 C55.5998205,27.148101 55.5998205,26.9055103 55.859564,26.7587307 Z M62.6224527,22.2279212 C62.8799909,22.0806515 63.3012165,22.0806515 63.5587547,22.2279212 C63.8160478,22.3771512 63.8160478,22.6197419 63.5587547,22.7692169 C63.3012165,22.918692 62.8799909,22.918692 62.6224527,22.7692169 C62.3654046,22.6197419 62.3654046,22.3771512 62.6224527,22.2279212 Z M75.2300612,24.0510268 C75.4898047,23.9015517 75.908825,23.9015517 76.1658731,24.0510268 C76.4234112,24.2005018 76.4234112,24.4428475 76.1658731,24.5923225 C75.908825,24.7420426 75.4898047,24.7420426 75.2300612,24.5923225 C74.972768,24.4428475 74.972768,24.2005018 75.2300612,24.0510268 Z M48.2583898,40.5471921 C48.5181333,40.397472 48.9371536,40.397472 49.1944467,40.5471921 C49.4541902,40.6964221 49.4541902,40.9365624 49.1944467,41.0860374 C48.9371536,41.2355125 48.5181333,41.2355125 48.2583898,41.0860374 C48.0008516,40.9365624 48.0008516,40.6964221 48.2583898,40.5471921 Z M85.0096506,30.3899944 C85.2669437,30.2407644 85.6859639,30.2407644 85.9454625,30.3899944 C86.2030006,30.5394695 86.2030006,30.7823052 85.9454625,30.9317802 C85.6859639,31.0785598 85.2669437,31.0785598 85.0096506,30.9317802 C84.7523574,30.7823052 84.7523574,30.5394695 85.0096506,30.3899944 Z M49.076827,31.6299023 C49.3338751,31.4806723 49.7528953,31.4806723 50.0128839,31.6299023 C50.270177,31.7793773 50.270177,32.0197626 50.0128839,32.1689926 C49.7528953,32.3187127 49.3338751,32.3187127 49.076827,32.1689926 C48.8168384,32.0197626 48.8168384,31.7793773 49.076827,31.6299023 Z M34.0068007,40.9270058 C34.2665443,40.7797361 34.6855645,40.7797361 34.9428576,40.9270058 C35.2023561,41.0762358 35.2023561,41.3188265 34.9428576,41.4683015 C34.6855645,41.6177766 34.2665443,41.6177766 34.0068007,41.4683015 C33.7495076,41.3188265 33.7495076,41.0762358 34.0068007,40.9270058 Z M70.1699629,35.9916335 C70.4272561,35.8424034 70.8487267,35.8424034 71.1057748,35.9916335 C71.363313,36.1413535 71.363313,36.3814938 71.1057748,36.5309689 C70.8487267,36.6804439 70.4272561,36.6804439 70.1699629,36.5309689 C69.9126698,36.3814938 69.9126698,36.1413535 70.1699629,35.9916335 Z M72.3900351,36.9619961 C72.6470832,36.8127661 73.0663485,36.8127661 73.325847,36.9619961 C73.5833851,37.1117162 73.5833851,37.3540618 73.325847,37.5013315 C73.0663485,37.6508066 72.6470832,37.6508066 72.3900351,37.5013315 C72.1302915,37.3540618 72.1302915,37.1117162 72.3900351,36.9619961 Z M56.8446291,43.4016756 C57.1019223,43.254651 57.5206975,43.254651 57.7806861,43.4016756 C58.0379792,43.5511507 58.0379792,43.7939864 57.7806861,43.9432164 C57.5206975,44.0926915 57.1019223,44.0926915 56.8446291,43.9432164 C56.5848856,43.7939864 56.5848856,43.5511507 56.8446291,43.4016756 Z M37.0401642,43.9214078 C37.3001528,43.7716877 37.719173,43.7716877 37.9764662,43.9214078 C38.2362097,44.0706378 38.2362097,44.310778 37.9764662,44.4602531 C37.719173,44.6097281 37.3001528,44.6097281 37.0401642,44.4602531 C36.7831161,44.310778 36.7831161,44.0706378 37.0401642,43.9214078 Z M38.9125231,47.2074086 C39.1722666,47.0579335 39.5912869,47.0579335 39.848335,47.2074086 C40.1083236,47.3568837 40.1083236,47.5992293 39.848335,47.7487043 C39.5912869,47.895729 39.1722666,47.895729 38.9125231,47.7487043 C38.65523,47.5992293 38.65523,47.3568837 38.9125231,47.2074086 Z M56.8446291,47.7511548 C57.1019223,47.6043751 57.5206975,47.6043751 57.7806861,47.7511548 C58.0379792,47.9006298 58.0379792,48.1434655 57.7806861,48.2929406 C57.5206975,48.4424156 57.1019223,48.4424156 56.8446291,48.2929406 C56.5848856,48.1434655 56.5848856,47.9006298 56.8446291,47.7511548 L56.8446291,47.7511548 Z"
          id="Fill-2358"
          fill="#9ECB94"
        />
        <path
          d="M37.7020202,35.0629278 C37.9617637,34.9134527 38.380784,34.9134527 38.6380771,35.0629278 C38.8975756,35.2126479 38.8975756,35.4549935 38.6380771,35.6020181 C38.380784,35.7514932 37.9617637,35.7514932 37.7020202,35.6020181 C37.444482,35.4549935 37.444482,35.2126479 37.7020202,35.0629278 Z M49.8928138,29.0768193 C50.1525573,28.9297946 50.5715776,28.9297946 50.8288707,29.0768193 C51.0883692,29.2262943 51.0883692,29.468885 50.8288707,29.618115 C50.5715776,29.7675901 50.1525573,29.7675901 49.8928138,29.618115 C49.6352756,29.468885 49.6352756,29.2262943 49.8928138,29.0768193 Z M57.505995,29.4590834 C57.7635332,29.3120587 58.1825534,29.3120587 58.442297,29.4590834 C58.6995901,29.6083134 58.6995901,29.8509041 58.442297,30.0006241 C58.1825534,30.1500992 57.7635332,30.1500992 57.505995,30.0006241 C57.2464965,29.8509041 57.2464965,29.6083134 57.505995,29.4590834 Z M60.7701872,25.388706 C61.0296857,25.239476 61.448951,25.239476 61.7062441,25.388706 C61.9659877,25.5384261 61.9659877,25.7807718 61.7062441,25.9302468 C61.448951,26.0799669 61.0296857,26.0799669 60.7701872,25.9302468 C60.512649,25.7807718 60.512649,25.5384261 60.7701872,25.388706 Z M74.2768514,21.0367765 C74.5365949,20.8875465 74.9556152,20.8875465 75.2129083,21.0367765 C75.4726518,21.1862516 75.4726518,21.4290873 75.2129083,21.5785623 C74.9556152,21.7280374 74.5365949,21.7280374 74.2768514,21.5785623 C74.0195583,21.4290873 74.0195583,21.1862516 74.2768514,21.0367765 Z M41.4462478,35.9916335 C41.7059914,35.8424034 42.1250116,35.8424034 42.3823047,35.9916335 C42.6420483,36.1413535 42.6420483,36.3836992 42.3823047,36.5309689 C42.1250116,36.6804439 41.7059914,36.6804439 41.4462478,36.5309689 C41.1889547,36.3836992 41.1889547,36.1413535 41.4462478,35.9916335 Z M89.4130387,25.692557 C89.6703319,25.543327 90.0918025,25.543327 90.3490957,25.692557 C90.6061437,25.842032 90.6061437,26.0848677 90.3490957,26.2316473 C90.0918025,26.3813674 89.6703319,26.3813674 89.4130387,26.2316473 C89.1530502,26.0848677 89.1530502,25.842032 89.4130387,25.692557 Z M91.1871361,26.7587307 C91.4468797,26.6090106 91.8658999,26.6090106 92.122948,26.7587307 C92.3829366,26.9055103 92.3829366,27.148101 92.122948,27.297576 C91.8658999,27.4472961 91.4468797,27.4472961 91.1871361,27.297576 C90.929843,27.148101 90.929843,26.9055103 91.1871361,26.7587307 Z M45.2811407,30.8656192 C45.5408842,30.7161441 45.9596594,30.7161441 46.2171976,30.8656192 C46.4769412,31.0148492 46.4769412,31.2574398 46.2171976,31.4069149 C45.9596594,31.5541846 45.5408842,31.5541846 45.2811407,31.4069149 C45.0236025,31.2574398 45.0236025,31.0148492 45.2811407,30.8656192 Z M70.1699629,16.5454186 C70.4297065,16.3983939 70.8487267,16.3983939 71.1057748,16.5454186 C71.363313,16.6946486 71.363313,16.9372393 71.1057748,17.0867143 C70.8487267,17.2361894 70.4297065,17.2361894 70.1699629,17.0867143 C69.9126698,16.9372393 69.9126698,16.6946486 70.1699629,16.5454186 Z M64.0390352,31.6299023 C64.2987787,31.4806723 64.717799,31.4806723 64.974847,31.6299023 C65.2348356,31.7793773 65.2348356,32.0197626 64.974847,32.1689926 C64.717799,32.3187127 64.2987787,32.3187127 64.0390352,32.1689926 C63.781742,32.0197626 63.781742,31.7793773 64.0390352,31.6299023 Z M52.3530262,36.9619961 C52.6100743,36.8127661 53.0290945,36.8127661 53.2890831,36.9619961 C53.5463762,37.1117162 53.5463762,37.3540618 53.2890831,37.5013315 C53.0290945,37.6508066 52.6100743,37.6508066 52.3530262,37.5013315 C52.095488,37.3540618 52.095488,37.1117162 52.3530262,36.9619961 Z M63.6298166,38.8635149 C63.8895601,38.7142849 64.3085804,38.7142849 64.5658735,38.8635149 C64.825617,39.0107846 64.825617,39.2533752 64.5658735,39.4026052 C64.3085804,39.5523253 63.8895601,39.5523253 63.6298166,39.4026052 C63.3722784,39.2533752 63.3722784,39.0107846 63.6298166,38.8635149 Z M69.9763805,40.3288605 C70.2336736,40.1796305 70.6551443,40.1796305 70.9124374,40.3288605 C71.1697305,40.4783356 71.1697305,40.7211713 70.9124374,40.8704013 C70.6551443,41.0198764 70.2336736,41.0198764 69.9763805,40.8704013 C69.7190873,40.7211713 69.7190873,40.4783356 69.9763805,40.3288605 Z M27.7778565,40.5471921 C28.0349046,40.397472 28.4566203,40.397472 28.7139135,40.5471921 C28.9712066,40.6964221 28.9712066,40.9365624 28.7139135,41.0860374 C28.4566203,41.2355125 28.0349046,41.2355125 27.7778565,41.0860374 C27.5203184,40.9365624 27.5203184,40.6964221 27.7778565,40.5471921 Z M25.5038753,41.5224556 C25.7611685,41.3727355 26.1801887,41.3727355 26.4399323,41.5224556 C26.6969803,41.6692352 26.6969803,41.9120709 26.4399323,42.061546 C26.1801887,42.211021 25.7611685,42.211021 25.5038753,42.061546 C25.2441318,41.9120709 25.2441318,41.6692352 25.5038753,41.5224556 Z M42.9458992,42.9976029 C43.2029473,42.8478828 43.624663,42.8478828 43.8819561,42.9976029 C44.1392493,43.147078 44.1392493,43.3894236 43.8819561,43.5364482 C43.624663,43.6859233 43.2029473,43.6859233 42.9458992,43.5364482 C42.6886061,43.3894236 42.6886061,43.147078 42.9458992,42.9976029 Z M44.6195298,50.7749617 C44.8792733,50.627937 45.2982936,50.627937 45.5555867,50.7749617 C45.8150852,50.9244367 45.8150852,51.1672724 45.5555867,51.3167475 C45.2982936,51.4659775 44.8792733,51.4659775 44.6195298,51.3167475 C44.3622367,51.1672724 44.3622367,50.9244367 44.6195298,50.7749617 Z M40.7846369,51.5666894 C41.0443805,51.4172143 41.4634007,51.4172143 41.7204488,51.5666894 C41.9804374,51.7159194 41.9804374,51.9585101 41.7204488,52.1055347 C41.4634007,52.2552548 41.0443805,52.2552548 40.7846369,52.1055347 C40.5273438,51.9585101 40.5273438,51.7159194 40.7846369,51.5666894 Z M51.2893029,51.5813918 C51.546841,51.4319168 51.9658613,51.4319168 52.2256048,51.5813918 C52.482898,51.7306219 52.482898,51.9732125 52.2256048,52.1226876 C51.9658613,52.2699573 51.546841,52.2699573 51.2893029,52.1226876 C51.0322548,51.9732125 51.0322548,51.7306219 51.2893029,51.5813918 L51.2893029,51.5813918 Z"
          id="Fill-2359"
          fill="#51A146"
        />
        <path
          d="M62.8723946,43.4631809 C62.8723946,42.5614298 63.6053125,41.828757 64.5070636,41.828757 C64.5070636,42.7327135 63.7768412,43.4631809 62.8723946,43.4631809"
          id="Fill-2360"
          fill="#51A146"
        />
        <path
          d="M62.8723946,43.4631809 C62.8723946,42.5614298 62.1424172,41.828757 61.2382157,41.828757 C61.2382157,42.7327135 61.9708885,43.4631809 62.8723946,43.4631809"
          id="Fill-2361"
          fill="#51A146"
        />
        <path
          d="M31.3530059,45.3181419 C31.3530059,44.4139403 32.0832283,43.6837179 32.9874298,43.6837179 C32.9874298,44.5854691 32.254757,45.3181419 31.3530059,45.3181419"
          id="Fill-2362"
          fill="#9ECB94"
        />
        <path
          d="M31.3530059,45.3181419 C31.3530059,44.4139403 30.620333,43.6837179 29.7185819,43.6837179 C29.7185819,44.5854691 30.4488043,45.3181419 31.3530059,45.3181419"
          id="Fill-2363"
          fill="#9ECB94"
        />
        <path
          d="M79.4815239,35.5091476 C79.4815239,34.6073964 80.2117463,33.8747236 81.1159479,33.8747236 C81.1159479,34.7789252 80.383275,35.5091476 79.4815239,35.5091476"
          id="Fill-2364"
          fill="#9ECB94"
        />
        <path
          d="M79.4815239,35.5091476 C79.4815239,34.6073964 78.748851,33.8747236 77.8470999,33.8747236 C77.8470999,34.7789252 78.5773223,35.5091476 79.4815239,35.5091476"
          id="Fill-2365"
          fill="#9ECB94"
        />
        <path
          d="M47.3833481,36.1509102 C47.3833481,35.2467086 48.116266,34.5164862 49.0177721,34.5164862 C49.0177721,35.4182373 48.2875497,36.1509102 47.3833481,36.1509102 L47.3833481,36.1487048 L47.3833481,36.1509102"
          id="Fill-2366"
          fill="#9ECB94"
        />
        <path
          d="M47.3833481,36.1509102 C47.3833481,35.2467086 46.6533707,34.5164862 45.7491692,34.5164862 C45.7491692,35.4182373 46.481842,36.1509102 47.3833481,36.1509102 L47.3833481,36.1487048 L47.3833481,36.1509102"
          id="Fill-2367"
          fill="#9ECB94"
        />
        <path
          d="M49.5448554,46.9523208 C49.5448554,46.0481193 50.2750779,45.3181419 51.1792794,45.3181419 C51.1792794,46.2198931 50.4466066,46.9523208 49.5448554,46.9523208"
          id="Fill-2368"
          fill="#51A146"
        />
        <path
          d="M49.5448554,46.9523208 C49.5448554,46.0481193 48.8121826,45.3181419 47.9104315,45.3181419 C47.9104315,46.2198931 48.6406539,46.9523208 49.5448554,46.9523208"
          id="Fill-2369"
          fill="#51A146"
        />
        <path
          d="M60.7946913,33.1001487 C60.7946913,32.1959472 61.5273641,31.4659698 62.4291153,31.4659698 C62.4291153,32.3674759 61.6964425,33.1001487 60.7946913,33.1001487"
          id="Fill-2370"
          fill="#51A146"
        />
        <path
          d="M60.7946913,33.1001487 C60.7946913,32.1959472 60.0620185,31.4659698 59.1600223,31.4659698 C59.1600223,32.3674759 59.8929401,33.1001487 60.7946913,33.1001487"
          id="Fill-2371"
          fill="#51A146"
        />
        <path
          d="M68.3958655,24.7565001 C68.3958655,23.8547489 69.1260879,23.1220761 70.0302895,23.1220761 C70.0302895,24.0238272 69.2976167,24.7565001 68.3958655,24.7565001"
          id="Fill-2372"
          fill="#51A146"
        />
        <path
          d="M68.3958655,24.7565001 C68.3958655,23.8547489 67.6631927,23.1220761 66.7611965,23.1220761 C66.7611965,24.0238272 67.491664,24.7565001 68.3958655,24.7565001"
          id="Fill-2373"
          fill="#51A146"
        />
        <path
          d="M73.5196745,30.5470658 C73.5196745,29.6453146 74.2496518,28.9126418 75.1540984,28.9126418 C75.1540984,29.8168433 74.4214256,30.5470658 73.5196745,30.5470658"
          id="Fill-2374"
          fill="#51A146"
        />
        <path
          d="M73.5196745,30.5470658 C73.5196745,29.6453146 72.7870016,28.9126418 71.8852505,28.9126418 C71.8852505,29.8168433 72.6154729,30.5470658 73.5196745,30.5470658"
          id="Fill-2375"
          fill="#51A146"
        />
        <path
          d="M41.4437974,24.8471652 C41.7008455,24.6976902 42.1198658,24.6976902 42.3798543,24.8471652 C42.6371475,24.9968853 42.6371475,25.239476 42.3798543,25.3865007 C42.1198658,25.5359757 41.7008455,25.5359757 41.4437974,25.3865007 C41.1840539,25.239476 41.1840539,24.9968853 41.4437974,24.8471652 Z M25.7366644,26.5820561 C25.9937125,26.432581 26.4154281,26.432581 26.6727213,26.5820561 C26.9300144,26.7315311 26.9300144,26.9716714 26.6727213,27.1213915 C26.4154281,27.2706215 25.9937125,27.2706215 25.7366644,27.1213915 C25.4793712,26.9716714 25.4793712,26.7315311 25.7366644,26.5820561 Z M48.0721586,17.1700283 C48.3294517,17.0205532 48.7484719,17.0205532 49.00552,17.1700283 C49.2655086,17.317298 49.2655086,17.5598886 49.00552,17.7091187 C48.7484719,17.8585937 48.3294517,17.8585937 48.0721586,17.7091187 C47.812415,17.5598886 47.812415,17.317298 48.0721586,17.1700283 Z M68.5646988,15.9595254 C68.8246874,15.8102954 69.2437077,15.8102954 69.5010008,15.9595254 C69.7607443,16.1092455 69.7607443,16.3515911 69.5010008,16.5010662 C69.2437077,16.6507863 68.8246874,16.6507863 68.5646988,16.5010662 C68.3076507,16.3515911 68.3076507,16.1092455 68.5646988,15.9595254 Z M64.8795261,11.083453 C65.1390246,10.9339779 65.5580448,10.9339779 65.815583,11.083453 C66.0753265,11.232683 66.0753265,11.4752737 65.815583,11.6247487 C65.5580448,11.7742238 65.1390246,11.7742238 64.8795261,11.6247487 C64.6219879,11.4752737 64.6219879,11.232683 64.8795261,11.083453 Z M57.6704176,4.63642223 C57.9277107,4.48915254 58.3467309,4.48915254 58.6064745,4.63642223 C58.8635226,4.78565224 58.8635226,5.02824291 58.6064745,5.17771797 C58.3467309,5.32743806 57.9277107,5.32743806 57.6704176,5.17771797 C57.4131244,5.02824291 57.4131244,4.78565224 57.6704176,4.63642223 Z M37.6383095,15.6118121 C37.8956026,15.4645424 38.3146229,15.4645424 38.571916,15.6118121 C38.8314145,15.7610421 38.8314145,16.0036328 38.571916,16.1531078 C38.3146229,16.3025829 37.8956026,16.3025829 37.6383095,16.1531078 C37.3785659,16.0036328 37.3785659,15.7610421 37.6383095,15.6118121 Z M44.4014432,11.083453 C44.6587364,10.9339779 45.0777566,10.9339779 45.3375001,11.083453 C45.5947933,11.232683 45.5947933,11.4752737 45.3375001,11.6247487 C45.0777566,11.7742238 44.6587364,11.7742238 44.4014432,11.6247487 C44.1441501,11.4752737 44.1441501,11.232683 44.4014432,11.083453 Z M57.0088067,12.9065586 C57.2660998,12.7570835 57.6875704,12.7570835 57.9446185,12.9065586 C58.2021567,13.0557886 58.2021567,13.2983793 57.9446185,13.4478543 C57.6875704,13.5975744 57.2660998,13.5975744 57.0088067,13.4478543 C56.7515135,13.2983793 56.7515135,13.0557886 57.0088067,12.9065586 Z M30.0368902,29.4027239 C30.2968788,29.2530038 30.7158991,29.2530038 30.9731922,29.4027239 C31.2304853,29.5495035 31.2304853,29.7920942 30.9731922,29.9415692 C30.7158991,30.0910443 30.2968788,30.0910443 30.0368902,29.9415692 C29.7798421,29.7920942 29.7798421,29.5495035 30.0368902,29.4027239 Z M66.7883961,19.2455262 C67.0456892,19.0962962 67.4647094,19.0962962 67.724453,19.2455262 C67.9815011,19.3950013 67.9815011,19.637837 67.724453,19.7848616 C67.4647094,19.9340916 67.0456892,19.9340916 66.7883961,19.7848616 C66.5286525,19.637837 66.5286525,19.3950013 66.7883961,19.2455262 Z M30.8555725,20.4854341 C31.1126206,20.3362041 31.5318858,20.3362041 31.7913843,20.4854341 C32.0489225,20.6349091 32.0489225,20.8752944 31.7913843,21.0245244 C31.5318858,21.1742445 31.1126206,21.1742445 30.8555725,21.0245244 C30.5958289,20.8752944 30.5958289,20.6349091 30.8555725,20.4854341 Z M15.7855462,29.7825376 C16.0452897,29.6352679 16.46431,29.6352679 16.7216031,29.7825376 C16.9813467,29.9320126 16.9813467,30.1743583 16.7216031,30.3238333 C16.46431,30.4733084 16.0452897,30.4733084 15.7855462,30.3238333 C15.5282531,30.1743583 15.5282531,29.9320126 15.7855462,29.7825376 Z M51.9487084,24.8471652 C52.2060015,24.6976902 52.6250218,24.6976902 52.8847653,24.8471652 C53.1420585,24.9968853 53.1420585,25.2370256 52.8847653,25.3865007 C52.6250218,25.5359757 52.2060015,25.5359757 51.9487084,25.3865007 C51.6911702,25.2370256 51.6911702,24.9968853 51.9487084,24.8471652 Z M54.1685355,25.8175279 C54.4260737,25.6682979 54.8450939,25.6682979 55.102142,25.8175279 C55.3621306,25.967248 55.3621306,26.2095936 55.102142,26.3568633 C54.8450939,26.5063384 54.4260737,26.5063384 54.1685355,26.3568633 C53.909037,26.2095936 53.909037,25.967248 54.1685355,25.8175279 Z M38.6209242,32.2572074 C38.8806678,32.1077324 39.299688,32.1077324 39.5594315,32.2572074 C39.8164796,32.4069275 39.8164796,32.6495182 39.5594315,32.7987482 C39.299688,32.9482233 38.8806678,32.9482233 38.6209242,32.7987482 C38.363386,32.6495182 38.363386,32.4069275 38.6209242,32.2572074 Z M18.8191547,32.7769396 C19.0788983,32.6272195 19.4979185,32.6272195 19.7552117,32.7769396 C20.0125048,32.9261696 20.0125048,33.1663098 19.7552117,33.3157849 C19.4979185,33.4652599 19.0788983,33.4652599 18.8191547,33.3157849 C18.5618616,33.1663098 18.5618616,32.9261696 18.8191547,32.7769396 Z M20.6912686,36.0629404 C20.9510121,35.9134653 21.3700324,35.9134653 21.6273255,36.0629404 C21.887069,36.2121704 21.887069,36.4547611 21.6273255,36.6017857 C21.3700324,36.7512608 20.9510121,36.7512608 20.6912686,36.6017857 C20.4337304,36.4547611 20.4337304,36.2121704 20.6912686,36.0629404 Z M38.6209242,36.6066866 C38.8806678,36.4596619 39.299688,36.4596619 39.5594315,36.6066866 C39.8164796,36.7561616 39.8164796,36.9989973 39.5594315,37.1484724 C39.299688,37.2979474 38.8806678,37.2979474 38.6209242,37.1484724 C38.363386,36.9989973 38.363386,36.7561616 38.6209242,36.6066866 L38.6209242,36.6066866 Z"
          id="Fill-2376"
          fill="#9ECB94"
        />
        <path
          d="M19.4807657,23.9184596 C19.7405092,23.7692295 20.1595294,23.7692295 20.4168226,23.9184596 C20.6741157,24.0681797 20.6741157,24.3083199 20.4168226,24.4575499 C20.1595294,24.607025 19.7405092,24.607025 19.4807657,24.4575499 C19.2234725,24.3083199 19.2234725,24.0681797 19.4807657,23.9184596 Z M31.6715593,17.9323511 C31.9310578,17.7853264 32.350323,17.7853264 32.6076162,17.9323511 C32.8646643,18.0815811 32.8646643,18.3241718 32.6076162,18.4736468 C32.350323,18.6233669 31.9310578,18.6233669 31.6715593,18.4736468 C31.4142661,18.3241718 31.4142661,18.0815811 31.6715593,17.9323511 Z M39.2849855,18.3146152 C39.5422787,18.1648951 39.9610539,18.1648951 40.2210424,18.3146152 C40.4783356,18.4638452 40.4783356,18.7064358 40.2210424,18.8561559 C39.9610539,19.005631 39.5422787,19.005631 39.2849855,18.8561559 C39.025242,18.7064358 39.025242,18.4638452 39.2849855,18.3146152 Z M42.5489327,14.2442378 C42.8086762,14.0950078 43.2276965,14.0950078 43.4849896,14.2442378 C43.7447331,14.3939579 43.7447331,14.6363036 43.4849896,14.7857786 C43.2276965,14.9354987 42.8086762,14.9354987 42.5489327,14.7857786 C42.2916396,14.6363036 42.2916396,14.3939579 42.5489327,14.2442378 Z M56.0553518,9.8923083 C56.3153404,9.74307828 56.7343607,9.74307828 56.9914087,9.8923083 C57.2513973,10.0417834 57.2513973,10.2846191 56.9914087,10.4340941 C56.7343607,10.5835692 56.3153404,10.5835692 56.0553518,10.4340941 C55.7983037,10.2846191 55.7983037,10.0417834 56.0553518,9.8923083 Z M23.2249933,24.8471652 C23.4847369,24.6976902 23.9037571,24.6976902 24.1608052,24.8471652 C24.4207938,24.9968853 24.4207938,25.2370256 24.1608052,25.3865007 C23.9037571,25.5359757 23.4847369,25.5359757 23.2249933,25.3865007 C22.9677002,25.2370256 22.9677002,24.9968853 23.2249933,24.8471652 Z M71.1917842,14.5480888 C71.4490774,14.3988587 71.8680976,14.3988587 72.1275961,14.5480888 C72.3851343,14.6975638 72.3851343,14.9377041 72.1275961,15.0871791 C71.8680976,15.2368992 71.4490774,15.2368992 71.1917842,15.0871791 C70.9320407,14.9377041 70.9320407,14.6975638 71.1917842,14.5480888 Z M72.9658816,15.6118121 C73.2231748,15.4645424 73.6444004,15.4645424 73.9019385,15.6118121 C74.1592317,15.7610421 74.1592317,16.0036328 73.9019385,16.1531078 C73.6444004,16.3025829 73.2231748,16.3025829 72.9658816,16.1531078 C72.7083434,16.0036328 72.7083434,15.7610421 72.9658816,15.6118121 Z M27.0598862,19.721151 C27.3193847,19.5716759 27.73865,19.5716759 27.9959431,19.721151 C28.2532362,19.870381 28.2532362,20.1129716 27.9959431,20.2602413 C27.73865,20.4097164 27.3193847,20.4097164 27.0598862,20.2602413 C26.802593,20.1129716 26.802593,19.870381 27.0598862,19.721151 Z M51.9487084,5.40070535 C52.2060015,5.25147533 52.6250218,5.25147533 52.8847653,5.40070535 C53.1420585,5.5501804 53.1420585,5.79277107 52.8847653,5.94249117 C52.6250218,6.09172118 52.2060015,6.09172118 51.9487084,5.94249117 C51.6911702,5.79277107 51.6911702,5.5501804 51.9487084,5.40070535 Z M45.8177807,20.4854341 C46.0772792,20.3362041 46.4965444,20.3362041 46.7538376,20.4854341 C47.0135811,20.6349091 47.0135811,20.8752944 46.7538376,21.0245244 C46.4965444,21.1742445 46.0772792,21.1742445 45.8177807,21.0245244 C45.5602425,20.8752944 45.5602425,20.6349091 45.8177807,20.4854341 Z M34.1315266,25.8175279 C34.3890648,25.6682979 34.808085,25.6682979 35.0678286,25.8175279 C35.3251217,25.967248 35.3251217,26.2095936 35.0678286,26.3568633 C34.808085,26.5063384 34.3890648,26.5063384 34.1315266,26.3568633 C33.8720281,26.2095936 33.8720281,25.967248 34.1315266,25.8175279 Z M45.408317,27.7190467 C45.6658552,27.5698167 46.0848754,27.5698167 46.344619,27.7190467 C46.6019121,27.8663164 46.6019121,28.108907 46.344619,28.258137 C46.0848754,28.4078571 45.6658552,28.4078571 45.408317,28.258137 C45.1512689,28.108907 45.1512689,27.8663164 45.408317,27.7190467 Z M51.755126,29.1843923 C52.0121741,29.0351623 52.4311943,29.0351623 52.6911829,29.1843923 C52.948231,29.3338674 52.948231,29.5767031 52.6911829,29.7259331 C52.4311943,29.8754082 52.0121741,29.8754082 51.755126,29.7259331 C51.4978328,29.5767031 51.4978328,29.3338674 51.755126,29.1843923 Z M9.55660202,29.4027239 C9.81389515,29.2530038 10.2329154,29.2530038 10.4926589,29.4027239 C10.7499521,29.5495035 10.7499521,29.7920942 10.4926589,29.9415692 C10.2329154,30.0910443 9.81389515,30.0910443 9.55660202,29.9415692 C9.29930889,29.7920942 9.29930889,29.5495035 9.55660202,29.4027239 Z M7.28017041,30.375292 C7.53991395,30.2282673 7.95893419,30.2282673 8.21622733,30.375292 C8.47597087,30.524767 8.47597087,30.7676027 8.21622733,30.9170778 C7.95893419,31.0663078 7.53991395,31.0663078 7.28017041,30.9170778 C7.02287728,30.7676027 7.02287728,30.524767 7.28017041,30.375292 Z M24.7246447,31.8531347 C24.9819378,31.7034146 25.4009581,31.7034146 25.6604566,31.8531347 C25.9179948,32.0026098 25.9179948,32.2449554 25.6604566,32.39198 C25.4009581,32.5414551 24.9819378,32.5414551 24.7246447,32.39198 C24.4649012,32.2449554 24.4649012,32.0026098 24.7246447,31.8531347 Z M26.3982753,39.6304934 C26.6555684,39.4834688 27.0770391,39.4834688 27.3343322,39.6304934 C27.5940757,39.7799685 27.5940757,40.0228042 27.3343322,40.1722793 C27.0770391,40.3215093 26.6555684,40.3215093 26.3982753,40.1722793 C26.1409821,40.0228042 26.1409821,39.7799685 26.3982753,39.6304934 Z M22.5633824,40.4222212 C22.8206755,40.2727461 23.2419012,40.2727461 23.4994393,40.4222212 C23.7564874,40.5714512 23.7564874,40.8115914 23.4994393,40.9613115 C23.2419012,41.1107866 22.8206755,41.1107866 22.5633824,40.9613115 C22.3060893,40.8115914 22.3060893,40.5714512 22.5633824,40.4222212 Z M33.0682934,40.4369236 C33.3255865,40.2874486 33.7446068,40.2874486 34.0043503,40.4369236 C34.2616434,40.5861537 34.2616434,40.8287443 34.0043503,40.9782194 C33.7446068,41.1254891 33.3255865,41.1254891 33.0682934,40.9782194 C32.8085499,40.8287443 32.8085499,40.5861537 33.0682934,40.4369236 L33.0682934,40.4369236 Z"
          id="Fill-2377"
          fill="#51A146"
        />
        <path
          d="M44.6513851,32.3187127 C44.6513851,31.4169616 45.3840579,30.6842888 46.2858091,30.6842888 C46.2858091,31.5884903 45.5555867,32.3187127 44.6513851,32.3187127"
          id="Fill-2378"
          fill="#51A146"
        />
        <path
          d="M44.6513851,32.3187127 C44.6513851,31.4169616 43.9209177,30.6842888 43.0169611,30.6842888 C43.0169611,31.5884903 43.749634,32.3187127 44.6513851,32.3187127"
          id="Fill-2379"
          fill="#51A146"
        />
        <path
          d="M13.1317513,34.1736737 C13.1317513,33.2694721 13.8619737,32.5392497 14.7637249,32.5392497 L14.7661753,32.5392497 C14.7661753,33.4410009 14.0335025,34.1736737 13.1317513,34.1736737"
          id="Fill-2380"
          fill="#9ECB94"
        />
        <path
          d="M13.1317513,34.1736737 C13.1317513,33.2694721 12.3988335,32.5392497 11.4946319,32.5392497 C11.4946319,33.4410009 12.2275498,34.1736737 13.1293009,34.1736737 L13.1317513,34.1736737"
          id="Fill-2381"
          fill="#9ECB94"
        />
        <path
          d="M61.2602694,24.3646794 C61.2602694,23.4629282 61.9904918,22.7302554 62.8946933,22.7302554 C62.8946933,23.634457 62.1620205,24.3646794 61.2602694,24.3646794"
          id="Fill-2382"
          fill="#9ECB94"
        />
        <path
          d="M61.2602694,24.3646794 C61.2602694,23.4629282 60.5275965,22.7302554 59.6256003,22.7302554 C59.6256003,23.634457 60.3560678,24.3646794 61.2602694,24.3646794"
          id="Fill-2383"
          fill="#9ECB94"
        />
        <path
          d="M29.1623386,25.0042366 C29.1623386,24.1022404 29.8950114,23.3695676 30.7967626,23.3695676 C30.7967626,24.2737691 30.0665402,25.0042366 29.1623386,25.0042366"
          id="Fill-2384"
          fill="#9ECB94"
        />
        <path
          d="M29.1623386,25.0042366 C29.1623386,24.1022404 28.4321162,23.3695676 27.5279146,23.3695676 C27.5279146,24.2737691 28.2605875,25.0042366 29.1623386,25.0042366"
          id="Fill-2385"
          fill="#9ECB94"
        />
        <path
          d="M31.3233559,35.8054022 C31.3233559,34.9036511 32.0538233,34.1736737 32.9580249,34.1736737 C32.9580249,35.0754249 32.2253521,35.8078526 31.3233559,35.8078526 L31.3233559,35.8054022"
          id="Fill-2386"
          fill="#51A146"
        />
        <path
          d="M31.3233559,35.8054022 C31.3233559,34.9036511 30.5909281,34.1736737 29.6889319,34.1736737 C29.6889319,35.0754249 30.4193993,35.8078526 31.3211505,35.8078526 L31.3233559,35.8078526 L31.3233559,35.8054022"
          id="Fill-2387"
          fill="#51A146"
        />
        <path
          d="M42.5731917,21.9532301 C42.5731917,21.051724 43.3034142,20.3188061 44.2076157,20.3188061 L44.2076157,20.3215016 C44.2076157,21.2230077 43.475188,21.9532301 42.5731917,21.9532301"
          id="Fill-2388"
          fill="#51A146"
        />
        <path
          d="M42.5731917,21.9532301 C42.5731917,21.051724 41.840764,20.3188061 40.9390128,20.3188061 L40.9390128,20.3215016 C40.9390128,21.2230077 41.6692352,21.9532301 42.5731917,21.9532301"
          id="Fill-2389"
          fill="#51A146"
        />
        <path
          d="M50.174366,13.6120319 C50.174366,12.7102807 50.9045884,11.9776079 51.80879,11.9776079 C51.80879,12.879359 51.0763622,13.6120319 50.174366,13.6120319"
          id="Fill-2390"
          fill="#51A146"
        />
        <path
          d="M50.174366,13.6120319 C50.174366,12.7102807 49.4419382,11.9776079 48.540187,11.9776079 C48.540187,12.879359 49.2704094,13.6120319 50.174366,13.6120319"
          id="Fill-2391"
          fill="#51A146"
        />
        <path
          d="M55.2959695,19.4025976 C55.2959695,18.5008464 56.0286424,17.7681736 56.9303935,17.7681736 C56.9303935,18.6699247 56.2001711,19.4025976 55.2959695,19.4025976"
          id="Fill-2392"
          fill="#51A146"
        />
        <path
          d="M55.2959695,19.4025976 C55.2959695,18.5008464 54.5655021,17.7681736 53.6613005,17.7681736 C53.6613005,18.6699247 54.3942184,19.4025976 55.2959695,19.4025976"
          id="Fill-2393"
          fill="#51A146"
        />
      </g>
    </g>
  </svg>
)

export const step30Image1 = (
  <svg
    width="70px"
    height="70px"
    viewBox="0 0 128 128"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    aria-hidden="true"
  >
    <g
      id="5.climate/climate_4.2"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Group" transform="translate(0.000000, 11.200000)">
        <polyline
          id="Fill-2402"
          fill="#9E9F9E"
          points="56.1315596 30.7136937 2.94971255e-13 63.3066074 70.68945 104.1231 127.884488 72.2895682 56.1315596 30.7136937"
        />
        <polyline
          id="Fill-2403"
          fill="#B4B5B4"
          points="56.1315596 28.973657 2.94971255e-13 61.5665707 70.68945 102.383063 127.884488 70.5500216 56.1315596 28.973657"
        />
        <polyline
          id="Fill-2404"
          fill="#9E9F9E"
          points="0.0318553401 61.5665707 1.53395714 62.4340161 0.0318553401 63.3066074 0.0318553401 61.5665707"
        />
        <polyline
          id="Fill-2405"
          fill="#9E9F9E"
          points="127.884488 70.5500216 126.355432 71.4027646 127.884488 72.2895682 127.884488 70.5500216"
        />
        <polyline
          id="Fill-2480"
          fill="#777776"
          points="109.876174 68.136367 112.133247 69.412786 119.119369 65.4235173 116.837791 64.1198987 109.876174 68.136367"
        />
        <polyline
          id="Fill-2481"
          fill="#777776"
          points="14.8102827 62.1620205 17.0646606 63.4389296 24.0505367 59.4472104 21.7694493 58.1460423 14.8102827 62.1620205"
        />
        <polyline
          id="Fill-2482"
          fill="#777776"
          points="56.5530303 86.1147858 58.8098586 87.3916949 65.7959797 83.4021811 63.5146473 82.0985626 56.5530303 86.1147858"
        />
        <polyline
          id="Fill-2483"
          fill="#777776"
          points="44.7395999 79.6508473 46.9964282 80.9272662 53.9825494 76.9379975 51.6985215 75.634624 44.7395999 79.6508473"
        />
        <polyline
          id="Fill-2484"
          fill="#777776"
          points="82.2406864 81.0228322 84.4972697 82.2994963 91.4836358 78.3077771 89.199853 77.006609 82.2406864 81.0228322"
        />
        <polyline
          id="Fill-2485"
          fill="#777776"
          points="70.2802314 95.7206411 72.5343643 96.9970601 79.5231809 93.0080364 77.239153 91.7041728 70.2802314 95.7206411"
        />
        <polyline
          id="Fill-2486"
          fill="#8A8B8A"
          points="65.6121989 95.8012596 67.9106842 97.1024277 74.8526979 93.0888999 72.5713655 91.7850364 65.6121989 95.8012596"
        />
        <polyline
          id="Fill-2487"
          fill="#8A8B8A"
          points="70.468913 86.1025338 72.7698488 87.4039469 79.7118625 83.3901741 77.4278346 82.0863105 70.468913 86.1025338"
        />
        <polyline
          id="Fill-2488"
          fill="#8A8B8A"
          points="38.0377264 81.0081298 40.3386622 82.3119934 47.2806759 78.2957701 44.996893 76.9919065 38.0377264 81.0081298"
        />
        <polyline
          id="Fill-2489"
          fill="#8A8B8A"
          points="13.4405031 65.5781382 15.7411938 66.8790613 22.6834525 62.8652884 20.3996697 61.5616699 13.4405031 65.5781382"
        />
        <polyline
          id="Fill-2490"
          fill="#8A8B8A"
          points="84.3847958 89.6801335 86.6832811 90.983752 93.6252949 86.9677738 91.3439624 85.6666057 84.3847958 89.6801335"
        />
        <polyline
          id="Fill-2491"
          fill="#8A8B8A"
          points="29.8656065 71.6034532 32.1665422 72.9046214 39.108556 68.8910935 36.8272235 67.587475 29.8656065 71.6034532"
        />
        <polyline
          id="Fill-2492"
          fill="#8A8B8A"
          points="95.9629867 77.8078933 98.2636774 79.1117569 105.205936 75.0952886 102.922153 73.7919151 95.9629867 77.8078933"
        />
        <polyline
          id="Fill-2493"
          fill="#8A8B8A"
          points="32.2032984 50.932033 34.5039891 52.2356515 41.4462478 48.2191832 39.162465 46.9155647 32.2032984 50.932033"
        />
        <polyline
          id="Fill-2494"
          fill="#8A8B8A"
          points="91.520392 63.6104583 93.8213277 64.9116264 100.763096 60.8976086 98.4795586 59.59399 91.520392 63.6104583"
        />
        <polyline
          id="Fill-2495"
          fill="#E4E4E3"
          points="67.2564245 80.9983281 38.363386 64.8528166 38.363386 21.3090171 67.545573 39.0573424 67.2564245 80.9983281"
        />
        <polyline
          id="Fill-2496"
          fill="#B4B5B4"
          points="53.0366908 -2.98043872e-13 38.3611807 21.4018877 67.5431226 39.150458 81.6966952 16.8024667 53.0366908 -2.98043872e-13"
        />
        <polyline
          id="Fill-2497"
          fill="#9E9F9E"
          points="53.0366908 -7.85053704e-13 67.545573 4.82975964 96.1418667 21.3090171 81.6966952 16.8024667 53.0366908 -7.85053704e-13"
        />
        <polyline
          id="Fill-2498"
          fill="#F8F7F6"
          points="67.2515237 80.9983281 96.1418667 64.8528166 96.1418667 21.3090171 81.6966952 16.8024667 67.545573 39.0573424 67.2515237 80.9983281"
        />
        <polyline
          id="Fill-2499"
          fill="#E4E4E3"
          points="71.2236396 53.2768311 78.5797727 49.0302692 78.5797727 74.6689171 71.2236396 78.7588977 71.2236396 53.2768311"
        />
        <polyline
          id="Fill-2500"
          fill="#E4E4E3"
          points="83.5124496 46.8077466 90.2143231 42.938548 90.2143231 57.0039058 83.5124496 61.1352984 83.5124496 46.8077466"
        />
        <polyline
          id="Fill-2501"
          fill="#FFFFFE"
          points="62.2649378 53.032035 55.5630643 49.1625914 55.5630643 63.2279492 62.2649378 67.3595868 62.2649378 53.032035"
        />
        <polyline
          id="Fill-2502"
          fill="#FFFFFE"
          points="49.3610746 46.8077466 42.6589561 42.938548 42.6589561 57.0039058 49.3610746 61.1352984 49.3610746 46.8077466"
        />
      </g>
    </g>
  </svg>
)

export const step30Image2 = (
  <svg
    width="70px"
    height="70px"
    viewBox="0 0 128 128"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    aria-hidden="true"
  >
    <g
      id="5.climate/climate_4.1"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Group" transform="translate(0.000000, 12.800000)">
        <path
          d="M40.739491,41.0459675 C42.3101833,40.1402198 44.8577697,40.1402198 46.4311985,41.0459675 C47.9909452,41.9514416 47.9909452,43.4238972 46.4311985,44.3296449 C44.8577697,45.235119 42.3101833,45.235119 40.739491,44.3296449 C39.171535,43.4238972 39.171535,41.9514416 40.739491,41.0459675"
          id="Fill-380"
          fill="#71A241"
        />
        <path
          d="M44.9234433,42.6878062 C44.9234433,43.1144106 44.3241721,43.4619332 43.5853447,43.4619332 C42.8437809,43.4619332 42.2445098,43.1144106 42.2445098,42.6878062 L42.2445098,26.2694192 C42.2445098,25.8425412 42.8437809,25.4950186 43.5853447,25.4950186 C44.3241721,25.4950186 44.9234433,25.8425412 44.9234433,26.2694192 L44.9234433,42.6878062"
          id="Fill-381"
          fill="#66493C"
        />
        <polyline
          id="Fill-382"
          fill="#136053"
          points="43.5853447 39.4041288 43.5853447 26.2694192 49.2770522 22.9857418 54.9687597 32.836774 43.5853447 39.4041288"
        />
        <polyline
          id="Fill-383"
          fill="#167061"
          points="43.5853447 26.2694192 52.122906 21.3439031 46.8963861 11.2192311 43.5853447 13.1347096 43.5853447 26.2694192"
        />
        <polyline
          id="Fill-2147"
          fill="#54A044"
          points="55.7620414 30.5080995 1.13686838e-13 62.884885 70.2104956 103.427629 127.045205 71.8055419 55.7620414 30.5080995"
        />
        <polyline
          id="Fill-2148"
          fill="#75B86A"
          points="55.7620414 28.7811588 1.13686838e-13 61.1554816 70.2104956 101.700688 127.045205 70.0788749 55.7620414 28.7811588"
        />
        <polyline
          id="Fill-2150"
          fill="#54A044"
          points="127.045205 70.0788749 125.513096 70.9246955 127.045205 71.8055419 127.045205 70.0788749"
        />
        <path
          d="M84.3847628,78.1761497 C84.6313122,78.0283843 85.0691359,78.0283843 85.315138,78.1761497 C85.5887778,78.3266516 85.5887778,78.570191 85.315138,78.7206929 C85.0691359,78.8684584 84.6313122,78.8684584 84.3847628,78.7206929 C84.1113966,78.570191 84.1113966,78.3266516 84.3847628,78.1761497 Z M68.5960209,79.9189615 C68.8696607,79.7687333 69.2801204,79.7687333 69.5537602,79.9189615 C69.800036,80.069737 69.800036,80.3130028 69.5537602,80.4607683 C69.2801204,80.6112702 68.8696607,80.6112702 68.5960209,80.4607683 C68.3494715,80.3130028 68.3494715,80.069737 68.5960209,79.9189615 Z M91.0344832,70.464707 C91.3081229,70.3142051 91.7185826,70.3142051 91.9648584,70.464707 C92.2384982,70.6152089 92.2384982,70.8587483 91.9648584,71.0065138 C91.7185826,71.1570157 91.3081229,71.1570157 91.0344832,71.0065138 C90.7882074,70.8587483 90.7882074,70.6152089 91.0344832,70.464707 Z M111.612195,69.2497464 C111.885561,69.1019809 112.296021,69.1019809 112.569934,69.2497464 C112.815936,69.4002482 112.815936,69.6437877 112.569934,69.7942895 C112.296021,69.942055 111.885561,69.942055 111.612195,69.7942895 C111.365919,69.6437877 111.365919,69.4002482 111.612195,69.2497464 Z M107.918058,64.3518679 C108.191424,64.2041024 108.601884,64.2041024 108.848433,64.3518679 C109.121799,64.5023698 109.121799,64.7459092 108.848433,64.896411 C108.601884,65.0469129 108.191424,65.0469129 107.918058,64.896411 C107.671782,64.7459092 107.671782,64.5023698 107.918058,64.3518679 Z M100.666604,57.877277 C100.940243,57.7270487 101.350703,57.7270487 101.624069,57.877277 C101.870619,58.0277788 101.870619,58.2715919 101.624069,58.4193574 C101.350703,58.5695856 100.940243,58.5695856 100.666604,58.4193574 C100.420328,58.2715919 100.420328,58.0277788 100.666604,57.877277 Z M80.5540795,68.9022238 C80.8000816,68.7519956 81.2381789,68.7519956 81.4841811,68.9022238 C81.7580945,69.0527257 81.7580945,69.2938024 81.4841811,69.4440306 C81.2381789,69.5945325 80.8000816,69.5945325 80.5540795,69.4440306 C80.3078037,69.2938024 80.3078037,69.0527257 80.5540795,68.9022238 Z M87.3403461,64.3518679 C87.6139859,64.2041024 88.0244455,64.2041024 88.2980853,64.3518679 C88.5443611,64.5023698 88.5443611,64.7459092 88.2980853,64.896411 C88.0244455,65.0469129 87.6139859,65.0469129 87.3403461,64.896411 C87.0940703,64.7459092 87.0940703,64.5023698 87.3403461,64.3518679 Z M100.009868,66.182518 C100.283508,66.0347525 100.693968,66.0347525 100.940243,66.182518 C101.213609,66.3330199 101.213609,66.5765593 100.940243,66.7267876 C100.693968,66.8775631 100.283508,66.8775631 100.009868,66.7267876 C99.7635923,66.5765593 99.7635923,66.3330199 100.009868,66.182518 Z M72.9195295,82.7514069 C73.1931693,82.600905 73.603629,82.600905 73.8499048,82.7514069 C74.1232709,82.9019088 74.1232709,83.1451746 73.8499048,83.2959501 C73.603629,83.4437156 73.1931693,83.4437156 72.9195295,83.2959501 C72.6732537,83.1451746 72.6732537,82.9019088 72.9195295,82.7514069 Z M109.833263,72.5501158 C110.107176,72.4020767 110.517636,72.4020767 110.763638,72.5501158 C111.037278,72.700344 111.037278,72.9438834 110.763638,73.0943853 C110.517636,73.2421508 110.107176,73.2421508 109.833263,73.0943853 C109.58726,72.9438834 109.58726,72.700344 109.833263,72.5501158 Z M73.7404488,73.7951768 C74.0140886,73.6474113 74.4245483,73.6474113 74.6708241,73.7951768 C74.9441903,73.9456787 74.9441903,74.1889445 74.6708241,74.33972 C74.4245483,74.4874855 74.0140886,74.4874855 73.7404488,74.33972 C73.494173,74.1889445 73.494173,73.9456787 73.7404488,73.7951768 Z M58.6081688,83.1369654 C58.8544446,82.9864635 59.2922683,82.9864635 59.5385441,83.1369654 C59.8121839,83.2847309 59.8121839,83.5285439 59.5385441,83.6787721 C59.2922683,83.829274 58.8544446,83.829274 58.6081688,83.6787721 C58.334529,83.5285439 58.334529,83.2847309 58.6081688,83.1369654 Z M94.9201681,78.1761497 C95.1938079,78.0283843 95.6042675,78.0283843 95.8776337,78.1761497 C96.1241831,78.3266516 96.1241831,78.570191 95.8776337,78.7206929 C95.6042675,78.8684584 95.1938079,78.8684584 94.9201681,78.7206929 C94.6738923,78.570191 94.6738923,78.3266516 94.9201681,78.1761497 Z M97.1640143,79.1530438 C97.4102901,79.0025419 97.8481138,79.0025419 98.0943896,79.1530438 C98.3680294,79.3008092 98.3680294,79.5443487 98.0943896,79.6948505 C97.8481138,79.8450788 97.4102901,79.8450788 97.1640143,79.6948505 C96.8903745,79.5443487 96.8903745,79.3008092 97.1640143,79.1530438 Z M81.5391827,85.6218882 C81.8128225,85.4711127 82.2232821,85.4711127 82.4969219,85.6218882 C82.7429241,85.7723901 82.7429241,86.0129195 82.4969219,86.163695 C82.2232821,86.3141969 81.8128225,86.3141969 81.5391827,86.163695 C81.2929069,86.0129195 81.2929069,85.7723901 81.5391827,85.6218882 Z M61.6455704,86.1415302 C61.9189366,85.991302 62.3293962,85.991302 62.603036,86.1415302 C62.8495855,86.2920321 62.8495855,86.5358451 62.603036,86.6836106 C62.3293962,86.8338388 61.9189366,86.8338388 61.6455704,86.6836106 C61.399021,86.5358451 61.399021,86.2920321 61.6455704,86.1415302 Z M63.5336849,89.441626 C63.7799607,89.2938605 64.2177844,89.2938605 64.4640602,89.441626 C64.7377,89.5921279 64.7377,89.8356673 64.4640602,89.9861692 C64.2177844,90.1369447 63.7799607,90.1369447 63.5336849,89.9861692 C63.2874091,89.8356673 63.2874091,89.5921279 63.5336849,89.441626 Z M81.5391827,89.9891792 C81.8128225,89.8414137 82.2232821,89.8414137 82.4969219,89.9891792 C82.7429241,90.1396811 82.7429241,90.3832205 82.4969219,90.5334487 C82.2232821,90.6842242 81.8128225,90.6842242 81.5391827,90.5334487 C81.2929069,90.3832205 81.2929069,90.1396811 81.5391827,89.9891792 L81.5391827,89.9891792 Z"
          id="Fill-2151"
          fill="#9ECB94"
        />
        <path
          d="M62.3293962,77.2430381 C62.5759457,77.0952726 62.9864054,77.0952726 63.2600451,77.2430381 C63.5063209,77.3932663 63.5063209,77.6370794 63.2600451,77.7873076 C62.9864054,77.9350731 62.5759457,77.9350731 62.3293962,77.7873076 C62.0560301,77.6370794 62.0560301,77.3932663 62.3293962,77.2430381 Z M74.5613682,71.2336348 C74.835008,71.0831329 75.2454677,71.0831329 75.4917435,71.2336348 C75.7651096,71.3814003 75.7651096,71.6252133 75.4917435,71.7754416 C75.2454677,71.9259434 74.835008,71.9259434 74.5613682,71.7754416 C74.3150924,71.6252133 74.3150924,71.3814003 74.5613682,71.2336348 Z M82.1959182,71.6170041 C82.4695579,71.4665022 82.8800176,71.4665022 83.1533838,71.6170041 C83.3999332,71.7672324 83.3999332,72.008309 83.1533838,72.1588109 C82.8800176,72.3090391 82.4695579,72.3090391 82.1959182,72.1588109 C81.9496424,72.008309 81.9496424,71.7672324 82.1959182,71.6170041 Z M85.4795956,67.5288258 C85.7532353,67.3783239 86.163695,67.3783239 86.4370612,67.5288258 C86.6836106,67.6765912 86.6836106,67.9201307 86.4370612,68.0706325 C86.163695,68.2208608 85.7532353,68.2208608 85.4795956,68.0706325 C85.2333198,67.9201307 85.2333198,67.6765912 85.4795956,67.5288258 Z M99.0521288,63.1557884 C99.3257686,63.0055601 99.7362283,63.0055601 99.9822304,63.1557884 C100.256144,63.3062903 100.256144,63.5501033 99.9822304,63.6975952 C99.7362283,63.848097 99.3257686,63.848097 99.0521288,63.6975952 C98.805853,63.5501033 98.805853,63.3062903 99.0521288,63.1557884 Z M66.0785349,78.1761497 C66.3245371,78.0283843 66.7626344,78.0283843 67.0089102,78.1761497 C67.28255,78.3266516 67.28255,78.570191 67.0089102,78.7206929 C66.7626344,78.8711948 66.3245371,78.8711948 66.0785349,78.7206929 C65.8322591,78.570191 65.8322591,78.3266516 66.0785349,78.1761497 Z M114.266501,67.8322923 C114.512777,67.6817904 114.9506,67.6817904 115.196876,67.8322923 C115.470516,67.9830678 115.470516,68.2235972 115.196876,68.3740991 C114.9506,68.5248746 114.512777,68.5248746 114.266501,68.3740991 C113.992861,68.2235972 113.992861,67.9830678 114.266501,67.8322923 Z M116.045159,68.9022238 C116.291435,68.7519956 116.729259,68.7519956 116.975535,68.9022238 C117.249174,69.0527257 117.249174,69.2938024 116.975535,69.4440306 C116.729259,69.5945325 116.291435,69.5945325 116.045159,69.4440306 C115.77152,69.2938024 115.77152,69.0527257 116.045159,68.9022238 Z M69.9368559,73.0289854 C70.1831317,72.8782099 70.6209553,72.8782099 70.8672311,73.0289854 C71.1408709,73.1794873 71.1408709,73.4200167 70.8672311,73.5707922 C70.6209553,73.7212941 70.1831317,73.7212941 69.9368559,73.5707922 C69.6632161,73.4200167 69.6632161,73.1794873 69.9368559,73.0289854 Z M94.9201681,58.6464784 C95.1938079,58.4957029 95.6042675,58.4957029 95.8776337,58.6464784 C96.1241831,58.7942439 96.1241831,59.0377833 95.8776337,59.1882852 C95.6042675,59.3385134 95.1938079,59.3385134 94.9201681,59.1882852 C94.6738923,59.0377833 94.6738923,58.7942439 94.9201681,58.6464784 Z M88.763273,73.7951768 C89.0369127,73.6474113 89.4473724,73.6474113 89.7207386,73.7951768 C89.967288,73.9456787 89.967288,74.1889445 89.7207386,74.33972 C89.4473724,74.4874855 89.0369127,74.4874855 88.763273,74.33972 C88.5169972,74.1889445 88.5169972,73.9456787 88.763273,73.7951768 Z M77.0241263,79.1530438 C77.297766,79.0025419 77.7082257,79.0025419 77.9818655,79.1530438 C78.2278677,79.3008092 78.2278677,79.5443487 77.9818655,79.6948505 C77.7082257,79.8450788 77.297766,79.8450788 77.0241263,79.6948505 C76.7778504,79.5443487 76.7778504,79.3008092 77.0241263,79.1530438 Z M88.3528133,81.0600394 C88.6264531,80.9122739 89.0369127,80.9122739 89.3102789,81.0600394 C89.5568283,81.2105413 89.5568283,81.4540807 89.3102789,81.6045826 C89.0369127,81.7523481 88.6264531,81.7523481 88.3528133,81.6045826 C88.1065375,81.4540807 88.1065375,81.2105413 88.3528133,81.0600394 Z M94.7286202,82.5349578 C95.00226,82.384456 95.4127197,82.384456 95.6863595,82.5349578 C95.9326353,82.6854597 95.9326353,82.9262627 95.6863595,83.0767646 C95.4127197,83.2275401 95.00226,83.2275401 94.7286202,83.0767646 C94.4823444,82.9262627 94.4823444,82.6854597 94.7286202,82.5349578 Z M52.3415441,82.7514069 C52.6154576,82.600905 53.0259172,82.600905 53.2992834,82.7514069 C53.5458328,82.9019088 53.5458328,83.1451746 53.2992834,83.2959501 C53.0259172,83.4437156 52.6154576,83.4437156 52.3415441,83.2959501 C52.095542,83.1451746 52.095542,82.9019088 52.3415441,82.7514069 Z M50.0706076,83.7307637 C50.3166097,83.5829982 50.754707,83.5829982 51.0009828,83.7307637 C51.2746226,83.8812656 51.2746226,84.124805 51.0009828,84.2755805 C50.754707,84.4230724 50.3166097,84.4230724 50.0706076,84.2755805 C49.7969678,84.124805 49.7969678,83.8812656 50.0706076,83.7307637 Z M67.5835537,85.214165 C67.8571935,85.0636631 68.2676532,85.0636631 68.513929,85.214165 C68.7872951,85.3646669 68.7872951,85.6079326 68.513929,85.7559717 C68.2676532,85.9064736 67.8571935,85.9064736 67.5835537,85.7559717 C67.3372779,85.6079326 67.3372779,85.3646669 67.5835537,85.214165 Z M69.2527564,93.0293172 C69.5263962,92.8788153 69.9368559,92.8788153 70.2104956,93.0293172 C70.4567714,93.1770827 70.4567714,93.4206221 70.2104956,93.571124 C69.9368559,93.7216258 69.5263962,93.7216258 69.2527564,93.571124 C69.0064806,93.4206221 69.0064806,93.1770827 69.2527564,93.0293172 Z M65.4217994,93.8201362 C65.6680752,93.672097 66.1058989,93.672097 66.3521747,93.8201362 C66.6258145,93.9703644 66.6258145,94.2139038 66.3521747,94.3644057 C66.1058989,94.5151812 65.6680752,94.5151812 65.4217994,94.3644057 C65.1481596,94.2139038 65.1481596,93.9703644 65.4217994,93.8201362 Z M75.9569311,93.8365545 C76.2305709,93.685779 76.6410306,93.685779 76.9146703,93.8365545 C77.1609461,93.9870564 77.1609461,94.2305958 76.9146703,94.3783613 C76.6410306,94.5288632 76.2305709,94.5288632 75.9569311,94.3783613 C75.7106553,94.2305958 75.7106553,93.9870564 75.9569311,93.8365545 L75.9569311,93.8365545 Z"
          id="Fill-2152"
          fill="#51A146"
        />
        <path
          d="M87.6139859,85.6818154 C87.6139859,84.7760677 88.3254493,84.0399767 89.2284606,84.0399767 L89.2558246,84.0399767 C89.2558246,84.9487344 88.5169972,85.6818154 87.6139859,85.6818154"
          id="Fill-2153"
          fill="#51A146"
        />
        <path
          d="M87.6139859,85.6818154 C87.6139859,84.7760677 86.8751585,84.0399767 85.9721472,84.0399767 C85.9721472,84.9487344 86.6836106,85.6818154 87.6139859,85.6818154"
          id="Fill-2154"
          fill="#51A146"
        />
        <path
          d="M55.9264989,87.5455759 C55.9264989,86.6370918 56.6653264,85.9037372 57.5683376,85.9037372 C57.5683376,86.8092113 56.8566006,87.5455759 55.9264989,87.5455759"
          id="Fill-2155"
          fill="#9ECB94"
        />
        <path
          d="M55.9264989,87.5455759 C55.9264989,86.6370918 55.2147619,85.9037372 54.2846602,85.9037372 C54.2846602,86.8092113 55.0234877,87.5455759 55.9264989,87.5455759"
          id="Fill-2156"
          fill="#9ECB94"
        />
        <path
          d="M104.278649,77.6945437 C104.278649,76.7860596 105.017202,76.052705 105.920487,76.052705 C105.920487,76.9581791 105.18166,77.6945437 104.278649,77.6945437"
          id="Fill-2157"
          fill="#9ECB94"
        />
        <path
          d="M104.278649,77.6945437 C104.278649,76.7860596 103.539821,76.052705 102.63681,76.052705 C102.63681,76.9581791 103.375364,77.6945437 104.278649,77.6945437"
          id="Fill-2158"
          fill="#9ECB94"
        />
        <path
          d="M72.0436086,78.3373236 C72.0436086,77.4291131 72.7827096,76.6954849 73.6854473,76.6954849 C73.6854473,77.6015062 72.9468935,78.3373236 72.0436086,78.3373236 L72.0436086,78.3345872 L72.0436086,78.3373236"
          id="Fill-2159"
          fill="#9ECB94"
        />
        <path
          d="M72.0436086,78.3373236 C72.0436086,77.4291131 71.3050548,76.6954849 70.4017699,76.6954849 C70.4017699,77.6015062 71.1408709,78.3373236 72.0436086,78.3373236 L72.0436086,78.3345872 L72.0436086,78.3373236"
          id="Fill-2160"
          fill="#9ECB94"
        />
        <path
          d="M74.2056365,89.1874146 C74.2056365,88.2789305 74.9441903,87.5455759 75.8474752,87.5455759 C75.8474752,88.45105 75.1086478,89.1874146 74.2056365,89.1874146"
          id="Fill-2161"
          fill="#51A146"
        />
        <path
          d="M74.2056365,89.1874146 C74.2056365,88.2789305 73.4668091,87.5455759 72.5637978,87.5455759 C72.5637978,88.45105 73.3023516,89.1874146 74.2056365,89.1874146"
          id="Fill-2162"
          fill="#51A146"
        />
        <path
          d="M85.5069595,75.272558 C85.5069595,74.3640739 86.245787,73.6307193 87.1487982,73.6307193 C87.1487982,74.536467 86.4096972,75.272558 85.5069595,75.272558"
          id="Fill-2163"
          fill="#51A146"
        />
        <path
          d="M85.5069595,75.272558 C85.5069595,74.3640739 84.7678585,73.6307193 83.8651208,73.6307193 C83.8651208,74.536467 84.6039483,75.272558 85.5069595,75.272558"
          id="Fill-2164"
          fill="#51A146"
        />
        <path
          d="M93.1415095,66.8912451 C93.1415095,65.9852237 93.8803369,65.2494064 94.7833482,65.2494064 L94.7833482,65.2521428 C94.7833482,66.1576168 94.0445208,66.8912451 93.1415095,66.8912451"
          id="Fill-2165"
          fill="#51A146"
        />
        <path
          d="M93.1415095,66.8912451 C93.1415095,65.9852237 92.4026821,65.2494064 91.4996708,65.2494064 L91.4996708,65.2521428 C91.4996708,66.1576168 92.2384982,66.8912451 93.1415095,66.8912451"
          id="Fill-2166"
          fill="#51A146"
        />
        <path
          d="M98.2859374,72.7088269 C98.2859374,71.8030792 99.0247648,71.0669882 99.9277761,71.0669882 C99.9277761,71.9724622 99.1889487,72.7088269 98.2859374,72.7088269"
          id="Fill-2167"
          fill="#51A146"
        />
        <path
          d="M98.2859374,72.7088269 C98.2859374,71.8030792 97.54711,71.0669882 96.6440987,71.0669882 C96.6440987,71.9724622 97.3829261,72.7088269 98.2859374,72.7088269"
          id="Fill-2168"
          fill="#51A146"
        />
        <path
          d="M59.9216398,64.9317106 C60.1952796,64.7842187 60.6057392,64.7842187 60.879379,64.9317106 C61.1256548,65.0824861 61.1256548,65.3260255 60.879379,65.4765274 C60.6057392,65.6242929 60.1952796,65.6242929 59.9216398,65.4765274 C59.675364,65.3260255 59.675364,65.0824861 59.9216398,64.9317106 Z M44.1545155,66.674796 C44.4144733,66.5245678 44.8358785,66.5245678 45.0955627,66.674796 C45.3637297,66.8252979 45.3637297,67.0688373 45.0955627,67.2196128 C44.8358785,67.3673783 44.4144733,67.3673783 44.1545155,67.2196128 C43.8945577,67.0688373 43.8945577,66.8252979 44.1545155,66.674796 Z M66.5984505,57.2205415 C66.8444527,57.0700396 67.28255,57.0700396 67.5285521,57.2205415 C67.7751016,57.3710434 67.7751016,57.6145828 67.5285521,57.7623483 C67.28255,57.9128501 66.8444527,57.9128501 66.5984505,57.7623483 C66.3245371,57.6145828 66.3245371,57.3710434 66.5984505,57.2205415 Z M87.1761622,56.0058545 C87.422438,55.8578154 87.8602617,55.8578154 88.1065375,56.0058545 C88.3801773,56.1560827 88.3801773,56.3996221 88.1065375,56.550124 C87.8602617,56.6978895 87.422438,56.6978895 87.1761622,56.550124 C86.9025224,56.3996221 86.9025224,56.1560827 87.1761622,56.0058545 Z M83.4820251,51.1104388 C83.7283009,50.9599369 84.1661246,50.9599369 84.4124004,51.1104388 C84.6860402,51.2582042 84.6860402,51.5017436 84.4124004,51.6522455 C84.1661246,51.8024738 83.7283009,51.8024738 83.4820251,51.6522455 C83.2083854,51.5017436 83.2083854,51.2582042 83.4820251,51.1104388 Z M76.2305709,44.6333851 C76.5042107,44.4826096 76.9146703,44.4826096 77.1609461,44.6333851 C77.4345859,44.783887 77.4345859,45.0274264 77.1609461,45.1751919 C76.9146703,45.3256937 76.5042107,45.3256937 76.2305709,45.1751919 C75.9842951,45.0274264 75.9842951,44.783887 76.2305709,44.6333851 Z M56.1180468,55.658332 C56.3643226,55.5075564 56.8021463,55.5075564 57.0484221,55.658332 C57.2944242,55.8088338 57.2944242,56.0493632 57.0484221,56.2001387 C56.8021463,56.3506406 56.3643226,56.3506406 56.1180468,56.2001387 C55.844407,56.0493632 55.844407,55.8088338 56.1180468,55.658332 Z M62.9043134,51.1104388 C63.1503156,50.9599369 63.5884129,50.9599369 63.834415,51.1104388 C64.1083285,51.2582042 64.1083285,51.5017436 63.834415,51.6522455 C63.5884129,51.8024738 63.1503156,51.8024738 62.9043134,51.6522455 C62.6304,51.5017436 62.6304,51.2582042 62.9043134,51.1104388 Z M75.5738354,52.9410889 C75.8201112,52.790587 76.2579349,52.790587 76.5042107,52.9410889 C76.7778504,53.0888544 76.7778504,53.3323938 76.5042107,53.4828957 C76.2579349,53.6331239 75.8201112,53.6331239 75.5738354,53.4828957 C75.3001956,53.3323938 75.3001956,53.0888544 75.5738354,52.9410889 Z M48.4834968,69.5072414 C48.7297726,69.3594759 49.1675963,69.3594759 49.4138721,69.5072414 C49.6875119,69.6574696 49.6875119,69.9012827 49.4138721,70.0515109 C49.1675963,70.1992764 48.7297726,70.1992764 48.4834968,70.0515109 C48.2098571,69.9012827 48.2098571,69.6574696 48.4834968,69.5072414 Z M85.3975036,59.3056766 C85.6437794,59.1581848 86.0816031,59.1581848 86.3278789,59.3056766 C86.6015187,59.4561785 86.6015187,59.6999916 86.3278789,59.8502198 C86.0816031,59.9979853 85.6437794,59.9979853 85.3975036,59.8502198 C85.1238638,59.6999916 85.1238638,59.4561785 85.3975036,59.3056766 Z M49.3044162,60.5510113 C49.550692,60.4032458 49.9885156,60.4032458 50.2347914,60.5510113 C50.5084312,60.7012395 50.5084312,60.9450526 50.2347914,61.0952808 C49.9885156,61.2430463 49.550692,61.2430463 49.3044162,61.0952808 C49.0307764,60.9450526 49.0307764,60.7012395 49.3044162,60.5510113 Z M34.1611906,69.8900635 C34.4181383,69.742298 34.8398172,69.742298 35.099775,69.8900635 C35.3594592,70.040839 35.3594592,70.2841047 35.099775,70.4348803 C34.8398172,70.5853821 34.4181383,70.5853821 34.1611906,70.4348803 C33.9012328,70.2841047 33.9012328,70.040839 34.1611906,69.8900635 Z M70.4841354,64.9317106 C70.7304112,64.7842187 71.1682349,64.7842187 71.4145107,64.9317106 C71.6881505,65.0824861 71.6881505,65.3260255 71.4145107,65.4765274 C71.1682349,65.6242929 70.7304112,65.6242929 70.4841354,65.4765274 C70.2378596,65.3260255 70.2378596,65.0824861 70.4841354,64.9317106 Z M72.7006177,65.9088782 C72.9742575,65.7581027 73.3847171,65.7581027 73.6583569,65.9088782 C73.9046327,66.0591065 73.9046327,66.2999095 73.6583569,66.4504114 C73.3847171,66.6009133 72.9742575,66.6009133 72.7006177,66.4504114 C72.4540682,66.2999095 72.4540682,66.0591065 72.7006177,65.9088782 Z M57.10315,72.3777227 C57.3494258,72.2272208 57.7872495,72.2272208 58.0335253,72.3777227 C58.3071651,72.5282246 58.3071651,72.771764 58.0335253,72.9195295 C57.7872495,73.0700314 57.3494258,73.0700314 57.10315,72.9195295 C56.8295102,72.771764 56.8295102,72.5282246 57.10315,72.3777227 Z M37.2065277,72.8976383 C37.4667592,72.7468628 37.8878908,72.7468628 38.1481222,72.8976383 C38.4053436,73.0481402 38.4053436,73.2916796 38.1481222,73.4394451 C37.8878908,73.589947 37.4667592,73.589947 37.2065277,73.4394451 C36.9468436,73.2916796 36.9468436,73.0481402 37.2065277,72.8976383 Z M39.0867067,76.2004705 C39.3466645,76.0499686 39.7680697,76.0499686 40.0277539,76.2004705 C40.2879853,76.348236 40.2879853,76.5917754 40.0277539,76.7422773 C39.7680697,76.8927792 39.3466645,76.8927792 39.0867067,76.7422773 C38.8294853,76.5917754 38.8294853,76.348236 39.0867067,76.2004705 Z M57.10315,76.7477501 C57.3494258,76.5972482 57.7872495,76.5972482 58.0335253,76.7477501 C58.3071651,76.8955156 58.3071651,77.139055 58.0335253,77.2895568 C57.7872495,77.4397851 57.3494258,77.4397851 57.10315,77.2895568 C56.8295102,77.139055 56.8295102,76.8955156 57.10315,76.7477501 L57.10315,76.7477501 Z"
          id="Fill-2169"
          fill="#9ECB94"
        />
        <path
          d="M37.871746,64.001609 C38.1317038,63.8511071 38.5528355,63.8511071 38.8103305,64.001609 C39.0702883,64.1493744 39.0702883,64.3929138 38.8103305,64.5431421 C38.5528355,64.6911812 38.1317038,64.6911812 37.871746,64.5431421 C37.6115146,64.3929138 37.6115146,64.1493744 37.871746,64.001609 Z M50.1253355,57.9897429 C50.3716113,57.8389674 50.809435,57.8389674 51.0557108,57.9897429 C51.3293506,58.1375084 51.3293506,58.3807742 51.0557108,58.5315497 C50.809435,58.6820516 50.3716113,58.6820516 50.1253355,58.5315497 C49.8516958,58.3807742 49.8516958,58.1375084 50.1253355,57.9897429 Z M57.7598855,58.372565 C58.0335253,58.2220631 58.443985,58.2220631 58.6902608,58.372565 C58.9639005,58.5230669 58.9639005,58.7638699 58.6902608,58.9143717 C58.443985,59.0648736 58.0335253,59.0648736 57.7598855,58.9143717 C57.5136097,58.7638699 57.5136097,58.5230669 57.7598855,58.372565 Z M61.0435629,54.2846602 C61.2898387,54.1338847 61.7276624,54.1338847 61.9739382,54.2846602 C62.2475779,54.4324257 62.2475779,54.6756915 61.9739382,54.826467 C61.7276624,54.9766953 61.2898387,54.9766953 61.0435629,54.826467 C60.7699231,54.6756915 60.7699231,54.4324257 61.0435629,54.2846602 Z M74.6160962,49.9118965 C74.862372,49.764131 75.3001956,49.764131 75.5464714,49.9118965 C75.8201112,50.0623984 75.8201112,50.3059378 75.5464714,50.4564397 C75.3001956,50.6042052 74.862372,50.6042052 74.6160962,50.4564397 C74.3424564,50.3059378 74.3424564,50.0623984 74.6160962,49.9118965 Z M41.631283,64.9317106 C41.8915145,64.7842187 42.3126461,64.7842187 42.5728775,64.9317106 C42.8325617,65.0824861 42.8325617,65.3260255 42.5728775,65.4765274 C42.3126461,65.6242929 41.8915145,65.6242929 41.631283,65.4765274 C41.3743353,65.3260255 41.3743353,65.0824861 41.631283,64.9317106 Z M89.8031041,54.5881268 C90.0767439,54.4378985 90.4872036,54.4378985 90.7608434,54.5881268 C91.0071192,54.7386286 91.0071192,54.9797053 90.7608434,55.1299335 C90.4872036,55.2804354 90.0767439,55.2804354 89.8031041,55.1299335 C89.5568283,54.9797053 89.5568283,54.7386286 89.8031041,54.5881268 Z M91.5817627,55.658332 C91.8554025,55.5075564 92.2658622,55.5075564 92.539502,55.658332 C92.7857778,55.8088338 92.7857778,56.0493632 92.539502,56.2001387 C92.2658622,56.3506406 91.8554025,56.3506406 91.5817627,56.2001387 C91.3352133,56.0493632 91.3352133,55.8088338 91.5817627,55.658332 Z M45.4734592,59.7848199 C45.747099,59.634318 46.1575587,59.634318 46.4311985,59.7848199 C46.6774743,59.9353218 46.6774743,60.1761248 46.4311985,60.3266267 C46.1575587,60.4771285 45.747099,60.4771285 45.4734592,60.3266267 C45.2271834,60.1761248 45.2271834,59.9353218 45.4734592,59.7848199 Z M70.4841354,45.3995765 C70.7304112,45.2515374 71.1682349,45.2515374 71.4145107,45.3995765 C71.6881505,45.5500784 71.6881505,45.7933441 71.4145107,45.9441196 C71.1682349,46.0946215 70.7304112,46.0946215 70.4841354,45.9441196 C70.2378596,45.7933441 70.2378596,45.5500784 70.4841354,45.3995765 Z M64.3272403,60.5510113 C64.5735161,60.4032458 65.0113398,60.4032458 65.2576156,60.5510113 C65.5312553,60.7012395 65.5312553,60.9450526 65.2576156,61.0952808 C65.0113398,61.2430463 64.5735161,61.2430463 64.3272403,61.0952808 C64.0536005,60.9450526 64.0536005,60.7012395 64.3272403,60.5510113 Z M52.5880936,65.9088782 C52.8343694,65.7581027 53.272193,65.7581027 53.5184689,65.9088782 C53.7921086,66.0566437 53.7921086,66.2999095 53.5184689,66.4504114 C53.272193,66.6009133 52.8343694,66.6009133 52.5880936,66.4504114 C52.3144538,66.2999095 52.3144538,66.0566437 52.5880936,65.9088782 Z M63.9167806,67.8158739 C64.1630564,67.6681084 64.6008801,67.6681084 64.8471559,67.8158739 C65.1207957,67.9663758 65.1207957,68.2099152 64.8471559,68.3604171 C64.6008801,68.5081825 64.1630564,68.5081825 63.9167806,68.3604171 C63.6431408,68.2099152 63.6431408,67.9663758 63.9167806,67.8158739 Z M70.2925876,69.2907923 C70.5385897,69.1405641 70.976687,69.1405641 71.2226892,69.2907923 C71.4966026,69.4412942 71.4966026,69.6823709 71.2226892,69.8325991 C70.976687,69.9833746 70.5385897,69.9833746 70.2925876,69.8325991 C70.0186742,69.6823709 70.0186742,69.4412942 70.2925876,69.2907923 Z M27.9030487,69.5072414 C28.1630065,69.3594759 28.5844118,69.3594759 28.8416332,69.5072414 C29.101591,69.6574696 29.101591,69.9012827 28.8416332,70.0515109 C28.5844118,70.1992764 28.1630065,70.1992764 27.9030487,70.0515109 C27.6430909,69.9012827 27.6430909,69.6574696 27.9030487,69.5072414 Z M25.6178829,70.4865982 C25.8753779,70.3388327 26.2967832,70.3388327 26.556741,70.4865982 C26.8166988,70.6371001 26.8166988,70.8809131 26.556741,71.0311414 C26.2967832,71.1789068 25.8753779,71.1789068 25.6178829,71.0311414 C25.3581987,70.8809131 25.3581987,70.6371001 25.6178829,70.4865982 Z M43.1393119,71.9699994 C43.3965333,71.8194976 43.8179385,71.8194976 44.0778963,71.9699994 C44.3375805,72.1202277 44.3375805,72.3640407 44.0778963,72.5118062 C43.8179385,72.6620345 43.3965333,72.6620345 43.1393119,72.5118062 C42.8793541,72.3640407 42.8793541,72.1202277 43.1393119,71.9699994 Z M44.8191865,79.7851517 C45.0794179,79.6343761 45.5005496,79.6343761 45.747099,79.7851517 C46.0207388,79.9329171 46.0207388,80.1764566 45.747099,80.3269584 C45.5005496,80.4771867 45.0794179,80.4771867 44.8191865,80.3269584 C44.5595023,80.1764566 44.5595023,79.9329171 44.8191865,79.7851517 Z M40.9663383,80.5784334 C41.2265698,80.4279315 41.647975,80.4279315 41.9079328,80.5784334 C42.1678906,80.7261989 42.1678906,80.9700119 41.9079328,81.1202402 C41.647975,81.2710157 41.2265698,81.2710157 40.9663383,81.1202402 C40.7091169,80.9700119 40.7091169,80.7261989 40.9663383,80.5784334 Z M51.5206248,80.5921154 C51.7671742,80.4418871 52.2049979,80.4418871 52.4512737,80.5921154 C52.7249135,80.7426173 52.7249135,80.9861567 52.4512737,81.1339222 C52.2049979,81.284424 51.7671742,81.284424 51.5206248,81.1339222 C51.246985,80.9861567 51.246985,80.7426173 51.5206248,80.5921154 L51.5206248,80.5921154 Z"
          id="Fill-2170"
          fill="#51A146"
        />
        <path
          d="M63.1503156,72.4379235 C63.1503156,71.5319022 63.8894166,70.7985475 64.7921543,70.7985475 C64.7921543,71.7042952 64.0536005,72.4403862 63.1503156,72.4403862 L63.1503156,72.4379235"
          id="Fill-2171"
          fill="#51A146"
        />
        <path
          d="M63.1503156,72.4379235 C63.1503156,71.5319022 62.4117618,70.7985475 61.5084769,70.7985475 C61.5084769,71.7042952 62.2475779,72.4403862 63.1503156,72.4403862 L63.1503156,72.4379235"
          id="Fill-2172"
          fill="#51A146"
        />
        <path
          d="M31.4932027,74.3014104 C31.4932027,73.3926527 32.2265573,72.6595717 33.1350414,72.6595717 C33.1350414,73.5650457 32.3989504,74.3014104 31.4932027,74.3014104"
          id="Fill-2173"
          fill="#9ECB94"
        />
        <path
          d="M31.4932027,74.3014104 C31.4932027,73.3926527 30.7571117,72.6595717 29.851364,72.6595717 C29.851364,73.5650457 30.5847186,74.3014104 31.4932027,74.3014104"
          id="Fill-2174"
          fill="#9ECB94"
        />
        <path
          d="M79.8423424,64.4503782 C79.8423424,63.5416205 80.5814434,62.8085395 81.4841811,62.8085395 C81.4841811,63.7140135 80.7456273,64.4503782 79.8423424,64.4503782"
          id="Fill-2175"
          fill="#9ECB94"
        />
        <path
          d="M79.8423424,64.4503782 C79.8423424,63.5416205 79.1037886,62.8085395 78.2005037,62.8085395 C78.2005037,63.7140135 78.9396047,64.4503782 79.8423424,64.4503782"
          id="Fill-2176"
          fill="#9ECB94"
        />
        <path
          d="M47.6078495,65.0931581 C47.6078495,64.184674 48.319313,63.4513194 49.2496882,63.4513194 C49.2496882,64.3573407 48.5108608,65.0931581 47.6078495,65.0931581 L47.6078495,65.0904217 L47.6078495,65.0931581"
          id="Fill-2177"
          fill="#9ECB94"
        />
        <path
          d="M47.6078495,65.0931581 C47.6078495,64.184674 46.8690221,63.4513194 45.9660108,63.4513194 C45.9660108,64.3573407 46.6774743,65.0931581 47.6078495,65.0931581 L47.6078495,65.0904217 L47.6078495,65.0931581"
          id="Fill-2178"
          fill="#9ECB94"
        />
        <path
          d="M49.7696038,75.9432491 C49.7696038,75.0344914 50.5084312,74.3014104 51.4114425,74.3014104 C51.4114425,75.2068844 50.6726151,75.9432491 49.7696038,75.9432491"
          id="Fill-2179"
          fill="#51A146"
        />
        <path
          d="M49.7696038,75.9432491 C49.7696038,75.0344914 49.0307764,74.3014104 48.1277651,74.3014104 C48.1277651,75.2068844 48.8665925,75.9432491 49.7696038,75.9432491"
          id="Fill-2180"
          fill="#51A146"
        />
        <path
          d="M61.0709269,62.0283925 C61.0709269,61.1199084 61.8094806,60.3865538 62.7127656,60.3865538 C62.7127656,61.2925751 61.9739382,62.0283925 61.0709269,62.0283925"
          id="Fill-2181"
          fill="#51A146"
        />
        <path
          d="M61.0709269,62.0283925 C61.0709269,61.1199084 60.3320995,60.3865538 59.4290882,60.3865538 C59.4290882,61.2925751 60.1676419,62.0283925 61.0709269,62.0283925"
          id="Fill-2182"
          fill="#51A146"
        />
        <path
          d="M68.7054768,53.6470795 C68.7054768,52.7410582 69.4443042,52.0052408 70.3473155,52.0052408 L70.3473155,52.0077036 C70.3473155,52.9134513 69.6082145,53.6470795 68.7054768,53.6470795"
          id="Fill-2183"
          fill="#51A146"
        />
        <path
          d="M68.7054768,53.6470795 C68.7054768,52.7410582 67.9663758,52.0052408 67.0636381,52.0052408 L67.0636381,52.0077036 C67.0636381,52.9134513 67.8024655,53.6470795 68.7054768,53.6470795"
          id="Fill-2184"
          fill="#51A146"
        />
        <path
          d="M73.8499048,59.4643877 C73.8499048,58.55864 74.5887322,57.822549 75.4917435,57.822549 C75.4917435,58.7282967 74.752916,59.4643877 73.8499048,59.4643877"
          id="Fill-2185"
          fill="#51A146"
        />
        <path
          d="M73.8499048,59.4643877 C73.8499048,58.55864 73.1110773,57.822549 72.2080661,57.822549 C72.2080661,58.7282967 72.9468935,59.4643877 73.8499048,59.4643877"
          id="Fill-2186"
          fill="#51A146"
        />
        <path
          d="M41.6288203,53.7401171 C41.8887781,53.5896152 42.3101833,53.5896152 42.5701411,53.7401171 C42.8273625,53.8878826 42.8273625,54.131422 42.5701411,54.2816502 C42.3101833,54.4324257 41.8887781,54.4324257 41.6288203,54.2816502 C41.3688625,54.131422 41.3688625,53.8878826 41.6288203,53.7401171 Z M25.8534867,55.4801925 C26.1107081,55.3299642 26.5321134,55.3299642 26.7920712,55.4801925 C27.052029,55.6306943 27.052029,55.8745074 26.7920712,56.0247356 C26.5321134,56.1725011 26.1107081,56.1725011 25.8534867,56.0247356 C25.5932553,55.8745074 25.5932553,55.6306943 25.8534867,55.4801925 Z M48.291949,46.0259379 C48.5382248,45.8781725 48.9760484,45.8781725 49.2223242,46.0259379 C49.4956904,46.1767135 49.4956904,46.4199792 49.2223242,46.5707547 C48.9760484,46.7185202 48.5382248,46.7185202 48.291949,46.5707547 C48.0183092,46.4199792 48.0183092,46.1767135 48.291949,46.0259379 Z M68.8696607,44.8109773 C69.1433005,44.6632118 69.5537602,44.6632118 69.800036,44.8109773 C70.0736758,44.9614792 70.0736758,45.2050186 69.800036,45.3557941 C69.5537602,45.5060224 69.1433005,45.5060224 68.8696607,45.3557941 C68.6233849,45.2050186 68.6233849,44.9614792 68.8696607,44.8109773 Z M65.1755236,39.9155616 C65.4217994,39.7653333 65.8596231,39.7653333 66.1058989,39.9155616 C66.3795387,40.0636007 66.3795387,40.3071401 66.1058989,40.4573683 C65.8596231,40.6081439 65.4217994,40.6081439 65.1755236,40.4573683 C64.9018838,40.3071401 64.9018838,40.0636007 65.1755236,39.9155616 Z M57.9240694,33.4387815 C58.1977091,33.2882797 58.6081688,33.2882797 58.8818086,33.4387815 C59.1280844,33.5892834 59.1280844,33.8328228 58.8818086,33.9833247 C58.6081688,34.1310902 58.1977091,34.1310902 57.9240694,33.9833247 C57.6775199,33.8328228 57.6775199,33.5892834 57.9240694,33.4387815 Z M37.8060725,44.4637284 C38.0657566,44.3132265 38.4874355,44.3132265 38.7446569,44.4637284 C39.0046147,44.6139567 39.0046147,44.8577697 38.7446569,45.0055352 C38.4874355,45.1557634 38.0657566,45.1557634 37.8060725,45.0055352 C37.545841,44.8577697 37.545841,44.6139567 37.8060725,44.4637284 Z M44.6005483,39.9155616 C44.8605061,39.7653333 45.2819114,39.7653333 45.5281872,39.9155616 C45.8015533,40.0636007 45.8015533,40.3071401 45.5281872,40.4573683 C45.2819114,40.6081439 44.8605061,40.6081439 44.6005483,40.4573683 C44.3405905,40.3071401 44.3405905,40.0636007 44.6005483,39.9155616 Z M57.2670602,41.7462117 C57.5136097,41.5959835 57.9514333,41.5959835 58.1977091,41.7462117 C58.4713489,41.8939772 58.4713489,42.1377903 58.1977091,42.2880185 C57.9514333,42.4385204 57.5136097,42.4385204 57.2670602,42.2880185 C56.9934205,42.1377903 56.9934205,41.8939772 57.2670602,41.7462117 Z M30.1715225,58.3123642 C30.4314803,58.1645987 30.8528856,58.1645987 31.1128434,58.3123642 C31.3728012,58.4631397 31.3728012,58.7064055 31.1128434,58.8569074 C30.8528856,59.0049465 30.4314803,59.0049465 30.1715225,58.8569074 C29.9115647,58.7064055 29.9115647,58.4631397 30.1715225,58.3123642 Z M67.0910021,48.1110731 C67.3372779,47.9633076 67.7751016,47.9633076 68.0213774,48.1110731 C68.2950172,48.261575 68.2950172,48.5051144 68.0213774,48.6556163 C67.7751016,48.8033817 67.3372779,48.8033817 67.0910021,48.6556163 C66.8173623,48.5051144 66.8173623,48.261575 67.0910021,48.1110731 Z M30.9924419,49.3561341 C31.2523997,49.2083686 31.6738049,49.2083686 31.9337627,49.3561341 C32.1937205,49.5069096 32.1937205,49.7501754 31.9337627,49.9009509 C31.6738049,50.0511792 31.2523997,50.0511792 30.9924419,49.9009509 C30.7324841,49.7501754 30.7324841,49.5069096 30.9924419,49.3561341 Z M15.8571518,58.6981963 C16.1173832,58.5479681 16.5387885,58.5479681 16.7960099,58.6981963 C17.0559677,58.8459618 17.0559677,59.0897748 16.7960099,59.2402767 C16.5387885,59.390505 16.1173832,59.390505 15.8571518,59.2402767 C15.5974677,59.0897748 15.5974677,58.8459618 15.8571518,58.6981963 Z M52.1776339,53.7373807 C52.4512737,53.5896152 52.8617334,53.5896152 53.1080092,53.7373807 C53.381649,53.8878826 53.381649,54.131422 53.1080092,54.2816502 C52.8617334,54.4324257 52.4512737,54.4324257 52.1776339,54.2816502 C51.9310845,54.131422 51.9310845,53.8878826 52.1776339,53.7373807 Z M54.4212065,54.7142747 C54.6677559,54.5637728 55.0782156,54.5637728 55.3515818,54.7142747 C55.5981312,54.8645029 55.5981312,55.1055796 55.3515818,55.2558078 C55.0782156,55.4063097 54.6677559,55.4063097 54.4212065,55.2558078 C54.1478404,55.1055796 54.1478404,54.8645029 54.4212065,54.7142747 Z M38.7939121,61.1831192 C39.0535963,61.0323437 39.4752752,61.0323437 39.7349593,61.1831192 C39.9951908,61.3336211 39.9951908,61.5771605 39.7349593,61.724926 C39.4752752,61.8751542 39.0535963,61.8751542 38.7939121,61.724926 C38.5366907,61.5771605 38.5366907,61.3336211 38.7939121,61.1831192 Z M18.9030362,61.7030348 C19.162994,61.5525329 19.5843993,61.5525329 19.8443571,61.7030348 C20.1043149,61.853263 20.1043149,62.0970761 19.8443571,62.2448415 C19.5843993,62.3950698 19.162994,62.3950698 18.9030362,62.2448415 C18.6455412,62.0970761 18.6455412,61.853263 18.9030362,61.7030348 Z M20.785678,65.0055933 C21.0428993,64.8550914 21.4643046,64.8550914 21.7239888,65.0055933 C21.9842202,65.1533588 21.9842202,65.3971719 21.7239888,65.5474001 C21.4643046,65.6981756 21.0428993,65.6981756 20.785678,65.5474001 C20.5257202,65.3971719 20.5257202,65.1533588 20.785678,65.0055933 Z M38.7939121,65.5528729 C39.0535963,65.4026446 39.4752752,65.4026446 39.7349593,65.5528729 C39.9951908,65.7006384 39.9951908,65.9444514 39.7349593,66.0946797 C39.4752752,66.2451815 39.0535963,66.2451815 38.7939121,66.0946797 C38.5366907,65.9444514 38.5366907,65.7006384 38.7939121,65.5528729 L38.7939121,65.5528729 Z"
          id="Fill-2187"
          fill="#9ECB94"
        />
        <path
          d="M19.5679809,52.8070054 C19.8276651,52.6565035 20.249344,52.6565035 20.5093018,52.8070054 C20.7692596,52.9544973 20.7692596,53.1983103 20.5093018,53.3488122 C20.249344,53.4993141 19.8276651,53.4993141 19.5679809,53.3488122 C19.3107595,53.1983103 19.3107595,52.9544973 19.5679809,52.8070054 Z M31.8133612,46.7948657 C32.073319,46.6446375 32.4947243,46.6446375 32.7546821,46.7948657 C33.0146399,46.9453676 33.0146399,47.1864443 32.7546821,47.3369461 C32.4947243,47.4871744 32.073319,47.4871744 31.8133612,47.3369461 C31.5534034,47.1864443 31.5534034,46.9453676 31.8133612,46.7948657 Z M39.4585831,47.1779614 C39.7188146,47.0277332 40.1402198,47.0277332 40.399904,47.1779614 C40.6601354,47.3284633 40.6601354,47.5720027 40.399904,47.7197682 C40.1402198,47.8705437 39.7188146,47.8705437 39.4585831,47.7197682 C39.2016354,47.5720027 39.2016354,47.3284633 39.4585831,47.1779614 Z M42.7397978,43.0900567 C42.9994819,42.9395548 43.4211608,42.9395548 43.6811186,43.0900567 C43.93834,43.2402849 43.93834,43.4813616 43.6811186,43.6318635 C43.4211608,43.7820917 42.9994819,43.7820917 42.7397978,43.6318635 C42.47984,43.4813616 42.47984,43.2402849 42.7397978,43.0900567 Z M56.3095946,38.717293 C56.5558704,38.5695275 56.9934205,38.5695275 57.2399699,38.717293 C57.5136097,38.8675212 57.5136097,39.1113343 57.2399699,39.2618361 C56.9934205,39.409328 56.5558704,39.409328 56.3095946,39.2618361 C56.0356812,39.1113343 56.0356812,38.8675212 56.3095946,38.717293 Z M23.3305279,53.7401171 C23.5902121,53.5896152 24.0091546,53.5896152 24.2691124,53.7401171 C24.5287966,53.8878826 24.5287966,54.131422 24.2691124,54.2816502 C24.0091546,54.4324257 23.5902121,54.4324257 23.3305279,54.2816502 C23.0705701,54.131422 23.0705701,53.8878826 23.3305279,53.7401171 Z M71.4966026,43.3935232 C71.7699688,43.2430213 72.1804284,43.2430213 72.4540682,43.3935232 C72.7006177,43.5440251 72.7006177,43.7875645 72.4540682,43.93533 C72.1804284,44.0858319 71.7699688,44.0858319 71.4966026,43.93533 C71.2500532,43.7875645 71.2500532,43.5440251 71.4966026,43.3935232 Z M73.3023516,44.4637284 C73.548901,44.3132265 73.9593607,44.3132265 74.2327268,44.4637284 C74.4792763,44.6139567 74.4792763,44.8577697 74.2327268,45.0055352 C73.9593607,45.1557634 73.548901,45.1557634 73.3023516,45.0055352 C73.0289854,44.8577697 73.0289854,44.6139567 73.3023516,44.4637284 Z M27.1806397,48.5902164 C27.4403238,48.4394408 27.8620028,48.4394408 28.1219605,48.5902164 C28.3816447,48.7404446 28.3816447,48.9842576 28.1219605,49.1320231 C27.8620028,49.2822514 27.4403238,49.2822514 27.1806397,49.1320231 C26.9234183,48.9842576 26.9234183,48.7404446 27.1806397,48.5902164 Z M52.1776339,34.2077093 C52.4512737,34.0572075 52.8617334,34.0572075 53.1080092,34.2077093 C53.381649,34.3554748 53.381649,34.5990142 53.1080092,34.7495161 C52.8617334,34.8997443 52.4512737,34.8997443 52.1776339,34.7495161 C51.9310845,34.5990142 51.9310845,34.3554748 52.1776339,34.2077093 Z M46.0207388,49.3561341 C46.2943786,49.2083686 46.7048382,49.2083686 46.951114,49.3561341 C47.2247538,49.5069096 47.2247538,49.7501754 46.951114,49.9009509 C46.7048382,50.0511792 46.2943786,50.0511792 46.0207388,49.9009509 C45.7741893,49.7501754 45.7741893,49.5069096 46.0207388,49.3561341 Z M34.2843285,54.7142747 C34.5442863,54.5637728 34.9656915,54.5637728 35.2229129,54.7142747 C35.4828707,54.8620402 35.4828707,55.1055796 35.2229129,55.2558078 C34.9656915,55.4063097 34.5442863,55.4063097 34.2843285,55.2558078 C34.0243707,55.1055796 34.0243707,54.8620402 34.2843285,54.7142747 Z M45.6102791,56.621544 C45.8839189,56.4735049 46.2943786,56.4735049 46.5406544,56.621544 C46.8142942,56.7717722 46.8142942,57.0153116 46.5406544,57.1658135 C46.2943786,57.316589 45.8839189,57.316589 45.6102791,57.1658135 C45.3637297,57.0153116 45.3637297,56.7717722 45.6102791,56.621544 Z M51.9860861,58.0961888 C52.2323619,57.9456869 52.6701855,57.9456869 52.9164613,58.0961888 C53.1898275,58.2466907 53.1898275,58.4874937 52.9164613,58.6379956 C52.6701855,58.7884974 52.2323619,58.7884974 51.9860861,58.6379956 C51.7398103,58.4874937 51.7398103,58.2466907 51.9860861,58.0961888 Z M9.5992836,58.3123642 C9.85896776,58.1645987 10.2806467,58.1645987 10.5403308,58.3123642 C10.7975522,58.4631397 10.7975522,58.7064055 10.5403308,58.8569074 C10.2806467,59.0049465 9.85896776,59.0049465 9.5992836,58.8569074 C9.33932581,58.7064055 9.33932581,58.4631397 9.5992836,58.3123642 Z M7.31439141,59.2919946 C7.57434921,59.1442292 7.99575447,59.1442292 8.25571227,59.2919946 C8.51266002,59.4427702 8.51266002,59.6860359 8.25571227,59.8368115 C7.99575447,59.9845769 7.57434921,59.9845769 7.31439141,59.8368115 C7.05443362,59.6860359 7.05443362,59.4427702 7.31439141,59.2919946 Z M24.8355467,60.7751223 C25.0955045,60.624894 25.5169098,60.624894 25.7741312,60.7751223 C26.0338154,60.9258978 26.0338154,61.1691636 25.7741312,61.3196654 C25.5169098,61.4677046 25.0955045,61.4677046 24.8355467,61.3196654 C24.575589,61.1691636 24.575589,60.9258978 24.8355467,60.7751223 Z M26.515695,68.5905481 C26.7756528,68.4400462 27.1967844,68.4400462 27.4570159,68.5905481 C27.7169737,68.7383136 27.7169737,68.981853 27.4570159,69.1323549 C27.1967844,69.2828568 26.7756528,69.2828568 26.515695,69.1323549 C26.2582,68.981853 26.2582,68.7383136 26.515695,68.5905481 Z M22.6655833,69.3838299 C22.9252674,69.233328 23.3469463,69.233328 23.6041677,69.3838299 C23.8641255,69.5315953 23.8641255,69.7751347 23.6041677,69.9256366 C23.3469463,70.0761385 22.9252674,70.0761385 22.6655833,69.9256366 C22.4053518,69.7751347 22.4053518,69.5315953 22.6655833,69.3838299 Z M33.2168597,69.3977855 C33.4743547,69.2497464 33.89576,69.2497464 34.1557178,69.3977855 C34.4156756,69.5480137 34.4156756,69.7915531 34.1557178,69.942055 C33.89576,70.0898205 33.4743547,70.0898205 33.2168597,69.942055 C32.9571755,69.7915531 32.9571755,69.5480137 33.2168597,69.3977855 L33.2168597,69.3977855 Z"
          id="Fill-2188"
          fill="#51A146"
        />
        <path
          d="M44.8522969,61.2457827 C44.8522969,60.3375723 45.5829151,59.603944 46.4859264,59.603944 C46.4859264,60.5099653 45.747099,61.2457827 44.8522969,61.2457827"
          id="Fill-2189"
          fill="#51A146"
        />
        <path
          d="M44.8522969,61.2457827 C44.8522969,60.3375723 44.1162059,59.603944 43.2104582,59.603944 C43.2104582,60.5099653 43.9438128,61.2457827 44.8522969,61.2457827"
          id="Fill-2190"
          fill="#51A146"
        />
        <path
          d="M13.1891639,63.1065332 C13.1891639,62.1980491 13.9252549,61.4646945 14.8310026,61.4646945 C14.8310026,62.3704422 14.0951852,63.1065332 13.1891639,63.1065332"
          id="Fill-2191"
          fill="#9ECB94"
        />
        <path
          d="M13.1891639,63.1065332 C13.1891639,62.1980491 12.4533465,61.4646945 11.5473252,61.4646945 C11.5473252,62.3704422 12.2834162,63.1065332 13.1891639,63.1065332"
          id="Fill-2192"
          fill="#9ECB94"
        />
        <path
          d="M61.5361145,53.255501 C61.5361145,52.3470169 62.2749419,51.6136623 63.1779532,51.6136623 C63.1779532,52.51941 62.4391258,53.255501 61.5361145,53.255501"
          id="Fill-2193"
          fill="#9ECB94"
        />
        <path
          d="M61.5361145,53.255501 C61.5361145,52.3470169 60.7972871,51.6136623 59.8942758,51.6136623 C59.8942758,52.51941 60.6331032,53.255501 61.5361145,53.255501"
          id="Fill-2194"
          fill="#9ECB94"
        />
        <path
          d="M29.2928652,53.8985545 C29.2928652,52.9903441 30.0292298,52.2567158 30.9347039,52.2567158 C30.9347039,53.1627371 30.2016229,53.8985545 29.2928652,53.8985545"
          id="Fill-2195"
          fill="#9ECB94"
        />
        <path
          d="M29.2928652,53.8985545 C29.2928652,52.9903441 28.5597842,52.2567158 27.6510265,52.2567158 C27.6510265,53.1627371 28.3873911,53.8985545 29.2928652,53.8985545"
          id="Fill-2196"
          fill="#9ECB94"
        />
        <path
          d="M31.4631023,64.7483719 C31.4631023,63.8398878 32.1991933,63.1065332 33.104941,63.1065332 C33.104941,64.0122809 32.36885,64.7483719 31.4631023,64.7483719"
          id="Fill-2197"
          fill="#51A146"
        />
        <path
          d="M31.4631023,64.7483719 C31.4631023,63.8398878 30.7270113,63.1065332 29.8212636,63.1065332 C29.8212636,64.0122809 30.5573546,64.7483719 31.4631023,64.7483719"
          id="Fill-2198"
          fill="#51A146"
        />
        <path
          d="M42.7644254,50.8337889 C42.7644254,49.9253049 43.4975063,49.1919502 44.4062641,49.1919502 C44.4062641,50.0976979 43.670173,50.8337889 42.7644254,50.8337889"
          id="Fill-2199"
          fill="#51A146"
        />
        <path
          d="M42.7644254,50.8337889 C42.7644254,49.9253049 42.0283343,49.1919502 41.1225867,49.1919502 C41.1225867,50.0976979 41.8556676,50.8337889 42.7644254,50.8337889"
          id="Fill-2200"
          fill="#51A146"
        />
        <path
          d="M50.3989753,42.4552124 C50.3989753,41.5464547 51.1375291,40.8133737 52.040814,40.8133737 C52.040814,41.7191214 51.3019866,42.4552124 50.3989753,42.4552124"
          id="Fill-2201"
          fill="#51A146"
        />
        <path
          d="M50.3989753,42.4552124 C50.3989753,41.5464547 49.6601479,40.8133737 48.7571366,40.8133737 C48.7571366,41.7191214 49.4956904,42.4552124 50.3989753,42.4552124"
          id="Fill-2202"
          fill="#51A146"
        />
        <path
          d="M55.5434032,48.2700578 C55.5434032,47.3640365 56.2822307,46.6282191 57.1852419,46.6282191 C57.1852419,47.5364295 56.4461409,48.2700578 55.5434032,48.2700578"
          id="Fill-2203"
          fill="#51A146"
        />
        <path
          d="M55.5434032,48.2700578 C55.5434032,47.3640365 54.8043022,46.6282191 53.9015645,46.6282191 C53.9015645,47.5364295 54.640392,48.2700578 55.5434032,48.2700578"
          id="Fill-2204"
          fill="#51A146"
        />
        <polyline
          id="Fill-2205"
          fill="#E4E4E3"
          points="66.8173623 80.4583055 38.1098126 64.4202778 38.1098126 21.1687736 67.0910021 38.7966485 66.8173623 80.4583055"
        />
        <polyline
          id="Fill-2206"
          fill="#B4B5B4"
          points="52.6975495 8.48861722e-13 38.1070762 21.2590748 67.0910021 38.8894124 81.156087 16.6917532 52.6975495 8.48861722e-13"
        />
        <polyline
          id="Fill-2207"
          fill="#9E9F9E"
          points="52.6975495 -4.85063841e-13 67.0910021 4.79936816 95.4948116 21.1687736 81.156087 16.6917532 52.6975495 -4.85063841e-13"
        />
        <polyline
          id="Fill-2208"
          fill="#F8F7F6"
          points="66.7899983 80.4583055 95.4948116 64.4202778 95.4948116 21.1687736 81.156087 16.6917532 67.0910021 38.7966485 66.7899983 80.4583055"
        />
        <polyline
          id="Fill-2209"
          fill="#E4E4E3"
          points="70.7577752 52.9219341 78.0639574 48.7051451 78.0639574 74.1700633 70.7577752 78.2363505 70.7577752 52.9219341"
        />
        <polyline
          id="Fill-2210"
          fill="#E4E4E3"
          points="82.9621096 46.496872 89.6115563 42.6519594 89.6115563 56.6240068 82.9621096 60.7261407 82.9621096 46.496872"
        />
        <polyline
          id="Fill-2211"
          fill="#FFFFFE"
          points="61.8371183 52.6783947 55.1876715 48.8364922 55.1876715 62.8055295 61.8371183 66.9101262 61.8371183 52.6783947"
        />
        <polyline
          id="Fill-2212"
          fill="#FFFFFE"
          points="49.0307764 46.496872 42.3755832 42.6519594 42.3755832 56.6240068 49.0307764 60.7261407 49.0307764 46.496872"
        />
        <path
          d="M77.5377696,87.6390446 C75.8376438,87.6390446 74.4117318,88.7861773 73.8358828,90.4045955 C73.7536186,90.3993924 73.6713545,90.3911771 73.5616689,90.3911771 C72.711606,90.3911771 71.9438073,90.6839164 71.2856941,91.1798479 C70.6550023,90.6839164 69.8597821,90.3911771 69.0097193,90.3911771 C68.5161343,90.3911771 68.0499708,90.4977024 67.6112287,90.6839164 C67.2273293,90.333396 66.7885872,90.0625643 66.2950023,89.8870303 C65.6640362,88.4329185 64.2932413,87.4281847 62.7302224,87.4281847 C60.5365117,87.4281847 58.7815432,89.369465 58.7815432,91.7683387 C58.7815432,93.6907238 59.9055457,95.3203697 61.4962601,95.8896914 C62.126952,97.3440771 63.4980211,98.3518231 65.06104,98.3518231 C65.5546249,98.3518231 66.0482098,98.2447501 66.4866777,98.0585361 C67.1724865,98.6911158 68.0499708,99.071759 69.0097193,99.071759 C69.8597821,99.071759 70.6550023,98.7790198 71.2856941,98.2830882 C71.9438073,98.7790198 72.711606,99.071759 73.5616689,99.071759 C75.2343733,99.071759 76.6877067,97.921888 77.2635557,96.3031959 C77.3458199,96.3114112 77.428084,96.3199004 77.5377696,96.3199004 C79.7040589,96.3199004 81.4864488,94.3756078 81.4864488,91.9791987 C81.4864488,89.5803249 79.7040589,87.6390446 77.5377696,87.6390446"
          id="Fill-3455"
          fill="#428849"
        />
        <path
          d="M77.0990274,82.759144 C75.4811658,82.950561 74.2472035,84.3337472 73.8904513,86.1134595 C73.8084614,86.116198 73.7261972,86.1192102 73.6162375,86.1298902 C72.8212916,86.2257356 72.0809142,86.6258217 71.5324865,87.2255401 C70.846952,86.7734236 70.0517318,86.5518838 69.2290903,86.6501938 C68.7629268,86.7077011 68.2967633,86.8747459 67.9128639,87.1212056 C67.5015432,86.7928666 67.0351054,86.5570869 66.5417947,86.4283802 C65.7465746,84.96085 64.2932413,84.051414 62.7847909,84.2296864 C60.6736186,84.4816229 59.1928639,86.7433008 59.4942249,89.2821088 C59.7412916,91.3192345 61.057518,92.9160191 62.6479582,93.3347266 C63.4431784,94.8028045 64.8965117,95.7147051 66.4046878,95.533968 C66.8979985,95.4764608 67.3367406,95.3094159 67.7480614,95.0626824 C68.488713,95.6514471 69.3933444,95.955414 70.3256715,95.8431379 C71.148313,95.7472925 71.8612689,95.3474802 72.4373922,94.7480356 C73.0952312,95.1996045 73.8904513,95.4214181 74.7130928,95.3231081 C76.3312287,95.1311434 77.5923381,93.7509695 77.9490903,91.9685187 C78.0310803,91.9657803 78.1136186,91.9657803 78.1958828,91.9545527 C80.3073293,91.7026162 81.788084,89.4409383 81.4864488,86.9024042 C81.1848136,84.36387 79.210474,82.5096721 77.0990274,82.759144"
          id="Fill-3456"
          fill="#4E9C52"
        />
        <path
          d="M76.6602853,83.684463 C75.1795306,83.684463 73.9178727,84.5032566 73.3971406,85.6564138 C73.3148765,85.650937 73.2600337,85.6451862 73.1777696,85.6451862 C72.4099708,85.6451862 71.7244362,85.8533077 71.148313,86.2065665 C70.5998853,85.8533077 69.8872035,85.6451862 69.1468262,85.6451862 C68.708084,85.6451862 68.2967633,85.7218626 67.8854425,85.8533077 C67.5563859,85.6041096 67.1724865,85.4096804 66.7337444,85.2867244 C66.1853167,84.2513201 64.9785016,83.5338488 63.6074325,83.5338488 C61.6607884,83.5338488 60.0977696,84.9194996 60.0977696,86.6258217 C60.0977696,87.994768 61.1123608,89.1558667 62.5105771,89.5614297 C63.059279,90.5965601 64.2658199,91.3112931 65.6640362,91.3112931 C66.1027784,91.3112931 66.5140991,91.2373552 66.8979985,91.1028978 C67.5015432,91.5550143 68.2967633,91.825846 69.1468262,91.825846 C69.8872035,91.825846 70.5998853,91.6177245 71.148313,91.2644657 C71.7244362,91.6177245 72.4099708,91.825846 73.1777696,91.825846 C74.6585243,91.825846 75.9199079,91.0073262 76.4134928,89.854169 C76.4954828,89.8596459 76.5780211,89.8651227 76.6602853,89.8651227 C78.6072035,89.8651227 80.1702224,88.4822104 80.1702224,86.7764359 C80.1702224,85.0673753 78.6072035,83.684463 76.6602853,83.684463"
          id="Fill-3457"
          fill="#70BA64"
        />
        <path
          d="M64.6222979,85.6287556 C65.8836815,85.6287556 66.9531155,84.9414071 67.3644362,83.9719992 C67.4464262,83.9750115 67.5015432,83.9802145 67.5838073,83.9802145 C68.2144991,83.9802145 68.7903482,83.8052282 69.2565117,83.5067382 C69.7500966,83.8052282 70.3256715,83.9802145 70.9566375,83.9802145 C71.3131155,83.9802145 71.6695935,83.9175042 71.9986501,83.8052282 C72.3002853,84.0160881 72.6293419,84.1773822 72.9858199,84.281443 C73.4519834,85.152267 74.4665746,85.7547238 75.6182727,85.7547238 C77.2361343,85.7547238 78.5520865,84.5911606 78.5520865,83.155944 C78.5520865,82.0030606 77.7022979,81.0281759 76.5505998,80.6888831 C76.0570148,79.8177853 75.069845,79.2156022 73.8904513,79.2156022 C73.506552,79.2156022 73.1777696,79.2783125 72.848713,79.3905886 C72.3277067,79.0129577 71.6695935,78.7829287 70.9566375,78.7829287 C70.3256715,78.7829287 69.7500966,78.957915 69.2565117,79.256405 C68.7903482,78.957915 68.2144991,78.7829287 67.5838073,78.7829287 C66.3224237,78.7829287 65.2527155,79.4700033 64.8413947,80.4394112 C64.7594048,80.4369466 64.704562,80.4314697 64.6222979,80.4314697 C63.0044362,80.4314697 61.6879356,81.595033 61.6879356,83.0299757 C61.6879356,84.4651923 63.0044362,85.6287556 64.6222979,85.6287556"
          id="Fill-3458"
          fill="#88C37D"
        />
        <path
          d="M64.0738702,81.4553726 C65.3078325,81.4553726 66.3772664,82.1457334 66.7885872,83.1124028 C66.8708513,83.1093905 66.9254199,83.1039136 67.0079582,83.1039136 C67.6386501,83.1039136 68.2144991,83.2794477 68.6803884,83.5776638 C69.1742476,83.2794477 69.7500966,83.1039136 70.3807884,83.1039136 C70.7369922,83.1039136 71.0937444,83.1668978 71.4225268,83.2794477 C71.7244362,83.0683139 72.0534928,82.9070198 72.4099708,82.8026852 C72.8761343,81.9318612 73.8904513,81.3294043 75.0424237,81.3294043 C76.6877067,81.3294043 78.0036589,82.4932414 78.0036589,83.928458 C78.0036589,85.0813414 77.1538702,86.0559523 75.9744765,86.3955189 C75.4811658,87.2663429 74.493996,87.8687998 73.3148765,87.8687998 C72.9583985,87.8687998 72.6019205,87.8058156 72.2725897,87.6938134 C71.7518576,88.0714443 71.0937444,88.3014733 70.3807884,88.3014733 C69.7500966,88.3014733 69.1742476,88.1262131 68.6803884,87.8277232 C68.2144991,88.1262131 67.6386501,88.3014733 67.0079582,88.3014733 C65.7465746,88.3014733 64.704562,87.6143987 64.2658199,86.6449908 C64.2109771,86.6474554 64.128713,86.6529323 64.0738702,86.6529323 C62.4285872,86.6529323 61.1123608,85.4890951 61.1123608,84.0544263 C61.1123608,82.6192097 62.4285872,81.4553726 64.0738702,81.4553726"
          id="Fill-3459"
          fill="#88C37D"
        />
        <path
          d="M117.57299,64.6742104 C115.900285,64.6742104 114.474373,65.8243553 113.898524,67.4427735 C113.788565,67.4348321 113.706575,67.4263429 113.62431,67.4263429 C112.774248,67.4263429 111.979027,67.7220944 111.348061,68.218026 C110.690222,67.7220944 109.922424,67.4263429 109.072361,67.4263429 C108.578502,67.4263429 108.085191,67.5331421 107.646175,67.719356 C107.262549,67.3688356 106.823533,67.0980039 106.357644,66.9252083 C105.699256,65.4686319 104.355609,64.4636243 102.792864,64.4636243 C100.599153,64.4636243 98.8167633,66.4079169 98.8167633,68.8040522 C98.8167633,70.7289019 99.9684614,72.3585477 101.558902,72.9278695 C102.189593,74.3819813 103.532967,75.3872627 105.123682,75.3872627 C105.617266,75.3872627 106.08343,75.2801897 106.521898,75.096988 C107.207432,75.7268293 108.112612,76.1099371 109.072361,76.1099371 C109.922424,76.1099371 110.690222,75.8141855 111.348061,75.3185278 C111.979027,75.8141855 112.774248,76.1099371 113.62431,76.1099371 C115.297015,76.1099371 116.722927,74.960066 117.298776,73.3413739 C117.408461,73.3471247 117.490451,73.3550661 117.57299,73.3550661 C119.7667,73.3550661 121.54909,71.4137858 121.54909,69.0149121 C121.54909,66.6187768 119.7667,64.6742104 117.57299,64.6742104"
          id="Fill-3460"
          fill="#428849"
        />
        <path
          d="M117.161669,59.797322 C115.543807,59.988739 114.282424,61.3689129 113.953367,63.1488991 C113.843682,63.154376 113.761417,63.154376 113.679153,63.1653298 C112.856512,63.2611752 112.143282,63.6639998 111.567707,64.2607059 C110.909319,63.8091371 110.114099,63.5900619 109.291458,63.6856334 C108.798147,63.7434145 108.359405,63.9101855 107.948084,64.1566452 C107.536763,63.8310446 107.0706,63.5925265 106.577015,63.4640936 C105.781795,61.9990281 104.355609,61.0871274 102.820011,61.2678645 C100.708839,61.5167887 99.2555054,63.7787404 99.5571406,66.3172746 C99.8036589,68.3574126 101.092738,69.9514587 102.710326,70.3731785 C103.505546,71.8409825 104.931732,72.7498708 106.467329,72.5694076 C106.933219,72.5119004 107.399656,72.347594 107.783556,72.0983959 C108.551354,72.6896252 109.45626,72.9911274 110.388587,72.881316 C111.183807,72.7827321 111.924185,72.3831937 112.472612,71.7859399 C113.158147,72.2353179 113.953367,72.4571316 114.776009,72.3612862 C116.393596,72.1665831 117.627558,70.7864091 117.98431,69.0064229 C118.066575,69.0039583 118.148839,69.0012199 118.258524,68.9899923 C120.369697,68.7410681 121.823304,66.4791164 121.521669,63.9405822 C121.21976,61.4020481 119.272841,59.5451117 117.161669,59.797322"
          id="Fill-3461"
          fill="#4E9C52"
        />
        <path
          d="M116.722927,60.722641 C115.242172,60.722641 113.953367,61.5386962 113.459782,62.6915796 C113.377244,62.689115 113.295254,62.6806258 113.21299,62.6806258 C112.472612,62.6806258 111.787078,62.8914857 111.211229,63.2420061 C110.635105,62.8914857 109.949845,62.6806258 109.209468,62.6806258 C108.770726,62.6806258 108.331983,62.7573022 107.948084,62.8887473 C107.618753,62.6395492 107.207432,62.4481323 106.796112,62.3246286 C106.220537,61.2870336 105.041417,60.5720268 103.642653,60.5720268 C101.72343,60.5720268 100.160411,61.9549392 100.160411,63.6612613 C100.160411,65.0332199 101.147581,66.1913063 102.546071,66.5968693 C103.121646,67.6317259 104.328187,68.3494711 105.699256,68.3494711 C106.138273,68.3494711 106.577015,68.2727948 106.960914,68.1413497 C107.564185,68.5904539 108.359405,68.8612856 109.209468,68.8612856 C109.949845,68.8612856 110.635105,68.6531641 111.211229,68.2999053 C111.787078,68.6531641 112.472612,68.8612856 113.21299,68.8612856 C114.693744,68.8612856 115.955128,68.0455042 116.476134,66.8926209 C116.558398,66.8953593 116.640663,66.9035746 116.722927,66.9035746 C118.642424,66.9035746 120.205443,65.5179238 120.205443,63.8118755 C120.205443,62.1058272 118.642424,60.722641 116.722927,60.722641"
          id="Fill-3462"
          fill="#70BA64"
        />
        <path
          d="M104.684939,62.664469 C105.946323,62.664469 106.988336,61.9771205 107.427078,61.0077127 C107.481921,61.0131895 107.564185,61.0183926 107.618753,61.0183926 C108.249719,61.0183926 108.825568,60.8406678 109.319153,60.5449163 C109.785317,60.8406678 110.361166,61.0183926 110.991858,61.0183926 C111.375757,61.0183926 111.731961,60.9529439 112.061292,60.8431324 C112.335505,61.0515277 112.664562,61.2158341 113.02104,61.3168826 C113.514351,62.1879804 114.501795,62.7901635 115.680914,62.7901635 C117.298776,62.7901635 118.615002,61.6293386 118.615002,60.194122 C118.615002,59.0412387 117.764939,58.0663539 116.58582,57.7243227 C116.119656,56.8532249 115.105065,56.250768 113.953367,56.250768 C113.569468,56.250768 113.21299,56.3164906 112.883933,56.4260282 C112.390348,56.0481234 111.731961,55.8211067 110.991858,55.8211067 C110.361166,55.8211067 109.785317,55.9963669 109.319153,56.2918446 C108.825568,55.9963669 108.249719,55.8211067 107.618753,55.8211067 C106.384791,55.8211067 105.315631,56.5081814 104.876615,57.4775893 C104.822046,57.4721124 104.766929,57.4693739 104.684939,57.4693739 C103.067078,57.4693739 101.750851,58.6304726 101.750851,60.0654154 C101.750851,61.5003581 103.067078,62.664469 104.684939,62.664469"
          id="Fill-3463"
          fill="#88C37D"
        />
        <path
          d="M104.10909,58.4935506 C105.370474,58.4935506 106.412212,59.181173 106.851229,60.1505808 C106.906071,60.1448301 106.988336,60.1420917 107.043178,60.1420917 C107.67387,60.1420917 108.277141,60.3176257 108.743304,60.6131034 C109.209468,60.3176257 109.812464,60.1420917 110.416009,60.1420917 C110.799908,60.1420917 111.156386,60.2050758 111.485443,60.3148873 C111.759382,60.106492 112.088713,59.9451978 112.445191,59.8411371 C112.938776,58.9700392 113.925671,58.3675824 115.105065,58.3675824 C116.722927,58.3675824 118.038879,59.5314195 118.038879,60.9663622 C118.038879,62.1165071 117.18909,63.0941303 116.009971,63.4336969 C115.543807,64.3045209 114.529216,64.9072517 113.377244,64.9072517 C112.993344,64.9072517 112.637141,64.8415291 112.308084,64.7317176 C111.814499,65.1096224 111.156386,65.3369129 110.416009,65.3369129 C109.812464,65.3369129 109.209468,65.1616528 108.743304,64.8659012 C108.277141,65.1616528 107.67387,65.3369129 107.043178,65.3369129 C105.809216,65.3369129 104.739508,64.6498383 104.328187,63.6804304 C104.246197,63.6856334 104.191354,63.6913842 104.10909,63.6913842 C102.491229,63.6913842 101.174728,62.5272732 101.174728,61.0923305 C101.174728,59.6573877 102.491229,58.4935506 104.10909,58.4935506"
          id="Fill-3464"
          fill="#88C37D"
        />
      </g>
    </g>
  </svg>
)

export const step31Image1 = (
  <svg
    width="70px"
    height="70px"
    viewBox="0 0 128 128"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    aria-hidden="true"
  >
    <g
      id="5.climate/climate_5.2"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Group" transform="translate(17.600000, 0.000000)">
        <polyline
          id="Fill-2523"
          fill="#FADCCE"
          points="40.8012282 126.542173 81.6043454 103.505657 82.0236719 43.8158461 61.2025979 35.8786746 41.2165882 67.3054991 40.8012282 126.542173"
        />
        <polyline
          id="Fill-2524"
          fill="#EEA78E"
          points="40.8068948 126.542173 0.00358883078 103.737987 0.00358883078 42.2422382 41.2165882 67.3054991 40.8068948 126.542173"
        />
        <polyline
          id="Fill-2525"
          fill="#C85231"
          points="20.7245533 12.1470589 2.60532336e-13 42.3746472 41.2148882 67.4379081 61.2025979 35.8786746 20.7245533 12.1470589"
        />
        <polyline
          id="Fill-2526"
          fill="#B04A2D"
          points="20.7245533 12.1470589 40.4952332 18.5597328 82.0236719 43.8158461 61.2025979 35.8786746 20.7245533 12.1470589"
        />
        <polyline
          id="Fill-2527"
          fill="#EEA78E"
          points="47.5614521 86.5359655 57.9501728 80.5388404 57.9501728 116.746365 47.5614521 122.524572 47.5614521 86.5359655"
        />
        <polyline
          id="Fill-2528"
          fill="#EEA78E"
          points="64.9162822 77.3997468 74.3813512 71.9350908 74.3813512 91.7985136 64.9162822 97.633008 64.9162822 77.3997468"
        />
        <polyline
          id="Fill-2529"
          fill="#FFFFFE"
          points="34.9078014 86.1903044 25.4448102 80.7260262 25.4448102 100.589071 34.9078014 106.423755 34.9078014 86.1903044"
        />
        <polyline
          id="Fill-2530"
          fill="#FFFFFE"
          points="16.6842854 77.3997468 7.2211053 71.9350908 7.2211053 91.7985136 16.6842854 97.633008 16.6842854 77.3997468"
        />
        <path
          d="M87.235032,53.7283856 L87.235032,6.20282179 C87.235032,2.77643282 84.4584103,1.5158245e-13 81.0339101,1.5158245e-13 C77.6075212,1.5158245e-13 74.8308995,2.77643282 74.8308995,6.20282179 L74.8308995,53.7283856 C70.6905221,55.9460941 67.8740454,60.3110568 67.8740454,65.3374976 C67.8740454,72.6037466 73.7655834,78.4950957 81.0339101,78.4950957 C88.3001592,78.4950957 94.1916971,72.6037466 94.1916971,65.3374976 C94.1916971,60.3110568 91.3754094,55.9460941 87.235032,53.7283856"
          id="Fill-2555"
          fill="#679CC7"
        />
        <path
          d="M84.2921907,59.2854067 L84.2921907,5.55324342 C84.2921907,3.75486142 82.8321033,2.29496284 81.0339101,2.29496284 C79.2336393,2.29496284 77.7737407,3.75486142 77.7737407,5.55324342 L77.7737407,59.2854067 C75.5996648,60.4508323 74.118611,62.7439063 74.118611,65.3845302 C74.118611,69.2038017 77.2146387,72.2977516 81.0339101,72.2977516 C84.8512928,72.2977516 87.9471315,69.2038017 87.9471315,65.3845302 C87.9471315,62.7439063 86.4662666,60.4508323 84.2921907,59.2854067"
          id="Fill-2556"
          fill="#E36A6D"
        />
        <path
          d="M81.0320213,51.0122074 C80.2387008,51.0122074 79.4831575,50.9368419 78.7861688,50.8006552 L78.7861688,51.5110548 C79.4831575,51.6451638 80.2387008,51.7205292 81.0320213,51.7205292 C82.5657742,51.7205292 83.969196,51.4428671 85.0515118,50.9840634 L85.0515118,50.2736638 C83.969196,50.7345452 82.5657742,51.0122074 81.0320213,51.0122074"
          id="Fill-2557"
          fill="#1A6C95"
        />
        <path
          d="M81.0320213,48.1486982 C80.2387008,48.1486982 79.4831575,48.0731438 78.7861688,47.9392238 L78.7861688,48.6475456 C79.4831575,48.7814657 80.2387008,48.85702 81.0320213,48.85702 C82.5657742,48.85702 83.969196,48.5795467 85.0515118,48.1205542 L85.0515118,47.4122323 C83.969196,47.8712249 82.5657742,48.1486982 81.0320213,48.1486982"
          id="Fill-2558"
          fill="#1A6C95"
        />
        <path
          d="M81.0320213,45.2872667 C80.2387008,45.2872667 79.4831575,45.2115235 78.7861688,45.0755257 L78.7861688,45.7838476 C79.4831575,45.9198454 80.2387008,45.9955886 81.0320213,45.9955886 C82.5657742,45.9955886 83.969196,45.7177375 85.0515118,45.2589338 L85.0515118,44.5485342 C83.969196,45.0075268 82.5657742,45.2872667 81.0320213,45.2872667"
          id="Fill-2559"
          fill="#1A6C95"
        />
        <path
          d="M81.0320213,42.4235686 C80.2387008,42.4235686 79.4831575,42.3482032 78.7861688,42.2139054 L78.7861688,42.9222272 C79.4831575,43.0565251 80.2387008,43.1318905 81.0320213,43.1318905 C82.5657742,43.1318905 83.969196,42.8542283 85.0515118,42.3952358 L85.0515118,41.6869139 C83.969196,42.1459065 82.5657742,42.4235686 81.0320213,42.4235686"
          id="Fill-2560"
          fill="#1A6C95"
        />
        <path
          d="M81.0320213,39.5602483 C80.2387008,39.5602483 79.4831575,39.4845051 78.7861688,39.3503962 L78.7861688,40.058718 C79.4831575,40.1947158 80.2387008,40.2702702 81.0320213,40.2702702 C82.5657742,40.2702702 83.969196,39.990908 85.0515118,39.5317266 L85.0515118,38.8234047 C83.969196,39.2825862 82.5657742,39.5602483 81.0320213,39.5602483"
          id="Fill-2561"
          fill="#1A6C95"
        />
        <path
          d="M81.0320213,36.6984391 C80.2387008,36.6984391 79.4831575,36.6228848 78.7861688,36.4870759 L78.7861688,37.1972866 C79.4831575,37.3312067 80.2387008,37.406761 81.0320213,37.406761 C82.5657742,37.406761 83.969196,37.1290988 85.0515118,36.6701062 L85.0515118,35.9600844 C83.969196,36.420777 82.5657742,36.6984391 81.0320213,36.6984391"
          id="Fill-2562"
          fill="#1A6C95"
        />
        <path
          d="M81.0320213,33.8351188 C80.2387008,33.8351188 79.4831575,33.7595645 78.7861688,33.6254555 L78.7861688,34.3337774 C79.4831575,34.4695863 80.2387008,34.5434407 81.0320213,34.5434407 C82.5657742,34.5434407 83.969196,34.2655896 85.0515118,33.8067859 L85.0515118,33.0984641 C83.969196,33.5572678 82.5657742,33.8351188 81.0320213,33.8351188"
          id="Fill-2563"
          fill="#1A6C95"
        />
        <path
          d="M81.0320213,30.9734985 C80.2387008,30.9734985 79.4831575,30.8977553 78.7861688,30.7617575 L78.7861688,31.4719682 C79.4831575,31.6060771 80.2387008,31.6818204 81.0320213,31.6818204 C82.5657742,31.6818204 83.969196,31.4041582 85.0515118,30.9449767 L85.0515118,30.234766 C83.969196,30.6939475 82.5657742,30.9734985 81.0320213,30.9734985"
          id="Fill-2564"
          fill="#1A6C95"
        />
        <path
          d="M81.0320213,28.1098004 C80.2387008,28.1098004 79.4831575,28.034435 78.7861688,27.900326 L78.7861688,28.6086479 C79.4831575,28.7427568 80.2387008,28.8181223 81.0320213,28.8181223 C82.5657742,28.8181223 83.969196,28.5404601 85.0515118,28.0816564 L85.0515118,27.3733346 C83.969196,27.8321382 82.5657742,28.1098004 81.0320213,28.1098004"
          id="Fill-2565"
          fill="#1A6C95"
        />
        <path
          d="M81.0320213,25.2464801 C80.2387008,25.2464801 79.4831575,25.1709258 78.7861688,25.0368168 L78.7861688,25.7451387 C79.4831575,25.8809476 80.2387008,25.9566908 81.0320213,25.9566908 C82.5657742,25.9566908 83.969196,25.6788398 85.0515118,25.2179583 L85.0515118,24.5096365 C83.969196,24.9688179 82.5657742,25.2464801 81.0320213,25.2464801"
          id="Fill-2566"
          fill="#1A6C95"
        />
        <path
          d="M81.0320213,22.3846709 C80.2387008,22.3846709 79.4831575,22.3093054 78.7861688,22.1731188 L78.7861688,22.8833295 C79.4831575,23.0176273 80.2387008,23.0929928 81.0320213,23.0929928 C82.5657742,23.0929928 83.969196,22.8153306 85.0515118,22.356338 L85.0515118,21.6461273 C83.969196,22.1070087 82.5657742,22.3846709 81.0320213,22.3846709"
          id="Fill-2567"
          fill="#1A6C95"
        />
        <path
          d="M81.0320213,19.5211617 C80.2387008,19.5211617 79.4831575,19.4456074 78.7861688,19.3114984 L78.7861688,20.0198203 C79.4831575,20.156007 80.2387008,20.2294836 81.0320213,20.2294836 C82.5657742,20.2294836 83.969196,19.9520103 85.0515118,19.4928288 L85.0515118,18.784507 C83.969196,19.2436884 82.5657742,19.5211617 81.0320213,19.5211617"
          id="Fill-2568"
          fill="#1A6C95"
        />
        <path
          d="M81.0320213,16.6595414 C80.2387008,16.6595414 79.4831575,16.583987 78.7861688,16.4479892 L78.7861688,17.1583888 C79.4831575,17.2923089 80.2387008,17.3678632 81.0320213,17.3678632 C82.5657742,17.3678632 83.969196,17.0903899 85.0515118,16.6313974 L85.0515118,15.9209978 C83.969196,16.3799903 82.5657742,16.6595414 81.0320213,16.6595414"
          id="Fill-2569"
          fill="#1A6C95"
        />
        <path
          d="M81.0320213,13.7960322 C80.2387008,13.7960322 79.4831575,13.7204778 78.7861688,13.5863689 L78.7861688,14.2946908 C79.4831575,14.4287997 80.2387008,14.504354 81.0320213,14.504354 C82.5657742,14.504354 83.969196,14.2266919 85.0515118,13.7676993 L85.0515118,13.0593774 C83.969196,13.51837 82.5657742,13.7960322 81.0320213,13.7960322"
          id="Fill-2570"
          fill="#1A6C95"
        />
        <path
          d="M81.0320213,10.932523 C80.2387008,10.932523 79.4831575,10.8588575 78.7861688,10.7228597 L78.7861688,11.4311816 C79.4831575,11.5671794 80.2387008,11.6427337 81.0320213,11.6427337 C82.5657742,11.6427337 83.969196,11.3652604 85.0515118,10.9041901 L85.0515118,10.1958682 C83.969196,10.6550497 82.5657742,10.932523 81.0320213,10.932523"
          id="Fill-2571"
          fill="#1A6C95"
        />
        <path
          d="M81.0320213,8.07090265 C80.2387008,8.07090265 79.4831575,7.99534832 78.7861688,7.86123938 L78.7861688,8.56956124 C79.4831575,8.70367018 80.2387008,8.77922452 81.0320213,8.77922452 C82.5657742,8.77922452 83.969196,8.50156235 85.0515118,8.04256978 L85.0515118,7.33424791 C83.969196,7.79324048 82.5657742,8.07090265 81.0320213,8.07090265"
          id="Fill-2572"
          fill="#1A6C95"
        />
      </g>
    </g>
  </svg>
)

export const step31Image2 = (
  <svg
    width="70px"
    height="70px"
    viewBox="0 0 128 128"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    aria-hidden="true"
  >
    <g
      id="5.climate/climate_5.1"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Group" transform="translate(19.200000, 0.000000)">
        <polyline
          id="Fill-2547"
          fill="#DCECF1"
          points="40.7991505 126.468697 81.6024565 103.432181 82.021783 43.7423695 61.2008979 35.805198 41.2167771 67.2320225 40.7991505 126.468697"
        />
        <polyline
          id="Fill-2548"
          fill="#A3C6DC"
          points="40.8067059 126.468697 0.00377771661 103.66451 0.00377771661 42.1687617 41.2167771 67.2320225 40.8067059 126.468697"
        />
        <polyline
          id="Fill-2549"
          fill="#4B86B0"
          points="20.7245533 12.0735823 2.65269288e-13 42.3011706 41.2129994 67.3644315 61.2008979 35.805198 20.7245533 12.0735823"
        />
        <polyline
          id="Fill-2550"
          fill="#44769B"
          points="20.7245533 12.0735823 40.4933443 18.4862562 82.021783 43.7423695 61.2008979 35.805198 20.7245533 12.0735823"
        />
        <polyline
          id="Fill-2551"
          fill="#A3C6DC"
          points="47.5593744 86.4624889 57.9480951 80.4653638 57.9480951 116.672889 47.5593744 122.451095 47.5593744 86.4624889"
        />
        <polyline
          id="Fill-2552"
          fill="#A3C6DC"
          points="64.9143934 77.3262702 74.3794623 71.8616142 74.3794623 91.725037 64.9143934 97.5595315 64.9143934 77.3262702"
        />
        <polyline
          id="Fill-2553"
          fill="#FFFFFE"
          points="34.9078014 86.1168278 25.4427325 80.6525497 25.4427325 100.515595 34.9078014 106.350278 34.9078014 86.1168278"
        />
        <polyline
          id="Fill-2554"
          fill="#FFFFFE"
          points="16.6842854 77.3262702 7.21921644 71.8616142 7.21921644 91.725037 16.6842854 97.5595315 16.6842854 77.3262702"
        />
        <path
          d="M84.2580024,53.6775753 L84.2580024,6.19564413 C84.2580024,2.77473285 81.4834584,-3.74219174e-13 78.0608472,-3.74219174e-13 C74.6399359,-3.74219174e-13 71.8653919,2.77473285 71.8653919,6.19564413 L71.8653919,53.6775753 C67.7287922,55.8932061 64.9143934,60.2545799 64.9143934,65.2753542 C64.9143934,72.5359366 70.799887,78.4216191 78.0608472,78.4216191 C85.3216185,78.4216191 91.2091898,72.5359366 91.2091898,65.2753542 C91.2091898,60.2545799 88.3946021,55.8932061 84.2580024,53.6775753"
          id="Fill-2573"
          fill="#679CC7"
        />
        <path
          d="M81.3172389,59.2308187 L81.3172389,42.6390874 C81.3172389,40.8408943 79.8588514,39.3845845 78.0608472,39.3845845 C76.2645429,39.3845845 74.8061554,40.8408943 74.8061554,42.6390874 L74.8061554,59.2308187 C72.6322684,60.3945443 71.1551812,62.6857295 71.1551812,65.3223868 C71.1551812,69.1380694 74.2472423,72.2299416 78.0608472,72.2299416 C81.8763409,72.2299416 84.968402,69.1380694 84.968402,65.3223868 C84.968402,62.6857295 83.4913148,60.3945443 81.3172389,59.2308187"
          id="Fill-2574"
          fill="#E36A6D"
        />
        <path
          d="M78.0589583,50.9632859 C77.2675267,50.9632859 76.5119834,50.8877316 75.8168835,50.7536227 L75.8168835,51.4619445 C76.5119834,51.5960535 77.2675267,51.6716078 78.0589583,51.6716078 C79.5927113,51.6716078 80.9942441,51.3941345 82.0765599,50.9349531 L82.0765599,50.2266312 C80.9942441,50.6858126 79.5927113,50.9632859 78.0589583,50.9632859"
          id="Fill-2575"
          fill="#1A6C95"
        />
        <path
          d="M78.0589583,48.1035545 C77.2675267,48.1035545 76.5119834,48.0280001 75.8168835,47.8938912 L75.8168835,48.602213 C76.5119834,48.736322 77.2675267,48.8118763 78.0589583,48.8118763 C79.5927113,48.8118763 80.9942441,48.534403 82.0765599,48.0752216 L82.0765599,47.3668997 C80.9942441,47.8260812 79.5927113,48.1035545 78.0589583,48.1035545"
          id="Fill-2576"
          fill="#1A6C95"
        />
        <path
          d="M78.0589583,45.2440119 C77.2675267,45.2440119 76.5119834,45.1684575 75.8168835,45.0341597 L75.8168835,45.7424816 C76.5119834,45.8767794 77.2675267,45.9523337 78.0589583,45.9523337 C79.5927113,45.9523337 80.9942441,45.6746716 82.0765599,45.215679 L82.0765599,44.5073571 C80.9942441,44.9663497 79.5927113,45.2440119 78.0589583,45.2440119"
          id="Fill-2577"
          fill="#1A6C95"
        />
        <path
          d="M78.0589583,42.3840915 C77.2675267,42.3840915 76.5119834,42.3085372 75.8168835,42.1746171 L75.8168835,42.8810501 C76.5119834,43.016859 77.2675267,43.0924134 78.0589583,43.0924134 C79.5927113,43.0924134 80.9942441,42.8147512 82.0765599,42.3557586 L82.0765599,41.6474368 C80.9942441,42.1064293 79.5927113,42.3840915 78.0589583,42.3840915"
          id="Fill-2578"
          fill="#1A6C95"
        />
        <path
          d="M78.0589583,39.52436 C77.2675267,39.52436 76.5119834,39.4488057 75.8168835,39.3129968 L75.8168835,40.0213187 C76.5119834,40.1571276 77.2675267,40.230793 78.0589583,40.230793 C79.5927113,40.230793 80.9942441,39.9552086 82.0765599,39.4960272 L82.0765599,38.7877053 C80.9942441,39.2468867 79.5927113,39.52436 78.0589583,39.52436"
          id="Fill-2579"
          fill="#1A6C95"
        />
        <path
          d="M78.0589583,36.6627397 C77.2675267,36.6627397 76.5119834,36.5871854 75.8168835,36.4532653 L75.8168835,37.1615872 C76.5119834,37.2955072 77.2675267,37.3710616 78.0589583,37.3710616 C79.5927113,37.3710616 80.9942441,37.0935883 82.0765599,36.6345957 L82.0765599,35.9262738 C80.9942441,36.3852664 79.5927113,36.6627397 78.0589583,36.6627397"
          id="Fill-2580"
          fill="#1A6C95"
        />
        <path
          d="M78.0589583,33.8030082 C77.2675267,33.8030082 76.5119834,33.7274539 75.8168835,33.5935338 L75.8168835,34.3018557 C76.5119834,34.4357758 77.2675267,34.5113301 78.0589583,34.5113301 C79.5927113,34.5113301 80.9942441,34.2336679 82.0765599,33.7748642 L82.0765599,33.0665424 C80.9942441,33.5253461 79.5927113,33.8030082 78.0589583,33.8030082"
          id="Fill-2581"
          fill="#1A6C95"
        />
        <path
          d="M78.0589583,30.9434656 C77.2675267,30.9434656 76.5119834,30.8677224 75.8168835,30.7336135 L75.8168835,31.4419353 C76.5119834,31.5760443 77.2675267,31.6517875 78.0589583,31.6517875 C79.5927113,31.6517875 80.9942441,31.3739364 82.0765599,30.9149439 L82.0765599,30.206622 C80.9942441,30.6656146 79.5927113,30.9434656 78.0589583,30.9434656"
          id="Fill-2582"
          fill="#1A6C95"
        />
        <path
          d="M78.0589583,28.0837342 C77.2675267,28.0837342 76.5119834,28.0081798 75.8168835,27.8740709 L75.8168835,28.5823928 C76.5119834,28.7165017 77.2675267,28.792056 78.0589583,28.792056 C79.5927113,28.792056 80.9942441,28.514205 82.0765599,28.0554013 L82.0765599,27.3470794 C80.9942441,27.8058831 79.5927113,28.0837342 78.0589583,28.0837342"
          id="Fill-2583"
          fill="#1A6C95"
        />
        <path
          d="M78.0589583,25.2240027 C77.2675267,25.2240027 76.5119834,25.1484484 75.8168835,25.0122617 L75.8168835,25.7205835 C76.5119834,25.8567702 77.2675267,25.9323246 78.0589583,25.9323246 C79.5927113,25.9323246 80.9942441,25.6546624 82.0765599,25.1956698 L82.0765599,24.487348 C80.9942441,24.9463405 79.5927113,25.2240027 78.0589583,25.2240027"
          id="Fill-2584"
          fill="#1A6C95"
        />
        <path
          d="M78.0589583,22.3623824 C77.2675267,22.3623824 76.5119834,22.288528 75.8168835,22.1527191 L75.8168835,22.861041 C76.5119834,22.9968499 77.2675267,23.0707042 78.0589583,23.0707042 C79.5927113,23.0707042 80.9942441,22.7928532 82.0765599,22.3338606 L82.0765599,21.6274276 C80.9942441,22.0864202 79.5927113,22.3623824 78.0589583,22.3623824"
          id="Fill-2585"
          fill="#1A6C95"
        />
        <path
          d="M78.0589583,19.502462 C77.2675267,19.502462 76.5119834,19.4269077 75.8168835,19.2927987 L75.8168835,20.0011206 C76.5119834,20.1352295 77.2675267,20.2107839 78.0589583,20.2107839 C79.5927113,20.2107839 80.9942441,19.9333106 82.0765599,19.4741291 L82.0765599,18.7658073 C80.9942441,19.2249887 79.5927113,19.502462 78.0589583,19.502462"
          id="Fill-2586"
          fill="#1A6C95"
        />
        <path
          d="M78.0589583,16.6429194 C77.2675267,16.6429194 76.5119834,16.5671762 75.8168835,16.4330673 L75.8168835,17.1413891 C76.5119834,17.2754981 77.2675267,17.3512413 78.0589583,17.3512413 C79.5927113,17.3512413 80.9942441,17.0735791 82.0765599,16.6143977 L82.0765599,15.9060758 C80.9942441,16.3652572 79.5927113,16.6429194 78.0589583,16.6429194"
          id="Fill-2587"
          fill="#1A6C95"
        />
        <path
          d="M78.0589583,13.7829991 C77.2675267,13.7829991 76.5119834,13.7076336 75.8168835,13.5733358 L75.8168835,14.2816576 C76.5119834,14.4159555 77.2675267,14.4913209 78.0589583,14.4913209 C79.5927113,14.4913209 80.9942441,14.2136587 82.0765599,13.7548551 L82.0765599,13.0465332 C80.9942441,13.5053369 79.5927113,13.7829991 78.0589583,13.7829991"
          id="Fill-2588"
          fill="#1A6C95"
        />
        <path
          d="M78.0589583,10.9232676 C77.2675267,10.9232676 76.5119834,10.8479021 75.8168835,10.7136043 L75.8168835,11.4200373 C76.5119834,11.556224 77.2675267,11.6315894 78.0589583,11.6315894 C79.5927113,11.6315894 80.9942441,11.3541162 82.0765599,10.8949347 L82.0765599,10.1866128 C80.9942441,10.6457943 79.5927113,10.9232676 78.0589583,10.9232676"
          id="Fill-2589"
          fill="#1A6C95"
        />
        <path
          d="M78.0589583,8.0635361 C77.2675267,8.0635361 76.5119834,7.98798177 75.8168835,7.85217286 L75.8168835,8.56049472 C76.5119834,8.69630364 77.2675267,8.77185797 78.0589583,8.77185797 C79.5927113,8.77185797 80.9942441,8.49438468 82.0765599,8.03520323 L82.0765599,7.32688137 C80.9942441,7.78606282 79.5927113,8.0635361 78.0589583,8.0635361"
          id="Fill-2590"
          fill="#1A6C95"
        />
      </g>
    </g>
  </svg>
)
